var Cf = Object.defineProperty;
var Sf = (e, t, n) => t in e ? Cf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Jl = (e, t, n) => Sf(e, typeof t != "symbol" ? t + "" : t, n);
import * as Ef from "react/jsx-runtime";
import { jsxs as F, jsx as g, Fragment as et } from "react/jsx-runtime";
import Ur, { useRef as ee, useState as Ee, useCallback as he, useId as rt, useLayoutEffect as rr, useEffect as me, forwardRef as Af, useMemo as $e, createContext as ei, useContext as Fn, Fragment as Vo, useReducer as If } from "react";
import { createPortal as hi } from "react-dom";
var Lf = /* @__PURE__ */ ((e) => (e.Text = "text", e.Email = "email", e.Number = "number", e.Choice = "choice", e.MultiChoice = "multiChoice", e.Date = "date", e.Time = "time", e.Entity = "entity", e))(Lf || {}), dt = /* @__PURE__ */ ((e) => (e.TextInput = "textInput", e.EmailInput = "emailInput", e.NumberInput = "numberInput", e.PasswordInput = "passwordInput", e.Select = "select", e.ComboBox = "comboBox", e.MultiSelect = "multiSelect", e.DatePicker = "datePicker", e.TimePicker = "timePicker", e.EntityPicker = "entityPicker", e.Separator = "separator", e.CheckboxGroup = "checkboxGroup", e.Custom = "custom", e.RadioGroup = "radioGroup", e.TextArea = "textArea", e))(dt || {}), Nt = /* @__PURE__ */ ((e) => (e.Large = "large", e.Medium = "medium", e.Small = "small", e))(Nt || {}), Pe = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Warning = "warning", e.Success = "success", e))(Pe || {}), Nf = /* @__PURE__ */ ((e) => (e.info = "info", e.warning = "warning", e.success = "success", e.error = "error", e))(Nf || {}), Tf = /* @__PURE__ */ ((e) => (e.text = "text", e.number = "number", e.date = "date", e.time = "time", e.datetime = "datetime", e))(Tf || {}), Pf = /* @__PURE__ */ ((e) => (e.text = "text", e.currency = "currency", e.datetime = "datetime", e.select = "select", e.multiselect = "multiselect", e))(Pf || {}), gt = /* @__PURE__ */ ((e) => (e.Text = "text", e.Email = "email", e.Number = "number", e.Password = "password", e.Search = "search", e.Tel = "tel", e.Url = "url", e))(gt || {});
function Xr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var aa = { exports: {} };
var Wl;
function Df() {
  return Wl || (Wl = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var s = "", o = 0; o < arguments.length; o++) {
          var l = arguments[o];
          l && (s = r(s, i(l)));
        }
        return s;
      }
      function i(s) {
        if (typeof s == "string" || typeof s == "number")
          return s;
        if (typeof s != "object")
          return "";
        if (Array.isArray(s))
          return n.apply(null, s);
        if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
          return s.toString();
        var o = "";
        for (var l in s)
          t.call(s, l) && s[l] && (o = r(o, l));
        return o;
      }
      function r(s, o) {
        return o ? s ? s + " " + o : s + o : s;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  })(aa)), aa.exports;
}
var Mf = Df();
const X = /* @__PURE__ */ Xr(Mf);
var Le = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Info = "info", e.Success = "success", e.Warning = "warning", e.Error = "error", e))(Le || {}), lt = /* @__PURE__ */ ((e) => (e.Large = "large", e.Medium = "medium", e.Small = "small", e))(lt || {}), we = /* @__PURE__ */ ((e) => (e.Auto = "auto", e.Full = "full", e.Small = "sm", e.Medium = "md", e.Large = "lg", e))(we || {}), Xn = /* @__PURE__ */ ((e) => (e.Blank = "_blank", e.Self = "_self", e))(Xn || {});
function sr(...e) {
  return (t) => {
    for (const n of e)
      typeof n == "function" ? n(t) : n != null && (n.current = t);
  };
}
function Yt(e, t, n) {
  const i = e !== void 0, r = ee(i);
  r.current = i;
  const [s, o] = Ee(
    i ? e : t
  ), l = i ? e : s, u = he(
    (c) => {
      const d = typeof c == "function" ? c(l) : c;
      r.current || o(d), n?.(d);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, n]
  );
  return [l, u];
}
const Zl = {
  "ds-input": "_ds-input_fzm43_1",
  "ds-input--width-full": "_ds-input--width-full_fzm43_1",
  "ds-input--width-sm": "_ds-input--width-sm_fzm43_4",
  "ds-input--width-md": "_ds-input--width-md_fzm43_7",
  "ds-input--width-lg": "_ds-input--width-lg_fzm43_10"
}, Vf = "ds-tooltip-layer", Ff = 8, Rf = 8, Of = 6, Bf = 200, zf = 100, jf = {
  top: ["bottom", "right", "left"],
  bottom: ["top", "right", "left"],
  left: ["right", "top", "bottom"],
  right: ["left", "top", "bottom"]
};
function pi(e) {
  const t = document.getElementById(e);
  if (t)
    return t;
  const n = document.createElement("div");
  return n.id = e, n.setAttribute("data-ds-layer", ""), document.body.appendChild(n), n;
}
function tr(e, t, n, i, r) {
  const s = document.documentElement.clientWidth, o = document.documentElement.clientHeight;
  return e >= r && t >= r && e + n <= s - r && t + i <= o - r;
}
function Fo(e, t, n, i, r) {
  const s = document.documentElement.clientWidth, o = document.documentElement.clientHeight;
  return {
    x: Math.min(Math.max(e, r), s - n - r),
    y: Math.min(Math.max(t, r), o - i - r)
  };
}
function Xl(e, t, n, i, r, s) {
  const o = i + (s ? r : 0), l = e.left + e.width / 2, u = e.top + e.height / 2;
  switch (n) {
    case "top":
      return {
        x: l - t.width / 2,
        y: e.top - t.height - o
      };
    case "bottom":
      return {
        x: l - t.width / 2,
        y: e.bottom + o
      };
    case "left":
      return {
        x: e.left - t.width - o,
        y: u - t.height / 2
      };
    case "right":
      return {
        x: e.right + o,
        y: u - t.height / 2
      };
  }
}
function $f(e, t, n, i, r, s, o) {
  const l = e.left + e.width / 2, u = e.top + e.height / 2, c = o;
  switch (s) {
    case "top":
    case "bottom": {
      const d = l - t, h = i - o;
      return { offset: Math.min(Math.max(d, c), h), edge: s === "top" ? "bottom" : "top" };
    }
    case "left":
    case "right": {
      const d = u - n, h = r - o;
      return { offset: Math.min(Math.max(d, c), h), edge: s === "left" ? "right" : "left" };
    }
  }
}
function Hf(e, t, n, i, r, s, o) {
  const { viewportPaddingPx: l, flip: u } = r;
  let c = n, d = Xl(e, t, n, i, o, s);
  if (u && !tr(d.x, d.y, t.width, t.height, l)) {
    const _ = jf[n];
    for (const y of _) {
      const v = Xl(e, t, y, i, o, s);
      if (tr(v.x, v.y, t.width, t.height, l)) {
        c = y, d = v;
        break;
      }
    }
  }
  const h = Fo(d.x, d.y, t.width, t.height, l), m = s ? $f(
    e,
    h.x,
    h.y,
    t.width,
    t.height,
    c,
    o
  ) : null;
  return {
    tooltip: { x: h.x, y: h.y, resolvedPlacement: c },
    arrow: m
  };
}
const zi = {
  "ds-tooltip": "_ds-tooltip_y2xmt_1",
  "ds-tooltip--top": "_ds-tooltip--top_y2xmt_31",
  "ds-tooltip--closed": "_ds-tooltip--closed_y2xmt_34",
  "ds-tooltip--bottom": "_ds-tooltip--bottom_y2xmt_37",
  "ds-tooltip--left": "_ds-tooltip--left_y2xmt_43",
  "ds-tooltip--right": "_ds-tooltip--right_y2xmt_49",
  "ds-tooltip--open": "_ds-tooltip--open_y2xmt_55",
  "ds-tooltip__content": "_ds-tooltip__content_y2xmt_61",
  "ds-tooltip__arrow": "_ds-tooltip__arrow_y2xmt_78"
}, kn = ({
  id: e,
  content: t,
  anchorRef: n,
  placement: i = "top",
  offsetPx: r = Ff,
  collision: s,
  disabled: o = !1,
  layerId: l = Vf,
  showArrow: u = !0,
  arrowSizePx: c = Of
}) => {
  const d = rt(), h = e || d, [m, _] = Ee(!1), y = ee(null), v = ee(null), w = ee(null), x = ee(null), A = ee(null), S = ee({ x: 0, y: 0, resolvedPlacement: i }), N = ee(null), E = {
    viewportPaddingPx: s?.viewportPaddingPx ?? Rf,
    flip: s?.flip ?? !0
  }, f = he(() => {
    w.current !== null && (clearTimeout(w.current), w.current = null), x.current !== null && (clearTimeout(x.current), x.current = null);
  }, []), C = he(() => {
    A.current !== null && (cancelAnimationFrame(A.current), A.current = null);
  }, []), L = he(() => {
    const O = n.current, W = y.current;
    if (!O || !W)
      return;
    const G = O.getBoundingClientRect(), re = W.getBoundingClientRect(), { tooltip: K, arrow: P } = Hf(
      G,
      re,
      i,
      r,
      E,
      u,
      c
    );
    if (S.current = K, N.current = P, W.style.transform = `translate(${K.x}px, ${K.y}px)`, W.dataset.placement = K.resolvedPlacement, P && v.current) {
      const oe = v.current;
      oe.dataset.edge = P.edge, P.edge === "top" || P.edge === "bottom" ? (oe.style.left = `${P.offset}px`, oe.style.top = "") : (oe.style.top = `${P.offset}px`, oe.style.left = "");
    }
  }, [n, i, r, E.viewportPaddingPx, E.flip, u, c]), R = he(() => {
    C(), A.current = requestAnimationFrame(() => {
      L();
    });
  }, [C, L]), V = he(() => {
    f(), w.current = setTimeout(() => {
      _(!0);
    }, Bf);
  }, [f]), z = he(() => {
    f(), x.current = setTimeout(() => {
      _(!1);
    }, zf);
  }, [f]), $ = he(() => {
    f(), _(!1);
  }, [f]);
  rr(() => {
    m && L();
  }, [m, L]), me(() => {
    const O = n?.current;
    if (!(!O || o))
      return O.setAttribute("aria-describedby", h), () => {
        O.removeAttribute("aria-describedby");
      };
  }, [n, h, o]), me(() => {
    const O = n?.current;
    if (!O || o)
      return;
    const W = () => {
      V();
    }, G = () => {
      z();
    }, re = () => {
      V();
    }, K = () => {
      z();
    }, P = (oe) => {
      oe.key === "Escape" && $();
    };
    return O.addEventListener("pointerenter", W), O.addEventListener("pointerleave", G), O.addEventListener("focusin", re), O.addEventListener("focusout", K), O.addEventListener("keydown", P), () => {
      O.removeEventListener("pointerenter", W), O.removeEventListener("pointerleave", G), O.removeEventListener("focusin", re), O.removeEventListener("focusout", K), O.removeEventListener("keydown", P);
    };
  }, [n, o, V, z, $]), me(() => {
    if (!m || o) {
      C();
      return;
    }
    const O = () => {
      R();
    }, W = () => {
      R();
    };
    return window.addEventListener("scroll", O, { capture: !0, passive: !0 }), window.addEventListener("resize", W, { passive: !0 }), () => {
      window.removeEventListener("scroll", O, { capture: !0 }), window.removeEventListener("resize", W), C();
    };
  }, [m, o, R, C]), me(() => {
    const O = n?.current;
    if (!O || !m || o)
      return;
    const W = new ResizeObserver(() => {
      R();
    });
    return W.observe(O), y?.current && W.observe(y.current), () => {
      W.disconnect();
    };
  }, [n, m, o, R]), me(() => () => {
    f(), C();
  }, [f, C]);
  const H = pi(l), B = m && !o ? "open" : "closed";
  return hi(
    /* @__PURE__ */ F(
      "div",
      {
        ref: y,
        id: h,
        role: "tooltip",
        "aria-hidden": B === "closed",
        "data-state": B,
        "data-placement": S?.current.resolvedPlacement,
        className: X({
          [zi["ds-tooltip"]]: !0,
          [zi[`ds-tooltip--${S?.current.resolvedPlacement}`]]: !0,
          [zi["ds-tooltip--open"]]: m && !o,
          [zi["ds-tooltip--closed"]]: !m || o
        }),
        children: [
          /* @__PURE__ */ g("span", { className: zi["ds-tooltip__content"], children: t }),
          u && /* @__PURE__ */ g(
            "div",
            {
              ref: v,
              className: zi["ds-tooltip__arrow"],
              "data-edge": N?.current?.edge ?? S?.current.resolvedPlacement,
              "aria-hidden": "true"
            }
          )
        ]
      }
    ),
    H
  );
};
var ce = /* @__PURE__ */ ((e) => (e.Circle = "circle", e.Ellipse = "ellipse", e.Image = "image", e.Line = "line", e.Path = "path", e.Polygon = "polygon", e.Polyline = "polyline", e.Rect = "rect", e.Text = "text", e.Tspan = "tspan", e.Use = "use", e))(ce || {}), q = /* @__PURE__ */ ((e) => (e.Apartment = "apartment", e.Done = "done", e.Launch = "launch", e.Close = "close", e.MoreVert = "more_vert", e.Sort = "content_sort", e.Help = "help", e.Support = "support", e.Chat = "chat", e.Feedback = "feedback", e.Menu = "menu", e.Dashboard = "dashboard", e.FolderOpen = "folder-open", e.Add = "add", e.ChevronLeft = "chevron-left", e.ChevronRight = "chevron-right", e.ManageAccounts = "manage-accounts", e.TextSnippet = "text-snippet", e.NetworkNode = "network-node", e.Group = "group", e.FolderShared = "folder-shared", e.StatusActive = "status-active", e.StatusOpen = "status-open", e.StatusClosed = "status-closed", e.StatusDenied = "status-denied", e.StatusPending = "status-pending", e.SwapHoriz = "swap-horiz", e.CheckCircle = "check-circle", e.CheckCircleOutline = "check-circle-outline", e.Delete = "_delete", e.RemoveCircleOutline = "remove-circle-outline", e.HighlightOff = "hightlight-off", e.Dangerous = "dangerous", e.Send = "send", e.HomeFilled = "home-filled", e.Developer = "developer", e.FilterList = "filter-list", e.KeyboardArrowLeft = "keyboard-arrow-left", e.KeyboardArrowRight = "keyboard-arrow-right", e.CalendarToday = "calendar-today", e.KeyboardArrowDown = "keyboard-arrow-down", e.KeyboardArrowUp = "keyboard-arrow-up", e.Edit = "edit", e.Search = "search", e.Cancel = "cancel", e.Replay = "replay", e.Lock = "lock", e.Link = "link", e.Power = "power", e.ErrorOutline = "error_outline", e.Archive = "archive", e.Notifications = "notifications", e.FileUpload = "file_upload", e.FileDownload = "file_download", e.CloudUpload = "cloud_upload", e.AttachFile = "attach_file", e.AccountCircle = "account-circle", e.FindInPage = "find-in-page", e.PrivacyTip = "privacy-tip", e.Logout = "logout", e.ARIES = "aries", e.AlertCircle = "alert-circle", e.Warning = "warning", e.WarningOutline = "warning-outline", e.Info = "info", e.InfoOutline = "info-outline", e.Visibility = "visibility", e.VisibilityOff = "visibility-off", e.ThumbUp = "thumb-up", e.ThumbDown = "thumb-down", e.NumericalSpinner = "numerical-spinner", e.Reply = "reply", e.ReplyAll = "reply_all", e.Forward = "forward", e.ContentCopy = "content_copy", e.History = "history", e.Mail = "mail", e.OpenInFull = "open_in_full", e.CloseFullscreen = "close_fullscreen", e))(q || {});
const Uf = {
  [q.Apartment]: {
    id: "apartment",
    category: "places",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M17 11V3H7V7H3V21H11V17H13V21H21V11H17ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM11 15H9V13H11V15ZM11 11H9V9H11V11ZM11 7H9V5H11V7ZM15 15H13V13H15V15ZM15 11H13V9H15V11ZM15 7H13V5H15V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Add]: {
    id: "add",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Done]: {
    id: "done",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M9 16.2L4.8 12L3.4 13.4L9 19L21 7.00001L19.6 5.60001L9 16.2Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Launch]: {
    id: "launch",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Close]: {
    id: "close",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.MoreVert]: {
    id: "more_vert",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Sort]: {
    id: "content-sort",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M7 13.1L12 18.1L17 13.1H7Z",
          fill: "#323232"
        }
      },
      {
        type: ce.Path,
        props: {
          d: "M7 10.9L12 5.90002L17 10.9H7Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Help]: {
    id: "help",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",
          fill: "CurrentColor"
        }
      }
    ]
  },
  [q.Support]: {
    id: "support",
    category: "communication",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2ZM18.92 8H15.89C15.63 7.66 15.34 7.37 15 7.11V4.08C16.72 4.73 18.27 6.28 18.92 8ZM12 16C9.79 16 8 14.21 8 12S9.79 8 12 8 16 9.79 16 12 14.21 16 12 16ZM9 4.08V7.11C8.66 7.37 8.37 7.66 8.11 8H5.08C5.73 6.28 7.28 4.73 9 4.08ZM5.08 16H8.11C8.37 16.34 8.66 16.63 9 16.89V19.92C7.28 19.27 5.73 17.72 5.08 16ZM15 19.92V16.89C15.34 16.63 15.63 16.34 15.89 16H18.92C18.27 17.72 16.72 19.27 15 19.92Z",
          fill: "currentColor"
        }
      }
    ]
  },
  [q.Chat]: {
    id: "chat",
    category: "communication",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M4 4H20V16H7L4 19V4Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinejoin: "round",
          strokeWidth: 2
        }
      },
      {
        type: ce.Path,
        props: {
          d: "M7 8H17M7 12H14",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 2
        }
      }
    ]
  },
  [q.Feedback]: {
    id: "feedback",
    category: "communication",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M4 4H20V16H7L4 19V4Z",
          fill: "none",
          stroke: "currentColor",
          strokeLinejoin: "round",
          strokeWidth: 2
        }
      },
      {
        type: ce.Path,
        props: {
          d: "M12 7V11",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeWidth: 2
        }
      },
      {
        type: ce.Circle,
        props: {
          cx: 12,
          cy: 14,
          fill: "currentColor",
          r: 1
        }
      }
    ]
  },
  [q.Menu]: {
    id: "menu",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Dashboard]: {
    id: "dashboard",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.FolderOpen]: {
    id: "folder_open",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H10L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8H4V18L6.4 10H23.5L20.925 18.575C20.7917 19.0083 20.5458 19.3542 20.1875 19.6125C19.8292 19.8708 19.4333 20 19 20H4Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.ChevronLeft]: {
    id: "chevron_left",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.ChevronRight]: {
    id: "chevron_right",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.ManageAccounts]: {
    id: "manage-accounts",
    category: "social",
    width: 24,
    height: 24,
    viewBox: "0 0 20 17",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M14 17L13.7 15.5C13.5 15.4167 13.3125 15.3292 13.1375 15.2375C12.9625 15.1458 12.7833 15.0333 12.6 14.9L11.15 15.35L10.15 13.65L11.3 12.65C11.2667 12.4167 11.25 12.2 11.25 12C11.25 11.8 11.2667 11.5833 11.3 11.35L10.15 10.35L11.15 8.65L12.6 9.1C12.7833 8.96667 12.9625 8.85417 13.1375 8.7625C13.3125 8.67083 13.5 8.58333 13.7 8.5L14 7H16L16.3 8.5C16.5 8.58333 16.6875 8.675 16.8625 8.775C17.0375 8.875 17.2167 9 17.4 9.15L18.85 8.65L19.85 10.4L18.7 11.4C18.7333 11.6 18.75 11.8083 18.75 12.025C18.75 12.2417 18.7333 12.45 18.7 12.65L19.85 13.65L18.85 15.35L17.4 14.9C17.2167 15.0333 17.0375 15.1458 16.8625 15.2375C16.6875 15.3292 16.5 15.4167 16.3 15.5L16 17H14ZM0 16V13.2C0 12.65 0.141667 12.1333 0.425 11.65C0.708333 11.1667 1.1 10.8 1.6 10.55C2.45 10.1167 3.40833 9.75 4.475 9.45C5.54167 9.15 6.71667 9 8 9H8.35C8.45 9 8.55 9.01667 8.65 9.05C8.16667 10.25 7.96667 11.4417 8.05 12.625C8.13333 13.8083 8.53333 14.9333 9.25 16H0ZM15 14C15.55 14 16.0208 13.8042 16.4125 13.4125C16.8042 13.0208 17 12.55 17 12C17 11.45 16.8042 10.9792 16.4125 10.5875C16.0208 10.1958 15.55 10 15 10C14.45 10 13.9792 10.1958 13.5875 10.5875C13.1958 10.9792 13 11.45 13 12C13 12.55 13.1958 13.0208 13.5875 13.4125C13.9792 13.8042 14.45 14 15 14ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.TextSnippet]: {
    id: "text_snippet",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M20.41 8.41L15.58 3.58C15.21 3.21 14.7 3 14.17 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V9.83C21 9.3 20.79 8.79 20.41 8.41ZM7 7H14V9H7V7ZM17 17H7V15H17V17ZM17 13H7V11H17V13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.NetworkNode]: {
    id: "network-node",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M5.5 22C4.53333 22 3.70833 21.6583 3.025 20.975C2.34167 20.2917 2 19.4667 2 18.5C2 17.5333 2.34167 16.7083 3.025 16.025C3.70833 15.3417 4.53333 15 5.5 15C5.8 15 6.09167 15.0375 6.375 15.1125C6.65833 15.1875 6.925 15.2917 7.175 15.425L11 11.6V8.85C10.2667 8.63333 9.66667 8.22083 9.2 7.6125C8.73333 7.00417 8.5 6.3 8.5 5.5C8.5 4.53333 8.84167 3.70833 9.525 3.025C10.2083 2.34167 11.0333 2 12 2C12.9667 2 13.7917 2.34167 14.475 3.025C15.1583 3.70833 15.5 4.53333 15.5 5.5C15.5 6.3 15.2667 7.00417 14.8 7.6125C14.3333 8.22083 13.7333 8.63333 13 8.85V11.6L16.85 15.425C17.1 15.2917 17.3625 15.1875 17.6375 15.1125C17.9125 15.0375 18.2 15 18.5 15C19.4667 15 20.2917 15.3417 20.975 16.025C21.6583 16.7083 22 17.5333 22 18.5C22 19.4667 21.6583 20.2917 20.975 20.975C20.2917 21.6583 19.4667 22 18.5 22C17.5333 22 16.7083 21.6583 16.025 20.975C15.3417 20.2917 15 19.4667 15 18.5C15 18.2 15.0375 17.9083 15.1125 17.625C15.1875 17.3417 15.2917 17.075 15.425 16.825L12 13.4L8.575 16.825C8.70833 17.075 8.8125 17.3417 8.8875 17.625C8.9625 17.9083 9 18.2 9 18.5C9 19.4667 8.65833 20.2917 7.975 20.975C7.29167 21.6583 6.46667 22 5.5 22ZM18.5 20C18.9167 20 19.2708 19.8542 19.5625 19.5625C19.8542 19.2708 20 18.9167 20 18.5C20 18.0833 19.8542 17.7292 19.5625 17.4375C19.2708 17.1458 18.9167 17 18.5 17C18.0833 17 17.7292 17.1458 17.4375 17.4375C17.1458 17.7292 17 18.0833 17 18.5C17 18.9167 17.1458 19.2708 17.4375 19.5625C17.7292 19.8542 18.0833 20 18.5 20ZM12 7C12.4167 7 12.7708 6.85417 13.0625 6.5625C13.3542 6.27083 13.5 5.91667 13.5 5.5C13.5 5.08333 13.3542 4.72917 13.0625 4.4375C12.7708 4.14583 12.4167 4 12 4C11.5833 4 11.2292 4.14583 10.9375 4.4375C10.6458 4.72917 10.5 5.08333 10.5 5.5C10.5 5.91667 10.6458 6.27083 10.9375 6.5625C11.2292 6.85417 11.5833 7 12 7ZM5.5 20C5.91667 20 6.27083 19.8542 6.5625 19.5625C6.85417 19.2708 7 18.9167 7 18.5C7 18.0833 6.85417 17.7292 6.5625 17.4375C6.27083 17.1458 5.91667 17 5.5 17C5.08333 17 4.72917 17.1458 4.4375 17.4375C4.14583 17.7292 4 18.0833 4 18.5C4 18.9167 4.14583 19.2708 4.4375 19.5625C4.72917 19.8542 5.08333 20 5.5 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Group]: {
    id: "group",
    category: "social",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.FolderShared]: {
    id: "folder_shared",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM15 9C16.1 9 17 9.9 17 11C17 12.1 16.1 13 15 13C13.9 13 13 12.1 13 11C13 9.9 13.9 9 15 9ZM19 17H11V16C11 14.67 13.67 14 15 14C16.33 14 19 14.67 19 16V17Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.StatusActive]: {
    id: "status-active",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          fill: "#00774E"
        }
      }
    ]
  },
  [q.StatusOpen]: {
    id: "status-open",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          // --Background-orange (LOA-1700)
          fill: "#ED5B3E"
        }
      }
    ]
  },
  [q.StatusClosed]: {
    id: "status-closed",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          // --Background-blue (LOA-1700)
          fill: "#0067D2"
        }
      }
    ]
  },
  [q.StatusDenied]: {
    id: "status-denied",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          fill: "#CD2026"
        }
      }
    ]
  },
  [q.StatusPending]: {
    id: "status-pending",
    category: "status",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Circle,
        props: {
          cx: "12",
          cy: "12",
          r: "12",
          // --Background-primary_bold (LOA-1700)
          fill: "#ABBDCF"
        }
      }
    ]
  },
  [q.SwapHoriz]: {
    id: "swap_horiz",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.CheckCircle]: {
    id: "check_circle",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.CheckCircleOutline]: {
    id: "check_circle_outline",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M16.59 7.58L10 14.17L6.41 10.59L5 12L10 17L18 9L16.59 7.58ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Delete]: {
    id: "_delete",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.RemoveCircleOutline]: {
    id: "remove_circle_outline",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M7 11V13H17V11H7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.HighlightOff]: {
    id: "highlight_off",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Dangerous]: {
    id: "dangerous",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM17 15.74L15.74 17L12 13.26L8.26 17L7 15.74L10.74 12L7 8.26L8.26 7L12 10.74L15.74 7L17 8.26L13.26 12L17 15.74Z",
          fill: "#323232"
        }
      }
    ]
  },
  // Form / input controls
  [q.Visibility]: {
    id: "visibility",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Cancel]: {
    id: "cancel",
    category: "navigation",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Replay]: {
    id: "replay",
    category: "media",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 5V1L7 6L12 11V7C15.31 7 18 9.69 18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13H4C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13C20 8.58 16.42 5 12 5Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.VisibilityOff]: {
    id: "visibility-off",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Send]: {
    id: "send",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Developer]: {
    id: "developer",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M7.77001 6.75998L6.23001 5.47998L0.820007 12L6.23001 18.52L7.77001 17.24L3.42001 12L7.77001 6.75998ZM7.00001 13H9.00001V11H7.00001V13ZM17 11H15V13H17V11ZM11 13H13V11H11V13ZM17.77 5.47998L16.23 6.75998L20.58 12L16.23 17.24L17.77 18.52L23.18 12L17.77 5.47998Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.FilterList]: {
    id: "filter_list",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Search]: {
    id: "search",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z",
          fill: "#323232"
        }
      }
    ]
  },
  // ARIES
  [q.ARIES]: {
    id: "aries",
    category: "aries",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M13.4697 9.47508L14.0811 11.174C14.761 13.0596 16.2457 14.5442 18.1312 15.2241L19.8301 15.8355C19.9835 15.8907 19.9835 16.1079 19.8301 16.1631L18.1312 16.7745C16.2456 17.4544 14.761 18.9391 14.0811 20.8246L13.4697 22.5235C13.4145 22.6769 13.1973 22.6769 13.1421 22.5235L12.5307 20.8246C11.8508 18.939 10.3661 17.4544 8.48061 16.7745L6.78168 16.1631C6.62836 16.1079 6.62836 15.8907 6.78168 15.8355L8.48061 15.2241C10.3662 14.5442 11.8508 13.0595 12.5307 11.174L13.1421 9.47508C13.1973 9.32081 13.4145 9.32081 13.4697 9.47508Z",
          fill: "currentColor"
        }
      },
      {
        type: ce.Path,
        props: {
          d: "M21.1177 5.39261L21.4281 6.25254C21.7729 7.20676 22.5242 7.95907 23.4794 8.30382L24.3393 8.61426C24.4174 8.64283 24.4174 8.75235 24.3393 8.77997L23.4794 9.09041C22.5252 9.43516 21.7729 10.1865 21.4281 11.1417L21.1177 12.0016C21.0891 12.0797 20.9796 12.0797 20.952 12.0016L20.6415 11.1417C20.2968 10.1875 19.5454 9.43516 18.5902 9.09041L17.7303 8.77997C17.6522 8.7514 17.6522 8.64188 17.7303 8.61426L18.5902 8.30382C19.5445 7.95907 20.2968 7.20771 20.6415 6.25254L20.952 5.39261C20.9796 5.31357 21.0901 5.31357 21.1177 5.39261Z",
          fill: "currentColor"
        }
      },
      {
        type: ce.Path,
        props: {
          d: "M21.1177 19.9991L21.4281 20.859C21.7729 21.8132 22.5242 22.5656 23.4794 22.9103L24.3393 23.2207C24.4174 23.2493 24.4174 23.3588 24.3393 23.3864L23.4794 23.6969C22.5252 24.0416 21.7729 24.793 21.4281 25.7482L21.1177 26.6081C21.0891 26.6862 20.9796 26.6862 20.952 26.6081L20.6415 25.7482C20.2968 24.794 19.5454 24.0416 18.5902 23.6969L17.7303 23.3864C17.6522 23.3579 17.6522 23.2484 17.7303 23.2207L18.5902 22.9103C19.5445 22.5656 20.2968 21.8142 20.6415 20.859L20.952 19.9991C20.9796 19.921 21.0901 19.921 21.1177 19.9991Z",
          fill: "currentColor"
        }
      }
    ]
  },
  [q.HomeFilled]: {
    id: "home_filled",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 3L4 9V21H9V14H15V21H20V9L12 3Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.KeyboardArrowLeft]: {
    id: "keyboard_arrow_left",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.KeyboardArrowRight]: {
    id: "keyboard_arrow_right",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M8.59009 16.59L13.1701 12L8.59009 7.41L10.0001 6L16.0001 12L10.0001 18L8.59009 16.59Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.CalendarToday]: {
    id: "calendar_today",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V8H20V21Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.KeyboardArrowDown]: {
    id: "keyboard_arrow_down",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M7.41 8.59003L12 13.17L16.59 8.59003L18 10L12 16L6 10L7.41 8.59003Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.KeyboardArrowUp]: {
    id: "keyboard_arrow_up",
    category: "hardware",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Edit]: {
    id: "edit",
    category: "image",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.ThumbUp]: {
    id: "thumb-up",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.ThumbDown]: {
    id: "thumb-down",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L10.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.NumericalSpinner]: {
    id: "numerical-spinner",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M7 11L12 6L17 11H7Z",
          fill: "#323232"
        }
      },
      {
        type: ce.Path,
        props: {
          d: "M7 13L12 18L17 13H7Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.AlertCircle]: {
    id: "alert-circle",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Warning]: {
    id: "warning",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.WarningOutline]: {
    id: "warning-outline",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      // Hollow triangle: the inner subpath winds against the outer one, so the
      // default nonzero fill rule leaves the middle empty.
      {
        type: ce.Path,
        props: {
          d: "M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2z",
          fill: "#323232"
        }
      },
      // Solid "!" stem and dot.
      {
        type: ce.Path,
        props: {
          d: "M11 10h2v4h-2zm0 6h2v2h-2z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Info]: {
    id: "info",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.InfoOutline]: {
    id: "info-outline",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      // Hollow ring (stroke only, no fill) — the "hollow circle".
      {
        type: ce.Circle,
        props: {
          cx: 12,
          cy: 12,
          r: 9,
          fill: "none",
          stroke: "#323232",
          strokeWidth: 1.5
        }
      },
      // Solid "i" stem.
      {
        type: ce.Path,
        props: {
          d: "M11 10.5h2v6.5h-2z",
          fill: "#323232"
        }
      },
      // Solid "i" dot.
      {
        type: ce.Circle,
        props: {
          cx: 12,
          cy: 7.6,
          r: 1.15,
          fill: "#323232"
        }
      }
    ]
  },
  [q.AccountCircle]: {
    id: "account-circle",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 54 19.5 111T234-276Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5q-42-33-92-50.5T480-286q-54 0-104 17.5T284-198q42 33 92 50.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.FindInPage]: {
    id: "find-in-page",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: ce.Path,
        props: {
          d: "m590-160 80 80H240q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h360l200 240v480q0 20-8.5 36.5T768-96L560-302q-17 11-37 16.5t-43 5.5q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 23-5.5 43T618-360l102 104v-356L562-800H240v640h350ZM480-360q33 0 56.5-23.5T560-440q0-33-23.5-56.5T480-520q-33 0-56.5 23.5T400-440q0 33 23.5 56.5T480-360Zm0-80Zm0 0Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.PrivacyTip]: {
    id: "privacy-tip",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm0-396q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm-40 40v240h80v-240h-80Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Logout]: {
    id: "logout",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Lock]: {
    id: "lock",
    category: "action",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17ZM18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H8.9V6ZM18 20H6V10H18V20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Link]: {
    id: "link",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.ErrorOutline]: {
    id: "error_outline",
    category: "alert",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Power]: {
    id: "power",
    category: "notification",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M16.01 7L16 3H14V7H10V3H8V7H7.99C7 6.99 6 7.99 6 8.99V14.48L9.5 18V21H14.5V18L18 14.49V8.99C18 7.99 17 6.99 16.01 7Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.FileUpload]: {
    id: "file_upload",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.FileDownload]: {
    id: "file_download",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.CloudUpload]: {
    id: "cloud_upload",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM14 13V17H10V13H7L12 8L17 13H14Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.AttachFile]: {
    id: "attach_file",
    category: "file",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Archive]: {
    id: "archive",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM12 17.5L6.5 12H10V10H14V12H17.5L12 17.5ZM5.12 5L5.93 4H17.93L18.87 5H5.12Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Notifications]: {
    id: "notifications",
    category: "social",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z",
          fill: "#323232"
        }
      }
    ]
  },
  // Messaging
  [q.Reply]: {
    id: "reply",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M10 9V5L3 12L10 19V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.ReplyAll]: {
    id: "reply_all",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M7 8V5L0 12L7 19V16L3 12L7 8ZM13 9V5L6 12L13 19V14.9C18 14.9 21.5 16.5 24 20C23 15 20 10 13 9Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Forward]: {
    id: "forward",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M12 8V4L20 12L12 20V16H4V8H12Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.ContentCopy]: {
    id: "content_copy",
    category: "content",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.History]: {
    id: "history",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.Mail]: {
    id: "mail",
    category: "communication",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V8L12 13L20 8V18ZM12 11L4 6H20L12 11Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.OpenInFull]: {
    id: "open_in_full",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z",
          fill: "#323232"
        }
      }
    ]
  },
  [q.CloseFullscreen]: {
    id: "close_fullscreen",
    category: "action",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data: [
      {
        type: ce.Path,
        props: {
          d: "M22 3.41L16.71 8.7L20 12H12V4L15.29 7.29L20.59 2L22 3.41ZM3.41 22L8.7 16.71L12 20V12H4L7.29 15.29L2 20.59L3.41 22Z",
          fill: "#323232"
        }
      }
    ]
  }
};
function be({ ref: e, name: t, size: n, color: i, className: r, tooltip: s, tooltipPlacement: o, onClick: l }) {
  const { width: u, height: c, viewBox: d, data: h } = Uf[t], m = ee(null), _ = rt();
  return (
    // `className` is applied to BOTH the wrapper and the <svg>. The wrapper is
    // the component root and carries the merged ref for Tooltip /
    // ContextualMenu anchoring, so layout utilities (margin, alignment) must
    // land there; but a consumer writing `<Icon className="text-red-500" />`
    // is styling the glyph, and colour utilities do not reliably inherit into
    // an SVG. Duplicating the class is redundant DOM in exchange for both
    // working. See LOA-1156 bug 17.
    /* @__PURE__ */ F("div", { ref: sr(m, e), className: r, children: [
      /* @__PURE__ */ g(
        "svg",
        {
          className: r,
          width: n ?? u,
          height: n ?? c,
          viewBox: d,
          fill: "none",
          onClick: () => {
            l && l();
          },
          children: h.map((y) => {
            const v = { ...y.props };
            switch (i && (v.fill = i, v.stroke && (v.stroke = i)), y.type) {
              case "circle":
                return /* @__PURE__ */ g("circle", { ...v }, crypto.randomUUID());
              default:
                return /* @__PURE__ */ g("path", { ...v }, crypto.randomUUID());
            }
          })
        }
      ),
      s && /* @__PURE__ */ g(kn, { id: `tooltip-${t}-${_}`, content: s, anchorRef: m, placement: o })
    ] })
  );
}
const Tn = {
  "ds-input-chrome": "_ds-input-chrome_sjquo_1",
  "ds-input-chrome__body": "_ds-input-chrome__body_sjquo_22",
  "ds-input-chrome__adornment": "_ds-input-chrome__adornment_sjquo_28",
  "ds-input-chrome__adornment--prefix": "_ds-input-chrome__adornment--prefix_sjquo_41",
  "ds-input-chrome__adornment--suffix": "_ds-input-chrome__adornment--suffix_sjquo_44",
  "ds-input-chrome__adornment--interactive": "_ds-input-chrome__adornment--interactive_sjquo_47",
  "ds-input-chrome--size-large": "_ds-input-chrome--size-large_sjquo_59",
  "ds-input-chrome--size-medium": "_ds-input-chrome--size-medium_sjquo_67",
  "ds-input-chrome--size-small": "_ds-input-chrome--size-small_sjquo_75",
  "ds-input-chrome--focused": "_ds-input-chrome--focused_sjquo_83",
  "ds-input-chrome--state-error": "_ds-input-chrome--state-error_sjquo_88",
  "ds-input-chrome--state-warning": "_ds-input-chrome--state-warning_sjquo_95",
  "ds-input-chrome--state-success": "_ds-input-chrome--state-success_sjquo_102",
  "ds-input-chrome--disabled": "_ds-input-chrome--disabled_sjquo_109",
  "ds-input-chrome--readonly": "_ds-input-chrome--readonly_sjquo_115"
};
function Gl({ icon: e, position: t, onClick: n, ariaLabel: i }) {
  const r = n ? (o) => {
    o.stopPropagation(), n();
  } : void 0, s = n ? (o) => {
    (o.key === "Enter" || o.key === " ") && (o.preventDefault(), n());
  } : void 0;
  return /* @__PURE__ */ g(
    "span",
    {
      className: X(
        Tn["ds-input-chrome__adornment"],
        Tn[`ds-input-chrome__adornment--${t}`],
        n && Tn["ds-input-chrome__adornment--interactive"]
      ),
      "data-input-adornment": t,
      "aria-hidden": n ? void 0 : !0,
      "aria-label": n ? i : void 0,
      role: n ? "button" : void 0,
      tabIndex: n ? 0 : void 0,
      onClick: r,
      onKeyDown: s,
      children: /* @__PURE__ */ g(be, { name: e, "aria-hidden": "true" })
    }
  );
}
const Rn = ({
  isFocused: e = !1,
  disabled: t = !1,
  readOnly: n = !1,
  state: i = Pe.Default,
  size: r = Nt.Medium,
  prefix: s,
  onPrefixClick: o,
  prefixAriaLabel: l,
  suffix: u,
  onSuffixClick: c,
  suffixAriaLabel: d,
  inputRef: h,
  onClick: m,
  children: _,
  className: y
}) => {
  const v = (w) => {
    w.target.closest("[data-input-adornment]") === null && (h?.current?.focus(), m?.(w));
  };
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        Tn["ds-input-chrome"],
        Tn[`ds-input-chrome--size-${r}`],
        i !== Pe.Default && Tn[`ds-input-chrome--state-${i}`],
        e && Tn["ds-input-chrome--focused"],
        t && Tn["ds-input-chrome--disabled"],
        n && Tn["ds-input-chrome--readonly"],
        y
      ),
      onClick: v,
      children: [
        s && /* @__PURE__ */ g(Gl, { icon: s, position: "prefix", onClick: o, ariaLabel: l }),
        /* @__PURE__ */ g("div", { className: Tn["ds-input-chrome__body"], children: _ }),
        u && /* @__PURE__ */ g(Gl, { icon: u, position: "suffix", onClick: c, ariaLabel: d })
      ]
    }
  );
}, qf = {
  "ds-text-entry": "_ds-text-entry_542kk_1"
}, On = ({
  id: e,
  name: t,
  ref: n,
  value: i,
  placeholder: r,
  type: s = gt.Text,
  disabled: o = !1,
  readOnly: l = !1,
  maxLength: u,
  minLength: c,
  min: d,
  max: h,
  required: m = !1,
  ariaLabel: _,
  ariaLabelledBy: y,
  ariaDescribedBy: v,
  ariaExpanded: w,
  ariaControls: x,
  ariaActivedescendant: A,
  role: S,
  ariaInvalid: N = !1,
  ariaAutocomplete: E,
  onChange: f,
  onFocus: C,
  onBlur: L,
  onKeyDown: R,
  onPaste: V,
  autoComplete: z = "off",
  className: $
}) => {
  const H = ee(null), B = (O) => {
    s === gt.Number && O.key.length === 1 && !/^[0-9]$/.test(O.key) && !O.ctrlKey && !O.metaKey && O.preventDefault(), R?.(O);
  };
  return /* @__PURE__ */ g(
    "input",
    {
      ref: sr(H, n),
      id: e,
      name: t,
      type: s,
      value: i,
      placeholder: r,
      disabled: o,
      readOnly: l,
      maxLength: u,
      minLength: c,
      min: d,
      max: h,
      required: m,
      autoComplete: z,
      role: S,
      "aria-label": _,
      "aria-labelledby": y,
      "aria-describedby": v,
      "aria-expanded": w,
      "aria-controls": x,
      "aria-activedescendant": A,
      "aria-invalid": N || void 0,
      "aria-autocomplete": E,
      "aria-required": m || void 0,
      className: `${qf["ds-text-entry"]}${$ ? ` ${$}` : ""}`,
      onChange: (O) => f(O.target.value),
      onFocus: C,
      onBlur: L,
      onKeyDown: B,
      onPaste: V
    }
  );
}, Jf = Af(function({
  id: t,
  name: n,
  placeholder: i,
  disabled: r = !1,
  readOnly: s = !1,
  required: o = !1,
  size: l = Nt.Medium,
  state: u = Pe.Default,
  width: c = we.Auto,
  prefix: d,
  onPrefixClick: h,
  suffix: m,
  onSuffixClick: _,
  inputType: y = gt.Text,
  maxLength: v,
  minLength: w,
  min: x,
  max: A,
  className: S,
  value: N,
  defaultValue: E = "",
  onChange: f,
  onBlur: C,
  onFocus: L,
  ariaLabel: R
}, V) {
  const z = rt(), $ = t ?? z, H = ee(null), [B, O] = Ee(!1), [W, G] = Yt(N, E, f), re = () => {
    O(!0), L?.();
  }, K = () => {
    O(!1), C?.(W);
  };
  return /* @__PURE__ */ g(
    Rn,
    {
      isFocused: B,
      disabled: r,
      readOnly: s,
      state: u,
      size: l,
      prefix: d,
      onPrefixClick: h,
      suffix: m,
      onSuffixClick: _,
      inputRef: H,
      className: X(
        Zl["ds-input"],
        c !== we.Auto && Zl[`ds-input--width-${c}`],
        S
      ),
      children: /* @__PURE__ */ g(
        On,
        {
          ref: sr(H, V),
          id: $,
          name: n,
          value: W,
          placeholder: i,
          type: y,
          disabled: r,
          readOnly: s,
          maxLength: v,
          minLength: w,
          min: x,
          max: A,
          required: o,
          ariaLabel: R,
          ariaInvalid: u === Pe.Error,
          onChange: G,
          onFocus: re,
          onBlur: K
        }
      )
    }
  );
}), It = {
  "ds-field-base": "_ds-field-base_1t7a2_1",
  "ds-field-base__label-row": "_ds-field-base__label-row_1t7a2_8",
  "ds-field-base__label": "_ds-field-base__label_1t7a2_8",
  "ds-field-base__required": "_ds-field-base__required_1t7a2_22",
  "ds-field-base__help-trigger": "_ds-field-base__help-trigger_1t7a2_25",
  "ds-field-base__description": "_ds-field-base__description_1t7a2_42",
  "ds-field-base__control": "_ds-field-base__control_1t7a2_48",
  "ds-field-base__control-row": "_ds-field-base__control-row_1t7a2_52",
  "ds-field-base__control-input": "_ds-field-base__control-input_1t7a2_57",
  "ds-field-base__suffix-copy": "_ds-field-base__suffix-copy_1t7a2_61",
  "ds-field-base__footer": "_ds-field-base__footer_1t7a2_69",
  "ds-field-base__hint": "_ds-field-base__hint_1t7a2_76",
  "ds-field-base__hint--error": "_ds-field-base__hint--error_1t7a2_83",
  "ds-field-base__hint--warning": "_ds-field-base__hint--warning_1t7a2_86",
  "ds-field-base__hint--success": "_ds-field-base__hint--success_1t7a2_89",
  "ds-field-base__counter": "_ds-field-base__counter_1t7a2_92",
  "ds-field-base__counter--exceeded": "_ds-field-base__counter--exceeded_1t7a2_99",
  "ds-field-base--disabled": "_ds-field-base--disabled_1t7a2_103",
  "ds-field-base--width-full": "_ds-field-base--width-full_1t7a2_111",
  "ds-field-base--width-sm": "_ds-field-base--width-sm_1t7a2_114",
  "ds-field-base--width-md": "_ds-field-base--width-md_1t7a2_117",
  "ds-field-base--width-lg": "_ds-field-base--width-lg_1t7a2_120"
}, ti = ({
  id: e,
  label: t,
  description: n,
  hint: i,
  state: r = Pe.Default,
  required: s = !1,
  disabled: o = !1,
  width: l = we.Auto,
  tooltip: u,
  tooltipPlacement: c,
  maxLength: d,
  currentLength: h,
  suffixCopy: m,
  className: _,
  children: y
}) => {
  const v = ee(null), w = rt(), x = d !== void 0 && h !== void 0 && h > d;
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        It["ds-field-base"],
        r !== Pe.Default && It[`ds-field-base--${r}`],
        o && It["ds-field-base--disabled"],
        l !== we.Auto && It[`ds-field-base--width-${l}`],
        _
      ),
      children: [
        t && /* @__PURE__ */ F("div", { className: It["ds-field-base__label-row"], children: [
          /* @__PURE__ */ F("label", { htmlFor: e, className: It["ds-field-base__label"], children: [
            t,
            s && /* @__PURE__ */ g("span", { className: It["ds-field-base__required"], "aria-hidden": "true", children: " *" })
          ] }),
          u && /* @__PURE__ */ F(et, { children: [
            /* @__PURE__ */ g(
              "span",
              {
                ref: v,
                className: It["ds-field-base__help-trigger"],
                role: "img",
                "aria-label": `More information about ${t}`,
                children: /* @__PURE__ */ g(be, { name: q.Help, "aria-hidden": "true" })
              }
            ),
            /* @__PURE__ */ g(kn, { id: w, content: u, anchorRef: v, placement: c })
          ] })
        ] }),
        n && /* @__PURE__ */ g("p", { id: `${e}-description`, className: It["ds-field-base__description"], children: n }),
        /* @__PURE__ */ g("div", { className: It["ds-field-base__control"], children: m ? /* @__PURE__ */ F("div", { className: It["ds-field-base__control-row"], children: [
          /* @__PURE__ */ g("div", { className: It["ds-field-base__control-input"], children: y }),
          /* @__PURE__ */ g("span", { className: It["ds-field-base__suffix-copy"], children: m })
        ] }) : y }),
        (i || d !== void 0 && h !== void 0) && /* @__PURE__ */ F("div", { className: It["ds-field-base__footer"], children: [
          i && /* @__PURE__ */ g(
            "p",
            {
              id: `${e}-hint`,
              className: X(
                It["ds-field-base__hint"],
                r !== Pe.Default && It[`ds-field-base__hint--${r}`]
              ),
              role: r === Pe.Error ? "alert" : void 0,
              "aria-live": r === Pe.Error ? "polite" : void 0,
              children: i
            }
          ),
          d !== void 0 && h !== void 0 && /* @__PURE__ */ F(
            "span",
            {
              className: X(It["ds-field-base__counter"], x && It["ds-field-base__counter--exceeded"]),
              "aria-label": `${h} of ${d} characters used`,
              "aria-live": "polite",
              children: [
                h,
                "/",
                d
              ]
            }
          )
        ] })
      ]
    }
  );
}, Wf = {}, Ki = ({
  id: e,
  name: t,
  ref: n,
  label: i,
  description: r,
  hint: s,
  state: o = Pe.Default,
  placeholder: l,
  disabled: u = !1,
  readOnly: c = !1,
  size: d = Nt.Medium,
  required: h = !1,
  min: m,
  max: _,
  minLength: y,
  maxLength: v,
  prefix: w,
  onPrefixClick: x,
  prefixAriaLabel: A,
  suffix: S,
  onSuffixClick: N,
  suffixAriaLabel: E,
  suffixCopy: f,
  tooltip: C,
  tooltipPlacement: L,
  width: R,
  className: V,
  value: z,
  defaultValue: $ = "",
  onChange: H,
  onBlur: B,
  onFocus: O,
  onKeyDown: W,
  inputType: G = gt.Text,
  showCounter: re = !1,
  revealable: K = !1,
  revealAriaLabel: P = "Show value",
  hideAriaLabel: oe = "Hide value"
}) => {
  const se = ee(null), [D, pe] = Ee(!1), [Ce, Z] = Ee(!1), [j, ie] = Yt(z, $, H);
  let te = G, ge = S, ne = N, _e = E;
  K && (te = Ce ? gt.Text : gt.Password, ge = Ce ? q.VisibilityOff : q.Visibility, ne = () => Z((Ke) => !Ke), _e = Ce ? oe : P);
  const Ie = () => {
    pe(!0), O?.();
  }, Ve = () => {
    pe(!1), B?.(j);
  }, nt = [r ? `${e}-description` : null, s ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ g(
    ti,
    {
      id: e,
      label: i,
      description: r,
      hint: s,
      state: o,
      required: h,
      disabled: u,
      tooltip: C,
      tooltipPlacement: L,
      suffixCopy: f,
      width: R,
      maxLength: re && v !== void 0 ? v : void 0,
      currentLength: re && v !== void 0 ? j.length : void 0,
      className: V,
      children: /* @__PURE__ */ g(
        Rn,
        {
          isFocused: D,
          disabled: u,
          readOnly: c,
          state: o,
          size: d,
          prefix: w,
          onPrefixClick: x,
          prefixAriaLabel: A,
          suffix: ge,
          onSuffixClick: ne,
          suffixAriaLabel: _e,
          inputRef: se,
          className: Wf["ds-text-field__chrome"],
          children: /* @__PURE__ */ g(
            On,
            {
              ref: (Ke) => {
                se.current = Ke, typeof n == "function" ? n(Ke) : n && (n.current = Ke);
              },
              id: e,
              name: t,
              value: j,
              placeholder: l,
              type: te,
              disabled: u,
              readOnly: c,
              maxLength: v,
              minLength: y,
              min: m,
              max: _,
              required: h,
              ariaDescribedBy: nt,
              ariaInvalid: o === Pe.Error,
              onChange: ie,
              onFocus: Ie,
              onBlur: Ve,
              onKeyDown: W
            }
          )
        }
      )
    }
  );
};
function Zf(e, t) {
  if (e.length === 0)
    return null;
  if (t === null)
    return e[0]?.id ?? null;
  const n = e.findIndex((i) => i.id === t);
  return e[(n + 1) % e.length]?.id ?? null;
}
function Xf(e, t) {
  if (e.length === 0)
    return null;
  if (t === null)
    return e[e.length - 1]?.id ?? null;
  const n = e.findIndex((r) => r.id === t), i = n <= 0 ? e.length - 1 : n - 1;
  return e[i]?.id ?? null;
}
function Gf(e, t) {
  t && e.get(t)?.scrollIntoView({ block: "nearest" });
}
function ar({
  options: e,
  isOpen: t,
  onSelect: n,
  onClose: i,
  onOpen: r
}) {
  const [s, o] = Ee(null), l = ee(/* @__PURE__ */ new Map()), u = he((m, _) => {
    l.current.set(m, _);
  }, []), c = e.filter((m) => !m.disabled), d = he(
    (m) => {
      const _ = (y) => {
        o(y), Gf(l.current, y);
      };
      switch (m.key) {
        case "ArrowDown": {
          m.preventDefault(), t || r(), _(Zf(c, t ? s : null));
          break;
        }
        case "ArrowUp": {
          m.preventDefault(), t || r(), _(Xf(c, t ? s : null));
          break;
        }
        case "Home": {
          if (!t)
            break;
          m.preventDefault(), _(c[0]?.id ?? null);
          break;
        }
        case "End": {
          if (!t)
            break;
          m.preventDefault(), _(c[c.length - 1]?.id ?? null);
          break;
        }
        case "Enter": {
          if (!t || s === null)
            break;
          m.preventDefault();
          const y = e.find((v) => v.id === s);
          y && !y.disabled && n(y);
          break;
        }
        case "Escape": {
          if (!t)
            break;
          m.preventDefault(), i(), o(null);
          break;
        }
        case "Tab": {
          if (!t)
            break;
          i(), o(null);
          break;
        }
      }
    },
    [t, s, e, c, r, n, i]
  ), h = he(() => o(null), []);
  return {
    activeId: s,
    clearActiveId: h,
    handleInputKeyDown: d,
    onOptionRef: u
  };
}
function _i({
  anchorRef: e,
  overlayRef: t,
  placement: n = "bottom-start",
  disabled: i = !1,
  isOpen: r,
  onOpenChange: s,
  onOpen: o,
  onClose: l
}) {
  const [u, c] = Yt(r, !1, s), d = ee(!1);
  me(() => {
    d.current = u;
  }, [u]);
  const h = ee({
    x: 0,
    y: 0,
    resolvedPlacement: n
  }), m = ee(!1), _ = he(() => {
    i || d.current || c(!0);
  }, [i, c]), y = he(() => {
    d.current && c(!1);
  }, [c]), v = he(() => {
    d.current ? y() : _();
  }, [_, y]);
  return me(() => {
    if (!m.current) {
      m.current = !0;
      return;
    }
    u ? o?.() : l?.();
  }, [u, o, l]), me(() => {
    if (!u)
      return;
    const w = (x) => {
      const A = e.current, S = t.current;
      A?.contains(x.target) || S?.contains(x.target) || y();
    };
    return document.addEventListener("pointerdown", w, {
      capture: !0
    }), document.addEventListener("click", w, {
      capture: !0
    }), () => {
      document.removeEventListener("pointerdown", w, { capture: !0 }), document.removeEventListener("click", w, { capture: !0 });
    };
  }, [u, e, t, y]), me(() => {
    if (!u)
      return;
    const w = (x) => {
      x.key === "Escape" && (x.stopPropagation(), y(), e.current?.focus());
    };
    return document.addEventListener("keydown", w, { capture: !0 }), () => {
      document.removeEventListener("keydown", w, {
        capture: !0
      });
    };
  }, [u, y, e]), {
    isOpen: u,
    open: _,
    close: y,
    toggle: v,
    position: h.current
  };
}
function Ro(e) {
  const { mode: t, options: n } = e, i = t === "single" ? e : void 0, [r, s] = Yt(
    t === "single" ? i.value : void 0,
    t === "single" ? i.defaultValue ?? null : null,
    t === "single" ? i.onChange : void 0
  ), o = t === "multi" ? e : void 0, [l, u] = Yt(
    t === "multi" ? o.value : void 0,
    t === "multi" ? o.defaultValue ?? [] : [],
    t === "multi" ? o.onChange : void 0
  ), c = $e(() => {
    if (t === "single") {
      if (r == null)
        return [];
      const x = n.find((A) => A.value === r);
      return x ? [x.id] : [];
    }
    return n.filter((x) => l.includes(x.value)).map((x) => x.id);
  }, [t, r, l, n]), d = $e(() => n.filter((x) => c.includes(x.id)), [n, c]), h = he((x) => c.includes(x), [c]), m = he(
    (x) => {
      t === "single" ? s(x.value) : u((A) => A.includes(x.value) ? A : [...A, x.value]);
    },
    [t, s, u]
  ), _ = he(
    (x) => {
      if (t === "single")
        n.find((S) => S.id === x)?.value === r && s(null);
      else {
        const A = n.find((S) => S.id === x);
        A && u((S) => S.filter((N) => N !== A.value));
      }
    },
    [t, n, r, s, u]
  ), y = he(
    (x) => {
      h(x.id) ? _(x.id) : m(x);
    },
    [h, _, m]
  ), v = he(() => {
    t === "single" ? s(null) : u([]);
  }, [t, s, u]), w = $e(() => d.map((x) => x.label).join(", "), [d]);
  return {
    selectedIds: c,
    selectedOptions: d,
    isSelected: h,
    select: m,
    deselect: _,
    toggle: y,
    clear: v,
    displayValue: w
  };
}
const $t = {
  "ds-option-list": "_ds-option-list_cyotw_1",
  "ds-option-list__item": "_ds-option-list__item_cyotw_7",
  "ds-option-list__item--disabled": "_ds-option-list__item--disabled_cyotw_17",
  "ds-option-list__item--active": "_ds-option-list__item--active_cyotw_20",
  "ds-option-list__item--selected": "_ds-option-list__item--selected_cyotw_25",
  "ds-option-list__label": "_ds-option-list__label_cyotw_28",
  "ds-option-list__checkbox": "_ds-option-list__checkbox_cyotw_42",
  "ds-option-list__checkbox--checked": "_ds-option-list__checkbox--checked_cyotw_51",
  "ds-option-list__icon": "_ds-option-list__icon_cyotw_58",
  "ds-option-list__content": "_ds-option-list__content_cyotw_68",
  "ds-option-list__label--wrap": "_ds-option-list__label--wrap_cyotw_84",
  "ds-option-list__description": "_ds-option-list__description_cyotw_89",
  "ds-option-list__description--sr-only": "_ds-option-list__description--sr-only_cyotw_97",
  "ds-option-list__selected-mark": "_ds-option-list__selected-mark_cyotw_108",
  "ds-option-list__empty": "_ds-option-list__empty_cyotw_115"
};
function Kf({
  option: e,
  isSelected: t,
  isActive: n,
  mode: i,
  onActivate: r,
  onRef: s,
  selectedMarkPosition: o = "trailing"
}) {
  const l = (_) => {
    _.preventDefault(), e.disabled || r(e);
  }, u = (_) => {
    (_.key === "Enter" || _.key === " ") && (_.preventDefault(), e.disabled || r(e));
  }, c = !!(e.icon && e.description && e.descriptionAsTooltip), d = e.description ? `${e.id}-description` : void 0, h = e.icon && /* @__PURE__ */ g("span", { className: $t["ds-option-list__icon"], "aria-hidden": c ? void 0 : "true", children: /* @__PURE__ */ g(be, { name: e.icon, tooltip: c ? e.description : void 0 }) }), m = i === "single" && t && /* @__PURE__ */ g("span", { className: $t["ds-option-list__selected-mark"], "aria-hidden": "true", children: "✓" });
  return /* @__PURE__ */ F(
    "li",
    {
      ref: (_) => s(e.id, _),
      id: e.id,
      role: "option",
      "aria-selected": t,
      "aria-disabled": e.disabled ? !0 : void 0,
      "aria-describedby": d,
      className: X(
        $t["ds-option-list__item"],
        n && $t["ds-option-list__item--active"],
        t && $t["ds-option-list__item--selected"],
        e.disabled && $t["ds-option-list__item--disabled"]
      ),
      onClick: l,
      onKeyDown: u,
      children: [
        i === "multi" && /* @__PURE__ */ g(
          "span",
          {
            className: X($t["ds-option-list__checkbox"], t && $t["ds-option-list__checkbox--checked"]),
            "aria-hidden": "true"
          }
        ),
        o === "leading" && m,
        e.iconPosition !== "trailing" && h,
        /* @__PURE__ */ F("span", { className: $t["ds-option-list__content"], children: [
          /* @__PURE__ */ g(
            "span",
            {
              className: X(
                $t["ds-option-list__label"],
                e.description && !c && $t["ds-option-list__label--wrap"]
              ),
              children: e.label
            }
          ),
          e.description && !c && /* @__PURE__ */ g("span", { id: d, className: $t["ds-option-list__description"], "aria-hidden": "true", children: e.description }),
          e.description && c && /* @__PURE__ */ g("span", { id: d, className: $t["ds-option-list__description--sr-only"], "aria-hidden": "true", children: e.description })
        ] }),
        e.iconPosition === "trailing" && h,
        o === "trailing" && m
      ]
    }
  );
}
function or({
  id: e,
  options: t,
  selectedIds: n,
  activeId: i,
  mode: r = "single",
  ariaLabel: s,
  emptyText: o = "No options available",
  onActivate: l,
  onOptionRef: u,
  className: c,
  selectedMarkPosition: d
}) {
  return /* @__PURE__ */ g(
    "ul",
    {
      id: e,
      role: "listbox",
      "aria-label": s,
      "aria-multiselectable": r === "multi" ? !0 : void 0,
      className: X($t["ds-option-list"], c),
      onMouseDown: (h) => h.preventDefault(),
      children: t.length === 0 ? /* @__PURE__ */ g("li", { role: "presentation", className: $t["ds-option-list__empty"], "aria-live": "polite", children: o }) : t.map((h) => /* @__PURE__ */ g(
        Kf,
        {
          option: h,
          isSelected: n.includes(h.id),
          isActive: i === h.id,
          mode: r,
          onActivate: l,
          onRef: u,
          selectedMarkPosition: d
        },
        h.id
      ))
    }
  );
}
const Yf = "ds-input-overlay-layer", Qf = 4, e0 = 8, t0 = {
  "bottom-start": ["top-start", "bottom-end", "top-end"],
  "bottom-end": ["top-end", "bottom-start", "top-start"],
  "top-start": ["bottom-start", "top-end", "bottom-end"],
  "top-end": ["bottom-end", "top-start", "bottom-start"]
};
function Kl(e, t, n, i) {
  switch (n) {
    case "bottom-start":
      return {
        x: e.left,
        y: e.bottom + i
      };
    case "bottom-end":
      return {
        x: e.right - t.width,
        y: e.bottom + i
      };
    case "top-start":
      return {
        x: e.left,
        y: e.top - t.height - i
      };
    case "top-end":
      return {
        x: e.right - t.width,
        y: e.top - t.height - i
      };
  }
}
function n0(e, t, n, i, r) {
  const { viewportPaddingPx: s, flip: o } = r;
  let l = n, u = Kl(e, t, n, i);
  if (o && !tr(u.x, u.y, t.width, t.height, s))
    for (const d of t0[n]) {
      const h = Kl(e, t, d, i);
      if (tr(h.x, h.y, t.width, t.height, s)) {
        l = d, u = h;
        break;
      }
    }
  const c = Fo(u.x, u.y, t.width, t.height, s);
  return { x: c.x, y: c.y, resolvedPlacement: l };
}
const oa = {
  "ds-overlay-surface": "_ds-overlay-surface_4ir7y_1",
  "ds-overlay-surface--bottom-start": "_ds-overlay-surface--bottom-start_4ir7y_28",
  "ds-overlay-surface--bottom-end": "_ds-overlay-surface--bottom-end_4ir7y_28",
  "ds-overlay-surface--closed": "_ds-overlay-surface--closed_4ir7y_31",
  "ds-overlay-surface--open": "_ds-overlay-surface--open_4ir7y_34",
  "ds-overlay-surface--top-start": "_ds-overlay-surface--top-start_4ir7y_37",
  "ds-overlay-surface--top-end": "_ds-overlay-surface--top-end_4ir7y_37"
}, gi = ({
  id: e,
  anchorRef: t,
  isOpen: n,
  placement: i = "bottom-start",
  offsetPx: r = Qf,
  collision: s,
  layerId: o = Yf,
  minWidth: l,
  className: u,
  children: c,
  ref: d
}) => {
  const h = ee(null), m = ee(null), _ = ee({
    x: 0,
    y: 0,
    resolvedPlacement: i
  }), y = {
    viewportPaddingPx: s?.viewportPaddingPx ?? e0,
    flip: s?.flip ?? !0
  }, v = he(() => {
    m.current !== null && (cancelAnimationFrame(m.current), m.current = null);
  }, []), w = he(() => {
    const N = t.current, E = h.current;
    if (!N || !E)
      return;
    const f = N.getBoundingClientRect(), C = E.getBoundingClientRect();
    l === "anchor" && (E.style.minWidth = `${f.width}px`);
    const L = n0(f, C, i, r, y);
    _.current = L, E.style.setProperty("--_x", `${L.x}px`), E.style.setProperty("--_y", `${L.y}px`), E.dataset.placement = L.resolvedPlacement;
  }, [t, i, r, l, y.viewportPaddingPx, y.flip]), x = he(() => {
    v(), m.current = requestAnimationFrame(() => {
      w();
    });
  }, [v, w]);
  rr(() => {
    n && w();
  }, [n, w]), me(() => {
    if (!n) {
      v();
      return;
    }
    const N = () => x(), E = () => x();
    return window.addEventListener("scroll", N, { capture: !0, passive: !0 }), window.addEventListener("resize", E, { passive: !0 }), () => {
      window.removeEventListener("scroll", N, {
        capture: !0
      }), window.removeEventListener("resize", E), v();
    };
  }, [n, x, v]), me(() => {
    const N = t.current;
    if (!N || !n)
      return;
    const E = new ResizeObserver(() => x());
    return E.observe(N), h.current && E.observe(h.current), () => E.disconnect();
  }, [t, n, x]), me(() => () => v(), [v]);
  const A = n ? "open" : "closed", S = pi(o);
  return hi(
    /* @__PURE__ */ g(
      "div",
      {
        ref: sr(h, d),
        id: e,
        className: X(
          oa["ds-overlay-surface"],
          oa[`ds-overlay-surface--${_.current.resolvedPlacement}`],
          oa[`ds-overlay-surface--${A}`],
          u
        ),
        "data-state": A,
        "data-placement": _.current.resolvedPlacement,
        children: c
      }
    ),
    S
  );
}, vr = {
  "ds-select-field": "_ds-select-field_r82g1_1",
  "ds-select-field--width-full": "_ds-select-field--width-full_r82g1_6",
  "ds-select-field--width-sm": "_ds-select-field--width-sm_r82g1_9",
  "ds-select-field--width-md": "_ds-select-field--width-md_r82g1_12",
  "ds-select-field--width-lg": "_ds-select-field--width-lg_r82g1_15",
  "ds-select-field__trigger-wrap": "_ds-select-field__trigger-wrap_r82g1_18",
  "ds-select-field__chrome": "_ds-select-field__chrome_r82g1_22",
  "ds-select-field__input": "_ds-select-field__input_r82g1_25"
};
function Oo({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: s = Pe.Default,
  placeholder: o = "Select an option",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = Nt.Medium,
  required: d = !1,
  prefix: h,
  suffix: m,
  suffixCopy: _,
  tooltip: y,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: x,
  options: A,
  value: S,
  defaultValue: N = null,
  onChange: E,
  emptyText: f = "No options available",
  popupPlacement: C = "bottom-start",
  selectedMarkPosition: L
}) {
  const R = ee(null), V = ee(null), z = ee(null), [$, H] = Ee(!1), B = rt(), { isOpen: O, open: W, close: G } = _i({
    anchorRef: R,
    overlayRef: V,
    placement: C,
    disabled: l || u
  }), { selectedIds: re, displayValue: K, select: P } = Ro({
    mode: "single",
    options: A,
    value: S,
    defaultValue: N,
    onChange: E
  }), { activeId: oe, clearActiveId: se, handleInputKeyDown: D, onOptionRef: pe } = ar({
    options: A,
    isOpen: O,
    onOpen: W,
    onClose: G,
    onSelect: (ne) => {
      P(ne), G(), se(), z.current?.focus();
    }
  }), Ce = () => {
    l || u || (O ? G() : W(), z.current?.focus());
  }, Z = (ne) => {
    P(ne), G(), se(), z.current?.focus();
  }, j = () => H(!0), ie = () => {
    H(!1);
  }, te = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, ge = m ?? q.KeyboardArrowDown;
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        vr["ds-select-field"],
        w !== we.Auto && vr[`ds-select-field--width-${w}`],
        x
      ),
      children: [
        /* @__PURE__ */ g(
          ti,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: s,
            required: d,
            disabled: l,
            tooltip: y,
            tooltipPlacement: v,
            suffixCopy: _,
            children: /* @__PURE__ */ g("div", { ref: R, className: vr["ds-select-field__trigger-wrap"], children: /* @__PURE__ */ g(
              Rn,
              {
                isFocused: $ || O,
                disabled: l,
                readOnly: u,
                state: s,
                size: c,
                prefix: h,
                suffix: ge,
                inputRef: z,
                onClick: Ce,
                className: vr["ds-select-field__chrome"],
                children: /* @__PURE__ */ g(
                  On,
                  {
                    ref: z,
                    id: e,
                    name: t,
                    value: K,
                    placeholder: o,
                    type: gt.Text,
                    disabled: l,
                    readOnly: !0,
                    required: d,
                    role: "combobox",
                    ariaExpanded: O,
                    ariaControls: B,
                    ariaActivedescendant: oe ?? void 0,
                    ariaDescribedBy: te,
                    ariaInvalid: s === Pe.Error,
                    onChange: () => {
                    },
                    onFocus: j,
                    onBlur: ie,
                    onKeyDown: D,
                    className: vr["ds-select-field__input"]
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ g(
          gi,
          {
            id: B,
            ref: V,
            anchorRef: R,
            isOpen: O && !l && !u,
            placement: C,
            minWidth: "anchor",
            children: /* @__PURE__ */ g(
              or,
              {
                id: `${B}-list`,
                options: A,
                selectedIds: re,
                activeId: oe,
                mode: "single",
                ariaLabel: n,
                emptyText: f,
                onActivate: Z,
                onOptionRef: pe,
                selectedMarkPosition: L
              }
            )
          }
        )
      ]
    }
  );
}
function la(e) {
  return e.toLowerCase().trim();
}
function Bo(e, t, n = !0) {
  return $e(() => {
    if (!n || t.trim() === "")
      return e;
    const i = la(t);
    return e.filter((r) => !!(la(r.label).includes(i) || r.description && la(r.description).includes(i)));
  }, [e, t, n]);
}
const ls = {
  "ds-combo-box-field": "_ds-combo-box-field_18p8z_1",
  "ds-combo-box-field--width-full": "_ds-combo-box-field--width-full_18p8z_6",
  "ds-combo-box-field--width-sm": "_ds-combo-box-field--width-sm_18p8z_9",
  "ds-combo-box-field--width-md": "_ds-combo-box-field--width-md_18p8z_12",
  "ds-combo-box-field--width-lg": "_ds-combo-box-field--width-lg_18p8z_15",
  "ds-combo-box-field__trigger-wrap": "_ds-combo-box-field__trigger-wrap_18p8z_18"
};
function rd({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: s = Pe.Default,
  placeholder: o = "Search or select...",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = Nt.Medium,
  required: d = !1,
  minLength: h,
  maxLength: m,
  prefix: _,
  suffix: y = q.KeyboardArrowDown,
  suffixCopy: v,
  tooltip: w,
  tooltipPlacement: x,
  width: A = we.Auto,
  className: S,
  options: N,
  value: E,
  defaultValue: f = null,
  onChange: C,
  noOptionsText: L = "No matching options",
  popupPlacement: R = "bottom-start",
  allowFreeInput: V = !1,
  onFreeInput: z
}) {
  const $ = ee(null), H = ee(null), B = ee(null), O = ee(!1), [W, G] = Ee(!1), [re, K] = Ee(""), P = rt(), { isOpen: oe, open: se, close: D } = _i({
    anchorRef: $,
    overlayRef: H,
    placement: R,
    disabled: l || u
  }), { selectedIds: pe, displayValue: Ce, select: Z, clear: j } = Ro({
    mode: "single",
    options: N,
    value: E,
    defaultValue: f,
    onChange: C
  }), ie = V && typeof E == "string" && E.trim() !== "" ? E : "", te = Ce || ie, ge = Bo(N, re, !0), { activeId: ne, clearActiveId: _e, handleInputKeyDown: Ie, onOptionRef: Ve } = ar({
    options: ge,
    isOpen: oe,
    onOpen: se,
    onClose: () => {
      D(), K(te);
    },
    onSelect: (Re) => {
      Z(Re), K(Re.label), D(), _e(), O.current = !0, B.current?.focus();
    }
  }), nt = (Re) => {
    K(Re), !oe && Re.length > 0 && se(), Re === "" && j();
  }, Ke = (Re) => {
    Z(Re), K(Re.label), D(), _e(), O.current = !0, B.current?.focus();
  }, pt = () => {
    if (G(!0), O.current) {
      O.current = !1;
      return;
    }
    N.length > 0 && (K(""), se());
  }, Be = () => {
    G(!1), te ? K(te) : V && re.trim() !== "" ? z?.(re.trim()) : V || (K(""), j());
  }, xt = () => {
    l || u || !oe && N.length > 0 && (K(""), se());
  }, kt = () => {
    l || u || (oe ? (D(), K(te)) : N.length > 0 && (K(""), se(), B.current?.focus()));
  }, ft = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, Fe = W ? re : te, je = y ?? q.KeyboardArrowDown;
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        ls["ds-combo-box-field"],
        A !== we.Auto && ls[`ds-combo-box-field--width-${A}`],
        S
      ),
      children: [
        /* @__PURE__ */ g(
          ti,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: s,
            required: d,
            disabled: l,
            tooltip: w,
            tooltipPlacement: x,
            suffixCopy: v,
            children: /* @__PURE__ */ g("div", { ref: $, className: ls["ds-combo-box-field__trigger-wrap"], children: /* @__PURE__ */ g(
              Rn,
              {
                isFocused: W || oe,
                disabled: l,
                readOnly: u,
                state: s,
                size: c,
                prefix: _,
                suffix: je,
                inputRef: B,
                className: ls["ds-combo-box-field__chrome"],
                onClick: xt,
                onSuffixClick: kt,
                suffixAriaLabel: oe ? "Close options" : "Open options",
                children: /* @__PURE__ */ g(
                  On,
                  {
                    ref: B,
                    id: e,
                    name: t,
                    value: Fe,
                    placeholder: o,
                    type: gt.Text,
                    disabled: l,
                    readOnly: u,
                    required: d,
                    minLength: h,
                    maxLength: m,
                    role: "combobox",
                    ariaExpanded: oe,
                    ariaControls: P,
                    ariaActivedescendant: ne ?? void 0,
                    ariaDescribedBy: ft,
                    ariaInvalid: s === Pe.Error,
                    autoComplete: "off",
                    onChange: nt,
                    onFocus: pt,
                    onBlur: Be,
                    onKeyDown: Ie
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ g(
          gi,
          {
            id: P,
            ref: H,
            anchorRef: $,
            isOpen: oe && !l && !u,
            placement: R,
            minWidth: "anchor",
            children: /* @__PURE__ */ g(
              or,
              {
                id: `${P}-list`,
                options: ge,
                selectedIds: pe,
                activeId: ne,
                mode: "single",
                ariaLabel: n,
                emptyText: L,
                onActivate: Ke,
                onOptionRef: Ve
              }
            )
          }
        )
      ]
    }
  );
}
const Pn = {
  "ds-multi-select-field": "_ds-multi-select-field_yvwwl_1",
  "ds-multi-select-field--width-full": "_ds-multi-select-field--width-full_yvwwl_6",
  "ds-multi-select-field--width-sm": "_ds-multi-select-field--width-sm_yvwwl_9",
  "ds-multi-select-field--width-md": "_ds-multi-select-field--width-md_yvwwl_12",
  "ds-multi-select-field--width-lg": "_ds-multi-select-field--width-lg_yvwwl_15",
  "ds-multi-select-field__trigger-wrap": "_ds-multi-select-field__trigger-wrap_yvwwl_18",
  "ds-multi-select-field__chrome": "_ds-multi-select-field__chrome_yvwwl_22",
  "ds-multi-select__body": "_ds-multi-select__body_yvwwl_29",
  "ds-multi-select__text-entry": "_ds-multi-select__text-entry_yvwwl_39",
  "ds-multi-select__chip": "_ds-multi-select__chip_yvwwl_44",
  "ds-multi-select__chip--disabled": "_ds-multi-select__chip--disabled_yvwwl_59",
  "ds-multi-select__chip-label": "_ds-multi-select__chip-label_yvwwl_62",
  "ds-multi-select__chip-remove": "_ds-multi-select__chip-remove_yvwwl_66"
};
function i0({
  option: e,
  onRemove: t,
  disabled: n
}) {
  const i = (s) => {
    s.stopPropagation(), n || t(e.id);
  }, r = (s) => {
    (s.key === "Enter" || s.key === " " || s.key === "Backspace") && !n && (s.preventDefault(), s.stopPropagation(), t(e.id));
  };
  return /* @__PURE__ */ F(
    "span",
    {
      className: X(Pn["ds-multi-select__chip"], n && Pn["ds-multi-select__chip--disabled"]),
      role: "group",
      "aria-label": e.label,
      children: [
        /* @__PURE__ */ g("span", { className: Pn["ds-multi-select__chip-label"], children: e.label }),
        !n && /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            className: Pn["ds-multi-select__chip-remove"],
            "aria-label": `Remove ${e.label}`,
            onClick: i,
            onKeyDown: r,
            tabIndex: 0,
            children: "×"
          }
        )
      ]
    }
  );
}
function sd({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: s = Pe.Default,
  placeholder: o = "Select options...",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = Nt.Medium,
  required: d = !1,
  prefix: h,
  suffix: m,
  suffixCopy: _,
  tooltip: y,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: x,
  options: A,
  value: S,
  defaultValue: N = [],
  onChange: E,
  noOptionsText: f = "No matching options",
  popupPlacement: C = "bottom-start",
  maxSelections: L
}) {
  const R = ee(null), V = ee(null), z = ee(null), [$, H] = Ee(!1), [B, O] = Ee(""), W = rt(), { isOpen: G, open: re, close: K } = _i({
    anchorRef: R,
    overlayRef: V,
    placement: C,
    disabled: l || u
  }), { selectedIds: P, selectedOptions: oe, toggle: se, deselect: D } = Ro({
    mode: "multi",
    options: A,
    value: S,
    defaultValue: N,
    onChange: E
  }), pe = Bo(A, B, !0), Ce = L ? pe.map(
    (Be) => !P.includes(Be.id) && P.length >= L ? { ...Be, disabled: !0 } : Be
  ) : pe, { activeId: Z, clearActiveId: j, handleInputKeyDown: ie, onOptionRef: te } = ar({
    options: Ce,
    isOpen: G,
    onOpen: re,
    onClose: K,
    onSelect: (Be) => {
      se(Be), O(""), z.current?.focus();
    }
  }), ge = (Be) => {
    if (Be.key === "Backspace" && B === "" && oe.length > 0 && !l && !u) {
      const xt = oe[oe.length - 1];
      xt && D(xt.id);
      return;
    }
    ie(Be);
  }, ne = (Be) => {
    O(Be), !G && Be.length > 0 && re();
  }, _e = () => {
    l || u || (re(), z.current?.focus());
  }, Ie = () => {
    H(!0), G || re();
  }, Ve = () => {
    H(!1), O("");
  }, nt = (Be) => {
    D(Be), z.current?.focus();
  }, Ke = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, pt = m ?? q.KeyboardArrowDown;
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        Pn["ds-multi-select-field"],
        w !== we.Auto && Pn[`ds-multi-select-field--width-${w}`],
        x
      ),
      children: [
        /* @__PURE__ */ g(
          ti,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: s,
            required: d,
            disabled: l,
            tooltip: y,
            tooltipPlacement: v,
            suffixCopy: _,
            children: /* @__PURE__ */ g("div", { ref: R, className: Pn["ds-multi-select-field__trigger-wrap"], children: /* @__PURE__ */ g(
              Rn,
              {
                isFocused: $ || G,
                disabled: l,
                readOnly: u,
                state: s,
                size: c,
                prefix: h,
                suffix: pt,
                inputRef: z,
                onClick: _e,
                className: Pn["ds-multi-select-field__chrome"],
                children: /* @__PURE__ */ F(
                  "div",
                  {
                    className: Pn["ds-multi-select__body"],
                    "aria-label": `Selected items: ${oe.map((Be) => Be.label).join(", ") || "none"}`,
                    children: [
                      oe.map((Be) => /* @__PURE__ */ g(i0, { option: Be, onRemove: nt, disabled: l || u }, Be.id)),
                      /* @__PURE__ */ g(
                        On,
                        {
                          ref: z,
                          id: e,
                          name: t,
                          value: B,
                          placeholder: oe.length === 0 ? o : "",
                          type: gt.Text,
                          disabled: l,
                          readOnly: u,
                          required: d,
                          role: "combobox",
                          ariaExpanded: G,
                          ariaControls: W,
                          ariaActivedescendant: Z ?? void 0,
                          ariaDescribedBy: Ke,
                          ariaInvalid: s === Pe.Error,
                          autoComplete: "off",
                          onChange: ne,
                          onFocus: Ie,
                          onBlur: Ve,
                          onKeyDown: ge,
                          className: Pn["ds-multi-select__text-entry"]
                        }
                      )
                    ]
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ g(
          gi,
          {
            id: W,
            ref: V,
            anchorRef: R,
            isOpen: G && !l && !u,
            placement: C,
            minWidth: "anchor",
            children: /* @__PURE__ */ g(
              or,
              {
                id: `${W}-list`,
                options: Ce,
                selectedIds: P,
                activeId: Z,
                mode: "multi",
                ariaLabel: n,
                emptyText: f,
                onActivate: (Be) => {
                  se(Be), O(""), j(), z.current?.focus();
                },
                onOptionRef: te
              }
            )
          }
        )
      ]
    }
  );
}
var Ye = /* @__PURE__ */ ((e) => (e.Contained = "contained", e.Outlined = "outlined", e.Text = "text", e))(Ye || {}), Is = /* @__PURE__ */ ((e) => (e.Horizontal = "horizontal", e.Vertical = "vertical", e))(Is || {}), r0 = /* @__PURE__ */ ((e) => (e.Text = "text", e.Link = "link", e.Icon = "icon", e.Bool = "bool", e.List = "list", e))(r0 || {});
const ad = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/, od = "Please enter a valid email address";
function s0(e) {
  return ad.test(e);
}
const Lt = {
  "ds-chip": "_ds-chip_dobiv_1",
  "ds-chip__icon": "_ds-chip__icon_dobiv_13",
  "ds-chip__dismiss": "_ds-chip__dismiss_dobiv_18",
  "ds-chip__contained": "_ds-chip__contained_dobiv_51",
  "ds-chip__contained-primary": "_ds-chip__contained-primary_dobiv_55",
  "ds-chip__contained-secondary": "_ds-chip__contained-secondary_dobiv_66",
  "ds-chip__contained-info": "_ds-chip__contained-info_dobiv_78",
  "ds-chip__contained-success": "_ds-chip__contained-success_dobiv_89",
  "ds-chip__contained-warning": "_ds-chip__contained-warning_dobiv_100",
  "ds-chip__contained-error": "_ds-chip__contained-error_dobiv_111",
  "ds-chip__outlined": "_ds-chip__outlined_dobiv_122",
  "ds-chip__outlined-primary": "_ds-chip__outlined-primary_dobiv_126",
  "ds-chip__outlined-secondary": "_ds-chip__outlined-secondary_dobiv_138",
  "ds-chip__outlined-info": "_ds-chip__outlined-info_dobiv_150",
  "ds-chip__outlined-success": "_ds-chip__outlined-success_dobiv_162",
  "ds-chip__outlined-warning": "_ds-chip__outlined-warning_dobiv_174",
  "ds-chip__outlined-error": "_ds-chip__outlined-error_dobiv_186"
};
var fi = /* @__PURE__ */ ((e) => (e.Contained = "contained", e.Outlined = "outlined", e))(fi || {});
const Gn = ({
  id: e,
  label: t,
  text: n,
  variant: i = fi.Contained,
  color: r = Le.Primary,
  className: s,
  prefix: o,
  suffix: l,
  interactive: u = !1,
  ref: c,
  onDismiss: d,
  onClick: h
}) => {
  const m = u || h !== void 0, _ = i === fi.Contained, y = r === Le.Primary, v = r === Le.Secondary, w = r === Le.Error, x = r === Le.Info, A = r === Le.Success, S = r === Le.Warning, N = X({
    // root class
    [Lt["ds-chip"]]: !0,
    // contained variants
    [Lt["ds-chip__contained"]]: _,
    [Lt["ds-chip__contained-primary"]]: _ && y,
    [Lt["ds-chip__contained-secondary"]]: _ && v,
    [Lt["ds-chip__contained-info"]]: _ && x,
    [Lt["ds-chip__contained-success"]]: _ && A,
    [Lt["ds-chip__contained-warning"]]: _ && S,
    [Lt["ds-chip__contained-error"]]: _ && w,
    // outlined variants
    [Lt["ds-chip__outlined"]]: !_,
    [Lt["ds-chip__outlined-primary"]]: !_ && y,
    [Lt["ds-chip__outlined-secondary"]]: !_ && v,
    [Lt["ds-chip__outlined-info"]]: !_ && x,
    [Lt["ds-chip__outlined-success"]]: !_ && A,
    [Lt["ds-chip__outlined-warning"]]: !_ && S,
    [Lt["ds-chip__outlined-error"]]: !_ && w
  }, s);
  return /* @__PURE__ */ F(
    "span",
    {
      ref: c,
      "aria-label": m ? t : void 0,
      title: m ? void 0 : t,
      className: N,
      role: m ? "button" : void 0,
      tabIndex: m ? 0 : void 0,
      onClick: h ? () => h(e) : void 0,
      onKeyDown: h ? (E) => {
        (E.key === "Enter" || E.key === " ") && h(e);
      } : void 0,
      children: [
        o && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: Lt["ds-chip__icon"], children: /* @__PURE__ */ g(be, { name: o, size: 12 }) }),
        n,
        l && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: Lt["ds-chip__icon"], children: /* @__PURE__ */ g(be, { name: l, size: 12 }) }),
        d && /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            "aria-label": `Remove ${t}`,
            className: Lt["ds-chip__dismiss"],
            onClick: (E) => {
              E.stopPropagation(), d(e);
            },
            children: /* @__PURE__ */ g(be, { name: q.Cancel, "aria-hidden": "true", size: 12 })
          }
        )
      ]
    },
    e
  );
};
function ld(e, t) {
  const n = ee(null), i = he(() => {
    n.current !== null && (clearTimeout(n.current), n.current = null);
  }, []);
  return me(() => i, [i]), $e(() => {
    const r = ((...s) => {
      i(), n.current = setTimeout(() => {
        n.current = null, e(...s);
      }, t);
    });
    return r.cancel = i, r;
  }, [e, t, i]);
}
function a0({
  onSearch: e,
  minSearchLength: t = 1,
  debounceMs: n = 300
}) {
  const [i, r] = Ee([]), [s, o] = Ee(!1), l = ee(0);
  me(
    () => () => {
      l.current += 1;
    },
    []
  );
  const u = he(
    async (m, { force: _ = !1 } = {}) => {
      l.current += 1;
      const y = l.current;
      if (!_ && m.trim().length < t) {
        r([]), o(!1);
        return;
      }
      o(!0);
      try {
        const v = await e(m);
        y === l.current && r(v);
      } catch (v) {
        console.warn("[NorthStar] useAsyncSearch: onSearch rejected", v), y === l.current && r([]);
      } finally {
        y === l.current && o(!1);
      }
    },
    [e, t]
  ), c = he(
    (m) => {
      u(m);
    },
    [u]
  ), d = ld(c, n), h = he(() => {
    d.cancel(), l.current += 1, r([]), o(!1);
  }, [d]);
  return { results: i, isLoading: s, search: d, searchNow: u, reset: h };
}
const En = {
  "ds-multi-entity-picker-field": "_ds-multi-entity-picker-field_1wwlk_1",
  "ds-multi-entity-picker-field--width-full": "_ds-multi-entity-picker-field--width-full_1wwlk_6",
  "ds-multi-entity-picker-field--width-sm": "_ds-multi-entity-picker-field--width-sm_1wwlk_9",
  "ds-multi-entity-picker-field--width-md": "_ds-multi-entity-picker-field--width-md_1wwlk_12",
  "ds-multi-entity-picker-field--width-lg": "_ds-multi-entity-picker-field--width-lg_1wwlk_15",
  "ds-multi-entity-picker-field__trigger-wrap": "_ds-multi-entity-picker-field__trigger-wrap_1wwlk_18",
  "ds-multi-entity-picker-field__chrome": "_ds-multi-entity-picker-field__chrome_1wwlk_22",
  "ds-multi-entity-picker__body": "_ds-multi-entity-picker__body_1wwlk_28",
  "ds-multi-entity-picker__chips": "_ds-multi-entity-picker__chips_1wwlk_37",
  "ds-multi-entity-picker__item": "_ds-multi-entity-picker__item_1wwlk_43",
  "ds-multi-entity-picker__chip": "_ds-multi-entity-picker__chip_1wwlk_37",
  "ds-multi-entity-picker__text-entry": "_ds-multi-entity-picker__text-entry_1wwlk_52",
  "ds-multi-entity-picker__loading": "_ds-multi-entity-picker__loading_1wwlk_57",
  "ds-multi-entity-picker-pulse": "_ds-multi-entity-picker-pulse_1wwlk_1"
}, o0 = [], l0 = ["Enter", ","], u0 = /[\s,;]+/, c0 = "Enter a valid value";
function d0(e) {
  return s0(e) || od;
}
function h0(e) {
  return e === !0 ? null : typeof e == "string" && e !== "" ? e : c0;
}
function p0(e) {
  return e.kind === "entity" ? { variant: fi.Contained, color: Le.Primary } : { variant: fi.Outlined, color: Le.Secondary };
}
function U6({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: s = Pe.Default,
  placeholder: o = "Search...",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = Nt.Medium,
  required: d = !1,
  prefix: h,
  suffix: m,
  suffixCopy: _,
  tooltip: y,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: x,
  value: A,
  defaultValue: S = o0,
  onChange: N,
  onSearch: E,
  initialOptions: f,
  getOptionLabel: C,
  getChipLabel: L,
  getChipAppearance: R,
  allowFreeInput: V = !0,
  validateFreeInput: z = d0,
  freeInputDelimiters: $ = l0,
  onInvalidFreeInput: H,
  maxSelections: B,
  maxSelectionsMessage: O,
  loadingText: W = "Searching...",
  noResultsText: G = "No results found",
  minSearchLength: re = 1,
  debounceMs: K = 300,
  popupPlacement: P = "bottom-start"
}) {
  const oe = ee(null), se = ee(null), D = ee(null), pe = ee(null), Ce = ee(null), [Z, j] = Ee(!1), [ie, te] = Ee(""), [ge, ne] = Ee(null), _e = rt(), Ie = l || u, [Ve, nt] = Yt(
    A,
    S,
    N
  ), { results: Ke, isLoading: pt, search: Be, searchNow: xt, reset: kt } = a0({
    onSearch: E,
    minSearchLength: re,
    debounceMs: K
  }), { isOpen: ft, open: Fe, close: je } = _i({
    anchorRef: oe,
    overlayRef: se,
    placement: P,
    disabled: Ie
  }), Re = B !== void 0 && Ve.length >= B, on = Ve.filter((Ae) => Ae.kind === "entity").map((Ae) => Ae.id), Y = (ie.trim() === "" ? f ?? Ke : Ke).map(
    (Ae) => Re && !on.includes(Ae.id) ? { ...Ae, disabled: !0 } : Ae
  );
  me(() => {
    const Ae = Ce.current;
    if (Ae === null)
      return;
    Ce.current = null, (Array.from(pe.current?.children ?? []).find(
      (At) => At.dataset.itemId === Ae.itemId
    )?.querySelector("button") ?? D.current)?.focus();
  }, [Ve]);
  const T = () => ne(null), Se = (Ae, ct) => {
    ne(ct), H?.(Ae, ct);
  }, He = (Ae) => {
    if (!V)
      return;
    const ct = [...Ve], yt = [];
    let At = null, ns = !1;
    for (const yi of Ae) {
      const tn = yi.trim(), xr = `free:${tn.toLowerCase()}`;
      if (tn === "" || ct.some((is) => is.id === xr))
        continue;
      const br = B !== void 0 && ct.length >= B ? O ?? `You can add up to ${B} items` : h0(z(tn));
      br === null ? (ct.push({ kind: "free", id: xr, label: tn, text: tn }), ns = !0) : (yt.push(tn), At = At ?? br, Se(tn, br));
    }
    ns && nt(ct), te(yt.join(", ")), ne(At);
  }, ut = (Ae) => {
    if (Ae.disabled)
      return;
    const ct = Ve.some((yt) => yt.id === Ae.id);
    nt(ct ? Ve.filter((yt) => yt.id !== Ae.id) : [...Ve, { kind: "entity", id: Ae.id, label: C(Ae.value), entity: Ae.value }]), te(""), T(), kt(), je(), D.current?.focus();
  }, ue = () => {
    Fe(), ie.trim() === "" && (f?.length ?? 0) === 0 && Ke.length === 0 && !pt && xt("", { force: !0 });
  }, { activeId: _t, clearActiveId: Tt, handleInputKeyDown: ln, onOptionRef: bt } = ar({
    options: Y,
    isOpen: ft,
    onOpen: ue,
    onClose: je,
    onSelect: ut
  });
  me(() => {
    ft || Tt();
  }, [ft, Tt]);
  const un = (Ae) => {
    const ct = Ve.findIndex((At) => At.id === Ae);
    if (ct === -1)
      return;
    const yt = Ve.filter((At) => At.id !== Ae);
    Ce.current = { itemId: (yt[ct] ?? yt[ct - 1])?.id ?? null }, nt(yt);
  }, qt = (Ae) => {
    if (te(Ae), T(), Tt(), Ae.trim() === "") {
      kt(), (f?.length ?? 0) === 0 && je();
      return;
    }
    Fe(), Be(Ae);
  }, ra = (Ae) => {
    if (Ae.key === "Enter" && Ae.preventDefault(), Ie)
      return;
    if (Ae.key === "Backspace" && ie === "" && Ve.length > 0) {
      Ve[Ve.length - 1] && nt(Ve.slice(0, -1));
      return;
    }
    const ct = ft && Y.some((yt) => yt.id === _t);
    if (Ae.key === "Enter" && ct) {
      ln(Ae);
      return;
    }
    if (V && $.includes(Ae.key)) {
      Ae.preventDefault(), He([ie]);
      return;
    }
    ln(Ae);
  }, Fi = (Ae) => {
    if (Ie || !V)
      return;
    const ct = Ae.clipboardData.getData("text").split(u0).filter((yt) => yt !== "");
    ct.length < 2 || (Ae.preventDefault(), He(ct));
  }, Jt = () => {
    j(!1), !Ie && ie.trim() !== "" && He([ie]);
  }, Wt = () => {
    Ie || D.current?.focus();
  }, tt = ge === null ? s : Pe.Error, Hn = ge ?? r, Ne = [i ? `${e}-description` : null, Hn ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, gr = ft && !Ie;
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        En["ds-multi-entity-picker-field"],
        w !== we.Auto && En[`ds-multi-entity-picker-field--width-${w}`],
        x
      ),
      children: [
        /* @__PURE__ */ g(
          ti,
          {
            id: e,
            label: n,
            description: i,
            hint: Hn,
            state: tt,
            required: d,
            disabled: l,
            tooltip: y,
            tooltipPlacement: v,
            suffixCopy: _,
            children: /* @__PURE__ */ g("div", { ref: oe, className: En["ds-multi-entity-picker-field__trigger-wrap"], children: /* @__PURE__ */ g(
              Rn,
              {
                isFocused: Z || ft,
                disabled: l,
                readOnly: u,
                state: tt,
                size: c,
                prefix: h,
                suffix: m,
                inputRef: D,
                onClick: Wt,
                className: En["ds-multi-entity-picker-field__chrome"],
                children: /* @__PURE__ */ F("div", { className: En["ds-multi-entity-picker__body"], children: [
                  Ve.length > 0 && // Explicit role: list-style/display:contents make Safari drop the list semantics.
                  // eslint-disable-next-line jsx-a11y/no-redundant-roles -- see comment above
                  /* @__PURE__ */ g(
                    "ul",
                    {
                      ref: pe,
                      role: "list",
                      "aria-label": `${n}: selected`,
                      className: En["ds-multi-entity-picker__chips"],
                      children: Ve.map((Ae) => {
                        const ct = { ...p0(Ae), ...R?.(Ae) };
                        return /* @__PURE__ */ g("li", { "data-item-id": Ae.id, className: En["ds-multi-entity-picker__item"], children: /* @__PURE__ */ g(
                          Gn,
                          {
                            id: Ae.id,
                            text: L?.(Ae) ?? Ae.label,
                            label: L?.(Ae) ?? Ae.label,
                            variant: ct.variant,
                            color: ct.color,
                            className: En["ds-multi-entity-picker__chip"],
                            onDismiss: Ie ? void 0 : un
                          }
                        ) }, Ae.id);
                      })
                    }
                  ),
                  /* @__PURE__ */ g(
                    On,
                    {
                      ref: D,
                      id: e,
                      name: t,
                      value: ie,
                      placeholder: Ve.length === 0 ? o : void 0,
                      type: gt.Text,
                      disabled: l,
                      readOnly: u,
                      required: d,
                      role: "combobox",
                      ariaExpanded: gr,
                      ariaControls: _e,
                      ariaActivedescendant: _t ?? void 0,
                      ariaAutocomplete: "list",
                      ariaDescribedBy: Ne,
                      ariaInvalid: tt === Pe.Error,
                      autoComplete: "off",
                      onChange: qt,
                      onFocus: () => j(!0),
                      onBlur: Jt,
                      onKeyDown: ra,
                      onPaste: Fi,
                      className: En["ds-multi-entity-picker__text-entry"]
                    }
                  )
                ] })
              }
            ) })
          }
        ),
        /* @__PURE__ */ g(
          gi,
          {
            id: _e,
            ref: se,
            anchorRef: oe,
            isOpen: gr,
            placement: P,
            minWidth: "anchor",
            children: pt ? /* @__PURE__ */ g("div", { className: En["ds-multi-entity-picker__loading"], role: "status", "aria-live": "polite", "aria-busy": "true", children: W }) : /* @__PURE__ */ g(
              or,
              {
                id: `${_e}-list`,
                options: Y,
                selectedIds: on,
                activeId: _t,
                mode: "multi",
                ariaLabel: n,
                emptyText: ie.trim().length < re ? `Type at least ${re} character${re === 1 ? "" : "s"} to search` : G,
                onActivate: ut,
                onOptionRef: bt
              }
            )
          }
        )
      ]
    }
  );
}
const ud = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])'
].join(",");
function f0(e, t) {
  if (e.tabIndex < 0)
    return !1;
  let n = e;
  for (; n !== null && n !== t; ) {
    if (n.hasAttribute("hidden") || n.hasAttribute("inert"))
      return !1;
    n = n.parentElement;
  }
  return !0;
}
function nr(e) {
  return Array.from(e.querySelectorAll(ud)).filter(
    (t) => f0(t, e)
  );
}
const zo = ei(null), Vr = [];
function m0(e, t) {
  for (let n = e.parent; n !== null; n = n.parent)
    if (n === t)
      return !0;
  return !1;
}
function cd(e) {
  return Vr.some((t) => t !== e && m0(t, e));
}
function _0() {
  return [...Vr].reverse().find((e) => !cd(e));
}
function jo({
  isOpen: e,
  onClose: t,
  onAction: n,
  closeOnBackdropClick: i = !0,
  closeOnEscape: r = !0,
  lockBodyScroll: s = !1,
  modal: o = !0
}) {
  const l = ee(null), u = Fn(zo), c = $e(() => ({ ref: l, parent: u }), [u]), d = ee(t);
  d.current = t;
  const h = ee(r);
  return h.current = r, me(() => {
    if (!(!e || !o))
      return Vr.push(c), () => {
        const y = Vr.indexOf(c);
        y !== -1 && Vr.splice(y, 1);
      };
  }, [e, c, o]), me(() => {
    if (!e)
      return;
    const y = document.activeElement;
    if (!cd(c)) {
      const v = l.current;
      ((v ? nr(v)[0] : void 0) ?? v)?.focus();
    }
    return () => {
      y?.isConnected && y.focus();
    };
  }, [e, c]), me(() => {
    if (!e)
      return;
    const y = (w) => {
      if (!(o && _0() !== c)) {
        if (w.key === "Escape") {
          h.current && d.current();
          return;
        }
        if (o && w.key === "Tab") {
          const x = l.current ? nr(l.current) : [];
          if (!x.length) {
            w.preventDefault();
            return;
          }
          const A = x[0], S = x[x.length - 1];
          w.shiftKey ? document.activeElement === A && (w.preventDefault(), S.focus()) : document.activeElement === S && (w.preventDefault(), A.focus());
        }
      }
    };
    if (o)
      return document.addEventListener("keydown", y), () => document.removeEventListener("keydown", y);
    const v = l.current;
    if (v !== null)
      return v.addEventListener("keydown", y), () => v.removeEventListener("keydown", y);
  }, [e, c, o]), me(() => {
    if (!s || !e || !o)
      return;
    const y = document.body.style.overflow;
    return document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = y;
    };
  }, [e, s, o]), { panelRef: l, panel: c, handleBackdropClick: () => {
    i && t();
  }, handleActionClick: (y) => {
    n?.(y);
  } };
}
const dd = "data-ns-autofocus";
function g0(e) {
  const t = e.querySelector(`[${dd}]`);
  if (t)
    return t;
  const n = nr(e)[0];
  return n || (e.matches(ud) ? e : null);
}
function hd(e, { enabled: t = !0, preventScroll: n = !0 } = {}) {
  const i = ee(null), r = ee(null);
  return me(() => {
    if (!t || e !== null && e === r.current)
      return;
    const s = i.current;
    if (!s)
      return;
    const o = requestAnimationFrame(() => {
      if (s.contains(document.activeElement))
        return;
      const l = g0(s);
      l && (l.focus({ preventScroll: n }), r.current = e);
    });
    return () => cancelAnimationFrame(o);
  }, [e, t, n]), i;
}
const x0 = "_buttons_33e4f_62", it = {
  "ds-date-picker-field": "_ds-date-picker-field_33e4f_1",
  "ds-date-picker-field--width-full": "_ds-date-picker-field--width-full_33e4f_6",
  "ds-date-picker-field--width-sm": "_ds-date-picker-field--width-sm_33e4f_9",
  "ds-date-picker-field--width-md": "_ds-date-picker-field--width-md_33e4f_12",
  "ds-date-picker-field--width-lg": "_ds-date-picker-field--width-lg_33e4f_15",
  "ds-date-picker-field__trigger-wrap": "_ds-date-picker-field__trigger-wrap_33e4f_18",
  "ds-date-picker-field__calendar-trigger": "_ds-date-picker-field__calendar-trigger_33e4f_22",
  "ds-date-picker__calendar": "_ds-date-picker__calendar_33e4f_45",
  "ds-date-picker__calendar-disabled": "_ds-date-picker__calendar-disabled_33e4f_53",
  "ds-date-picker__cal-header": "_ds-date-picker__cal-header_33e4f_56",
  buttons: x0,
  "ds-date-picker__nav-btn": "_ds-date-picker__nav-btn_33e4f_72",
  "ds-date-picker__month-label": "_ds-date-picker__month-label_33e4f_93",
  "ds-date-picker__year-btn": "_ds-date-picker__year-btn_33e4f_100",
  "ds-date-picker__year-grid": "_ds-date-picker__year-grid_33e4f_120",
  "ds-date-picker__year-cell": "_ds-date-picker__year-cell_33e4f_126",
  "ds-date-picker__year-cell--selected": "_ds-date-picker__year-cell--selected_33e4f_147",
  "ds-date-picker__year-cell--current": "_ds-date-picker__year-cell--current_33e4f_154",
  "ds-date-picker__day-names": "_ds-date-picker__day-names_33e4f_157",
  "ds-date-picker__day-name": "_ds-date-picker__day-name_33e4f_157",
  "ds-date-picker__grid": "_ds-date-picker__grid_33e4f_171",
  "ds-date-picker__day-cell": "_ds-date-picker__day-cell_33e4f_176",
  "ds-date-picker__day-cell--disabled": "_ds-date-picker__day-cell--disabled_33e4f_190",
  "ds-date-picker__day-cell--today": "_ds-date-picker__day-cell--today_33e4f_197",
  "ds-date-picker__day-cell--selected": "_ds-date-picker__day-cell--selected_33e4f_201",
  "ds-date-picker__day-cell--selected-disabled": "_ds-date-picker__day-cell--selected-disabled_33e4f_213",
  "ds-date-picker__day-cell--today-disabled": "_ds-date-picker__day-cell--today-disabled_33e4f_221"
};
function Ti(e, t, n) {
  return `${e}-${String(t + 1).padStart(2, "0")}-${String(n).padStart(2, "0")}`;
}
function Fr(e, t, n, i) {
  return !!(t && e < t || n && e > n || i?.(e));
}
function b0(e, t) {
  return new Date(e, t + 1, 0).getDate();
}
function y0(e, t) {
  return new Date(e, t, 1).getDay();
}
const Yl = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], v0 = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], An = 12, us = 7, Ql = 3, eu = 'button:not([disabled]), [tabindex="0"]';
function w0(e, t, n, i, r, s, o) {
  let l = 1;
  if (i) {
    const [u, c, d] = i.split("-").map(Number);
    u === e && c - 1 === t && (l = d);
  }
  if (!Fr(Ti(e, t, l), r, s, o))
    return l;
  for (let u = l + 1; u <= n; u += 1)
    if (!Fr(Ti(e, t, u), r, s, o))
      return u;
  for (let u = l - 1; u >= 1; u -= 1)
    if (!Fr(Ti(e, t, u), r, s, o))
      return u;
  return l;
}
function pd({
  id: e,
  selectedIso: t,
  calState: n,
  disabled: i = !1,
  focusGrid: r = !1,
  minDate: s,
  maxDate: o,
  isDateDisabled: l,
  onSelectDay: u,
  onPrevMonth: c,
  onNextMonth: d,
  onSelectYear: h,
  onEscape: m
}) {
  const { year: _, month: y } = n, [v, w] = Ee(!1), [x, A] = Ee(0), S = ee(/* @__PURE__ */ new Map()), [N, E] = Ee(1), f = ee(!1), C = ee(/* @__PURE__ */ new Map()), [L, R] = Ee(_), V = ee(null), z = X({
    [it["ds-date-picker__calendar"]]: !0,
    [it["ds-date-picker__calendar-disabled"]]: i
  });
  me(() => {
    const j = V.current, ie = (te) => {
      if (te.key === "Escape") {
        m && (te.preventDefault(), te.stopPropagation(), m());
        return;
      }
      if (te.key !== "Tab")
        return;
      const ge = Array.from(j?.querySelectorAll(eu) ?? []);
      if (ge.length === 0)
        return;
      const ne = ge.indexOf(document.activeElement), _e = ne === -1 ? ge[te.shiftKey ? ge.length - 1 : 0] : ge[(ne + (te.shiftKey ? -1 : 1) + ge.length) % ge.length];
      te.preventDefault(), _e?.focus();
    };
    return j?.addEventListener("keydown", ie), () => j?.removeEventListener("keydown", ie);
  }, [m]), me(() => {
    v && C.current.get(L)?.focus();
  }, [v, L]);
  const $ = () => {
    i || (A(Math.floor(_ / An) * An), R(_), w(!0));
  }, H = (j) => {
    i || (h?.(j), w(!1), f.current = !1);
  }, B = (j, ie) => {
    switch (ie) {
      case "ArrowLeft":
        return j - 1;
      case "ArrowRight":
        return j + 1;
      case "ArrowUp":
        return j - Ql;
      case "ArrowDown":
        return j + Ql;
      case "Home":
        return x;
      case "End":
        return x + An - 1;
      default:
        return null;
    }
  }, O = (j, ie) => {
    if (i)
      return;
    if (ie.key === "Enter" || ie.key === " ") {
      ie.preventDefault(), H(j);
      return;
    }
    const te = B(j, ie.key);
    te !== null && (ie.preventDefault(), (te < x || te > x + An - 1) && A((ge) => ge + (te < x ? -An : An)), R(te), C.current.get(te)?.focus());
  }, W = b0(_, y), G = y0(_, y);
  me(() => {
    const j = w0(
      _,
      y,
      W,
      t,
      s,
      o,
      l
    ), ie = !Fr(
      Ti(_, y, j),
      s,
      o,
      l
    );
    let te = 0;
    return E(j), !r || i ? f.current = !1 : !v && !f.current && (f.current = !0, te = requestAnimationFrame(() => {
      ie ? S.current.get(j)?.focus() : V.current?.querySelector(eu)?.focus();
    })), () => cancelAnimationFrame(te);
  }, [
    _,
    y,
    W,
    t,
    s,
    o,
    l,
    r,
    i,
    v
  ]);
  const re = (j) => i || Fr(Ti(_, y, j), s, o, l), K = (j, ie) => {
    for (let te = j; te >= 1 && te <= W; te += ie)
      if (!re(te))
        return te;
    return null;
  }, P = (j, ie) => {
    switch (ie) {
      case "ArrowLeft":
        return K(j - 1, -1);
      case "ArrowRight":
        return K(j + 1, 1);
      case "ArrowUp":
        return K(j - us, -us);
      case "ArrowDown":
        return K(j + us, us);
      case "Home":
        return K(1, 1);
      case "End":
        return K(W, -1);
      default:
        return null;
    }
  }, oe = (j, ie) => {
    if (i)
      return;
    if (ie.key === "PageUp" || ie.key === "PageDown") {
      ie.preventDefault(), f.current = !1;
      const ge = ie.key === "PageUp";
      ie.shiftKey && h ? h(ge ? _ - 1 : _ + 1) : ge ? c() : d();
      return;
    }
    const te = P(j, ie.key);
    te === null || te === j || (ie.preventDefault(), E(te), S.current.get(te)?.focus());
  }, se = (j) => Ti(_, y, j) === t, D = (j) => {
    const ie = /* @__PURE__ */ new Date();
    return ie.getFullYear() === _ && ie.getMonth() === y && ie.getDate() === j;
  }, pe = (j) => {
    re(j) || u(Ti(_, y, j));
  }, Ce = (j, ie) => {
    (ie.key === "Enter" || ie.key === " ") && (ie.preventDefault(), pe(j));
  }, Z = (/* @__PURE__ */ new Date()).getFullYear();
  return /* @__PURE__ */ F("div", { ref: V, id: e, role: "dialog", "aria-label": "Date picker", "aria-modal": "true", className: z, children: [
    /* @__PURE__ */ F("div", { className: it["ds-date-picker__cal-header"], children: [
      v ? /* @__PURE__ */ F("span", { className: it["ds-date-picker__month-label"], children: [
        x,
        "-",
        x + An - 1
      ] }) : /* @__PURE__ */ F("span", { className: it["ds-date-picker__month-label"], "aria-live": "polite", "aria-atomic": "true", children: [
        Yl[y],
        " ",
        h ? /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            className: it["ds-date-picker__year-btn"],
            disabled: i,
            "aria-label": `Select year, currently ${_}`,
            onClick: $,
            children: _
          }
        ) : _
      ] }),
      /* @__PURE__ */ F("div", { className: it.buttons, children: [
        /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            className: it["ds-date-picker__nav-btn"],
            disabled: i,
            "aria-label": v ? "Previous years" : "Previous month",
            onClick: v ? () => A((j) => j - An) : c,
            children: /* @__PURE__ */ g(be, { name: q.KeyboardArrowLeft })
          }
        ),
        /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            className: it["ds-date-picker__nav-btn"],
            disabled: i,
            "aria-label": v ? "Next years" : "Next month",
            onClick: v ? () => A((j) => j + An) : d,
            children: /* @__PURE__ */ g(be, { name: q.KeyboardArrowRight })
          }
        )
      ] })
    ] }),
    v ? (
      /* Year picker grid */
      /* @__PURE__ */ g("div", { role: "grid", "aria-label": "Year selection", className: it["ds-date-picker__year-grid"], children: Array.from({ length: An }, (j, ie) => x + ie).map((j) => /* @__PURE__ */ g(
        "div",
        {
          ref: (ie) => {
            C.current.set(j, ie);
          },
          role: "gridcell",
          tabIndex: !i && j === L ? 0 : -1,
          "aria-selected": j === _,
          "aria-disabled": i ? !0 : void 0,
          className: X(
            it["ds-date-picker__year-cell"],
            j === _ && it["ds-date-picker__year-cell--selected"],
            j === Z && j !== _ && it["ds-date-picker__year-cell--current"]
          ),
          onClick: () => H(j),
          onKeyDown: (ie) => O(j, ie),
          children: j
        },
        j
      )) })
    ) : /* @__PURE__ */ F(et, { children: [
      /* @__PURE__ */ g("div", { className: it["ds-date-picker__day-names"], "aria-hidden": "true", children: v0.map((j) => /* @__PURE__ */ g("span", { className: it["ds-date-picker__day-name"], children: j }, j)) }),
      /* @__PURE__ */ F("div", { role: "grid", "aria-label": `${Yl[y]} ${_}`, className: it["ds-date-picker__grid"], children: [
        Array.from({ length: G }).map((j, ie) => /* @__PURE__ */ g("div", { role: "gridcell", "aria-disabled": "true", className: it["ds-date-picker__day-cell"] }, `empty-${ie}`)),
        Array.from({ length: W }, (j, ie) => ie + 1).map((j) => /* @__PURE__ */ g(
          "div",
          {
            ref: (ie) => {
              S.current.set(j, ie);
            },
            role: "gridcell",
            tabIndex: re(j) ? -1 : j === N ? 0 : -1,
            ...!re(j) && j === N ? { [dd]: "" } : {},
            "aria-selected": se(j),
            "aria-disabled": re(j) ? !0 : void 0,
            className: X(
              it["ds-date-picker__day-cell"],
              D(j) && !re(j) && it["ds-date-picker__day-cell--today"],
              se(j) && !re(j) && it["ds-date-picker__day-cell--selected"],
              re(j) && !se(j) && !D(j) && it["ds-date-picker__day-cell--disabled"],
              se(j) && re(j) && it["ds-date-picker__day-cell--selected-disabled"],
              D(j) && re(j) && it["ds-date-picker__day-cell--today-disabled"]
            ),
            onClick: () => pe(j),
            onKeyDown: (ie) => {
              Ce(j, ie), oe(j, ie);
            },
            children: j
          },
          j
        ))
      ] })
    ] })
  ] });
}
function ua(e) {
  if (!e)
    return "";
  const t = e.split("-");
  if (t.length !== 3)
    return e;
  const [n, i, r] = t;
  return `${i}/${r}/${n}`;
}
function k0(e) {
  const t = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(e.trim());
  if (!t)
    return null;
  const [, n, i, r] = t;
  return `${r}-${n}-${i}`;
}
function C0(e) {
  if (!e)
    return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(e))
    return e;
  const t = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(e.trim());
  return t ? `${t[3]}-${t[1].padStart(2, "0")}-${t[2].padStart(2, "0")}` : null;
}
const $o = ({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: s = Pe.Default,
  placeholder: o = "MM/DD/YYYY",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = Nt.Medium,
  required: d = !1,
  prefix: h,
  suffix: m,
  suffixCopy: _,
  tooltip: y,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: x,
  value: A,
  defaultValue: S = null,
  onChange: N,
  minDate: E,
  maxDate: f,
  isDateDisabled: C,
  popupPlacement: L = "bottom-start"
}) => {
  const R = ee(null), V = ee(null), z = ee(null), $ = ee(null), [H, B] = Ee(!1), [O, W] = Ee(""), G = rt(), re = /* @__PURE__ */ new Date(), [K, P] = Ee({
    year: re.getFullYear(),
    month: re.getMonth()
  }), [oe, se] = Yt(A, S, N), D = C0(oe), { isOpen: pe, open: Ce, close: Z } = _i({
    anchorRef: R,
    overlayRef: V,
    placement: L,
    disabled: l || u
  }), j = () => {
    B(!0), W(ua(D));
  }, ie = () => {
    B(!1);
    const Fe = k0(O);
    if (Fe) {
      se(Fe);
      const [je, Re] = Fe.split("-").map(Number);
      P({ year: je, month: Re - 1 });
    } else
      se(null);
  }, te = (Fe) => {
    W(Fe);
  }, ge = ee(null), ne = () => {
    Z(), (ge.current ?? $.current)?.focus();
  }, _e = ee(!1);
  me(() => {
    const Fe = document.activeElement, je = Fe === document.body || V.current?.contains(Fe) === !0;
    _e.current && !pe && je && (ge.current ?? $.current)?.focus(), _e.current = pe;
  }, [pe]);
  const Ie = (Fe) => {
    if (ge.current = Fe, D) {
      const [je, Re] = D.split("-").map(Number);
      P({ year: je, month: Re - 1 });
    }
    Ce();
  }, Ve = () => {
    l || u || (pe ? Z() : Ie($.current));
  }, nt = (Fe) => {
    se(Fe), ne(), W(ua(Fe));
  }, Ke = (Fe) => {
    l || u || Fe.key === "ArrowDown" && !pe && (Fe.preventDefault(), Ie(z.current));
  }, pt = () => {
    P((Fe) => {
      const je = new Date(Fe.year, Fe.month - 1);
      return { year: je.getFullYear(), month: je.getMonth() };
    });
  }, Be = () => {
    P((Fe) => {
      const je = new Date(Fe.year, Fe.month + 1);
      return { year: je.getFullYear(), month: je.getMonth() };
    });
  }, xt = (Fe) => {
    P((je) => ({ ...je, year: Fe }));
  }, kt = H ? O : ua(D), ft = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        it["ds-date-picker-field"],
        w !== we.Auto && it[`ds-date-picker-field--width-${w}`],
        x
      ),
      children: [
        /* @__PURE__ */ g(
          ti,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: s,
            required: d,
            disabled: l,
            tooltip: y,
            tooltipPlacement: v,
            suffixCopy: _,
            children: /* @__PURE__ */ g("div", { ref: R, className: it["ds-date-picker-field__trigger-wrap"], children: /* @__PURE__ */ F(
              Rn,
              {
                isFocused: H || pe,
                disabled: l,
                readOnly: u,
                state: s,
                size: c,
                prefix: h,
                suffix: m,
                inputRef: z,
                className: it["ds-date-picker-field__chrome"],
                children: [
                  /* @__PURE__ */ g(
                    "span",
                    {
                      ref: $,
                      className: it["ds-date-picker-field__calendar-trigger"],
                      role: "button",
                      tabIndex: l || u ? -1 : 0,
                      "aria-label": "Open calendar",
                      "aria-expanded": pe,
                      "aria-controls": pe ? G : void 0,
                      onClick: Ve,
                      onKeyDown: (Fe) => {
                        (Fe.key === "Enter" || Fe.key === " ") && (Fe.preventDefault(), Ve());
                      },
                      children: /* @__PURE__ */ g(be, { name: q.CalendarToday, "aria-hidden": "true" })
                    }
                  ),
                  /* @__PURE__ */ g(
                    On,
                    {
                      ref: z,
                      id: e,
                      name: t,
                      value: kt,
                      placeholder: o,
                      type: gt.Text,
                      disabled: l,
                      readOnly: u,
                      required: d,
                      ariaDescribedBy: ft,
                      ariaInvalid: s === Pe.Error,
                      autoComplete: "off",
                      onChange: te,
                      onFocus: j,
                      onBlur: ie,
                      onKeyDown: Ke
                    }
                  )
                ]
              }
            ) })
          }
        ),
        /* @__PURE__ */ g(
          gi,
          {
            id: G,
            ref: V,
            anchorRef: R,
            isOpen: pe && !l && !u,
            placement: L,
            children: /* @__PURE__ */ g(
              pd,
              {
                id: `${G}-panel`,
                selectedIso: D,
                calState: K,
                minDate: E,
                maxDate: f,
                isDateDisabled: C,
                focusGrid: pe && !l && !u,
                onSelectDay: nt,
                onPrevMonth: pt,
                onNextMonth: Be,
                onSelectYear: xt,
                onEscape: ne
              }
            )
          }
        )
      ]
    }
  );
}, li = {
  "ds-time-picker-field": "_ds-time-picker-field_1b8bw_1",
  "ds-time-picker-field--width-full": "_ds-time-picker-field--width-full_1b8bw_6",
  "ds-time-picker-field--width-sm": "_ds-time-picker-field--width-sm_1b8bw_9",
  "ds-time-picker-field--width-md": "_ds-time-picker-field--width-md_1b8bw_12",
  "ds-time-picker-field--width-lg": "_ds-time-picker-field--width-lg_1b8bw_15",
  "ds-time-picker-field__trigger-wrap": "_ds-time-picker-field__trigger-wrap_1b8bw_18",
  "ds-time-picker__list": "_ds-time-picker__list_1b8bw_22",
  "ds-time-picker__slot": "_ds-time-picker__slot_1b8bw_30",
  "ds-time-picker__slot--disabled": "_ds-time-picker__slot--disabled_1b8bw_39",
  "ds-time-picker__slot--selected": "_ds-time-picker__slot--selected_1b8bw_46"
};
function Rr(e) {
  const t = /^(\d{1,2}):(\d{2})$/.exec(e.trim());
  if (!t)
    return -1;
  const n = parseInt(t[1], 10), i = parseInt(t[2], 10);
  return n < 0 || n > 23 || i < 0 || i > 59 ? -1 : n * 60 + i;
}
function tu(e) {
  const t = Math.floor(e / 60), n = e % 60;
  return `${String(t).padStart(2, "0")}:${String(n).padStart(2, "0")}`;
}
function fd(e) {
  const t = Rr(e);
  if (t === -1)
    return e;
  const n = Math.floor(t / 60), i = t % 60, r = n >= 12 ? "PM" : "AM", s = n % 12 === 0 ? 12 : n % 12;
  return `${String(s).padStart(2, "0")}:${String(i).padStart(2, "0")} ${r}`;
}
function S0({
  id: e,
  slots: t,
  selectedValue: n,
  minTime: i,
  maxTime: r,
  onSelect: s
}) {
  const o = i ? Rr(i) : -1, l = r ? Rr(r) : 1 / 0;
  return /* @__PURE__ */ g("ul", { id: e, role: "listbox", "aria-label": "Select a time", className: li["ds-time-picker__list"], children: t.map((u) => {
    const c = Rr(u), d = o !== -1 && c < o || c > l, h = u === n;
    return /* @__PURE__ */ g(
      "li",
      {
        id: `${e}-${u}`,
        role: "option",
        "aria-selected": h,
        "aria-disabled": d ? !0 : void 0,
        className: X(
          li["ds-time-picker__slot"],
          h && li["ds-time-picker__slot--selected"],
          d && li["ds-time-picker__slot--disabled"]
        ),
        onClick: d ? void 0 : () => s(u),
        onKeyDown: d ? void 0 : (m) => {
          (m.key === "Enter" || m.key === " ") && (m.preventDefault(), s(u));
        },
        tabIndex: d ? -1 : 0,
        children: fd(u)
      },
      u
    );
  }) });
}
const Ho = ({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: s = Pe.Default,
  placeholder: o = "HH:mm",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = Nt.Medium,
  required: d = !1,
  prefix: h,
  suffixCopy: m,
  tooltip: _,
  tooltipPlacement: y,
  width: v = we.Auto,
  className: w,
  value: x,
  defaultValue: A = null,
  onChange: S,
  minuteStep: N = 15,
  minTime: E,
  maxTime: f,
  popupPlacement: C = "bottom-start"
}) => {
  const L = ee(null), R = ee(null), V = ee(null), [z, $] = Ee(!1), [H, B] = Ee(""), O = rt(), [W, G] = Yt(x, A, S), re = $e(() => {
    const te = Math.max(1, Math.min(60, N)), ge = [];
    for (let ne = 0; ne < 1440; ne += te)
      ge.push(tu(ne));
    return ge;
  }, [N]), { isOpen: K, open: P, close: oe } = _i({
    anchorRef: L,
    overlayRef: R,
    placement: C,
    disabled: l || u
  }), se = () => {
    $(!0), B(W ?? "");
  }, D = () => {
    $(!1);
    const te = Rr(H);
    G(te !== -1 ? tu(te) : null), B(W ?? "");
  }, pe = (te) => {
    B(te);
  }, Ce = () => {
    l || u || (K ? oe() : P());
  }, Z = (te) => {
    G(te), B(te), oe();
  }, j = z ? H : fd(W ?? ""), ie = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        li["ds-time-picker-field"],
        v !== we.Auto && li[`ds-time-picker-field--width-${v}`],
        w
      ),
      children: [
        /* @__PURE__ */ g(
          ti,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: s,
            required: d,
            disabled: l,
            tooltip: _,
            tooltipPlacement: y,
            suffixCopy: m,
            children: /* @__PURE__ */ g("div", { ref: L, className: li["ds-time-picker-field__trigger-wrap"], children: /* @__PURE__ */ g(
              Rn,
              {
                isFocused: z || K,
                disabled: l,
                readOnly: u,
                state: s,
                size: c,
                prefix: h,
                suffix: q.SwapHoriz,
                onSuffixClick: Ce,
                inputRef: V,
                className: li["ds-time-picker-field__chrome"],
                children: /* @__PURE__ */ g(
                  On,
                  {
                    ref: V,
                    id: e,
                    name: t,
                    value: j,
                    placeholder: o,
                    type: gt.Text,
                    disabled: l,
                    readOnly: u,
                    required: d,
                    ariaDescribedBy: ie,
                    ariaInvalid: s === Pe.Error,
                    ariaExpanded: K,
                    ariaControls: K ? O : void 0,
                    autoComplete: "off",
                    onChange: pe,
                    onFocus: se,
                    onBlur: D
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ g(
          gi,
          {
            id: O,
            ref: R,
            anchorRef: L,
            isOpen: K && !l && !u,
            placement: C,
            children: /* @__PURE__ */ g(
              S0,
              {
                id: `${O}-list`,
                slots: re,
                selectedValue: W,
                minTime: E,
                maxTime: f,
                onSelect: Z
              }
            )
          }
        )
      ]
    }
  );
}, wr = {
  "ds-entity-picker-field": "_ds-entity-picker-field_1pcr2_1",
  "ds-entity-picker-field--width-full": "_ds-entity-picker-field--width-full_1pcr2_6",
  "ds-entity-picker-field--width-sm": "_ds-entity-picker-field--width-sm_1pcr2_9",
  "ds-entity-picker-field--width-md": "_ds-entity-picker-field--width-md_1pcr2_12",
  "ds-entity-picker-field--width-lg": "_ds-entity-picker-field--width-lg_1pcr2_15",
  "ds-entity-picker-field__trigger-wrap": "_ds-entity-picker-field__trigger-wrap_1pcr2_18",
  "ds-entity-picker__loading": "_ds-entity-picker__loading_1pcr2_22",
  "ds-entity-picker-pulse": "_ds-entity-picker-pulse_1pcr2_1"
};
function Uo({
  id: e,
  name: t,
  label: n,
  description: i,
  hint: r,
  state: s = Pe.Default,
  placeholder: o = "Search...",
  disabled: l = !1,
  readOnly: u = !1,
  size: c = Nt.Medium,
  required: d = !1,
  prefix: h,
  suffix: m = q.KeyboardArrowDown,
  suffixCopy: _,
  tooltip: y,
  tooltipPlacement: v,
  width: w = we.Auto,
  className: x,
  value: A,
  defaultValue: S = null,
  onChange: N,
  onSearch: E,
  initialOptions: f,
  getOptionLabel: C,
  loadingText: L = "Searching...",
  noResultsText: R = "No results found",
  minSearchLength: V = 1,
  debounceMs: z = 300,
  popupPlacement: $ = "bottom-start"
}) {
  const H = ee(null), B = ee(null), O = ee(null), W = ee(!1), [G, re] = Ee(!1), [K, P] = Ee(""), [oe, se] = Ee([]), [D, pe] = Ee(!1), [Ce, Z] = Ee(null), j = ee(0), ie = rt(), [te, ge] = Yt(A, S, N), { isOpen: ne, open: _e, close: Ie } = _i({
    anchorRef: H,
    overlayRef: B,
    placement: $,
    disabled: l || u
  }), Ve = te != null && K === C(te), nt = K.trim() === "" || Ve, Ke = K.trim() === "" ? f ?? oe : oe, pt = (() => {
    if (Ce !== null)
      return [Ce];
    if (te == null)
      return [];
    const ue = C(te), _t = Ke.find(
      (Tt) => C(Tt.value) === ue
    );
    return _t ? [_t.id] : [];
  })(), Be = ee(!1);
  me(() => {
    Be.current || l || u || (f?.length ?? 0) > 0 && te == null && (Be.current = !0, _e());
  }, []);
  const xt = he(
    async (ue, { force: _t = !1 } = {}) => {
      if (!_t && ue.trim().length < V) {
        se([]);
        return;
      }
      const Tt = ++j.current;
      pe(!0);
      try {
        const ln = await E(ue);
        Tt === j.current && se(ln);
      } catch {
        Tt === j.current && se([]);
      } finally {
        Tt === j.current && pe(!1);
      }
    },
    [E, V]
  ), kt = ld(xt, z);
  me(() => {
    !ne || !nt || D || (f?.length ?? 0) > 0 || oe.length > 0 || xt("", { force: !0 });
  }, [ne, nt]);
  const { activeId: ft, clearActiveId: Fe, handleInputKeyDown: je, onOptionRef: Re } = ar({
    options: Ke,
    isOpen: ne,
    onOpen: _e,
    onClose: Ie,
    onSelect: (ue) => {
      ge(ue.value), P(C(ue.value)), Z(ue.id), Ie(), Fe(), W.current = !0, O.current?.focus();
    }
  }), on = (ue) => {
    if (P(ue), ue.trim() === "") {
      ge(null), Z(null), se([]), j.current += 1, pe(!1);
      return;
    }
    ne || _e(), kt(ue);
  }, Q = (ue) => {
    ge(ue.value), P(C(ue.value)), Z(ue.id), Ie(), Fe(), W.current = !0, O.current?.focus();
  }, Y = () => {
    if (re(!0), W.current) {
      W.current = !1;
      return;
    }
    te != null && P(C(te));
  }, T = () => {
    re(!1), te != null ? P(C(te)) : P("");
  }, Se = () => {
    ne ? Ie() : (_e(), O.current?.focus());
  }, He = [i ? `${e}-description` : null, r ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, ut = G ? K : te != null ? C(te) : "";
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        wr["ds-entity-picker-field"],
        w !== we.Auto && wr[`ds-entity-picker-field--width-${w}`],
        x
      ),
      children: [
        /* @__PURE__ */ g(
          ti,
          {
            id: e,
            label: n,
            description: i,
            hint: r,
            state: s,
            required: d,
            disabled: l,
            tooltip: y,
            tooltipPlacement: v,
            suffixCopy: _,
            children: /* @__PURE__ */ g("div", { ref: H, className: wr["ds-entity-picker-field__trigger-wrap"], children: /* @__PURE__ */ g(
              Rn,
              {
                isFocused: G || ne,
                disabled: l,
                readOnly: u,
                state: s,
                size: c,
                prefix: h,
                suffix: m,
                onSuffixClick: l || u ? void 0 : Se,
                suffixAriaLabel: ne ? "Close options" : "Open options",
                inputRef: O,
                className: wr["ds-entity-picker-field__chrome"],
                children: /* @__PURE__ */ g(
                  On,
                  {
                    ref: O,
                    id: e,
                    name: t,
                    value: ut,
                    placeholder: o,
                    type: gt.Text,
                    disabled: l,
                    readOnly: u,
                    required: d,
                    role: "combobox",
                    ariaExpanded: ne,
                    ariaControls: ie,
                    ariaActivedescendant: ft ?? void 0,
                    ariaDescribedBy: He,
                    ariaInvalid: s === Pe.Error,
                    autoComplete: "off",
                    onChange: on,
                    onFocus: Y,
                    onBlur: T,
                    onKeyDown: je
                  }
                )
              }
            ) })
          }
        ),
        /* @__PURE__ */ g(
          gi,
          {
            id: ie,
            ref: B,
            anchorRef: H,
            isOpen: ne && !l && !u,
            placement: $,
            minWidth: "anchor",
            children: D ? /* @__PURE__ */ g("div", { className: wr["ds-entity-picker__loading"], role: "status", "aria-live": "polite", "aria-busy": "true", children: L }) : /* @__PURE__ */ g(
              or,
              {
                id: `${ie}-list`,
                options: Ke,
                selectedIds: pt,
                activeId: ft,
                mode: "single",
                ariaLabel: n,
                emptyText: K.trim().length < V ? `Type at least ${V} character${V === 1 ? "" : "s"} to search` : R,
                onActivate: Q,
                onOptionRef: Re
              }
            )
          }
        )
      ]
    }
  );
}
const Ct = {
  "ds-textarea-field": "_ds-textarea-field_nzkva_1",
  "ds-textarea-field__label-row": "_ds-textarea-field__label-row_nzkva_17",
  "ds-textarea-field__label": "_ds-textarea-field__label_nzkva_17",
  "ds-textarea-field__required": "_ds-textarea-field__required_nzkva_32",
  "ds-textarea-field__help-trigger": "_ds-textarea-field__help-trigger_nzkva_35",
  "ds-textarea-field__counter": "_ds-textarea-field__counter_nzkva_52",
  "ds-textarea-field__counter--exceeded": "_ds-textarea-field__counter--exceeded_nzkva_59",
  "ds-textarea-field__description": "_ds-textarea-field__description_nzkva_63",
  "ds-textarea-field__chrome": "_ds-textarea-field__chrome_nzkva_69",
  "ds-textarea-field__chrome--focused": "_ds-textarea-field__chrome--focused_nzkva_77",
  "ds-textarea-field__chrome--state-error": "_ds-textarea-field__chrome--state-error_nzkva_81",
  "ds-textarea-field__chrome--state-warning": "_ds-textarea-field__chrome--state-warning_nzkva_88",
  "ds-textarea-field__chrome--state-success": "_ds-textarea-field__chrome--state-success_nzkva_95",
  "ds-textarea-field__chrome--disabled": "_ds-textarea-field__chrome--disabled_nzkva_102",
  "ds-textarea-field__chrome--readonly": "_ds-textarea-field__chrome--readonly_nzkva_107",
  "ds-textarea-field__textarea": "_ds-textarea-field__textarea_nzkva_110",
  "ds-textarea-field__textarea--size-large": "_ds-textarea-field__textarea--size-large_nzkva_129",
  "ds-textarea-field__textarea--size-medium": "_ds-textarea-field__textarea--size-medium_nzkva_134",
  "ds-textarea-field__textarea--size-small": "_ds-textarea-field__textarea--size-small_nzkva_139",
  "ds-textarea-field__hint": "_ds-textarea-field__hint_nzkva_144",
  "ds-textarea-field__hint--error": "_ds-textarea-field__hint--error_nzkva_150",
  "ds-textarea-field__hint--warning": "_ds-textarea-field__hint--warning_nzkva_153",
  "ds-textarea-field__hint--success": "_ds-textarea-field__hint--success_nzkva_156",
  "ds-textarea-field--disabled": "_ds-textarea-field--disabled_nzkva_159",
  "ds-textarea-field--width-full": "_ds-textarea-field--width-full_nzkva_167",
  "ds-textarea-field--width-sm": "_ds-textarea-field--width-sm_nzkva_170",
  "ds-textarea-field--width-md": "_ds-textarea-field--width-md_nzkva_173",
  "ds-textarea-field--width-lg": "_ds-textarea-field--width-lg_nzkva_176"
}, E0 = ({
  id: e,
  name: t,
  ref: n,
  label: i,
  description: r,
  hint: s,
  state: o = Pe.Default,
  placeholder: l,
  disabled: u = !1,
  readOnly: c = !1,
  size: d = Nt.Medium,
  required: h = !1,
  tooltip: m,
  tooltipPlacement: _,
  width: y = we.Auto,
  className: v,
  value: w,
  defaultValue: x = "",
  onChange: A,
  onBlur: S,
  onFocus: N,
  rows: E = 4,
  maxLength: f,
  minLength: C,
  showCounter: L = !1
}) => {
  const R = ee(null), [V, z] = Ee(!1), $ = ee(null), H = rt(), [B, O] = Yt(w, x, A), W = f !== void 0 && B.length > f, G = [r ? `${e}-description` : null, s ? `${e}-hint` : null].filter(Boolean).join(" ") || void 0, re = () => {
    z(!0), N?.();
  }, K = (P) => {
    z(!1), S?.(P.target.value);
  };
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        Ct["ds-textarea-field"],
        u && Ct["ds-textarea-field--disabled"],
        y !== we.Auto && Ct[`ds-textarea-field--width-${y}`],
        v
      ),
      children: [
        i && /* @__PURE__ */ F("div", { className: Ct["ds-textarea-field__label-row"], children: [
          /* @__PURE__ */ F("label", { htmlFor: e, className: Ct["ds-textarea-field__label"], children: [
            i,
            h && /* @__PURE__ */ g("span", { className: Ct["ds-textarea-field__required"], "aria-hidden": "true", children: " *" })
          ] }),
          m && /* @__PURE__ */ F(et, { children: [
            /* @__PURE__ */ g(
              "span",
              {
                ref: $,
                className: Ct["ds-textarea-field__help-trigger"],
                role: "img",
                "aria-label": `More information about ${i}`,
                children: /* @__PURE__ */ g(be, { name: q.Help, "aria-hidden": "true" })
              }
            ),
            /* @__PURE__ */ g(
              kn,
              {
                id: H,
                content: m,
                anchorRef: $,
                placement: _
              }
            )
          ] }),
          L && f !== void 0 && /* @__PURE__ */ F(
            "span",
            {
              className: X(
                Ct["ds-textarea-field__counter"],
                W && Ct["ds-textarea-field__counter--exceeded"]
              ),
              "aria-label": `${B.length} of ${f} characters used`,
              "aria-live": "polite",
              children: [
                B.length,
                "/",
                f
              ]
            }
          )
        ] }),
        r && /* @__PURE__ */ g("p", { id: `${e}-description`, className: Ct["ds-textarea-field__description"], children: r }),
        /* @__PURE__ */ g(
          "div",
          {
            className: X(
              Ct["ds-textarea-field__chrome"],
              o !== Pe.Default && Ct[`ds-textarea-field__chrome--state-${o}`],
              V && Ct["ds-textarea-field__chrome--focused"],
              u && Ct["ds-textarea-field__chrome--disabled"],
              c && Ct["ds-textarea-field__chrome--readonly"]
            ),
            onClick: () => {
              !u && !c && R.current?.focus();
            },
            children: /* @__PURE__ */ g(
              "textarea",
              {
                ref: (P) => {
                  R.current = P, typeof n == "function" ? n(P) : n && (n.current = P);
                },
                id: e,
                name: t,
                value: B,
                placeholder: l,
                disabled: u,
                readOnly: c,
                rows: E,
                maxLength: f,
                minLength: C,
                required: h,
                "aria-describedby": G,
                "aria-invalid": o === Pe.Error || void 0,
                "aria-required": h || void 0,
                className: X(
                  Ct["ds-textarea-field__textarea"],
                  Ct[`ds-textarea-field__textarea--size-${d}`]
                ),
                onChange: (P) => O(P.target.value),
                onFocus: re,
                onBlur: K
              }
            )
          }
        ),
        s && /* @__PURE__ */ g(
          "p",
          {
            id: `${e}-hint`,
            className: X(
              Ct["ds-textarea-field__hint"],
              o !== Pe.Default && Ct[`ds-textarea-field__hint--${o}`]
            ),
            role: o === Pe.Error ? "alert" : void 0,
            "aria-live": o === Pe.Error ? "polite" : void 0,
            children: s
          }
        )
      ]
    }
  );
}, A0 = {
  short: { month: "short", day: "numeric" },
  long: { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }
}, nu = /* @__PURE__ */ new Map();
function I0(e) {
  let t = nu.get(e);
  return t || (t = new Intl.DateTimeFormat("en-US", A0[e]), nu.set(e, t)), t;
}
function md(e, t = {}) {
  const n = e instanceof Date ? e : new Date(e);
  return Number.isNaN(n.getTime()) ? "" : I0(t.style ?? "long").format(n).replace(/\u202f/g, " ");
}
const eo = 1024, to = eo * 1024, iu = to * 1024;
function _d(e) {
  return e < eo ? { divisor: 1, label: "B" } : e < to ? { divisor: eo, label: "KB" } : e < iu ? { divisor: to, label: "MB" } : { divisor: iu, label: "GB" };
}
function no(e, t) {
  return t.label === "B" || t.label === "KB" ? Math.round(e).toString() : e.toFixed(1).replace(/\.0$/, "");
}
function L0(e) {
  const t = Math.max(0, e), n = _d(t);
  return `${no(t / n.divisor, n)} ${n.label}`;
}
function N0(e, t) {
  const n = Math.max(0, t), i = Math.min(Math.max(0, e), n), r = _d(n), s = no(i / r.divisor, r), o = no(n / r.divisor, r);
  return `${s} of ${o} ${r.label}`;
}
function qo(e, t = 2) {
  const n = e.trim().split(/\s+/).filter(Boolean), i = n[0]?.[0] ?? "";
  if (n.length < 2 || t === 1)
    return i.toUpperCase();
  const r = n[n.length - 1]?.[0] ?? "";
  return `${i}${r}`.toUpperCase();
}
const cs = {
  "ns-avatar": "_ns-avatar_1cmu4_1",
  "ns-avatar--neutral": "_ns-avatar--neutral_1cmu4_15",
  "ns-avatar--agent": "_ns-avatar--agent_1cmu4_18",
  "ns-avatar__initials": "_ns-avatar__initials_1cmu4_29"
};
var Pi = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Neutral = "neutral", e))(Pi || {});
function Hs({
  imageUrl: e,
  iconName: t,
  name: n,
  initials: i,
  size: r = 28,
  isAries: s,
  color: o = Pi.Primary,
  className: l
}) {
  const u = X(
    cs["ns-avatar"],
    s && cs["ns-avatar--agent"],
    o === Pi.Neutral && cs["ns-avatar--neutral"],
    l
  ), c = n ? n.trim().slice(0, 1).toUpperCase() : "", d = i ?? c, h = d.length > 1 ? { fontSize: Math.round(r * 0.4) } : void 0;
  return /* @__PURE__ */ g("div", { className: u, style: { width: r, height: r, minWidth: r }, "aria-hidden": "true", children: e ? /* @__PURE__ */ g("img", { src: e, alt: "" }) : t ? /* @__PURE__ */ g(be, { name: t, size: Math.round(r * 0.65) }) : /* @__PURE__ */ g("span", { className: cs["ns-avatar__initials"], style: h, children: d }) });
}
const T0 = "data:image/svg+xml,%3csvg%20width='187'%20height='34'%20viewBox='0%200%20187%2034'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Group'%3e%3cpath%20id='Vector'%20d='M181.447%2034H4.81359C2.16515%2034%200%2031.8691%200%2029.2625V4.73755C0%202.13095%202.16515%200%204.81359%200H181.447C184.096%200%20186.261%202.13095%20186.261%204.73755V29.2625C186.261%2031.8691%20184.115%2034%20181.447%2034ZM4.81359%200.894236C2.66777%200.894236%200.90859%202.62563%200.90859%204.73755V29.2625C0.90859%2031.3744%202.66777%2033.1058%204.81359%2033.1058H181.447C183.593%2033.1058%20185.352%2031.3744%20185.352%2029.2625V4.73755C185.352%202.62563%20183.593%200.894236%20181.447%200.894236H4.81359Z'%20fill='%230067D2'/%3e%3cg%20id='Group_2'%3e%3cpath%20id='Vector_2'%20d='M53.8193%2019.2927H50.4555L49.8369%2020.967H48.7737L51.5574%2013.4517H52.7173L55.4818%2020.967H54.4185L53.8193%2019.2927ZM53.5293%2018.4746L52.1374%2014.6503L50.7455%2018.4746H53.5293Z'%20fill='%230067D2'/%3e%3c/g%3e%3cg%20id='Group_3'%3e%3cpath%20id='Vector_3'%20d='M131.494%2017.1996C131.049%2017.6181%20130.392%2017.8274%20129.503%2017.8274H128.033V20.9858H127.009V13.4133H129.483C130.353%2013.4133%20131.01%2013.6226%20131.455%2014.0412C131.9%2014.4598%20132.132%2014.9925%20132.132%2015.6394C132.151%2016.2482%20131.919%2016.781%20131.494%2017.1996ZM130.72%2016.6478C130.991%2016.4005%20131.126%2016.077%20131.126%2015.6204C131.126%2014.6881%20130.585%2014.2315%20129.503%2014.2315H128.033V17.0093H129.503C130.044%2017.0093%20130.45%2016.8761%20130.72%2016.6478Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_4'%20d='M135.148%2015.2018C135.476%2015.0115%20135.863%2014.9164%20136.346%2014.9164V15.9438H136.076C134.955%2015.9438%20134.394%2016.5526%20134.394%2017.7513V20.9858H133.389V15.0305H134.394V16.0009C134.568%2015.6584%20134.819%2015.392%20135.148%2015.2018Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_5'%20d='M138.589%2020.6814C138.125%2020.434%20137.777%2020.0725%20137.506%2019.5969C137.255%2019.1212%20137.12%2018.5885%20137.12%2017.9796C137.12%2017.3708%20137.255%2016.838%20137.526%2016.3624C137.796%2015.8867%20138.164%2015.5442%20138.627%2015.2969C139.091%2015.0496%20139.613%2014.9164%20140.174%2014.9164C140.735%2014.9164%20141.257%2015.0496%20141.721%2015.2969C142.185%2015.5442%20142.552%2015.9057%20142.822%2016.3624C143.093%2016.819%20143.228%2017.3708%20143.228%2017.9796C143.228%2018.5885%20143.093%2019.1402%20142.822%2019.5969C142.552%2020.0725%20142.165%2020.415%20141.701%2020.6814C141.237%2020.9287%20140.715%2021.0619%20140.135%2021.0619C139.555%2021.0619%20139.053%2020.9477%20138.589%2020.6814ZM141.141%2019.9584C141.45%2019.7871%20141.721%2019.5398%20141.914%2019.2163C142.107%2018.8929%20142.204%2018.4743%20142.204%2017.9986C142.204%2017.523%20142.107%2017.1234%20141.914%2016.781C141.721%2016.4575%20141.469%2016.2102%20141.16%2016.0389C140.851%2015.8677%20140.522%2015.7916%20140.155%2015.7916C139.787%2015.7916%20139.459%2015.8677%20139.149%2016.0389C138.84%2016.2102%20138.608%2016.4575%20138.415%2016.781C138.241%2017.1234%20138.144%2017.523%20138.144%2017.9986C138.144%2018.4743%20138.241%2018.8929%20138.415%2019.2163C138.589%2019.5398%20138.84%2019.7871%20139.13%2019.9584C139.439%2020.1296%20139.768%2020.2057%20140.116%2020.2057C140.483%2020.2057%20140.831%2020.1106%20141.141%2019.9584Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_6'%20d='M144.544%2016.3815C144.795%2015.9249%20145.143%2015.5634%20145.569%2015.316C146.013%2015.0687%20146.497%2014.9355%20147.038%2014.9355C147.502%2014.9355%20147.946%2015.0497%20148.352%2015.259C148.758%2015.4683%20149.068%2015.7537%20149.28%2016.0961V12.9568H150.286V20.9859H149.28V19.8633C149.087%2020.2248%20148.797%2020.5102%20148.391%2020.7385C148.004%2020.9669%20147.54%2021.081%20147.019%2021.081C146.477%2021.081%20145.994%2020.9478%20145.569%2020.7005C145.124%2020.4341%20144.795%2020.0726%20144.544%2019.597C144.293%2019.1213%20144.177%2018.5886%20144.177%2017.9988C144.177%2017.3709%20144.293%2016.8382%20144.544%2016.3815ZM149.01%2016.8191C148.836%2016.4957%20148.584%2016.2293%20148.275%2016.0581C147.966%2015.8868%20147.618%2015.7917%20147.251%2015.7917C146.883%2015.7917%20146.535%2015.8868%20146.226%2016.0581C145.917%2016.2293%20145.665%2016.4767%20145.491%2016.8191C145.317%2017.1426%20145.221%2017.5421%20145.221%2017.9988C145.221%2018.4554%20145.317%2018.8549%20145.491%2019.1784C145.685%2019.5209%20145.917%2019.7682%20146.226%2019.9394C146.535%2020.1107%20146.883%2020.2058%20147.251%2020.2058C147.618%2020.2058%20147.966%2020.1107%20148.275%2019.9394C148.584%2019.7682%20148.836%2019.5018%20149.01%2019.1784C149.203%2018.8359%20149.28%2018.4554%20149.28%2017.9988C149.28%2017.5421%20149.184%2017.1426%20149.01%2016.8191Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_7'%20d='M157.339%2015.0308V20.967H156.334V20.0918C156.14%2020.3962%20155.87%2020.6245%20155.541%2020.7957C155.193%2020.967%20154.826%2021.0431%20154.42%2021.0431C153.956%2021.0431%20153.531%2020.9479%20153.144%2020.7577C152.777%2020.5674%20152.467%2020.282%20152.255%2019.9015C152.042%2019.521%20151.926%2019.0453%20151.926%2018.4935V15.0308H152.912V18.3794C152.912%2018.9692%20153.067%2019.4068%20153.357%2019.7303C153.666%2020.0537%20154.072%2020.2059%20154.594%2020.2059C155.135%2020.2059%20155.56%2020.0347%20155.87%2019.7112C156.179%2019.3878%20156.334%2018.9121%20156.334%2018.2843V15.0308H157.339Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_8'%20d='M159.042%2016.3814C159.294%2015.9248%20159.642%2015.5633%20160.086%2015.316C160.531%2015.0686%20161.034%2014.9354%20161.613%2014.9354C162.348%2014.9354%20162.967%2015.1067%20163.45%2015.4682C163.933%2015.8297%20164.243%2016.3053%20164.397%2016.9332H163.315C163.218%2016.5717%20163.005%2016.2863%20162.715%2016.077C162.425%2015.8677%20162.058%2015.7536%20161.613%2015.7536C161.034%2015.7536%20160.57%2015.9438%20160.222%2016.3243C159.874%2016.7049%20159.7%2017.2566%20159.7%2017.9606C159.7%2018.6836%20159.874%2019.2354%20160.222%2019.6159C160.57%2019.9964%20161.034%2020.2057%20161.613%2020.2057C162.058%2020.2057%20162.425%2020.1106%20162.715%2019.9013C163.005%2019.692%20163.218%2019.4066%20163.315%2019.0261H164.397C164.243%2019.6349%20163.914%2020.1106%20163.431%2020.4911C162.947%2020.8526%20162.348%2021.0429%20161.613%2021.0429C161.034%2021.0429%20160.531%2020.9097%20160.086%2020.6623C159.642%2020.415%20159.294%2020.0535%20159.042%2019.5969C158.791%2019.1402%20158.675%2018.5885%20158.675%2017.9796C158.656%2017.3708%20158.791%2016.8381%20159.042%2016.3814Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_9'%20d='M166.947%2015.8489V19.3498C166.947%2019.6352%20167.005%2019.8444%20167.14%2019.9586C167.256%2020.0728%20167.488%2020.1298%20167.797%2020.1298H168.532V20.967H167.623C167.063%2020.967%20166.637%2020.8338%20166.367%2020.5865C166.096%2020.3391%20165.941%2019.9205%20165.941%2019.3307V15.8489H165.168V15.0308H165.941V13.5277H166.947V15.0308H168.512V15.8489H166.947Z'%20fill='%230067D2'/%3e%3c/g%3e%3cg%20id='Group_4'%3e%3cpath%20id='Vector_10'%20opacity='0.5'%20d='M93.4102%2020.967L90.2784%2013.6609L89.6405%2015.164L92.1343%2020.967H93.4102Z'%20fill='%230067D2'/%3e%3cg%20id='Group_5'%3e%3cg%20id='Group_6'%3e%3cpath%20id='Vector_11'%20d='M59.5029%2013.718H60.8368L63.002%2017.1428L65.1671%2013.718H66.501V20.967H65.2444V15.7729L62.9826%2019.1976H62.944L60.7402%2015.7919V20.967H59.5029V13.718Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_12'%20d='M68.8391%2013.7179H70.0957V20.9669H68.8391V13.7179Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_13'%20d='M74.0597%2014.8975H71.7979V13.7179H77.5974V14.8975H75.3356V20.9669H74.079V14.8975H74.0597Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_14'%20d='M83.4736%2018.2271C84.4595%2017.9418%2085.1748%2017.2188%2085.1748%2016.0391V16.0201C85.1748%2015.3922%2084.9621%2014.8405%2084.5755%2014.4599C84.1115%2014.0033%2083.4156%2013.7369%2082.507%2013.7369H79.3173V20.986H80.5738V18.4364H82.1397L83.8795%2020.9479L84.4402%2019.6351L83.4736%2018.2271ZM80.5738%2017.3139V14.8785H82.391C83.3189%2014.8785%2083.8795%2015.2971%2083.8795%2016.0772V16.0962C83.8795%2016.8382%2083.2996%2017.3139%2082.4103%2017.3139H80.5738Z'%20fill='%230067D2'/%3e%3c/g%3e%3cg%20id='Group_7'%3e%3cpath%20id='Vector_15'%20d='M95.7491%2014.8976H93.4873V13.718H99.2868V14.8976H97.025V20.967H95.7684V14.8976H95.7491Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_16'%20d='M101.007%2013.718H106.304V14.8596H102.263V16.7432H105.84V17.8848H102.263V19.8255H106.362V20.967H101.007V13.718Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_17'%20d='M107.831%2017.352V17.333C107.831%2015.2782%20109.359%2013.5848%20111.524%2013.5848C112.838%2013.5848%20113.631%2014.0415%20114.327%2014.7074L113.515%2015.6587C112.935%2015.126%20112.336%2014.7645%20111.524%2014.7645C110.171%2014.7645%20109.165%2015.906%20109.165%2017.314V17.333C109.165%2018.76%20110.151%2019.9016%20111.524%2019.9016C112.394%2019.9016%20112.954%2019.5401%20113.573%2018.9693L114.385%2019.8064C113.631%2020.5865%20112.819%2021.0812%20111.485%2021.0812C109.378%2021.0812%20107.831%2019.4449%20107.831%2017.352Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_18'%20d='M116.183%2013.718H117.44V16.7242H120.842V13.718H122.098V20.967H120.842V17.9038H117.44V20.967H116.183V13.718Z'%20fill='%230067D2'/%3e%3c/g%3e%3cpath%20id='Vector_19'%20d='M90.279%2013.6609H89.0031L85.8521%2020.967H87.1473L90.279%2013.6609Z'%20fill='%230067D2'/%3e%3c/g%3e%3c/g%3e%3cg%20id='Group_8'%3e%3cpath%20id='Vector_20'%20d='M33.3655%200.551514H5.00589C2.45411%200.551514%200.38562%202.58733%200.38562%205.0988V28.9007C0.38562%2031.4122%202.45411%2033.448%205.00589%2033.448H33.3655V0.551514ZM22.965%2025.9326L16.6629%2011.2443L10.3414%2025.9326H7.09372L15.039%207.47709H18.2868L26.2321%2025.9326H22.965Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_21'%20opacity='0.5'%20d='M16.6439%2011.2442L18.8864%206.06909L27.7403%2026.6746H16.6439V11.2442Z'%20fill='%230067D2'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", P0 = {
  "loa-badge": "_loa-badge_dop88_1"
};
function D0({ label: e = "A MITRATECH Product", badge: t = T0, onClick: n }) {
  const i = X({
    [P0["loa-badge"]]: !0
  });
  return /* @__PURE__ */ g("button", { "aria-label": e, title: e, id: "logo-badge", className: i, onClick: () => n?.(), children: /* @__PURE__ */ g("img", { "aria-label": e, src: t }) });
}
const zt = {
  "ds-badge": "_ds-badge_1b8mi_1",
  "ds-badge__contained": "_ds-badge__contained_1b8mi_16",
  "ds-badge__contained-primary": "_ds-badge__contained-primary_1b8mi_20",
  "ds-badge__contained-secondary": "_ds-badge__contained-secondary_1b8mi_24",
  "ds-badge__contained-info": "_ds-badge__contained-info_1b8mi_28",
  "ds-badge__contained-success": "_ds-badge__contained-success_1b8mi_32",
  "ds-badge__contained-warning": "_ds-badge__contained-warning_1b8mi_36",
  "ds-badge__contained-error": "_ds-badge__contained-error_1b8mi_40",
  "ds-badge__outlined": "_ds-badge__outlined_1b8mi_44",
  "ds-badge__outlined-primary": "_ds-badge__outlined-primary_1b8mi_48",
  "ds-badge__outlined-secondary": "_ds-badge__outlined-secondary_1b8mi_53",
  "ds-badge__outlined-info": "_ds-badge__outlined-info_1b8mi_58",
  "ds-badge__outlined-success": "_ds-badge__outlined-success_1b8mi_63",
  "ds-badge__outlined-warning": "_ds-badge__outlined-warning_1b8mi_68",
  "ds-badge__outlined-error": "_ds-badge__outlined-error_1b8mi_73"
};
var io = /* @__PURE__ */ ((e) => (e.Contained = "contained", e.Outlined = "outlined", e))(io || {});
function M0({
  text: e,
  variant: t = io.Contained,
  color: n = Le.Primary
}) {
  const i = t === io.Contained, r = n === Le.Primary, s = n === Le.Secondary, o = n === Le.Error, l = n === Le.Info, u = n === Le.Success, c = n === Le.Warning, d = X({
    // root class
    [zt["ds-badge"]]: !0,
    // contained variants
    [zt["ds-badge__contained"]]: i,
    [zt["ds-badge__contained-primary"]]: i && r,
    [zt["ds-badge__contained-secondary"]]: i && s,
    [zt["ds-badge__contained-info"]]: i && l,
    [zt["ds-badge__contained-success"]]: i && u,
    [zt["ds-badge__contained-warning"]]: i && c,
    [zt["ds-badge__contained-error"]]: i && o,
    // outlined variants
    [zt["ds-badge__outlined"]]: !i,
    [zt["ds-badge__outlined-primary"]]: !i && r,
    [zt["ds-badge__outlined-secondary"]]: !i && s,
    [zt["ds-badge__outlined-info"]]: !i && l,
    [zt["ds-badge__outlined-success"]]: !i && u,
    [zt["ds-badge__outlined-warning"]]: !i && c,
    [zt["ds-badge__outlined-error"]]: !i && o
  });
  return /* @__PURE__ */ g("span", { className: d, children: e });
}
const V0 = "ds-contextual-menu-layer", F0 = 4, R0 = 8, O0 = {
  "bottom-start": ["top-start", "bottom-end", "top-end"],
  "bottom-end": ["top-end", "bottom-start", "top-start"],
  "top-start": ["bottom-start", "top-end", "bottom-end"],
  "top-end": ["bottom-end", "top-start", "bottom-start"]
}, Dt = {
  "ds-contextual-menu": "_ds-contextual-menu_18wig_1",
  "ds-contextual-menu--closed": "_ds-contextual-menu--closed_18wig_29",
  "ds-contextual-menu--open": "_ds-contextual-menu--open_18wig_32",
  "ds-contextual-menu__list": "_ds-contextual-menu__list_18wig_53",
  "ds-contextual-menu__item": "_ds-contextual-menu__item_18wig_62",
  "ds-contextual-menu__button--disabled": "_ds-contextual-menu__button--disabled_18wig_77",
  "ds-contextual-menu__button": "_ds-contextual-menu__button_18wig_77",
  "ds-contextual-menu__label": "_ds-contextual-menu__label_18wig_107",
  "ds-contextual-menu__prefix": "_ds-contextual-menu__prefix_18wig_110",
  "ds-contextual-menu__suffix": "_ds-contextual-menu__suffix_18wig_110",
  "ds-contextual-menu__content": "_ds-contextual-menu__content_18wig_113",
  "ds-contextual-menu__header": "_ds-contextual-menu__header_18wig_152",
  "ds-contextual-menu__divider": "_ds-contextual-menu__divider_18wig_163"
}, ji = {
  "ds-checkbox": "_ds-checkbox_1dx76_1",
  "ds-checkbox--disabled": "_ds-checkbox--disabled_1dx76_7",
  "ds-checkbox--width-full": "_ds-checkbox--width-full_1dx76_12",
  "ds-checkbox--width-sm": "_ds-checkbox--width-sm_1dx76_15",
  "ds-checkbox--width-md": "_ds-checkbox--width-md_1dx76_18",
  "ds-checkbox--width-lg": "_ds-checkbox--width-lg_1dx76_21",
  "ds-checkbox__input": "_ds-checkbox__input_1dx76_24",
  "ds-checkbox--size-small": "_ds-checkbox--size-small_1dx76_78",
  "ds-checkbox--size-medium": "_ds-checkbox--size-medium_1dx76_88",
  "ds-checkbox__label": "_ds-checkbox__label_1dx76_92"
};
var lr = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(lr || {});
const ur = ({
  id: e,
  label: t,
  checked: n,
  indeterminate: i = !1,
  disabled: r = !1,
  size: s = lr.Medium,
  width: o = we.Auto,
  onChange: l,
  className: u
}) => {
  const c = ee(null);
  me(() => {
    c.current && (c.current.indeterminate = i);
  }, [i]);
  const d = X(
    ji["ds-checkbox"],
    ji[`ds-checkbox--size-${s}`],
    r && ji["ds-checkbox--disabled"],
    o !== we.Auto && ji[`ds-checkbox--width-${o}`],
    u
  );
  return /* @__PURE__ */ F("span", { className: d, children: [
    /* @__PURE__ */ g(
      "input",
      {
        ref: c,
        id: e,
        type: "checkbox",
        className: ji["ds-checkbox__input"],
        checked: n,
        disabled: r,
        "aria-checked": i ? "mixed" : n,
        onChange: (h) => l(h.target.checked)
      }
    ),
    t && /* @__PURE__ */ g("label", { htmlFor: e, className: ji["ds-checkbox__label"], children: t })
  ] });
};
function B0({ item: e, onActivate: t, onRef: n }) {
  const i = ee(null), r = (m) => {
    i.current = m, n(e.id, m);
  }, s = e.type === "checkbox", o = (m) => {
    if (e.disabled) {
      m.preventDefault();
      return;
    }
    if (e.type === "checkbox") {
      e.onChange(!e.checked), t(e.id);
      return;
    }
    e.onClick?.(), t(e.id);
  }, l = (m) => {
    e.type === "anchor" && m.key === " " && (m.preventDefault(), m.currentTarget.click());
  }, u = X(Dt["ds-contextual-menu__button"], e.disabled && Dt["ds-contextual-menu__button--disabled"]), c = {
    "data-item-id": e.id,
    role: s ? "menuitemcheckbox" : "menuitem",
    tabIndex: -1,
    "aria-disabled": e.disabled ? !0 : void 0,
    "aria-checked": s ? e.checked : void 0,
    className: u,
    onClick: o,
    onKeyDown: l
  }, d = /* @__PURE__ */ F("span", { className: Dt["ds-contextual-menu__content"], children: [
    e.prefix && /* @__PURE__ */ g(be, { className: Dt["ds-contextual-menu__prefix"], name: e.prefix, "aria-hidden": "true" }),
    /* @__PURE__ */ g("span", { className: Dt["ds-contextual-menu__label"], children: e.label }),
    s ? (
      // aria-hidden: the <button> already carries role=menuitemcheckbox +
      // aria-checked, so the visual Checkbox is purely decorative here.
      /* @__PURE__ */ g("span", { className: Dt["ds-contextual-menu__suffix"], "aria-hidden": "true", children: /* @__PURE__ */ g(
        ur,
        {
          id: `ds-cm-checkbox-${e.id}`,
          label: "",
          checked: e.checked,
          size: lr.Medium,
          onChange: () => {
          }
        }
      ) })
    ) : "suffix" in e && e.suffix && /* @__PURE__ */ g(be, { className: Dt["ds-contextual-menu__suffix"], name: e.suffix, "aria-hidden": "true" })
  ] }), h = e.type === "anchor" ? /* @__PURE__ */ g(
    "a",
    {
      ref: r,
      href: e.disabled ? void 0 : e.href,
      target: e.target,
      rel: e.target === Xn.Blank ? "noopener noreferrer" : void 0,
      ...c,
      children: d
    }
  ) : /* @__PURE__ */ g("button", { ref: r, type: "button", ...c, children: d });
  return /* @__PURE__ */ F("li", { role: "presentation", className: Dt["ds-contextual-menu__item"], children: [
    h,
    e.tooltip && /* @__PURE__ */ g(
      kn,
      {
        id: `ds-cm-item-tooltip-${e.id}`,
        content: e.tooltip,
        anchorRef: i,
        placement: e.tooltipPlacement ?? "right"
      }
    )
  ] });
}
function ru(e, t, n, i) {
  switch (n) {
    case "bottom-start":
      return {
        x: e.left,
        y: e.bottom + i
      };
    case "bottom-end":
      return {
        x: e.right + i,
        y: e.top
      };
    case "top-start":
      return {
        x: e.left,
        y: e.top - t.height - i
      };
    case "top-end":
      return {
        x: e.right + i,
        y: e.bottom - t.height
      };
  }
}
function z0(e, t, n, i, r) {
  const { viewportPaddingPx: s, flip: o } = r;
  let l = n, u = ru(e, t, n, i);
  if (o && !tr(u.x, u.y, t.width, t.height, s))
    for (const d of O0[n]) {
      const h = ru(e, t, d, i);
      if (tr(h.x, h.y, t.width, t.height, s)) {
        l = d, u = h;
        break;
      }
    }
  const c = Fo(u.x, u.y, t.width, t.height, s);
  return { x: c.x, y: c.y, resolvedPlacement: l };
}
const Kn = ({
  id: e,
  items: t = [],
  content: n,
  anchorRef: i,
  label: r = "Menu",
  placement: s = "bottom-start",
  offsetPx: o = F0,
  collision: l,
  disabled: u = !1,
  layerId: c = V0,
  className: d,
  onItemClick: h,
  onShow: m,
  onHide: _
}) => {
  const y = n !== void 0, v = rt(), w = e ?? v, [x, A] = Ee(!1), S = ee(null), N = ee(null), E = ee({
    x: 0,
    y: 0,
    resolvedPlacement: s
  }), f = ee(!1);
  me(() => {
    f.current = x;
  }, [x]);
  const C = ee(null), L = {
    viewportPaddingPx: l?.viewportPaddingPx ?? R0,
    flip: l?.flip ?? !0
  }, R = $e(
    () => t.filter(
      (Z) => Z.type !== "divider" && Z.type !== "header"
    ),
    [t]
  ), V = ee(/* @__PURE__ */ new Map()), z = he((Z, j) => {
    V.current.set(Z, j);
  }, []), $ = he(() => {
    const Z = R[0];
    Z && V.current.get(Z.id)?.focus();
  }, [R]), H = he(() => {
    const Z = R[R.length - 1];
    Z && V.current.get(Z.id)?.focus();
  }, [R]), B = he(
    (Z) => {
      const j = R.findIndex((ge) => ge.id === Z), ie = j === -1 ? 0 : (j + 1) % R.length, te = R[ie];
      te && V.current.get(te.id)?.focus();
    },
    [R]
  ), O = he(
    (Z) => {
      const j = R.findIndex((ge) => ge.id === Z), ie = j <= 0 ? R.length - 1 : j - 1, te = R[ie];
      te && V.current.get(te.id)?.focus();
    },
    [R]
  ), W = he(() => {
    N.current !== null && (cancelAnimationFrame(N.current), N.current = null);
  }, []), G = he(() => {
    const Z = i.current, j = S.current;
    if (!Z || !j)
      return;
    const ie = Z.getBoundingClientRect(), te = j.getBoundingClientRect(), ge = z0(ie, te, s, o, L);
    E.current = ge, j.style.setProperty("--_x", `${ge.x}px`), j.style.setProperty("--_y", `${ge.y}px`), j.dataset.placement = ge.resolvedPlacement;
  }, [i, s, o, L.viewportPaddingPx, L.flip]), re = he(() => {
    W(), N.current = requestAnimationFrame(() => {
      G();
    });
  }, [W, G]), K = he(() => {
    A(!1);
  }, []), P = he((Z = "first") => {
    C.current = Z, A(!0);
  }, []);
  me(() => {
    u && K();
  }, [u, K]);
  const oe = ee(!1);
  me(() => {
    if (!oe.current) {
      oe.current = !0;
      return;
    }
    x ? m?.() : _?.();
  }, [x, m, _]);
  const se = he(
    (Z) => {
      h?.(Z), t.find((ie) => ie.type !== "divider" && ie.id === Z)?.type !== "checkbox" && (K(), i.current?.focus());
    },
    [h, t, K, i]
  );
  rr(() => {
    if (!x)
      return;
    G();
    const Z = C.current;
    Z !== null && (C.current = null, Z === "first" ? $() : H());
  }, [x, G, $, H]), me(() => {
    const Z = i.current;
    if (!(!Z || u))
      return Z.setAttribute("aria-haspopup", y ? "dialog" : "menu"), Z.setAttribute("aria-controls", w), Z.setAttribute("aria-expanded", "false"), () => {
        Z.removeAttribute("aria-haspopup"), Z.removeAttribute("aria-controls"), Z.removeAttribute("aria-expanded");
      };
  }, [i, w, u, y]), me(() => {
    const Z = i.current;
    !Z || u || Z.setAttribute("aria-expanded", x ? "true" : "false");
  }, [i, x, u]), me(() => {
    const Z = i.current;
    if (!Z || u)
      return;
    const j = () => {
      f.current ? K() : P("first");
    }, ie = (te) => {
      f.current || (te.key === "Enter" || te.key === " " || te.key === "ArrowDown" ? (te.preventDefault(), P("first")) : te.key === "ArrowUp" && (te.preventDefault(), P("last")));
    };
    return Z.addEventListener("click", j), Z.addEventListener("keydown", ie), () => {
      Z.removeEventListener("click", j), Z.removeEventListener("keydown", ie);
    };
  }, [i, u, P, K]);
  const D = he(
    (Z) => {
      const j = document.activeElement?.dataset.itemId;
      switch (Z.key) {
        case "ArrowDown":
          Z.preventDefault(), j ? B(j) : $();
          break;
        case "ArrowUp":
          Z.preventDefault(), j ? O(j) : H();
          break;
        case "Home":
          Z.preventDefault(), $();
          break;
        case "End":
          Z.preventDefault(), H();
          break;
        case "Escape":
          Z.preventDefault(), K(), i.current?.focus();
          break;
        case "Tab":
          K();
          break;
      }
    },
    [B, O, $, H, K, i]
  );
  me(() => {
    if (!x)
      return;
    const Z = (j) => {
      const ie = i.current, te = S.current;
      ie?.contains(j.target) || te?.contains(j.target) || K();
    };
    return document.addEventListener("pointerdown", Z, { capture: !0 }), () => {
      document.removeEventListener("pointerdown", Z, { capture: !0 });
    };
  }, [x, i, K]), me(() => {
    if (!x || u) {
      W();
      return;
    }
    const Z = () => re(), j = () => re();
    return window.addEventListener("scroll", Z, { capture: !0, passive: !0 }), window.addEventListener("resize", j, { passive: !0 }), () => {
      window.removeEventListener("scroll", Z, { capture: !0 }), window.removeEventListener("resize", j), W();
    };
  }, [x, u, re, W]), me(() => {
    const Z = i.current;
    if (!Z || !x || u)
      return;
    const j = new ResizeObserver(() => {
      re();
    });
    return j.observe(Z), S.current && j.observe(S.current), () => j.disconnect();
  }, [i, x, u, re]), me(() => () => {
    W();
  }, [W]);
  const pe = x && !u ? "open" : "closed", Ce = pi(c);
  return hi(
    /* @__PURE__ */ g(
      "div",
      {
        ref: S,
        className: X(
          Dt["ds-contextual-menu"],
          Dt[`ds-contextual-menu--${pe}`],
          d
        ),
        "data-state": pe,
        children: y ? /* @__PURE__ */ g(
          "div",
          {
            id: w,
            role: "dialog",
            "aria-label": r,
            "aria-hidden": pe === "closed",
            className: Dt["ds-contextual-menu__list"],
            onKeyDown: (Z) => {
              Z.key === "Escape" && (Z.preventDefault(), K(), i.current?.focus());
            },
            children: n
          }
        ) : /* @__PURE__ */ g(
          "ul",
          {
            id: w,
            role: "menu",
            "aria-label": r,
            "aria-hidden": pe === "closed",
            className: Dt["ds-contextual-menu__list"],
            onKeyDown: D,
            children: t.map((Z) => Z.type === "divider" ? /* @__PURE__ */ g(
              "li",
              {
                role: "separator",
                "aria-orientation": "horizontal",
                className: Dt["ds-contextual-menu__divider"]
              },
              Z.id
            ) : Z.type === "header" ? /* @__PURE__ */ g("li", { role: "presentation", className: Dt["ds-contextual-menu__header"], children: /* @__PURE__ */ F("span", { className: Dt["ds-contextual-menu__content"], children: [
              Z.prefix && /* @__PURE__ */ g(be, { className: Dt["ds-contextual-menu__prefix"], name: Z.prefix, "aria-hidden": "true" }),
              /* @__PURE__ */ g("span", { className: Dt["ds-contextual-menu__label"], children: Z.label })
            ] }) }, Z.id) : /* @__PURE__ */ g(B0, { item: Z, onActivate: se, onRef: z }, Z.id))
          }
        )
      }
    ),
    Ce
  );
}, $i = {
  "user-badge": "_user-badge_1jsb6_1",
  "user-badge__text": "_user-badge__text_1jsb6_6",
  "user-badge__title": "_user-badge__title_1jsb6_13",
  "user-badge__subtitle": "_user-badge__subtitle_1jsb6_24",
  "user-badge__email": "_user-badge__email_1jsb6_35",
  "user-badge__trigger": "_user-badge__trigger_1jsb6_46"
}, Or = (e, t) => e.find((n) => n.role === t), Cs = (e, t) => {
  if (t) {
    if (t.render)
      return t.render(e);
    if (t.key !== void 0)
      return e[t.key];
  }
}, su = (e, t) => {
  const n = Cs(e, t);
  return typeof n == "string" ? n : "";
}, j0 = (e, t) => {
  const n = su(e, Or(t, "title")).trim();
  if (n) {
    const r = n.split(/\s+/).filter(Boolean);
    if (r.length >= 2)
      return `${r[0][0]}${r[r.length - 1][0]}`.toUpperCase();
    if (r.length === 1 && r[0].length > 0)
      return r[0][0].toUpperCase();
  }
  const i = su(e, Or(t, "email")).trim();
  return i ? (i.split("@")[0] ?? "").split(/[._-]/).filter(Boolean).slice(0, 2).map((o) => o[0].toUpperCase()).join("") : "";
};
function q6({
  "aria-label": e,
  id: t,
  entity: n,
  columns: i = [],
  getInitials: r,
  menuHeaderLabel: s,
  menuHeaderIcon: o,
  links: l = [],
  actions: u = [],
  onAction: c
}) {
  const d = ee(null), h = rt(), m = t ?? h, _ = (r?.(n) ?? j0(n, i)).trim(), y = Cs(n, Or(i, "title")), v = Cs(n, Or(i, "subtitle")), w = Cs(n, Or(i, "email")), x = y !== void 0 || v !== void 0 || w !== void 0, A = typeof y == "string" ? y.trim() : "", S = e ?? (A ? `Open menu for ${A}` : "Open user menu"), N = $e(() => {
    const f = [], C = s?.trim();
    C && f.push({
      type: "header",
      id: `${m}-header`,
      label: C,
      prefix: o
    });
    const L = l.map((z) => ({
      type: "anchor",
      id: `${m}-link-${z.id}`,
      label: z.label,
      href: z.href,
      target: z.target,
      prefix: z.prefix
    })), R = u.map((z) => ({
      type: "button",
      id: `${m}-action-${z.name}`,
      label: z.text ?? z.title ?? z.name,
      prefix: z.prefix ?? z.icon,
      tooltip: z.tooltip,
      tooltipPlacement: z.tooltipPlacement,
      disabled: z.disabled,
      onClick: () => c?.(z)
    }));
    return L.length > 0 || R.length > 0 ? (f.length > 0 && f.push({ type: "divider", id: `${m}-divider` }), [...f, ...L, ...R]) : [];
  }, [s, o, l, u, c, m]), E = N.length > 0;
  return /* @__PURE__ */ F("div", { className: $i["user-badge"], children: [
    x && /* @__PURE__ */ F("div", { className: $i["user-badge__text"], children: [
      y && /* @__PURE__ */ g("span", { className: $i["user-badge__title"], children: y }),
      v && /* @__PURE__ */ g("span", { className: $i["user-badge__subtitle"], children: v }),
      w && /* @__PURE__ */ g("span", { className: $i["user-badge__email"], children: w })
    ] }),
    /* @__PURE__ */ g(
      "button",
      {
        ref: d,
        type: "button",
        id: `${m}-trigger`,
        "aria-label": S,
        className: $i["user-badge__trigger"],
        disabled: !E,
        children: _
      }
    ),
    E && /* @__PURE__ */ g(
      Kn,
      {
        id: `${m}-menu`,
        label: typeof y == "string" ? y : "User menu",
        anchorRef: d,
        items: N,
        placement: "top-end"
      }
    )
  ] });
}
const Vt = {
  "ds-button": "_ds-button_xyia5_11",
  "ds-button__content": "_ds-button__content_xyia5_27",
  "ds-button__prefix": "_ds-button__prefix_xyia5_40",
  "ds-button__suffix": "_ds-button__suffix_xyia5_40",
  "ds-button__prefix--animated": "_ds-button__prefix--animated_xyia5_47",
  "ds-button-aries-pulse": "_ds-button-aries-pulse_xyia5_1",
  "ds-button__label": "_ds-button__label_xyia5_62",
  "ds-button__icon": "_ds-button__icon_xyia5_68",
  "ds-button__badge": "_ds-button__badge_xyia5_73",
  "ds-button--variant-contained": "_ds-button--variant-contained_xyia5_91",
  "ds-button--disabled": "_ds-button--disabled_xyia5_99",
  "ds-button--variant-outlined": "_ds-button--variant-outlined_xyia5_112",
  "ds-button--variant-text": "_ds-button--variant-text_xyia5_138",
  "ds-button--color-primary": "_ds-button--color-primary_xyia5_161",
  "ds-button--color-secondary": "_ds-button--color-secondary_xyia5_184",
  "ds-button--color-info": "_ds-button--color-info_xyia5_207",
  "ds-button--color-success": "_ds-button--color-success_xyia5_230",
  "ds-button--color-warning": "_ds-button--color-warning_xyia5_253",
  "ds-button--color-error": "_ds-button--color-error_xyia5_276",
  "ds-button--size-large": "_ds-button--size-large_xyia5_299",
  "ds-button--size-medium": "_ds-button--size-medium_xyia5_310",
  "ds-button--size-small": "_ds-button--size-small_xyia5_321",
  "ds-button--orientation-vertical": "_ds-button--orientation-vertical_xyia5_332",
  "ds-button--icon-only": "_ds-button--icon-only_xyia5_343",
  "ds-button--icon-only--size-large": "_ds-button--icon-only--size-large_xyia5_350",
  "ds-button--icon-only--size-medium": "_ds-button--icon-only--size-medium_xyia5_353",
  "ds-button--icon-only--size-small": "_ds-button--icon-only--size-small_xyia5_356"
}, au = (...e) => e.filter(Boolean).join(" "), $0 = {
  [lt.Large]: 24,
  [lt.Medium]: 20,
  [lt.Small]: 18
}, Ze = (e) => {
  const {
    id: t,
    name: n,
    ref: i,
    text: r,
    label: s,
    tooltip: o,
    tooltipPlacement: l,
    color: u = Le.Primary,
    variant: c = Ye.Contained,
    size: d = lt.Medium,
    icon: h,
    prefix: m,
    animatedPrefix: _ = !1,
    suffix: y,
    disabled: v = !1,
    isIconOnly: w = !1,
    badge: x,
    orientation: A = Is.Horizontal,
    type: S = "button",
    onClick: N,
    className: E,
    ...f
  } = e, C = ee(null), L = t === void 0 ? `tooltip-${s}` : `tooltip-${t}`, R = f["aria-busy"], z = v || (R === !0 || R === "true"), $ = f["aria-label"], H = !!(r && r.trim().length > 0), B = x !== void 0 && x !== "", O = B && s !== void 0 ? `${s} ${x}` : s, W = $ ?? (H ? void 0 : O), G = h !== void 0, re = (D) => {
    if (z) {
      D.preventDefault(), D.stopPropagation();
      return;
    }
    N?.(D);
  }, K = $0[d], P = !!m, oe = !!y, se = A === Is.Vertical;
  return /* @__PURE__ */ F(
    "button",
    {
      id: t,
      ref: sr(C, i),
      name: n,
      type: S,
      className: au(
        Vt["ds-button"],
        Vt[`ds-button--variant-${c}`],
        Vt[`ds-button--color-${u}`],
        Vt[`ds-button--size-${d}`],
        w && Vt["ds-button--icon-only"],
        w && Vt[`ds-button--icon-only--size-${d}`],
        z && Vt["ds-button--disabled"],
        se && Vt["ds-button--orientation-vertical"],
        E
      ),
      "aria-label": W,
      "aria-disabled": z || void 0,
      disabled: z,
      ...f,
      onClick: re,
      children: [
        /* @__PURE__ */ F("span", { className: Vt["ds-button__content"], children: [
          P && /* @__PURE__ */ g(
            "span",
            {
              className: au(Vt["ds-button__prefix"], _ && Vt["ds-button__prefix--animated"]),
              children: /* @__PURE__ */ g(be, { className: Vt["ds-button__icon"], "aria-hidden": "true", name: m, size: K, color: "currentColor" })
            }
          ),
          H && /* @__PURE__ */ g("span", { className: Vt["ds-button__label"], children: r }),
          G && /* @__PURE__ */ g(be, { "aria-hidden": "true", name: h, size: K, color: "currentColor" }),
          oe && /* @__PURE__ */ g("span", { className: Vt["ds-button__suffix"], children: /* @__PURE__ */ g(be, { className: Vt["ds-button__icon"], "aria-hidden": "true", name: y, size: K, color: "currentColor" }) }),
          B && // The leading space keeps the badge a separate word in the
          // accessible name ("Messages 2", not "Messages2"); as a
          // whitespace-only text node in a flex container it is not rendered.
          /* @__PURE__ */ F(et, { children: [
            " ",
            /* @__PURE__ */ g("span", { className: Vt["ds-button__badge"], children: x })
          ] })
        ] }),
        o && /* @__PURE__ */ g(
          kn,
          {
            id: L,
            content: o,
            anchorRef: C,
            placement: l,
            disabled: v
          }
        )
      ]
    }
  );
}, Gt = {
  "ds-radio": "_ds-radio_vxb0h_1",
  "ds-radio--label-start": "_ds-radio--label-start_vxb0h_7",
  "ds-radio--disabled": "_ds-radio--disabled_vxb0h_10",
  "ds-radio--width-full": "_ds-radio--width-full_vxb0h_15",
  "ds-radio--width-sm": "_ds-radio--width-sm_vxb0h_18",
  "ds-radio--width-md": "_ds-radio--width-md_vxb0h_21",
  "ds-radio--width-lg": "_ds-radio--width-lg_vxb0h_24",
  "ds-radio__input": "_ds-radio__input_vxb0h_27",
  "ds-radio--size-small": "_ds-radio--size-small_vxb0h_64",
  "ds-radio--size-medium": "_ds-radio--size-medium_vxb0h_68",
  "ds-radio__label": "_ds-radio__label_vxb0h_72",
  "ds-radio-group": "_ds-radio-group_vxb0h_83",
  "ds-radio-group__label": "_ds-radio-group__label_vxb0h_89",
  "ds-radio-group__options": "_ds-radio-group__options_vxb0h_100",
  "ds-radio-group__options--horizontal": "_ds-radio-group__options--horizontal_vxb0h_105",
  "ds-radio-group__helper": "_ds-radio-group__helper_vxb0h_110",
  "ds-radio-group--error": "_ds-radio-group--error_vxb0h_115",
  "ds-radio-group--disabled": "_ds-radio-group--disabled_vxb0h_121"
};
var Jo = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(Jo || {});
const H0 = ({
  id: e,
  name: t,
  value: n,
  label: i,
  checked: r,
  onChange: s,
  disabled: o = !1,
  size: l = Jo.Medium,
  labelPlacement: u = "end",
  width: c = we.Auto,
  className: d
}) => {
  const h = X(
    Gt["ds-radio"],
    Gt[`ds-radio--size-${l}`],
    o && Gt["ds-radio--disabled"],
    u === "start" && Gt["ds-radio--label-start"],
    c !== we.Auto && Gt[`ds-radio--width-${c}`],
    d
  );
  return /* @__PURE__ */ F("span", { className: h, children: [
    /* @__PURE__ */ g(
      "input",
      {
        id: e,
        type: "radio",
        name: t,
        value: n,
        className: Gt["ds-radio__input"],
        checked: r,
        disabled: o,
        onChange: (m) => {
          m.target.checked && s(n);
        }
      }
    ),
    i && /* @__PURE__ */ g("label", { htmlFor: e, className: Gt["ds-radio__label"], children: i })
  ] });
};
function U0({
  name: e,
  options: t,
  value: n,
  onChange: i,
  label: r,
  helperText: s,
  error: o = !1,
  disabled: l = !1,
  orientation: u = "vertical",
  size: c = Jo.Medium,
  id: d,
  className: h
}) {
  const m = rt(), _ = d ?? e ?? m, y = `${_}-label`, v = `${_}-helper`, w = X(
    Gt["ds-radio-group"],
    o && Gt["ds-radio-group--error"],
    l && Gt["ds-radio-group--disabled"],
    h
  ), x = X(Gt["ds-radio-group__options"], {
    [Gt["ds-radio-group__options--horizontal"]]: u === "horizontal"
  });
  return /* @__PURE__ */ F(
    "div",
    {
      role: "radiogroup",
      "aria-labelledby": r ? y : void 0,
      "aria-describedby": s ? v : void 0,
      "aria-invalid": o || void 0,
      className: w,
      children: [
        r && /* @__PURE__ */ g("span", { id: y, className: Gt["ds-radio-group__label"], children: r }),
        /* @__PURE__ */ g("div", { className: x, children: t.map((A) => /* @__PURE__ */ g(
          H0,
          {
            id: `${_}-${A.value}`,
            name: e,
            value: A.value,
            label: A.label,
            checked: n === A.value,
            disabled: l || A.disabled,
            size: c,
            onChange: (S) => i(S)
          },
          A.value
        )) }),
        s && /* @__PURE__ */ g("span", { id: v, className: Gt["ds-radio-group__helper"], children: s })
      ]
    }
  );
}
const ri = {
  "ds-segmented-control": "_ds-segmented-control_ks8gt_1",
  "ds-segmented-control--disabled": "_ds-segmented-control--disabled_ks8gt_7",
  "ds-segmented-control__label": "_ds-segmented-control__label_ks8gt_10",
  "ds-segmented-control__options": "_ds-segmented-control__options_ks8gt_18",
  "ds-segmented-control__option": "_ds-segmented-control__option_ks8gt_18",
  "ds-segmented-control__input": "_ds-segmented-control__input_ks8gt_29",
  "ds-segmented-control__segment": "_ds-segmented-control__segment_ks8gt_39",
  "ds-segmented-control__options--size-small": "_ds-segmented-control__options--size-small_ks8gt_61",
  "ds-segmented-control__options--size-medium": "_ds-segmented-control__options--size-medium_ks8gt_69"
};
var gd = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(gd || {});
function J6({
  name: e,
  options: t,
  value: n,
  onChange: i,
  label: r,
  "aria-label": s,
  disabled: o = !1,
  size: l = gd.Medium,
  id: u,
  className: c
}) {
  const d = rt(), h = u ?? e ?? d, m = `${h}-label`, _ = X(
    ri["ds-segmented-control"],
    o && ri["ds-segmented-control--disabled"],
    c
  ), y = X(ri["ds-segmented-control__options"], ri[`ds-segmented-control__options--size-${l}`]);
  return /* @__PURE__ */ F("div", { className: _, children: [
    r && /* @__PURE__ */ g("span", { id: m, className: ri["ds-segmented-control__label"], children: r }),
    /* @__PURE__ */ g(
      "div",
      {
        role: "radiogroup",
        "aria-labelledby": r ? m : void 0,
        "aria-label": r ? void 0 : s ?? e,
        className: y,
        children: t.map((v) => {
          const w = `${h}-${v.value}`;
          return /* @__PURE__ */ F("span", { className: ri["ds-segmented-control__option"], children: [
            /* @__PURE__ */ g(
              "input",
              {
                id: w,
                type: "radio",
                name: e,
                value: v.value,
                checked: n === v.value,
                disabled: o || v.disabled,
                className: ri["ds-segmented-control__input"],
                onChange: (x) => {
                  x.target.checked && i(v.value);
                }
              }
            ),
            /* @__PURE__ */ g("label", { htmlFor: w, className: ri["ds-segmented-control__segment"], children: v.label })
          ] }, v.value);
        })
      }
    )
  ] });
}
const kr = {
  "ds-progress-bar": "_ds-progress-bar_e5wga_1",
  "ds-progress-bar__label": "_ds-progress-bar__label_e5wga_8",
  "ds-progress-bar__track": "_ds-progress-bar__track_e5wga_16",
  "ds-progress-bar--size-small": "_ds-progress-bar--size-small_e5wga_22",
  "ds-progress-bar--size-medium": "_ds-progress-bar--size-medium_e5wga_25",
  "ds-progress-bar__fill": "_ds-progress-bar__fill_e5wga_28"
};
var Wo = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(Wo || {});
function q0({
  id: e,
  value: t,
  label: n,
  "aria-label": i,
  "aria-labelledby": r,
  size: s = Wo.Medium,
  className: o
}) {
  const l = Number.isFinite(t) ? t : 0, u = Math.min(100, Math.max(0, l)), c = `${e}-label`, d = r ?? (n && !i ? c : void 0);
  return /* @__PURE__ */ F("div", { className: X(kr["ds-progress-bar"], kr[`ds-progress-bar--size-${s}`], o), children: [
    n && /* @__PURE__ */ g("span", { id: c, className: kr["ds-progress-bar__label"], children: n }),
    /* @__PURE__ */ g(
      "div",
      {
        id: e,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": Math.round(u),
        "aria-label": i,
        "aria-labelledby": d,
        className: kr["ds-progress-bar__track"],
        children: /* @__PURE__ */ g("div", { className: kr["ds-progress-bar__fill"], style: { width: `${u}%` } })
      }
    )
  ] });
}
const vi = {
  "ds-disclosure": "_ds-disclosure_1bh2a_1",
  "ds-disclosure--inline": "_ds-disclosure--inline_1bh2a_4",
  "ds-disclosure__trigger": "_ds-disclosure__trigger_1bh2a_7",
  "ds-disclosure__chevron": "_ds-disclosure__chevron_1bh2a_30",
  "ds-disclosure--open": "_ds-disclosure--open_1bh2a_39",
  "ds-disclosure__panel": "_ds-disclosure__panel_1bh2a_42"
};
function xd({
  id: e,
  isOpen: t,
  defaultOpen: n,
  onToggle: i,
  trigger: r,
  children: s,
  keepMounted: o = !0,
  chevron: l = !1,
  inline: u = !1,
  panelRole: c,
  disabled: d = !1,
  className: h,
  triggerClassName: m,
  panelClassName: _,
  "aria-label": y
}) {
  const [v, w] = Yt(t, n ?? !1, i), x = `${e}-trigger`;
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        vi["ds-disclosure"],
        v && vi["ds-disclosure--open"],
        u && vi["ds-disclosure--inline"],
        d && vi["ds-disclosure--disabled"],
        h
      ),
      children: [
        /* @__PURE__ */ F(
          "button",
          {
            type: "button",
            id: x,
            className: X(vi["ds-disclosure__trigger"], m),
            "aria-expanded": v,
            "aria-controls": e,
            "aria-label": y,
            disabled: d,
            onClick: () => w(!v),
            children: [
              typeof r == "function" ? r({ isOpen: v }) : r,
              l && /* @__PURE__ */ g("span", { className: vi["ds-disclosure__chevron"], "aria-hidden": "true", children: /* @__PURE__ */ g(be, { name: q.ChevronRight, size: 16, color: "currentColor" }) })
            ]
          }
        ),
        (o || v) && /* @__PURE__ */ g(
          "div",
          {
            id: e,
            role: c,
            "aria-labelledby": c ? x : void 0,
            className: X(vi["ds-disclosure__panel"], _),
            hidden: !v,
            children: s
          }
        )
      ]
    }
  );
}
const J0 = "ds-popover-layer", ou = {
  "ds-popover__surface": "_ds-popover__surface_q8au3_1",
  "ds-popover": "_ds-popover_q8au3_1"
};
function W6({
  id: e,
  anchorRef: t,
  isOpen: n,
  onClose: i,
  placement: r = "bottom-end",
  offsetPx: s,
  collision: o,
  layerId: l,
  role: u = "dialog",
  "aria-label": c,
  "aria-labelledby": d,
  initialFocus: h = "first",
  returnFocus: m = !0,
  className: _,
  children: y
}) {
  const v = ee(null), w = ee(null), x = ee(n);
  _i({
    anchorRef: t,
    overlayRef: v,
    placement: r,
    isOpen: n,
    onOpenChange: (S) => {
      S || i();
    }
  }), me(() => {
    if (!n || h === "none")
      return;
    const S = requestAnimationFrame(() => {
      const N = w.current;
      if (!N || N.contains(document.activeElement))
        return;
      const E = nr(N)[0];
      (h === "first" ? E ?? N : N).focus({ preventScroll: !0 });
    });
    return () => cancelAnimationFrame(S);
  }, [n, h]), me(() => {
    const S = x.current;
    if (x.current = n, !S || n || !m)
      return;
    const N = document.activeElement;
    (N === document.body || v.current?.contains(N)) && t.current?.focus();
  }, [n, m, t]);
  const A = (S) => {
    if (S.key !== "Tab")
      return;
    const N = w.current;
    if (!N)
      return;
    const E = nr(N), f = E[0], C = E[E.length - 1], L = document.activeElement, R = !S.shiftKey && (E.length === 0 || L === C), V = L === f || L === N, z = S.shiftKey && (E.length === 0 || V);
    !R && !z || (S.preventDefault(), S.stopPropagation(), i(), t.current?.focus());
  };
  return /* @__PURE__ */ g(
    gi,
    {
      id: `${e}-surface`,
      ref: v,
      anchorRef: t,
      isOpen: n,
      placement: r,
      offsetPx: s,
      collision: o,
      layerId: l ?? J0,
      minWidth: "anchor",
      className: ou["ds-popover__surface"],
      children: /* @__PURE__ */ g(
        "div",
        {
          id: e,
          ref: w,
          role: u,
          "aria-label": c,
          "aria-labelledby": d,
          "aria-hidden": n ? void 0 : !0,
          tabIndex: -1,
          className: X(ou["ds-popover"], _),
          onKeyDown: A,
          children: y
        }
      )
    }
  );
}
function Z6(e = {}) {
  const t = rt(), n = e.id ?? t, [i, r] = Ee(e.defaultOpen ?? !1), s = ee(null), o = he(() => r(!0), []), l = he(() => r(!1), []), u = he(() => r((c) => !c), []);
  return {
    id: n,
    isOpen: i,
    open: o,
    close: l,
    toggle: u,
    anchorRef: s,
    triggerProps: {
      ref: s,
      "aria-haspopup": "dialog",
      "aria-expanded": i,
      "aria-controls": n,
      onClick: u
    },
    popoverProps: { id: n, anchorRef: s, isOpen: i, onClose: l }
  };
}
const W0 = {
  "ns-link": "_ns-link_148zc_1"
};
function Gr({ url: e, target: t, title: n, ariaLabel: i, id: r, className: s, text: o, icon: l, children: u }) {
  const c = t === Xn.Blank, d = u !== void 0 ? void 0 : l ?? (c ? q.Launch : void 0);
  return /* @__PURE__ */ g(
    "a",
    {
      id: r,
      href: e,
      target: t,
      rel: c ? "noopener noreferrer" : void 0,
      title: n,
      "aria-label": i ?? n,
      className: X(W0["ns-link"], s),
      children: u ?? /* @__PURE__ */ F(et, { children: [
        o,
        d !== void 0 && /* @__PURE__ */ g(be, { name: d })
      ] })
    }
  );
}
const lu = {
  "ns-visually-hidden": "_ns-visually-hidden_ppm9o_1"
};
function Kr({ as: e = "span", className: t, children: n, ...i }) {
  const r = t ? `${lu["ns-visually-hidden"]} ${t}` : lu["ns-visually-hidden"];
  return /* @__PURE__ */ g(e, { className: r, ...i, children: n });
}
const Cr = {
  "ns-empty-state": "_ns-empty-state_od79r_1",
  "ns-empty-state__icon": "_ns-empty-state__icon_od79r_11",
  "ns-empty-state__title": "_ns-empty-state__title_od79r_22",
  "ns-empty-state__description": "_ns-empty-state__description_od79r_31",
  "ns-empty-state__actions": "_ns-empty-state__actions_od79r_40"
};
function X6({
  icon: e = q.Mail,
  title: t,
  description: n,
  actions: i,
  onAction: r,
  headingLevel: s,
  className: o,
  "aria-label": l
}) {
  const u = s ? `h${s}` : "p";
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(Cr["ns-empty-state"], o),
      role: l ? "group" : void 0,
      "aria-label": l,
      children: [
        /* @__PURE__ */ g("span", { className: Cr["ns-empty-state__icon"], "aria-hidden": "true", children: /* @__PURE__ */ g(be, { name: e, size: 24, color: "currentColor" }) }),
        /* @__PURE__ */ g(u, { className: Cr["ns-empty-state__title"], children: t }),
        n ? /* @__PURE__ */ g("div", { className: Cr["ns-empty-state__description"], children: n }) : null,
        i && i.length > 0 ? /* @__PURE__ */ g("div", { className: Cr["ns-empty-state__actions"], children: i.map((c) => /* @__PURE__ */ g(Ze, { ...c, onClick: () => r?.(c) }, c.name)) }) : null
      ]
    }
  );
}
const ca = {
  "ns-panel-header": "_ns-panel-header_1qex2_1",
  "ns-panel-header__title": "_ns-panel-header__title_1qex2_11",
  "ns-panel-header__actions": "_ns-panel-header__actions_1qex2_25"
};
function G6({
  id: e,
  title: t,
  onBack: n,
  backLabel: i = "Back",
  actions: r,
  onAction: s,
  trailing: o,
  headingLevel: l = 3,
  className: u
}) {
  const c = `h${l}`;
  return /* @__PURE__ */ F("div", { className: X(ca["ns-panel-header"], u), children: [
    n ? /* @__PURE__ */ g(
      Ze,
      {
        isIconOnly: !0,
        icon: q.ChevronLeft,
        variant: Ye.Text,
        color: Le.Secondary,
        size: lt.Small,
        label: i,
        onClick: n
      }
    ) : null,
    /* @__PURE__ */ g(c, { id: e ? `${e}-title` : void 0, className: ca["ns-panel-header__title"], children: t }),
    r && r.length > 0 ? /* @__PURE__ */ g("div", { className: ca["ns-panel-header__actions"], children: r.map((d) => /* @__PURE__ */ g(Ze, { ...d, onClick: () => s?.(d) }, d.name)) }) : null,
    o
  ] });
}
const Sr = {
  "ns-split-view": "_ns-split-view_em3ji_1",
  "ns-split-view__list": "_ns-split-view__list_em3ji_8",
  "ns-split-view__detail": "_ns-split-view__detail_em3ji_8",
  "ns-split-view--split": "_ns-split-view--split_em3ji_16",
  "ns-split-view--stacked": "_ns-split-view--stacked_em3ji_20"
};
var bd = /* @__PURE__ */ ((e) => (e.Split = "split", e.Stacked = "stacked", e))(bd || {});
function K6({
  mode: e,
  list: t,
  detail: n,
  hasSelection: i,
  emptyDetail: r,
  listWidth: s = "33.333%",
  listLabel: o,
  detailLabel: l,
  className: u
}) {
  const c = e === bd.Split, d = c || !i, h = c || i, m = { "--ns-split-view-list-width": s };
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        Sr["ns-split-view"],
        c ? Sr["ns-split-view--split"] : Sr["ns-split-view--stacked"],
        u
      ),
      style: m,
      children: [
        d ? /* @__PURE__ */ g("section", { "aria-label": o, className: Sr["ns-split-view__list"], children: t }) : null,
        h ? /* @__PURE__ */ g("section", { "aria-label": l, className: Sr["ns-split-view__detail"], children: i ? n : r }) : null
      ]
    }
  );
}
const rn = {
  "ns-conversation-list": "_ns-conversation-list_e92vd_1",
  "ns-conversation-item": "_ns-conversation-item_e92vd_8",
  "ns-conversation-item__button": "_ns-conversation-item__button_e92vd_11",
  "ns-conversation-item--unread": "_ns-conversation-item--unread_e92vd_31",
  "ns-conversation-item--selected": "_ns-conversation-item--selected_e92vd_34",
  "ns-conversation-item__body": "_ns-conversation-item__body_e92vd_37",
  "ns-conversation-item__row": "_ns-conversation-item__row_e92vd_44",
  "ns-conversation-item__title": "_ns-conversation-item__title_e92vd_50",
  "ns-conversation-item__time": "_ns-conversation-item__time_e92vd_61",
  "ns-conversation-item__subtitle": "_ns-conversation-item__subtitle_e92vd_61",
  "ns-conversation-item__preview": "_ns-conversation-item__preview_e92vd_61",
  "ns-conversation-item__prefix": "_ns-conversation-item__prefix_e92vd_77",
  "ns-conversation-item__preview--draft": "_ns-conversation-item__preview--draft_e92vd_80"
};
var ro = /* @__PURE__ */ ((e) => (e.Default = "default", e.Draft = "draft", e))(ro || {});
const Z0 = 40;
function X0(e) {
  return md(e, { style: "short" });
}
function G0(e) {
  const t = e instanceof Date ? e : new Date(e);
  return Number.isNaN(t.getTime()) ? void 0 : t.toISOString();
}
function Y6({
  id: e,
  avatar: t,
  title: n,
  subtitle: i,
  preview: r,
  previewPrefix: s,
  previewTone: o = ro.Default,
  timestamp: l,
  formatTimestamp: u = X0,
  unread: c = !1,
  selected: d = !1,
  onSelect: h,
  className: m
}) {
  return /* @__PURE__ */ g(
    "li",
    {
      className: X(
        rn["ns-conversation-item"],
        c && rn["ns-conversation-item--unread"],
        d && rn["ns-conversation-item--selected"],
        m
      ),
      children: /* @__PURE__ */ F(
        "button",
        {
          type: "button",
          className: rn["ns-conversation-item__button"],
          "aria-current": d ? "true" : void 0,
          onClick: () => h(e),
          children: [
            /* @__PURE__ */ g(
              Hs,
              {
                size: Z0,
                name: t.name,
                initials: t.initials ?? qo(t.name),
                imageUrl: t.imageUrl
              }
            ),
            /* @__PURE__ */ F("span", { className: rn["ns-conversation-item__body"], children: [
              /* @__PURE__ */ F("span", { className: rn["ns-conversation-item__row"], children: [
                /* @__PURE__ */ g("span", { className: rn["ns-conversation-item__title"], children: n }),
                /* @__PURE__ */ g("time", { className: rn["ns-conversation-item__time"], dateTime: G0(l), children: u(l) })
              ] }),
              i ? /* @__PURE__ */ g("span", { className: rn["ns-conversation-item__subtitle"], children: i }) : null,
              r ? /* @__PURE__ */ F(
                "span",
                {
                  className: X(
                    rn["ns-conversation-item__preview"],
                    o === ro.Draft && rn["ns-conversation-item__preview--draft"]
                  ),
                  children: [
                    s ? /* @__PURE__ */ g("span", { className: rn["ns-conversation-item__prefix"], children: s }) : null,
                    r
                  ]
                }
              ) : null
            ] }),
            c ? /* @__PURE__ */ g(Kr, { children: "Unread" }) : null
          ]
        }
      )
    }
  );
}
function Q6({ "aria-label": e, children: t, className: n }) {
  return /* @__PURE__ */ g("ul", { className: X(rn["ns-conversation-list"], n), "aria-label": e, children: t });
}
const da = {
  "ns-copy-button": "_ns-copy-button_xkilz_1",
  "ns-copy-button__feedback": "_ns-copy-button__feedback_xkilz_7",
  "ns-copy-button__feedback--error": "_ns-copy-button__feedback--error_xkilz_17"
}, K0 = 2e3;
function Y0({
  id: e,
  value: t,
  label: n,
  tooltip: i = "Copy to clipboard",
  successMessage: r = "Copied",
  errorMessage: s = "Couldn't copy. Try again.",
  onCopied: o,
  size: l = lt.Small,
  className: u
}) {
  const [c, d] = Ee(null), [h, m] = Ee(""), _ = ee(null), y = he(() => {
    _.current !== null && (clearTimeout(_.current), _.current = null);
  }, []);
  me(() => y, [y]);
  const v = (S, N) => {
    y(), d({ message: S, isError: N }), m(S), _.current = setTimeout(() => {
      d(null), m(""), _.current = null;
    }, K0);
  };
  async function w() {
    try {
      if (!navigator.clipboard?.writeText)
        throw new Error("Clipboard API unavailable");
      await navigator.clipboard.writeText(t);
    } catch (S) {
      console.warn("CopyButton: could not copy to the clipboard", S), v(s, !0);
      return;
    }
    v(r, !1), o?.(t);
  }
  const x = () => {
    w();
  }, A = c !== null && !c.isError;
  return /* @__PURE__ */ F("span", { className: X(da["ns-copy-button"], u), children: [
    /* @__PURE__ */ g(
      Ze,
      {
        id: e,
        isIconOnly: !0,
        icon: A ? q.Done : q.ContentCopy,
        label: n,
        tooltip: i,
        variant: Ye.Text,
        color: Le.Secondary,
        size: l,
        onClick: x
      }
    ),
    /* @__PURE__ */ g(Kr, { role: "status", "aria-live": "polite", "aria-atomic": "true", children: h }),
    c && /* @__PURE__ */ g(
      "span",
      {
        className: X(
          da["ns-copy-button__feedback"],
          c.isError && da["ns-copy-button__feedback--error"]
        ),
        "aria-hidden": "true",
        children: c.message
      }
    )
  ] });
}
const Er = {
  "ns-participant-list": "_ns-participant-list_1dwbh_1",
  "ns-participant-list__row": "_ns-participant-list__row_1dwbh_10",
  "ns-participant-list__text": "_ns-participant-list__text_1dwbh_17",
  "ns-participant-list__name": "_ns-participant-list__name_1dwbh_24",
  "ns-participant-list__email": "_ns-participant-list__email_1dwbh_32"
};
function ek({
  participants: e,
  currentUserId: t,
  "aria-label": n = "Participants",
  className: i
}) {
  const r = rt();
  return /* @__PURE__ */ g("ul", { className: X(Er["ns-participant-list"], i), "aria-label": n, children: e.map((s) => {
    const o = s.id === t || s.isCurrentUser === !0;
    return /* @__PURE__ */ F("li", { className: Er["ns-participant-list__row"], children: [
      /* @__PURE__ */ g(
        Hs,
        {
          size: 32,
          initials: qo(s.name),
          color: o ? Pi.Primary : Pi.Neutral
        }
      ),
      /* @__PURE__ */ F("div", { className: Er["ns-participant-list__text"], children: [
        /* @__PURE__ */ F("span", { className: Er["ns-participant-list__name"], children: [
          s.name,
          o ? " (You)" : ""
        ] }),
        s.email && /* @__PURE__ */ g("span", { className: Er["ns-participant-list__email"], children: s.email })
      ] }),
      s.email && /* @__PURE__ */ g(
        Y0,
        {
          id: `${r}-copy-${s.id}`,
          value: s.email,
          label: `Copy email address for ${s.name}`,
          tooltip: "Copy email address",
          successMessage: "Email address copied",
          errorMessage: "Couldn't copy the email address. Try again."
        }
      )
    ] }, s.id);
  }) });
}
const uu = {
  "ns-file-trigger": "_ns-file-trigger_14yuf_1",
  "ns-file-trigger__input": "_ns-file-trigger__input_14yuf_5"
};
function tk({
  id: e,
  text: t = "Attach file",
  accept: n,
  multiple: i,
  disabled: r,
  onFilesSelected: s,
  variant: o = Ye.Text,
  color: l = Le.Primary,
  size: u = lt.Small,
  prefix: c = q.AttachFile,
  label: d,
  className: h
}) {
  const m = ee(null), _ = (y) => {
    const v = y.currentTarget, w = Array.from(v.files ?? []);
    v.value = "", w.length > 0 && s(w);
  };
  return /* @__PURE__ */ F("span", { className: X(uu["ns-file-trigger"], h), children: [
    /* @__PURE__ */ g(
      Ze,
      {
        text: t,
        prefix: c,
        variant: o,
        color: l,
        size: u,
        disabled: r,
        label: d,
        onClick: () => m.current?.click()
      }
    ),
    /* @__PURE__ */ g(
      "input",
      {
        ref: m,
        id: e,
        type: "file",
        className: uu["ns-file-trigger__input"],
        accept: n,
        multiple: i,
        disabled: r,
        tabIndex: -1,
        "aria-hidden": "true",
        onChange: _
      }
    )
  ] });
}
const yn = {
  "ns-attachment-list": "_ns-attachment-list_ioza8_1",
  "ns-attachment-list__items": "_ns-attachment-list__items_ioza8_7",
  "ns-attachment-list__helper": "_ns-attachment-list__helper_ioza8_15",
  "ns-attachment": "_ns-attachment_ioza8_1",
  "ns-attachment__tag": "_ns-attachment__tag_ioza8_36",
  "ns-attachment__tag--pdf": "_ns-attachment__tag--pdf_ioza8_53",
  "ns-attachment__tag--doc": "_ns-attachment__tag--doc_ioza8_56",
  "ns-attachment__tag--jpeg": "_ns-attachment__tag--jpeg_ioza8_59",
  "ns-attachment__tag--png": "_ns-attachment__tag--png_ioza8_62",
  "ns-attachment__tag--default": "_ns-attachment__tag--default_ioza8_65",
  "ns-attachment__body": "_ns-attachment__body_ioza8_68",
  "ns-attachment__name": "_ns-attachment__name_ioza8_76",
  "ns-attachment__status": "_ns-attachment__status_ioza8_76",
  "ns-attachment__status--failed": "_ns-attachment__status--failed_ioza8_99"
};
var Q0 = /* @__PURE__ */ ((e) => (e.Pdf = "pdf", e.Doc = "doc", e.Jpeg = "jpeg", e.Png = "png", e.Default = "default", e))(Q0 || {});
const yd = "FILE", e1 = 4, t1 = {
  pdf: "pdf",
  msword: "doc",
  "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  jpeg: "jpeg",
  png: "png",
  plain: "txt",
  csv: "csv",
  zip: "zip"
}, n1 = {
  pdf: "pdf",
  doc: "doc",
  docx: "doc",
  jpg: "jpeg",
  jpeg: "jpeg",
  png: "png"
  /* Png */
};
function i1(e) {
  const t = e.trim().toLowerCase();
  if (t.includes("/")) {
    const i = t.split("/")[1] ?? "";
    return t1[i] ?? "";
  }
  const n = t.lastIndexOf(".");
  return n >= 0 ? t.slice(n + 1) : t;
}
function cu(e) {
  const t = i1(e);
  return /^[a-z0-9]+$/.test(t) ? {
    label: t.slice(0, e1).toUpperCase(),
    tone: n1[t] ?? "default"
    /* Default */
  } : {
    label: yd,
    tone: "default"
    /* Default */
  };
}
function r1(e, t) {
  const n = e ? cu(e) : void 0;
  return n && n.label !== yd ? n : cu(t);
}
var ci = /* @__PURE__ */ ((e) => (e.Idle = "idle", e.Uploading = "uploading", e.Uploaded = "uploaded", e.Failed = "failed", e))(ci || {});
function vd(e) {
  return !e || e.totalBytes <= 0 ? 0 : Math.round(e.loadedBytes / e.totalBytes * 100);
}
function s1({ state: e, sizeBytes: t, progress: n, errorMessage: i }) {
  const r = t === void 0 ? void 0 : L0(t);
  if (e === ci.Uploading) {
    const o = n ? ` · ${N0(n.loadedBytes, n.totalBytes)}` : "";
    return `Uploading… ${vd(n)}%${o}`;
  }
  if (e === ci.Failed)
    return `Failed · ${i ?? "Upload failed"}`;
  const s = e === ci.Uploaded ? "Uploaded" : "Ready";
  return r ? `${s} · ${r}` : s;
}
function a1(e) {
  const { id: t, fileName: n, state: i, menuItems: r, onCancel: s, onRemove: o, onDownload: l } = e;
  if (r)
    return { icon: q.MoreVert, label: `More actions for ${n}` };
  if (i === ci.Uploading && s)
    return { icon: q.Close, label: `Cancel upload of ${n}`, onClick: () => s(t) };
  if (o)
    return { icon: q.Delete, label: `Remove ${n}`, onClick: () => o(t) };
  if (l)
    return { icon: q.FileDownload, label: `Download ${n}`, onClick: () => l(t) };
}
function o1(e) {
  const { id: t, fileName: n, fileType: i, state: r, progress: s, canRetry: o, onRetry: l } = e, { menuItems: u, onMenuItemClick: c, className: d } = e, h = ee(null), m = r1(i, n), _ = a1(e), y = r === ci.Uploading, v = r === ci.Failed;
  return /* @__PURE__ */ F("li", { className: X(yn["ns-attachment"], yn[`ns-attachment--${r}`], d), children: [
    /* @__PURE__ */ g("span", { className: X(yn["ns-attachment__tag"], yn[`ns-attachment__tag--${m.tone}`]), "aria-hidden": "true", children: m.label }),
    /* @__PURE__ */ g(Kr, { children: `${m.label} file` }),
    /* @__PURE__ */ F("div", { className: yn["ns-attachment__body"], children: [
      /* @__PURE__ */ g("p", { className: yn["ns-attachment__name"], title: n, children: n }),
      /* @__PURE__ */ g("p", { className: X(yn["ns-attachment__status"], v && yn["ns-attachment__status--failed"]), children: s1(e) }),
      y && /* @__PURE__ */ g(
        q0,
        {
          id: `${t}-progress`,
          value: vd(s),
          size: Wo.Small,
          "aria-label": `Uploading ${n}`
        }
      ),
      v && o && l && /* @__PURE__ */ g(
        Ze,
        {
          text: "Retry",
          "aria-label": `Retry upload of ${n}`,
          variant: Ye.Text,
          size: lt.Small,
          onClick: () => l(t)
        }
      )
    ] }),
    _ && /* @__PURE__ */ g(
      Ze,
      {
        ref: h,
        id: `${t}-action`,
        isIconOnly: !0,
        icon: _.icon,
        label: _.label,
        tooltip: _.label,
        variant: Ye.Text,
        color: Le.Secondary,
        size: lt.Small,
        onClick: _.onClick
      }
    ),
    u && /* @__PURE__ */ g(
      Kn,
      {
        id: `${t}-menu`,
        anchorRef: h,
        items: u,
        label: `Actions for ${n}`,
        placement: "bottom-end",
        onItemClick: (w) => c?.(w, t)
      }
    )
  ] });
}
function l1({
  attachments: e,
  helperText: t,
  "aria-label": n = "Attachments",
  id: i,
  className: r
}) {
  const s = rt(), o = i ?? s, l = `${o}-helper`, u = t != null && t !== !1 && t !== "";
  return e.length === 0 && !u ? null : /* @__PURE__ */ F("div", { id: o, className: X(yn["ns-attachment-list"], r), children: [
    e.length > 0 && /* @__PURE__ */ g(
      "ul",
      {
        className: yn["ns-attachment-list__items"],
        "aria-label": n,
        "aria-describedby": u ? l : void 0,
        children: e.map((c) => /* @__PURE__ */ g(o1, { ...c }, c.id))
      }
    ),
    u && /* @__PURE__ */ g("p", { id: l, className: yn["ns-attachment-list__helper"], children: t })
  ] });
}
const wi = {
  "ds-alert": "_ds-alert_lip8q_1",
  "ds-alert--filled-primary": "_ds-alert--filled-primary_lip8q_24",
  "ds-alert--filled-secondary": "_ds-alert--filled-secondary_lip8q_28",
  "ds-alert--filled-error": "_ds-alert--filled-error_lip8q_32",
  "ds-alert--filled-warning": "_ds-alert--filled-warning_lip8q_36",
  "ds-alert--filled-info": "_ds-alert--filled-info_lip8q_44",
  "ds-alert--filled-success": "_ds-alert--filled-success_lip8q_48",
  "ds-alert--outlined-primary": "_ds-alert--outlined-primary_lip8q_52",
  "ds-alert--outlined-secondary": "_ds-alert--outlined-secondary_lip8q_60",
  "ds-alert--outlined-error": "_ds-alert--outlined-error_lip8q_68",
  "ds-alert--outlined-warning": "_ds-alert--outlined-warning_lip8q_76",
  "ds-alert--outlined-info": "_ds-alert--outlined-info_lip8q_84",
  "ds-alert--outlined-success": "_ds-alert--outlined-success_lip8q_92",
  "ds-alert__icon": "_ds-alert__icon_lip8q_127",
  "ds-alert__body": "_ds-alert__body_lip8q_137",
  "ds-alert__title": "_ds-alert__title_lip8q_144",
  "ds-alert__description": "_ds-alert__description_lip8q_150",
  "ds-alert__dismiss": "_ds-alert__dismiss_lip8q_155"
};
var Us = /* @__PURE__ */ ((e) => (e.Filled = "filled", e.Outlined = "outlined", e))(Us || {}), pn = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Error = "error", e.Warning = "warning", e.Info = "info", e.Success = "success", e))(pn || {}), Zo = /* @__PURE__ */ ((e) => (e.TopLeft = "top-left", e.TopCenter = "top-center", e.TopRight = "top-right", e.CenterLeft = "center-left", e.Center = "center", e.CenterRight = "center-right", e.BottomLeft = "bottom-left", e.BottomCenter = "bottom-center", e.BottomRight = "bottom-right", e))(Zo || {}), wd = /* @__PURE__ */ ((e) => (e.FadeIn = "fade-in", e.SlideIn = "slide-in", e.None = "none", e))(wd || {}), kd = /* @__PURE__ */ ((e) => (e.FadeOut = "fade-out", e.SlideOut = "slide-out", e.None = "none", e))(kd || {});
const u1 = {
  [pn.Primary]: q.AlertCircle,
  [pn.Secondary]: q.AlertCircle,
  [pn.Error]: q.AlertCircle,
  [pn.Warning]: q.Warning,
  [pn.Info]: q.Info,
  [pn.Success]: q.CheckCircle
}, c1 = [pn.Error, pn.Warning], Cd = ({
  title: e,
  description: t,
  severity: n = pn.Info,
  variant: i = Us.Filled,
  dismissible: r = !0,
  onDismiss: s,
  className: o,
  phase: l = "visible",
  enterEffect: u,
  exitEffect: c
}) => {
  const d = c1.includes(n);
  return /* @__PURE__ */ F(
    "div",
    {
      role: d ? "alert" : "status",
      "aria-atomic": "true",
      "aria-live": d ? "assertive" : "polite",
      "data-state": l,
      "data-enter": u,
      "data-exit": c,
      className: X(
        wi["ds-alert"],
        wi[`ds-alert--${i}-${n}`],
        o
      ),
      children: [
        /* @__PURE__ */ g("span", { className: wi["ds-alert__icon"], "aria-hidden": "true", children: /* @__PURE__ */ g(be, { name: u1[n], size: 20 }) }),
        /* @__PURE__ */ F("div", { className: wi["ds-alert__body"], children: [
          /* @__PURE__ */ g("span", { className: wi["ds-alert__title"], children: e }),
          t && /* @__PURE__ */ g("span", { className: wi["ds-alert__description"], children: t })
        ] }),
        r && /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            "aria-label": "Dismiss notification",
            className: wi["ds-alert__dismiss"],
            onClick: s,
            children: /* @__PURE__ */ g(be, { name: q.Close, size: 16 })
          }
        )
      ]
    }
  );
}, mt = {
  "ns-message-card": "_ns-message-card_ix8ae_1",
  "ns-message-card--own": "_ns-message-card--own_ix8ae_11",
  "ns-message-card--quoted": "_ns-message-card--quoted_ix8ae_14",
  "ns-message-card__caption": "_ns-message-card__caption_ix8ae_19",
  "ns-message-card__header": "_ns-message-card__header_ix8ae_31",
  "ns-message-card__identity": "_ns-message-card__identity_ix8ae_36",
  "ns-message-card__sender": "_ns-message-card__sender_ix8ae_42",
  "ns-message-card__recipients-trigger": "_ns-message-card__recipients-trigger_ix8ae_50",
  "ns-message-card__details": "_ns-message-card__details_ix8ae_58",
  "ns-message-card__detail-row": "_ns-message-card__detail-row_ix8ae_69",
  "ns-message-card__stamp": "_ns-message-card__stamp_ix8ae_84",
  "ns-message-card__time": "_ns-message-card__time_ix8ae_90",
  "ns-message-card__sent": "_ns-message-card__sent_ix8ae_98",
  "ns-message-card__failure": "_ns-message-card__failure_ix8ae_102",
  "ns-message-card__failure-row": "_ns-message-card__failure-row_ix8ae_107",
  "ns-message-card__history": "_ns-message-card__history_ix8ae_114",
  "ns-message-card__timeline": "_ns-message-card__timeline_ix8ae_119",
  "ns-message-card__event": "_ns-message-card__event_ix8ae_135",
  "ns-message-card__body": "_ns-message-card__body_ix8ae_151",
  "ns-message-card__body--clamped": "_ns-message-card__body--clamped_ix8ae_161",
  "ns-message-card__actions": "_ns-message-card__actions_ix8ae_168"
};
var Br = /* @__PURE__ */ ((e) => (e.Sending = "sending", e.Sent = "sent", e.Failed = "failed", e))(Br || {}), Sd = /* @__PURE__ */ ((e) => (e.Default = "default", e.Quoted = "quoted", e))(Sd || {});
const d1 = 40, h1 = 5, du = "download", p1 = "remove";
function Ed(e) {
  return md(e, { style: "long" });
}
function Ad(e) {
  const t = e instanceof Date ? e : new Date(e);
  return Number.isNaN(t.getTime()) ? void 0 : t.toISOString();
}
function f1({ name: e, email: t }) {
  return t ? `${e} • ${t}` : e;
}
function m1(e) {
  return e.length > 0 && e.every((t) => t.isCurrentUser) ? "You" : e.length === 1 && e[0] ? e[0].name : "All";
}
function _1(e, t, n, i) {
  const r = ee(null), [s, o] = Ee(!1);
  return rr(() => {
    const l = r.current;
    if (!e || !l || t)
      return;
    const u = () => o(l.scrollHeight > l.clientHeight);
    u();
    const c = new ResizeObserver(u);
    return c.observe(l), () => c.disconnect();
  }, [e, t, n, i]), { bodyRef: r, isOverflowing: e && s };
}
function ha({ term: e, people: t }) {
  return /* @__PURE__ */ F("div", { className: mt["ns-message-card__detail-row"], children: [
    /* @__PURE__ */ g("dt", { children: e }),
    t.map((n) => /* @__PURE__ */ g("dd", { children: f1(n) }, n.id))
  ] });
}
function g1({ from: e, to: t, cc: n }) {
  return /* @__PURE__ */ F("dl", { className: mt["ns-message-card__details"], children: [
    e && /* @__PURE__ */ g(ha, { term: "From", people: [e] }),
    t.length > 0 && /* @__PURE__ */ g(ha, { term: "To", people: t }),
    n && n.length > 0 && /* @__PURE__ */ g(ha, { term: "Cc", people: n })
  ] });
}
function x1(e, t) {
  const { attachments: n = [], onAttachmentDownload: i, onAttachmentRemove: r } = e, s = [];
  return t && i && s.push({ type: "button", id: du, label: "Download", onClick: () => {
  } }), t && r && s.push({ type: "button", id: p1, label: "Remove file", danger: !0, onClick: () => {
  } }), n.map((o) => ({
    ...o,
    state: ci.Uploaded,
    onDownload: t ? void 0 : i,
    menuItems: s.length > 0 ? s : void 0,
    onMenuItemClick: (l, u) => {
      l === du ? i?.(u) : r?.(u);
    }
  }));
}
function b1({ id: e, props: t }) {
  const { showReplyAll: n, onReply: i, onReplyAll: r, onForward: s } = t, o = [
    { key: "reply", icon: q.Reply, label: "Reply", onClick: i },
    { key: "reply-all", icon: q.ReplyAll, label: "Reply all", onClick: n ? r : void 0 },
    { key: "forward", icon: q.Forward, label: "Forward", onClick: s }
  ].filter((l) => l.onClick !== void 0);
  return o.length === 0 ? null : /* @__PURE__ */ g("div", { className: mt["ns-message-card__actions"], role: "group", "aria-label": "Message actions", children: o.map((l) => /* @__PURE__ */ g(
    Ze,
    {
      id: `${e}-${l.key}`,
      isIconOnly: !0,
      icon: l.icon,
      label: l.label,
      tooltip: l.label,
      variant: Ye.Text,
      color: Le.Secondary,
      size: lt.Small,
      onClick: l.onClick
    },
    l.key
  )) });
}
function y1({ id: e, props: t }) {
  const { statusHistory: n = [], formatTimestamp: i = Ed } = t;
  return /* @__PURE__ */ g(xd, { id: `${e}-history`, chevron: !0, trigger: "Status history", className: mt["ns-message-card__history"], children: /* @__PURE__ */ g("ol", { className: mt["ns-message-card__timeline"], children: n.map((r) => /* @__PURE__ */ F("li", { className: mt["ns-message-card__event"], children: [
    /* @__PURE__ */ g("time", { dateTime: Ad(r.timestamp), children: i(r.timestamp) }),
    /* @__PURE__ */ g("span", { children: r.description })
  ] }, `${String(r.timestamp)}-${r.description}`)) }) });
}
function v1({ id: e, props: t }) {
  const { status: n, statusHistory: i, errorMessage: r, errorTitle: s, onResend: o } = t, l = n === Br.Sending;
  return /* @__PURE__ */ F("div", { className: mt["ns-message-card__failure"], children: [
    /* @__PURE__ */ F("div", { className: mt["ns-message-card__failure-row"], children: [
      i && i.length > 0 && /* @__PURE__ */ g(y1, { id: e, props: t }),
      (l || o) && /* @__PURE__ */ g(
        Ze,
        {
          text: l ? "Sending" : "Resend",
          disabled: l,
          variant: Ye.Text,
          size: lt.Small,
          onClick: o
        }
      )
    ] }),
    /* @__PURE__ */ g(
      Cd,
      {
        severity: pn.Error,
        variant: Us.Filled,
        dismissible: !1,
        title: s ?? "Message not sent",
        description: r
      }
    )
  ] });
}
function nk(e) {
  const { id: t, sender: n, isOwn: i = !1, recipients: r, from: s, recipientSummary: o, timestamp: l } = e, { status: u, errorMessage: c, statusHistory: d, body: h, attachments: m, variant: _, className: y } = e, { formatTimestamp: v = Ed } = e, { truncateLines: w = h1 } = e, x = _ === Sd.Quoted, [A, S] = Ee(!1), { bodyRef: N, isOverflowing: E } = _1(x, A, h, w), f = u === Br.Sending, C = u === Br.Failed || f && (c !== void 0 || (d?.length ?? 0) > 0), L = i ? "You" : n.name, R = `${t}-body`, V = o ?? m1(r.to), z = x1(e, x);
  return /* @__PURE__ */ F(
    "article",
    {
      id: t,
      className: X(
        mt["ns-message-card"],
        i && mt["ns-message-card--own"],
        C && mt["ns-message-card--failed"],
        x && mt["ns-message-card--quoted"],
        y
      ),
      "aria-labelledby": `${t}-sender ${t}-time`,
      children: [
        x && /* @__PURE__ */ F("div", { className: mt["ns-message-card__caption"], children: [
          /* @__PURE__ */ g("span", { "aria-hidden": "true", children: /* @__PURE__ */ g(be, { name: q.Forward, size: 16, color: "currentColor" }) }),
          "Forwarded email"
        ] }),
        /* @__PURE__ */ F("header", { className: mt["ns-message-card__header"], children: [
          /* @__PURE__ */ g(
            Hs,
            {
              size: d1,
              initials: n.initials ?? qo(n.name),
              color: i ? Pi.Primary : Pi.Neutral,
              imageUrl: n.imageUrl
            }
          ),
          /* @__PURE__ */ F("div", { className: mt["ns-message-card__identity"], children: [
            /* @__PURE__ */ g("p", { id: `${t}-sender`, className: mt["ns-message-card__sender"], children: L }),
            /* @__PURE__ */ g(
              xd,
              {
                id: `${t}-recipients`,
                chevron: !0,
                trigger: `To: ${V}`,
                className: mt["ns-message-card__recipients"],
                triggerClassName: mt["ns-message-card__recipients-trigger"],
                children: /* @__PURE__ */ g(g1, { from: s, to: r.to, cc: r.cc })
              }
            )
          ] }),
          /* @__PURE__ */ F("div", { className: mt["ns-message-card__stamp"], children: [
            /* @__PURE__ */ g("time", { id: `${t}-time`, className: mt["ns-message-card__time"], dateTime: Ad(l), children: v(l) }),
            u === Br.Sent && /* @__PURE__ */ g("span", { className: mt["ns-message-card__sent"], role: "img", "aria-label": "Sent", children: /* @__PURE__ */ g(be, { name: q.Done, size: 16, color: "currentColor" }) }),
            C && /* @__PURE__ */ g(Gn, { id: `${t}-status`, text: "Failed", label: "Status: Failed", color: Le.Error, variant: fi.Contained })
          ] })
        ] }),
        C && /* @__PURE__ */ g(v1, { id: t, props: e }),
        /* @__PURE__ */ g(
          "div",
          {
            id: R,
            ref: N,
            className: X(
              mt["ns-message-card__body"],
              x && !A && mt["ns-message-card__body--clamped"]
            ),
            style: x ? { "--ns-message-card-truncate-lines": w } : void 0,
            children: h
          }
        ),
        E && /* @__PURE__ */ g(
          Ze,
          {
            text: A ? "Show less" : "Show more",
            variant: Ye.Text,
            size: lt.Small,
            "aria-expanded": A,
            "aria-controls": R,
            onClick: () => S(($) => !$)
          }
        ),
        m && m.length > 0 && /* @__PURE__ */ g(
          l1,
          {
            id: `${t}-attachments`,
            "aria-label": `Attachments from ${L}`,
            attachments: z
          }
        ),
        !x && /* @__PURE__ */ g(b1, { id: t, props: e })
      ]
    }
  );
}
const Ft = {
  "ns-projection-calendar": "_ns-projection-calendar_1k5ac_1",
  "ns-projection-calendar__header": "_ns-projection-calendar__header_1k5ac_11",
  "ns-projection-calendar__label-cell": "_ns-projection-calendar__label-cell_1k5ac_19",
  "ns-projection-calendar__label-stack": "_ns-projection-calendar__label-stack_1k5ac_37",
  "ns-projection-calendar__label-sub": "_ns-projection-calendar__label-sub_1k5ac_43",
  "ns-projection-calendar__week-strip": "_ns-projection-calendar__week-strip_1k5ac_49",
  "ns-projection-calendar__week-cell": "_ns-projection-calendar__week-cell_1k5ac_55",
  "ns-projection-calendar__week-dates": "_ns-projection-calendar__week-dates_1k5ac_74",
  "ns-projection-calendar__lane": "_ns-projection-calendar__lane_1k5ac_80",
  "ns-projection-calendar__timeline": "_ns-projection-calendar__timeline_1k5ac_88",
  "ns-projection-calendar__bars-container": "_ns-projection-calendar__bars-container_1k5ac_93",
  "ns-projection-calendar__bar": "_ns-projection-calendar__bar_1k5ac_93",
  "ns-projection-calendar__bar--open-ended": "_ns-projection-calendar__bar--open-ended_1k5ac_112",
  "ns-projection-calendar__bar-label": "_ns-projection-calendar__bar-label_1k5ac_116",
  "ns-projection-calendar__legend": "_ns-projection-calendar__legend_1k5ac_131"
}, Xo = 19, Id = 10, Ld = 8, Ar = 240, w1 = 112, k1 = 112, C1 = 25, S1 = 16, E1 = 96, A1 = 7, I1 = {
  primary: Le.Info,
  secondary: Le.Warning,
  tertiary: Le.Success,
  quaternary: Le.Primary,
  neutral: Le.Secondary
};
function so(e) {
  const [t, n, i] = e.split("-").map(Number);
  return Date.UTC(t, n - 1, i) / 864e5;
}
function Di(e, t) {
  return so(t) - so(e);
}
function Ss(e) {
  const [t, n, i] = e.split("-").map(Number);
  return `${n}/${i}/${t}`;
}
function Ls(e, t) {
  const n = so(e) + t, i = new Date(n * 864e5);
  return `${i.getUTCFullYear()}-${i.getUTCMonth() + 1}-${i.getUTCDate()}`;
}
function pa(e) {
  const [, t, n] = e.split("-").map(Number);
  return `${t}/${n}`;
}
function ao(e) {
  return e < A1 ? "days" : "weeks";
}
function L1(e, t) {
  return e === t ? pa(e) : `${pa(e)} – ${pa(t)}`;
}
function N1(e) {
  if (e.openEnded)
    return `${Ss(e.startDate)} – End Date TBD`;
  const t = Di(e.startDate, e.endDate) > 1 ? Ls(e.endDate, -1) : e.startDate;
  return `${Ss(e.startDate)} – ${Ss(t)}`;
}
function T1(e, t) {
  const n = Di(e, t), i = Math.ceil(n / 7);
  return Array.from({ length: i }, (r, s) => {
    const o = s === i - 1 ? n - s * 7 : 7;
    return {
      label: `Week ${s + 1}`,
      detail: L1(
        Ls(e, s * 7),
        Ls(e, s * 7 + o - 1)
      ),
      days: o
    };
  });
}
function P1(e, t) {
  const n = Di(e, t);
  return Array.from({ length: n }, (i, r) => ({
    label: Ss(Ls(e, r)),
    days: 1
  }));
}
function D1(e, t) {
  const n = Di(e, t);
  return ao(n) === "days" ? P1(e, t) : T1(e, t);
}
function M1(e) {
  const t = Math.max(e, 1);
  return t * Xo + (t - 1) * Id + Ld * 2;
}
function V1(e) {
  return Ld + e * (Xo + Id);
}
function F1({ bar: e, index: t, calStart: n, totalDays: i }) {
  const r = ee(null), s = Di(n, e.startDate) / i * 100, o = Di(e.startDate, e.endDate) / i * 100, l = N1(e), u = e.tooltip ?? `${e.label} · ${l}`;
  return /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ g(
      "div",
      {
        ref: r,
        role: "gridcell",
        tabIndex: 0,
        "aria-label": `${e.label}: ${l}`,
        className: [
          Ft["ns-projection-calendar__bar"],
          e.openEnded && Ft["ns-projection-calendar__bar--open-ended"]
        ].filter(Boolean).join(" "),
        style: {
          position: "absolute",
          left: `${s}%`,
          width: `${o}%`,
          top: V1(t),
          height: Xo,
          backgroundColor: e.color
        },
        children: /* @__PURE__ */ g("span", { className: Ft["ns-projection-calendar__bar-label"], children: e.openEnded ? `${e.label} · End Date TBD` : e.label })
      }
    ),
    /* @__PURE__ */ g(kn, { id: `tip-${e.id}`, anchorRef: r, content: u, placement: "top" })
  ] });
}
function ik({
  "aria-label": e = "Projection calendar",
  laneHeaderLabel: t = "Timeline",
  startDate: n,
  endDate: i,
  lanes: r,
  legend: s
}) {
  const o = Di(n, i), l = D1(n, i), u = ao(o) === "days" ? k1 : w1, c = l[l.length - 1], d = ao(o) === "weeks" && c && c.days < 7 ? E1 : 0, h = Ar + C1 + S1 + l.length * u + d;
  return /* @__PURE__ */ F("div", { className: Ft["ns-projection-calendar"], children: [
    /* @__PURE__ */ F(
      "div",
      {
        role: "grid",
        "aria-label": e,
        "aria-rowcount": r.length + 1,
        style: {
          minWidth: h,
          "--ns-projection-calendar-overhang": `${d}px`
        },
        children: [
          /* @__PURE__ */ F("div", { className: Ft["ns-projection-calendar__header"], role: "row", children: [
            /* @__PURE__ */ g(
              "div",
              {
                className: Ft["ns-projection-calendar__label-cell"],
                role: "columnheader",
                style: {
                  width: Ar,
                  minWidth: Ar,
                  backgroundColor: "var(--ns-color-secondary-100)"
                },
                children: t
              }
            ),
            /* @__PURE__ */ g("div", { className: Ft["ns-projection-calendar__week-strip"], children: l.map((m, _) => /* @__PURE__ */ F(
              "div",
              {
                role: "columnheader",
                className: Ft["ns-projection-calendar__week-cell"],
                style: { flex: m.days },
                "aria-label": m.detail ? `${m.label} (${m.detail})` : void 0,
                title: m.detail ? `${m.label} (${m.detail})` : void 0,
                children: [
                  /* @__PURE__ */ g("span", { children: m.label }),
                  m.detail && /* @__PURE__ */ g("span", { className: Ft["ns-projection-calendar__week-dates"], children: m.detail })
                ]
              },
              `${m.label}-${_}`
            )) })
          ] }),
          r.map((m, _) => {
            const y = M1(m.bars.length), v = _ % 2 === 0 ? "var(--ns-color-background-primary)" : "var(--ns-color-background-secondary)";
            return /* @__PURE__ */ F(
              "div",
              {
                className: Ft["ns-projection-calendar__lane"],
                style: { backgroundColor: v },
                role: "row",
                children: [
                  /* @__PURE__ */ g(
                    "div",
                    {
                      className: Ft["ns-projection-calendar__label-cell"],
                      role: "rowheader",
                      style: {
                        width: Ar,
                        minWidth: Ar,
                        backgroundColor: v
                      },
                      children: m.subLabel ? /* @__PURE__ */ F("span", { className: Ft["ns-projection-calendar__label-stack"], children: [
                        /* @__PURE__ */ g("span", { children: m.label }),
                        /* @__PURE__ */ g("span", { className: Ft["ns-projection-calendar__label-sub"], children: m.subLabel })
                      ] }) : m.label
                    }
                  ),
                  /* @__PURE__ */ g(
                    "div",
                    {
                      className: Ft["ns-projection-calendar__timeline"],
                      style: { minHeight: y },
                      children: /* @__PURE__ */ g("div", { className: Ft["ns-projection-calendar__bars-container"], children: m.bars.map((w, x) => /* @__PURE__ */ g(
                        F1,
                        {
                          bar: w,
                          index: x,
                          calStart: n,
                          totalDays: o
                        },
                        w.id
                      )) })
                    }
                  )
                ]
              },
              m.id
            );
          })
        ]
      }
    ),
    s && s.length > 0 && // Shares the grid's minWidth so its border-top and background span
    // the full (possibly wider-than-viewport) table width instead of
    // just the visible, scrolled-into portion. border-box keeps the
    // legend's own padding from pushing its rendered width past the
    // grid's (content-box) minWidth.
    /* @__PURE__ */ g(
      "div",
      {
        className: Ft["ns-projection-calendar__legend"],
        role: "list",
        style: { minWidth: h, boxSizing: "border-box" },
        children: s.map((m) => /* @__PURE__ */ g("div", { role: "listitem", children: /* @__PURE__ */ g(
          Gn,
          {
            id: `legend-${m.variant}`,
            label: m.label,
            text: m.label,
            variant: fi.Outlined,
            color: I1[m.variant]
          }
        ) }, m.variant))
      }
    )
  ] });
}
const Nd = ei({
  open: [],
  toggle: () => {
  }
}), In = {
  "ns-accordion": "_ns-accordion_xno7b_1",
  "ns-accordion__item": "_ns-accordion__item_xno7b_8",
  "ns-accordion__heading": "_ns-accordion__heading_xno7b_11",
  "ns-accordion__trigger": "_ns-accordion__trigger_xno7b_14",
  "ns-accordion__trigger-label": "_ns-accordion__trigger-label_xno7b_38",
  "ns-accordion__trigger-icon": "_ns-accordion__trigger-icon_xno7b_41",
  "ns-accordion__content-wrapper": "_ns-accordion__content-wrapper_xno7b_50",
  "ns-accordion__content-wrapper--open": "_ns-accordion__content-wrapper--open_xno7b_56",
  "ns-accordion__content": "_ns-accordion__content_xno7b_50",
  "ns-accordion__item--open": "_ns-accordion__item--open_xno7b_75"
};
function R1({ children: e, initialOpen: t = [], isMultiExpand: n }) {
  const [i, r] = Ee(() => t), s = (l) => {
    const u = i.includes(l);
    r(u ? i.filter((c) => c !== l) : n ? [...i, l] : [l]);
  }, o = X({
    [In["ns-accordion"]]: !0
  });
  return /* @__PURE__ */ g("div", { className: o, children: /* @__PURE__ */ g(Nd.Provider, { value: { open: i, toggle: s }, children: e }) });
}
function O1({ children: e, id: t, title: n, label: i }) {
  const { open: r, toggle: s } = Fn(Nd), o = r.includes(t), l = `ns-accordion-trigger-${t}`, u = `ns-accordion-content-${t}`, c = X({
    [In["ns-accordion__item"]]: !0,
    [In["ns-accordion__item--open"]]: o
  }), d = X({
    [In["ns-accordion__content-wrapper"]]: !0,
    [In["ns-accordion__content-wrapper--open"]]: o
  });
  return /* @__PURE__ */ F("div", { className: c, children: [
    /* @__PURE__ */ g("h3", { className: In["ns-accordion__heading"], children: /* @__PURE__ */ F(
      "button",
      {
        id: l,
        type: "button",
        className: In["ns-accordion__trigger"],
        "aria-expanded": o,
        "aria-controls": u,
        "aria-label": i !== n ? i : void 0,
        onClick: () => s(t),
        children: [
          /* @__PURE__ */ g("span", { className: In["ns-accordion__trigger-label"], children: n }),
          /* @__PURE__ */ g("span", { "aria-hidden": "true", className: In["ns-accordion__trigger-icon"], children: /* @__PURE__ */ g(be, { name: o ? q.KeyboardArrowUp : q.KeyboardArrowDown }) })
        ]
      }
    ) }),
    /* @__PURE__ */ g(
      "div",
      {
        id: u,
        role: "region",
        "aria-labelledby": l,
        className: d,
        children: /* @__PURE__ */ g("div", { className: In["ns-accordion__content"], children: e })
      }
    )
  ] });
}
const Td = ei(null);
function Go() {
  const e = Fn(Td);
  if (e === null)
    throw new Error("useTabs() must be used within <Tabs>");
  return e;
}
const Pd = ei(!0);
function rk() {
  return Fn(Pd);
}
function Dd(e, t) {
  return `${e}-tab-${t}`;
}
function Md(e, t) {
  return `${e}-panel-${t}`;
}
const Vd = ei(null);
function B1({ id: e, value: t, defaultValue: n, onChange: i, children: r }) {
  const s = rt(), o = e ?? s, [l, u] = Yt(t, n ?? "", i), c = $e(
    () => ({ baseId: o, selected: l, select: u }),
    [o, l, u]
  );
  return /* @__PURE__ */ g(Td.Provider, { value: c, children: r });
}
const Ni = {
  "ns-tabs__list": "_ns-tabs__list_19x1e_1",
  "ns-tabs__tab": "_ns-tabs__tab_19x1e_11",
  "ns-tabs__tab--selected": "_ns-tabs__tab--selected_19x1e_44",
  "ns-tabs__tab--disabled": "_ns-tabs__tab--disabled_19x1e_51",
  "ns-tabs__label": "_ns-tabs__label_19x1e_58",
  "ns-tabs__badge": "_ns-tabs__badge_19x1e_61",
  "ns-tabs__panel": "_ns-tabs__panel_19x1e_76"
}, z1 = '[role="tab"]:not([aria-disabled="true"])';
function j1({ className: e, children: t, ...n }) {
  const { select: i } = Go(), r = ee(null), s = (o) => {
    if (o.defaultPrevented)
      return;
    const l = Array.from(
      r.current?.querySelectorAll(z1) ?? []
    ), u = l.length - 1;
    if (u < 0)
      return;
    const c = l.findIndex((y) => y === document.activeElement), h = {
      ArrowRight: c >= u ? 0 : c + 1,
      ArrowLeft: c <= 0 ? u : c - 1,
      Home: 0,
      End: u
    }[o.key];
    if (h === void 0)
      return;
    o.preventDefault();
    const m = l[h], _ = m?.dataset.value;
    m === void 0 || _ === void 0 || (m.focus(), i(_));
  };
  return /* @__PURE__ */ g("div", { ref: r, role: "tablist", className: X(Ni["ns-tabs__list"], e), ...n, children: /* @__PURE__ */ g(Vd.Provider, { value: s, children: t }) });
}
function $1(e) {
  const n = e.scrollIntoView;
  typeof n == "function" && n.call(e, { inline: "nearest", block: "nearest" });
}
function H1({
  value: e,
  badge: t,
  disabled: n = !1,
  className: i,
  children: r,
  onClick: s,
  onFocus: o,
  onKeyDown: l,
  ...u
}) {
  const { baseId: c, selected: d, select: h } = Go(), m = Fn(Vd), _ = d === e, y = t !== void 0 && t !== "", v = (A) => {
    s?.(A), !(A.defaultPrevented || n) && h(e);
  }, w = (A) => {
    o?.(A), $1(A.currentTarget);
  }, x = (A) => {
    l?.(A), m?.(A);
  };
  return /* @__PURE__ */ F(
    "button",
    {
      type: "button",
      role: "tab",
      id: Dd(c, e),
      "aria-selected": _,
      "aria-controls": Md(c, e),
      "aria-disabled": n || void 0,
      tabIndex: _ ? 0 : -1,
      "data-value": e,
      className: X(
        Ni["ns-tabs__tab"],
        _ && Ni["ns-tabs__tab--selected"],
        n && Ni["ns-tabs__tab--disabled"],
        i
      ),
      onClick: v,
      onFocus: w,
      onKeyDown: x,
      ...u,
      children: [
        /* @__PURE__ */ g("span", { className: Ni["ns-tabs__label"], children: r }),
        y && // The space keeps the count a separate word in the accessible name.
        /* @__PURE__ */ F(et, { children: [
          " ",
          /* @__PURE__ */ g("span", { className: Ni["ns-tabs__badge"], children: t })
        ] })
      ]
    }
  );
}
function U1({ value: e, className: t, children: n, ...i }) {
  const { baseId: r, selected: s } = Go(), o = s === e, l = ee(null), [u, c] = Ee(o);
  return o && !u && c(!0), rr(() => {
    const d = l.current;
    !d || !o || (nr(d).length === 0 ? d.setAttribute("tabindex", "0") : d.removeAttribute("tabindex"));
  }), !u && !o ? null : /* @__PURE__ */ g(
    "div",
    {
      ref: l,
      role: "tabpanel",
      id: Md(r, e),
      "aria-labelledby": Dd(r, e),
      hidden: !o,
      className: X(Ni["ns-tabs__panel"], t),
      ...i,
      children: /* @__PURE__ */ g(Pd.Provider, { value: o, children: n })
    }
  );
}
const oo = {}, Fd = Ur.createContext(oo);
function q1(e) {
  const t = Ur.useContext(Fd);
  return Ur.useMemo(
    function() {
      return typeof e == "function" ? e(t) : { ...t, ...e };
    },
    [t, e]
  );
}
function J1(e) {
  let t;
  return e.disableParentContext ? t = typeof e.components == "function" ? e.components(oo) : e.components || oo : t = q1(e.components), Ur.createElement(
    Fd.Provider,
    { value: t },
    e.children
  );
}
const W1 = "data:image/svg+xml,%3csvg%20width='168'%20height='24'%20viewBox='0%200%20168%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='Logo%20Type=Default,%20Size=Small'%3e%3cg%20id='Icon%20Left'%3e%3cg%20id='Group'%3e%3cpath%20id='Vector'%20d='M10.1023%207.10631L10.5608%208.38051C11.0708%209.7947%2012.1843%2010.9081%2013.5984%2011.4181L14.8726%2011.8766C14.9876%2011.9181%2014.9876%2012.0809%2014.8726%2012.1223L13.5984%2012.5809C12.1842%2013.0908%2011.0708%2014.2043%2010.5608%2015.6184L10.1023%2016.8926C10.0608%2017.0076%209.89799%2017.0076%209.85656%2016.8926L9.39803%2015.6184C8.88806%2014.2043%207.77458%2013.0908%206.36044%2012.5809L5.08624%2012.1223C4.97125%2012.0809%204.97125%2011.9181%205.08624%2011.8766L6.36044%2011.4181C7.77463%2010.9081%208.88807%209.79464%209.39803%208.38051L9.85656%207.10631C9.89799%206.9906%2010.0608%206.9906%2010.1023%207.10631Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_2'%20d='M15.8382%204.04446L16.0711%204.68941C16.3296%205.40507%2016.8931%205.96931%2017.6095%206.22787L18.2545%206.4607C18.313%206.48213%2018.313%206.56427%2018.2545%206.58498L17.6095%206.81781C16.8939%207.07637%2016.3296%207.6399%2016.0711%208.35628L15.8382%209.00122C15.8168%209.05979%2015.7347%209.05979%2015.714%209.00122L15.4811%208.35628C15.2226%207.64061%2014.659%207.07637%2013.9427%206.81781L13.2977%206.58498C13.2391%206.56355%2013.2391%206.48142%2013.2977%206.4607L13.9427%206.22787C14.6583%205.96931%2015.2226%205.40579%2015.4811%204.68941L15.714%204.04446C15.7347%203.98518%2015.8175%203.98518%2015.8382%204.04446Z'%20fill='%230067D2'/%3e%3cpath%20id='Vector_3'%20d='M15.8382%2014.9993L16.0711%2015.6443C16.3296%2016.3599%2016.8931%2016.9242%2017.6095%2017.1827L18.2545%2017.4156C18.313%2017.437%2018.313%2017.5191%2018.2545%2017.5398L17.6095%2017.7727C16.8939%2018.0312%2016.3296%2018.5948%2016.0711%2019.3111L15.8382%2019.9561C15.8168%2020.0147%2015.7347%2020.0147%2015.714%2019.9561L15.4811%2019.3111C15.2226%2018.5955%2014.659%2018.0312%2013.9427%2017.7727L13.2977%2017.5398C13.2391%2017.5184%2013.2391%2017.4363%2013.2977%2017.4156L13.9427%2017.1827C14.6583%2016.9242%2015.2226%2016.3606%2015.4811%2015.6443L15.714%2014.9993C15.7347%2014.9408%2015.8175%2014.9408%2015.8382%2014.9993Z'%20fill='%230067D2'/%3e%3c/g%3e%3c/g%3e%3cpath%20id='powered%20by'%20d='M30.352%2010.742C30.604%2010.3033%2030.9773%209.93933%2031.472%209.65C31.976%209.35133%2032.5593%209.202%2033.222%209.202C33.9033%209.202%2034.5193%209.36533%2035.07%209.692C35.63%2010.0187%2036.0687%2010.4807%2036.386%2011.078C36.7033%2011.666%2036.862%2012.352%2036.862%2013.136C36.862%2013.9107%2036.7033%2014.6013%2036.386%2015.208C36.0687%2015.8147%2035.63%2016.286%2035.07%2016.622C34.5193%2016.958%2033.9033%2017.126%2033.222%2017.126C32.5687%2017.126%2031.99%2016.9813%2031.486%2016.692C30.9913%2016.3933%2030.6133%2016.0247%2030.352%2015.586V20.64H29.078V9.328H30.352V10.742ZM35.56%2013.136C35.56%2012.5573%2035.4433%2012.0533%2035.21%2011.624C34.9767%2011.1947%2034.6593%2010.868%2034.258%2010.644C33.866%2010.42%2033.432%2010.308%2032.956%2010.308C32.4893%2010.308%2032.0553%2010.4247%2031.654%2010.658C31.262%2010.882%2030.9447%2011.2133%2030.702%2011.652C30.4687%2012.0813%2030.352%2012.5807%2030.352%2013.15C30.352%2013.7287%2030.4687%2014.2373%2030.702%2014.676C30.9447%2015.1053%2031.262%2015.4367%2031.654%2015.67C32.0553%2015.894%2032.4893%2016.006%2032.956%2016.006C33.432%2016.006%2033.866%2015.894%2034.258%2015.67C34.6593%2015.4367%2034.9767%2015.1053%2035.21%2014.676C35.4433%2014.2373%2035.56%2013.724%2035.56%2013.136ZM41.9849%2017.126C41.2663%2017.126%2040.6129%2016.9627%2040.0249%2016.636C39.4463%2016.3093%2038.9889%2015.8473%2038.6529%2015.25C38.3263%2014.6433%2038.1629%2013.9433%2038.1629%2013.15C38.1629%2012.366%2038.3309%2011.6753%2038.6669%2011.078C39.0123%2010.4713%2039.4789%2010.0093%2040.0669%209.692C40.6549%209.36533%2041.3129%209.202%2042.0409%209.202C42.7689%209.202%2043.4269%209.36533%2044.0149%209.692C44.6029%2010.0093%2045.0649%2010.4667%2045.4009%2011.064C45.7463%2011.6613%2045.9189%2012.3567%2045.9189%2013.15C45.9189%2013.9433%2045.7416%2014.6433%2045.3869%2015.25C45.0416%2015.8473%2044.5703%2016.3093%2043.9729%2016.636C43.3756%2016.9627%2042.7129%2017.126%2041.9849%2017.126ZM41.9849%2016.006C42.4423%2016.006%2042.8716%2015.8987%2043.2729%2015.684C43.6743%2015.4693%2043.9963%2015.1473%2044.2389%2014.718C44.4909%2014.2887%2044.6169%2013.766%2044.6169%2013.15C44.6169%2012.534%2044.4956%2012.0113%2044.2529%2011.582C44.0103%2011.1527%2043.6929%2010.8353%2043.3009%2010.63C42.9089%2010.4153%2042.4843%2010.308%2042.0269%2010.308C41.5603%2010.308%2041.1309%2010.4153%2040.7389%2010.63C40.3563%2010.8353%2040.0483%2011.1527%2039.8149%2011.582C39.5816%2012.0113%2039.4649%2012.534%2039.4649%2013.15C39.4649%2013.7753%2039.5769%2014.3027%2039.8009%2014.732C40.0343%2015.1613%2040.3423%2015.4833%2040.7249%2015.698C41.1076%2015.9033%2041.5276%2016.006%2041.9849%2016.006ZM57.914%209.328L55.52%2017H54.204L52.356%2010.91L50.508%2017H49.192L46.784%209.328H48.086L49.85%2015.768L51.754%209.328H53.056L54.918%2015.782L56.654%209.328H57.914ZM66.2784%2012.87C66.2784%2013.1127%2066.2644%2013.3693%2066.2364%2013.64H60.1044C60.1511%2014.396%2060.4077%2014.9887%2060.8744%2015.418C61.3504%2015.838%2061.9244%2016.048%2062.5964%2016.048C63.1471%2016.048%2063.6044%2015.922%2063.9684%2015.67C64.3417%2015.4087%2064.6031%2015.0633%2064.7524%2014.634H66.1244C65.9191%2015.3713%2065.5084%2015.9733%2064.8924%2016.44C64.2764%2016.8973%2063.5111%2017.126%2062.5964%2017.126C61.8684%2017.126%2061.2151%2016.9627%2060.6364%2016.636C60.0671%2016.3093%2059.6191%2015.8473%2059.2924%2015.25C58.9657%2014.6433%2058.8024%2013.9433%2058.8024%2013.15C58.8024%2012.3567%2058.9611%2011.6613%2059.2784%2011.064C59.5957%2010.4667%2060.0391%2010.0093%2060.6084%209.692C61.1871%209.36533%2061.8497%209.202%2062.5964%209.202C63.3244%209.202%2063.9684%209.36067%2064.5284%209.678C65.0884%209.99533%2065.5177%2010.434%2065.8164%2010.994C66.1244%2011.5447%2066.2784%2012.17%2066.2784%2012.87ZM64.9624%2012.604C64.9624%2012.1187%2064.8551%2011.7033%2064.6404%2011.358C64.4257%2011.0033%2064.1317%2010.7373%2063.7584%2010.56C63.3944%2010.3733%2062.9884%2010.28%2062.5404%2010.28C61.8964%2010.28%2061.3457%2010.4853%2060.8884%2010.896C60.4404%2011.3067%2060.1837%2011.876%2060.1184%2012.604H64.9624ZM69.334%2010.574C69.558%2010.1353%2069.8754%209.79467%2070.286%209.552C70.706%209.30933%2071.2147%209.188%2071.812%209.188V10.504H71.476C70.048%2010.504%2069.334%2011.2787%2069.334%2012.828V17H68.06V9.328H69.334V10.574ZM80.3827%2012.87C80.3827%2013.1127%2080.3687%2013.3693%2080.3407%2013.64H74.2087C74.2554%2014.396%2074.512%2014.9887%2074.9787%2015.418C75.4547%2015.838%2076.0287%2016.048%2076.7007%2016.048C77.2514%2016.048%2077.7087%2015.922%2078.0727%2015.67C78.446%2015.4087%2078.7074%2015.0633%2078.8567%2014.634H80.2287C80.0234%2015.3713%2079.6127%2015.9733%2078.9967%2016.44C78.3807%2016.8973%2077.6154%2017.126%2076.7007%2017.126C75.9727%2017.126%2075.3194%2016.9627%2074.7407%2016.636C74.1714%2016.3093%2073.7234%2015.8473%2073.3967%2015.25C73.07%2014.6433%2072.9067%2013.9433%2072.9067%2013.15C72.9067%2012.3567%2073.0654%2011.6613%2073.3827%2011.064C73.7%2010.4667%2074.1434%2010.0093%2074.7127%209.692C75.2914%209.36533%2075.954%209.202%2076.7007%209.202C77.4287%209.202%2078.0727%209.36067%2078.6327%209.678C79.1927%209.99533%2079.622%2010.434%2079.9207%2010.994C80.2287%2011.5447%2080.3827%2012.17%2080.3827%2012.87ZM79.0667%2012.604C79.0667%2012.1187%2078.9594%2011.7033%2078.7447%2011.358C78.53%2011.0033%2078.236%2010.7373%2077.8627%2010.56C77.4987%2010.3733%2077.0927%2010.28%2076.6447%2010.28C76.0007%2010.28%2075.45%2010.4853%2074.9927%2010.896C74.5447%2011.3067%2074.288%2011.876%2074.2227%2012.604H79.0667ZM81.6883%2013.136C81.6883%2012.352%2081.847%2011.666%2082.1643%2011.078C82.4817%2010.4807%2082.9157%2010.0187%2083.4663%209.692C84.0263%209.36533%2084.6517%209.202%2085.3423%209.202C85.9397%209.202%2086.495%209.342%2087.0083%209.622C87.5217%209.89267%2087.9137%2010.252%2088.1843%2010.7V6.64H89.4723V17H88.1843V15.558C87.9323%2016.0153%2087.559%2016.3933%2087.0643%2016.692C86.5697%2016.9813%2085.991%2017.126%2085.3283%2017.126C84.647%2017.126%2084.0263%2016.958%2083.4663%2016.622C82.9157%2016.286%2082.4817%2015.8147%2082.1643%2015.208C81.847%2014.6013%2081.6883%2013.9107%2081.6883%2013.136ZM88.1843%2013.15C88.1843%2012.5713%2088.0677%2012.0673%2087.8343%2011.638C87.601%2011.2087%2087.2837%2010.882%2086.8823%2010.658C86.4903%2010.4247%2086.0563%2010.308%2085.5803%2010.308C85.1043%2010.308%2084.6703%2010.42%2084.2783%2010.644C83.8863%2010.868%2083.5737%2011.1947%2083.3403%2011.624C83.107%2012.0533%2082.9903%2012.5573%2082.9903%2013.136C82.9903%2013.724%2083.107%2014.2373%2083.3403%2014.676C83.5737%2015.1053%2083.8863%2015.4367%2084.2783%2015.67C84.6703%2015.894%2085.1043%2016.006%2085.5803%2016.006C86.0563%2016.006%2086.4903%2015.894%2086.8823%2015.67C87.2837%2015.4367%2087.601%2015.1053%2087.8343%2014.676C88.0677%2014.2373%2088.1843%2013.7287%2088.1843%2013.15ZM96.8317%2010.756C97.093%2010.2987%2097.4757%209.92533%2097.9797%209.636C98.4837%209.34667%2099.0577%209.202%2099.7017%209.202C100.392%209.202%20101.013%209.36533%20101.564%209.692C102.114%2010.0187%20102.548%2010.4807%20102.866%2011.078C103.183%2011.666%20103.342%2012.352%20103.342%2013.136C103.342%2013.9107%20103.183%2014.6013%20102.866%2015.208C102.548%2015.8147%20102.11%2016.286%20101.55%2016.622C100.999%2016.958%20100.383%2017.126%2099.7017%2017.126C99.039%2017.126%2098.4557%2016.9813%2097.9517%2016.692C97.457%2016.4027%2097.0837%2016.034%2096.8317%2015.586V17H95.5577V6.64H96.8317V10.756ZM102.04%2013.136C102.04%2012.5573%20101.923%2012.0533%20101.69%2011.624C101.456%2011.1947%20101.139%2010.868%20100.738%2010.644C100.346%2010.42%2099.9117%2010.308%2099.4357%2010.308C98.969%2010.308%2098.535%2010.4247%2098.1337%2010.658C97.7417%2010.882%2097.4244%2011.2133%2097.1817%2011.652C96.9484%2012.0813%2096.8317%2012.5807%2096.8317%2013.15C96.8317%2013.7287%2096.9484%2014.2373%2097.1817%2014.676C97.4244%2015.1053%2097.7417%2015.4367%2098.1337%2015.67C98.535%2015.894%2098.969%2016.006%2099.4357%2016.006C99.9117%2016.006%20100.346%2015.894%20100.738%2015.67C101.139%2015.4367%20101.456%2015.1053%20101.69%2014.676C101.923%2014.2373%20102.04%2013.724%20102.04%2013.136ZM111.727%209.328L107.107%2020.612H105.791L107.303%2016.916L104.209%209.328H105.623L108.031%2015.544L110.411%209.328H111.727Z'%20fill='%23001A35'/%3e%3cg%20id='ARIES-logo'%3e%3cg%20id='Group_2'%3e%3cpath%20id='Vector_4'%20opacity='0.979'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M161.235%205.05044C162.697%204.8775%20164.065%205.14926%20165.339%205.86573C166.39%206.60954%20166.952%207.631%20167.026%208.93008C165.996%208.93008%20164.964%208.93008%20163.934%208.93008C163.821%208.03902%20163.315%207.5236%20162.416%207.38385C161.558%207.19671%20160.874%207.44973%20160.363%208.14291C160.028%208.99224%20160.244%209.6576%20161.01%2010.139C161.197%2010.2327%20161.385%2010.3264%20161.572%2010.4201C162.488%2010.7287%20163.406%2011.0285%20164.327%2011.3197C166.729%2012.1399%20167.6%2013.7799%20166.942%2016.2395C166.321%2017.6661%20165.243%2018.5376%20163.709%2018.8541C161.903%2019.2187%20160.235%2018.9001%20158.705%2017.8982C157.743%2017.1268%20157.274%2016.1241%20157.299%2014.8901C158.293%2014.8901%20159.286%2014.8901%20160.279%2014.8901C160.336%2015.8933%20160.86%2016.4837%20161.853%2016.6612C162.708%2016.8199%20163.429%2016.5857%20164.018%2015.9584C164.456%2015.1552%20164.334%2014.4524%20163.653%2013.8499C163.434%2013.675%20163.19%2013.5438%20162.922%2013.4563C161.984%2013.1565%20161.048%2012.8566%20160.11%2012.5567C157.703%2011.7071%20156.851%2010.0484%20157.552%207.58064C158.099%206.35981%20159.027%205.58201%20160.335%205.24724C160.642%205.17668%20160.942%205.11108%20161.235%205.05044Z'%20fill='%23001A35'/%3e%3c/g%3e%3cg%20id='Group_3'%3e%3cpath%20id='Vector_5'%20opacity='0.987'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M131.21%205.21885C133.103%205.20947%20134.996%205.21885%20136.889%205.24696C138.458%205.29541%20139.704%205.94201%20140.628%207.18678C141.281%208.38984%20141.393%209.64557%20140.965%2010.954C140.43%2012.2108%20139.502%2013.0167%20138.182%2013.3717C139.258%2015.1757%20140.326%2016.9843%20141.387%2018.7976C140.319%2018.8351%20139.25%2018.8351%20138.182%2018.7976C137.196%2017.0593%20136.202%2015.3257%20135.202%2013.5966C134.792%2013.5406%20134.379%2013.5218%20133.965%2013.5404C133.965%2015.3021%20133.965%2017.0639%20133.965%2018.8257C133.047%2018.8257%20132.128%2018.8257%20131.21%2018.8257C131.21%2014.2901%20131.21%209.75448%20131.21%205.21885ZM133.965%207.52414C134.828%207.51477%20135.69%207.52415%20136.551%207.55225C137.733%207.65667%20138.352%208.30327%20138.407%209.49207C138.373%2010.6036%20137.81%2011.2502%20136.72%2011.4319C135.802%2011.46%20134.884%2011.4694%20133.965%2011.46C133.965%2010.1481%20133.965%208.83609%20133.965%207.52414Z'%20fill='%23001A35'/%3e%3c/g%3e%3cg%20id='Group_4'%3e%3cpath%20id='Vector_6'%20opacity='0.968'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M143.128%205.21924C144.065%205.21924%20145.002%205.21924%20145.939%205.21924C145.939%209.75487%20145.939%2014.2905%20145.939%2018.8261C145.002%2018.8261%20144.065%2018.8261%20143.128%2018.8261C143.128%2014.2905%20143.128%209.75487%20143.128%205.21924Z'%20fill='%23001A35'/%3e%3c/g%3e%3cg%20id='Group_5'%3e%3cpath%20id='Vector_7'%20opacity='0.988'%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M148.021%205.21924C150.663%205.21924%20153.306%205.21924%20155.948%205.21924C155.948%205.96892%20155.948%206.71862%20155.948%207.4683C154.224%207.4683%20152.5%207.4683%20150.776%207.4683C150.776%208.59284%20150.776%209.71737%20150.776%2010.8419C152.294%2010.8419%20153.812%2010.8419%20155.33%2010.8419C155.33%2011.5728%20155.33%2012.3038%20155.33%2013.0347C153.812%2013.0347%20152.294%2013.0347%20150.776%2013.0347C150.776%2014.2155%20150.776%2015.3963%20150.776%2016.577C152.5%2016.577%20154.224%2016.577%20155.948%2016.577C155.948%2017.3267%20155.948%2018.0764%20155.948%2018.8261C153.306%2018.8261%20150.663%2018.8261%20148.021%2018.8261C148.021%2014.2905%20148.021%209.75487%20148.021%205.21924Z'%20fill='%23001A35'/%3e%3c/g%3e%3cpath%20id='Vector_8'%20d='M125.93%2016.2595H120.677L119.784%2018.85H117L121.727%205.25H124.826L129.554%2018.85H126.77L125.877%2016.2595H125.93ZM125.247%2014.1008L123.356%208.43413L121.465%2014.1008H125.299H125.247Z'%20fill='%23031C37'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", ds = {
  "ns-aries-card": "_ns-aries-card_7uxe1_1",
  "ns-aries-card__header": "_ns-aries-card__header_7uxe1_16",
  "ns-aries-card__body": "_ns-aries-card__body_7uxe1_33",
  "ns-aries-card__footer": "_ns-aries-card__footer_7uxe1_42"
};
function Z1({ actions: e, "aria-label": t, children: n, tags: i, onAction: r }) {
  const s = X({
    [ds["ns-aries-card"]]: !0
  }), o = X({
    [ds["ns-aries-card__header"]]: !0
  }), l = X({
    [ds["ns-aries-card__body"]]: !0
  }), u = X({
    [ds["ns-aries-card__footer"]]: !0
  }), c = (d) => {
    r?.(d);
  };
  return /* @__PURE__ */ F("section", { className: s, "aria-label": t, children: [
    /* @__PURE__ */ F("header", { className: o, children: [
      /* @__PURE__ */ g("img", { src: W1, alt: "ARIES logo", "aria-hidden": "true" }),
      /* @__PURE__ */ g("div", { children: i?.map((d) => /* @__PURE__ */ g(Gn, { ...d }, d.id)) })
    ] }),
    /* @__PURE__ */ g("div", { className: l, children: n }),
    e?.length ? /* @__PURE__ */ g("footer", { className: u, children: e.map((d) => /* @__PURE__ */ g(Ze, { ...d, onClick: () => c(d) }, d.name)) }) : null
  ] });
}
const fa = {
  "ns-aries-infocard": "_ns-aries-infocard_ukfbi_1",
  "ns-aries-infocard__heading": "_ns-aries-infocard__heading_ukfbi_27",
  "ns-aries-infocard__body": "_ns-aries-infocard__body_ukfbi_56"
};
function X1({ "aria-label": e, heading: t, icon: n, instructions: i }) {
  const r = X({
    [fa["ns-aries-infocard"]]: !0
  }), s = X({
    [fa["ns-aries-infocard__heading"]]: !0
  }), o = X({
    [fa["ns-aries-infocard__body"]]: !0
  });
  return /* @__PURE__ */ F("section", { className: r, "aria-label": e, children: [
    /* @__PURE__ */ F("header", { className: s, children: [
      n && /* @__PURE__ */ g(be, { name: q.ARIES }),
      " ",
      t
    ] }),
    /* @__PURE__ */ g("ol", { className: o, children: i.map((l, u) => /* @__PURE__ */ F("li", { children: [
      /* @__PURE__ */ g("strong", { children: l.text }),
      " ",
      l.subtext
    ] }, l.id ?? `instruction-${u}`)) })
  ] });
}
const St = {
  "ds-input": "_ds-input_1kuia_1",
  "ds-input__label": "_ds-input__label_1kuia_11",
  "ds-input__label-counter": "_ds-input__label-counter_1kuia_16",
  "ds-input__wrapper": "_ds-input__wrapper_1kuia_19",
  "ds-input__prefix": "_ds-input__prefix_1kuia_39",
  "ds-input__suffix": "_ds-input__suffix_1kuia_39",
  "ds-input__suffix-btn": "_ds-input__suffix-btn_1kuia_52",
  "ds-input__icon": "_ds-input__icon_1kuia_58",
  "ds-input__field": "_ds-input__field_1kuia_63",
  "ds-input__hint": "_ds-input__hint_1kuia_96",
  "ds-input__hint-icon": "_ds-input__hint-icon_1kuia_108",
  "ds-input__hint-text": "_ds-input__hint-text_1kuia_114",
  "ds-input__message": "_ds-input__message_1kuia_117",
  "ds-input--status-error": "_ds-input--status-error_1kuia_128",
  "ds-input--status-success": "_ds-input--status-success_1kuia_135",
  "ds-input--status-warning": "_ds-input--status-warning_1kuia_142",
  "ds-input--disabled": "_ds-input--disabled_1kuia_149",
  "ds-input--readonly": "_ds-input--readonly_1kuia_167"
};
var G1 = /* @__PURE__ */ ((e) => (e.Text = "text", e.Email = "email", e.Password = "password", e.Search = "search", e.URL = "url", e.Tel = "tel", e))(G1 || {}), lo = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Success = "success", e.Warning = "warning", e))(lo || {}), uo = /* @__PURE__ */ ((e) => (e.Characters = "characters", e.Words = "words", e))(uo || {});
const K1 = (...e) => e.filter(Boolean).join(" "), Y1 = (e) => {
  const {
    ref: t,
    id: n,
    name: i,
    label: r,
    required: s = !1,
    readOnly: o = !1,
    disabled: l = !1,
    status: u = lo.Default,
    size: c = lt.Medium,
    prefix: d,
    suffix: h,
    counterMode: m,
    maxCount: _,
    hintIcon: y,
    hint: v,
    message: w,
    value: x,
    defaultValue: A,
    onChange: S,
    onSuffixClick: N,
    suffixAriaLabel: E = "Submit",
    className: f,
    placeholder: C = "Get started...",
    ...L
  } = e, R = rt(), V = n ?? R, z = `${V}-hint`, $ = `${V}-message`, H = x !== void 0, [B, O] = Ee(A ?? ""), W = H ? x : B, G = ee(null), re = sr(G, t), K = (ne) => {
    H || O(ne.target.value), S?.(ne);
  }, oe = m ? m === uo.Words ? W.trim() === "" ? 0 : W.trim().split(/\s+/).length : W.length : 0, se = h, D = N, pe = !!r, Ce = !!m, Z = !!v, j = !!w, ie = d !== void 0, te = se !== void 0, ge = u === lo.Error;
  return /* @__PURE__ */ F(
    "fieldset",
    {
      className: K1(
        St["ds-input"],
        St[`ds-input--size-${c}`],
        St[`ds-input--status-${u}`],
        l && St["ds-input--disabled"],
        o && St["ds-input--readonly"],
        f
      ),
      children: [
        pe && /* @__PURE__ */ F("label", { className: St["ds-input__label"], htmlFor: V, children: [
          /* @__PURE__ */ F("span", { className: St["ds-input__label-text"], children: [
            r,
            s && /* The asterisk is presentational; aria-required on <input>
            * conveys the requirement to assistive technology. */
            /* @__PURE__ */ g("span", { className: St["ds-input__label-required"], "aria-hidden": "true", children: " *" })
          ] }),
          Ce && /* @__PURE__ */ g(
            "span",
            {
              className: St["ds-input__label-counter"],
              role: "status",
              "aria-live": "polite",
              "aria-label": `${oe} ${m === uo.Words ? "words" : "characters"}` + (_ ? ` out of ${_}` : ""),
              children: _ ? `${oe} / ${_}` : `${oe}`
            }
          )
        ] }),
        /* @__PURE__ */ F("div", { className: St["ds-input__wrapper"], children: [
          ie && /* @__PURE__ */ g("span", { className: St["ds-input__prefix"], children: /* @__PURE__ */ g(be, { className: St["ds-input__icon"], "aria-hidden": "true", name: d }) }),
          /* @__PURE__ */ g(
            "input",
            {
              ref: re,
              id: V,
              name: i,
              className: St["ds-input__field"],
              ...H ? { value: x } : { defaultValue: A },
              disabled: l,
              readOnly: o,
              required: s,
              "aria-required": s || void 0,
              "aria-invalid": ge || void 0,
              "aria-describedby": Z ? z : void 0,
              placeholder: C,
              onChange: K,
              ...L
            }
          ),
          te && D ? (
            // Interactive suffix: wrapped in a native <button> for full keyboard + AT support.
            /* @__PURE__ */ g(
              Ze,
              {
                type: "submit",
                color: Le.Primary,
                variant: Ye.Contained,
                size: lt.Medium,
                className: St["ds-input__suffix-btn"],
                onClick: D,
                disabled: l,
                tabIndex: l ? -1 : 0,
                icon: se,
                isIconOnly: !0,
                label: E
              }
            )
          ) : (
            // Decorative static suffix icon
            /* @__PURE__ */ g(be, { className: St["ds-input__icon"], "aria-hidden": "true", name: se })
          )
        ] }),
        Z && /* @__PURE__ */ F(
          "p",
          {
            id: z,
            className: St["ds-input__hint"],
            role: ge ? "alert" : void 0,
            "aria-live": ge ? void 0 : "polite",
            children: [
              y && /* @__PURE__ */ g(be, { className: St["ds-input__hint-icon"], "aria-hidden": "true", name: y }),
              /* @__PURE__ */ g("span", { className: St["ds-input__hint-text"], children: v })
            ]
          }
        ),
        j && /* @__PURE__ */ g(
          "p",
          {
            id: $,
            className: St["ds-input__message"],
            role: "alert",
            "aria-live": "polite",
            children: w
          }
        )
      ]
    }
  );
}, Hi = {
  "error-boundary": "_error-boundary_e2ts8_1",
  "error-boundary__icon": "_error-boundary__icon_e2ts8_16",
  "error-boundary__content": "_error-boundary__content_e2ts8_30",
  "error-boundary__title": "_error-boundary__title_e2ts8_34",
  "error-boundary__message": "_error-boundary__message_e2ts8_40",
  "error-boundary__action": "_error-boundary__action_e2ts8_45"
};
class Q1 extends Ur.Component {
  constructor() {
    super(...arguments);
    Jl(this, "state", {
      error: null,
      componentStack: void 0,
      timestamp: void 0
    });
  }
  /**
   * Derives state from the thrown error.
   *
   * React calls this method when a descendant throws during render.
   *
   * @param error - The thrown error instance.
   * @returns Partial state update that stores the error.
   *
   * @internal
   */
  static getDerivedStateFromError(n) {
    return {
      error: n,
      timestamp: /* @__PURE__ */ new Date()
    };
  }
  /**
   * Lifecycle hook where side-effects for captured errors can be executed.
   *
   * @param error - The thrown error instance.
   * @param info - React error info with component stack.
   *
   * @internal
   */
  componentDidCatch(n, i) {
    const { onErrorCaptured: r, name: s } = this.props;
    if (this.setState({
      componentStack: i.componentStack
    }), typeof r == "function") {
      const o = {
        ...i,
        boundaryName: s
      };
      try {
        r(n, o);
      } catch {
        process.env.NODE_ENV !== "production" && console.warn("[ErrorBoundary] onErrorCaptured handler threw an error. Swallowing to avoid cascade.");
      }
    }
  }
  /**
   * Resets the boundary back to a "clean" state.
   *
   * @remarks
   * Use this to allow the user to retry rendering, for example by wiring
   * it to a "Try again" button in the fallback UI.
   *
   * Note: If you use a custom {@link ErrorBoundaryProps.renderFallback},
   * you are responsible for calling this method via a ref.
   */
  reset() {
    this.setState({
      error: null,
      componentStack: void 0,
      timestamp: void 0
    });
  }
  /**
   * Handles reset-on-key-change logic.
   *
   * @param prevProps - Previous props before the update.
   *
   * @internal
   */
  componentDidUpdate(n) {
    const { enableResetOnKeyChange: i, resetKey: r } = this.props;
    i && n.resetKey !== r && this.state.error && this.reset();
  }
  /**
   * Renders either the children (no error) or the fallback UI.
   */
  render() {
    const { children: n, renderFallback: i } = this.props, { error: r, componentStack: s, timestamp: o } = this.state;
    if (!r)
      return n;
    const l = {
      error: r,
      componentStack: s,
      timestamp: o ?? /* @__PURE__ */ new Date()
    };
    return typeof i == "function" ? i(l) : /* @__PURE__ */ F("div", { className: Hi["error-boundary"], role: "alert", "aria-live": "assertive", children: [
      /* @__PURE__ */ g("div", { className: Hi["error-boundary__icon"], "aria-hidden": "true", children: "!" }),
      /* @__PURE__ */ F("div", { className: Hi["error-boundary__content"], children: [
        /* @__PURE__ */ g("h1", { className: Hi["error-boundary__title"], children: "Something went wrong" }),
        /* @__PURE__ */ g("p", { className: Hi["error-boundary__message"], children: "An unexpected error occurred while rendering this section of the application." }),
        /* @__PURE__ */ g("button", { type: "button", className: Hi["error-boundary__action"], onClick: () => this.reset(), children: "Try again" })
      ] })
    ] });
  }
}
const vt = {
  "ns-card": "_ns-card_1k7gv_11",
  "ns-card--variant-secondary": "_ns-card--variant-secondary_1k7gv_22",
  "ns-card__body": "_ns-card__body_1k7gv_27",
  "ns-card__heading": "_ns-card__heading_1k7gv_31",
  "ns-card__icon": "_ns-card__icon_1k7gv_42",
  "ns-card__heading-text": "_ns-card__heading-text_1k7gv_50",
  "ns-card__subheading": "_ns-card__subheading_1k7gv_56",
  "ns-card__toggle": "_ns-card__toggle_1k7gv_75",
  "ns-card-content-in": "_ns-card-content-in_1k7gv_1",
  "ns-card__header-actions": "_ns-card__header-actions_1k7gv_105",
  "ns-card__tags": "_ns-card__tags_1k7gv_117",
  "ns-card__tags--position-left": "_ns-card__tags--position-left_1k7gv_125",
  "ns-card__tags--position-right": "_ns-card__tags--position-right_1k7gv_128",
  "ns-card__tags--position-center": "_ns-card__tags--position-center_1k7gv_131",
  "ns-card__body--hidden": "_ns-card__body--hidden_1k7gv_143",
  "ns-card__footer": "_ns-card__footer_1k7gv_147",
  "ns-card__footer--stretch": "_ns-card__footer--stretch_1k7gv_151",
  "ns-card__footer--hidden": "_ns-card__footer--hidden_1k7gv_154"
};
var co = /* @__PURE__ */ ((e) => (e.Default = "default", e.Secondary = "secondary", e))(co || {});
function em({
  "aria-label": e,
  variant: t = co.Default,
  heading: n,
  subheading: i,
  headingContent: r,
  icon: s,
  actions: o,
  headerActions: l,
  headerControl: u,
  onAction: c,
  children: d,
  stretch: h = !1,
  tags: m,
  tagsContent: _,
  tagPosition: y = "left",
  open: v,
  defaultOpen: w = !0,
  onOpenChange: x,
  fullCardDisclosure: A = !1
}) {
  const [S, N] = Yt(v, w, x), E = v !== void 0, f = !r || !A || S, C = X({
    [vt["ns-card"]]: !0,
    [vt[`ns-card--variant-${t}`]]: t !== co.Default
  }), L = X({
    [vt["ns-card__heading"]]: !0
  }), R = X({
    [vt["ns-card__body"]]: !0,
    [vt["ns-card__body--hidden"]]: !f
  }), V = X({
    [vt["ns-card__footer"]]: !0,
    [vt["ns-card__footer--stretch"]]: h,
    [vt["ns-card__footer--hidden"]]: !f
  }), z = X({
    [vt["ns-card__tags"]]: !0,
    [vt[`ns-card__tags--position-${y}`]]: !0
  }), $ = (B) => {
    c?.(B);
  }, H = () => l?.length || u != null ? /* @__PURE__ */ F(
    "div",
    {
      className: vt["ns-card__header-actions"],
      role: "presentation",
      onClick: (B) => {
        B.stopPropagation();
      },
      onKeyDown: (B) => {
        B.stopPropagation();
      },
      children: [
        l?.map((B) => /* @__PURE__ */ g(
          Ze,
          {
            ...B,
            onClick: (O) => {
              O.preventDefault(), O.stopPropagation(), $(B);
            }
          },
          B.name
        )),
        u
      ]
    }
  ) : null;
  return /* @__PURE__ */ F("section", { className: C, "aria-label": e, children: [
    /* @__PURE__ */ F("header", { className: L, children: [
      !r && /* @__PURE__ */ F(et, { children: [
        s && /* @__PURE__ */ g(be, { name: s, className: vt["ns-card__icon"] }),
        /* @__PURE__ */ F("div", { className: vt["ns-card__heading-text"], children: [
          /* @__PURE__ */ g("span", { className: vt["ns-card__title"], children: n }),
          i && /* @__PURE__ */ g("span", { className: vt["ns-card__subheading"], children: i })
        ] }),
        /* @__PURE__ */ F("div", { className: z, children: [
          m?.map((B) => /* @__PURE__ */ g(Gn, { ...B }, B.id)),
          _
        ] }),
        H()
      ] }),
      r && /* @__PURE__ */ F(
        "details",
        {
          open: S,
          onToggle: (B) => {
            const O = B.currentTarget, W = O.open;
            E && (O.open = v), N(W);
          },
          children: [
            /* @__PURE__ */ F("summary", { children: [
              s && /* @__PURE__ */ g(be, { name: s, className: vt["ns-card__icon"] }),
              /* @__PURE__ */ F("div", { className: vt["ns-card__heading-text"], children: [
                /* @__PURE__ */ g("span", { className: vt["ns-card__title"], children: n }),
                i && /* @__PURE__ */ g("span", { className: vt["ns-card__subheading"], children: i })
              ] }),
              /* @__PURE__ */ F("div", { className: z, children: [
                m?.map((B) => /* @__PURE__ */ g(Gn, { ...B }, B.id)),
                _
              ] }),
              H(),
              /* @__PURE__ */ g("span", { className: vt["ns-card__toggle"], children: /* @__PURE__ */ g(be, { name: q.KeyboardArrowDown, size: 24 }) })
            ] }),
            /* @__PURE__ */ g("div", { children: r })
          ]
        }
      )
    ] }),
    d != null && /* @__PURE__ */ g("div", { className: R, children: d }),
    o?.length ? /* @__PURE__ */ g("footer", { className: V, children: o.map((B) => /* @__PURE__ */ g(Ze, { ...B, onClick: () => $(B) }, B.name)) }) : null
  ] });
}
const Pt = {
  "ns-drawer-overlay": "_ns-drawer-overlay_d059m_1",
  "ns-drawer-overlay--open": "_ns-drawer-overlay--open_d059m_10",
  "ns-drawer": "_ns-drawer_d059m_1",
  "ns-drawer--open": "_ns-drawer--open_d059m_40",
  "ns-drawer--expanded": "_ns-drawer--expanded_d059m_43",
  "ns-drawer__expand": "_ns-drawer__expand_d059m_53",
  "ns-drawer__header": "_ns-drawer__header_d059m_62",
  "ns-drawer__title": "_ns-drawer__title_d059m_71",
  "ns-drawer__tablist": "_ns-drawer__tablist_d059m_81",
  "ns-drawer__header-actions": "_ns-drawer__header-actions_d059m_93",
  "ns-drawer__close": "_ns-drawer__close_d059m_99",
  "ns-drawer__body": "_ns-drawer__body_d059m_125",
  "ns-drawer__tabpanel": "_ns-drawer__tabpanel_d059m_133",
  "ns-drawer__footer": "_ns-drawer__footer_d059m_142",
  "ns-drawer__edge-tab": "_ns-drawer__edge-tab_d059m_159",
  "ns-drawer__edge-tab--hidden": "_ns-drawer__edge-tab--hidden_d059m_168"
}, Rd = ei(null);
function sk() {
  const e = Fn(Rd);
  if (e === null)
    throw new Error("useDrawer() must be used within <Drawer>");
  return e;
}
function tm({ drawerId: e, config: t, isOpen: n, onOpen: i }) {
  const r = t.count ?? 0, s = r > 0, o = t.label ?? (s ? `${t.text}, ${r}` : t.text);
  return /* @__PURE__ */ g(
    Ze,
    {
      className: X(Pt["ns-drawer__edge-tab"], n && Pt["ns-drawer__edge-tab--hidden"]),
      variant: Ye.Contained,
      color: Le.Primary,
      size: lt.Large,
      orientation: Is.Vertical,
      text: t.text,
      badge: s ? r : void 0,
      "aria-label": o,
      "aria-haspopup": "dialog",
      "aria-controls": e,
      "aria-hidden": n || void 0,
      inert: n || void 0,
      onClick: i
    }
  );
}
const hu = "ds-drawer-layer", nm = () => {
};
function im(e) {
  const {
    id: t,
    isOpen: n,
    onClose: i,
    actions: r,
    onAction: s,
    closeOnBackdropClick: o = !0,
    closeOnEscape: l = !0,
    lockBodyScroll: u = !1,
    transitionDuration: c = "250ms",
    transitionEasing: d = "ease-in-out",
    "aria-label": h,
    modal: m = !0,
    expandable: _ = !1,
    isExpanded: y,
    defaultExpanded: v = !1,
    onExpandedChange: w,
    headerActions: x,
    onHeaderAction: A,
    edgeTab: S,
    onOpen: N,
    title: E,
    children: f,
    tabs: C,
    activeTab: L,
    defaultTab: R,
    onTabChange: V
  } = e, {
    panelRef: z,
    panel: $,
    handleBackdropClick: H,
    handleActionClick: B
  } = jo({
    isOpen: n,
    onClose: i,
    onAction: s,
    closeOnBackdropClick: o,
    closeOnEscape: l,
    lockBodyScroll: u,
    modal: m
  }), [O, W] = Yt(
    y,
    v,
    w
  ), G = _ && O, re = $e(
    () => ({
      isOpen: n,
      isExpanded: G,
      expandable: _,
      expand: () => W(!0),
      collapse: () => W(!1),
      close: i
    }),
    [n, G, _, W, i]
  ), K = (x?.length ?? 0) > 0, P = C !== void 0, oe = G ? "Collapse drawer" : "Expand drawer", se = X(Pt["ns-drawer-overlay"], n && Pt["ns-drawer-overlay--open"]), D = X(
    Pt["ns-drawer"],
    n && Pt["ns-drawer--open"],
    G && Pt["ns-drawer--expanded"],
    !m && Pt["ns-drawer--non-modal"]
  ), Ce = /* @__PURE__ */ F("div", { style: {
    "--ns-drawer-transition-duration": c,
    "--ns-drawer-transition-easing": d
  }, children: [
    m && /* @__PURE__ */ g("div", { className: se, onClick: H, "aria-hidden": "true" }),
    S && /* @__PURE__ */ g(tm, { drawerId: t, config: S, isOpen: n, onOpen: N }),
    /* @__PURE__ */ F(
      "div",
      {
        ref: z,
        id: t,
        role: "dialog",
        "aria-modal": m && n ? "true" : void 0,
        "aria-label": h ?? E,
        "aria-labelledby": P ? void 0 : `${t}-title`,
        "aria-hidden": !n || void 0,
        inert: !n || void 0,
        tabIndex: -1,
        className: D,
        children: [
          /* @__PURE__ */ F("header", { className: Pt["ns-drawer__header"], children: [
            P ? /* @__PURE__ */ g(j1, { className: Pt["ns-drawer__tablist"], "aria-label": h, children: C.map((j) => /* @__PURE__ */ g(
              H1,
              {
                value: j.id,
                badge: j.count !== void 0 && j.count > 0 ? j.count : void 0,
                disabled: j.disabled,
                children: j.label
              },
              j.id
            )) }) : /* @__PURE__ */ g("h6", { id: `${t}-title`, className: Pt["ns-drawer__title"], children: E }),
            (K || _) && /* @__PURE__ */ F("div", { className: Pt["ns-drawer__header-actions"], children: [
              x?.map((j) => /* @__PURE__ */ g(
                Ze,
                {
                  isIconOnly: !0,
                  variant: Ye.Text,
                  color: Le.Secondary,
                  size: lt.Medium,
                  ...j,
                  onClick: () => A?.(j)
                },
                j.name
              )),
              _ && /* @__PURE__ */ g(
                "button",
                {
                  type: "button",
                  className: Pt["ns-drawer__expand"],
                  "aria-expanded": G,
                  "aria-label": oe,
                  onClick: () => W(!G),
                  children: /* @__PURE__ */ g(be, { name: G ? q.CloseFullscreen : q.OpenInFull, "aria-hidden": !0 })
                }
              )
            ] }),
            /* @__PURE__ */ g(
              "button",
              {
                type: "button",
                className: Pt["ns-drawer__close"],
                "aria-label": "Close drawer",
                onClick: i,
                children: /* @__PURE__ */ g(be, { name: q.Close, "aria-hidden": !0 })
              }
            )
          ] }),
          /* @__PURE__ */ g("div", { className: Pt["ns-drawer__body"], children: /* @__PURE__ */ g(zo.Provider, { value: $, children: /* @__PURE__ */ g(Rd.Provider, { value: re, children: P ? C.map((j) => /* @__PURE__ */ g(U1, { value: j.id, className: Pt["ns-drawer__tabpanel"], children: j.content }, j.id)) : f }) }) }),
          r?.length ? /* @__PURE__ */ g("footer", { className: Pt["ns-drawer__footer"], children: r.map((j) => /* @__PURE__ */ g(Ze, { ...j, onClick: () => B(j) }, j.name)) }) : null
        ]
      }
    )
  ] });
  if (!P)
    return hi(Ce, pi(hu));
  const Z = L === void 0 ? { defaultValue: R ?? C[0]?.id ?? "", onChange: V, children: Ce } : { value: L, onChange: V ?? nm, children: Ce };
  return hi(/* @__PURE__ */ g(B1, { id: `${t}-tabs`, ...Z }), pi(hu));
}
const ki = {
  "ns-entity-editor": "_ns-entity-editor_13tza_1",
  "ns-entity-editor__form": "_ns-entity-editor__form_13tza_8",
  "ns-entity-editor__columns": "_ns-entity-editor__columns_13tza_26",
  "ns-entity-editor__column": "_ns-entity-editor__column_13tza_26",
  "ns-entity-editor__footer": "_ns-entity-editor__footer_13tza_40",
  "ns-entity-editor__separator": "_ns-entity-editor__separator_13tza_55"
};
function Od(e, t) {
  return e.length < t ? `Must be at least ${t} character${t === 1 ? "" : "s"}` : null;
}
function hs(e) {
  const [t, n] = e.split(":").map(Number);
  return (t ?? 0) * 60 + (n ?? 0);
}
function pu(e) {
  const [t, n, i] = e.split("-");
  return `${n}/${i}/${t}`;
}
const rm = /^\d{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12]\d|3[01])$/;
function sm(e, t) {
  return rm.test(t) ? e.minDate && t < e.minDate ? `Date must be on or after ${pu(e.minDate)}` : e.maxDate && t > e.maxDate ? `Date must be on or before ${pu(e.maxDate)}` : null : "Please enter a valid date (MM/DD/YYYY)";
}
function am(e, t) {
  return ad.test(t) ? e.minLength !== void 0 ? Od(t, e.minLength) : null : od;
}
function om(e, t) {
  const n = typeof t == "string" ? Number(t) : t;
  return Number.isNaN(n) ? "Please enter a valid number" : e.min !== void 0 && n < e.min ? `Value must be at least ${e.min}` : e.max !== void 0 && n > e.max ? `Value must be at most ${e.max}` : null;
}
function fu(e, t) {
  return e.minLength !== void 0 ? Od(t, e.minLength) : null;
}
const lm = /^([01]\d|2[0-3]):[0-5]\d$/;
function um(e, t) {
  return lm.test(t) ? e.minTime && hs(t) < hs(e.minTime) ? `Time must be at or after ${e.minTime}` : e.maxTime && hs(t) > hs(e.maxTime) ? `Time must be at or before ${e.maxTime}` : null : "Please enter a valid time";
}
function cm(e, t) {
  if (typeof t != "string")
    return null;
  switch (e.type) {
    case dt.TextInput:
      return fu(e, t);
    case dt.EmailInput:
      return am(e, t);
    case dt.NumberInput:
      return om(e, t);
    case dt.PasswordInput:
      return fu(e, t);
    case dt.DatePicker:
      return sm(e, t);
    case dt.TimePicker:
      return um(e, t);
    default:
      return null;
  }
}
function dm(e) {
  if (!e.every((s) => "fields" in s))
    return e.map(
      (s) => "columns" in s && s.columns ? { columns: s.columns } : { isSeparator: !0 }
    );
  const i = [];
  let r = [];
  for (const s of e)
    s.isSeparator ? (r.length > 0 && (i.push({ columns: r }), r = []), i.push({ isSeparator: !0, isVisible: s.isVisible })) : r.push({ fields: s.fields, width: s.width });
  return r.length > 0 && i.push({ columns: r }), i;
}
function hm(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0;
}
function Ir(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ma(e, t, n = {}, i) {
  const r = /* @__PURE__ */ new Map();
  for (const s of e) {
    const o = t[s.key], l = hm(o);
    if (s.required && l) {
      r.set(s.key, s.errorHint ?? "This field is required");
      continue;
    }
    if (l)
      continue;
    const u = o === n[s.key], c = cm(s, o);
    if (c) {
      u || r.set(s.key, c);
      continue;
    }
    if (i) {
      const d = i(s, o, t);
      d && r.set(s.key, d);
    }
  }
  return r;
}
function pm(e, t) {
  const n = `${t.formId}-${String(e.key)}`, i = t.values[e.key], r = t.fieldErrors.get(e.key), s = r !== void 0, o = s ? Pe.Error : Pe.Default, l = s ? r : e.hint, u = typeof e.disabled == "function" ? e.disabled(t.values) : e.disabled, c = {
    id: n,
    name: String(e.key),
    label: e.label,
    description: e.description,
    hint: l,
    placeholder: e.placeholder,
    disabled: u,
    readOnly: e.readOnly,
    size: e.size,
    required: e.required,
    prefix: e.prefix,
    suffix: e.suffix,
    suffixCopy: e.suffixCopy,
    tooltip: e.tooltip,
    tooltipPlacement: e.tooltipPlacement,
    state: o
  };
  switch (e.type) {
    // -------------------------------------------------------------------------
    // Text-based inputs
    // -------------------------------------------------------------------------
    case dt.TextInput: {
      const d = e;
      return /* @__PURE__ */ g(
        Ki,
        {
          ...c,
          inputType: gt.Text,
          value: i ?? "",
          maxLength: d.maxLength,
          showCounter: d.showCounter,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    case dt.EmailInput: {
      const d = e;
      return /* @__PURE__ */ g(
        Ki,
        {
          ...c,
          inputType: gt.Email,
          value: i ?? "",
          maxLength: d.maxLength,
          showCounter: d.showCounter,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    case dt.NumberInput: {
      const d = e;
      return /* @__PURE__ */ g(
        Ki,
        {
          ...c,
          inputType: gt.Number,
          value: i ?? "",
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    case dt.PasswordInput: {
      const d = e;
      return /* @__PURE__ */ g(
        Ki,
        {
          ...c,
          revealable: !0,
          revealAriaLabel: d.revealAriaLabel,
          hideAriaLabel: d.hideAriaLabel,
          value: i ?? "",
          maxLength: d.maxLength,
          showCounter: d.showCounter,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    case dt.TextArea: {
      const d = e;
      return /* @__PURE__ */ g(
        E0,
        {
          id: n,
          name: String(d.key),
          label: d.label,
          description: d.description,
          hint: l,
          placeholder: d.placeholder,
          disabled: u,
          readOnly: d.readOnly,
          size: d.size,
          required: d.required,
          tooltip: d.tooltip,
          tooltipPlacement: d.tooltipPlacement,
          state: o,
          value: i ?? "",
          maxLength: d.maxLength,
          minLength: d.minLength,
          showCounter: d.showCounter,
          rows: d.rows,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    // -------------------------------------------------------------------------
    // Selection inputs
    // -------------------------------------------------------------------------
    case dt.Select: {
      const d = e;
      return /* @__PURE__ */ g(
        Oo,
        {
          ...c,
          options: Ir(d.options, t.values),
          value: i ?? null,
          emptyText: d.emptyText,
          popupPlacement: d.popupPlacement,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    case dt.MultiSelect: {
      const d = e;
      return /* @__PURE__ */ g(
        sd,
        {
          ...c,
          options: Ir(d.options, t.values),
          value: i ?? [],
          noOptionsText: d.noOptionsText,
          maxSelections: d.maxSelections,
          popupPlacement: d.popupPlacement,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    case dt.ComboBox: {
      const d = e;
      return /* @__PURE__ */ g(
        rd,
        {
          ...c,
          options: Ir(d.options, t.values),
          value: i ?? null,
          allowFreeInput: d.allowFreeInput,
          onFreeInput: (h) => {
            d.onFreeInput?.(h), t.onChange(d.key, h);
          },
          noOptionsText: d.noOptionsText,
          popupPlacement: d.popupPlacement,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    // -------------------------------------------------------------------------
    // Date / time inputs
    // -------------------------------------------------------------------------
    case dt.DatePicker: {
      const d = e;
      return /* @__PURE__ */ g(
        $o,
        {
          ...c,
          value: i ?? null,
          minDate: d.minDate,
          maxDate: d.maxDate,
          isDateDisabled: d.isDateDisabled,
          popupPlacement: d.popupPlacement,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    case dt.TimePicker: {
      const d = e;
      return /* @__PURE__ */ g(
        Ho,
        {
          ...c,
          value: i ?? null,
          minuteStep: d.minuteStep,
          minTime: d.minTime,
          maxTime: d.maxTime,
          popupPlacement: d.popupPlacement,
          onChange: (h) => t.onChange(d.key, h)
        }
      );
    }
    // -------------------------------------------------------------------------
    // Async entity input
    // -------------------------------------------------------------------------
    case dt.EntityPicker: {
      const d = e, h = d.kind ?? String(d.key);
      return /* @__PURE__ */ g(
        Uo,
        {
          ...c,
          value: i ?? null,
          onSearch: (m) => t.onSearch?.(h, m, d.endpoint) ?? Promise.resolve([]),
          getOptionLabel: (m) => d.labelAttribute != null && m != null ? String(m[d.labelAttribute]) : t.getEntityLabel?.(h, m) ?? String(m),
          loadingText: d.loadingText,
          noResultsText: d.noResultsText,
          minSearchLength: d.minSearchLength,
          debounceMs: d.debounceMs,
          popupPlacement: d.popupPlacement,
          onChange: (m) => {
            const _ = d.attributeAsValue != null && m != null ? m[d.attributeAsValue] : m;
            t.onChange(d.key, _);
          }
        }
      );
    }
    case dt.CheckboxGroup: {
      const d = e, h = Array.isArray(i) ? i : [], m = Ir(d.options, t.values);
      return /* @__PURE__ */ g(
        ti,
        {
          id: n,
          label: d.label,
          description: d.description,
          hint: c.hint,
          required: d.required,
          disabled: c.disabled,
          state: c.state,
          tooltip: d.tooltip,
          tooltipPlacement: d.tooltipPlacement,
          suffixCopy: d.suffixCopy,
          children: /* @__PURE__ */ g("div", { style: {
            display: "flex",
            flexDirection: "column",
            gap: "var(--ns-spacing-space-2)",
            paddingTop: "var(--ns-spacing-space-1)"
          }, children: m.map((_) => /* @__PURE__ */ g(
            ur,
            {
              id: `${n}-${_.id}`,
              label: _.label,
              checked: h.includes(_.value),
              disabled: c.disabled,
              onChange: (y) => {
                const v = y ? [...h, _.value] : h.filter((w) => w !== _.value);
                t.onChange(d.key, v);
              }
            },
            _.id
          )) })
        }
      );
    }
    case dt.Custom:
      return e.render({ values: t.values, onChange: t.onChange, disabled: u });
    case dt.RadioGroup: {
      const d = e, h = Ir(d.options, t.values).map((m) => ({
        value: m.value,
        label: m.label
      }));
      return /* @__PURE__ */ g(
        U0,
        {
          id: n,
          name: String(d.key),
          label: d.label,
          options: h,
          value: i ?? null,
          orientation: d.orientation,
          disabled: u,
          error: s,
          helperText: s ? r : d.hint,
          onChange: (m) => t.onChange(d.key, m)
        }
      );
    }
  }
}
function fm({
  "aria-label": e,
  bgcolor: t,
  entity: n,
  columns: i,
  onSave: r,
  onCancel: s,
  saveLabel: o = "Save",
  cancelLabel: l = "Cancel",
  validate: u,
  onSearch: c,
  getEntityLabel: d,
  instructions: h,
  transform: m,
  externalErrors: _,
  isSaving: y = !1
}) {
  const v = rt(), [w, x] = Ee(() => ({ ...n })), [A, S] = Ee(/* @__PURE__ */ new Map()), [N, E] = Ee(/* @__PURE__ */ new Map()), f = dm(i), C = f.flatMap(
    (se) => se.isSeparator ? [] : se.columns.flatMap(
      (D) => D.fields.filter(
        (pe) => pe.type !== dt.Separator && pe.type !== dt.Custom
      )
    )
  ), L = (se) => {
    const D = C.find((Z) => se.has(Z.key));
    if (!D)
      return;
    const pe = document.getElementById(`${v}-${String(D.key)}`), Ce = typeof window < "u" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === !0;
    pe?.scrollIntoView?.({ block: "center", behavior: Ce ? "auto" : "smooth" }), pe?.focus?.({ preventScroll: !0 });
  };
  me(() => {
    const se = new Map(
      Object.entries(_ ?? {}).filter(([, D]) => D != null)
    );
    E(se), se.size > 0 && L(new Set(se.keys()));
  }, [_]);
  const R = new Map(N);
  A.forEach((se, D) => R.set(D, se));
  const V = Array.from(/* @__PURE__ */ new Set([...Object.keys(n), ...Object.keys(w)])).some((se) => {
    const D = w[se], pe = n[se];
    return Array.isArray(D) && Array.isArray(pe) ? D.length !== pe.length || D.some((Ce, Z) => Ce !== pe[Z]) : D !== pe;
  }), z = ma(C, w, n, u).size === 0, $ = (se, D) => {
    x((Z) => {
      let j = { ...Z, [se]: D };
      if (m) {
        const ie = m(se, j);
        Object.keys(ie).length > 0 && (j = { ...j, ...ie });
      }
      return j;
    });
    const pe = C.find((Z) => Z.key === se), Ce = pe ? ma([pe], { ...w, [se]: D }, n, u).get(se) : void 0;
    S((Z) => {
      const j = new Map(Z);
      return Ce !== void 0 ? j.set(se, Ce) : j.delete(se), j;
    }), E((Z) => {
      if (!Z.has(se))
        return Z;
      const j = new Map(Z);
      return j.delete(se), j;
    });
  }, H = (se) => {
    se.preventDefault();
    const D = ma(C, w, void 0, u);
    if (D.size > 0) {
      S(D), L(new Set(D.keys()));
      return;
    }
    r({ ...n, ...w });
  }, B = () => {
    x({ ...n }), S(/* @__PURE__ */ new Map()), E(/* @__PURE__ */ new Map()), s?.();
  }, O = {
    formId: v,
    values: w,
    fieldErrors: R,
    onChange: $,
    onSearch: c,
    getEntityLabel: d
  }, W = X({ [ki["ns-entity-editor"]]: !0 }), G = X({ [ki["ns-entity-editor__form"]]: !0 }), re = X({ [ki["ns-entity-editor__columns"]]: !0 }), K = X({ [ki["ns-entity-editor__column"]]: !0 }), P = X({ [ki["ns-entity-editor__footer"]]: !0 });
  return /* @__PURE__ */ g("section", { className: W, "aria-label": e, children: /* @__PURE__ */ F(
    "form",
    {
      className: G,
      onSubmit: H,
      noValidate: !0,
      "aria-label": e,
      style: {
        backgroundColor: t ?? "inherit"
      },
      children: [
        h,
        f.map((se, D) => {
          if (se.isSeparator)
            return se.isVisible === !1 ? null : /* @__PURE__ */ g("hr", { className: ki["ns-entity-editor__separator"] }, `row-sep-${D}`);
          const pe = se.columns.map((Ce) => Ce.width ?? "1fr").join(" ");
          return /* @__PURE__ */ g(
            "div",
            {
              className: re,
              style: {
                "--ns-editor-grid-template": pe
              },
              children: se.columns.map((Ce, Z) => /* @__PURE__ */ g("div", { className: K, children: Ce.fields.map((j) => {
                if (j.type === dt.Separator)
                  return /* @__PURE__ */ g("hr", { className: ki["ns-entity-editor__separator"] }, j.id);
                const ie = j;
                return /* @__PURE__ */ g("div", { children: pm(ie, O) }, String(ie.key));
              }) }, Z))
            },
            D
          );
        }),
        /* @__PURE__ */ F("footer", { className: P, children: [
          /* @__PURE__ */ g(
            Ze,
            {
              text: l,
              variant: Ye.Outlined,
              color: Le.Secondary,
              type: "button",
              onClick: B
            }
          ),
          /* @__PURE__ */ g(
            Ze,
            {
              text: o,
              variant: Ye.Contained,
              color: Le.Primary,
              type: "submit",
              disabled: !V || !z || y
            }
          )
        ] })
      ]
    }
  ) });
}
const Ui = {
  "ns-header": "_ns-header_1a30a_1",
  "ns-header__cta": "_ns-header__cta_1a30a_27",
  "ns-header__actions": "_ns-header__actions_1a30a_51",
  "ns-header__action": "_ns-header__action_1a30a_51",
  "ns-header__toggle": "_ns-header__toggle_1a30a_60"
};
function mm(e) {
  const { cta: t, ctaControls: n, ctaExpanded: i, ctaRef: r, logo: s, title: o, additionalActions: l } = e, { onCallToActionClick: u, onToggle: c } = e, [d, h] = Ee(!1), m = X(Ui["ns-header__action"]);
  return me(() => {
    c(d);
  }, [d, c]), /* @__PURE__ */ F("header", { className: Ui["ns-header"], children: [
    /* @__PURE__ */ F("h1", { children: [
      s,
      o
    ] }),
    /* @__PURE__ */ F("div", { className: Ui["ns-header__actions"], children: [
      l,
      n ? /* @__PURE__ */ F(
        "button",
        {
          ref: r,
          "aria-controls": n,
          "aria-expanded": i ?? !1,
          "aria-haspopup": "dialog",
          "aria-label": t.config.label,
          className: Ui["ns-header__cta"],
          onClick: u,
          type: "button",
          children: [
            t.config.icon && /* @__PURE__ */ g(be, { className: m, name: t.config.icon }),
            t.config.text && /* @__PURE__ */ g("span", { children: t.config.text })
          ]
        }
      ) : /* @__PURE__ */ F(
        "a",
        {
          "aria-label": t.config.label,
          className: Ui["ns-header__cta"],
          href: t.config.url,
          target: t.config.target ?? Xn.Self,
          rel: t.config.target === Xn.Blank ? "noopener noreferrer" : void 0,
          onClick: u,
          children: [
            t.config.icon && /* @__PURE__ */ g(be, { className: m, name: t.config.icon }),
            t.config.text && /* @__PURE__ */ g("span", { children: t.config.text })
          ]
        }
      ),
      /* @__PURE__ */ g(
        "button",
        {
          "aria-expanded": d,
          "aria-label": d ? "Close navigation menu" : "Open navigation menu",
          className: Ui["ns-header__toggle"],
          onClick: () => h((_) => !_),
          type: "button",
          children: /* @__PURE__ */ g(
            be,
            {
              name: d ? q.Close : q.Menu,
              color: "var(--ns-color-neutral-white)"
            }
          )
        }
      )
    ] })
  ] });
}
const _m = "_middle_1oq25_326", at = {
  "ns-sidebar": "_ns-sidebar_1oq25_1",
  "ns-sidebar__toggle": "_ns-sidebar__toggle_1oq25_23",
  "ns-sidebar--expanded": "_ns-sidebar--expanded_1oq25_49",
  "ns-sidebar__nav-strip": "_ns-sidebar__nav-strip_1oq25_52",
  "ns-sidebar__nav-strip--active": "_ns-sidebar__nav-strip--active_1oq25_116",
  "ns-sidebar__nav-panel": "_ns-sidebar__nav-panel_1oq25_120",
  "ns-sidebar__nav-panel--disabled": "_ns-sidebar__nav-panel--disabled_1oq25_197",
  "ns-sidebar__entity-panel": "_ns-sidebar__entity-panel_1oq25_210",
  "status-filter-heading": "_status-filter-heading_1oq25_240",
  "ns-sidebar__entity-panel-list-item": "_ns-sidebar__entity-panel-list-item_1oq25_253",
  "ns-sidebar__entity-menu-trigger": "_ns-sidebar__entity-menu-trigger_1oq25_318",
  middle: _m,
  "status-icon": "_status-icon_1oq25_339",
  "suffix-icon": "_suffix-icon_1oq25_349",
  "ns-sidebar__entity-panel-list-item--active": "_ns-sidebar__entity-panel-list-item--active_1oq25_377",
  "ns-sidebar__entity-panel-list-item--disabled": "_ns-sidebar__entity-panel-list-item--disabled_1oq25_381",
  "ns-sidebar__filter-controls": "_ns-sidebar__filter-controls_1oq25_401",
  "ns-sidebar__filter-input": "_ns-sidebar__filter-input_1oq25_408",
  "ns-sidebar__filter-chips": "_ns-sidebar__filter-chips_1oq25_411",
  "ns-sidebar__nav-panel--active": "_ns-sidebar__nav-panel--active_1oq25_418",
  "ns-sidebar__panel-footer": "_ns-sidebar__panel-footer_1oq25_424",
  "no-items": "_no-items_1oq25_429",
  "ns-sidebar__backdrop--expanded": "_ns-sidebar__backdrop--expanded_1oq25_439",
  "ns-sidebar__backdrop": "_ns-sidebar__backdrop_1oq25_439"
};
function gm({
  entity: e,
  entityNameSingular: t,
  uIdAttribute: n,
  textAttribute: i,
  subtextAttribute: r,
  displayIdAttribute: s,
  isActive: o,
  isDisabled: l = !1,
  prefixIcon: u,
  suffixIcon: c,
  contextMenu: d,
  contextMenuFor: h,
  onEntityClick: m,
  onEntityContextMenuAction: _
}) {
  const y = ee(null), v = e[n], w = s ? e[s] : v, x = i.split(".").reduce((L, R) => {
    if (L !== null && typeof L == "object" && Object.prototype.hasOwnProperty.call(L, R))
      return L[R];
  }, e), A = x !== null && typeof x == "object" && r && Object.prototype.hasOwnProperty.call(x, r) ? x[r] : x, N = typeof A == "string" || typeof A == "number" ? String(A) : "", E = h?.(e) ?? d, f = $e(() => E ? E.items.map((L) => L.type === "divider" ? { type: "divider", id: L.id } : L.type === "anchor" ? {
    type: "anchor",
    id: L.id,
    label: L.label ?? "",
    href: L.href ?? "#",
    target: L.target,
    prefix: L.prefix,
    suffix: L.suffix,
    danger: L.danger,
    disabled: L.disabled,
    tooltip: L.tooltip,
    tooltipPlacement: L.tooltipPlacement,
    onClick: () => _?.(v, L.id)
  } : {
    type: "button",
    id: L.id,
    label: L.label ?? "",
    prefix: L.prefix,
    suffix: L.suffix,
    danger: L.danger,
    disabled: L.disabled,
    tooltip: L.tooltip,
    tooltipPlacement: L.tooltipPlacement,
    onClick: () => _?.(v, L.id)
  }) : [], [E, v, _]), C = X({
    [at["ns-sidebar__entity-panel-list-item"]]: !0,
    [at["ns-sidebar__entity-panel-list-item--active"]]: o,
    [at["ns-sidebar__entity-panel-list-item--disabled"]]: l
  });
  return /* @__PURE__ */ F("li", { className: C, children: [
    /* @__PURE__ */ F(
      "button",
      {
        type: "button",
        tabIndex: 0,
        className: at["ns-sidebar__entity-row"],
        disabled: l,
        "aria-current": o ? "page" : void 0,
        onClick: () => m(v),
        children: [
          u && /* @__PURE__ */ g(be, { className: at["status-icon"], name: u, "aria-hidden": "true" }),
          /* @__PURE__ */ F("div", { className: at.middle, children: [
            /* @__PURE__ */ g("span", { children: N }),
            /* @__PURE__ */ F("span", { children: [
              "#",
              w
            ] })
          ] }),
          c && /* @__PURE__ */ F(et, { children: [
            /* @__PURE__ */ g(Kr, { children: c.tooltip }),
            /* @__PURE__ */ g(
              be,
              {
                className: at["suffix-icon"],
                name: c.icon,
                tooltip: c.tooltip
              }
            )
          ] })
        ]
      }
    ),
    E && f.length > 0 && /* @__PURE__ */ F(et, { children: [
      /* @__PURE__ */ g(
        "button",
        {
          type: "button",
          className: at["ns-sidebar__entity-menu-trigger"],
          "aria-label": `Actions for ${t} ${w}`,
          disabled: l,
          ref: y,
          children: /* @__PURE__ */ g(be, { tooltip: `${t} Options`, name: q.MoreVert, "aria-hidden": "true" })
        }
      ),
      /* @__PURE__ */ g(
        Kn,
        {
          id: `context-menu-for-${v}`,
          label: `Actions for ${t} ${w}`,
          items: f,
          placement: E.placement,
          anchorRef: y,
          disabled: l
        }
      )
    ] })
  ] });
}
function Bd(e, t) {
  const n = t.split(".");
  let i = e;
  for (const r of n) {
    if (i == null || typeof i != "object")
      return;
    i = i[r];
  }
  if (typeof i == "string" || typeof i == "number" || typeof i == "boolean")
    return i;
}
function xm({
  items: e,
  filterFields: t,
  query: n
}) {
  const i = n.trim().toLowerCase();
  if (!i)
    return e;
  const r = [];
  for (const s of e)
    for (let o = 0; o < t.length; o++) {
      const l = Bd(s, t[o]);
      if (l != null && String(l).toLowerCase().includes(i)) {
        r.push({ item: s, matchIndex: o });
        break;
      }
    }
  return r.sort((s, o) => s.matchIndex - o.matchIndex), r.map((s) => s.item);
}
function bm({
  items: e,
  filterField: t,
  query: n
}) {
  if (!n.length)
    return e;
  const i = [], r = n.reduce((s, o, l) => (s[o] = l, s), {});
  for (const s of e) {
    const o = Bd(s, t);
    o && n.includes(`${o}`) && i.push({ item: s, matchIndex: r[`${o}`] });
  }
  return i.sort((s, o) => s.matchIndex - o.matchIndex), i.map((s) => s.item);
}
function ym({
  icon: e,
  entities: t,
  filterTerm: n,
  entityNameSingular: i,
  entityNamePlural: r,
  activeEntityId: s,
  isFilterable: o,
  uIdAttribute: l,
  textAttribute: u,
  subtextAttribute: c,
  displayIdAttribute: d,
  filterBy: h,
  valueFilter: m,
  prefixIconField: _,
  selectedFilterValues: y = [],
  contextMenu: v,
  contextMenuFor: w,
  disabledFor: x,
  suffixIconFor: A,
  onEntityClick: S = () => {
  },
  onEntityFilter: N = () => {
  },
  onEntityContextMenuAction: E = () => {
  },
  onFilterChange: f = () => {
  }
}) {
  const C = ee(null), L = $e(() => m ? m.options.map((H) => ({
    type: "checkbox",
    id: H.id,
    label: H.label,
    prefix: H.prefix,
    checked: y.includes(H.value),
    onChange: (B) => {
      const O = B ? [...y, H.value] : y.filter((W) => W !== H.value);
      f(O);
    }
  })) : [], [m, y, f]), R = $e(() => !_ || !m ? null : Object.fromEntries(m.options.filter((H) => H.prefix).map((H) => [H.value, H.prefix])), [_, m]), V = $e(() => {
    N(n);
    let H = xm({ items: t, filterFields: h, query: n });
    return m && y.length > 0 && (H = bm({
      items: H,
      filterField: m.field,
      query: y
    })), H;
  }, [t, h, n, m, y]), z = X({
    [at["ns-sidebar__entity-panel"]]: !0
  }), $ = () => V.length ? /* @__PURE__ */ g("ul", { children: V.map((H) => /* @__PURE__ */ g(
    gm,
    {
      entity: H,
      entityNameSingular: i,
      uIdAttribute: l,
      textAttribute: u,
      subtextAttribute: c,
      displayIdAttribute: d,
      isActive: s === H.id,
      isDisabled: x?.(H) ?? !1,
      prefixIcon: _ ? R?.[H[_]] ?? void 0 : void 0,
      contextMenu: v,
      contextMenuFor: w,
      suffixIcon: A?.(H),
      onEntityClick: S,
      onEntityContextMenuAction: E
    },
    H.id
  )) }) : /* @__PURE__ */ F("p", { className: at["no-items"], children: [
    "No ",
    r,
    " found"
  ] });
  return /* @__PURE__ */ F("section", { className: z, children: [
    o && /* @__PURE__ */ F(et, { children: [
      /* @__PURE__ */ F("div", { className: at["ns-sidebar__filter-controls"], children: [
        /* @__PURE__ */ g(
          Jf,
          {
            className: at["ns-sidebar__filter-input"],
            placeholder: `Search ${r}`,
            value: n,
            onChange: N,
            prefix: q.Search
          }
        ),
        m && /* @__PURE__ */ F(et, { children: [
          /* @__PURE__ */ g(
            Ze,
            {
              ref: C,
              label: `Filter ${i}`,
              icon: q.FilterList,
              isIconOnly: !0,
              size: lt.Large,
              variant: Ye.Outlined,
              color: Le.Primary,
              tooltip: m.tooltip ?? `Filter ${r}`,
              tooltipPlacement: "right"
            }
          ),
          /* @__PURE__ */ g(
            Kn,
            {
              id: "context-menu-for-entity-filters",
              label: `Filter ${r}`,
              items: L,
              placement: "bottom-start",
              anchorRef: C
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ g("span", { className: at["status-filter-heading"], children: "Status Filter" }),
      m && y.length > 0 && /* @__PURE__ */ g("div", { className: at["ns-sidebar__filter-chips"], children: y.map((H) => {
        const B = m.options.find((O) => O.value === H);
        return B ? /* @__PURE__ */ g(
          Gn,
          {
            id: B.id,
            label: B.label,
            text: B.label,
            variant: fi.Outlined,
            color: B?.color ?? Le.Secondary,
            className: B?.className,
            onDismiss: () => f(y.filter((O) => O !== H))
          },
          B.id
        ) : null;
      }) })
    ] }),
    $()
  ] });
}
function vm({ item: e, classNames: t, onNavitemClick: n = () => {
} }) {
  const i = ee(null), r = e.disabled === !0, s = e.target ?? Xn.Self, o = s === Xn.Blank;
  return /* @__PURE__ */ F(
    "a",
    {
      className: t,
      href: e.href,
      ref: i,
      "aria-label": e.label,
      "aria-disabled": r || void 0,
      "data-disabled": r ? "true" : void 0,
      "data-nav-item-id": e.id,
      target: s,
      rel: o ? "noopener noreferrer" : void 0,
      onClick: (l) => {
        if (r) {
          l.preventDefault();
          return;
        }
        s === Xn.Self && l.preventDefault(), n(e.id);
      },
      children: [
        e.icon && /* @__PURE__ */ g(be, { name: e.icon }),
        e.text,
        e.count !== void 0 ? /* @__PURE__ */ F("span", { style: { marginLeft: "auto" }, children: [
          "(",
          e.count,
          ")"
        ] }) : null,
        e.tooltip ? /* @__PURE__ */ g(kn, { id: `tooltip-${e.id}`, content: e.tooltip, anchorRef: i, placement: "right" }) : null
      ]
    }
  );
}
function wm({ activeNavitemId: e, items: t, onNavitemClick: n = () => {
} }) {
  const i = X({
    [at["ns-sidebar__nav-panel"]]: !0
  });
  return /* @__PURE__ */ g("ul", { className: i, children: t.filter((r) => r.display).map((r) => {
    const s = X({
      [at["ns-sidebar__nav-panel--active"]]: e === r.id && !r.disabled,
      [at["ns-sidebar__nav-panel--disabled"]]: r.disabled
    });
    return /* @__PURE__ */ g("li", { children: /* @__PURE__ */ g(vm, { item: r, classNames: s, onNavitemClick: n }) }, r.id);
  }) });
}
var ho = /* @__PURE__ */ ((e) => (e.Navigation = "Navigation", e.Entity = "Entity", e))(ho || {}), po = /* @__PURE__ */ ((e) => (e.Button = "button", e.Link = "link", e))(po || {});
const mu = "--ns-sidebar-width";
function km({
  filterTerm: e = "",
  activePanelId: t = "",
  activeEntityId: n,
  activeNavitemId: i,
  isExpanded: r,
  panels: s,
  entities: o,
  onPanelClick: l = () => {
  },
  onEntityClick: u = () => {
  },
  onEntityFilter: c = () => {
  },
  onNavClick: d = () => {
  },
  onPanelCtaClick: h = () => {
  },
  onEntityContextMenuAction: m,
  onToggle: _,
  selectedFilterValues: y = [],
  onFilterChange: v = () => {
  },
  userBadge: w,
  panelFooter: x
}) {
  const A = t.length ? t : Object.values(s).shift()?.id, S = s[A], N = ee(null), E = ee(null);
  rr(() => {
    const H = E.current;
    if (H === null)
      return;
    const B = () => {
      const W = H.getBoundingClientRect().right;
      document.documentElement.style.setProperty(
        mu,
        `${Math.max(0, Math.round(W))}px`
      );
    };
    B();
    const O = new ResizeObserver(B);
    return O.observe(H), window.addEventListener("resize", B, { passive: !0 }), () => {
      O.disconnect(), window.removeEventListener("resize", B);
    };
  }, [r]), me(
    () => () => {
      document.documentElement.style.removeProperty(mu);
    },
    []
  );
  const f = X({
    [at["ns-sidebar"]]: !0,
    [at["ns-sidebar--expanded"]]: r
  }), C = X({
    [at["ns-sidebar__backdrop"]]: !0,
    [at["ns-sidebar__backdrop--expanded"]]: r
  }), L = (H) => {
    u(H);
  }, R = X({
    [at["ns-sidebar__nav-strip"]]: !0
  }), V = X({
    [at["ns-sidebar__nav-panel"]]: !0
  }), z = () => {
    if (!S?.cta || !S.cta.display)
      return null;
    if (S.cta.type === po.Button)
      return /* @__PURE__ */ g(
        Ze,
        {
          ...S.cta.config,
          onClick: () => h(S.id),
          isIconOnly: !0,
          tooltip: S.cta.config.tooltip,
          tooltipPlacement: S.cta.config.tooltipPlacement
        }
      );
    if (S.cta.type === po.Link) {
      const { id: H, label: B, title: O, text: W, url: G, target: re } = S.cta.config;
      return /* @__PURE__ */ g(Gr, { id: H, ariaLabel: B, title: O, text: W, url: G, target: re });
    }
    return null;
  }, $ = () => S?.type === ho.Navigation ? /* @__PURE__ */ g(wm, { ...S.config, activeNavitemId: i, onNavitemClick: d }) : S?.type === ho.Entity ? /* @__PURE__ */ g(
    ym,
    {
      ...S.config,
      entities: o[S.id] ?? [],
      contextMenu: S.config.contextMenu,
      activeEntityId: n,
      onEntityClick: L,
      filterTerm: e,
      onEntityFilter: c,
      selectedFilterValues: y,
      onFilterChange: v,
      onEntityContextMenuAction: (H, B) => m?.(S.id, H, B)
    }
  ) : null;
  return /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ g(
      "div",
      {
        className: C,
        onClick: () => _(),
        onKeyDown: (H) => {
          ["Enter", "Space"].includes(H.code) && _();
        }
      }
    ),
    /* @__PURE__ */ F("aside", { ref: E, className: f, children: [
      /* @__PURE__ */ F(
        "button",
        {
          ref: N,
          "aria-label": r ? "Shrink" : "Expand",
          tabIndex: 0,
          className: at["ns-sidebar__toggle"],
          onClick: () => _(),
          children: [
            /* @__PURE__ */ g(
              kn,
              {
                id: "tooltip-toggle",
                content: r ? "Collapse" : "Expand",
                anchorRef: N,
                placement: "right"
              }
            ),
            /* @__PURE__ */ g(be, { "aria-hidden": !0, name: r ? q.ChevronLeft : q.ChevronRight })
          ]
        }
      ),
      /* @__PURE__ */ F("section", { children: [
        /* @__PURE__ */ F("nav", { className: R, children: [
          /* @__PURE__ */ g("header", { children: w !== null ? w : /* @__PURE__ */ g("div", { children: "AM" }) }),
          Object.entries(s).filter(([, H]) => H.showInNavStrip !== !1).map(([H, B]) => /* @__PURE__ */ g(
            "button",
            {
              "aria-label": B.tooltip ?? B.title ?? H,
              className: X({
                [at["ns-sidebar__nav-strip--active"]]: t === H
              }),
              onClick: () => {
                r || _(), l(H);
              },
              children: /* @__PURE__ */ g(be, { name: B.icon, tooltip: B.tooltip, tooltipPlacement: "right" })
            },
            H
          ))
        ] }),
        /* @__PURE__ */ F("nav", { className: V, children: [
          /* @__PURE__ */ F("header", { children: [
            /* @__PURE__ */ g("h2", { children: S?.title }),
            z()
          ] }),
          $(),
          x ? /* @__PURE__ */ g("div", { className: at["ns-sidebar__panel-footer"], children: x }) : null,
          /* @__PURE__ */ g(D0, {})
        ] })
      ] })
    ] })
  ] });
}
const Cm = "_subheader_166lu_42", Sm = "_link_166lu_96", Dn = {
  "ns-table": "_ns-table_166lu_1",
  "color-success": "_color-success_166lu_9",
  "color-failure": "_color-failure_166lu_12",
  "header-cell": "_header-cell_166lu_30",
  "header-text": "_header-text_166lu_35",
  subheader: Cm,
  "header-icon": "_header-icon_166lu_50",
  "drag-button": "_drag-button_166lu_64",
  "cell-subheader": "_cell-subheader_166lu_88",
  link: Sm
};
function Em({ kind: e, value: t, label: n }) {
  return /* @__PURE__ */ g("td", { children: t ? /* @__PURE__ */ F("span", { children: [
    /* @__PURE__ */ g(be, { name: q.Done, className: Dn["color-success"] }),
    " ",
    n
  ] }) : /* @__PURE__ */ F("span", { children: [
    /* @__PURE__ */ g(be, { name: q.Close, className: Dn["color-failure"] }),
    " ",
    n
  ] }) });
}
function Am({ kind: e, icon: t }) {
  return /* @__PURE__ */ g("td", { children: t ?? /* @__PURE__ */ g(be, { name: q.MoreVert, className: "dd-handle" }) });
}
function Im({ kind: e, text: t, label: n, href: i, target: r = "_blank", icon: s }) {
  return /* @__PURE__ */ g("td", { children: /* @__PURE__ */ F(Gr, { url: i, target: r, ariaLabel: n, title: n, children: [
    t,
    " ",
    s ?? /* @__PURE__ */ g(be, { name: q.Launch, className: Dn.link })
  ] }) });
}
function Lm({ kind: e, items: t }) {
  return /* @__PURE__ */ g("td", { children: /* @__PURE__ */ g("ul", { className: "list", children: t.map((n, i) => /* @__PURE__ */ g("li", { children: n }, `${n}-${i}`)) }) });
}
function Nm({ kind: e, text: t, subtext: n }) {
  return /* @__PURE__ */ F("td", { children: [
    /* @__PURE__ */ g("span", { children: t }),
    /* @__PURE__ */ g("span", { className: Dn["cell-subheader"], children: n })
  ] });
}
function Tm({ caption: e, columns: t, data: n }) {
  return /* @__PURE__ */ F("table", { className: Dn["ns-table"], children: [
    e && /* @__PURE__ */ g("caption", { children: e }),
    /* @__PURE__ */ g("thead", { children: /* @__PURE__ */ F("tr", { children: [
      /* @__PURE__ */ g("td", { children: " " }),
      t.map((i) => /* @__PURE__ */ g("th", { children: /* @__PURE__ */ F("div", { className: Dn["header-cell"], children: [
        /* @__PURE__ */ F("div", { className: Dn["header-text"], children: [
          /* @__PURE__ */ g("span", { children: i.header ?? i.key }),
          i.subheader && /* @__PURE__ */ g("span", { className: Dn.subheader, children: i.subheader })
        ] }),
        /* @__PURE__ */ g("div", { className: Dn["header-icon"], children: i.isSortable && /* @__PURE__ */ g(be, { name: q.Sort }) })
      ] }) }, i.key))
    ] }) }),
    /* @__PURE__ */ g("tbody", { children: n.map((i) => /* @__PURE__ */ F("tr", { children: [
      /* @__PURE__ */ g("td", { className: Dn["drag-button"], children: /* @__PURE__ */ g(be, { name: q.MoreVert }) }),
      t.map((r) => {
        const s = i[r.key];
        switch (r.type) {
          case "text":
            return /* @__PURE__ */ g(Nm, { ...s });
          case "binary":
            return /* @__PURE__ */ g(Em, { ...s });
          case "link":
            return /* @__PURE__ */ g(Im, { ...s });
          case "icon":
            return /* @__PURE__ */ g(Am, { ...s });
          case "list":
            return /* @__PURE__ */ g(Lm, { ...s });
          default:
            return /* @__PURE__ */ g("td", {}, r.key);
        }
      })
    ] }, crypto.randomUUID())) })
  ] });
}
const Ln = {
  "ns-entity-viewer": "_ns-entity-viewer_113m3_1",
  "ns-entity-viewer__columns": "_ns-entity-viewer__columns_113m3_11",
  "ns-entity-viewer__column": "_ns-entity-viewer__column_113m3_11",
  "ns-entity-viewer__term": "_ns-entity-viewer__term_113m3_28",
  "ns-entity-viewer__property-actions": "_ns-entity-viewer__property-actions_113m3_45",
  "ns-entity-viewer__label-tooltip": "_ns-entity-viewer__label-tooltip_113m3_52",
  "ns-entity-viewer__value": "_ns-entity-viewer__value_113m3_59",
  "ns-entity-viewer__email": "_ns-entity-viewer__email_113m3_70",
  "ns-entity-viewer__list": "_ns-entity-viewer__list_113m3_74",
  "ns-entity-viewer__action": "_ns-entity-viewer__action_113m3_80"
};
var Es = /* @__PURE__ */ ((e) => (e.Email = "email", e.List = "list", e.Text = "text", e))(Es || {});
function ak(e) {
  return e;
}
function Pm({
  actions: e,
  className: t,
  onAction: n
}) {
  return /* @__PURE__ */ g("div", { className: t, children: e.map((i) => /* @__PURE__ */ g(Ze, { ...i, onClick: () => n(i) }, i.name)) });
}
function Dm({ content: e, className: t }) {
  const n = ee(null), i = rt();
  return /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ g(
      "span",
      {
        ref: n,
        role: "img",
        "aria-label": e,
        tabIndex: 0,
        className: t,
        children: /* @__PURE__ */ g(be, { name: q.InfoOutline, size: 20, "aria-hidden": "true" })
      }
    ),
    /* @__PURE__ */ g(kn, { id: i, content: e, anchorRef: n })
  ] });
}
function _a(e, t = "") {
  return typeof e == "string" ? e : typeof e == "number" || typeof e == "boolean" || typeof e == "bigint" ? String(e) : t;
}
function Mm(e, t) {
  switch (t) {
    case Es.Email: {
      const n = _a(e);
      return /* @__PURE__ */ g(Gr, { url: `mailto:${n}`, text: n, className: Ln["ns-entity-viewer__email"] });
    }
    case Es.List: {
      const n = Array.isArray(e) ? e.map(String) : [_a(e)];
      return /* @__PURE__ */ g("ul", { className: Ln["ns-entity-viewer__list"], children: n.map((i, r) => (
        // Index keys are acceptable here: list items are static display
        // data with no identity beyond their position. // NOSONAR
        /* @__PURE__ */ g("li", { children: i }, r)
      )) });
    }
    case Es.Text:
    default:
      return /* @__PURE__ */ g(et, { children: _a(e) });
  }
}
function Vm({
  "aria-label": e,
  entity: t,
  columns: n,
  action: i,
  onAction: r
}) {
  if (!t)
    return null;
  const s = X({
    [Ln["ns-entity-viewer"]]: !0
  }), o = X({
    [Ln["ns-entity-viewer__columns"]]: !0
  }), l = n.map((x) => x.width ?? "1fr").join(" "), u = Math.max(1, ...n.map((x) => x.properties.length)), c = Array.from({ length: u * 2 }, () => "auto").join(" "), d = X({
    [Ln["ns-entity-viewer__column"]]: !0
  }), h = X({
    [Ln["ns-entity-viewer__term"]]: !0
  }), m = X({
    [Ln["ns-entity-viewer__value"]]: !0
  }), _ = X({
    [Ln["ns-entity-viewer__action"]]: !0
  }), y = X({
    [Ln["ns-entity-viewer__property-actions"]]: !0
  }), v = X({
    [Ln["ns-entity-viewer__label-tooltip"]]: !0
  }), w = (x) => {
    r?.(x);
  };
  return /* @__PURE__ */ F("section", { className: s, "aria-label": e, children: [
    /* @__PURE__ */ g(
      "div",
      {
        className: o,
        style: {
          "--ns-viewer-grid-template": l,
          "--ns-viewer-grid-rows": c
        },
        children: n.map((x, A) => /* @__PURE__ */ g(
          "dl",
          {
            className: d,
            style: { gridRow: `span ${Math.max(1, x.properties.length * 2)}` },
            children: x.properties.map((S) => /* @__PURE__ */ F(Vo, { children: [
              /* @__PURE__ */ F("dt", { className: h, children: [
                /* @__PURE__ */ g("span", { children: S.label }),
                S.labelTooltip ? /* @__PURE__ */ g(
                  Dm,
                  {
                    content: S.labelTooltip,
                    className: v
                  }
                ) : null,
                S.actions?.length ? /* @__PURE__ */ g(
                  Pm,
                  {
                    actions: S.actions,
                    className: y,
                    onAction: w
                  }
                ) : null
              ] }),
              /* @__PURE__ */ g("dd", { className: m, children: S.transform ? S.transform(t[S.key]) : Mm(t[S.key], S.format) })
            ] }, String(S.key)))
          },
          A
        ))
      }
    ),
    i ? /* @__PURE__ */ g("div", { className: _, children: /* @__PURE__ */ g(Ze, { ...i, onClick: () => w(i) }) }) : null
  ] });
}
const nn = {
  "ns-dialog-overlay": "_ns-dialog-overlay_y8ami_1",
  "ns-dialog-overlay--open": "_ns-dialog-overlay--open_y8ami_10",
  "ns-dialog-positioner": "_ns-dialog-positioner_y8ami_20",
  "ns-dialog--open": "_ns-dialog--open_y8ami_29",
  "ns-dialog": "_ns-dialog_y8ami_1",
  "ns-dialog__header": "_ns-dialog__header_y8ami_71",
  "ns-dialog__header-text": "_ns-dialog__header-text_y8ami_80",
  "ns-dialog__title": "_ns-dialog__title_y8ami_87",
  "ns-dialog__description": "_ns-dialog__description_y8ami_95",
  "ns-dialog__close": "_ns-dialog__close_y8ami_102",
  "ns-dialog__body": "_ns-dialog__body_y8ami_128",
  "ns-dialog__footer": "_ns-dialog__footer_y8ami_133"
}, Fm = "ds-dialog-layer", Rm = ({
  id: e,
  isOpen: t,
  onClose: n,
  title: i,
  description: r,
  children: s,
  size: o = "md",
  actions: l,
  onAction: u,
  closeOnBackdropClick: c = !0,
  closeOnEscape: d = !0,
  lockBodyScroll: h = !0,
  transitionDuration: m = "200ms",
  transitionEasing: _ = "ease-out",
  "aria-label": y
}) => {
  const { panelRef: v, panel: w, handleBackdropClick: x, handleActionClick: A } = jo({
    isOpen: t,
    onClose: n,
    onAction: u,
    closeOnBackdropClick: c,
    closeOnEscape: d,
    lockBodyScroll: h
  }), S = X({
    [nn["ns-dialog-overlay"]]: !0,
    [nn["ns-dialog-overlay--open"]]: t
  }), N = X({
    [nn["ns-dialog"]]: !0,
    [nn[`ns-dialog--size-${o}`]]: !0,
    [nn["ns-dialog--open"]]: t
  });
  return hi(
    /* @__PURE__ */ F("div", { style: {
      "--ns-dialog-transition-duration": m,
      "--ns-dialog-transition-easing": _
    }, children: [
      /* @__PURE__ */ g("div", { className: S, onClick: x, "aria-hidden": "true" }),
      /* @__PURE__ */ g("div", { className: nn["ns-dialog-positioner"], children: /* @__PURE__ */ F(
        "dialog",
        {
          ref: v,
          id: e,
          open: !0,
          "aria-hidden": !t || void 0,
          "aria-modal": t ? "true" : void 0,
          inert: !t || void 0,
          "aria-label": y ?? i,
          "aria-labelledby": i ? `${e}-title` : void 0,
          "aria-describedby": r ? `${e}-description` : void 0,
          tabIndex: -1,
          className: N,
          children: [
            /* @__PURE__ */ F("header", { className: nn["ns-dialog__header"], children: [
              /* @__PURE__ */ F("div", { className: nn["ns-dialog__header-text"], children: [
                /* @__PURE__ */ g("h6", { id: `${e}-title`, className: nn["ns-dialog__title"], children: i }),
                r && /* @__PURE__ */ g("p", { id: `${e}-description`, className: nn["ns-dialog__description"], children: r })
              ] }),
              /* @__PURE__ */ g("button", { type: "button", className: nn["ns-dialog__close"], "aria-label": "Close dialog", onClick: n, children: /* @__PURE__ */ g(be, { name: q.Close, "aria-hidden": !0 }) })
            ] }),
            /* @__PURE__ */ g("div", { className: nn["ns-dialog__body"], children: /* @__PURE__ */ g(zo.Provider, { value: w, children: s }) }),
            l?.length ? /* @__PURE__ */ g("footer", { className: nn["ns-dialog__footer"], children: l.map((f) => /* @__PURE__ */ g(Ze, { ...f, onClick: () => A(f) }, f.name)) }) : null
          ]
        }
      ) })
    ] }),
    pi(Fm)
  );
}, Om = "_token_v25we_1", Bm = "_copyButton_v25we_11", zm = "_swatch_v25we_16", jm = "_value_v25we_23", $m = "_tooltip_v25we_49", Hm = "_copyButtonDone_v25we_62", Um = "_buttonIcon_v25we_70", qm = "_srOnly_v25we_107", Wn = {
  token: Om,
  copyButton: Bm,
  swatch: zm,
  value: jm,
  tooltip: $m,
  copyButtonDone: Hm,
  buttonIcon: Um,
  srOnly: qm
};
function Jm({ color: e }) {
  return /* @__PURE__ */ g(
    "svg",
    {
      className: Wn.swatch,
      width: "10",
      height: "10",
      viewBox: "0 0 10 10",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ g("circle", { cx: "5", cy: "5", r: "4", fill: e, stroke: "rgba(0,0,0,0.15)", strokeWidth: "0.5" })
    }
  );
}
function Wm() {
  return /* @__PURE__ */ g(
    "svg",
    {
      className: Wn.buttonIcon,
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ g("path", { d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" })
    }
  );
}
function Zm() {
  return /* @__PURE__ */ g(
    "svg",
    {
      className: Wn.buttonIcon,
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ g("path", { d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" })
    }
  );
}
function Xm({ value: e, color: t }) {
  const [n, i] = Ee(!1), r = $e(() => {
    if (t)
      return t;
    if (!e.startsWith("--") || typeof document > "u")
      return;
    const l = getComputedStyle(document.documentElement).getPropertyValue(e).trim();
    if (l)
      return /^(#|rgb|hsl|oklch|oklab|lch|lab|color\()/i.test(l) ? l : void 0;
  }, [e, t]), s = async () => {
    try {
      await navigator.clipboard.writeText(e), i(!0), setTimeout(() => i(!1), 1500);
    } catch {
    }
  }, o = n ? "Copied!" : `Copy ${e}`;
  return /* @__PURE__ */ F("span", { className: Wn.token, children: [
    r && /* @__PURE__ */ g(Jm, { color: r }),
    /* @__PURE__ */ g("code", { className: Wn.value, children: e }),
    /* @__PURE__ */ F(
      "button",
      {
        type: "button",
        className: `${Wn.copyButton} ${n ? Wn.copyButtonDone : ""}`,
        "aria-label": o,
        onClick: s,
        children: [
          n ? /* @__PURE__ */ g(Zm, {}) : /* @__PURE__ */ g(Wm, {}),
          /* @__PURE__ */ g("span", { className: Wn.tooltip, "aria-hidden": "true", children: n ? "Copied!" : "Copy" })
        ]
      }
    ),
    /* @__PURE__ */ g("span", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: Wn.srOnly, children: n ? `Copied ${e} to clipboard` : "" })
  ] });
}
function Gm(e) {
  return /* @__PURE__ */ g("pre", { tabIndex: 0, ...e });
}
const zd = {
  // MDX utilities
  Token: Xm,
  pre: Gm,
  // Base components
  Badge: M0,
  Button: Ze,
  Checkbox: ur,
  Chip: Gn,
  ContextualMenu: Kn,
  Icon: be,
  Tooltip: kn,
  // Input system
  ComboBoxField: rd,
  DatePickerField: $o,
  EntityPickerField: Uo,
  MultiSelectField: sd,
  SelectField: Oo,
  TextField: Ki,
  TimePickerField: Ho,
  // Patterns
  Accordion: R1,
  AccordionItem: O1,
  AriesCard: Z1,
  AriesInput: Y1,
  Card: em,
  Dialog: Rm,
  Drawer: im,
  EntityEditor: fm,
  EntityViewer: Vm,
  ErrorBoundary: Q1,
  InfoCard: X1,
  Navbar: mm,
  Sidebar: km,
  Table: Tm
};
function ok({ children: e, components: t = {} }) {
  const n = {
    ...zd,
    ...t
  };
  return /* @__PURE__ */ g(J1, { components: n, children: e });
}
function _n(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? _u(e.position) : "start" in e || "end" in e ? _u(e) : "line" in e || "column" in e ? fo(e) : "";
}
function fo(e) {
  return gu(e && e.line) + ":" + gu(e && e.column);
}
function _u(e) {
  return fo(e && e.start) + "-" + fo(e && e.end);
}
function gu(e) {
  return e && typeof e == "number" ? e : 1;
}
class Qe extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, i) {
    super(), typeof n == "string" && (i = n, n = void 0);
    let r = "", s = {}, o = !1;
    if (n && ("line" in n && "column" in n ? s = { place: n } : "start" in n && "end" in n ? s = { place: n } : "type" in n ? s = {
      ancestors: [n],
      place: n.position
    } : s = { ...n }), typeof t == "string" ? r = t : !s.cause && t && (o = !0, r = t.message, s.cause = t), !s.ruleId && !s.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? s.ruleId = i : (s.source = i.slice(0, u), s.ruleId = i.slice(u + 1));
    }
    if (!s.place && s.ancestors && s.ancestors) {
      const u = s.ancestors[s.ancestors.length - 1];
      u && (s.place = u.position);
    }
    const l = s.place && "start" in s.place ? s.place.start : s.place;
    this.ancestors = s.ancestors || void 0, this.cause = s.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file = "", this.message = r, this.line = l ? l.line : void 0, this.name = _n(s.place) || "1:1", this.place = s.place || void 0, this.reason = this.message, this.ruleId = s.ruleId || void 0, this.source = s.source || void 0, this.stack = o && s.cause && typeof s.cause.stack == "string" ? s.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
Qe.prototype.file = "";
Qe.prototype.name = "";
Qe.prototype.reason = "";
Qe.prototype.message = "";
Qe.prototype.stack = "";
Qe.prototype.column = void 0;
Qe.prototype.line = void 0;
Qe.prototype.ancestors = void 0;
Qe.prototype.cause = void 0;
Qe.prototype.fatal = void 0;
Qe.prototype.place = void 0;
Qe.prototype.ruleId = void 0;
Qe.prototype.source = void 0;
const Nn = { basename: Km, dirname: Ym, extname: Qm, join: e2, sep: "/" };
function Km(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Yr(e);
  let n = 0, i = -1, r = e.length, s;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; r--; )
      if (e.codePointAt(r) === 47) {
        if (s) {
          n = r + 1;
          break;
        }
      } else i < 0 && (s = !0, i = r + 1);
    return i < 0 ? "" : e.slice(n, i);
  }
  if (t === e)
    return "";
  let o = -1, l = t.length - 1;
  for (; r--; )
    if (e.codePointAt(r) === 47) {
      if (s) {
        n = r + 1;
        break;
      }
    } else
      o < 0 && (s = !0, o = r + 1), l > -1 && (e.codePointAt(r) === t.codePointAt(l--) ? l < 0 && (i = r) : (l = -1, i = o));
  return n === i ? i = o : i < 0 && (i = e.length), e.slice(n, i);
}
function Ym(e) {
  if (Yr(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, i;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (i) {
        t = n;
        break;
      }
    } else i || (i = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function Qm(e) {
  Yr(e);
  let t = e.length, n = -1, i = 0, r = -1, s = 0, o;
  for (; t--; ) {
    const l = e.codePointAt(t);
    if (l === 47) {
      if (o) {
        i = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), l === 46 ? r < 0 ? r = t : s !== 1 && (s = 1) : r > -1 && (s = -1);
  }
  return r < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  s === 0 || // The (right-most) trimmed path component is exactly `..`.
  s === 1 && r === n - 1 && r === i + 1 ? "" : e.slice(r, n);
}
function e2(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Yr(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : t2(n);
}
function t2(e) {
  Yr(e);
  const t = e.codePointAt(0) === 47;
  let n = n2(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function n2(e, t) {
  let n = "", i = 0, r = -1, s = 0, o = -1, l, u;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      l = e.codePointAt(o);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(r === o - 1 || s === 1)) if (r !== o - 1 && s === 2) {
        if (n.length < 2 || i !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", i = 0) : (n = n.slice(0, u), i = n.length - 1 - n.lastIndexOf("/")), r = o, s = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", i = 0, r = o, s = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", i = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(r + 1, o) : n = e.slice(r + 1, o), i = o - r - 1;
      r = o, s = 0;
    } else l === 46 && s > -1 ? s++ : s = -1;
  }
  return n;
}
function Yr(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const i2 = { cwd: r2 };
function r2() {
  return "/";
}
function mo(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function s2(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!mo(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return a2(e);
}
function a2(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const i = t.codePointAt(n + 2);
      if (i === 70 || i === 102) {
        const r = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw r.code = "ERR_INVALID_FILE_URL_PATH", r;
      }
    }
  return decodeURIComponent(t);
}
const ga = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class jd {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? mo(t) ? n = { path: t } : typeof t == "string" || o2(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : i2.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < ga.length; ) {
      const s = ga[i];
      s in n && n[s] !== void 0 && n[s] !== null && (this[s] = s === "history" ? [...n[s]] : n[s]);
    }
    let r;
    for (r in n)
      ga.includes(r) || (this[r] = n[r]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Nn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    ba(t, "basename"), xa(t, "basename"), this.path = Nn.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Nn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    xu(this.basename, "dirname"), this.path = Nn.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Nn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (xa(t, "extname"), xu(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Nn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    mo(t) && (t = s2(t)), ba(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Nn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    ba(t, "stem"), xa(t, "stem"), this.path = Nn.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, i) {
    const r = this.message(t, n, i);
    throw r.fatal = !0, r;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, i) {
    const r = this.message(t, n, i);
    return r.fatal = void 0, r;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, i) {
    const r = new Qe(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      i
    );
    return this.path && (r.name = this.path + ":" + r.name, r.file = this.path), r.fatal = !1, this.messages.push(r), r;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function xa(e, t) {
  if (e && e.includes(Nn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Nn.sep + "`"
    );
}
function ba(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function xu(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function o2(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const l2 = [
  "md",
  "markdown",
  "mdown",
  "mkdn",
  "mkd",
  "mdwn",
  "mkdown",
  "ron"
], u2 = l2.map(function(e) {
  return "." + e;
});
function c2(e, t) {
  const n = d2(e) ? e : new jd(e), { format: i, ...r } = t || {};
  return {
    file: n,
    options: {
      format: i === "md" || i === "mdx" ? i : n.extname && (r.mdExtensions || u2).includes(n.extname) ? "md" : "mdx",
      ...r
    }
  };
}
function d2(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
const h2 = /[$_\p{ID_Start}]/u, p2 = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u, f2 = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u, m2 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, _2 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, $d = {};
function xn(e) {
  return e ? h2.test(String.fromCodePoint(e)) : !1;
}
function Lr(e, t) {
  const i = (t || $d).jsx ? f2 : p2;
  return e ? i.test(String.fromCodePoint(e)) : !1;
}
function Mn(e, t) {
  return ((t || $d).jsx ? _2 : m2).test(e);
}
class g2 {
  constructor() {
    this.should_skip = !1, this.should_remove = !1, this.replacement = null, this.context = {
      skip: () => this.should_skip = !0,
      remove: () => this.should_remove = !0,
      replace: (t) => this.replacement = t
    };
  }
  /**
   * @template {Node} Parent
   * @param {Parent | null | undefined} parent
   * @param {keyof Parent | null | undefined} prop
   * @param {number | null | undefined} index
   * @param {Node} node
   */
  replace(t, n, i, r) {
    t && n && (i != null ? t[n][i] = r : t[n] = r);
  }
  /**
   * @template {Node} Parent
   * @param {Parent | null | undefined} parent
   * @param {keyof Parent | null | undefined} prop
   * @param {number | null | undefined} index
   */
  remove(t, n, i) {
    t && n && (i != null ? t[n].splice(i, 1) : delete t[n]);
  }
}
class x2 extends g2 {
  /**
   *
   * @param {SyncHandler} [enter]
   * @param {SyncHandler} [leave]
   */
  constructor(t, n) {
    super(), this.should_skip = !1, this.should_remove = !1, this.replacement = null, this.context = {
      skip: () => this.should_skip = !0,
      remove: () => this.should_remove = !0,
      replace: (i) => this.replacement = i
    }, this.enter = t, this.leave = n;
  }
  /**
   * @template {Node} Parent
   * @param {Node} node
   * @param {Parent | null} parent
   * @param {keyof Parent} [prop]
   * @param {number | null} [index]
   * @returns {Node | null}
   */
  visit(t, n, i, r) {
    if (t) {
      if (this.enter) {
        const o = this.should_skip, l = this.should_remove, u = this.replacement;
        this.should_skip = !1, this.should_remove = !1, this.replacement = null, this.enter.call(this.context, t, n, i, r), this.replacement && (t = this.replacement, this.replace(n, i, r, t)), this.should_remove && this.remove(n, i, r);
        const c = this.should_skip, d = this.should_remove;
        if (this.should_skip = o, this.should_remove = l, this.replacement = u, c) return t;
        if (d) return null;
      }
      let s;
      for (s in t) {
        const o = t[s];
        if (o && typeof o == "object")
          if (Array.isArray(o)) {
            const l = (
              /** @type {Array<unknown>} */
              o
            );
            for (let u = 0; u < l.length; u += 1) {
              const c = l[u];
              bu(c) && (this.visit(c, t, s, u) || u--);
            }
          } else bu(o) && this.visit(o, t, s, null);
      }
      if (this.leave) {
        const o = this.replacement, l = this.should_remove;
        this.replacement = null, this.should_remove = !1, this.leave.call(this.context, t, n, i, r), this.replacement && (t = this.replacement, this.replace(n, i, r, t)), this.should_remove && this.remove(n, i, r);
        const u = this.should_remove;
        if (this.replacement = o, this.should_remove = l, u) return null;
      }
    }
    return t;
  }
}
function bu(e) {
  return e !== null && typeof e == "object" && "type" in e && typeof e.type == "string";
}
function Qi(e, { enter: t, leave: n }) {
  return new x2(t, n).visit(e, null);
}
const ya = /@(jsx|jsxFrag|jsxImportSource|jsxRuntime)\s+(\S+)/g;
function b2(e, t) {
  const n = t || {};
  let i = n.runtime === "automatic";
  const r = {}, s = {};
  Qi(e, {
    enter(o) {
      if (o.type === "Program") {
        const l = o.comments || [];
        let u = -1;
        for (; ++u < l.length; ) {
          ya.lastIndex = 0;
          let c = ya.exec(l[u].value);
          for (; c; )
            r[c[1]] = c[2], c = ya.exec(l[u].value);
        }
        if (r.jsxRuntime)
          if (r.jsxRuntime === "automatic") {
            if (i = !0, r.jsx)
              throw new Error("Unexpected `@jsx` pragma w/ automatic runtime");
            if (r.jsxFrag)
              throw new Error(
                "Unexpected `@jsxFrag` pragma w/ automatic runtime"
              );
          } else if (r.jsxRuntime === "classic") {
            if (i = !1, r.jsxImportSource)
              throw new Error(
                "Unexpected `@jsxImportSource` w/ classic runtime"
              );
          } else
            throw new Error(
              "Unexpected `jsxRuntime` `" + r.jsxRuntime + "`, expected `automatic` or `classic`"
            );
      }
    },
    // eslint-disable-next-line complexity
    leave(o) {
      if (o.type === "Program") {
        const v = [];
        if (s.fragment && v.push({
          type: "ImportSpecifier",
          imported: { type: "Identifier", name: "Fragment" },
          local: { type: "Identifier", name: "_Fragment" }
        }), s.jsx && v.push({
          type: "ImportSpecifier",
          imported: { type: "Identifier", name: "jsx" },
          local: { type: "Identifier", name: "_jsx" }
        }), s.jsxs && v.push({
          type: "ImportSpecifier",
          imported: { type: "Identifier", name: "jsxs" },
          local: { type: "Identifier", name: "_jsxs" }
        }), s.jsxDEV && v.push({
          type: "ImportSpecifier",
          imported: { type: "Identifier", name: "jsxDEV" },
          local: { type: "Identifier", name: "_jsxDEV" }
        }), v.length > 0) {
          let w = 0;
          for (; w < o.body.length; ) {
            const x = o.body[w];
            if ("directive" in x && x.directive)
              w++;
            else
              break;
          }
          o.body.splice(w, 0, {
            type: "ImportDeclaration",
            specifiers: v,
            source: {
              type: "Literal",
              value: (r.jsxImportSource || n.importSource || "react") + (n.development ? "/jsx-dev-runtime" : "/jsx-runtime")
            }
          });
        }
      }
      if (o.type !== "JSXElement" && o.type !== "JSXFragment")
        return;
      const l = [];
      let u = -1;
      for (; ++u < o.children.length; ) {
        const v = o.children[u];
        if (v.type === "JSXExpressionContainer")
          v.expression.type !== "JSXEmptyExpression" && l.push(v.expression);
        else if (v.type === "JSXText") {
          const w = v.value.replace(/\t/g, " ").replace(/ *(\r?\n|\r) */g, `
`).replace(/\n+/g, `
`).replace(/\n+$/, "").replace(/^\n+/, "").replace(/\n/g, " ");
          if (w) {
            const x = { type: "Literal", value: w };
            zr(v, x), l.push(x);
          }
        } else
          v.type !== "JSXElement" && v.type !== "JSXFragment" && v.type, l.push(v);
      }
      let c;
      const d = [];
      let h = [], m;
      if (o.type === "JSXElement") {
        if (c = Ns(o.openingElement.name), c.type === "Identifier" && /^[a-z]/.test(c.name)) {
          const A = { type: "Literal", value: c.name };
          zr(c, A), c = A;
        }
        let v;
        const w = o.openingElement.attributes;
        let x = -1;
        for (; ++x < w.length; ) {
          const A = w[x];
          if (A.type === "JSXSpreadAttribute")
            A.argument.type === "ObjectExpression" ? d.push(...A.argument.properties) : d.push({ type: "SpreadElement", argument: A.argument }), v = !0;
          else {
            const S = y2(A);
            if (i && S.key.type === "Identifier" && S.key.name === "key") {
              if (v)
                throw new Error(
                  "Expected `key` to come before any spread expressions"
                );
              const N = S.value;
              N.type !== "AssignmentPattern" && N.type !== "ArrayPattern" && N.type !== "ObjectPattern" && N.type, m = N;
            } else
              d.push(S);
          }
        }
      } else i ? (s.fragment = !0, c = { type: "Identifier", name: "_Fragment" }) : c = yu(
        r.jsxFrag || n.pragmaFrag || "React.Fragment"
      );
      i ? l.length > 0 && d.push({
        type: "Property",
        key: { type: "Identifier", name: "children" },
        value: l.length > 1 ? { type: "ArrayExpression", elements: l } : l[0],
        kind: "init",
        method: !1,
        shorthand: !1,
        computed: !1
      }) : h = l;
      let _;
      if (i) {
        h.push({ type: "ObjectExpression", properties: d }), m ? h.push(m) : n.development && h.push({ type: "Identifier", name: "undefined" });
        const v = l.length > 1;
        if (n.development) {
          s.jsxDEV = !0, _ = {
            type: "Identifier",
            name: "_jsxDEV"
          }, h.push({ type: "Literal", value: v });
          const w = {
            type: "ObjectExpression",
            properties: [
              {
                type: "Property",
                method: !1,
                shorthand: !1,
                computed: !1,
                kind: "init",
                key: { type: "Identifier", name: "fileName" },
                value: {
                  type: "Literal",
                  value: n.filePath || "<source.js>"
                }
              }
            ]
          };
          o.loc && w.properties.push(
            {
              type: "Property",
              method: !1,
              shorthand: !1,
              computed: !1,
              kind: "init",
              key: { type: "Identifier", name: "lineNumber" },
              value: { type: "Literal", value: o.loc.start.line }
            },
            {
              type: "Property",
              method: !1,
              shorthand: !1,
              computed: !1,
              kind: "init",
              key: { type: "Identifier", name: "columnNumber" },
              value: { type: "Literal", value: o.loc.start.column + 1 }
            }
          ), h.push(w, { type: "ThisExpression" });
        } else v ? (s.jsxs = !0, _ = { type: "Identifier", name: "_jsxs" }) : (s.jsx = !0, _ = { type: "Identifier", name: "_jsx" });
      } else
        d.length > 0 ? h.unshift({ type: "ObjectExpression", properties: d }) : h.length > 0 && h.unshift({ type: "Literal", value: null }), _ = yu(
          r.jsx || n.pragma || "React.createElement"
        );
      h.unshift(c);
      const y = {
        type: "CallExpression",
        callee: _,
        arguments: h,
        optional: !1
      };
      zr(o, y), this.replace(y);
    }
  });
}
function y2(e) {
  let t;
  if (e.value)
    if (e.value.type === "JSXExpressionContainer") {
      const i = e.value.expression;
      i.type, t = i;
    } else {
      const i = e.value;
      i.type !== "JSXElement" && i.type, t = i, delete t.raw;
    }
  else
    t = { type: "Literal", value: !0 };
  const n = {
    type: "Property",
    key: Ns(e.name),
    value: t,
    kind: "init",
    method: !1,
    shorthand: !1,
    computed: !1
  };
  return zr(e, n), n;
}
function Ns(e) {
  let t;
  if (e.type === "JSXMemberExpression") {
    const n = Ns(e.property);
    t = {
      type: "MemberExpression",
      object: Ns(e.object),
      property: n,
      computed: n.type === "Literal",
      optional: !1
    };
  } else e.type === "JSXNamespacedName" ? t = {
    type: "Literal",
    value: e.namespace.name + ":" + e.name.name
  } : t = Mn(e.name) ? { type: "Identifier", name: e.name } : { type: "Literal", value: e.name };
  return zr(e, t), t;
}
function yu(e) {
  const t = e.split(".");
  let n = -1, i;
  for (; ++n < t.length; ) {
    const r = Mn(t[n]) ? { type: "Identifier", name: t[n] } : { type: "Literal", value: t[n] };
    i = i ? {
      type: "MemberExpression",
      object: i,
      property: r,
      computed: !!(n && r.type === "Literal"),
      optional: !1
    } : r;
  }
  return i;
}
function zr(e, t) {
  const n = ["start", "end", "loc", "range", "comments"];
  let i = -1;
  for (; ++i < n.length; ) {
    const r = n[i];
    r in e && (t[r] = e[r]);
  }
}
function v2(e) {
  return function(t, n) {
    b2(t, { filePath: n.history[0], ...e });
  };
}
var va = { exports: {} }, wa, vu;
function w2() {
  return vu || (vu = 1, wa = {
    quot: '"',
    amp: "&",
    apos: "'",
    lt: "<",
    gt: ">",
    nbsp: " ",
    iexcl: "¡",
    cent: "¢",
    pound: "£",
    curren: "¤",
    yen: "¥",
    brvbar: "¦",
    sect: "§",
    uml: "¨",
    copy: "©",
    ordf: "ª",
    laquo: "«",
    not: "¬",
    shy: "­",
    reg: "®",
    macr: "¯",
    deg: "°",
    plusmn: "±",
    sup2: "²",
    sup3: "³",
    acute: "´",
    micro: "µ",
    para: "¶",
    middot: "·",
    cedil: "¸",
    sup1: "¹",
    ordm: "º",
    raquo: "»",
    frac14: "¼",
    frac12: "½",
    frac34: "¾",
    iquest: "¿",
    Agrave: "À",
    Aacute: "Á",
    Acirc: "Â",
    Atilde: "Ã",
    Auml: "Ä",
    Aring: "Å",
    AElig: "Æ",
    Ccedil: "Ç",
    Egrave: "È",
    Eacute: "É",
    Ecirc: "Ê",
    Euml: "Ë",
    Igrave: "Ì",
    Iacute: "Í",
    Icirc: "Î",
    Iuml: "Ï",
    ETH: "Ð",
    Ntilde: "Ñ",
    Ograve: "Ò",
    Oacute: "Ó",
    Ocirc: "Ô",
    Otilde: "Õ",
    Ouml: "Ö",
    times: "×",
    Oslash: "Ø",
    Ugrave: "Ù",
    Uacute: "Ú",
    Ucirc: "Û",
    Uuml: "Ü",
    Yacute: "Ý",
    THORN: "Þ",
    szlig: "ß",
    agrave: "à",
    aacute: "á",
    acirc: "â",
    atilde: "ã",
    auml: "ä",
    aring: "å",
    aelig: "æ",
    ccedil: "ç",
    egrave: "è",
    eacute: "é",
    ecirc: "ê",
    euml: "ë",
    igrave: "ì",
    iacute: "í",
    icirc: "î",
    iuml: "ï",
    eth: "ð",
    ntilde: "ñ",
    ograve: "ò",
    oacute: "ó",
    ocirc: "ô",
    otilde: "õ",
    ouml: "ö",
    divide: "÷",
    oslash: "ø",
    ugrave: "ù",
    uacute: "ú",
    ucirc: "û",
    uuml: "ü",
    yacute: "ý",
    thorn: "þ",
    yuml: "ÿ",
    OElig: "Œ",
    oelig: "œ",
    Scaron: "Š",
    scaron: "š",
    Yuml: "Ÿ",
    fnof: "ƒ",
    circ: "ˆ",
    tilde: "˜",
    Alpha: "Α",
    Beta: "Β",
    Gamma: "Γ",
    Delta: "Δ",
    Epsilon: "Ε",
    Zeta: "Ζ",
    Eta: "Η",
    Theta: "Θ",
    Iota: "Ι",
    Kappa: "Κ",
    Lambda: "Λ",
    Mu: "Μ",
    Nu: "Ν",
    Xi: "Ξ",
    Omicron: "Ο",
    Pi: "Π",
    Rho: "Ρ",
    Sigma: "Σ",
    Tau: "Τ",
    Upsilon: "Υ",
    Phi: "Φ",
    Chi: "Χ",
    Psi: "Ψ",
    Omega: "Ω",
    alpha: "α",
    beta: "β",
    gamma: "γ",
    delta: "δ",
    epsilon: "ε",
    zeta: "ζ",
    eta: "η",
    theta: "θ",
    iota: "ι",
    kappa: "κ",
    lambda: "λ",
    mu: "μ",
    nu: "ν",
    xi: "ξ",
    omicron: "ο",
    pi: "π",
    rho: "ρ",
    sigmaf: "ς",
    sigma: "σ",
    tau: "τ",
    upsilon: "υ",
    phi: "φ",
    chi: "χ",
    psi: "ψ",
    omega: "ω",
    thetasym: "ϑ",
    upsih: "ϒ",
    piv: "ϖ",
    ensp: " ",
    emsp: " ",
    thinsp: " ",
    zwnj: "‌",
    zwj: "‍",
    lrm: "‎",
    rlm: "‏",
    ndash: "–",
    mdash: "—",
    lsquo: "‘",
    rsquo: "’",
    sbquo: "‚",
    ldquo: "“",
    rdquo: "”",
    bdquo: "„",
    dagger: "†",
    Dagger: "‡",
    bull: "•",
    hellip: "…",
    permil: "‰",
    prime: "′",
    Prime: "″",
    lsaquo: "‹",
    rsaquo: "›",
    oline: "‾",
    frasl: "⁄",
    euro: "€",
    image: "ℑ",
    weierp: "℘",
    real: "ℜ",
    trade: "™",
    alefsym: "ℵ",
    larr: "←",
    uarr: "↑",
    rarr: "→",
    darr: "↓",
    harr: "↔",
    crarr: "↵",
    lArr: "⇐",
    uArr: "⇑",
    rArr: "⇒",
    dArr: "⇓",
    hArr: "⇔",
    forall: "∀",
    part: "∂",
    exist: "∃",
    empty: "∅",
    nabla: "∇",
    isin: "∈",
    notin: "∉",
    ni: "∋",
    prod: "∏",
    sum: "∑",
    minus: "−",
    lowast: "∗",
    radic: "√",
    prop: "∝",
    infin: "∞",
    ang: "∠",
    and: "∧",
    or: "∨",
    cap: "∩",
    cup: "∪",
    int: "∫",
    there4: "∴",
    sim: "∼",
    cong: "≅",
    asymp: "≈",
    ne: "≠",
    equiv: "≡",
    le: "≤",
    ge: "≥",
    sub: "⊂",
    sup: "⊃",
    nsub: "⊄",
    sube: "⊆",
    supe: "⊇",
    oplus: "⊕",
    otimes: "⊗",
    perp: "⊥",
    sdot: "⋅",
    lceil: "⌈",
    rceil: "⌉",
    lfloor: "⌊",
    rfloor: "⌋",
    lang: "〈",
    rang: "〉",
    loz: "◊",
    spades: "♠",
    clubs: "♣",
    hearts: "♥",
    diams: "♦"
  }), wa;
}
var Mr = { exports: {} }, k2 = Mr.exports, wu;
function ku() {
  return wu || (wu = 1, (function(e, t) {
    (function(n, i) {
      i(t);
    })(k2, (function(n) {
      var i = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], r = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], s = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", o = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟍꟐꟑꟓꟕ-Ƛꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", l = {
        3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
        5: "class enum extends super const export import",
        6: "enum",
        strict: "implements interface let package private protected public static yield",
        strictBind: "eval arguments"
      }, u = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", c = {
        5: u,
        "5module": u + " export import",
        6: u + " const class extends export import super"
      }, d = /^in(stanceof)?$/, h = new RegExp("[" + o + "]"), m = new RegExp("[" + o + s + "]");
      function _(a, p) {
        for (var b = 65536, k = 0; k < p.length; k += 2) {
          if (b += p[k], b > a)
            return !1;
          if (b += p[k + 1], b >= a)
            return !0;
        }
        return !1;
      }
      function y(a, p) {
        return a < 65 ? a === 36 : a < 91 ? !0 : a < 97 ? a === 95 : a < 123 ? !0 : a <= 65535 ? a >= 170 && h.test(String.fromCharCode(a)) : p === !1 ? !1 : _(a, r);
      }
      function v(a, p) {
        return a < 48 ? a === 36 : a < 58 ? !0 : a < 65 ? !1 : a < 91 ? !0 : a < 97 ? a === 95 : a < 123 ? !0 : a <= 65535 ? a >= 170 && m.test(String.fromCharCode(a)) : p === !1 ? !1 : _(a, r) || _(a, i);
      }
      var w = function(p, b) {
        b === void 0 && (b = {}), this.label = p, this.keyword = b.keyword, this.beforeExpr = !!b.beforeExpr, this.startsExpr = !!b.startsExpr, this.isLoop = !!b.isLoop, this.isAssign = !!b.isAssign, this.prefix = !!b.prefix, this.postfix = !!b.postfix, this.binop = b.binop || null, this.updateContext = null;
      };
      function x(a, p) {
        return new w(a, { beforeExpr: !0, binop: p });
      }
      var A = { beforeExpr: !0 }, S = { startsExpr: !0 }, N = {};
      function E(a, p) {
        return p === void 0 && (p = {}), p.keyword = a, N[a] = new w(a, p);
      }
      var f = {
        num: new w("num", S),
        regexp: new w("regexp", S),
        string: new w("string", S),
        name: new w("name", S),
        privateId: new w("privateId", S),
        eof: new w("eof"),
        // Punctuation token types.
        bracketL: new w("[", { beforeExpr: !0, startsExpr: !0 }),
        bracketR: new w("]"),
        braceL: new w("{", { beforeExpr: !0, startsExpr: !0 }),
        braceR: new w("}"),
        parenL: new w("(", { beforeExpr: !0, startsExpr: !0 }),
        parenR: new w(")"),
        comma: new w(",", A),
        semi: new w(";", A),
        colon: new w(":", A),
        dot: new w("."),
        question: new w("?", A),
        questionDot: new w("?."),
        arrow: new w("=>", A),
        template: new w("template"),
        invalidTemplate: new w("invalidTemplate"),
        ellipsis: new w("...", A),
        backQuote: new w("`", S),
        dollarBraceL: new w("${", { beforeExpr: !0, startsExpr: !0 }),
        // Operators. These carry several kinds of properties to help the
        // parser use them properly (the presence of these properties is
        // what categorizes them as operators).
        //
        // `binop`, when present, specifies that this operator is a binary
        // operator, and will refer to its precedence.
        //
        // `prefix` and `postfix` mark the operator as a prefix or postfix
        // unary operator.
        //
        // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
        // binary operators with a very low precedence, that should result
        // in AssignmentExpression nodes.
        eq: new w("=", { beforeExpr: !0, isAssign: !0 }),
        assign: new w("_=", { beforeExpr: !0, isAssign: !0 }),
        incDec: new w("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
        prefix: new w("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        logicalOR: x("||", 1),
        logicalAND: x("&&", 2),
        bitwiseOR: x("|", 3),
        bitwiseXOR: x("^", 4),
        bitwiseAND: x("&", 5),
        equality: x("==/!=/===/!==", 6),
        relational: x("</>/<=/>=", 7),
        bitShift: x("<</>>/>>>", 8),
        plusMin: new w("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
        modulo: x("%", 10),
        star: x("*", 10),
        slash: x("/", 10),
        starstar: new w("**", { beforeExpr: !0 }),
        coalesce: x("??", 1),
        // Keyword token types.
        _break: E("break"),
        _case: E("case", A),
        _catch: E("catch"),
        _continue: E("continue"),
        _debugger: E("debugger"),
        _default: E("default", A),
        _do: E("do", { isLoop: !0, beforeExpr: !0 }),
        _else: E("else", A),
        _finally: E("finally"),
        _for: E("for", { isLoop: !0 }),
        _function: E("function", S),
        _if: E("if"),
        _return: E("return", A),
        _switch: E("switch"),
        _throw: E("throw", A),
        _try: E("try"),
        _var: E("var"),
        _const: E("const"),
        _while: E("while", { isLoop: !0 }),
        _with: E("with"),
        _new: E("new", { beforeExpr: !0, startsExpr: !0 }),
        _this: E("this", S),
        _super: E("super", S),
        _class: E("class", S),
        _extends: E("extends", A),
        _export: E("export"),
        _import: E("import", S),
        _null: E("null", S),
        _true: E("true", S),
        _false: E("false", S),
        _in: E("in", { beforeExpr: !0, binop: 7 }),
        _instanceof: E("instanceof", { beforeExpr: !0, binop: 7 }),
        _typeof: E("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _void: E("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _delete: E("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
      }, C = /\r\n?|\n|\u2028|\u2029/, L = new RegExp(C.source, "g");
      function R(a) {
        return a === 10 || a === 13 || a === 8232 || a === 8233;
      }
      function V(a, p, b) {
        b === void 0 && (b = a.length);
        for (var k = p; k < b; k++) {
          var M = a.charCodeAt(k);
          if (R(M))
            return k < b - 1 && M === 13 && a.charCodeAt(k + 1) === 10 ? k + 2 : k + 1;
        }
        return -1;
      }
      var z = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, $ = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, H = Object.prototype, B = H.hasOwnProperty, O = H.toString, W = Object.hasOwn || (function(a, p) {
        return B.call(a, p);
      }), G = Array.isArray || (function(a) {
        return O.call(a) === "[object Array]";
      }), re = /* @__PURE__ */ Object.create(null);
      function K(a) {
        return re[a] || (re[a] = new RegExp("^(?:" + a.replace(/ /g, "|") + ")$"));
      }
      function P(a) {
        return a <= 65535 ? String.fromCharCode(a) : (a -= 65536, String.fromCharCode((a >> 10) + 55296, (a & 1023) + 56320));
      }
      var oe = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, se = function(p, b) {
        this.line = p, this.column = b;
      };
      se.prototype.offset = function(p) {
        return new se(this.line, this.column + p);
      };
      var D = function(p, b, k) {
        this.start = b, this.end = k, p.sourceFile !== null && (this.source = p.sourceFile);
      };
      function pe(a, p) {
        for (var b = 1, k = 0; ; ) {
          var M = V(a, k, p);
          if (M < 0)
            return new se(b, p - k);
          ++b, k = M;
        }
      }
      var Ce = {
        // `ecmaVersion` indicates the ECMAScript version to parse. Must be
        // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
        // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
        // (the latest version the library supports). This influences
        // support for strict mode, the set of reserved words, and support
        // for new syntax features.
        ecmaVersion: null,
        // `sourceType` indicates the mode the code should be parsed in.
        // Can be either `"script"` or `"module"`. This influences global
        // strict mode and parsing of `import` and `export` declarations.
        sourceType: "script",
        // `onInsertedSemicolon` can be a callback that will be called when
        // a semicolon is automatically inserted. It will be passed the
        // position of the inserted semicolon as an offset, and if
        // `locations` is enabled, it is given the location as a `{line,
        // column}` object as second argument.
        onInsertedSemicolon: null,
        // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
        // trailing commas.
        onTrailingComma: null,
        // By default, reserved words are only enforced if ecmaVersion >= 5.
        // Set `allowReserved` to a boolean value to explicitly turn this on
        // an off. When this option has the value "never", reserved words
        // and keywords can also not be used as property names.
        allowReserved: null,
        // When enabled, a return at the top level is not considered an
        // error.
        allowReturnOutsideFunction: !1,
        // When enabled, import/export statements are not constrained to
        // appearing at the top of the program, and an import.meta expression
        // in a script isn't considered an error.
        allowImportExportEverywhere: !1,
        // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
        // When enabled, await identifiers are allowed to appear at the top-level scope,
        // but they are still not allowed in non-async functions.
        allowAwaitOutsideFunction: null,
        // When enabled, super identifiers are not constrained to
        // appearing in methods and do not raise an error when they appear elsewhere.
        allowSuperOutsideMethod: null,
        // When enabled, hashbang directive in the beginning of file is
        // allowed and treated as a line comment. Enabled by default when
        // `ecmaVersion` >= 2023.
        allowHashBang: !1,
        // By default, the parser will verify that private properties are
        // only used in places where they are valid and have been declared.
        // Set this to false to turn such checks off.
        checkPrivateFields: !0,
        // When `locations` is on, `loc` properties holding objects with
        // `start` and `end` properties in `{line, column}` form (with
        // line being 1-based and column 0-based) will be attached to the
        // nodes.
        locations: !1,
        // A function can be passed as `onToken` option, which will
        // cause Acorn to call that function with object in the same
        // format as tokens returned from `tokenizer().getToken()`. Note
        // that you are not allowed to call the parser from the
        // callback—that will corrupt its internal state.
        onToken: null,
        // A function can be passed as `onComment` option, which will
        // cause Acorn to call that function with `(block, text, start,
        // end)` parameters whenever a comment is skipped. `block` is a
        // boolean indicating whether this is a block (`/* */`) comment,
        // `text` is the content of the comment, and `start` and `end` are
        // character offsets that denote the start and end of the comment.
        // When the `locations` option is on, two more parameters are
        // passed, the full `{line, column}` locations of the start and
        // end of the comments. Note that you are not allowed to call the
        // parser from the callback—that will corrupt its internal state.
        // When this option has an array as value, objects representing the
        // comments are pushed to it.
        onComment: null,
        // Nodes have their start and end characters offsets recorded in
        // `start` and `end` properties (directly on the node, rather than
        // the `loc` object, which holds line/column data. To also add a
        // [semi-standardized][range] `range` property holding a `[start,
        // end]` array with the same numbers, set the `ranges` option to
        // `true`.
        //
        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
        ranges: !1,
        // It is possible to parse multiple files into a single AST by
        // passing the tree produced by parsing the first file as
        // `program` option in subsequent parses. This will add the
        // toplevel forms of the parsed file to the `Program` (top) node
        // of an existing parse tree.
        program: null,
        // When `locations` is on, you can pass this to record the source
        // file in every node's `loc` object.
        sourceFile: null,
        // This value, if given, is stored in every node, whether
        // `locations` is on or off.
        directSourceFile: null,
        // When enabled, parenthesized expressions are represented by
        // (non-standard) ParenthesizedExpression nodes
        preserveParens: !1
      }, Z = !1;
      function j(a) {
        var p = {};
        for (var b in Ce)
          p[b] = a && W(a, b) ? a[b] : Ce[b];
        if (p.ecmaVersion === "latest" ? p.ecmaVersion = 1e8 : p.ecmaVersion == null ? (!Z && typeof console == "object" && console.warn && (Z = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), p.ecmaVersion = 11) : p.ecmaVersion >= 2015 && (p.ecmaVersion -= 2009), p.allowReserved == null && (p.allowReserved = p.ecmaVersion < 5), (!a || a.allowHashBang == null) && (p.allowHashBang = p.ecmaVersion >= 14), G(p.onToken)) {
          var k = p.onToken;
          p.onToken = function(M) {
            return k.push(M);
          };
        }
        return G(p.onComment) && (p.onComment = ie(p, p.onComment)), p;
      }
      function ie(a, p) {
        return function(b, k, M, U, J, ae) {
          var de = {
            type: b ? "Block" : "Line",
            value: k,
            start: M,
            end: U
          };
          a.locations && (de.loc = new D(this, J, ae)), a.ranges && (de.range = [M, U]), p.push(de);
        };
      }
      var te = 1, ge = 2, ne = 4, _e = 8, Ie = 16, Ve = 32, nt = 64, Ke = 128, pt = 256, Be = 512, xt = te | ge | pt;
      function kt(a, p) {
        return ge | (a ? ne : 0) | (p ? _e : 0);
      }
      var ft = 0, Fe = 1, je = 2, Re = 3, on = 4, Q = 5, Y = function(p, b, k) {
        this.options = p = j(p), this.sourceFile = p.sourceFile, this.keywords = K(c[p.ecmaVersion >= 6 ? 6 : p.sourceType === "module" ? "5module" : 5]);
        var M = "";
        p.allowReserved !== !0 && (M = l[p.ecmaVersion >= 6 ? 6 : p.ecmaVersion === 5 ? 5 : 3], p.sourceType === "module" && (M += " await")), this.reservedWords = K(M);
        var U = (M ? M + " " : "") + l.strict;
        this.reservedWordsStrict = K(U), this.reservedWordsStrictBind = K(U + " " + l.strictBind), this.input = String(b), this.containsEsc = !1, k ? (this.pos = k, this.lineStart = this.input.lastIndexOf(`
`, k - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(C).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = f.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = p.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && p.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(te), this.regexpState = null, this.privateNameStack = [];
      }, T = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
      Y.prototype.parse = function() {
        var p = this.options.program || this.startNode();
        return this.nextToken(), this.parseTopLevel(p);
      }, T.inFunction.get = function() {
        return (this.currentVarScope().flags & ge) > 0;
      }, T.inGenerator.get = function() {
        return (this.currentVarScope().flags & _e) > 0;
      }, T.inAsync.get = function() {
        return (this.currentVarScope().flags & ne) > 0;
      }, T.canAwait.get = function() {
        for (var a = this.scopeStack.length - 1; a >= 0; a--) {
          var p = this.scopeStack[a], b = p.flags;
          if (b & (pt | Be))
            return !1;
          if (b & ge)
            return (b & ne) > 0;
        }
        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
      }, T.allowSuper.get = function() {
        var a = this.currentThisScope(), p = a.flags;
        return (p & nt) > 0 || this.options.allowSuperOutsideMethod;
      }, T.allowDirectSuper.get = function() {
        return (this.currentThisScope().flags & Ke) > 0;
      }, T.treatFunctionsAsVar.get = function() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
      }, T.allowNewDotTarget.get = function() {
        for (var a = this.scopeStack.length - 1; a >= 0; a--) {
          var p = this.scopeStack[a], b = p.flags;
          if (b & (pt | Be) || b & ge && !(b & Ie))
            return !0;
        }
        return !1;
      }, T.inClassStaticBlock.get = function() {
        return (this.currentVarScope().flags & pt) > 0;
      }, Y.extend = function() {
        for (var p = [], b = arguments.length; b--; ) p[b] = arguments[b];
        for (var k = this, M = 0; M < p.length; M++)
          k = p[M](k);
        return k;
      }, Y.parse = function(p, b) {
        return new this(b, p).parse();
      }, Y.parseExpressionAt = function(p, b, k) {
        var M = new this(k, p, b);
        return M.nextToken(), M.parseExpression();
      }, Y.tokenizer = function(p, b) {
        return new this(b, p);
      }, Object.defineProperties(Y.prototype, T);
      var Se = Y.prototype, He = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
      Se.strictDirective = function(a) {
        if (this.options.ecmaVersion < 5)
          return !1;
        for (; ; ) {
          $.lastIndex = a, a += $.exec(this.input)[0].length;
          var p = He.exec(this.input.slice(a));
          if (!p)
            return !1;
          if ((p[1] || p[2]) === "use strict") {
            $.lastIndex = a + p[0].length;
            var b = $.exec(this.input), k = b.index + b[0].length, M = this.input.charAt(k);
            return M === ";" || M === "}" || C.test(b[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(M) || M === "!" && this.input.charAt(k + 1) === "=");
          }
          a += p[0].length, $.lastIndex = a, a += $.exec(this.input)[0].length, this.input[a] === ";" && a++;
        }
      }, Se.eat = function(a) {
        return this.type === a ? (this.next(), !0) : !1;
      }, Se.isContextual = function(a) {
        return this.type === f.name && this.value === a && !this.containsEsc;
      }, Se.eatContextual = function(a) {
        return this.isContextual(a) ? (this.next(), !0) : !1;
      }, Se.expectContextual = function(a) {
        this.eatContextual(a) || this.unexpected();
      }, Se.canInsertSemicolon = function() {
        return this.type === f.eof || this.type === f.braceR || C.test(this.input.slice(this.lastTokEnd, this.start));
      }, Se.insertSemicolon = function() {
        if (this.canInsertSemicolon())
          return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
      }, Se.semicolon = function() {
        !this.eat(f.semi) && !this.insertSemicolon() && this.unexpected();
      }, Se.afterTrailingComma = function(a, p) {
        if (this.type === a)
          return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), p || this.next(), !0;
      }, Se.expect = function(a) {
        this.eat(a) || this.unexpected();
      }, Se.unexpected = function(a) {
        this.raise(a ?? this.start, "Unexpected token");
      };
      var ut = function() {
        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
      };
      Se.checkPatternErrors = function(a, p) {
        if (a) {
          a.trailingComma > -1 && this.raiseRecoverable(a.trailingComma, "Comma is not permitted after the rest element");
          var b = p ? a.parenthesizedAssign : a.parenthesizedBind;
          b > -1 && this.raiseRecoverable(b, p ? "Assigning to rvalue" : "Parenthesized pattern");
        }
      }, Se.checkExpressionErrors = function(a, p) {
        if (!a)
          return !1;
        var b = a.shorthandAssign, k = a.doubleProto;
        if (!p)
          return b >= 0 || k >= 0;
        b >= 0 && this.raise(b, "Shorthand property assignments are valid only in destructuring patterns"), k >= 0 && this.raiseRecoverable(k, "Redefinition of __proto__ property");
      }, Se.checkYieldAwaitInDefaultParams = function() {
        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
      }, Se.isSimpleAssignTarget = function(a) {
        return a.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(a.expression) : a.type === "Identifier" || a.type === "MemberExpression";
      };
      var ue = Y.prototype;
      ue.parseTopLevel = function(a) {
        var p = /* @__PURE__ */ Object.create(null);
        for (a.body || (a.body = []); this.type !== f.eof; ) {
          var b = this.parseStatement(null, !0, p);
          a.body.push(b);
        }
        if (this.inModule)
          for (var k = 0, M = Object.keys(this.undefinedExports); k < M.length; k += 1) {
            var U = M[k];
            this.raiseRecoverable(this.undefinedExports[U].start, "Export '" + U + "' is not defined");
          }
        return this.adaptDirectivePrologue(a.body), this.next(), a.sourceType = this.options.sourceType, this.finishNode(a, "Program");
      };
      var _t = { kind: "loop" }, Tt = { kind: "switch" };
      ue.isLet = function(a) {
        if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
          return !1;
        $.lastIndex = this.pos;
        var p = $.exec(this.input), b = this.pos + p[0].length, k = this.input.charCodeAt(b);
        if (k === 91 || k === 92)
          return !0;
        if (a)
          return !1;
        if (k === 123 || k > 55295 && k < 56320)
          return !0;
        if (y(k, !0)) {
          for (var M = b + 1; v(k = this.input.charCodeAt(M), !0); )
            ++M;
          if (k === 92 || k > 55295 && k < 56320)
            return !0;
          var U = this.input.slice(b, M);
          if (!d.test(U))
            return !0;
        }
        return !1;
      }, ue.isAsyncFunction = function() {
        if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
          return !1;
        $.lastIndex = this.pos;
        var a = $.exec(this.input), p = this.pos + a[0].length, b;
        return !C.test(this.input.slice(this.pos, p)) && this.input.slice(p, p + 8) === "function" && (p + 8 === this.input.length || !(v(b = this.input.charCodeAt(p + 8)) || b > 55295 && b < 56320));
      }, ue.isUsingKeyword = function(a, p) {
        if (this.options.ecmaVersion < 17 || !this.isContextual(a ? "await" : "using"))
          return !1;
        $.lastIndex = this.pos;
        var b = $.exec(this.input), k = this.pos + b[0].length;
        if (C.test(this.input.slice(this.pos, k)))
          return !1;
        if (a) {
          var M = k + 5, U;
          if (this.input.slice(k, M) !== "using" || M === this.input.length || v(U = this.input.charCodeAt(M)) || U > 55295 && U < 56320)
            return !1;
          $.lastIndex = M;
          var J = $.exec(this.input);
          if (J && C.test(this.input.slice(M, M + J[0].length)))
            return !1;
        }
        if (p) {
          var ae = k + 2, de;
          if (this.input.slice(k, ae) === "of" && (ae === this.input.length || !v(de = this.input.charCodeAt(ae)) && !(de > 55295 && de < 56320)))
            return !1;
        }
        var Te = this.input.charCodeAt(k);
        return y(Te, !0) || Te === 92;
      }, ue.isAwaitUsing = function(a) {
        return this.isUsingKeyword(!0, a);
      }, ue.isUsing = function(a) {
        return this.isUsingKeyword(!1, a);
      }, ue.parseStatement = function(a, p, b) {
        var k = this.type, M = this.startNode(), U;
        switch (this.isLet(a) && (k = f._var, U = "let"), k) {
          case f._break:
          case f._continue:
            return this.parseBreakContinueStatement(M, k.keyword);
          case f._debugger:
            return this.parseDebuggerStatement(M);
          case f._do:
            return this.parseDoStatement(M);
          case f._for:
            return this.parseForStatement(M);
          case f._function:
            return a && (this.strict || a !== "if" && a !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(M, !1, !a);
          case f._class:
            return a && this.unexpected(), this.parseClass(M, !0);
          case f._if:
            return this.parseIfStatement(M);
          case f._return:
            return this.parseReturnStatement(M);
          case f._switch:
            return this.parseSwitchStatement(M);
          case f._throw:
            return this.parseThrowStatement(M);
          case f._try:
            return this.parseTryStatement(M);
          case f._const:
          case f._var:
            return U = U || this.value, a && U !== "var" && this.unexpected(), this.parseVarStatement(M, U);
          case f._while:
            return this.parseWhileStatement(M);
          case f._with:
            return this.parseWithStatement(M);
          case f.braceL:
            return this.parseBlock(!0, M);
          case f.semi:
            return this.parseEmptyStatement(M);
          case f._export:
          case f._import:
            if (this.options.ecmaVersion > 10 && k === f._import) {
              $.lastIndex = this.pos;
              var J = $.exec(this.input), ae = this.pos + J[0].length, de = this.input.charCodeAt(ae);
              if (de === 40 || de === 46)
                return this.parseExpressionStatement(M, this.parseExpression());
            }
            return this.options.allowImportExportEverywhere || (p || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), k === f._import ? this.parseImport(M) : this.parseExport(M, b);
          // If the statement does not start with a statement keyword or a
          // brace, it's an ExpressionStatement or LabeledStatement. We
          // simply start parsing an expression, and afterwards, if the
          // next token is a colon and the expression was a simple
          // Identifier node, we switch to interpreting it as a label.
          default:
            if (this.isAsyncFunction())
              return a && this.unexpected(), this.next(), this.parseFunctionStatement(M, !0, !a);
            var Te = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
            if (Te)
              return p && this.options.sourceType === "script" && this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script`"), Te === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(M, !1, Te), this.semicolon(), this.finishNode(M, "VariableDeclaration");
            var ze = this.value, ot = this.parseExpression();
            return k === f.name && ot.type === "Identifier" && this.eat(f.colon) ? this.parseLabeledStatement(M, ze, ot, a) : this.parseExpressionStatement(M, ot);
        }
      }, ue.parseBreakContinueStatement = function(a, p) {
        var b = p === "break";
        this.next(), this.eat(f.semi) || this.insertSemicolon() ? a.label = null : this.type !== f.name ? this.unexpected() : (a.label = this.parseIdent(), this.semicolon());
        for (var k = 0; k < this.labels.length; ++k) {
          var M = this.labels[k];
          if ((a.label == null || M.name === a.label.name) && (M.kind != null && (b || M.kind === "loop") || a.label && b))
            break;
        }
        return k === this.labels.length && this.raise(a.start, "Unsyntactic " + p), this.finishNode(a, b ? "BreakStatement" : "ContinueStatement");
      }, ue.parseDebuggerStatement = function(a) {
        return this.next(), this.semicolon(), this.finishNode(a, "DebuggerStatement");
      }, ue.parseDoStatement = function(a) {
        return this.next(), this.labels.push(_t), a.body = this.parseStatement("do"), this.labels.pop(), this.expect(f._while), a.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(f.semi) : this.semicolon(), this.finishNode(a, "DoWhileStatement");
      }, ue.parseForStatement = function(a) {
        this.next();
        var p = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
        if (this.labels.push(_t), this.enterScope(0), this.expect(f.parenL), this.type === f.semi)
          return p > -1 && this.unexpected(p), this.parseFor(a, null);
        var b = this.isLet();
        if (this.type === f._var || this.type === f._const || b) {
          var k = this.startNode(), M = b ? "let" : this.value;
          return this.next(), this.parseVar(k, !0, M), this.finishNode(k, "VariableDeclaration"), this.parseForAfterInit(a, k, p);
        }
        var U = this.isContextual("let"), J = !1, ae = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
        if (ae) {
          var de = this.startNode();
          return this.next(), ae === "await using" && this.next(), this.parseVar(de, !0, ae), this.finishNode(de, "VariableDeclaration"), this.parseForAfterInit(a, de, p);
        }
        var Te = this.containsEsc, ze = new ut(), ot = this.start, Mt = p > -1 ? this.parseExprSubscripts(ze, "await") : this.parseExpression(!0, ze);
        return this.type === f._in || (J = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (p > -1 ? (this.type === f._in && this.unexpected(p), a.await = !0) : J && this.options.ecmaVersion >= 8 && (Mt.start === ot && !Te && Mt.type === "Identifier" && Mt.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (a.await = !1)), U && J && this.raise(Mt.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(Mt, !1, ze), this.checkLValPattern(Mt), this.parseForIn(a, Mt)) : (this.checkExpressionErrors(ze, !0), p > -1 && this.unexpected(p), this.parseFor(a, Mt));
      }, ue.parseForAfterInit = function(a, p, b) {
        return (this.type === f._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && p.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === f._in ? b > -1 && this.unexpected(b) : a.await = b > -1), this.parseForIn(a, p)) : (b > -1 && this.unexpected(b), this.parseFor(a, p));
      }, ue.parseFunctionStatement = function(a, p, b) {
        return this.next(), this.parseFunction(a, bt | (b ? 0 : un), !1, p);
      }, ue.parseIfStatement = function(a) {
        return this.next(), a.test = this.parseParenExpression(), a.consequent = this.parseStatement("if"), a.alternate = this.eat(f._else) ? this.parseStatement("if") : null, this.finishNode(a, "IfStatement");
      }, ue.parseReturnStatement = function(a) {
        return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(f.semi) || this.insertSemicolon() ? a.argument = null : (a.argument = this.parseExpression(), this.semicolon()), this.finishNode(a, "ReturnStatement");
      }, ue.parseSwitchStatement = function(a) {
        this.next(), a.discriminant = this.parseParenExpression(), a.cases = [], this.expect(f.braceL), this.labels.push(Tt), this.enterScope(0);
        for (var p, b = !1; this.type !== f.braceR; )
          if (this.type === f._case || this.type === f._default) {
            var k = this.type === f._case;
            p && this.finishNode(p, "SwitchCase"), a.cases.push(p = this.startNode()), p.consequent = [], this.next(), k ? p.test = this.parseExpression() : (b && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), b = !0, p.test = null), this.expect(f.colon);
          } else
            p || this.unexpected(), p.consequent.push(this.parseStatement(null));
        return this.exitScope(), p && this.finishNode(p, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(a, "SwitchStatement");
      }, ue.parseThrowStatement = function(a) {
        return this.next(), C.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), a.argument = this.parseExpression(), this.semicolon(), this.finishNode(a, "ThrowStatement");
      };
      var ln = [];
      ue.parseCatchClauseParam = function() {
        var a = this.parseBindingAtom(), p = a.type === "Identifier";
        return this.enterScope(p ? Ve : 0), this.checkLValPattern(a, p ? on : je), this.expect(f.parenR), a;
      }, ue.parseTryStatement = function(a) {
        if (this.next(), a.block = this.parseBlock(), a.handler = null, this.type === f._catch) {
          var p = this.startNode();
          this.next(), this.eat(f.parenL) ? p.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), p.param = null, this.enterScope(0)), p.body = this.parseBlock(!1), this.exitScope(), a.handler = this.finishNode(p, "CatchClause");
        }
        return a.finalizer = this.eat(f._finally) ? this.parseBlock() : null, !a.handler && !a.finalizer && this.raise(a.start, "Missing catch or finally clause"), this.finishNode(a, "TryStatement");
      }, ue.parseVarStatement = function(a, p, b) {
        return this.next(), this.parseVar(a, !1, p, b), this.semicolon(), this.finishNode(a, "VariableDeclaration");
      }, ue.parseWhileStatement = function(a) {
        return this.next(), a.test = this.parseParenExpression(), this.labels.push(_t), a.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(a, "WhileStatement");
      }, ue.parseWithStatement = function(a) {
        return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), a.object = this.parseParenExpression(), a.body = this.parseStatement("with"), this.finishNode(a, "WithStatement");
      }, ue.parseEmptyStatement = function(a) {
        return this.next(), this.finishNode(a, "EmptyStatement");
      }, ue.parseLabeledStatement = function(a, p, b, k) {
        for (var M = 0, U = this.labels; M < U.length; M += 1) {
          var J = U[M];
          J.name === p && this.raise(b.start, "Label '" + p + "' is already declared");
        }
        for (var ae = this.type.isLoop ? "loop" : this.type === f._switch ? "switch" : null, de = this.labels.length - 1; de >= 0; de--) {
          var Te = this.labels[de];
          if (Te.statementStart === a.start)
            Te.statementStart = this.start, Te.kind = ae;
          else
            break;
        }
        return this.labels.push({ name: p, kind: ae, statementStart: this.start }), a.body = this.parseStatement(k ? k.indexOf("label") === -1 ? k + "label" : k : "label"), this.labels.pop(), a.label = b, this.finishNode(a, "LabeledStatement");
      }, ue.parseExpressionStatement = function(a, p) {
        return a.expression = p, this.semicolon(), this.finishNode(a, "ExpressionStatement");
      }, ue.parseBlock = function(a, p, b) {
        for (a === void 0 && (a = !0), p === void 0 && (p = this.startNode()), p.body = [], this.expect(f.braceL), a && this.enterScope(0); this.type !== f.braceR; ) {
          var k = this.parseStatement(null);
          p.body.push(k);
        }
        return b && (this.strict = !1), this.next(), a && this.exitScope(), this.finishNode(p, "BlockStatement");
      }, ue.parseFor = function(a, p) {
        return a.init = p, this.expect(f.semi), a.test = this.type === f.semi ? null : this.parseExpression(), this.expect(f.semi), a.update = this.type === f.parenR ? null : this.parseExpression(), this.expect(f.parenR), a.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(a, "ForStatement");
      }, ue.parseForIn = function(a, p) {
        var b = this.type === f._in;
        return this.next(), p.type === "VariableDeclaration" && p.declarations[0].init != null && (!b || this.options.ecmaVersion < 8 || this.strict || p.kind !== "var" || p.declarations[0].id.type !== "Identifier") && this.raise(
          p.start,
          (b ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
        ), a.left = p, a.right = b ? this.parseExpression() : this.parseMaybeAssign(), this.expect(f.parenR), a.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(a, b ? "ForInStatement" : "ForOfStatement");
      }, ue.parseVar = function(a, p, b, k) {
        for (a.declarations = [], a.kind = b; ; ) {
          var M = this.startNode();
          if (this.parseVarId(M, b), this.eat(f.eq) ? M.init = this.parseMaybeAssign(p) : !k && b === "const" && !(this.type === f._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !k && (b === "using" || b === "await using") && this.options.ecmaVersion >= 17 && this.type !== f._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + b + " declaration") : !k && M.id.type !== "Identifier" && !(p && (this.type === f._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : M.init = null, a.declarations.push(this.finishNode(M, "VariableDeclarator")), !this.eat(f.comma))
            break;
        }
        return a;
      }, ue.parseVarId = function(a, p) {
        a.id = p === "using" || p === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(a.id, p === "var" ? Fe : je, !1);
      };
      var bt = 1, un = 2, qt = 4;
      ue.parseFunction = function(a, p, b, k, M) {
        this.initFunction(a), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !k) && (this.type === f.star && p & un && this.unexpected(), a.generator = this.eat(f.star)), this.options.ecmaVersion >= 8 && (a.async = !!k), p & bt && (a.id = p & qt && this.type !== f.name ? null : this.parseIdent(), a.id && !(p & un) && this.checkLValSimple(a.id, this.strict || a.generator || a.async ? this.treatFunctionsAsVar ? Fe : je : Re));
        var U = this.yieldPos, J = this.awaitPos, ae = this.awaitIdentPos;
        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(kt(a.async, a.generator)), p & bt || (a.id = this.type === f.name ? this.parseIdent() : null), this.parseFunctionParams(a), this.parseFunctionBody(a, b, !1, M), this.yieldPos = U, this.awaitPos = J, this.awaitIdentPos = ae, this.finishNode(a, p & bt ? "FunctionDeclaration" : "FunctionExpression");
      }, ue.parseFunctionParams = function(a) {
        this.expect(f.parenL), a.params = this.parseBindingList(f.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
      }, ue.parseClass = function(a, p) {
        this.next();
        var b = this.strict;
        this.strict = !0, this.parseClassId(a, p), this.parseClassSuper(a);
        var k = this.enterClassBody(), M = this.startNode(), U = !1;
        for (M.body = [], this.expect(f.braceL); this.type !== f.braceR; ) {
          var J = this.parseClassElement(a.superClass !== null);
          J && (M.body.push(J), J.type === "MethodDefinition" && J.kind === "constructor" ? (U && this.raiseRecoverable(J.start, "Duplicate constructor in the same class"), U = !0) : J.key && J.key.type === "PrivateIdentifier" && ra(k, J) && this.raiseRecoverable(J.key.start, "Identifier '#" + J.key.name + "' has already been declared"));
        }
        return this.strict = b, this.next(), a.body = this.finishNode(M, "ClassBody"), this.exitClassBody(), this.finishNode(a, p ? "ClassDeclaration" : "ClassExpression");
      }, ue.parseClassElement = function(a) {
        if (this.eat(f.semi))
          return null;
        var p = this.options.ecmaVersion, b = this.startNode(), k = "", M = !1, U = !1, J = "method", ae = !1;
        if (this.eatContextual("static")) {
          if (p >= 13 && this.eat(f.braceL))
            return this.parseClassStaticBlock(b), b;
          this.isClassElementNameStart() || this.type === f.star ? ae = !0 : k = "static";
        }
        if (b.static = ae, !k && p >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === f.star) && !this.canInsertSemicolon() ? U = !0 : k = "async"), !k && (p >= 9 || !U) && this.eat(f.star) && (M = !0), !k && !U && !M) {
          var de = this.value;
          (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? J = de : k = de);
        }
        if (k ? (b.computed = !1, b.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), b.key.name = k, this.finishNode(b.key, "Identifier")) : this.parseClassElementName(b), p < 13 || this.type === f.parenL || J !== "method" || M || U) {
          var Te = !b.static && Fi(b, "constructor"), ze = Te && a;
          Te && J !== "method" && this.raise(b.key.start, "Constructor can't have get/set modifier"), b.kind = Te ? "constructor" : J, this.parseClassMethod(b, M, U, ze);
        } else
          this.parseClassField(b);
        return b;
      }, ue.isClassElementNameStart = function() {
        return this.type === f.name || this.type === f.privateId || this.type === f.num || this.type === f.string || this.type === f.bracketL || this.type.keyword;
      }, ue.parseClassElementName = function(a) {
        this.type === f.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), a.computed = !1, a.key = this.parsePrivateIdent()) : this.parsePropertyName(a);
      }, ue.parseClassMethod = function(a, p, b, k) {
        var M = a.key;
        a.kind === "constructor" ? (p && this.raise(M.start, "Constructor can't be a generator"), b && this.raise(M.start, "Constructor can't be an async method")) : a.static && Fi(a, "prototype") && this.raise(M.start, "Classes may not have a static property named prototype");
        var U = a.value = this.parseMethod(p, b, k);
        return a.kind === "get" && U.params.length !== 0 && this.raiseRecoverable(U.start, "getter should have no params"), a.kind === "set" && U.params.length !== 1 && this.raiseRecoverable(U.start, "setter should have exactly one param"), a.kind === "set" && U.params[0].type === "RestElement" && this.raiseRecoverable(U.params[0].start, "Setter cannot use rest params"), this.finishNode(a, "MethodDefinition");
      }, ue.parseClassField = function(a) {
        return Fi(a, "constructor") ? this.raise(a.key.start, "Classes can't have a field named 'constructor'") : a.static && Fi(a, "prototype") && this.raise(a.key.start, "Classes can't have a static field named 'prototype'"), this.eat(f.eq) ? (this.enterScope(Be | nt), a.value = this.parseMaybeAssign(), this.exitScope()) : a.value = null, this.semicolon(), this.finishNode(a, "PropertyDefinition");
      }, ue.parseClassStaticBlock = function(a) {
        a.body = [];
        var p = this.labels;
        for (this.labels = [], this.enterScope(pt | nt); this.type !== f.braceR; ) {
          var b = this.parseStatement(null);
          a.body.push(b);
        }
        return this.next(), this.exitScope(), this.labels = p, this.finishNode(a, "StaticBlock");
      }, ue.parseClassId = function(a, p) {
        this.type === f.name ? (a.id = this.parseIdent(), p && this.checkLValSimple(a.id, je, !1)) : (p === !0 && this.unexpected(), a.id = null);
      }, ue.parseClassSuper = function(a) {
        a.superClass = this.eat(f._extends) ? this.parseExprSubscripts(null, !1) : null;
      }, ue.enterClassBody = function() {
        var a = { declared: /* @__PURE__ */ Object.create(null), used: [] };
        return this.privateNameStack.push(a), a.declared;
      }, ue.exitClassBody = function() {
        var a = this.privateNameStack.pop(), p = a.declared, b = a.used;
        if (this.options.checkPrivateFields)
          for (var k = this.privateNameStack.length, M = k === 0 ? null : this.privateNameStack[k - 1], U = 0; U < b.length; ++U) {
            var J = b[U];
            W(p, J.name) || (M ? M.used.push(J) : this.raiseRecoverable(J.start, "Private field '#" + J.name + "' must be declared in an enclosing class"));
          }
      };
      function ra(a, p) {
        var b = p.key.name, k = a[b], M = "true";
        return p.type === "MethodDefinition" && (p.kind === "get" || p.kind === "set") && (M = (p.static ? "s" : "i") + p.kind), k === "iget" && M === "iset" || k === "iset" && M === "iget" || k === "sget" && M === "sset" || k === "sset" && M === "sget" ? (a[b] = "true", !1) : k ? !0 : (a[b] = M, !1);
      }
      function Fi(a, p) {
        var b = a.computed, k = a.key;
        return !b && (k.type === "Identifier" && k.name === p || k.type === "Literal" && k.value === p);
      }
      ue.parseExportAllDeclaration = function(a, p) {
        return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (a.exported = this.parseModuleExportName(), this.checkExport(p, a.exported, this.lastTokStart)) : a.exported = null), this.expectContextual("from"), this.type !== f.string && this.unexpected(), a.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (a.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(a, "ExportAllDeclaration");
      }, ue.parseExport = function(a, p) {
        if (this.next(), this.eat(f.star))
          return this.parseExportAllDeclaration(a, p);
        if (this.eat(f._default))
          return this.checkExport(p, "default", this.lastTokStart), a.declaration = this.parseExportDefaultDeclaration(), this.finishNode(a, "ExportDefaultDeclaration");
        if (this.shouldParseExportStatement())
          a.declaration = this.parseExportDeclaration(a), a.declaration.type === "VariableDeclaration" ? this.checkVariableExport(p, a.declaration.declarations) : this.checkExport(p, a.declaration.id, a.declaration.id.start), a.specifiers = [], a.source = null, this.options.ecmaVersion >= 16 && (a.attributes = []);
        else {
          if (a.declaration = null, a.specifiers = this.parseExportSpecifiers(p), this.eatContextual("from"))
            this.type !== f.string && this.unexpected(), a.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (a.attributes = this.parseWithClause());
          else {
            for (var b = 0, k = a.specifiers; b < k.length; b += 1) {
              var M = k[b];
              this.checkUnreserved(M.local), this.checkLocalExport(M.local), M.local.type === "Literal" && this.raise(M.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            a.source = null, this.options.ecmaVersion >= 16 && (a.attributes = []);
          }
          this.semicolon();
        }
        return this.finishNode(a, "ExportNamedDeclaration");
      }, ue.parseExportDeclaration = function(a) {
        return this.parseStatement(null);
      }, ue.parseExportDefaultDeclaration = function() {
        var a;
        if (this.type === f._function || (a = this.isAsyncFunction())) {
          var p = this.startNode();
          return this.next(), a && this.next(), this.parseFunction(p, bt | qt, !1, a);
        } else if (this.type === f._class) {
          var b = this.startNode();
          return this.parseClass(b, "nullableID");
        } else {
          var k = this.parseMaybeAssign();
          return this.semicolon(), k;
        }
      }, ue.checkExport = function(a, p, b) {
        a && (typeof p != "string" && (p = p.type === "Identifier" ? p.name : p.value), W(a, p) && this.raiseRecoverable(b, "Duplicate export '" + p + "'"), a[p] = !0);
      }, ue.checkPatternExport = function(a, p) {
        var b = p.type;
        if (b === "Identifier")
          this.checkExport(a, p, p.start);
        else if (b === "ObjectPattern")
          for (var k = 0, M = p.properties; k < M.length; k += 1) {
            var U = M[k];
            this.checkPatternExport(a, U);
          }
        else if (b === "ArrayPattern")
          for (var J = 0, ae = p.elements; J < ae.length; J += 1) {
            var de = ae[J];
            de && this.checkPatternExport(a, de);
          }
        else b === "Property" ? this.checkPatternExport(a, p.value) : b === "AssignmentPattern" ? this.checkPatternExport(a, p.left) : b === "RestElement" && this.checkPatternExport(a, p.argument);
      }, ue.checkVariableExport = function(a, p) {
        if (a)
          for (var b = 0, k = p; b < k.length; b += 1) {
            var M = k[b];
            this.checkPatternExport(a, M.id);
          }
      }, ue.shouldParseExportStatement = function() {
        return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
      }, ue.parseExportSpecifier = function(a) {
        var p = this.startNode();
        return p.local = this.parseModuleExportName(), p.exported = this.eatContextual("as") ? this.parseModuleExportName() : p.local, this.checkExport(
          a,
          p.exported,
          p.exported.start
        ), this.finishNode(p, "ExportSpecifier");
      }, ue.parseExportSpecifiers = function(a) {
        var p = [], b = !0;
        for (this.expect(f.braceL); !this.eat(f.braceR); ) {
          if (b)
            b = !1;
          else if (this.expect(f.comma), this.afterTrailingComma(f.braceR))
            break;
          p.push(this.parseExportSpecifier(a));
        }
        return p;
      }, ue.parseImport = function(a) {
        return this.next(), this.type === f.string ? (a.specifiers = ln, a.source = this.parseExprAtom()) : (a.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), a.source = this.type === f.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (a.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(a, "ImportDeclaration");
      }, ue.parseImportSpecifier = function() {
        var a = this.startNode();
        return a.imported = this.parseModuleExportName(), this.eatContextual("as") ? a.local = this.parseIdent() : (this.checkUnreserved(a.imported), a.local = a.imported), this.checkLValSimple(a.local, je), this.finishNode(a, "ImportSpecifier");
      }, ue.parseImportDefaultSpecifier = function() {
        var a = this.startNode();
        return a.local = this.parseIdent(), this.checkLValSimple(a.local, je), this.finishNode(a, "ImportDefaultSpecifier");
      }, ue.parseImportNamespaceSpecifier = function() {
        var a = this.startNode();
        return this.next(), this.expectContextual("as"), a.local = this.parseIdent(), this.checkLValSimple(a.local, je), this.finishNode(a, "ImportNamespaceSpecifier");
      }, ue.parseImportSpecifiers = function() {
        var a = [], p = !0;
        if (this.type === f.name && (a.push(this.parseImportDefaultSpecifier()), !this.eat(f.comma)))
          return a;
        if (this.type === f.star)
          return a.push(this.parseImportNamespaceSpecifier()), a;
        for (this.expect(f.braceL); !this.eat(f.braceR); ) {
          if (p)
            p = !1;
          else if (this.expect(f.comma), this.afterTrailingComma(f.braceR))
            break;
          a.push(this.parseImportSpecifier());
        }
        return a;
      }, ue.parseWithClause = function() {
        var a = [];
        if (!this.eat(f._with))
          return a;
        this.expect(f.braceL);
        for (var p = {}, b = !0; !this.eat(f.braceR); ) {
          if (b)
            b = !1;
          else if (this.expect(f.comma), this.afterTrailingComma(f.braceR))
            break;
          var k = this.parseImportAttribute(), M = k.key.type === "Identifier" ? k.key.name : k.key.value;
          W(p, M) && this.raiseRecoverable(k.key.start, "Duplicate attribute key '" + M + "'"), p[M] = !0, a.push(k);
        }
        return a;
      }, ue.parseImportAttribute = function() {
        var a = this.startNode();
        return a.key = this.type === f.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(f.colon), this.type !== f.string && this.unexpected(), a.value = this.parseExprAtom(), this.finishNode(a, "ImportAttribute");
      }, ue.parseModuleExportName = function() {
        if (this.options.ecmaVersion >= 13 && this.type === f.string) {
          var a = this.parseLiteral(this.value);
          return oe.test(a.value) && this.raise(a.start, "An export name cannot include a lone surrogate."), a;
        }
        return this.parseIdent(!0);
      }, ue.adaptDirectivePrologue = function(a) {
        for (var p = 0; p < a.length && this.isDirectiveCandidate(a[p]); ++p)
          a[p].directive = a[p].expression.raw.slice(1, -1);
      }, ue.isDirectiveCandidate = function(a) {
        return this.options.ecmaVersion >= 5 && a.type === "ExpressionStatement" && a.expression.type === "Literal" && typeof a.expression.value == "string" && // Reject parenthesized strings.
        (this.input[a.start] === '"' || this.input[a.start] === "'");
      };
      var Jt = Y.prototype;
      Jt.toAssignable = function(a, p, b) {
        if (this.options.ecmaVersion >= 6 && a)
          switch (a.type) {
            case "Identifier":
              this.inAsync && a.name === "await" && this.raise(a.start, "Cannot use 'await' as identifier inside an async function");
              break;
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              a.type = "ObjectPattern", b && this.checkPatternErrors(b, !0);
              for (var k = 0, M = a.properties; k < M.length; k += 1) {
                var U = M[k];
                this.toAssignable(U, p), U.type === "RestElement" && (U.argument.type === "ArrayPattern" || U.argument.type === "ObjectPattern") && this.raise(U.argument.start, "Unexpected token");
              }
              break;
            case "Property":
              a.kind !== "init" && this.raise(a.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(a.value, p);
              break;
            case "ArrayExpression":
              a.type = "ArrayPattern", b && this.checkPatternErrors(b, !0), this.toAssignableList(a.elements, p);
              break;
            case "SpreadElement":
              a.type = "RestElement", this.toAssignable(a.argument, p), a.argument.type === "AssignmentPattern" && this.raise(a.argument.start, "Rest elements cannot have a default value");
              break;
            case "AssignmentExpression":
              a.operator !== "=" && this.raise(a.left.end, "Only '=' operator can be used for specifying default value."), a.type = "AssignmentPattern", delete a.operator, this.toAssignable(a.left, p);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(a.expression, p, b);
              break;
            case "ChainExpression":
              this.raiseRecoverable(a.start, "Optional chaining cannot appear in left-hand side");
              break;
            case "MemberExpression":
              if (!p)
                break;
            default:
              this.raise(a.start, "Assigning to rvalue");
          }
        else b && this.checkPatternErrors(b, !0);
        return a;
      }, Jt.toAssignableList = function(a, p) {
        for (var b = a.length, k = 0; k < b; k++) {
          var M = a[k];
          M && this.toAssignable(M, p);
        }
        if (b) {
          var U = a[b - 1];
          this.options.ecmaVersion === 6 && p && U && U.type === "RestElement" && U.argument.type !== "Identifier" && this.unexpected(U.argument.start);
        }
        return a;
      }, Jt.parseSpread = function(a) {
        var p = this.startNode();
        return this.next(), p.argument = this.parseMaybeAssign(!1, a), this.finishNode(p, "SpreadElement");
      }, Jt.parseRestBinding = function() {
        var a = this.startNode();
        return this.next(), this.options.ecmaVersion === 6 && this.type !== f.name && this.unexpected(), a.argument = this.parseBindingAtom(), this.finishNode(a, "RestElement");
      }, Jt.parseBindingAtom = function() {
        if (this.options.ecmaVersion >= 6)
          switch (this.type) {
            case f.bracketL:
              var a = this.startNode();
              return this.next(), a.elements = this.parseBindingList(f.bracketR, !0, !0), this.finishNode(a, "ArrayPattern");
            case f.braceL:
              return this.parseObj(!0);
          }
        return this.parseIdent();
      }, Jt.parseBindingList = function(a, p, b, k) {
        for (var M = [], U = !0; !this.eat(a); )
          if (U ? U = !1 : this.expect(f.comma), p && this.type === f.comma)
            M.push(null);
          else {
            if (b && this.afterTrailingComma(a))
              break;
            if (this.type === f.ellipsis) {
              var J = this.parseRestBinding();
              this.parseBindingListItem(J), M.push(J), this.type === f.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(a);
              break;
            } else
              M.push(this.parseAssignableListItem(k));
          }
        return M;
      }, Jt.parseAssignableListItem = function(a) {
        var p = this.parseMaybeDefault(this.start, this.startLoc);
        return this.parseBindingListItem(p), p;
      }, Jt.parseBindingListItem = function(a) {
        return a;
      }, Jt.parseMaybeDefault = function(a, p, b) {
        if (b = b || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(f.eq))
          return b;
        var k = this.startNodeAt(a, p);
        return k.left = b, k.right = this.parseMaybeAssign(), this.finishNode(k, "AssignmentPattern");
      }, Jt.checkLValSimple = function(a, p, b) {
        p === void 0 && (p = ft);
        var k = p !== ft;
        switch (a.type) {
          case "Identifier":
            this.strict && this.reservedWordsStrictBind.test(a.name) && this.raiseRecoverable(a.start, (k ? "Binding " : "Assigning to ") + a.name + " in strict mode"), k && (p === je && a.name === "let" && this.raiseRecoverable(a.start, "let is disallowed as a lexically bound name"), b && (W(b, a.name) && this.raiseRecoverable(a.start, "Argument name clash"), b[a.name] = !0), p !== Q && this.declareName(a.name, p, a.start));
            break;
          case "ChainExpression":
            this.raiseRecoverable(a.start, "Optional chaining cannot appear in left-hand side");
            break;
          case "MemberExpression":
            k && this.raiseRecoverable(a.start, "Binding member expression");
            break;
          case "ParenthesizedExpression":
            return k && this.raiseRecoverable(a.start, "Binding parenthesized expression"), this.checkLValSimple(a.expression, p, b);
          default:
            this.raise(a.start, (k ? "Binding" : "Assigning to") + " rvalue");
        }
      }, Jt.checkLValPattern = function(a, p, b) {
        switch (p === void 0 && (p = ft), a.type) {
          case "ObjectPattern":
            for (var k = 0, M = a.properties; k < M.length; k += 1) {
              var U = M[k];
              this.checkLValInnerPattern(U, p, b);
            }
            break;
          case "ArrayPattern":
            for (var J = 0, ae = a.elements; J < ae.length; J += 1) {
              var de = ae[J];
              de && this.checkLValInnerPattern(de, p, b);
            }
            break;
          default:
            this.checkLValSimple(a, p, b);
        }
      }, Jt.checkLValInnerPattern = function(a, p, b) {
        switch (p === void 0 && (p = ft), a.type) {
          case "Property":
            this.checkLValInnerPattern(a.value, p, b);
            break;
          case "AssignmentPattern":
            this.checkLValPattern(a.left, p, b);
            break;
          case "RestElement":
            this.checkLValPattern(a.argument, p, b);
            break;
          default:
            this.checkLValPattern(a, p, b);
        }
      };
      var Wt = function(p, b, k, M, U) {
        this.token = p, this.isExpr = !!b, this.preserveSpace = !!k, this.override = M, this.generator = !!U;
      }, tt = {
        b_stat: new Wt("{", !1),
        b_expr: new Wt("{", !0),
        b_tmpl: new Wt("${", !1),
        p_stat: new Wt("(", !1),
        p_expr: new Wt("(", !0),
        q_tmpl: new Wt("`", !0, !0, function(a) {
          return a.tryReadTemplateToken();
        }),
        f_stat: new Wt("function", !1),
        f_expr: new Wt("function", !0),
        f_expr_gen: new Wt("function", !0, !1, null, !0),
        f_gen: new Wt("function", !1, !1, null, !0)
      }, Hn = Y.prototype;
      Hn.initialContext = function() {
        return [tt.b_stat];
      }, Hn.curContext = function() {
        return this.context[this.context.length - 1];
      }, Hn.braceIsBlock = function(a) {
        var p = this.curContext();
        return p === tt.f_expr || p === tt.f_stat ? !0 : a === f.colon && (p === tt.b_stat || p === tt.b_expr) ? !p.isExpr : a === f._return || a === f.name && this.exprAllowed ? C.test(this.input.slice(this.lastTokEnd, this.start)) : a === f._else || a === f.semi || a === f.eof || a === f.parenR || a === f.arrow ? !0 : a === f.braceL ? p === tt.b_stat : a === f._var || a === f._const || a === f.name ? !1 : !this.exprAllowed;
      }, Hn.inGeneratorContext = function() {
        for (var a = this.context.length - 1; a >= 1; a--) {
          var p = this.context[a];
          if (p.token === "function")
            return p.generator;
        }
        return !1;
      }, Hn.updateContext = function(a) {
        var p, b = this.type;
        b.keyword && a === f.dot ? this.exprAllowed = !1 : (p = b.updateContext) ? p.call(this, a) : this.exprAllowed = b.beforeExpr;
      }, Hn.overrideContext = function(a) {
        this.curContext() !== a && (this.context[this.context.length - 1] = a);
      }, f.parenR.updateContext = f.braceR.updateContext = function() {
        if (this.context.length === 1) {
          this.exprAllowed = !0;
          return;
        }
        var a = this.context.pop();
        a === tt.b_stat && this.curContext().token === "function" && (a = this.context.pop()), this.exprAllowed = !a.isExpr;
      }, f.braceL.updateContext = function(a) {
        this.context.push(this.braceIsBlock(a) ? tt.b_stat : tt.b_expr), this.exprAllowed = !0;
      }, f.dollarBraceL.updateContext = function() {
        this.context.push(tt.b_tmpl), this.exprAllowed = !0;
      }, f.parenL.updateContext = function(a) {
        var p = a === f._if || a === f._for || a === f._with || a === f._while;
        this.context.push(p ? tt.p_stat : tt.p_expr), this.exprAllowed = !0;
      }, f.incDec.updateContext = function() {
      }, f._function.updateContext = f._class.updateContext = function(a) {
        a.beforeExpr && a !== f._else && !(a === f.semi && this.curContext() !== tt.p_stat) && !(a === f._return && C.test(this.input.slice(this.lastTokEnd, this.start))) && !((a === f.colon || a === f.braceL) && this.curContext() === tt.b_stat) ? this.context.push(tt.f_expr) : this.context.push(tt.f_stat), this.exprAllowed = !1;
      }, f.colon.updateContext = function() {
        this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
      }, f.backQuote.updateContext = function() {
        this.curContext() === tt.q_tmpl ? this.context.pop() : this.context.push(tt.q_tmpl), this.exprAllowed = !1;
      }, f.star.updateContext = function(a) {
        if (a === f._function) {
          var p = this.context.length - 1;
          this.context[p] === tt.f_expr ? this.context[p] = tt.f_expr_gen : this.context[p] = tt.f_gen;
        }
        this.exprAllowed = !0;
      }, f.name.updateContext = function(a) {
        var p = !1;
        this.options.ecmaVersion >= 6 && a !== f.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (p = !0), this.exprAllowed = p;
      };
      var Ne = Y.prototype;
      Ne.checkPropClash = function(a, p, b) {
        if (!(this.options.ecmaVersion >= 9 && a.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (a.computed || a.method || a.shorthand))) {
          var k = a.key, M;
          switch (k.type) {
            case "Identifier":
              M = k.name;
              break;
            case "Literal":
              M = String(k.value);
              break;
            default:
              return;
          }
          var U = a.kind;
          if (this.options.ecmaVersion >= 6) {
            M === "__proto__" && U === "init" && (p.proto && (b ? b.doubleProto < 0 && (b.doubleProto = k.start) : this.raiseRecoverable(k.start, "Redefinition of __proto__ property")), p.proto = !0);
            return;
          }
          M = "$" + M;
          var J = p[M];
          if (J) {
            var ae;
            U === "init" ? ae = this.strict && J.init || J.get || J.set : ae = J.init || J[U], ae && this.raiseRecoverable(k.start, "Redefinition of property");
          } else
            J = p[M] = {
              init: !1,
              get: !1,
              set: !1
            };
          J[U] = !0;
        }
      }, Ne.parseExpression = function(a, p) {
        var b = this.start, k = this.startLoc, M = this.parseMaybeAssign(a, p);
        if (this.type === f.comma) {
          var U = this.startNodeAt(b, k);
          for (U.expressions = [M]; this.eat(f.comma); )
            U.expressions.push(this.parseMaybeAssign(a, p));
          return this.finishNode(U, "SequenceExpression");
        }
        return M;
      }, Ne.parseMaybeAssign = function(a, p, b) {
        if (this.isContextual("yield")) {
          if (this.inGenerator)
            return this.parseYield(a);
          this.exprAllowed = !1;
        }
        var k = !1, M = -1, U = -1, J = -1;
        p ? (M = p.parenthesizedAssign, U = p.trailingComma, J = p.doubleProto, p.parenthesizedAssign = p.trailingComma = -1) : (p = new ut(), k = !0);
        var ae = this.start, de = this.startLoc;
        (this.type === f.parenL || this.type === f.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = a === "await");
        var Te = this.parseMaybeConditional(a, p);
        if (b && (Te = b.call(this, Te, ae, de)), this.type.isAssign) {
          var ze = this.startNodeAt(ae, de);
          return ze.operator = this.value, this.type === f.eq && (Te = this.toAssignable(Te, !1, p)), k || (p.parenthesizedAssign = p.trailingComma = p.doubleProto = -1), p.shorthandAssign >= Te.start && (p.shorthandAssign = -1), this.type === f.eq ? this.checkLValPattern(Te) : this.checkLValSimple(Te), ze.left = Te, this.next(), ze.right = this.parseMaybeAssign(a), J > -1 && (p.doubleProto = J), this.finishNode(ze, "AssignmentExpression");
        } else
          k && this.checkExpressionErrors(p, !0);
        return M > -1 && (p.parenthesizedAssign = M), U > -1 && (p.trailingComma = U), Te;
      }, Ne.parseMaybeConditional = function(a, p) {
        var b = this.start, k = this.startLoc, M = this.parseExprOps(a, p);
        if (this.checkExpressionErrors(p))
          return M;
        if (this.eat(f.question)) {
          var U = this.startNodeAt(b, k);
          return U.test = M, U.consequent = this.parseMaybeAssign(), this.expect(f.colon), U.alternate = this.parseMaybeAssign(a), this.finishNode(U, "ConditionalExpression");
        }
        return M;
      }, Ne.parseExprOps = function(a, p) {
        var b = this.start, k = this.startLoc, M = this.parseMaybeUnary(p, !1, !1, a);
        return this.checkExpressionErrors(p) || M.start === b && M.type === "ArrowFunctionExpression" ? M : this.parseExprOp(M, b, k, -1, a);
      }, Ne.parseExprOp = function(a, p, b, k, M) {
        var U = this.type.binop;
        if (U != null && (!M || this.type !== f._in) && U > k) {
          var J = this.type === f.logicalOR || this.type === f.logicalAND, ae = this.type === f.coalesce;
          ae && (U = f.logicalAND.binop);
          var de = this.value;
          this.next();
          var Te = this.start, ze = this.startLoc, ot = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, M), Te, ze, U, M), Mt = this.buildBinary(p, b, a, ot, de, J || ae);
          return (J && this.type === f.coalesce || ae && (this.type === f.logicalOR || this.type === f.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(Mt, p, b, k, M);
        }
        return a;
      }, Ne.buildBinary = function(a, p, b, k, M, U) {
        k.type === "PrivateIdentifier" && this.raise(k.start, "Private identifier can only be left side of binary expression");
        var J = this.startNodeAt(a, p);
        return J.left = b, J.operator = M, J.right = k, this.finishNode(J, U ? "LogicalExpression" : "BinaryExpression");
      }, Ne.parseMaybeUnary = function(a, p, b, k) {
        var M = this.start, U = this.startLoc, J;
        if (this.isContextual("await") && this.canAwait)
          J = this.parseAwait(k), p = !0;
        else if (this.type.prefix) {
          var ae = this.startNode(), de = this.type === f.incDec;
          ae.operator = this.value, ae.prefix = !0, this.next(), ae.argument = this.parseMaybeUnary(null, !0, de, k), this.checkExpressionErrors(a, !0), de ? this.checkLValSimple(ae.argument) : this.strict && ae.operator === "delete" && gr(ae.argument) ? this.raiseRecoverable(ae.start, "Deleting local variable in strict mode") : ae.operator === "delete" && Ae(ae.argument) ? this.raiseRecoverable(ae.start, "Private fields can not be deleted") : p = !0, J = this.finishNode(ae, de ? "UpdateExpression" : "UnaryExpression");
        } else if (!p && this.type === f.privateId)
          (k || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), J = this.parsePrivateIdent(), this.type !== f._in && this.unexpected();
        else {
          if (J = this.parseExprSubscripts(a, k), this.checkExpressionErrors(a))
            return J;
          for (; this.type.postfix && !this.canInsertSemicolon(); ) {
            var Te = this.startNodeAt(M, U);
            Te.operator = this.value, Te.prefix = !1, Te.argument = J, this.checkLValSimple(J), this.next(), J = this.finishNode(Te, "UpdateExpression");
          }
        }
        if (!b && this.eat(f.starstar))
          if (p)
            this.unexpected(this.lastTokStart);
          else
            return this.buildBinary(M, U, J, this.parseMaybeUnary(null, !1, !1, k), "**", !1);
        else
          return J;
      };
      function gr(a) {
        return a.type === "Identifier" || a.type === "ParenthesizedExpression" && gr(a.expression);
      }
      function Ae(a) {
        return a.type === "MemberExpression" && a.property.type === "PrivateIdentifier" || a.type === "ChainExpression" && Ae(a.expression) || a.type === "ParenthesizedExpression" && Ae(a.expression);
      }
      Ne.parseExprSubscripts = function(a, p) {
        var b = this.start, k = this.startLoc, M = this.parseExprAtom(a, p);
        if (M.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
          return M;
        var U = this.parseSubscripts(M, b, k, !1, p);
        return a && U.type === "MemberExpression" && (a.parenthesizedAssign >= U.start && (a.parenthesizedAssign = -1), a.parenthesizedBind >= U.start && (a.parenthesizedBind = -1), a.trailingComma >= U.start && (a.trailingComma = -1)), U;
      }, Ne.parseSubscripts = function(a, p, b, k, M) {
        for (var U = this.options.ecmaVersion >= 8 && a.type === "Identifier" && a.name === "async" && this.lastTokEnd === a.end && !this.canInsertSemicolon() && a.end - a.start === 5 && this.potentialArrowAt === a.start, J = !1; ; ) {
          var ae = this.parseSubscript(a, p, b, k, U, J, M);
          if (ae.optional && (J = !0), ae === a || ae.type === "ArrowFunctionExpression") {
            if (J) {
              var de = this.startNodeAt(p, b);
              de.expression = ae, ae = this.finishNode(de, "ChainExpression");
            }
            return ae;
          }
          a = ae;
        }
      }, Ne.shouldParseAsyncArrow = function() {
        return !this.canInsertSemicolon() && this.eat(f.arrow);
      }, Ne.parseSubscriptAsyncArrow = function(a, p, b, k) {
        return this.parseArrowExpression(this.startNodeAt(a, p), b, !0, k);
      }, Ne.parseSubscript = function(a, p, b, k, M, U, J) {
        var ae = this.options.ecmaVersion >= 11, de = ae && this.eat(f.questionDot);
        k && de && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
        var Te = this.eat(f.bracketL);
        if (Te || de && this.type !== f.parenL && this.type !== f.backQuote || this.eat(f.dot)) {
          var ze = this.startNodeAt(p, b);
          ze.object = a, Te ? (ze.property = this.parseExpression(), this.expect(f.bracketR)) : this.type === f.privateId && a.type !== "Super" ? ze.property = this.parsePrivateIdent() : ze.property = this.parseIdent(this.options.allowReserved !== "never"), ze.computed = !!Te, ae && (ze.optional = de), a = this.finishNode(ze, "MemberExpression");
        } else if (!k && this.eat(f.parenL)) {
          var ot = new ut(), Mt = this.yieldPos, yr = this.awaitPos, Ri = this.awaitIdentPos;
          this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
          var os = this.parseExprList(f.parenR, this.options.ecmaVersion >= 8, !1, ot);
          if (M && !de && this.shouldParseAsyncArrow())
            return this.checkPatternErrors(ot, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = Mt, this.awaitPos = yr, this.awaitIdentPos = Ri, this.parseSubscriptAsyncArrow(p, b, os, J);
          this.checkExpressionErrors(ot, !0), this.yieldPos = Mt || this.yieldPos, this.awaitPos = yr || this.awaitPos, this.awaitIdentPos = Ri || this.awaitIdentPos;
          var Oi = this.startNodeAt(p, b);
          Oi.callee = a, Oi.arguments = os, ae && (Oi.optional = de), a = this.finishNode(Oi, "CallExpression");
        } else if (this.type === f.backQuote) {
          (de || U) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
          var Bi = this.startNodeAt(p, b);
          Bi.tag = a, Bi.quasi = this.parseTemplate({ isTagged: !0 }), a = this.finishNode(Bi, "TaggedTemplateExpression");
        }
        return a;
      }, Ne.parseExprAtom = function(a, p, b) {
        this.type === f.slash && this.readRegexp();
        var k, M = this.potentialArrowAt === this.start;
        switch (this.type) {
          case f._super:
            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), k = this.startNode(), this.next(), this.type === f.parenL && !this.allowDirectSuper && this.raise(k.start, "super() call outside constructor of a subclass"), this.type !== f.dot && this.type !== f.bracketL && this.type !== f.parenL && this.unexpected(), this.finishNode(k, "Super");
          case f._this:
            return k = this.startNode(), this.next(), this.finishNode(k, "ThisExpression");
          case f.name:
            var U = this.start, J = this.startLoc, ae = this.containsEsc, de = this.parseIdent(!1);
            if (this.options.ecmaVersion >= 8 && !ae && de.name === "async" && !this.canInsertSemicolon() && this.eat(f._function))
              return this.overrideContext(tt.f_expr), this.parseFunction(this.startNodeAt(U, J), 0, !1, !0, p);
            if (M && !this.canInsertSemicolon()) {
              if (this.eat(f.arrow))
                return this.parseArrowExpression(this.startNodeAt(U, J), [de], !1, p);
              if (this.options.ecmaVersion >= 8 && de.name === "async" && this.type === f.name && !ae && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
                return de = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(f.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(U, J), [de], !0, p);
            }
            return de;
          case f.regexp:
            var Te = this.value;
            return k = this.parseLiteral(Te.value), k.regex = { pattern: Te.pattern, flags: Te.flags }, k;
          case f.num:
          case f.string:
            return this.parseLiteral(this.value);
          case f._null:
          case f._true:
          case f._false:
            return k = this.startNode(), k.value = this.type === f._null ? null : this.type === f._true, k.raw = this.type.keyword, this.next(), this.finishNode(k, "Literal");
          case f.parenL:
            var ze = this.start, ot = this.parseParenAndDistinguishExpression(M, p);
            return a && (a.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(ot) && (a.parenthesizedAssign = ze), a.parenthesizedBind < 0 && (a.parenthesizedBind = ze)), ot;
          case f.bracketL:
            return k = this.startNode(), this.next(), k.elements = this.parseExprList(f.bracketR, !0, !0, a), this.finishNode(k, "ArrayExpression");
          case f.braceL:
            return this.overrideContext(tt.b_expr), this.parseObj(!1, a);
          case f._function:
            return k = this.startNode(), this.next(), this.parseFunction(k, 0);
          case f._class:
            return this.parseClass(this.startNode(), !1);
          case f._new:
            return this.parseNew();
          case f.backQuote:
            return this.parseTemplate();
          case f._import:
            return this.options.ecmaVersion >= 11 ? this.parseExprImport(b) : this.unexpected();
          default:
            return this.parseExprAtomDefault();
        }
      }, Ne.parseExprAtomDefault = function() {
        this.unexpected();
      }, Ne.parseExprImport = function(a) {
        var p = this.startNode();
        if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === f.parenL && !a)
          return this.parseDynamicImport(p);
        if (this.type === f.dot) {
          var b = this.startNodeAt(p.start, p.loc && p.loc.start);
          return b.name = "import", p.meta = this.finishNode(b, "Identifier"), this.parseImportMeta(p);
        } else
          this.unexpected();
      }, Ne.parseDynamicImport = function(a) {
        if (this.next(), a.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
          this.eat(f.parenR) ? a.options = null : (this.expect(f.comma), this.afterTrailingComma(f.parenR) ? a.options = null : (a.options = this.parseMaybeAssign(), this.eat(f.parenR) || (this.expect(f.comma), this.afterTrailingComma(f.parenR) || this.unexpected())));
        else if (!this.eat(f.parenR)) {
          var p = this.start;
          this.eat(f.comma) && this.eat(f.parenR) ? this.raiseRecoverable(p, "Trailing comma is not allowed in import()") : this.unexpected(p);
        }
        return this.finishNode(a, "ImportExpression");
      }, Ne.parseImportMeta = function(a) {
        this.next();
        var p = this.containsEsc;
        return a.property = this.parseIdent(!0), a.property.name !== "meta" && this.raiseRecoverable(a.property.start, "The only valid meta property for import is 'import.meta'"), p && this.raiseRecoverable(a.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(a.start, "Cannot use 'import.meta' outside a module"), this.finishNode(a, "MetaProperty");
      }, Ne.parseLiteral = function(a) {
        var p = this.startNode();
        return p.value = a, p.raw = this.input.slice(this.start, this.end), p.raw.charCodeAt(p.raw.length - 1) === 110 && (p.bigint = p.value != null ? p.value.toString() : p.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(p, "Literal");
      }, Ne.parseParenExpression = function() {
        this.expect(f.parenL);
        var a = this.parseExpression();
        return this.expect(f.parenR), a;
      }, Ne.shouldParseArrow = function(a) {
        return !this.canInsertSemicolon();
      }, Ne.parseParenAndDistinguishExpression = function(a, p) {
        var b = this.start, k = this.startLoc, M, U = this.options.ecmaVersion >= 8;
        if (this.options.ecmaVersion >= 6) {
          this.next();
          var J = this.start, ae = this.startLoc, de = [], Te = !0, ze = !1, ot = new ut(), Mt = this.yieldPos, yr = this.awaitPos, Ri;
          for (this.yieldPos = 0, this.awaitPos = 0; this.type !== f.parenR; )
            if (Te ? Te = !1 : this.expect(f.comma), U && this.afterTrailingComma(f.parenR, !0)) {
              ze = !0;
              break;
            } else if (this.type === f.ellipsis) {
              Ri = this.start, de.push(this.parseParenItem(this.parseRestBinding())), this.type === f.comma && this.raiseRecoverable(
                this.start,
                "Comma is not permitted after the rest element"
              );
              break;
            } else
              de.push(this.parseMaybeAssign(!1, ot, this.parseParenItem));
          var os = this.lastTokEnd, Oi = this.lastTokEndLoc;
          if (this.expect(f.parenR), a && this.shouldParseArrow(de) && this.eat(f.arrow))
            return this.checkPatternErrors(ot, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = Mt, this.awaitPos = yr, this.parseParenArrowList(b, k, de, p);
          (!de.length || ze) && this.unexpected(this.lastTokStart), Ri && this.unexpected(Ri), this.checkExpressionErrors(ot, !0), this.yieldPos = Mt || this.yieldPos, this.awaitPos = yr || this.awaitPos, de.length > 1 ? (M = this.startNodeAt(J, ae), M.expressions = de, this.finishNodeAt(M, "SequenceExpression", os, Oi)) : M = de[0];
        } else
          M = this.parseParenExpression();
        if (this.options.preserveParens) {
          var Bi = this.startNodeAt(b, k);
          return Bi.expression = M, this.finishNode(Bi, "ParenthesizedExpression");
        } else
          return M;
      }, Ne.parseParenItem = function(a) {
        return a;
      }, Ne.parseParenArrowList = function(a, p, b, k) {
        return this.parseArrowExpression(this.startNodeAt(a, p), b, !1, k);
      };
      var ct = [];
      Ne.parseNew = function() {
        this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
        var a = this.startNode();
        if (this.next(), this.options.ecmaVersion >= 6 && this.type === f.dot) {
          var p = this.startNodeAt(a.start, a.loc && a.loc.start);
          p.name = "new", a.meta = this.finishNode(p, "Identifier"), this.next();
          var b = this.containsEsc;
          return a.property = this.parseIdent(!0), a.property.name !== "target" && this.raiseRecoverable(a.property.start, "The only valid meta property for new is 'new.target'"), b && this.raiseRecoverable(a.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(a.start, "'new.target' can only be used in functions and class static block"), this.finishNode(a, "MetaProperty");
        }
        var k = this.start, M = this.startLoc;
        return a.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), k, M, !0, !1), this.eat(f.parenL) ? a.arguments = this.parseExprList(f.parenR, this.options.ecmaVersion >= 8, !1) : a.arguments = ct, this.finishNode(a, "NewExpression");
      }, Ne.parseTemplateElement = function(a) {
        var p = a.isTagged, b = this.startNode();
        return this.type === f.invalidTemplate ? (p || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), b.value = {
          raw: this.value.replace(/\r\n?/g, `
`),
          cooked: null
        }) : b.value = {
          raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
          cooked: this.value
        }, this.next(), b.tail = this.type === f.backQuote, this.finishNode(b, "TemplateElement");
      }, Ne.parseTemplate = function(a) {
        a === void 0 && (a = {});
        var p = a.isTagged;
        p === void 0 && (p = !1);
        var b = this.startNode();
        this.next(), b.expressions = [];
        var k = this.parseTemplateElement({ isTagged: p });
        for (b.quasis = [k]; !k.tail; )
          this.type === f.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(f.dollarBraceL), b.expressions.push(this.parseExpression()), this.expect(f.braceR), b.quasis.push(k = this.parseTemplateElement({ isTagged: p }));
        return this.next(), this.finishNode(b, "TemplateLiteral");
      }, Ne.isAsyncProp = function(a) {
        return !a.computed && a.key.type === "Identifier" && a.key.name === "async" && (this.type === f.name || this.type === f.num || this.type === f.string || this.type === f.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === f.star) && !C.test(this.input.slice(this.lastTokEnd, this.start));
      }, Ne.parseObj = function(a, p) {
        var b = this.startNode(), k = !0, M = {};
        for (b.properties = [], this.next(); !this.eat(f.braceR); ) {
          if (k)
            k = !1;
          else if (this.expect(f.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(f.braceR))
            break;
          var U = this.parseProperty(a, p);
          a || this.checkPropClash(U, M, p), b.properties.push(U);
        }
        return this.finishNode(b, a ? "ObjectPattern" : "ObjectExpression");
      }, Ne.parseProperty = function(a, p) {
        var b = this.startNode(), k, M, U, J;
        if (this.options.ecmaVersion >= 9 && this.eat(f.ellipsis))
          return a ? (b.argument = this.parseIdent(!1), this.type === f.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(b, "RestElement")) : (b.argument = this.parseMaybeAssign(!1, p), this.type === f.comma && p && p.trailingComma < 0 && (p.trailingComma = this.start), this.finishNode(b, "SpreadElement"));
        this.options.ecmaVersion >= 6 && (b.method = !1, b.shorthand = !1, (a || p) && (U = this.start, J = this.startLoc), a || (k = this.eat(f.star)));
        var ae = this.containsEsc;
        return this.parsePropertyName(b), !a && !ae && this.options.ecmaVersion >= 8 && !k && this.isAsyncProp(b) ? (M = !0, k = this.options.ecmaVersion >= 9 && this.eat(f.star), this.parsePropertyName(b)) : M = !1, this.parsePropertyValue(b, a, k, M, U, J, p, ae), this.finishNode(b, "Property");
      }, Ne.parseGetterSetter = function(a) {
        var p = a.key.name;
        this.parsePropertyName(a), a.value = this.parseMethod(!1), a.kind = p;
        var b = a.kind === "get" ? 0 : 1;
        if (a.value.params.length !== b) {
          var k = a.value.start;
          a.kind === "get" ? this.raiseRecoverable(k, "getter should have no params") : this.raiseRecoverable(k, "setter should have exactly one param");
        } else
          a.kind === "set" && a.value.params[0].type === "RestElement" && this.raiseRecoverable(a.value.params[0].start, "Setter cannot use rest params");
      }, Ne.parsePropertyValue = function(a, p, b, k, M, U, J, ae) {
        (b || k) && this.type === f.colon && this.unexpected(), this.eat(f.colon) ? (a.value = p ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, J), a.kind = "init") : this.options.ecmaVersion >= 6 && this.type === f.parenL ? (p && this.unexpected(), a.method = !0, a.value = this.parseMethod(b, k), a.kind = "init") : !p && !ae && this.options.ecmaVersion >= 5 && !a.computed && a.key.type === "Identifier" && (a.key.name === "get" || a.key.name === "set") && this.type !== f.comma && this.type !== f.braceR && this.type !== f.eq ? ((b || k) && this.unexpected(), this.parseGetterSetter(a)) : this.options.ecmaVersion >= 6 && !a.computed && a.key.type === "Identifier" ? ((b || k) && this.unexpected(), this.checkUnreserved(a.key), a.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = M), p ? a.value = this.parseMaybeDefault(M, U, this.copyNode(a.key)) : this.type === f.eq && J ? (J.shorthandAssign < 0 && (J.shorthandAssign = this.start), a.value = this.parseMaybeDefault(M, U, this.copyNode(a.key))) : a.value = this.copyNode(a.key), a.kind = "init", a.shorthand = !0) : this.unexpected();
      }, Ne.parsePropertyName = function(a) {
        if (this.options.ecmaVersion >= 6) {
          if (this.eat(f.bracketL))
            return a.computed = !0, a.key = this.parseMaybeAssign(), this.expect(f.bracketR), a.key;
          a.computed = !1;
        }
        return a.key = this.type === f.num || this.type === f.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
      }, Ne.initFunction = function(a) {
        a.id = null, this.options.ecmaVersion >= 6 && (a.generator = a.expression = !1), this.options.ecmaVersion >= 8 && (a.async = !1);
      }, Ne.parseMethod = function(a, p, b) {
        var k = this.startNode(), M = this.yieldPos, U = this.awaitPos, J = this.awaitIdentPos;
        return this.initFunction(k), this.options.ecmaVersion >= 6 && (k.generator = a), this.options.ecmaVersion >= 8 && (k.async = !!p), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(kt(p, k.generator) | nt | (b ? Ke : 0)), this.expect(f.parenL), k.params = this.parseBindingList(f.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(k, !1, !0, !1), this.yieldPos = M, this.awaitPos = U, this.awaitIdentPos = J, this.finishNode(k, "FunctionExpression");
      }, Ne.parseArrowExpression = function(a, p, b, k) {
        var M = this.yieldPos, U = this.awaitPos, J = this.awaitIdentPos;
        return this.enterScope(kt(b, !1) | Ie), this.initFunction(a), this.options.ecmaVersion >= 8 && (a.async = !!b), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, a.params = this.toAssignableList(p, !0), this.parseFunctionBody(a, !0, !1, k), this.yieldPos = M, this.awaitPos = U, this.awaitIdentPos = J, this.finishNode(a, "ArrowFunctionExpression");
      }, Ne.parseFunctionBody = function(a, p, b, k) {
        var M = p && this.type !== f.braceL, U = this.strict, J = !1;
        if (M)
          a.body = this.parseMaybeAssign(k), a.expression = !0, this.checkParams(a, !1);
        else {
          var ae = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(a.params);
          (!U || ae) && (J = this.strictDirective(this.end), J && ae && this.raiseRecoverable(a.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
          var de = this.labels;
          this.labels = [], J && (this.strict = !0), this.checkParams(a, !U && !J && !p && !b && this.isSimpleParamList(a.params)), this.strict && a.id && this.checkLValSimple(a.id, Q), a.body = this.parseBlock(!1, void 0, J && !U), a.expression = !1, this.adaptDirectivePrologue(a.body.body), this.labels = de;
        }
        this.exitScope();
      }, Ne.isSimpleParamList = function(a) {
        for (var p = 0, b = a; p < b.length; p += 1) {
          var k = b[p];
          if (k.type !== "Identifier")
            return !1;
        }
        return !0;
      }, Ne.checkParams = function(a, p) {
        for (var b = /* @__PURE__ */ Object.create(null), k = 0, M = a.params; k < M.length; k += 1) {
          var U = M[k];
          this.checkLValInnerPattern(U, Fe, p ? null : b);
        }
      }, Ne.parseExprList = function(a, p, b, k) {
        for (var M = [], U = !0; !this.eat(a); ) {
          if (U)
            U = !1;
          else if (this.expect(f.comma), p && this.afterTrailingComma(a))
            break;
          var J = void 0;
          b && this.type === f.comma ? J = null : this.type === f.ellipsis ? (J = this.parseSpread(k), k && this.type === f.comma && k.trailingComma < 0 && (k.trailingComma = this.start)) : J = this.parseMaybeAssign(!1, k), M.push(J);
        }
        return M;
      }, Ne.checkUnreserved = function(a) {
        var p = a.start, b = a.end, k = a.name;
        if (this.inGenerator && k === "yield" && this.raiseRecoverable(p, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && k === "await" && this.raiseRecoverable(p, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & xt) && k === "arguments" && this.raiseRecoverable(p, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (k === "arguments" || k === "await") && this.raise(p, "Cannot use " + k + " in class static initialization block"), this.keywords.test(k) && this.raise(p, "Unexpected keyword '" + k + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(p, b).indexOf("\\") !== -1)) {
          var M = this.strict ? this.reservedWordsStrict : this.reservedWords;
          M.test(k) && (!this.inAsync && k === "await" && this.raiseRecoverable(p, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(p, "The keyword '" + k + "' is reserved"));
        }
      }, Ne.parseIdent = function(a) {
        var p = this.parseIdentNode();
        return this.next(!!a), this.finishNode(p, "Identifier"), a || (this.checkUnreserved(p), p.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = p.start)), p;
      }, Ne.parseIdentNode = function() {
        var a = this.startNode();
        return this.type === f.name ? a.name = this.value : this.type.keyword ? (a.name = this.type.keyword, (a.name === "class" || a.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = f.name) : this.unexpected(), a;
      }, Ne.parsePrivateIdent = function() {
        var a = this.startNode();
        return this.type === f.privateId ? a.name = this.value : this.unexpected(), this.next(), this.finishNode(a, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(a.start, "Private field '#" + a.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(a)), a;
      }, Ne.parseYield = function(a) {
        this.yieldPos || (this.yieldPos = this.start);
        var p = this.startNode();
        return this.next(), this.type === f.semi || this.canInsertSemicolon() || this.type !== f.star && !this.type.startsExpr ? (p.delegate = !1, p.argument = null) : (p.delegate = this.eat(f.star), p.argument = this.parseMaybeAssign(a)), this.finishNode(p, "YieldExpression");
      }, Ne.parseAwait = function(a) {
        this.awaitPos || (this.awaitPos = this.start);
        var p = this.startNode();
        return this.next(), p.argument = this.parseMaybeUnary(null, !0, !1, a), this.finishNode(p, "AwaitExpression");
      };
      var yt = Y.prototype;
      yt.raise = function(a, p) {
        var b = pe(this.input, a);
        p += " (" + b.line + ":" + b.column + ")", this.sourceFile && (p += " in " + this.sourceFile);
        var k = new SyntaxError(p);
        throw k.pos = a, k.loc = b, k.raisedAt = this.pos, k;
      }, yt.raiseRecoverable = yt.raise, yt.curPosition = function() {
        if (this.options.locations)
          return new se(this.curLine, this.pos - this.lineStart);
      };
      var At = Y.prototype, ns = function(p) {
        this.flags = p, this.var = [], this.lexical = [], this.functions = [];
      };
      At.enterScope = function(a) {
        this.scopeStack.push(new ns(a));
      }, At.exitScope = function() {
        this.scopeStack.pop();
      }, At.treatFunctionsAsVarInScope = function(a) {
        return a.flags & ge || !this.inModule && a.flags & te;
      }, At.declareName = function(a, p, b) {
        var k = !1;
        if (p === je) {
          var M = this.currentScope();
          k = M.lexical.indexOf(a) > -1 || M.functions.indexOf(a) > -1 || M.var.indexOf(a) > -1, M.lexical.push(a), this.inModule && M.flags & te && delete this.undefinedExports[a];
        } else if (p === on) {
          var U = this.currentScope();
          U.lexical.push(a);
        } else if (p === Re) {
          var J = this.currentScope();
          this.treatFunctionsAsVar ? k = J.lexical.indexOf(a) > -1 : k = J.lexical.indexOf(a) > -1 || J.var.indexOf(a) > -1, J.functions.push(a);
        } else
          for (var ae = this.scopeStack.length - 1; ae >= 0; --ae) {
            var de = this.scopeStack[ae];
            if (de.lexical.indexOf(a) > -1 && !(de.flags & Ve && de.lexical[0] === a) || !this.treatFunctionsAsVarInScope(de) && de.functions.indexOf(a) > -1) {
              k = !0;
              break;
            }
            if (de.var.push(a), this.inModule && de.flags & te && delete this.undefinedExports[a], de.flags & xt)
              break;
          }
        k && this.raiseRecoverable(b, "Identifier '" + a + "' has already been declared");
      }, At.checkLocalExport = function(a) {
        this.scopeStack[0].lexical.indexOf(a.name) === -1 && this.scopeStack[0].var.indexOf(a.name) === -1 && (this.undefinedExports[a.name] = a);
      }, At.currentScope = function() {
        return this.scopeStack[this.scopeStack.length - 1];
      }, At.currentVarScope = function() {
        for (var a = this.scopeStack.length - 1; ; a--) {
          var p = this.scopeStack[a];
          if (p.flags & (xt | Be | pt))
            return p;
        }
      }, At.currentThisScope = function() {
        for (var a = this.scopeStack.length - 1; ; a--) {
          var p = this.scopeStack[a];
          if (p.flags & (xt | Be | pt) && !(p.flags & Ie))
            return p;
        }
      };
      var yi = function(p, b, k) {
        this.type = "", this.start = b, this.end = 0, p.options.locations && (this.loc = new D(p, k)), p.options.directSourceFile && (this.sourceFile = p.options.directSourceFile), p.options.ranges && (this.range = [b, 0]);
      }, tn = Y.prototype;
      tn.startNode = function() {
        return new yi(this, this.start, this.startLoc);
      }, tn.startNodeAt = function(a, p) {
        return new yi(this, a, p);
      };
      function xr(a, p, b, k) {
        return a.type = p, a.end = b, this.options.locations && (a.loc.end = k), this.options.ranges && (a.range[1] = b), a;
      }
      tn.finishNode = function(a, p) {
        return xr.call(this, a, p, this.lastTokEnd, this.lastTokEndLoc);
      }, tn.finishNodeAt = function(a, p, b, k) {
        return xr.call(this, a, p, b, k);
      }, tn.copyNode = function(a) {
        var p = new yi(this, a.start, this.startLoc);
        for (var b in a)
          p[b] = a[b];
        return p;
      };
      var br = "Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz", is = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Cl = is + " Extended_Pictographic", Sl = Cl, El = Sl + " EBase EComp EMod EPres ExtPict", Al = El, tf = Al, nf = {
        9: is,
        10: Cl,
        11: Sl,
        12: El,
        13: Al,
        14: tf
      }, rf = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", sf = {
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: rf
      }, Il = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", Ll = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Nl = Ll + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", Tl = Nl + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", Pl = Tl + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", Dl = Pl + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", af = Dl + " " + br, of = {
        9: Ll,
        10: Nl,
        11: Tl,
        12: Pl,
        13: Dl,
        14: af
      }, Ml = {};
      function lf(a) {
        var p = Ml[a] = {
          binary: K(nf[a] + " " + Il),
          binaryOfStrings: K(sf[a]),
          nonBinary: {
            General_Category: K(Il),
            Script: K(of[a])
          }
        };
        p.nonBinary.Script_Extensions = p.nonBinary.Script, p.nonBinary.gc = p.nonBinary.General_Category, p.nonBinary.sc = p.nonBinary.Script, p.nonBinary.scx = p.nonBinary.Script_Extensions;
      }
      for (var sa = 0, Vl = [9, 10, 11, 12, 13, 14]; sa < Vl.length; sa += 1) {
        var uf = Vl[sa];
        lf(uf);
      }
      var ye = Y.prototype, rs = function(p, b) {
        this.parent = p, this.base = b || this;
      };
      rs.prototype.separatedFrom = function(p) {
        for (var b = this; b; b = b.parent)
          for (var k = p; k; k = k.parent)
            if (b.base === k.base && b !== k)
              return !0;
        return !1;
      }, rs.prototype.sibling = function() {
        return new rs(this.parent, this.base);
      };
      var Sn = function(p) {
        this.parser = p, this.validFlags = "gim" + (p.options.ecmaVersion >= 6 ? "uy" : "") + (p.options.ecmaVersion >= 9 ? "s" : "") + (p.options.ecmaVersion >= 13 ? "d" : "") + (p.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Ml[p.options.ecmaVersion >= 14 ? 14 : p.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
      };
      Sn.prototype.reset = function(p, b, k) {
        var M = k.indexOf("v") !== -1, U = k.indexOf("u") !== -1;
        this.start = p | 0, this.source = b + "", this.flags = k, M && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = U && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = U && this.parser.options.ecmaVersion >= 9);
      }, Sn.prototype.raise = function(p) {
        this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + p);
      }, Sn.prototype.at = function(p, b) {
        b === void 0 && (b = !1);
        var k = this.source, M = k.length;
        if (p >= M)
          return -1;
        var U = k.charCodeAt(p);
        if (!(b || this.switchU) || U <= 55295 || U >= 57344 || p + 1 >= M)
          return U;
        var J = k.charCodeAt(p + 1);
        return J >= 56320 && J <= 57343 ? (U << 10) + J - 56613888 : U;
      }, Sn.prototype.nextIndex = function(p, b) {
        b === void 0 && (b = !1);
        var k = this.source, M = k.length;
        if (p >= M)
          return M;
        var U = k.charCodeAt(p), J;
        return !(b || this.switchU) || U <= 55295 || U >= 57344 || p + 1 >= M || (J = k.charCodeAt(p + 1)) < 56320 || J > 57343 ? p + 1 : p + 2;
      }, Sn.prototype.current = function(p) {
        return p === void 0 && (p = !1), this.at(this.pos, p);
      }, Sn.prototype.lookahead = function(p) {
        return p === void 0 && (p = !1), this.at(this.nextIndex(this.pos, p), p);
      }, Sn.prototype.advance = function(p) {
        p === void 0 && (p = !1), this.pos = this.nextIndex(this.pos, p);
      }, Sn.prototype.eat = function(p, b) {
        return b === void 0 && (b = !1), this.current(b) === p ? (this.advance(b), !0) : !1;
      }, Sn.prototype.eatChars = function(p, b) {
        b === void 0 && (b = !1);
        for (var k = this.pos, M = 0, U = p; M < U.length; M += 1) {
          var J = U[M], ae = this.at(k, b);
          if (ae === -1 || ae !== J)
            return !1;
          k = this.nextIndex(k, b);
        }
        return this.pos = k, !0;
      }, ye.validateRegExpFlags = function(a) {
        for (var p = a.validFlags, b = a.flags, k = !1, M = !1, U = 0; U < b.length; U++) {
          var J = b.charAt(U);
          p.indexOf(J) === -1 && this.raise(a.start, "Invalid regular expression flag"), b.indexOf(J, U + 1) > -1 && this.raise(a.start, "Duplicate regular expression flag"), J === "u" && (k = !0), J === "v" && (M = !0);
        }
        this.options.ecmaVersion >= 15 && k && M && this.raise(a.start, "Invalid regular expression flag");
      };
      function cf(a) {
        for (var p in a)
          return !0;
        return !1;
      }
      ye.validateRegExpPattern = function(a) {
        this.regexp_pattern(a), !a.switchN && this.options.ecmaVersion >= 9 && cf(a.groupNames) && (a.switchN = !0, this.regexp_pattern(a));
      }, ye.regexp_pattern = function(a) {
        a.pos = 0, a.lastIntValue = 0, a.lastStringValue = "", a.lastAssertionIsQuantifiable = !1, a.numCapturingParens = 0, a.maxBackReference = 0, a.groupNames = /* @__PURE__ */ Object.create(null), a.backReferenceNames.length = 0, a.branchID = null, this.regexp_disjunction(a), a.pos !== a.source.length && (a.eat(
          41
          /* ) */
        ) && a.raise("Unmatched ')'"), (a.eat(
          93
          /* ] */
        ) || a.eat(
          125
          /* } */
        )) && a.raise("Lone quantifier brackets")), a.maxBackReference > a.numCapturingParens && a.raise("Invalid escape");
        for (var p = 0, b = a.backReferenceNames; p < b.length; p += 1) {
          var k = b[p];
          a.groupNames[k] || a.raise("Invalid named capture referenced");
        }
      }, ye.regexp_disjunction = function(a) {
        var p = this.options.ecmaVersion >= 16;
        for (p && (a.branchID = new rs(a.branchID, null)), this.regexp_alternative(a); a.eat(
          124
          /* | */
        ); )
          p && (a.branchID = a.branchID.sibling()), this.regexp_alternative(a);
        p && (a.branchID = a.branchID.parent), this.regexp_eatQuantifier(a, !0) && a.raise("Nothing to repeat"), a.eat(
          123
          /* { */
        ) && a.raise("Lone quantifier brackets");
      }, ye.regexp_alternative = function(a) {
        for (; a.pos < a.source.length && this.regexp_eatTerm(a); )
          ;
      }, ye.regexp_eatTerm = function(a) {
        return this.regexp_eatAssertion(a) ? (a.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(a) && a.switchU && a.raise("Invalid quantifier"), !0) : (a.switchU ? this.regexp_eatAtom(a) : this.regexp_eatExtendedAtom(a)) ? (this.regexp_eatQuantifier(a), !0) : !1;
      }, ye.regexp_eatAssertion = function(a) {
        var p = a.pos;
        if (a.lastAssertionIsQuantifiable = !1, a.eat(
          94
          /* ^ */
        ) || a.eat(
          36
          /* $ */
        ))
          return !0;
        if (a.eat(
          92
          /* \ */
        )) {
          if (a.eat(
            66
            /* B */
          ) || a.eat(
            98
            /* b */
          ))
            return !0;
          a.pos = p;
        }
        if (a.eat(
          40
          /* ( */
        ) && a.eat(
          63
          /* ? */
        )) {
          var b = !1;
          if (this.options.ecmaVersion >= 9 && (b = a.eat(
            60
            /* < */
          )), a.eat(
            61
            /* = */
          ) || a.eat(
            33
            /* ! */
          ))
            return this.regexp_disjunction(a), a.eat(
              41
              /* ) */
            ) || a.raise("Unterminated group"), a.lastAssertionIsQuantifiable = !b, !0;
        }
        return a.pos = p, !1;
      }, ye.regexp_eatQuantifier = function(a, p) {
        return p === void 0 && (p = !1), this.regexp_eatQuantifierPrefix(a, p) ? (a.eat(
          63
          /* ? */
        ), !0) : !1;
      }, ye.regexp_eatQuantifierPrefix = function(a, p) {
        return a.eat(
          42
          /* * */
        ) || a.eat(
          43
          /* + */
        ) || a.eat(
          63
          /* ? */
        ) || this.regexp_eatBracedQuantifier(a, p);
      }, ye.regexp_eatBracedQuantifier = function(a, p) {
        var b = a.pos;
        if (a.eat(
          123
          /* { */
        )) {
          var k = 0, M = -1;
          if (this.regexp_eatDecimalDigits(a) && (k = a.lastIntValue, a.eat(
            44
            /* , */
          ) && this.regexp_eatDecimalDigits(a) && (M = a.lastIntValue), a.eat(
            125
            /* } */
          )))
            return M !== -1 && M < k && !p && a.raise("numbers out of order in {} quantifier"), !0;
          a.switchU && !p && a.raise("Incomplete quantifier"), a.pos = b;
        }
        return !1;
      }, ye.regexp_eatAtom = function(a) {
        return this.regexp_eatPatternCharacters(a) || a.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(a) || this.regexp_eatCharacterClass(a) || this.regexp_eatUncapturingGroup(a) || this.regexp_eatCapturingGroup(a);
      }, ye.regexp_eatReverseSolidusAtomEscape = function(a) {
        var p = a.pos;
        if (a.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatAtomEscape(a))
            return !0;
          a.pos = p;
        }
        return !1;
      }, ye.regexp_eatUncapturingGroup = function(a) {
        var p = a.pos;
        if (a.eat(
          40
          /* ( */
        )) {
          if (a.eat(
            63
            /* ? */
          )) {
            if (this.options.ecmaVersion >= 16) {
              var b = this.regexp_eatModifiers(a), k = a.eat(
                45
                /* - */
              );
              if (b || k) {
                for (var M = 0; M < b.length; M++) {
                  var U = b.charAt(M);
                  b.indexOf(U, M + 1) > -1 && a.raise("Duplicate regular expression modifiers");
                }
                if (k) {
                  var J = this.regexp_eatModifiers(a);
                  !b && !J && a.current() === 58 && a.raise("Invalid regular expression modifiers");
                  for (var ae = 0; ae < J.length; ae++) {
                    var de = J.charAt(ae);
                    (J.indexOf(de, ae + 1) > -1 || b.indexOf(de) > -1) && a.raise("Duplicate regular expression modifiers");
                  }
                }
              }
            }
            if (a.eat(
              58
              /* : */
            )) {
              if (this.regexp_disjunction(a), a.eat(
                41
                /* ) */
              ))
                return !0;
              a.raise("Unterminated group");
            }
          }
          a.pos = p;
        }
        return !1;
      }, ye.regexp_eatCapturingGroup = function(a) {
        if (a.eat(
          40
          /* ( */
        )) {
          if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(a) : a.current() === 63 && a.raise("Invalid group"), this.regexp_disjunction(a), a.eat(
            41
            /* ) */
          ))
            return a.numCapturingParens += 1, !0;
          a.raise("Unterminated group");
        }
        return !1;
      }, ye.regexp_eatModifiers = function(a) {
        for (var p = "", b = 0; (b = a.current()) !== -1 && df(b); )
          p += P(b), a.advance();
        return p;
      };
      function df(a) {
        return a === 105 || a === 109 || a === 115;
      }
      ye.regexp_eatExtendedAtom = function(a) {
        return a.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(a) || this.regexp_eatCharacterClass(a) || this.regexp_eatUncapturingGroup(a) || this.regexp_eatCapturingGroup(a) || this.regexp_eatInvalidBracedQuantifier(a) || this.regexp_eatExtendedPatternCharacter(a);
      }, ye.regexp_eatInvalidBracedQuantifier = function(a) {
        return this.regexp_eatBracedQuantifier(a, !0) && a.raise("Nothing to repeat"), !1;
      }, ye.regexp_eatSyntaxCharacter = function(a) {
        var p = a.current();
        return Fl(p) ? (a.lastIntValue = p, a.advance(), !0) : !1;
      };
      function Fl(a) {
        return a === 36 || a >= 40 && a <= 43 || a === 46 || a === 63 || a >= 91 && a <= 94 || a >= 123 && a <= 125;
      }
      ye.regexp_eatPatternCharacters = function(a) {
        for (var p = a.pos, b = 0; (b = a.current()) !== -1 && !Fl(b); )
          a.advance();
        return a.pos !== p;
      }, ye.regexp_eatExtendedPatternCharacter = function(a) {
        var p = a.current();
        return p !== -1 && p !== 36 && !(p >= 40 && p <= 43) && p !== 46 && p !== 63 && p !== 91 && p !== 94 && p !== 124 ? (a.advance(), !0) : !1;
      }, ye.regexp_groupSpecifier = function(a) {
        if (a.eat(
          63
          /* ? */
        )) {
          this.regexp_eatGroupName(a) || a.raise("Invalid group");
          var p = this.options.ecmaVersion >= 16, b = a.groupNames[a.lastStringValue];
          if (b)
            if (p)
              for (var k = 0, M = b; k < M.length; k += 1) {
                var U = M[k];
                U.separatedFrom(a.branchID) || a.raise("Duplicate capture group name");
              }
            else
              a.raise("Duplicate capture group name");
          p ? (b || (a.groupNames[a.lastStringValue] = [])).push(a.branchID) : a.groupNames[a.lastStringValue] = !0;
        }
      }, ye.regexp_eatGroupName = function(a) {
        if (a.lastStringValue = "", a.eat(
          60
          /* < */
        )) {
          if (this.regexp_eatRegExpIdentifierName(a) && a.eat(
            62
            /* > */
          ))
            return !0;
          a.raise("Invalid capture group name");
        }
        return !1;
      }, ye.regexp_eatRegExpIdentifierName = function(a) {
        if (a.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(a)) {
          for (a.lastStringValue += P(a.lastIntValue); this.regexp_eatRegExpIdentifierPart(a); )
            a.lastStringValue += P(a.lastIntValue);
          return !0;
        }
        return !1;
      }, ye.regexp_eatRegExpIdentifierStart = function(a) {
        var p = a.pos, b = this.options.ecmaVersion >= 11, k = a.current(b);
        return a.advance(b), k === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(a, b) && (k = a.lastIntValue), hf(k) ? (a.lastIntValue = k, !0) : (a.pos = p, !1);
      };
      function hf(a) {
        return y(a, !0) || a === 36 || a === 95;
      }
      ye.regexp_eatRegExpIdentifierPart = function(a) {
        var p = a.pos, b = this.options.ecmaVersion >= 11, k = a.current(b);
        return a.advance(b), k === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(a, b) && (k = a.lastIntValue), pf(k) ? (a.lastIntValue = k, !0) : (a.pos = p, !1);
      };
      function pf(a) {
        return v(a, !0) || a === 36 || a === 95 || a === 8204 || a === 8205;
      }
      ye.regexp_eatAtomEscape = function(a) {
        return this.regexp_eatBackReference(a) || this.regexp_eatCharacterClassEscape(a) || this.regexp_eatCharacterEscape(a) || a.switchN && this.regexp_eatKGroupName(a) ? !0 : (a.switchU && (a.current() === 99 && a.raise("Invalid unicode escape"), a.raise("Invalid escape")), !1);
      }, ye.regexp_eatBackReference = function(a) {
        var p = a.pos;
        if (this.regexp_eatDecimalEscape(a)) {
          var b = a.lastIntValue;
          if (a.switchU)
            return b > a.maxBackReference && (a.maxBackReference = b), !0;
          if (b <= a.numCapturingParens)
            return !0;
          a.pos = p;
        }
        return !1;
      }, ye.regexp_eatKGroupName = function(a) {
        if (a.eat(
          107
          /* k */
        )) {
          if (this.regexp_eatGroupName(a))
            return a.backReferenceNames.push(a.lastStringValue), !0;
          a.raise("Invalid named reference");
        }
        return !1;
      }, ye.regexp_eatCharacterEscape = function(a) {
        return this.regexp_eatControlEscape(a) || this.regexp_eatCControlLetter(a) || this.regexp_eatZero(a) || this.regexp_eatHexEscapeSequence(a) || this.regexp_eatRegExpUnicodeEscapeSequence(a, !1) || !a.switchU && this.regexp_eatLegacyOctalEscapeSequence(a) || this.regexp_eatIdentityEscape(a);
      }, ye.regexp_eatCControlLetter = function(a) {
        var p = a.pos;
        if (a.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatControlLetter(a))
            return !0;
          a.pos = p;
        }
        return !1;
      }, ye.regexp_eatZero = function(a) {
        return a.current() === 48 && !ss(a.lookahead()) ? (a.lastIntValue = 0, a.advance(), !0) : !1;
      }, ye.regexp_eatControlEscape = function(a) {
        var p = a.current();
        return p === 116 ? (a.lastIntValue = 9, a.advance(), !0) : p === 110 ? (a.lastIntValue = 10, a.advance(), !0) : p === 118 ? (a.lastIntValue = 11, a.advance(), !0) : p === 102 ? (a.lastIntValue = 12, a.advance(), !0) : p === 114 ? (a.lastIntValue = 13, a.advance(), !0) : !1;
      }, ye.regexp_eatControlLetter = function(a) {
        var p = a.current();
        return Rl(p) ? (a.lastIntValue = p % 32, a.advance(), !0) : !1;
      };
      function Rl(a) {
        return a >= 65 && a <= 90 || a >= 97 && a <= 122;
      }
      ye.regexp_eatRegExpUnicodeEscapeSequence = function(a, p) {
        p === void 0 && (p = !1);
        var b = a.pos, k = p || a.switchU;
        if (a.eat(
          117
          /* u */
        )) {
          if (this.regexp_eatFixedHexDigits(a, 4)) {
            var M = a.lastIntValue;
            if (k && M >= 55296 && M <= 56319) {
              var U = a.pos;
              if (a.eat(
                92
                /* \ */
              ) && a.eat(
                117
                /* u */
              ) && this.regexp_eatFixedHexDigits(a, 4)) {
                var J = a.lastIntValue;
                if (J >= 56320 && J <= 57343)
                  return a.lastIntValue = (M - 55296) * 1024 + (J - 56320) + 65536, !0;
              }
              a.pos = U, a.lastIntValue = M;
            }
            return !0;
          }
          if (k && a.eat(
            123
            /* { */
          ) && this.regexp_eatHexDigits(a) && a.eat(
            125
            /* } */
          ) && ff(a.lastIntValue))
            return !0;
          k && a.raise("Invalid unicode escape"), a.pos = b;
        }
        return !1;
      };
      function ff(a) {
        return a >= 0 && a <= 1114111;
      }
      ye.regexp_eatIdentityEscape = function(a) {
        if (a.switchU)
          return this.regexp_eatSyntaxCharacter(a) ? !0 : a.eat(
            47
            /* / */
          ) ? (a.lastIntValue = 47, !0) : !1;
        var p = a.current();
        return p !== 99 && (!a.switchN || p !== 107) ? (a.lastIntValue = p, a.advance(), !0) : !1;
      }, ye.regexp_eatDecimalEscape = function(a) {
        a.lastIntValue = 0;
        var p = a.current();
        if (p >= 49 && p <= 57) {
          do
            a.lastIntValue = 10 * a.lastIntValue + (p - 48), a.advance();
          while ((p = a.current()) >= 48 && p <= 57);
          return !0;
        }
        return !1;
      };
      var Ol = 0, Un = 1, cn = 2;
      ye.regexp_eatCharacterClassEscape = function(a) {
        var p = a.current();
        if (mf(p))
          return a.lastIntValue = -1, a.advance(), Un;
        var b = !1;
        if (a.switchU && this.options.ecmaVersion >= 9 && ((b = p === 80) || p === 112)) {
          a.lastIntValue = -1, a.advance();
          var k;
          if (a.eat(
            123
            /* { */
          ) && (k = this.regexp_eatUnicodePropertyValueExpression(a)) && a.eat(
            125
            /* } */
          ))
            return b && k === cn && a.raise("Invalid property name"), k;
          a.raise("Invalid property name");
        }
        return Ol;
      };
      function mf(a) {
        return a === 100 || a === 68 || a === 115 || a === 83 || a === 119 || a === 87;
      }
      ye.regexp_eatUnicodePropertyValueExpression = function(a) {
        var p = a.pos;
        if (this.regexp_eatUnicodePropertyName(a) && a.eat(
          61
          /* = */
        )) {
          var b = a.lastStringValue;
          if (this.regexp_eatUnicodePropertyValue(a)) {
            var k = a.lastStringValue;
            return this.regexp_validateUnicodePropertyNameAndValue(a, b, k), Un;
          }
        }
        if (a.pos = p, this.regexp_eatLoneUnicodePropertyNameOrValue(a)) {
          var M = a.lastStringValue;
          return this.regexp_validateUnicodePropertyNameOrValue(a, M);
        }
        return Ol;
      }, ye.regexp_validateUnicodePropertyNameAndValue = function(a, p, b) {
        W(a.unicodeProperties.nonBinary, p) || a.raise("Invalid property name"), a.unicodeProperties.nonBinary[p].test(b) || a.raise("Invalid property value");
      }, ye.regexp_validateUnicodePropertyNameOrValue = function(a, p) {
        if (a.unicodeProperties.binary.test(p))
          return Un;
        if (a.switchV && a.unicodeProperties.binaryOfStrings.test(p))
          return cn;
        a.raise("Invalid property name");
      }, ye.regexp_eatUnicodePropertyName = function(a) {
        var p = 0;
        for (a.lastStringValue = ""; Bl(p = a.current()); )
          a.lastStringValue += P(p), a.advance();
        return a.lastStringValue !== "";
      };
      function Bl(a) {
        return Rl(a) || a === 95;
      }
      ye.regexp_eatUnicodePropertyValue = function(a) {
        var p = 0;
        for (a.lastStringValue = ""; _f(p = a.current()); )
          a.lastStringValue += P(p), a.advance();
        return a.lastStringValue !== "";
      };
      function _f(a) {
        return Bl(a) || ss(a);
      }
      ye.regexp_eatLoneUnicodePropertyNameOrValue = function(a) {
        return this.regexp_eatUnicodePropertyValue(a);
      }, ye.regexp_eatCharacterClass = function(a) {
        if (a.eat(
          91
          /* [ */
        )) {
          var p = a.eat(
            94
            /* ^ */
          ), b = this.regexp_classContents(a);
          return a.eat(
            93
            /* ] */
          ) || a.raise("Unterminated character class"), p && b === cn && a.raise("Negated character class may contain strings"), !0;
        }
        return !1;
      }, ye.regexp_classContents = function(a) {
        return a.current() === 93 ? Un : a.switchV ? this.regexp_classSetExpression(a) : (this.regexp_nonEmptyClassRanges(a), Un);
      }, ye.regexp_nonEmptyClassRanges = function(a) {
        for (; this.regexp_eatClassAtom(a); ) {
          var p = a.lastIntValue;
          if (a.eat(
            45
            /* - */
          ) && this.regexp_eatClassAtom(a)) {
            var b = a.lastIntValue;
            a.switchU && (p === -1 || b === -1) && a.raise("Invalid character class"), p !== -1 && b !== -1 && p > b && a.raise("Range out of order in character class");
          }
        }
      }, ye.regexp_eatClassAtom = function(a) {
        var p = a.pos;
        if (a.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatClassEscape(a))
            return !0;
          if (a.switchU) {
            var b = a.current();
            (b === 99 || $l(b)) && a.raise("Invalid class escape"), a.raise("Invalid escape");
          }
          a.pos = p;
        }
        var k = a.current();
        return k !== 93 ? (a.lastIntValue = k, a.advance(), !0) : !1;
      }, ye.regexp_eatClassEscape = function(a) {
        var p = a.pos;
        if (a.eat(
          98
          /* b */
        ))
          return a.lastIntValue = 8, !0;
        if (a.switchU && a.eat(
          45
          /* - */
        ))
          return a.lastIntValue = 45, !0;
        if (!a.switchU && a.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatClassControlLetter(a))
            return !0;
          a.pos = p;
        }
        return this.regexp_eatCharacterClassEscape(a) || this.regexp_eatCharacterEscape(a);
      }, ye.regexp_classSetExpression = function(a) {
        var p = Un, b;
        if (!this.regexp_eatClassSetRange(a)) if (b = this.regexp_eatClassSetOperand(a)) {
          b === cn && (p = cn);
          for (var k = a.pos; a.eatChars(
            [38, 38]
            /* && */
          ); ) {
            if (a.current() !== 38 && (b = this.regexp_eatClassSetOperand(a))) {
              b !== cn && (p = Un);
              continue;
            }
            a.raise("Invalid character in character class");
          }
          if (k !== a.pos)
            return p;
          for (; a.eatChars(
            [45, 45]
            /* -- */
          ); )
            this.regexp_eatClassSetOperand(a) || a.raise("Invalid character in character class");
          if (k !== a.pos)
            return p;
        } else
          a.raise("Invalid character in character class");
        for (; ; )
          if (!this.regexp_eatClassSetRange(a)) {
            if (b = this.regexp_eatClassSetOperand(a), !b)
              return p;
            b === cn && (p = cn);
          }
      }, ye.regexp_eatClassSetRange = function(a) {
        var p = a.pos;
        if (this.regexp_eatClassSetCharacter(a)) {
          var b = a.lastIntValue;
          if (a.eat(
            45
            /* - */
          ) && this.regexp_eatClassSetCharacter(a)) {
            var k = a.lastIntValue;
            return b !== -1 && k !== -1 && b > k && a.raise("Range out of order in character class"), !0;
          }
          a.pos = p;
        }
        return !1;
      }, ye.regexp_eatClassSetOperand = function(a) {
        return this.regexp_eatClassSetCharacter(a) ? Un : this.regexp_eatClassStringDisjunction(a) || this.regexp_eatNestedClass(a);
      }, ye.regexp_eatNestedClass = function(a) {
        var p = a.pos;
        if (a.eat(
          91
          /* [ */
        )) {
          var b = a.eat(
            94
            /* ^ */
          ), k = this.regexp_classContents(a);
          if (a.eat(
            93
            /* ] */
          ))
            return b && k === cn && a.raise("Negated character class may contain strings"), k;
          a.pos = p;
        }
        if (a.eat(
          92
          /* \ */
        )) {
          var M = this.regexp_eatCharacterClassEscape(a);
          if (M)
            return M;
          a.pos = p;
        }
        return null;
      }, ye.regexp_eatClassStringDisjunction = function(a) {
        var p = a.pos;
        if (a.eatChars(
          [92, 113]
          /* \q */
        )) {
          if (a.eat(
            123
            /* { */
          )) {
            var b = this.regexp_classStringDisjunctionContents(a);
            if (a.eat(
              125
              /* } */
            ))
              return b;
          } else
            a.raise("Invalid escape");
          a.pos = p;
        }
        return null;
      }, ye.regexp_classStringDisjunctionContents = function(a) {
        for (var p = this.regexp_classString(a); a.eat(
          124
          /* | */
        ); )
          this.regexp_classString(a) === cn && (p = cn);
        return p;
      }, ye.regexp_classString = function(a) {
        for (var p = 0; this.regexp_eatClassSetCharacter(a); )
          p++;
        return p === 1 ? Un : cn;
      }, ye.regexp_eatClassSetCharacter = function(a) {
        var p = a.pos;
        if (a.eat(
          92
          /* \ */
        ))
          return this.regexp_eatCharacterEscape(a) || this.regexp_eatClassSetReservedPunctuator(a) ? !0 : a.eat(
            98
            /* b */
          ) ? (a.lastIntValue = 8, !0) : (a.pos = p, !1);
        var b = a.current();
        return b < 0 || b === a.lookahead() && gf(b) || xf(b) ? !1 : (a.advance(), a.lastIntValue = b, !0);
      };
      function gf(a) {
        return a === 33 || a >= 35 && a <= 38 || a >= 42 && a <= 44 || a === 46 || a >= 58 && a <= 64 || a === 94 || a === 96 || a === 126;
      }
      function xf(a) {
        return a === 40 || a === 41 || a === 45 || a === 47 || a >= 91 && a <= 93 || a >= 123 && a <= 125;
      }
      ye.regexp_eatClassSetReservedPunctuator = function(a) {
        var p = a.current();
        return bf(p) ? (a.lastIntValue = p, a.advance(), !0) : !1;
      };
      function bf(a) {
        return a === 33 || a === 35 || a === 37 || a === 38 || a === 44 || a === 45 || a >= 58 && a <= 62 || a === 64 || a === 96 || a === 126;
      }
      ye.regexp_eatClassControlLetter = function(a) {
        var p = a.current();
        return ss(p) || p === 95 ? (a.lastIntValue = p % 32, a.advance(), !0) : !1;
      }, ye.regexp_eatHexEscapeSequence = function(a) {
        var p = a.pos;
        if (a.eat(
          120
          /* x */
        )) {
          if (this.regexp_eatFixedHexDigits(a, 2))
            return !0;
          a.switchU && a.raise("Invalid escape"), a.pos = p;
        }
        return !1;
      }, ye.regexp_eatDecimalDigits = function(a) {
        var p = a.pos, b = 0;
        for (a.lastIntValue = 0; ss(b = a.current()); )
          a.lastIntValue = 10 * a.lastIntValue + (b - 48), a.advance();
        return a.pos !== p;
      };
      function ss(a) {
        return a >= 48 && a <= 57;
      }
      ye.regexp_eatHexDigits = function(a) {
        var p = a.pos, b = 0;
        for (a.lastIntValue = 0; zl(b = a.current()); )
          a.lastIntValue = 16 * a.lastIntValue + jl(b), a.advance();
        return a.pos !== p;
      };
      function zl(a) {
        return a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102;
      }
      function jl(a) {
        return a >= 65 && a <= 70 ? 10 + (a - 65) : a >= 97 && a <= 102 ? 10 + (a - 97) : a - 48;
      }
      ye.regexp_eatLegacyOctalEscapeSequence = function(a) {
        if (this.regexp_eatOctalDigit(a)) {
          var p = a.lastIntValue;
          if (this.regexp_eatOctalDigit(a)) {
            var b = a.lastIntValue;
            p <= 3 && this.regexp_eatOctalDigit(a) ? a.lastIntValue = p * 64 + b * 8 + a.lastIntValue : a.lastIntValue = p * 8 + b;
          } else
            a.lastIntValue = p;
          return !0;
        }
        return !1;
      }, ye.regexp_eatOctalDigit = function(a) {
        var p = a.current();
        return $l(p) ? (a.lastIntValue = p - 48, a.advance(), !0) : (a.lastIntValue = 0, !1);
      };
      function $l(a) {
        return a >= 48 && a <= 55;
      }
      ye.regexp_eatFixedHexDigits = function(a, p) {
        var b = a.pos;
        a.lastIntValue = 0;
        for (var k = 0; k < p; ++k) {
          var M = a.current();
          if (!zl(M))
            return a.pos = b, !1;
          a.lastIntValue = 16 * a.lastIntValue + jl(M), a.advance();
        }
        return !0;
      };
      var as = function(p) {
        this.type = p.type, this.value = p.value, this.start = p.start, this.end = p.end, p.options.locations && (this.loc = new D(p, p.startLoc, p.endLoc)), p.options.ranges && (this.range = [p.start, p.end]);
      }, qe = Y.prototype;
      qe.next = function(a) {
        !a && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new as(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
      }, qe.getToken = function() {
        return this.next(), new as(this);
      }, typeof Symbol < "u" && (qe[Symbol.iterator] = function() {
        var a = this;
        return {
          next: function() {
            var p = a.getToken();
            return {
              done: p.type === f.eof,
              value: p
            };
          }
        };
      }), qe.nextToken = function() {
        var a = this.curContext();
        if ((!a || !a.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
          return this.finishToken(f.eof);
        if (a.override)
          return a.override(this);
        this.readToken(this.fullCharCodeAtPos());
      }, qe.readToken = function(a) {
        return y(a, this.options.ecmaVersion >= 6) || a === 92 ? this.readWord() : this.getTokenFromCode(a);
      }, qe.fullCharCodeAtPos = function() {
        var a = this.input.charCodeAt(this.pos);
        if (a <= 55295 || a >= 56320)
          return a;
        var p = this.input.charCodeAt(this.pos + 1);
        return p <= 56319 || p >= 57344 ? a : (a << 10) + p - 56613888;
      }, qe.skipBlockComment = function() {
        var a = this.options.onComment && this.curPosition(), p = this.pos, b = this.input.indexOf("*/", this.pos += 2);
        if (b === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = b + 2, this.options.locations)
          for (var k = void 0, M = p; (k = V(this.input, M, this.pos)) > -1; )
            ++this.curLine, M = this.lineStart = k;
        this.options.onComment && this.options.onComment(
          !0,
          this.input.slice(p + 2, b),
          p,
          this.pos,
          a,
          this.curPosition()
        );
      }, qe.skipLineComment = function(a) {
        for (var p = this.pos, b = this.options.onComment && this.curPosition(), k = this.input.charCodeAt(this.pos += a); this.pos < this.input.length && !R(k); )
          k = this.input.charCodeAt(++this.pos);
        this.options.onComment && this.options.onComment(
          !1,
          this.input.slice(p + a, this.pos),
          p,
          this.pos,
          b,
          this.curPosition()
        );
      }, qe.skipSpace = function() {
        e: for (; this.pos < this.input.length; ) {
          var a = this.input.charCodeAt(this.pos);
          switch (a) {
            case 32:
            case 160:
              ++this.pos;
              break;
            case 13:
              this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
            case 10:
            case 8232:
            case 8233:
              ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
              break;
            case 47:
              switch (this.input.charCodeAt(this.pos + 1)) {
                case 42:
                  this.skipBlockComment();
                  break;
                case 47:
                  this.skipLineComment(2);
                  break;
                default:
                  break e;
              }
              break;
            default:
              if (a > 8 && a < 14 || a >= 5760 && z.test(String.fromCharCode(a)))
                ++this.pos;
              else
                break e;
          }
        }
      }, qe.finishToken = function(a, p) {
        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
        var b = this.type;
        this.type = a, this.value = p, this.updateContext(b);
      }, qe.readToken_dot = function() {
        var a = this.input.charCodeAt(this.pos + 1);
        if (a >= 48 && a <= 57)
          return this.readNumber(!0);
        var p = this.input.charCodeAt(this.pos + 2);
        return this.options.ecmaVersion >= 6 && a === 46 && p === 46 ? (this.pos += 3, this.finishToken(f.ellipsis)) : (++this.pos, this.finishToken(f.dot));
      }, qe.readToken_slash = function() {
        var a = this.input.charCodeAt(this.pos + 1);
        return this.exprAllowed ? (++this.pos, this.readRegexp()) : a === 61 ? this.finishOp(f.assign, 2) : this.finishOp(f.slash, 1);
      }, qe.readToken_mult_modulo_exp = function(a) {
        var p = this.input.charCodeAt(this.pos + 1), b = 1, k = a === 42 ? f.star : f.modulo;
        return this.options.ecmaVersion >= 7 && a === 42 && p === 42 && (++b, k = f.starstar, p = this.input.charCodeAt(this.pos + 2)), p === 61 ? this.finishOp(f.assign, b + 1) : this.finishOp(k, b);
      }, qe.readToken_pipe_amp = function(a) {
        var p = this.input.charCodeAt(this.pos + 1);
        if (p === a) {
          if (this.options.ecmaVersion >= 12) {
            var b = this.input.charCodeAt(this.pos + 2);
            if (b === 61)
              return this.finishOp(f.assign, 3);
          }
          return this.finishOp(a === 124 ? f.logicalOR : f.logicalAND, 2);
        }
        return p === 61 ? this.finishOp(f.assign, 2) : this.finishOp(a === 124 ? f.bitwiseOR : f.bitwiseAND, 1);
      }, qe.readToken_caret = function() {
        var a = this.input.charCodeAt(this.pos + 1);
        return a === 61 ? this.finishOp(f.assign, 2) : this.finishOp(f.bitwiseXOR, 1);
      }, qe.readToken_plus_min = function(a) {
        var p = this.input.charCodeAt(this.pos + 1);
        return p === a ? p === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || C.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(f.incDec, 2) : p === 61 ? this.finishOp(f.assign, 2) : this.finishOp(f.plusMin, 1);
      }, qe.readToken_lt_gt = function(a) {
        var p = this.input.charCodeAt(this.pos + 1), b = 1;
        return p === a ? (b = a === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + b) === 61 ? this.finishOp(f.assign, b + 1) : this.finishOp(f.bitShift, b)) : p === 33 && a === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (p === 61 && (b = 2), this.finishOp(f.relational, b));
      }, qe.readToken_eq_excl = function(a) {
        var p = this.input.charCodeAt(this.pos + 1);
        return p === 61 ? this.finishOp(f.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : a === 61 && p === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(f.arrow)) : this.finishOp(a === 61 ? f.eq : f.prefix, 1);
      }, qe.readToken_question = function() {
        var a = this.options.ecmaVersion;
        if (a >= 11) {
          var p = this.input.charCodeAt(this.pos + 1);
          if (p === 46) {
            var b = this.input.charCodeAt(this.pos + 2);
            if (b < 48 || b > 57)
              return this.finishOp(f.questionDot, 2);
          }
          if (p === 63) {
            if (a >= 12) {
              var k = this.input.charCodeAt(this.pos + 2);
              if (k === 61)
                return this.finishOp(f.assign, 3);
            }
            return this.finishOp(f.coalesce, 2);
          }
        }
        return this.finishOp(f.question, 1);
      }, qe.readToken_numberSign = function() {
        var a = this.options.ecmaVersion, p = 35;
        if (a >= 13 && (++this.pos, p = this.fullCharCodeAtPos(), y(p, !0) || p === 92))
          return this.finishToken(f.privateId, this.readWord1());
        this.raise(this.pos, "Unexpected character '" + P(p) + "'");
      }, qe.getTokenFromCode = function(a) {
        switch (a) {
          // The interpretation of a dot depends on whether it is followed
          // by a digit or another two dots.
          case 46:
            return this.readToken_dot();
          // Punctuation tokens.
          case 40:
            return ++this.pos, this.finishToken(f.parenL);
          case 41:
            return ++this.pos, this.finishToken(f.parenR);
          case 59:
            return ++this.pos, this.finishToken(f.semi);
          case 44:
            return ++this.pos, this.finishToken(f.comma);
          case 91:
            return ++this.pos, this.finishToken(f.bracketL);
          case 93:
            return ++this.pos, this.finishToken(f.bracketR);
          case 123:
            return ++this.pos, this.finishToken(f.braceL);
          case 125:
            return ++this.pos, this.finishToken(f.braceR);
          case 58:
            return ++this.pos, this.finishToken(f.colon);
          case 96:
            if (this.options.ecmaVersion < 6)
              break;
            return ++this.pos, this.finishToken(f.backQuote);
          case 48:
            var p = this.input.charCodeAt(this.pos + 1);
            if (p === 120 || p === 88)
              return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
              if (p === 111 || p === 79)
                return this.readRadixNumber(8);
              if (p === 98 || p === 66)
                return this.readRadixNumber(2);
            }
          // Anything else beginning with a digit is an integer, octal
          // number, or float.
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return this.readNumber(!1);
          // Quotes produce strings.
          case 34:
          case 39:
            return this.readString(a);
          // Operators are parsed inline in tiny state machines. '=' (61) is
          // often referred to. `finishOp` simply skips the amount of
          // characters it is given as second argument, and returns a token
          // of the type given by its first argument.
          case 47:
            return this.readToken_slash();
          case 37:
          case 42:
            return this.readToken_mult_modulo_exp(a);
          case 124:
          case 38:
            return this.readToken_pipe_amp(a);
          case 94:
            return this.readToken_caret();
          case 43:
          case 45:
            return this.readToken_plus_min(a);
          case 60:
          case 62:
            return this.readToken_lt_gt(a);
          case 61:
          case 33:
            return this.readToken_eq_excl(a);
          case 63:
            return this.readToken_question();
          case 126:
            return this.finishOp(f.prefix, 1);
          case 35:
            return this.readToken_numberSign();
        }
        this.raise(this.pos, "Unexpected character '" + P(a) + "'");
      }, qe.finishOp = function(a, p) {
        var b = this.input.slice(this.pos, this.pos + p);
        return this.pos += p, this.finishToken(a, b);
      }, qe.readRegexp = function() {
        for (var a, p, b = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(b, "Unterminated regular expression");
          var k = this.input.charAt(this.pos);
          if (C.test(k) && this.raise(b, "Unterminated regular expression"), a)
            a = !1;
          else {
            if (k === "[")
              p = !0;
            else if (k === "]" && p)
              p = !1;
            else if (k === "/" && !p)
              break;
            a = k === "\\";
          }
          ++this.pos;
        }
        var M = this.input.slice(b, this.pos);
        ++this.pos;
        var U = this.pos, J = this.readWord1();
        this.containsEsc && this.unexpected(U);
        var ae = this.regexpState || (this.regexpState = new Sn(this));
        ae.reset(b, M, J), this.validateRegExpFlags(ae), this.validateRegExpPattern(ae);
        var de = null;
        try {
          de = new RegExp(M, J);
        } catch {
        }
        return this.finishToken(f.regexp, { pattern: M, flags: J, value: de });
      }, qe.readInt = function(a, p, b) {
        for (var k = this.options.ecmaVersion >= 12 && p === void 0, M = b && this.input.charCodeAt(this.pos) === 48, U = this.pos, J = 0, ae = 0, de = 0, Te = p ?? 1 / 0; de < Te; ++de, ++this.pos) {
          var ze = this.input.charCodeAt(this.pos), ot = void 0;
          if (k && ze === 95) {
            M && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), ae === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), de === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), ae = ze;
            continue;
          }
          if (ze >= 97 ? ot = ze - 97 + 10 : ze >= 65 ? ot = ze - 65 + 10 : ze >= 48 && ze <= 57 ? ot = ze - 48 : ot = 1 / 0, ot >= a)
            break;
          ae = ze, J = J * a + ot;
        }
        return k && ae === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === U || p != null && this.pos - U !== p ? null : J;
      };
      function yf(a, p) {
        return p ? parseInt(a, 8) : parseFloat(a.replace(/_/g, ""));
      }
      function Hl(a) {
        return typeof BigInt != "function" ? null : BigInt(a.replace(/_/g, ""));
      }
      qe.readRadixNumber = function(a) {
        var p = this.pos;
        this.pos += 2;
        var b = this.readInt(a);
        return b == null && this.raise(this.start + 2, "Expected number in radix " + a), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (b = Hl(this.input.slice(p, this.pos)), ++this.pos) : y(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(f.num, b);
      }, qe.readNumber = function(a) {
        var p = this.pos;
        !a && this.readInt(10, void 0, !0) === null && this.raise(p, "Invalid number");
        var b = this.pos - p >= 2 && this.input.charCodeAt(p) === 48;
        b && this.strict && this.raise(p, "Invalid number");
        var k = this.input.charCodeAt(this.pos);
        if (!b && !a && this.options.ecmaVersion >= 11 && k === 110) {
          var M = Hl(this.input.slice(p, this.pos));
          return ++this.pos, y(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(f.num, M);
        }
        b && /[89]/.test(this.input.slice(p, this.pos)) && (b = !1), k === 46 && !b && (++this.pos, this.readInt(10), k = this.input.charCodeAt(this.pos)), (k === 69 || k === 101) && !b && (k = this.input.charCodeAt(++this.pos), (k === 43 || k === 45) && ++this.pos, this.readInt(10) === null && this.raise(p, "Invalid number")), y(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
        var U = yf(this.input.slice(p, this.pos), b);
        return this.finishToken(f.num, U);
      }, qe.readCodePoint = function() {
        var a = this.input.charCodeAt(this.pos), p;
        if (a === 123) {
          this.options.ecmaVersion < 6 && this.unexpected();
          var b = ++this.pos;
          p = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, p > 1114111 && this.invalidStringToken(b, "Code point out of bounds");
        } else
          p = this.readHexChar(4);
        return p;
      }, qe.readString = function(a) {
        for (var p = "", b = ++this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
          var k = this.input.charCodeAt(this.pos);
          if (k === a)
            break;
          k === 92 ? (p += this.input.slice(b, this.pos), p += this.readEscapedChar(!1), b = this.pos) : k === 8232 || k === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (R(k) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
        }
        return p += this.input.slice(b, this.pos++), this.finishToken(f.string, p);
      };
      var Ul = {};
      qe.tryReadTemplateToken = function() {
        this.inTemplateElement = !0;
        try {
          this.readTmplToken();
        } catch (a) {
          if (a === Ul)
            this.readInvalidTemplateToken();
          else
            throw a;
        }
        this.inTemplateElement = !1;
      }, qe.invalidStringToken = function(a, p) {
        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
          throw Ul;
        this.raise(a, p);
      }, qe.readTmplToken = function() {
        for (var a = "", p = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
          var b = this.input.charCodeAt(this.pos);
          if (b === 96 || b === 36 && this.input.charCodeAt(this.pos + 1) === 123)
            return this.pos === this.start && (this.type === f.template || this.type === f.invalidTemplate) ? b === 36 ? (this.pos += 2, this.finishToken(f.dollarBraceL)) : (++this.pos, this.finishToken(f.backQuote)) : (a += this.input.slice(p, this.pos), this.finishToken(f.template, a));
          if (b === 92)
            a += this.input.slice(p, this.pos), a += this.readEscapedChar(!0), p = this.pos;
          else if (R(b)) {
            switch (a += this.input.slice(p, this.pos), ++this.pos, b) {
              case 13:
                this.input.charCodeAt(this.pos) === 10 && ++this.pos;
              case 10:
                a += `
`;
                break;
              default:
                a += String.fromCharCode(b);
                break;
            }
            this.options.locations && (++this.curLine, this.lineStart = this.pos), p = this.pos;
          } else
            ++this.pos;
        }
      }, qe.readInvalidTemplateToken = function() {
        for (; this.pos < this.input.length; this.pos++)
          switch (this.input[this.pos]) {
            case "\\":
              ++this.pos;
              break;
            case "$":
              if (this.input[this.pos + 1] !== "{")
                break;
            // fall through
            case "`":
              return this.finishToken(f.invalidTemplate, this.input.slice(this.start, this.pos));
            case "\r":
              this.input[this.pos + 1] === `
` && ++this.pos;
            // fall through
            case `
`:
            case "\u2028":
            case "\u2029":
              ++this.curLine, this.lineStart = this.pos + 1;
              break;
          }
        this.raise(this.start, "Unterminated template");
      }, qe.readEscapedChar = function(a) {
        var p = this.input.charCodeAt(++this.pos);
        switch (++this.pos, p) {
          case 110:
            return `
`;
          // 'n' -> '\n'
          case 114:
            return "\r";
          // 'r' -> '\r'
          case 120:
            return String.fromCharCode(this.readHexChar(2));
          // 'x'
          case 117:
            return P(this.readCodePoint());
          // 'u'
          case 116:
            return "	";
          // 't' -> '\t'
          case 98:
            return "\b";
          // 'b' -> '\b'
          case 118:
            return "\v";
          // 'v' -> '\u000b'
          case 102:
            return "\f";
          // 'f' -> '\f'
          case 13:
            this.input.charCodeAt(this.pos) === 10 && ++this.pos;
          // '\r\n'
          case 10:
            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
          case 56:
          case 57:
            if (this.strict && this.invalidStringToken(
              this.pos - 1,
              "Invalid escape sequence"
            ), a) {
              var b = this.pos - 1;
              this.invalidStringToken(
                b,
                "Invalid escape sequence in template string"
              );
            }
          default:
            if (p >= 48 && p <= 55) {
              var k = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], M = parseInt(k, 8);
              return M > 255 && (k = k.slice(0, -1), M = parseInt(k, 8)), this.pos += k.length - 1, p = this.input.charCodeAt(this.pos), (k !== "0" || p === 56 || p === 57) && (this.strict || a) && this.invalidStringToken(
                this.pos - 1 - k.length,
                a ? "Octal literal in template string" : "Octal literal in strict mode"
              ), String.fromCharCode(M);
            }
            return R(p) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(p);
        }
      }, qe.readHexChar = function(a) {
        var p = this.pos, b = this.readInt(16, a);
        return b === null && this.invalidStringToken(p, "Bad character escape sequence"), b;
      }, qe.readWord1 = function() {
        this.containsEsc = !1;
        for (var a = "", p = !0, b = this.pos, k = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
          var M = this.fullCharCodeAtPos();
          if (v(M, k))
            this.pos += M <= 65535 ? 1 : 2;
          else if (M === 92) {
            this.containsEsc = !0, a += this.input.slice(b, this.pos);
            var U = this.pos;
            this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
            var J = this.readCodePoint();
            (p ? y : v)(J, k) || this.invalidStringToken(U, "Invalid Unicode escape"), a += P(J), b = this.pos;
          } else
            break;
          p = !1;
        }
        return a + this.input.slice(b, this.pos);
      }, qe.readWord = function() {
        var a = this.readWord1(), p = f.name;
        return this.keywords.test(a) && (p = N[a]), this.finishToken(p, a);
      };
      var ql = "8.15.0";
      Y.acorn = {
        Parser: Y,
        version: ql,
        defaultOptions: Ce,
        Position: se,
        SourceLocation: D,
        getLineInfo: pe,
        Node: yi,
        TokenType: w,
        tokTypes: f,
        keywordTypes: N,
        TokContext: Wt,
        tokContexts: tt,
        isIdentifierChar: v,
        isIdentifierStart: y,
        Token: as,
        isNewLine: R,
        lineBreak: C,
        lineBreakG: L,
        nonASCIIwhitespace: z
      };
      function vf(a, p) {
        return Y.parse(a, p);
      }
      function wf(a, p, b) {
        return Y.parseExpressionAt(a, p, b);
      }
      function kf(a, p) {
        return Y.tokenizer(a, p);
      }
      n.Node = yi, n.Parser = Y, n.Position = se, n.SourceLocation = D, n.TokContext = Wt, n.Token = as, n.TokenType = w, n.defaultOptions = Ce, n.getLineInfo = pe, n.isIdentifierChar = v, n.isIdentifierStart = y, n.isNewLine = R, n.keywordTypes = N, n.lineBreak = C, n.lineBreakG = L, n.nonASCIIwhitespace = z, n.parse = vf, n.parseExpressionAt = wf, n.tokContexts = tt, n.tokTypes = f, n.tokenizer = kf, n.version = ql;
    }));
  })(Mr, Mr.exports)), Mr.exports;
}
var Cu;
function C2() {
  return Cu || (Cu = 1, (function(e) {
    const t = w2(), n = /^[\da-fA-F]+$/, i = /^\d+$/, r = /* @__PURE__ */ new WeakMap();
    function s(u) {
      u = u.Parser.acorn || u;
      let c = r.get(u);
      if (!c) {
        const d = u.tokTypes, h = u.TokContext, m = u.TokenType, _ = new h("<tag", !1), y = new h("</tag", !1), v = new h("<tag>...</tag>", !0, !0), w = {
          tc_oTag: _,
          tc_cTag: y,
          tc_expr: v
        }, x = {
          jsxName: new m("jsxName"),
          jsxText: new m("jsxText", { beforeExpr: !0 }),
          jsxTagStart: new m("jsxTagStart", { startsExpr: !0 }),
          jsxTagEnd: new m("jsxTagEnd")
        };
        x.jsxTagStart.updateContext = function() {
          this.context.push(v), this.context.push(_), this.exprAllowed = !1;
        }, x.jsxTagEnd.updateContext = function(A) {
          let S = this.context.pop();
          S === _ && A === d.slash || S === y ? (this.context.pop(), this.exprAllowed = this.curContext() === v) : this.exprAllowed = !0;
        }, c = { tokContexts: w, tokTypes: x }, r.set(u, c);
      }
      return c;
    }
    function o(u) {
      if (!u)
        return u;
      if (u.type === "JSXIdentifier")
        return u.name;
      if (u.type === "JSXNamespacedName")
        return u.namespace.name + ":" + u.name.name;
      if (u.type === "JSXMemberExpression")
        return o(u.object) + "." + o(u.property);
    }
    e.exports = function(u) {
      return u = u || {}, function(c) {
        return l({
          allowNamespaces: u.allowNamespaces !== !1,
          allowNamespacedObjects: !!u.allowNamespacedObjects
        }, c);
      };
    }, Object.defineProperty(e.exports, "tokTypes", {
      get: function() {
        return s(ku()).tokTypes;
      },
      configurable: !0,
      enumerable: !0
    });
    function l(u, c) {
      const d = c.acorn || ku(), h = s(d), m = d.tokTypes, _ = h.tokTypes, y = d.tokContexts, v = h.tokContexts.tc_oTag, w = h.tokContexts.tc_cTag, x = h.tokContexts.tc_expr, A = d.isNewLine, S = d.isIdentifierStart, N = d.isIdentifierChar;
      return class extends c {
        // Expose actual `tokTypes` and `tokContexts` to other plugins.
        static get acornJsx() {
          return h;
        }
        // Reads inline JSX contents token.
        jsx_readToken() {
          let E = "", f = this.pos;
          for (; ; ) {
            this.pos >= this.input.length && this.raise(this.start, "Unterminated JSX contents");
            let C = this.input.charCodeAt(this.pos);
            switch (C) {
              case 60:
              // '<'
              case 123:
                return this.pos === this.start ? C === 60 && this.exprAllowed ? (++this.pos, this.finishToken(_.jsxTagStart)) : this.getTokenFromCode(C) : (E += this.input.slice(f, this.pos), this.finishToken(_.jsxText, E));
              case 38:
                E += this.input.slice(f, this.pos), E += this.jsx_readEntity(), f = this.pos;
                break;
              case 62:
              // '>'
              case 125:
                this.raise(
                  this.pos,
                  "Unexpected token `" + this.input[this.pos] + "`. Did you mean `" + (C === 62 ? "&gt;" : "&rbrace;") + '` or `{"' + this.input[this.pos] + '"}`?'
                );
              default:
                A(C) ? (E += this.input.slice(f, this.pos), E += this.jsx_readNewLine(!0), f = this.pos) : ++this.pos;
            }
          }
        }
        jsx_readNewLine(E) {
          let f = this.input.charCodeAt(this.pos), C;
          return ++this.pos, f === 13 && this.input.charCodeAt(this.pos) === 10 ? (++this.pos, C = E ? `
` : `\r
`) : C = String.fromCharCode(f), this.options.locations && (++this.curLine, this.lineStart = this.pos), C;
        }
        jsx_readString(E) {
          let f = "", C = ++this.pos;
          for (; ; ) {
            this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
            let L = this.input.charCodeAt(this.pos);
            if (L === E) break;
            L === 38 ? (f += this.input.slice(C, this.pos), f += this.jsx_readEntity(), C = this.pos) : A(L) ? (f += this.input.slice(C, this.pos), f += this.jsx_readNewLine(!1), C = this.pos) : ++this.pos;
          }
          return f += this.input.slice(C, this.pos++), this.finishToken(m.string, f);
        }
        jsx_readEntity() {
          let E = "", f = 0, C, L = this.input[this.pos];
          L !== "&" && this.raise(this.pos, "Entity must start with an ampersand");
          let R = ++this.pos;
          for (; this.pos < this.input.length && f++ < 10; ) {
            if (L = this.input[this.pos++], L === ";") {
              E[0] === "#" ? E[1] === "x" ? (E = E.substr(2), n.test(E) && (C = String.fromCharCode(parseInt(E, 16)))) : (E = E.substr(1), i.test(E) && (C = String.fromCharCode(parseInt(E, 10)))) : C = t[E];
              break;
            }
            E += L;
          }
          return C || (this.pos = R, "&");
        }
        // Read a JSX identifier (valid tag or attribute name).
        //
        // Optimized version since JSX identifiers can't contain
        // escape characters and so can be read as single slice.
        // Also assumes that first character was already checked
        // by isIdentifierStart in readToken.
        jsx_readWord() {
          let E, f = this.pos;
          do
            E = this.input.charCodeAt(++this.pos);
          while (N(E) || E === 45);
          return this.finishToken(_.jsxName, this.input.slice(f, this.pos));
        }
        // Parse next token as JSX identifier
        jsx_parseIdentifier() {
          let E = this.startNode();
          return this.type === _.jsxName ? E.name = this.value : this.type.keyword ? E.name = this.type.keyword : this.unexpected(), this.next(), this.finishNode(E, "JSXIdentifier");
        }
        // Parse namespaced identifier.
        jsx_parseNamespacedName() {
          let E = this.start, f = this.startLoc, C = this.jsx_parseIdentifier();
          if (!u.allowNamespaces || !this.eat(m.colon)) return C;
          var L = this.startNodeAt(E, f);
          return L.namespace = C, L.name = this.jsx_parseIdentifier(), this.finishNode(L, "JSXNamespacedName");
        }
        // Parses element name in any form - namespaced, member
        // or single identifier.
        jsx_parseElementName() {
          if (this.type === _.jsxTagEnd) return "";
          let E = this.start, f = this.startLoc, C = this.jsx_parseNamespacedName();
          for (this.type === m.dot && C.type === "JSXNamespacedName" && !u.allowNamespacedObjects && this.unexpected(); this.eat(m.dot); ) {
            let L = this.startNodeAt(E, f);
            L.object = C, L.property = this.jsx_parseIdentifier(), C = this.finishNode(L, "JSXMemberExpression");
          }
          return C;
        }
        // Parses any type of JSX attribute value.
        jsx_parseAttributeValue() {
          switch (this.type) {
            case m.braceL:
              let E = this.jsx_parseExpressionContainer();
              return E.expression.type === "JSXEmptyExpression" && this.raise(E.start, "JSX attributes must only be assigned a non-empty expression"), E;
            case _.jsxTagStart:
            case m.string:
              return this.parseExprAtom();
            default:
              this.raise(this.start, "JSX value should be either an expression or a quoted JSX text");
          }
        }
        // JSXEmptyExpression is unique type since it doesn't actually parse anything,
        // and so it should start at the end of last read token (left brace) and finish
        // at the beginning of the next one (right brace).
        jsx_parseEmptyExpression() {
          let E = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
          return this.finishNodeAt(E, "JSXEmptyExpression", this.start, this.startLoc);
        }
        // Parses JSX expression enclosed into curly brackets.
        jsx_parseExpressionContainer() {
          let E = this.startNode();
          return this.next(), E.expression = this.type === m.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression(), this.expect(m.braceR), this.finishNode(E, "JSXExpressionContainer");
        }
        // Parses following JSX attribute name-value pair.
        jsx_parseAttribute() {
          let E = this.startNode();
          return this.eat(m.braceL) ? (this.expect(m.ellipsis), E.argument = this.parseMaybeAssign(), this.expect(m.braceR), this.finishNode(E, "JSXSpreadAttribute")) : (E.name = this.jsx_parseNamespacedName(), E.value = this.eat(m.eq) ? this.jsx_parseAttributeValue() : null, this.finishNode(E, "JSXAttribute"));
        }
        // Parses JSX opening tag starting after '<'.
        jsx_parseOpeningElementAt(E, f) {
          let C = this.startNodeAt(E, f);
          C.attributes = [];
          let L = this.jsx_parseElementName();
          for (L && (C.name = L); this.type !== m.slash && this.type !== _.jsxTagEnd; )
            C.attributes.push(this.jsx_parseAttribute());
          return C.selfClosing = this.eat(m.slash), this.expect(_.jsxTagEnd), this.finishNode(C, L ? "JSXOpeningElement" : "JSXOpeningFragment");
        }
        // Parses JSX closing tag starting after '</'.
        jsx_parseClosingElementAt(E, f) {
          let C = this.startNodeAt(E, f), L = this.jsx_parseElementName();
          return L && (C.name = L), this.expect(_.jsxTagEnd), this.finishNode(C, L ? "JSXClosingElement" : "JSXClosingFragment");
        }
        // Parses entire JSX element, including it's opening tag
        // (starting after '<'), attributes, contents and closing tag.
        jsx_parseElementAt(E, f) {
          let C = this.startNodeAt(E, f), L = [], R = this.jsx_parseOpeningElementAt(E, f), V = null;
          if (!R.selfClosing) {
            e: for (; ; )
              switch (this.type) {
                case _.jsxTagStart:
                  if (E = this.start, f = this.startLoc, this.next(), this.eat(m.slash)) {
                    V = this.jsx_parseClosingElementAt(E, f);
                    break e;
                  }
                  L.push(this.jsx_parseElementAt(E, f));
                  break;
                case _.jsxText:
                  L.push(this.parseExprAtom());
                  break;
                case m.braceL:
                  L.push(this.jsx_parseExpressionContainer());
                  break;
                default:
                  this.unexpected();
              }
            o(V.name) !== o(R.name) && this.raise(
              V.start,
              "Expected corresponding JSX closing tag for <" + o(R.name) + ">"
            );
          }
          let z = R.name ? "Element" : "Fragment";
          return C["opening" + z] = R, C["closing" + z] = V, C.children = L, this.type === m.relational && this.value === "<" && this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag"), this.finishNode(C, "JSX" + z);
        }
        // Parse JSX text
        jsx_parseText() {
          let E = this.parseLiteral(this.value);
          return E.type = "JSXText", E;
        }
        // Parses entire JSX element from current position.
        jsx_parseElement() {
          let E = this.start, f = this.startLoc;
          return this.next(), this.jsx_parseElementAt(E, f);
        }
        parseExprAtom(E) {
          return this.type === _.jsxText ? this.jsx_parseText() : this.type === _.jsxTagStart ? this.jsx_parseElement() : super.parseExprAtom(E);
        }
        readToken(E) {
          let f = this.curContext();
          if (f === x) return this.jsx_readToken();
          if (f === v || f === w) {
            if (S(E)) return this.jsx_readWord();
            if (E == 62)
              return ++this.pos, this.finishToken(_.jsxTagEnd);
            if ((E === 34 || E === 39) && f == v)
              return this.jsx_readString(E);
          }
          return E === 60 && this.exprAllowed && this.input.charCodeAt(this.pos + 1) !== 33 ? (++this.pos, this.finishToken(_.jsxTagStart)) : super.readToken(E);
        }
        updateContext(E) {
          if (this.type == m.braceL) {
            var f = this.curContext();
            f == v ? this.context.push(y.b_expr) : f == x ? this.context.push(y.b_tmpl) : super.updateContext(E), this.exprAllowed = !0;
          } else if (this.type === m.slash && E === _.jsxTagStart)
            this.context.length -= 2, this.context.push(w), this.exprAllowed = !1;
          else
            return super.updateContext(E);
        }
      };
    }
  })(va)), va.exports;
}
var S2 = C2();
const Hd = /* @__PURE__ */ Xr(S2), { stringify: E2 } = JSON;
if (!String.prototype.repeat)
  throw new Error(
    "String.prototype.repeat is undefined, see https://github.com/davidbonnet/astring#installation"
  );
if (!String.prototype.endsWith)
  throw new Error(
    "String.prototype.endsWith is undefined, see https://github.com/davidbonnet/astring#installation"
  );
const ps = {
  "||": 2,
  "??": 3,
  "&&": 4,
  "|": 5,
  "^": 6,
  "&": 7,
  "==": 8,
  "!=": 8,
  "===": 8,
  "!==": 8,
  "<": 9,
  ">": 9,
  "<=": 9,
  ">=": 9,
  in: 9,
  instanceof: 9,
  "<<": 10,
  ">>": 10,
  ">>>": 10,
  "+": 11,
  "-": 11,
  "*": 12,
  "%": 12,
  "/": 12,
  "**": 13
}, vn = 17, A2 = {
  // Definitions
  ArrayExpression: 20,
  TaggedTemplateExpression: 20,
  ThisExpression: 20,
  Identifier: 20,
  PrivateIdentifier: 20,
  Literal: 18,
  TemplateLiteral: 20,
  Super: 20,
  SequenceExpression: 20,
  // Operations
  MemberExpression: 19,
  ChainExpression: 19,
  CallExpression: 19,
  NewExpression: 19,
  // Other definitions
  ArrowFunctionExpression: vn,
  ClassExpression: vn,
  FunctionExpression: vn,
  ObjectExpression: vn,
  // Other operations
  UpdateExpression: 16,
  UnaryExpression: 15,
  AwaitExpression: 15,
  BinaryExpression: 14,
  LogicalExpression: 13,
  ConditionalExpression: 4,
  AssignmentExpression: 3,
  YieldExpression: 2,
  RestElement: 1
};
function qi(e, t) {
  const { generator: n } = e;
  if (e.write("("), t != null && t.length > 0) {
    n[t[0].type](t[0], e);
    const { length: i } = t;
    for (let r = 1; r < i; r++) {
      const s = t[r];
      e.write(", "), n[s.type](s, e);
    }
  }
  e.write(")");
}
function Ud(e, t, n, i) {
  const r = e.expressionsPrecedence[t.type];
  if (r === vn)
    return !0;
  const s = e.expressionsPrecedence[n.type];
  return r !== s ? !i && r === 15 && s === 14 && n.operator === "**" || r < s : r !== 13 && r !== 14 ? !1 : t.operator === "**" && n.operator === "**" ? !i : r === 13 && s === 13 && (t.operator === "??" || n.operator === "??") ? !0 : i ? ps[t.operator] <= ps[n.operator] : ps[t.operator] < ps[n.operator];
}
function fs(e, t, n, i) {
  const { generator: r } = e;
  Ud(e, t, n, i) ? (e.write("("), r[t.type](t, e), e.write(")")) : r[t.type](t, e);
}
function I2(e, t, n, i) {
  const r = t.split(`
`), s = r.length - 1;
  if (e.write(r[0].trim()), s > 0) {
    e.write(i);
    for (let o = 1; o < s; o++)
      e.write(n + r[o].trim() + i);
    e.write(n + r[s].trim());
  }
}
function jt(e, t, n, i) {
  const { length: r } = t;
  for (let s = 0; s < r; s++) {
    const o = t[s];
    e.write(n), o.type[0] === "L" ? e.write("// " + o.value.trim() + `
`, o) : (e.write("/*"), I2(e, o.value, n, i), e.write("*/" + i));
  }
}
function L2(e) {
  let t = e;
  for (; t != null; ) {
    const { type: n } = t;
    if (n[0] === "C" && n[1] === "a")
      return !0;
    if (n[0] === "M" && n[1] === "e" && n[2] === "m")
      t = t.object;
    else
      return !1;
  }
}
function ka(e, t) {
  const { generator: n } = e, { declarations: i } = t;
  e.write(t.kind + " ");
  const { length: r } = i;
  if (r > 0) {
    n.VariableDeclarator(i[0], e);
    for (let s = 1; s < r; s++)
      e.write(", "), n.VariableDeclarator(i[s], e);
  }
}
let Su, Eu, Au, Iu, Lu, Nu;
const qd = {
  /*
  Default generator.
  */
  Program(e, t) {
    const n = t.indent.repeat(t.indentLevel), { lineEnd: i, writeComments: r } = t;
    r && e.comments != null && jt(t, e.comments, n, i);
    const s = e.body, { length: o } = s;
    for (let l = 0; l < o; l++) {
      const u = s[l];
      r && u.comments != null && jt(t, u.comments, n, i), t.write(n), this[u.type](u, t), t.write(i);
    }
    r && e.trailingComments != null && jt(t, e.trailingComments, n, i);
  },
  BlockStatement: Nu = function(e, t) {
    const n = t.indent.repeat(t.indentLevel++), { lineEnd: i, writeComments: r } = t, s = n + t.indent;
    t.write("{");
    const o = e.body;
    if (o != null && o.length > 0) {
      t.write(i), r && e.comments != null && jt(t, e.comments, s, i);
      const { length: l } = o;
      for (let u = 0; u < l; u++) {
        const c = o[u];
        r && c.comments != null && jt(t, c.comments, s, i), t.write(s), this[c.type](c, t), t.write(i);
      }
      t.write(n);
    } else
      r && e.comments != null && (t.write(i), jt(t, e.comments, s, i), t.write(n));
    r && e.trailingComments != null && jt(t, e.trailingComments, s, i), t.write("}"), t.indentLevel--;
  },
  ClassBody: Nu,
  StaticBlock(e, t) {
    t.write("static "), this.BlockStatement(e, t);
  },
  EmptyStatement(e, t) {
    t.write(";");
  },
  ExpressionStatement(e, t) {
    const n = t.expressionsPrecedence[e.expression.type];
    n === vn || n === 3 && e.expression.left.type[0] === "O" ? (t.write("("), this[e.expression.type](e.expression, t), t.write(")")) : this[e.expression.type](e.expression, t), t.write(";");
  },
  IfStatement(e, t) {
    t.write("if ("), this[e.test.type](e.test, t), t.write(") "), this[e.consequent.type](e.consequent, t), e.alternate != null && (t.write(" else "), this[e.alternate.type](e.alternate, t));
  },
  LabeledStatement(e, t) {
    this[e.label.type](e.label, t), t.write(": "), this[e.body.type](e.body, t);
  },
  BreakStatement(e, t) {
    t.write("break"), e.label != null && (t.write(" "), this[e.label.type](e.label, t)), t.write(";");
  },
  ContinueStatement(e, t) {
    t.write("continue"), e.label != null && (t.write(" "), this[e.label.type](e.label, t)), t.write(";");
  },
  WithStatement(e, t) {
    t.write("with ("), this[e.object.type](e.object, t), t.write(") "), this[e.body.type](e.body, t);
  },
  SwitchStatement(e, t) {
    const n = t.indent.repeat(t.indentLevel++), { lineEnd: i, writeComments: r } = t;
    t.indentLevel++;
    const s = n + t.indent, o = s + t.indent;
    t.write("switch ("), this[e.discriminant.type](e.discriminant, t), t.write(") {" + i);
    const { cases: l } = e, { length: u } = l;
    for (let c = 0; c < u; c++) {
      const d = l[c];
      r && d.comments != null && jt(t, d.comments, s, i), d.test ? (t.write(s + "case "), this[d.test.type](d.test, t), t.write(":" + i)) : t.write(s + "default:" + i);
      const { consequent: h } = d, { length: m } = h;
      for (let _ = 0; _ < m; _++) {
        const y = h[_];
        r && y.comments != null && jt(t, y.comments, o, i), t.write(o), this[y.type](y, t), t.write(i);
      }
    }
    t.indentLevel -= 2, t.write(n + "}");
  },
  ReturnStatement(e, t) {
    t.write("return"), e.argument && (t.write(" "), this[e.argument.type](e.argument, t)), t.write(";");
  },
  ThrowStatement(e, t) {
    t.write("throw "), this[e.argument.type](e.argument, t), t.write(";");
  },
  TryStatement(e, t) {
    if (t.write("try "), this[e.block.type](e.block, t), e.handler) {
      const { handler: n } = e;
      n.param == null ? t.write(" catch ") : (t.write(" catch ("), this[n.param.type](n.param, t), t.write(") ")), this[n.body.type](n.body, t);
    }
    e.finalizer && (t.write(" finally "), this[e.finalizer.type](e.finalizer, t));
  },
  WhileStatement(e, t) {
    t.write("while ("), this[e.test.type](e.test, t), t.write(") "), this[e.body.type](e.body, t);
  },
  DoWhileStatement(e, t) {
    t.write("do "), this[e.body.type](e.body, t), t.write(" while ("), this[e.test.type](e.test, t), t.write(");");
  },
  ForStatement(e, t) {
    if (t.write("for ("), e.init != null) {
      const { init: n } = e;
      n.type[0] === "V" ? ka(t, n) : this[n.type](n, t);
    }
    t.write("; "), e.test && this[e.test.type](e.test, t), t.write("; "), e.update && this[e.update.type](e.update, t), t.write(") "), this[e.body.type](e.body, t);
  },
  ForInStatement: Su = function(e, t) {
    t.write(`for ${e.await ? "await " : ""}(`);
    const { left: n } = e;
    n.type[0] === "V" ? ka(t, n) : this[n.type](n, t), t.write(e.type[3] === "I" ? " in " : " of "), this[e.right.type](e.right, t), t.write(") "), this[e.body.type](e.body, t);
  },
  ForOfStatement: Su,
  DebuggerStatement(e, t) {
    t.write("debugger;", e);
  },
  FunctionDeclaration: Eu = function(e, t) {
    t.write(
      (e.async ? "async " : "") + (e.generator ? "function* " : "function ") + (e.id ? e.id.name : ""),
      e
    ), qi(t, e.params), t.write(" "), this[e.body.type](e.body, t);
  },
  FunctionExpression: Eu,
  VariableDeclaration(e, t) {
    ka(t, e), t.write(";");
  },
  VariableDeclarator(e, t) {
    this[e.id.type](e.id, t), e.init != null && (t.write(" = "), this[e.init.type](e.init, t));
  },
  ClassDeclaration(e, t) {
    if (t.write("class " + (e.id ? `${e.id.name} ` : ""), e), e.superClass) {
      t.write("extends ");
      const { superClass: n } = e, { type: i } = n, r = t.expressionsPrecedence[i];
      (i[0] !== "C" || i[1] !== "l" || i[5] !== "E") && (r === vn || r < t.expressionsPrecedence.ClassExpression) ? (t.write("("), this[e.superClass.type](n, t), t.write(")")) : this[n.type](n, t), t.write(" ");
    }
    this.ClassBody(e.body, t);
  },
  ImportDeclaration(e, t) {
    t.write("import ");
    const { specifiers: n, attributes: i } = e, { length: r } = n;
    let s = 0;
    if (r > 0) {
      for (; s < r; ) {
        s > 0 && t.write(", ");
        const o = n[s], l = o.type[6];
        if (l === "D")
          t.write(o.local.name, o), s++;
        else if (l === "N")
          t.write("* as " + o.local.name, o), s++;
        else
          break;
      }
      if (s < r) {
        for (t.write("{"); ; ) {
          const o = n[s], { name: l } = o.imported;
          if (t.write(l, o), l !== o.local.name && t.write(" as " + o.local.name), ++s < r)
            t.write(", ");
          else
            break;
        }
        t.write("}");
      }
      t.write(" from ");
    }
    if (this.Literal(e.source, t), i && i.length > 0) {
      t.write(" with { ");
      for (let o = 0; o < i.length; o++)
        this.ImportAttribute(i[o], t), o < i.length - 1 && t.write(", ");
      t.write(" }");
    }
    t.write(";");
  },
  ImportAttribute(e, t) {
    this.Identifier(e.key, t), t.write(": "), this.Literal(e.value, t);
  },
  ImportExpression(e, t) {
    t.write("import("), this[e.source.type](e.source, t), t.write(")");
  },
  ExportDefaultDeclaration(e, t) {
    t.write("export default "), this[e.declaration.type](e.declaration, t), t.expressionsPrecedence[e.declaration.type] != null && e.declaration.type[0] !== "F" && t.write(";");
  },
  ExportNamedDeclaration(e, t) {
    if (t.write("export "), e.declaration)
      this[e.declaration.type](e.declaration, t);
    else {
      t.write("{");
      const { specifiers: n } = e, { length: i } = n;
      if (i > 0)
        for (let r = 0; ; ) {
          const s = n[r], { name: o } = s.local;
          if (t.write(o, s), o !== s.exported.name && t.write(" as " + s.exported.name), ++r < i)
            t.write(", ");
          else
            break;
        }
      if (t.write("}"), e.source && (t.write(" from "), this.Literal(e.source, t)), e.attributes && e.attributes.length > 0) {
        t.write(" with { ");
        for (let r = 0; r < e.attributes.length; r++)
          this.ImportAttribute(e.attributes[r], t), r < e.attributes.length - 1 && t.write(", ");
        t.write(" }");
      }
      t.write(";");
    }
  },
  ExportAllDeclaration(e, t) {
    if (e.exported != null ? t.write("export * as " + e.exported.name + " from ") : t.write("export * from "), this.Literal(e.source, t), e.attributes && e.attributes.length > 0) {
      t.write(" with { ");
      for (let n = 0; n < e.attributes.length; n++)
        this.ImportAttribute(e.attributes[n], t), n < e.attributes.length - 1 && t.write(", ");
      t.write(" }");
    }
    t.write(";");
  },
  MethodDefinition(e, t) {
    e.static && t.write("static ");
    const n = e.kind[0];
    (n === "g" || n === "s") && t.write(e.kind + " "), e.value.async && t.write("async "), e.value.generator && t.write("*"), e.computed ? (t.write("["), this[e.key.type](e.key, t), t.write("]")) : this[e.key.type](e.key, t), qi(t, e.value.params), t.write(" "), this[e.value.body.type](e.value.body, t);
  },
  ClassExpression(e, t) {
    this.ClassDeclaration(e, t);
  },
  ArrowFunctionExpression(e, t) {
    t.write(e.async ? "async " : "", e);
    const { params: n } = e;
    n != null && (n.length === 1 && n[0].type[0] === "I" ? t.write(n[0].name, n[0]) : qi(t, e.params)), t.write(" => "), e.body.type[0] === "O" ? (t.write("("), this.ObjectExpression(e.body, t), t.write(")")) : this[e.body.type](e.body, t);
  },
  ThisExpression(e, t) {
    t.write("this", e);
  },
  Super(e, t) {
    t.write("super", e);
  },
  RestElement: Au = function(e, t) {
    t.write("..."), this[e.argument.type](e.argument, t);
  },
  SpreadElement: Au,
  YieldExpression(e, t) {
    t.write(e.delegate ? "yield*" : "yield"), e.argument && (t.write(" "), this[e.argument.type](e.argument, t));
  },
  AwaitExpression(e, t) {
    t.write("await ", e), fs(t, e.argument, e);
  },
  TemplateLiteral(e, t) {
    const { quasis: n, expressions: i } = e;
    t.write("`");
    const { length: r } = i;
    for (let o = 0; o < r; o++) {
      const l = i[o], u = n[o];
      t.write(u.value.raw, u), t.write("${"), this[l.type](l, t), t.write("}");
    }
    const s = n[n.length - 1];
    t.write(s.value.raw, s), t.write("`");
  },
  TemplateElement(e, t) {
    t.write(e.value.raw, e);
  },
  TaggedTemplateExpression(e, t) {
    fs(t, e.tag, e), this[e.quasi.type](e.quasi, t);
  },
  ArrayExpression: Lu = function(e, t) {
    if (t.write("["), e.elements.length > 0) {
      const { elements: n } = e, { length: i } = n;
      for (let r = 0; ; ) {
        const s = n[r];
        if (s != null && this[s.type](s, t), ++r < i)
          t.write(", ");
        else {
          s == null && t.write(", ");
          break;
        }
      }
    }
    t.write("]");
  },
  ArrayPattern: Lu,
  ObjectExpression(e, t) {
    const n = t.indent.repeat(t.indentLevel++), { lineEnd: i, writeComments: r } = t, s = n + t.indent;
    if (t.write("{"), e.properties.length > 0) {
      t.write(i), r && e.comments != null && jt(t, e.comments, s, i);
      const o = "," + i, { properties: l } = e, { length: u } = l;
      for (let c = 0; ; ) {
        const d = l[c];
        if (r && d.comments != null && jt(t, d.comments, s, i), t.write(s), this[d.type](d, t), ++c < u)
          t.write(o);
        else
          break;
      }
      t.write(i), r && e.trailingComments != null && jt(t, e.trailingComments, s, i), t.write(n + "}");
    } else r ? e.comments != null ? (t.write(i), jt(t, e.comments, s, i), e.trailingComments != null && jt(t, e.trailingComments, s, i), t.write(n + "}")) : e.trailingComments != null ? (t.write(i), jt(t, e.trailingComments, s, i), t.write(n + "}")) : t.write("}") : t.write("}");
    t.indentLevel--;
  },
  Property(e, t) {
    e.method || e.kind[0] !== "i" ? this.MethodDefinition(e, t) : (e.shorthand || (e.computed ? (t.write("["), this[e.key.type](e.key, t), t.write("]")) : this[e.key.type](e.key, t), t.write(": ")), this[e.value.type](e.value, t));
  },
  PropertyDefinition(e, t) {
    if (e.static && t.write("static "), e.computed && t.write("["), this[e.key.type](e.key, t), e.computed && t.write("]"), e.value == null) {
      e.key.type[0] !== "F" && t.write(";");
      return;
    }
    t.write(" = "), this[e.value.type](e.value, t), t.write(";");
  },
  ObjectPattern(e, t) {
    if (t.write("{"), e.properties.length > 0) {
      const { properties: n } = e, { length: i } = n;
      for (let r = 0; this[n[r].type](n[r], t), ++r < i; )
        t.write(", ");
    }
    t.write("}");
  },
  SequenceExpression(e, t) {
    qi(t, e.expressions);
  },
  UnaryExpression(e, t) {
    if (e.prefix) {
      const {
        operator: n,
        argument: i,
        argument: { type: r }
      } = e;
      t.write(n);
      const s = Ud(t, i, e);
      !s && (n.length > 1 || r[0] === "U" && (r[1] === "n" || r[1] === "p") && i.prefix && i.operator[0] === n && (n === "+" || n === "-")) && t.write(" "), s ? (t.write(n.length > 1 ? " (" : "("), this[r](i, t), t.write(")")) : this[r](i, t);
    } else
      this[e.argument.type](e.argument, t), t.write(e.operator);
  },
  UpdateExpression(e, t) {
    e.prefix ? (t.write(e.operator), this[e.argument.type](e.argument, t)) : (this[e.argument.type](e.argument, t), t.write(e.operator));
  },
  AssignmentExpression(e, t) {
    this[e.left.type](e.left, t), t.write(" " + e.operator + " "), this[e.right.type](e.right, t);
  },
  AssignmentPattern(e, t) {
    this[e.left.type](e.left, t), t.write(" = "), this[e.right.type](e.right, t);
  },
  BinaryExpression: Iu = function(e, t) {
    const n = e.operator === "in";
    n && t.write("("), fs(t, e.left, e, !1), t.write(" " + e.operator + " "), fs(t, e.right, e, !0), n && t.write(")");
  },
  LogicalExpression: Iu,
  ConditionalExpression(e, t) {
    const { test: n } = e, i = t.expressionsPrecedence[n.type];
    i === vn || i <= t.expressionsPrecedence.ConditionalExpression ? (t.write("("), this[n.type](n, t), t.write(")")) : this[n.type](n, t), t.write(" ? "), this[e.consequent.type](e.consequent, t), t.write(" : "), this[e.alternate.type](e.alternate, t);
  },
  NewExpression(e, t) {
    t.write("new ");
    const n = t.expressionsPrecedence[e.callee.type];
    n === vn || n < t.expressionsPrecedence.CallExpression || L2(e.callee) ? (t.write("("), this[e.callee.type](e.callee, t), t.write(")")) : this[e.callee.type](e.callee, t), qi(t, e.arguments);
  },
  CallExpression(e, t) {
    const n = t.expressionsPrecedence[e.callee.type];
    n === vn || n < t.expressionsPrecedence.CallExpression ? (t.write("("), this[e.callee.type](e.callee, t), t.write(")")) : this[e.callee.type](e.callee, t), e.optional && t.write("?."), qi(t, e.arguments);
  },
  ChainExpression(e, t) {
    this[e.expression.type](e.expression, t);
  },
  MemberExpression(e, t) {
    const n = t.expressionsPrecedence[e.object.type];
    n === vn || n < t.expressionsPrecedence.MemberExpression ? (t.write("("), this[e.object.type](e.object, t), t.write(")")) : this[e.object.type](e.object, t), e.computed ? (e.optional && t.write("?."), t.write("["), this[e.property.type](e.property, t), t.write("]")) : (e.optional ? t.write("?.") : t.write("."), this[e.property.type](e.property, t));
  },
  MetaProperty(e, t) {
    t.write(e.meta.name + "." + e.property.name, e);
  },
  Identifier(e, t) {
    t.write(e.name, e);
  },
  PrivateIdentifier(e, t) {
    t.write(`#${e.name}`, e);
  },
  Literal(e, t) {
    e.raw != null ? t.write(e.raw, e) : e.regex != null ? this.RegExpLiteral(e, t) : e.bigint != null ? t.write(e.bigint + "n", e) : t.write(E2(e.value), e);
  },
  RegExpLiteral(e, t) {
    const { regex: n } = e;
    t.write(`/${n.pattern}/${n.flags}`, e);
  }
}, N2 = {};
class T2 {
  constructor(t) {
    const n = t ?? N2;
    this.output = "", n.output != null ? (this.output = n.output, this.write = this.writeToStream) : this.output = "", this.generator = n.generator != null ? n.generator : qd, this.expressionsPrecedence = n.expressionsPrecedence != null ? n.expressionsPrecedence : A2, this.indent = n.indent != null ? n.indent : "  ", this.lineEnd = n.lineEnd != null ? n.lineEnd : `
`, this.indentLevel = n.startingIndentLevel != null ? n.startingIndentLevel : 0, this.writeComments = n.comments ? n.comments : !1, n.sourceMap != null && (this.write = n.output == null ? this.writeAndMap : this.writeToStreamAndMap, this.sourceMap = n.sourceMap, this.line = 1, this.column = 0, this.lineEndSize = this.lineEnd.split(`
`).length - 1, this.mapping = {
      original: null,
      // Uses the entire state to avoid generating ephemeral objects
      generated: this,
      name: void 0,
      source: n.sourceMap.file || n.sourceMap._file
    });
  }
  write(t) {
    this.output += t;
  }
  writeToStream(t) {
    this.output.write(t);
  }
  writeAndMap(t, n) {
    this.output += t, this.map(t, n);
  }
  writeToStreamAndMap(t, n) {
    this.output.write(t), this.map(t, n);
  }
  map(t, n) {
    if (n != null) {
      const { type: s } = n;
      if (s[0] === "L" && s[2] === "n") {
        this.column = 0, this.line++;
        return;
      }
      if (n.loc != null) {
        const { mapping: o } = this;
        o.original = n.loc.start, o.name = n.name, this.sourceMap.addMapping(o);
      }
      if (s[0] === "T" && s[8] === "E" || s[0] === "L" && s[1] === "i" && typeof n.value == "string") {
        const { length: o } = t;
        let { column: l, line: u } = this;
        for (let c = 0; c < o; c++)
          t[c] === `
` ? (l = 0, u++) : l++;
        this.column = l, this.line = u;
        return;
      }
    }
    const { length: i } = t, { lineEnd: r } = this;
    i > 0 && (this.lineEndSize > 0 && (r.length === 1 ? t[i - 1] === r : t.endsWith(r)) ? (this.line += this.lineEndSize, this.column = 0) : this.column += i);
  }
  toString() {
    return this.output;
  }
}
function P2(e, t) {
  const n = new T2(t);
  return n.generator[e.type](e, n), n.output;
}
const D2 = {};
function M2(e, t) {
  const { SourceMapGenerator: n, filePath: i, handlers: r } = t || D2, s = n ? new n({ file: i || "<unknown>.js" }) : void 0, o = P2(
    e,
    // @ts-expect-error: `sourceMap` can be undefined, `astring` types are buggy.
    {
      comments: !0,
      generator: { ...qd, ...r },
      sourceMap: s || void 0
    }
  ), l = s ? s.toJSON() : void 0;
  return { value: o, map: l };
}
const V2 = {
  JSXAttribute: F2,
  JSXClosingElement: R2,
  JSXClosingFragment: O2,
  JSXElement: B2,
  JSXEmptyExpression: z2,
  JSXExpressionContainer: j2,
  JSXFragment: $2,
  JSXIdentifier: H2,
  JSXMemberExpression: U2,
  JSXNamespacedName: q2,
  JSXOpeningElement: J2,
  JSXOpeningFragment: W2,
  JSXSpreadAttribute: Z2,
  JSXText: X2
};
function F2(e, t) {
  this[e.name.type](e.name, t), e.value !== null && e.value !== void 0 && (t.write("="), e.value.type === "Literal" ? t.write(
    '"' + Jd(String(e.value.value)).replace(/"/g, "&quot;") + '"',
    e
  ) : this[e.value.type](e.value, t));
}
function R2(e, t) {
  t.write("</"), this[e.name.type](e.name, t), t.write(">");
}
function O2(e, t) {
  t.write("</>", e);
}
function B2(e, t) {
  let n = -1;
  if (this[e.openingElement.type](e.openingElement, t), e.children)
    for (; ++n < e.children.length; ) {
      const i = e.children[n];
      if (i.type === "JSXSpreadChild")
        throw new Error("JSX spread children are not supported");
      this[i.type](i, t);
    }
  e.closingElement && this[e.closingElement.type](e.closingElement, t);
}
function z2() {
}
function j2(e, t) {
  t.write("{"), this[e.expression.type](e.expression, t), t.write("}");
}
function $2(e, t) {
  let n = -1;
  if (this[e.openingFragment.type](e.openingFragment, t), e.children)
    for (; ++n < e.children.length; ) {
      const i = e.children[n];
      if (i.type === "JSXSpreadChild")
        throw new Error("JSX spread children are not supported");
      this[i.type](i, t);
    }
  this[e.closingFragment.type](e.closingFragment, t);
}
function H2(e, t) {
  t.write(e.name, e);
}
function U2(e, t) {
  this[e.object.type](e.object, t), t.write("."), this[e.property.type](e.property, t);
}
function q2(e, t) {
  this[e.namespace.type](e.namespace, t), t.write(":"), this[e.name.type](e.name, t);
}
function J2(e, t) {
  let n = -1;
  if (t.write("<"), this[e.name.type](e.name, t), e.attributes)
    for (; ++n < e.attributes.length; )
      t.write(" "), this[e.attributes[n].type](e.attributes[n], t);
  t.write(e.selfClosing ? " />" : ">");
}
function W2(e, t) {
  t.write("<>", e);
}
function Z2(e, t) {
  t.write("{"), this.SpreadElement(e, t), t.write("}");
}
function X2(e, t) {
  t.write(Jd(e.value).replace(/[<>{}]/g, G2), e);
}
function Jd(e) {
  return e.replace(/&(?=[#a-z])/gi, "&amp;");
}
function G2(e) {
  return e === "<" ? "&lt;" : e === ">" ? "&gt;" : e === "{" ? "&#123;" : "&#125;";
}
function K2() {
  const e = this.data(), t = e.settings || (e.settings = {}), n = t.handlers || (t.handlers = {});
  (t.plugins || (t.plugins = [])).push(Hd()), Object.assign(n, V2);
}
function Y2(e) {
  const t = this;
  this.compiler = n;
  function n(i, r) {
    const s = { ...t.data("settings"), ...e }, o = M2(i, {
      SourceMapGenerator: s.SourceMapGenerator,
      filePath: r.path || "unknown.js",
      handlers: s.handlers
    });
    return r.map = o.map, o.value;
  }
}
function Q2(e, t) {
  const n = { type: "Block", value: e.value };
  t.inherit(e, n), t.comments.push(n);
  const i = {
    type: "JSXEmptyExpression",
    // @ts-expect-error: `comments` is custom.
    comments: [Object.assign({}, n, { leading: !1, trailing: !0 })]
  };
  t.patch(e, i);
  const r = { type: "JSXExpressionContainer", expression: i };
  return t.patch(e, r), r;
}
function e_(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
class Qr {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, i) {
    this.normal = n, this.property = t, i && (this.space = i);
  }
}
Qr.prototype.normal = {};
Qr.prototype.property = {};
Qr.prototype.space = void 0;
function Wd(e, t) {
  const n = {}, i = {};
  for (const r of e)
    Object.assign(n, r.property), Object.assign(i, r.normal);
  return new Qr(n, i, t);
}
function _o(e) {
  return e.toLowerCase();
}
class en {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
en.prototype.attribute = "";
en.prototype.booleanish = !1;
en.prototype.boolean = !1;
en.prototype.commaOrSpaceSeparated = !1;
en.prototype.commaSeparated = !1;
en.prototype.defined = !1;
en.prototype.mustUseProperty = !1;
en.prototype.number = !1;
en.prototype.overloadedBoolean = !1;
en.prototype.property = "";
en.prototype.spaceSeparated = !1;
en.prototype.space = void 0;
let t_ = 0;
const Oe = Mi(), wt = Mi(), go = Mi(), le = Mi(), st = Mi(), er = Mi(), sn = Mi();
function Mi() {
  return 2 ** ++t_;
}
const xo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Oe,
  booleanish: wt,
  commaOrSpaceSeparated: sn,
  commaSeparated: er,
  number: le,
  overloadedBoolean: go,
  spaceSeparated: st
}, Symbol.toStringTag, { value: "Module" })), Ca = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(xo)
);
class Ko extends en {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, i, r) {
    let s = -1;
    if (super(t, n), Tu(this, "space", r), typeof i == "number")
      for (; ++s < Ca.length; ) {
        const o = Ca[s];
        Tu(this, Ca[s], (i & xo[o]) === xo[o]);
      }
  }
}
Ko.prototype.defined = !0;
function Tu(e, t, n) {
  n && (e[t] = n);
}
function cr(e) {
  const t = {}, n = {};
  for (const [i, r] of Object.entries(e.properties)) {
    const s = new Ko(
      i,
      e.transform(e.attributes || {}, i),
      r,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(i) && (s.mustUseProperty = !0), t[i] = s, n[_o(i)] = i, n[_o(s.attribute)] = i;
  }
  return new Qr(t, n, e.space);
}
const Zd = cr({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: wt,
    ariaAutoComplete: null,
    ariaBusy: wt,
    ariaChecked: wt,
    ariaColCount: le,
    ariaColIndex: le,
    ariaColSpan: le,
    ariaControls: st,
    ariaCurrent: null,
    ariaDescribedBy: st,
    ariaDetails: null,
    ariaDisabled: wt,
    ariaDropEffect: st,
    ariaErrorMessage: null,
    ariaExpanded: wt,
    ariaFlowTo: st,
    ariaGrabbed: wt,
    ariaHasPopup: null,
    ariaHidden: wt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: st,
    ariaLevel: le,
    ariaLive: null,
    ariaModal: wt,
    ariaMultiLine: wt,
    ariaMultiSelectable: wt,
    ariaOrientation: null,
    ariaOwns: st,
    ariaPlaceholder: null,
    ariaPosInSet: le,
    ariaPressed: wt,
    ariaReadOnly: wt,
    ariaRelevant: null,
    ariaRequired: wt,
    ariaRoleDescription: st,
    ariaRowCount: le,
    ariaRowIndex: le,
    ariaRowSpan: le,
    ariaSelected: wt,
    ariaSetSize: le,
    ariaSort: null,
    ariaValueMax: le,
    ariaValueMin: le,
    ariaValueNow: le,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function Xd(e, t) {
  return t in e ? e[t] : t;
}
function Gd(e, t) {
  return Xd(e, t.toLowerCase());
}
const n_ = cr({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: er,
    acceptCharset: st,
    accessKey: st,
    action: null,
    allow: null,
    allowFullScreen: Oe,
    allowPaymentRequest: Oe,
    allowUserMedia: Oe,
    alt: null,
    as: null,
    async: Oe,
    autoCapitalize: null,
    autoComplete: st,
    autoFocus: Oe,
    autoPlay: Oe,
    blocking: st,
    capture: null,
    charSet: null,
    checked: Oe,
    cite: null,
    className: st,
    cols: le,
    colSpan: null,
    content: null,
    contentEditable: wt,
    controls: Oe,
    controlsList: st,
    coords: le | er,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Oe,
    defer: Oe,
    dir: null,
    dirName: null,
    disabled: Oe,
    download: go,
    draggable: wt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Oe,
    formTarget: null,
    headers: st,
    height: le,
    hidden: go,
    high: le,
    href: null,
    hrefLang: null,
    htmlFor: st,
    httpEquiv: st,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Oe,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Oe,
    itemId: null,
    itemProp: st,
    itemRef: st,
    itemScope: Oe,
    itemType: st,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Oe,
    low: le,
    manifest: null,
    max: null,
    maxLength: le,
    media: null,
    method: null,
    min: null,
    minLength: le,
    multiple: Oe,
    muted: Oe,
    name: null,
    nonce: null,
    noModule: Oe,
    noValidate: Oe,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Oe,
    optimum: le,
    pattern: null,
    ping: st,
    placeholder: null,
    playsInline: Oe,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Oe,
    referrerPolicy: null,
    rel: st,
    required: Oe,
    reversed: Oe,
    rows: le,
    rowSpan: le,
    sandbox: st,
    scope: null,
    scoped: Oe,
    seamless: Oe,
    selected: Oe,
    shadowRootClonable: Oe,
    shadowRootDelegatesFocus: Oe,
    shadowRootMode: null,
    shape: null,
    size: le,
    sizes: null,
    slot: null,
    span: le,
    spellCheck: wt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: le,
    step: null,
    style: null,
    tabIndex: le,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Oe,
    useMap: null,
    value: wt,
    width: le,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: st,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: le,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: le,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Oe,
    // Lists. Use CSS to reduce space between items instead
    declare: Oe,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: le,
    // `<img>` and `<object>`
    leftMargin: le,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: le,
    // `<body>`
    marginWidth: le,
    // `<body>`
    noResize: Oe,
    // `<frame>`
    noHref: Oe,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Oe,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Oe,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: le,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: wt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: le,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: le,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Oe,
    disableRemotePlayback: Oe,
    prefix: null,
    property: null,
    results: le,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Gd
}), i_ = cr({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: sn,
    accentHeight: le,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: le,
    amplitude: le,
    arabicForm: null,
    ascent: le,
    attributeName: null,
    attributeType: null,
    azimuth: le,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: le,
    by: null,
    calcMode: null,
    capHeight: le,
    className: st,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: le,
    diffuseConstant: le,
    direction: null,
    display: null,
    dur: null,
    divisor: le,
    dominantBaseline: null,
    download: Oe,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: le,
    enableBackground: null,
    end: null,
    event: null,
    exponent: le,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: le,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: er,
    g2: er,
    glyphName: er,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: le,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: le,
    horizOriginX: le,
    horizOriginY: le,
    id: null,
    ideographic: le,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: le,
    k: le,
    k1: le,
    k2: le,
    k3: le,
    k4: le,
    kernelMatrix: sn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: le,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: le,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: le,
    overlineThickness: le,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: le,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: st,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: le,
    pointsAtY: le,
    pointsAtZ: le,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: sn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: sn,
    rev: sn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: sn,
    requiredFeatures: sn,
    requiredFonts: sn,
    requiredFormats: sn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: le,
    specularExponent: le,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: le,
    strikethroughThickness: le,
    string: null,
    stroke: null,
    strokeDashArray: sn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: le,
    strokeOpacity: le,
    strokeWidth: null,
    style: null,
    surfaceScale: le,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: sn,
    tabIndex: le,
    tableValues: null,
    target: null,
    targetX: le,
    targetY: le,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: sn,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: le,
    underlineThickness: le,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: le,
    values: null,
    vAlphabetic: le,
    vMathematical: le,
    vectorEffect: null,
    vHanging: le,
    vIdeographic: le,
    version: null,
    vertAdvY: le,
    vertOriginX: le,
    vertOriginY: le,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: le,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: Xd
}), Kd = cr({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), Yd = cr({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Gd
}), Qd = cr({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), r_ = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, s_ = /[A-Z]/g, Pu = /-[a-z]/g, a_ = /^data[-\w.:]+$/i;
function o_(e, t) {
  const n = _o(t);
  let i = t, r = en;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && a_.test(t)) {
    if (t.charAt(4) === "-") {
      const s = t.slice(5).replace(Pu, u_);
      i = "data" + s.charAt(0).toUpperCase() + s.slice(1);
    } else {
      const s = t.slice(4);
      if (!Pu.test(s)) {
        let o = s.replace(s_, l_);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    r = Ko;
  }
  return new r(i, t);
}
function l_(e) {
  return "-" + e.toLowerCase();
}
function u_(e) {
  return e.charAt(1).toUpperCase();
}
const c_ = Wd([Zd, n_, Kd, Yd, Qd], "html"), Yo = Wd([Zd, i_, Kd, Yd, Qd], "svg");
function d_(e) {
  return e.join(" ").trim();
}
var Ji = {}, Sa, Du;
function h_() {
  if (Du) return Sa;
  Du = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, r = /^:\s*/, s = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, o = /^[;\s]*/, l = /^\s+|\s+$/g, u = `
`, c = "/", d = "*", h = "", m = "comment", _ = "declaration";
  function y(w, x) {
    if (typeof w != "string")
      throw new TypeError("First argument must be a string");
    if (!w) return [];
    x = x || {};
    var A = 1, S = 1;
    function N(B) {
      var O = B.match(t);
      O && (A += O.length);
      var W = B.lastIndexOf(u);
      S = ~W ? B.length - W : S + B.length;
    }
    function E() {
      var B = { line: A, column: S };
      return function(O) {
        return O.position = new f(B), R(), O;
      };
    }
    function f(B) {
      this.start = B, this.end = { line: A, column: S }, this.source = x.source;
    }
    f.prototype.content = w;
    function C(B) {
      var O = new Error(
        x.source + ":" + A + ":" + S + ": " + B
      );
      if (O.reason = B, O.filename = x.source, O.line = A, O.column = S, O.source = w, !x.silent) throw O;
    }
    function L(B) {
      var O = B.exec(w);
      if (O) {
        var W = O[0];
        return N(W), w = w.slice(W.length), O;
      }
    }
    function R() {
      L(n);
    }
    function V(B) {
      var O;
      for (B = B || []; O = z(); )
        O !== !1 && B.push(O);
      return B;
    }
    function z() {
      var B = E();
      if (!(c != w.charAt(0) || d != w.charAt(1))) {
        for (var O = 2; h != w.charAt(O) && (d != w.charAt(O) || c != w.charAt(O + 1)); )
          ++O;
        if (O += 2, h === w.charAt(O - 1))
          return C("End of comment missing");
        var W = w.slice(2, O - 2);
        return S += 2, N(W), w = w.slice(O), S += 2, B({
          type: m,
          comment: W
        });
      }
    }
    function $() {
      var B = E(), O = L(i);
      if (O) {
        if (z(), !L(r)) return C("property missing ':'");
        var W = L(s), G = B({
          type: _,
          property: v(O[0].replace(e, h)),
          value: W ? v(W[0].replace(e, h)) : h
        });
        return L(o), G;
      }
    }
    function H() {
      var B = [];
      V(B);
      for (var O; O = $(); )
        O !== !1 && (B.push(O), V(B));
      return B;
    }
    return R(), H();
  }
  function v(w) {
    return w ? w.replace(l, h) : h;
  }
  return Sa = y, Sa;
}
var Mu;
function p_() {
  if (Mu) return Ji;
  Mu = 1;
  var e = Ji && Ji.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ji, "__esModule", { value: !0 }), Ji.default = n;
  const t = e(h_());
  function n(i, r) {
    let s = null;
    if (!i || typeof i != "string")
      return s;
    const o = (0, t.default)(i), l = typeof r == "function";
    return o.forEach((u) => {
      if (u.type !== "declaration")
        return;
      const { property: c, value: d } = u;
      l ? r(c, d, u) : d && (s = s || {}, s[c] = d);
    }), s;
  }
  return Ji;
}
var Nr = {}, Vu;
function f_() {
  if (Vu) return Nr;
  Vu = 1, Object.defineProperty(Nr, "__esModule", { value: !0 }), Nr.camelCase = void 0;
  var e = /^--[a-zA-Z0-9_-]+$/, t = /-([a-z])/g, n = /^[^-]+$/, i = /^-(webkit|moz|ms|o|khtml)-/, r = /^-(ms)-/, s = function(c) {
    return !c || n.test(c) || e.test(c);
  }, o = function(c, d) {
    return d.toUpperCase();
  }, l = function(c, d) {
    return "".concat(d, "-");
  }, u = function(c, d) {
    return d === void 0 && (d = {}), s(c) ? c : (c = c.toLowerCase(), d.reactCompat ? c = c.replace(r, l) : c = c.replace(i, l), c.replace(t, o));
  };
  return Nr.camelCase = u, Nr;
}
var Tr, Fu;
function m_() {
  if (Fu) return Tr;
  Fu = 1;
  var e = Tr && Tr.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  }, t = e(p_()), n = f_();
  function i(r, s) {
    var o = {};
    return !r || typeof r != "string" || (0, t.default)(r, function(l, u) {
      l && u && (o[(0, n.camelCase)(l, s)] = u);
    }), o;
  }
  return i.default = i, Tr = i, Tr;
}
var __ = m_();
const g_ = /* @__PURE__ */ Xr(__), bo = {}.hasOwnProperty, x_ = /[A-Z]/g, b_ = /* @__PURE__ */ new Set(["td", "th"]);
function y_(e, t) {
  const n = t.schema;
  let i = n;
  const r = e.properties || {};
  n.space === "html" && e.tagName.toLowerCase() === "svg" && (i = Yo, t.schema = i);
  const s = t.all(e), o = [];
  let l, u, c;
  for (l in r)
    if (bo.call(r, l)) {
      let h = r[l];
      const m = o_(i, l);
      let _;
      if (h == null || h === !1 || typeof h == "number" && Number.isNaN(h) || !h && m.boolean)
        continue;
      if (l = t.elementAttributeNameCase === "react" && m.space ? r_[m.property] || m.property : m.attribute, Array.isArray(h) && (h = m.commaSeparated ? e_(h) : d_(h)), l === "style") {
        let y = typeof h == "object" ? h : v_(String(h), e.tagName);
        t.stylePropertyNameCase === "css" && (y = w_(y));
        const v = [];
        let w;
        for (w in y)
          bo.call(y, w) && v.push({
            type: "Property",
            method: !1,
            shorthand: !1,
            computed: !1,
            key: Mn(w) ? { type: "Identifier", name: w } : { type: "Literal", value: w },
            value: { type: "Literal", value: String(y[w]) },
            kind: "init"
          });
        c = v, _ = {
          type: "JSXExpressionContainer",
          expression: { type: "ObjectExpression", properties: v }
        };
      } else if (h === !0)
        _ = null;
      else if (t.tableCellAlignToStyle && b_.has(e.tagName) && l === "align") {
        u = String(h);
        continue;
      } else
        _ = { type: "Literal", value: String(h) };
      Mn(l, { jsx: !0 }) ? o.push({
        type: "JSXAttribute",
        name: { type: "JSXIdentifier", name: l },
        value: _
      }) : o.push({
        type: "JSXSpreadAttribute",
        argument: {
          type: "ObjectExpression",
          properties: [
            {
              type: "Property",
              method: !1,
              shorthand: !1,
              computed: !1,
              key: { type: "Literal", value: String(l) },
              // @ts-expect-error No need to worry about `style` (which has a
              // `JSXExpressionContainer` value) because that’s a valid identifier.
              value: _ || { type: "Literal", value: !0 },
              kind: "init"
            }
          ]
        }
      });
    }
  if (u !== void 0) {
    c || (c = [], o.push({
      type: "JSXAttribute",
      name: { type: "JSXIdentifier", name: "style" },
      value: {
        type: "JSXExpressionContainer",
        expression: { type: "ObjectExpression", properties: c }
      }
    }));
    const h = t.stylePropertyNameCase === "css" ? eh("textAlign") : "textAlign";
    c.push({
      type: "Property",
      method: !1,
      shorthand: !1,
      computed: !1,
      key: Mn(h) ? { type: "Identifier", name: h } : { type: "Literal", value: h },
      value: { type: "Literal", value: u },
      kind: "init"
    });
  }
  t.schema = n;
  const d = {
    type: "JSXElement",
    openingElement: {
      type: "JSXOpeningElement",
      attributes: o,
      name: t.createJsxElementName(e.tagName),
      selfClosing: s.length === 0
    },
    closingElement: s.length > 0 ? {
      type: "JSXClosingElement",
      name: t.createJsxElementName(e.tagName)
    } : null,
    children: s
  };
  return t.inherit(e, d), d;
}
function v_(e, t) {
  try {
    return g_(e, { reactCompat: !0 });
  } catch (n) {
    const i = (
      /** @type {Error} */
      n
    );
    throw new Error(
      "Could not parse `style` attribute on `" + t + "`",
      { cause: i }
    );
  }
}
function w_(e) {
  const t = {};
  let n;
  for (n in e)
    bo.call(e, n) && (t[eh(n)] = e[n]);
  return t;
}
function eh(e) {
  let t = e.replace(x_, k_);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function k_(e) {
  return "-" + e.toLowerCase();
}
const C_ = {}.hasOwnProperty, S_ = [];
function Ts(e, t) {
  const n = t ? [...t].sort(Qo) : S_;
  n.length > 0 && th(e, { comments: n, index: 0 });
}
function th(e, t) {
  if (t.index === t.comments.length)
    return;
  const n = [], i = [];
  let r;
  for (r in e)
    if (C_.call(e, r)) {
      const o = e[r];
      if (o && typeof o == "object" && r !== "comments")
        if (Array.isArray(o)) {
          let l = -1;
          for (; ++l < o.length; )
            o[l] && typeof o[l].type == "string" && n.push(o[l]);
        } else typeof o.type == "string" && n.push(o);
    }
  n.sort(Qo), i.push(...Ru(t, e, !1, { leading: !0, trailing: !1 }));
  let s = -1;
  for (; ++s < n.length; )
    th(n[s], t);
  i.push(
    ...Ru(t, e, !0, {
      leading: !1,
      trailing: n.length > 0
    })
  ), i.length > 0 && (e.comments = i);
}
function Ru(e, t, n, i) {
  const r = [];
  for (; e.comments[e.index] && Qo(e.comments[e.index], t, n) < 1; )
    r.push(Object.assign({}, e.comments[e.index++], i));
  return r;
}
function Qo(e, t, n) {
  const i = n ? "end" : "start";
  return e.range && t.range ? e.range[0] - t.range[n ? 1 : 0] : e.loc && e.loc.start && t.loc && t.loc[i] ? e.loc.start.line - t.loc[i].line || e.loc.start.column - t.loc[i].column : "start" in e && i in t ? e.start - t[i] : Number.NaN;
}
function Ou(e, t) {
  const n = e.data && e.data.estree, i = n && n.comments || [];
  let r;
  n && (t.comments.push(...i), Ts(n, n.comments), r = n.body[0] && n.body[0].type === "ExpressionStatement" && n.body[0].expression || void 0), r || (r = { type: "JSXEmptyExpression" }, t.patch(e, r));
  const s = { type: "JSXExpressionContainer", expression: r };
  return t.inherit(e, s), s;
}
function Bu(e, t) {
  const n = t.schema;
  let i = n;
  const r = e.attributes || [];
  let s = -1;
  e.name && n.space === "html" && e.name.toLowerCase() === "svg" && (i = Yo, t.schema = i);
  const o = t.all(e), l = [];
  for (; ++s < r.length; ) {
    const c = r[s], d = c.value;
    let h;
    if (c.type === "mdxJsxAttribute") {
      if (d == null)
        h = null;
      else if (typeof d == "object") {
        const _ = d.data && d.data.estree, y = _ && _.comments || [];
        let v;
        _ && (t.comments.push(...y), Ts(_, _.comments), v = _.body[0] && _.body[0].type === "ExpressionStatement" && _.body[0].expression || void 0), h = {
          type: "JSXExpressionContainer",
          expression: v || { type: "JSXEmptyExpression" }
        }, t.inherit(d, h);
      } else
        h = { type: "Literal", value: String(d) };
      const m = {
        type: "JSXAttribute",
        name: t.createJsxAttributeName(c.name),
        value: h
      };
      t.inherit(c, m), l.push(m);
    } else {
      const m = c.data && c.data.estree, _ = m && m.comments || [];
      let y;
      m && (t.comments.push(..._), Ts(m, m.comments), y = m.body[0] && m.body[0].type === "ExpressionStatement" && m.body[0].expression && m.body[0].expression.type === "ObjectExpression" && m.body[0].expression.properties && m.body[0].expression.properties[0] && m.body[0].expression.properties[0].type === "SpreadElement" && m.body[0].expression.properties[0].argument || void 0);
      const v = {
        type: "JSXSpreadAttribute",
        argument: y || { type: "ObjectExpression", properties: [] }
      };
      t.inherit(c, v), l.push(v);
    }
  }
  t.schema = n;
  const u = e.name ? {
    type: "JSXElement",
    openingElement: {
      type: "JSXOpeningElement",
      attributes: l,
      name: t.createJsxElementName(e.name),
      selfClosing: o.length === 0
    },
    closingElement: o.length > 0 ? {
      type: "JSXClosingElement",
      name: t.createJsxElementName(e.name)
    } : null,
    children: o
  } : {
    type: "JSXFragment",
    openingFragment: { type: "JSXOpeningFragment" },
    closingFragment: { type: "JSXClosingFragment" },
    children: o
  };
  return t.inherit(e, u), u;
}
function E_(e, t) {
  const n = e.data && e.data.estree, i = n && n.comments || [];
  n && (t.comments.push(...i), Ts(n, i), t.esm.push(...n.body));
}
const A_ = /[ \t\n\f\r]/g;
function I_(e) {
  return typeof e == "object" ? e.type === "text" ? zu(e.value) : !1 : zu(e);
}
function zu(e) {
  return e.replace(A_, "") === "";
}
function L_(e, t) {
  const n = t.all(e), i = [];
  let r = -1, s;
  for (; ++r < n.length; ) {
    const l = n[r];
    l.type === "JSXExpressionContainer" && l.expression.type === "Literal" && I_(String(l.expression.value)) ? s && s.push(l) : (s && i.push(...s), i.push(l), s = []);
  }
  const o = {
    type: "JSXFragment",
    openingFragment: { type: "JSXOpeningFragment" },
    closingFragment: { type: "JSXClosingFragment" },
    children: i
  };
  return t.inherit(e, o), o;
}
function N_(e, t) {
  const n = String(e.value || "");
  if (n) {
    const i = { type: "Literal", value: n };
    t.inherit(e, i);
    const r = { type: "JSXExpressionContainer", expression: i };
    return t.patch(e, r), r;
  }
}
const T_ = {
  comment: Q2,
  doctype: P_,
  element: y_,
  mdxFlowExpression: Ou,
  mdxJsxFlowElement: Bu,
  mdxJsxTextElement: Bu,
  mdxTextExpression: Ou,
  mdxjsEsm: E_,
  root: L_,
  text: N_
};
function P_() {
}
const nh = rh("end"), ih = rh("start");
function rh(e) {
  return t;
  function t(n) {
    const i = n && n.position && n.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function sh(e) {
  const t = ih(e), n = nh(e);
  if (t && n)
    return { start: t, end: n };
}
const ju = {}.hasOwnProperty;
function D_(e, t) {
  const n = t || {};
  function i(r, ...s) {
    let o = i.invalid;
    const l = i.handlers;
    if (r && ju.call(r, e)) {
      const u = String(r[e]);
      o = ju.call(l, u) ? l[u] : i.unknown;
    }
    if (o)
      return o.call(this, r, ...s);
  }
  return i.handlers = n.handlers || {}, i.invalid = n.invalid, i.unknown = n.unknown, i;
}
const M_ = {}.hasOwnProperty, V_ = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]);
function F_(e) {
  const t = D_("type", {
    invalid: R_,
    unknown: O_,
    handlers: { ...T_, ...e.handlers }
  });
  return {
    // Current space.
    elementAttributeNameCase: e.elementAttributeNameCase || "react",
    schema: e.space === "svg" ? Yo : c_,
    stylePropertyNameCase: e.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: e.tableCellAlignToStyle !== !1,
    // Results.
    comments: [],
    esm: [],
    // Useful functions.
    all: B_,
    createJsxAttributeName: j_,
    createJsxElementName: $_,
    handle: n,
    inherit: z_,
    patch: ah
  };
  function n(i) {
    return t(i, this);
  }
}
function R_(e) {
  throw new Error("Cannot handle value `" + e + "`, expected node");
}
function O_(e) {
  throw new Error("Cannot handle unknown node `" + e.type + "`");
}
function B_(e) {
  const t = e.children || [];
  let n = -1;
  const i = [], r = this.schema.space === "html" && e.type === "element" && V_.has(e.tagName.toLowerCase());
  for (; ++n < t.length; ) {
    const s = t[n];
    if (r && s.type === "text" && s.value === `
`)
      continue;
    const o = this.handle(s);
    Array.isArray(o) ? i.push(...o) : o && i.push(o);
  }
  return i;
}
function z_(e, t) {
  const n = (
    /** @type {Record<string, unknown> | undefined} */
    e.data
  );
  let i, r;
  if (ah(e, t), n) {
    for (r in n)
      M_.call(n, r) && r !== "estree" && (i || (i = {}), i[r] = n[r]);
    i && (t.data = i);
  }
}
function ah(e, t) {
  const n = sh(e);
  n && n.start.offset !== void 0 && n.end.offset !== void 0 && (t.start = n.start.offset, t.end = n.end.offset, t.loc = {
    start: { line: n.start.line, column: n.start.column - 1 },
    end: { line: n.end.line, column: n.end.column - 1 }
  }, t.range = [n.start.offset, n.end.offset]);
}
function j_(e) {
  const t = oh(e);
  if (t.type === "JSXMemberExpression")
    throw new Error("Member expressions in attribute names are not supported");
  return t;
}
function $_(e) {
  return oh(e);
}
function oh(e) {
  if (e.includes(".")) {
    const t = e.split(".");
    let n = t.shift(), i = { type: "JSXIdentifier", name: n };
    for (; n = t.shift(); )
      i = {
        type: "JSXMemberExpression",
        object: i,
        property: { type: "JSXIdentifier", name: n }
      };
    return i;
  }
  if (e.includes(":")) {
    const t = e.split(":");
    return {
      type: "JSXNamespacedName",
      namespace: { type: "JSXIdentifier", name: t[0] },
      name: { type: "JSXIdentifier", name: t[1] }
    };
  }
  return { type: "JSXIdentifier", name: e };
}
function H_(e, t) {
  const n = F_(t || {});
  let i = n.handle(e);
  const r = n.esm;
  if (i) {
    i.type !== "JSXFragment" && i.type !== "JSXElement" && (i = {
      type: "JSXFragment",
      openingFragment: { type: "JSXOpeningFragment" },
      closingFragment: { type: "JSXClosingFragment" },
      children: [i]
    }, n.patch(e, i));
    const o = { type: "ExpressionStatement", expression: i };
    n.patch(e, o), r.push(o);
  }
  const s = {
    type: "Program",
    body: r,
    sourceType: "module",
    comments: n.comments
  };
  return n.patch(e, s), s;
}
function U_(e) {
  return function(t) {
    return H_(t, e);
  };
}
function q_() {
  return {
    enter: {
      mdxFlowExpression: W_,
      mdxTextExpression: Z_
    },
    exit: {
      mdxFlowExpression: $u,
      mdxFlowExpressionChunk: Hu,
      mdxTextExpression: $u,
      mdxTextExpressionChunk: Hu
    }
  };
}
function J_() {
  return {
    handlers: {
      mdxFlowExpression: Uu,
      mdxTextExpression: Uu
    },
    unsafe: [
      { character: "{", inConstruct: ["phrasing"] },
      { atBreak: !0, character: "{" }
    ]
  };
}
function W_(e) {
  this.enter({ type: "mdxFlowExpression", value: "" }, e), this.buffer();
}
function Z_(e) {
  this.enter({ type: "mdxTextExpression", value: "" }, e), this.buffer();
}
function $u(e) {
  const t = this.resume(), n = e.estree, i = this.stack[this.stack.length - 1];
  i.type === "mdxFlowExpression" || i.type, this.exit(e), i.value = t, n && (i.data = { estree: n });
}
function Hu(e) {
  this.config.enter.data.call(this, e), this.config.exit.data.call(this, e);
}
function Uu(e, t, n) {
  const i = e.value || "";
  return "{" + n.indentLines(i, function(s, o, l) {
    return (o === 0 || l ? "" : "  ") + s;
  }) + "}";
}
function Ps(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let i = 0, r = n.indexOf(t);
  for (; r !== -1; )
    i++, r = n.indexOf(t, r + t.length);
  return i;
}
const X_ = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], qu = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function lh(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 48 && t <= 57;
}
function G_(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
}
function K_(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
function Ju(e) {
  return K_(e) || lh(e);
}
const Wu = document.createElement("i");
function qr(e) {
  const t = "&" + e + ";";
  Wu.innerHTML = t;
  const n = Wu.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
const Y_ = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function Q_(e, t) {
  const n = t || {}, i = typeof n.additional == "string" ? n.additional.charCodeAt(0) : n.additional, r = [];
  let s = 0, o = -1, l = "", u, c;
  n.position && ("start" in n.position || "indent" in n.position ? (c = n.position.indent, u = n.position.start) : u = n.position);
  let d = (u ? u.line : 0) || 1, h = (u ? u.column : 0) || 1, m = y(), _;
  for (s--; ++s <= e.length; )
    if (_ === 10 && (h = (c ? c[o] : 0) || 1), _ = e.charCodeAt(s), _ === 38) {
      const x = e.charCodeAt(s + 1);
      if (x === 9 || x === 10 || x === 12 || x === 32 || x === 38 || x === 60 || Number.isNaN(x) || i && x === i) {
        l += String.fromCharCode(_), h++;
        continue;
      }
      const A = s + 1;
      let S = A, N = A, E;
      if (x === 35) {
        N = ++S;
        const H = e.charCodeAt(N);
        H === 88 || H === 120 ? (E = "hexadecimal", N = ++S) : E = "decimal";
      } else
        E = "named";
      let f = "", C = "", L = "";
      const R = E === "named" ? Ju : E === "decimal" ? lh : G_;
      for (N--; ++N <= e.length; ) {
        const H = e.charCodeAt(N);
        if (!R(H))
          break;
        L += String.fromCharCode(H), E === "named" && X_.includes(L) && (f = L, C = qr(L));
      }
      let V = e.charCodeAt(N) === 59;
      if (V) {
        N++;
        const H = E === "named" ? qr(L) : !1;
        H && (f = L, C = H);
      }
      let z = 1 + N - A, $ = "";
      if (!(!V && n.nonTerminated === !1)) if (!L)
        E !== "named" && v(4, z);
      else if (E === "named") {
        if (V && !C)
          v(5, 1);
        else if (f !== L && (N = S + f.length, z = 1 + N - S, V = !1), !V) {
          const H = f ? 1 : 3;
          if (n.attribute) {
            const B = e.charCodeAt(N);
            B === 61 ? (v(H, z), C = "") : Ju(B) ? C = "" : v(H, z);
          } else
            v(H, z);
        }
        $ = C;
      } else {
        V || v(2, z);
        let H = Number.parseInt(
          L,
          E === "hexadecimal" ? 16 : 10
        );
        if (eg(H))
          v(7, z), $ = "�";
        else if (H in qu)
          v(6, z), $ = qu[H];
        else {
          let B = "";
          tg(H) && v(6, z), H > 65535 && (H -= 65536, B += String.fromCharCode(
            H >>> 10 | 55296
          ), H = 56320 | H & 1023), $ = B + String.fromCharCode(H);
        }
      }
      if ($) {
        w(), m = y(), s = N - 1, h += N - A + 1, r.push($);
        const H = y();
        H.offset++, n.reference && n.reference.call(
          n.referenceContext || void 0,
          $,
          { start: m, end: H },
          e.slice(A - 1, N)
        ), m = H;
      } else
        L = e.slice(A - 1, N), l += L, h += L.length, s = N - 1;
    } else
      _ === 10 && (d++, o++, h = 0), Number.isNaN(_) ? w() : (l += String.fromCharCode(_), h++);
  return r.join("");
  function y() {
    return {
      line: d,
      column: h,
      offset: s + ((u ? u.offset : 0) || 0)
    };
  }
  function v(x, A) {
    let S;
    n.warning && (S = y(), S.column += A, S.offset += A, n.warning.call(
      n.warningContext || void 0,
      Y_[x],
      S,
      x
    ));
  }
  function w() {
    l && (r.push(l), n.text && n.text.call(n.textContext || void 0, l, {
      start: m,
      end: y()
    }), l = "");
  }
}
function eg(e) {
  return e >= 55296 && e <= 57343 || e > 1114111;
}
function tg(e) {
  return e >= 1 && e <= 8 || e === 11 || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534;
}
const ng = /["&'<>`]/g, ig = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, rg = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), sg = /[|\\{}()[\]^$+*?.]/g, Zu = /* @__PURE__ */ new WeakMap();
function ag(e, t) {
  if (e = e.replace(
    t.subset ? og(t.subset) : ng,
    i
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(ig, n).replace(rg, i);
  function n(r, s, o) {
    return t.format(
      (r.charCodeAt(0) - 55296) * 1024 + r.charCodeAt(1) - 56320 + 65536,
      o.charCodeAt(s + 2),
      t
    );
  }
  function i(r, s, o) {
    return t.format(
      r.charCodeAt(0),
      o.charCodeAt(s + 1),
      t
    );
  }
}
function og(e) {
  let t = Zu.get(e);
  return t || (t = lg(e), Zu.set(e, t)), t;
}
function lg(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(sg, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
function ug(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function cg(e, t) {
  return ag(e, Object.assign({ format: ug }, t));
}
const uh = "  ";
function dg() {
  return {
    canContainEols: ["mdxJsxTextElement"],
    enter: {
      mdxJsxFlowTag: i,
      mdxJsxFlowTagClosingMarker: r,
      mdxJsxFlowTagAttribute: h,
      mdxJsxFlowTagExpressionAttribute: m,
      mdxJsxFlowTagAttributeValueLiteral: e,
      mdxJsxFlowTagAttributeValueExpression: e,
      mdxJsxFlowTagSelfClosingMarker: o,
      mdxJsxTextTag: i,
      mdxJsxTextTagClosingMarker: r,
      mdxJsxTextTagAttribute: h,
      mdxJsxTextTagExpressionAttribute: m,
      mdxJsxTextTagAttributeValueLiteral: e,
      mdxJsxTextTagAttributeValueExpression: e,
      mdxJsxTextTagSelfClosingMarker: o
    },
    exit: {
      mdxJsxFlowTagClosingMarker: l,
      mdxJsxFlowTagNamePrimary: u,
      mdxJsxFlowTagNameMember: c,
      mdxJsxFlowTagNameLocal: d,
      mdxJsxFlowTagExpressionAttribute: _,
      mdxJsxFlowTagExpressionAttributeValue: n,
      mdxJsxFlowTagAttributeNamePrimary: y,
      mdxJsxFlowTagAttributeNameLocal: v,
      mdxJsxFlowTagAttributeValueLiteral: w,
      mdxJsxFlowTagAttributeValueLiteralValue: n,
      mdxJsxFlowTagAttributeValueExpression: x,
      mdxJsxFlowTagAttributeValueExpressionValue: n,
      mdxJsxFlowTagSelfClosingMarker: A,
      mdxJsxFlowTag: S,
      mdxJsxTextTagClosingMarker: l,
      mdxJsxTextTagNamePrimary: u,
      mdxJsxTextTagNameMember: c,
      mdxJsxTextTagNameLocal: d,
      mdxJsxTextTagExpressionAttribute: _,
      mdxJsxTextTagExpressionAttributeValue: n,
      mdxJsxTextTagAttributeNamePrimary: y,
      mdxJsxTextTagAttributeNameLocal: v,
      mdxJsxTextTagAttributeValueLiteral: w,
      mdxJsxTextTagAttributeValueLiteralValue: n,
      mdxJsxTextTagAttributeValueExpression: x,
      mdxJsxTextTagAttributeValueExpressionValue: n,
      mdxJsxTextTagSelfClosingMarker: A,
      mdxJsxTextTag: S
    }
  };
  function e() {
    this.buffer();
  }
  function t(C) {
    return { line: C.line, column: C.column, offset: C.offset };
  }
  function n(C) {
    this.config.enter.data.call(this, C), this.config.exit.data.call(this, C);
  }
  function i(C) {
    const L = {
      name: void 0,
      attributes: [],
      close: !1,
      selfClosing: !1,
      start: C.start,
      end: C.end
    };
    this.data.mdxJsxTagStack || (this.data.mdxJsxTagStack = []), this.data.mdxJsxTag = L, this.buffer();
  }
  function r(C) {
    if (this.data.mdxJsxTagStack.length === 0)
      throw new Qe(
        "Unexpected closing slash `/` in tag, expected an open tag first",
        { start: C.start, end: C.end },
        "mdast-util-mdx-jsx:unexpected-closing-slash"
      );
  }
  function s(C) {
    if (this.data.mdxJsxTag.close)
      throw new Qe(
        "Unexpected attribute in closing tag, expected the end of the tag",
        { start: C.start, end: C.end },
        "mdast-util-mdx-jsx:unexpected-attribute"
      );
  }
  function o(C) {
    if (this.data.mdxJsxTag.close)
      throw new Qe(
        "Unexpected self-closing slash `/` in closing tag, expected the end of the tag",
        { start: C.start, end: C.end },
        "mdast-util-mdx-jsx:unexpected-self-closing-slash"
      );
  }
  function l() {
    const C = this.data.mdxJsxTag;
    C.close = !0;
  }
  function u(C) {
    const L = this.data.mdxJsxTag;
    L.name = this.sliceSerialize(C);
  }
  function c(C) {
    const L = this.data.mdxJsxTag;
    L.name += "." + this.sliceSerialize(C);
  }
  function d(C) {
    const L = this.data.mdxJsxTag;
    L.name += ":" + this.sliceSerialize(C);
  }
  function h(C) {
    const L = this.data.mdxJsxTag;
    s.call(this, C), L.attributes.push({
      type: "mdxJsxAttribute",
      name: "",
      value: null,
      position: {
        start: t(C.start),
        // @ts-expect-error: `end` will be patched later.
        end: void 0
      }
    });
  }
  function m(C) {
    const L = this.data.mdxJsxTag;
    s.call(this, C), L.attributes.push({
      type: "mdxJsxExpressionAttribute",
      value: "",
      position: {
        start: t(C.start),
        // @ts-expect-error: `end` will be patched later.
        end: void 0
      }
    }), this.buffer();
  }
  function _(C) {
    const L = this.data.mdxJsxTag, R = L.attributes[L.attributes.length - 1];
    R.type;
    const V = C.estree;
    R.value = this.resume(), R.position, R.position.end = t(C.end), V && (R.data = { estree: V });
  }
  function y(C) {
    const L = this.data.mdxJsxTag, R = L.attributes[L.attributes.length - 1];
    R.type, R.name = this.sliceSerialize(C), R.position, R.position.end = t(C.end);
  }
  function v(C) {
    const L = this.data.mdxJsxTag, R = L.attributes[L.attributes.length - 1];
    R.type, R.name += ":" + this.sliceSerialize(C), R.position, R.position.end = t(C.end);
  }
  function w(C) {
    const L = this.data.mdxJsxTag, R = L.attributes[L.attributes.length - 1];
    R.value = Q_(this.resume(), { nonTerminated: !1 }), R.position, R.position.end = t(C.end);
  }
  function x(C) {
    const L = this.data.mdxJsxTag, R = L.attributes[L.attributes.length - 1];
    R.type;
    const V = { type: "mdxJsxAttributeValueExpression", value: this.resume() }, z = C.estree;
    z && (V.data = { estree: z }), R.value = V, R.position, R.position.end = t(C.end);
  }
  function A() {
    const C = this.data.mdxJsxTag;
    C.selfClosing = !0;
  }
  function S(C) {
    const L = this.data.mdxJsxTag, R = this.data.mdxJsxTagStack, V = R[R.length - 1];
    if (L.close && V.name !== L.name)
      throw new Qe(
        "Unexpected closing tag `" + f(L) + "`, expected corresponding closing tag for `" + f(V) + "` (" + _n(V) + ")",
        { start: C.start, end: C.end },
        "mdast-util-mdx-jsx:end-tag-mismatch"
      );
    this.resume(), L.close ? R.pop() : this.enter(
      {
        type: C.type === "mdxJsxTextTag" ? "mdxJsxTextElement" : "mdxJsxFlowElement",
        name: L.name || null,
        attributes: L.attributes,
        children: []
      },
      C,
      N
    ), L.selfClosing || L.close ? this.exit(C, E) : R.push(L);
  }
  function N(C, L) {
    const R = this.data.mdxJsxTagStack, V = R[R.length - 1], z = C ? " before the end of `" + C.type + "`" : "", $ = C ? { start: C.start, end: C.end } : void 0;
    throw new Qe(
      "Expected a closing tag for `" + f(V) + "` (" + _n({ start: L.start, end: L.end }) + ")" + z,
      $,
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function E(C, L) {
    const R = this.data.mdxJsxTag;
    throw new Qe(
      "Expected the closing tag `" + f(R) + "` either after the end of `" + L.type + "` (" + _n(L.end) + ") or another opening tag after the start of `" + L.type + "` (" + _n(L.start) + ")",
      { start: C.start, end: C.end },
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function f(C) {
    return "<" + (C.close ? "/" : "") + (C.name || "") + ">";
  }
}
function hg(e) {
  const t = e || {}, n = t.quote || '"', i = t.quoteSmart || !1, r = t.tightSelfClosing || !1, s = t.printWidth || Number.POSITIVE_INFINITY, o = n === '"' ? "'" : '"';
  if (n !== '"' && n !== "'")
    throw new Error(
      "Cannot serialize attribute values with `" + n + "` for `options.quote`, expected `\"`, or `'`"
    );
  return l.peek = fg, {
    handlers: {
      mdxJsxFlowElement: l,
      mdxJsxTextElement: l
    },
    unsafe: [
      { character: "<", inConstruct: ["phrasing"] },
      { atBreak: !0, character: "<" }
    ],
    // Always generate fenced code (never indented code).
    fences: !0,
    // Always generate links with resources (never autolinks).
    resourceLink: !0
  };
  function l(u, c, d, h) {
    const m = u.type === "mdxJsxFlowElement", _ = u.name ? !u.children || u.children.length === 0 : !1, y = ch(d), v = dh(y), w = d.createTracker(h), x = d.createTracker(h), A = [], S = (m ? v : "") + "<" + (u.name || ""), N = d.enter(u.type);
    if (w.move(S), x.move(S), u.attributes && u.attributes.length > 0) {
      if (!u.name)
        throw new Error("Cannot serialize fragment w/ attributes");
      let R = -1;
      for (; ++R < u.attributes.length; ) {
        const V = u.attributes[R];
        let z;
        if (V.type === "mdxJsxExpressionAttribute")
          z = "{" + (V.value || "") + "}";
        else {
          if (!V.name)
            throw new Error("Cannot serialize attribute w/o name");
          const $ = V.value, H = V.name;
          let B = "";
          if ($ != null) if (typeof $ == "object")
            B = "{" + ($.value || "") + "}";
          else {
            const O = i && Ps($, n) > Ps($, o) ? o : n;
            B = O + cg($, { subset: [O] }) + O;
          }
          z = H + (B ? "=" : "") + B;
        }
        A.push(z);
      }
    }
    let E = !1;
    const f = A.join(" ");
    // Block:
    m && // Including a line ending (expressions).
    (/\r?\n|\r/.test(f) || // Current position (including `<tag`).
    w.current().now.column + // -1 because columns, +1 for ` ` before attributes.
    // Attributes joined by spaces.
    f.length + // ` />`.
    (_ ? r ? 2 : 3 : 1) > s) && (E = !0);
    let C = w, L = S;
    if (E) {
      C = x;
      let R = -1;
      for (; ++R < A.length; )
        A[R] = v + uh + A[R];
      L += C.move(
        `
` + A.join(`
`) + `
` + v
      );
    } else f && (L += C.move(" " + f));
    return _ && (L += C.move(
      (r || E ? "" : " ") + "/"
    )), L += C.move(">"), u.children && u.children.length > 0 && (u.type === "mdxJsxTextElement" ? L += C.move(
      d.containerPhrasing(u, {
        ...C.current(),
        before: ">",
        after: "<"
      })
    ) : (C.shift(2), L += C.move(`
`), L += C.move(pg(u, d, C.current())), L += C.move(`
`))), _ || (L += C.move(
      (m ? v : "") + "</" + (u.name || "") + ">"
    )), N(), L;
  }
}
function pg(e, t, n) {
  const i = t.indexStack, r = e.children, s = t.createTracker(n), o = dh(ch(t)), l = [];
  let u = -1;
  for (i.push(-1); ++u < r.length; ) {
    const c = r[u];
    i[i.length - 1] = u;
    const d = { before: `
`, after: `
`, ...s.current() }, h = t.handle(c, e, t, d), m = c.type === "mdxJsxFlowElement" ? h : t.indentLines(h, function(_, y, v) {
      return (v ? "" : o) + _;
    });
    l.push(s.move(m)), c.type !== "list" && (t.bulletLastUsed = void 0), u < r.length - 1 && l.push(s.move(`

`));
  }
  return i.pop(), l.join("");
}
function ch(e) {
  let t = 0, n = e.stack.length;
  for (; --n > -1; ) {
    const i = e.stack[n];
    if (i === "blockquote" || i === "listItem") break;
    i === "mdxJsxFlowElement" && t++;
  }
  return t;
}
function dh(e) {
  return uh.repeat(e);
}
function fg() {
  return "<";
}
function mg() {
  return {
    enter: { mdxjsEsm: gg },
    exit: { mdxjsEsm: xg, mdxjsEsmData: bg }
  };
}
function _g() {
  return { handlers: { mdxjsEsm: yg } };
}
function gg(e) {
  this.enter({ type: "mdxjsEsm", value: "" }, e), this.buffer();
}
function xg(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, this.exit(e);
  const i = e.estree;
  n.value = t, i && (n.data = { estree: i });
}
function bg(e) {
  this.config.enter.data.call(this, e), this.config.exit.data.call(this, e);
}
function yg(e) {
  return e.value || "";
}
function vg() {
  return [
    q_(),
    dg(),
    mg()
  ];
}
function wg(e) {
  return {
    extensions: [
      J_(),
      hg(e),
      _g()
    ]
  };
}
var kg = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], hh = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], Cg = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", ph = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟍꟐꟑꟓꟕ-Ƛꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Ea = {
  3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
  5: "class enum extends super const export import",
  6: "enum",
  strict: "implements interface let package private protected public static yield",
  strictBind: "eval arguments"
}, Aa = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", Sg = {
  5: Aa,
  "5module": Aa + " export import",
  6: Aa + " const class extends export import super"
}, Eg = /^in(stanceof)?$/, Ag = new RegExp("[" + ph + "]"), Ig = new RegExp("[" + ph + Cg + "]");
function yo(e, t) {
  for (var n = 65536, i = 0; i < t.length; i += 2) {
    if (n += t[i], n > e)
      return !1;
    if (n += t[i + 1], n >= e)
      return !0;
  }
  return !1;
}
function Vn(e, t) {
  return e < 65 ? e === 36 : e < 91 ? !0 : e < 97 ? e === 95 : e < 123 ? !0 : e <= 65535 ? e >= 170 && Ag.test(String.fromCharCode(e)) : t === !1 ? !1 : yo(e, hh);
}
function mi(e, t) {
  return e < 48 ? e === 36 : e < 58 ? !0 : e < 65 ? !1 : e < 91 ? !0 : e < 97 ? e === 95 : e < 123 ? !0 : e <= 65535 ? e >= 170 && Ig.test(String.fromCharCode(e)) : t === !1 ? !1 : yo(e, hh) || yo(e, kg);
}
var Ge = function(t, n) {
  n === void 0 && (n = {}), this.label = t, this.keyword = n.keyword, this.beforeExpr = !!n.beforeExpr, this.startsExpr = !!n.startsExpr, this.isLoop = !!n.isLoop, this.isAssign = !!n.isAssign, this.prefix = !!n.prefix, this.postfix = !!n.postfix, this.binop = n.binop || null, this.updateContext = null;
};
function dn(e, t) {
  return new Ge(e, { beforeExpr: !0, binop: t });
}
var hn = { beforeExpr: !0 }, Zt = { startsExpr: !0 }, el = {};
function We(e, t) {
  return t === void 0 && (t = {}), t.keyword = e, el[e] = new Ge(e, t);
}
var I = {
  num: new Ge("num", Zt),
  regexp: new Ge("regexp", Zt),
  string: new Ge("string", Zt),
  name: new Ge("name", Zt),
  privateId: new Ge("privateId", Zt),
  eof: new Ge("eof"),
  // Punctuation token types.
  bracketL: new Ge("[", { beforeExpr: !0, startsExpr: !0 }),
  bracketR: new Ge("]"),
  braceL: new Ge("{", { beforeExpr: !0, startsExpr: !0 }),
  braceR: new Ge("}"),
  parenL: new Ge("(", { beforeExpr: !0, startsExpr: !0 }),
  parenR: new Ge(")"),
  comma: new Ge(",", hn),
  semi: new Ge(";", hn),
  colon: new Ge(":", hn),
  dot: new Ge("."),
  question: new Ge("?", hn),
  questionDot: new Ge("?."),
  arrow: new Ge("=>", hn),
  template: new Ge("template"),
  invalidTemplate: new Ge("invalidTemplate"),
  ellipsis: new Ge("...", hn),
  backQuote: new Ge("`", Zt),
  dollarBraceL: new Ge("${", { beforeExpr: !0, startsExpr: !0 }),
  // Operators. These carry several kinds of properties to help the
  // parser use them properly (the presence of these properties is
  // what categorizes them as operators).
  //
  // `binop`, when present, specifies that this operator is a binary
  // operator, and will refer to its precedence.
  //
  // `prefix` and `postfix` mark the operator as a prefix or postfix
  // unary operator.
  //
  // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
  // binary operators with a very low precedence, that should result
  // in AssignmentExpression nodes.
  eq: new Ge("=", { beforeExpr: !0, isAssign: !0 }),
  assign: new Ge("_=", { beforeExpr: !0, isAssign: !0 }),
  incDec: new Ge("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
  prefix: new Ge("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  logicalOR: dn("||", 1),
  logicalAND: dn("&&", 2),
  bitwiseOR: dn("|", 3),
  bitwiseXOR: dn("^", 4),
  bitwiseAND: dn("&", 5),
  equality: dn("==/!=/===/!==", 6),
  relational: dn("</>/<=/>=", 7),
  bitShift: dn("<</>>/>>>", 8),
  plusMin: new Ge("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
  modulo: dn("%", 10),
  star: dn("*", 10),
  slash: dn("/", 10),
  starstar: new Ge("**", { beforeExpr: !0 }),
  coalesce: dn("??", 1),
  // Keyword token types.
  _break: We("break"),
  _case: We("case", hn),
  _catch: We("catch"),
  _continue: We("continue"),
  _debugger: We("debugger"),
  _default: We("default", hn),
  _do: We("do", { isLoop: !0, beforeExpr: !0 }),
  _else: We("else", hn),
  _finally: We("finally"),
  _for: We("for", { isLoop: !0 }),
  _function: We("function", Zt),
  _if: We("if"),
  _return: We("return", hn),
  _switch: We("switch"),
  _throw: We("throw", hn),
  _try: We("try"),
  _var: We("var"),
  _const: We("const"),
  _while: We("while", { isLoop: !0 }),
  _with: We("with"),
  _new: We("new", { beforeExpr: !0, startsExpr: !0 }),
  _this: We("this", Zt),
  _super: We("super", Zt),
  _class: We("class", Zt),
  _extends: We("extends", hn),
  _export: We("export"),
  _import: We("import", Zt),
  _null: We("null", Zt),
  _true: We("true", Zt),
  _false: We("false", Zt),
  _in: We("in", { beforeExpr: !0, binop: 7 }),
  _instanceof: We("instanceof", { beforeExpr: !0, binop: 7 }),
  _typeof: We("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  _void: We("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  _delete: We("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
}, Qt = /\r\n?|\n|\u2028|\u2029/, Lg = new RegExp(Qt.source, "g");
function dr(e) {
  return e === 10 || e === 13 || e === 8232 || e === 8233;
}
function fh(e, t, n) {
  n === void 0 && (n = e.length);
  for (var i = t; i < n; i++) {
    var r = e.charCodeAt(i);
    if (dr(r))
      return i < n - 1 && r === 13 && e.charCodeAt(i + 1) === 10 ? i + 2 : i + 1;
  }
  return -1;
}
var mh = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Rt = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, _h = Object.prototype, Ng = _h.hasOwnProperty, Tg = _h.toString, hr = Object.hasOwn || (function(e, t) {
  return Ng.call(e, t);
}), Xu = Array.isArray || (function(e) {
  return Tg.call(e) === "[object Array]";
}), Gu = /* @__PURE__ */ Object.create(null);
function ui(e) {
  return Gu[e] || (Gu[e] = new RegExp("^(?:" + e.replace(/ /g, "|") + ")$"));
}
function Yn(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10) + 55296, (e & 1023) + 56320));
}
var Pg = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, Jr = function(t, n) {
  this.line = t, this.column = n;
};
Jr.prototype.offset = function(t) {
  return new Jr(this.line, this.column + t);
};
var qs = function(t, n, i) {
  this.start = n, this.end = i, t.sourceFile !== null && (this.source = t.sourceFile);
};
function gh(e, t) {
  for (var n = 1, i = 0; ; ) {
    var r = fh(e, i, t);
    if (r < 0)
      return new Jr(n, t - i);
    ++n, i = r;
  }
}
var vo = {
  // `ecmaVersion` indicates the ECMAScript version to parse. Must be
  // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
  // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
  // (the latest version the library supports). This influences
  // support for strict mode, the set of reserved words, and support
  // for new syntax features.
  ecmaVersion: null,
  // `sourceType` indicates the mode the code should be parsed in.
  // Can be either `"script"` or `"module"`. This influences global
  // strict mode and parsing of `import` and `export` declarations.
  sourceType: "script",
  // `onInsertedSemicolon` can be a callback that will be called when
  // a semicolon is automatically inserted. It will be passed the
  // position of the inserted semicolon as an offset, and if
  // `locations` is enabled, it is given the location as a `{line,
  // column}` object as second argument.
  onInsertedSemicolon: null,
  // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
  // trailing commas.
  onTrailingComma: null,
  // By default, reserved words are only enforced if ecmaVersion >= 5.
  // Set `allowReserved` to a boolean value to explicitly turn this on
  // an off. When this option has the value "never", reserved words
  // and keywords can also not be used as property names.
  allowReserved: null,
  // When enabled, a return at the top level is not considered an
  // error.
  allowReturnOutsideFunction: !1,
  // When enabled, import/export statements are not constrained to
  // appearing at the top of the program, and an import.meta expression
  // in a script isn't considered an error.
  allowImportExportEverywhere: !1,
  // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
  // When enabled, await identifiers are allowed to appear at the top-level scope,
  // but they are still not allowed in non-async functions.
  allowAwaitOutsideFunction: null,
  // When enabled, super identifiers are not constrained to
  // appearing in methods and do not raise an error when they appear elsewhere.
  allowSuperOutsideMethod: null,
  // When enabled, hashbang directive in the beginning of file is
  // allowed and treated as a line comment. Enabled by default when
  // `ecmaVersion` >= 2023.
  allowHashBang: !1,
  // By default, the parser will verify that private properties are
  // only used in places where they are valid and have been declared.
  // Set this to false to turn such checks off.
  checkPrivateFields: !0,
  // When `locations` is on, `loc` properties holding objects with
  // `start` and `end` properties in `{line, column}` form (with
  // line being 1-based and column 0-based) will be attached to the
  // nodes.
  locations: !1,
  // A function can be passed as `onToken` option, which will
  // cause Acorn to call that function with object in the same
  // format as tokens returned from `tokenizer().getToken()`. Note
  // that you are not allowed to call the parser from the
  // callback—that will corrupt its internal state.
  onToken: null,
  // A function can be passed as `onComment` option, which will
  // cause Acorn to call that function with `(block, text, start,
  // end)` parameters whenever a comment is skipped. `block` is a
  // boolean indicating whether this is a block (`/* */`) comment,
  // `text` is the content of the comment, and `start` and `end` are
  // character offsets that denote the start and end of the comment.
  // When the `locations` option is on, two more parameters are
  // passed, the full `{line, column}` locations of the start and
  // end of the comments. Note that you are not allowed to call the
  // parser from the callback—that will corrupt its internal state.
  // When this option has an array as value, objects representing the
  // comments are pushed to it.
  onComment: null,
  // Nodes have their start and end characters offsets recorded in
  // `start` and `end` properties (directly on the node, rather than
  // the `loc` object, which holds line/column data. To also add a
  // [semi-standardized][range] `range` property holding a `[start,
  // end]` array with the same numbers, set the `ranges` option to
  // `true`.
  //
  // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
  ranges: !1,
  // It is possible to parse multiple files into a single AST by
  // passing the tree produced by parsing the first file as
  // `program` option in subsequent parses. This will add the
  // toplevel forms of the parsed file to the `Program` (top) node
  // of an existing parse tree.
  program: null,
  // When `locations` is on, you can pass this to record the source
  // file in every node's `loc` object.
  sourceFile: null,
  // This value, if given, is stored in every node, whether
  // `locations` is on or off.
  directSourceFile: null,
  // When enabled, parenthesized expressions are represented by
  // (non-standard) ParenthesizedExpression nodes
  preserveParens: !1
}, Ku = !1;
function Dg(e) {
  var t = {};
  for (var n in vo)
    t[n] = e && hr(e, n) ? e[n] : vo[n];
  if (t.ecmaVersion === "latest" ? t.ecmaVersion = 1e8 : t.ecmaVersion == null ? (!Ku && typeof console == "object" && console.warn && (Ku = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), t.ecmaVersion = 11) : t.ecmaVersion >= 2015 && (t.ecmaVersion -= 2009), t.allowReserved == null && (t.allowReserved = t.ecmaVersion < 5), (!e || e.allowHashBang == null) && (t.allowHashBang = t.ecmaVersion >= 14), Xu(t.onToken)) {
    var i = t.onToken;
    t.onToken = function(r) {
      return i.push(r);
    };
  }
  return Xu(t.onComment) && (t.onComment = Mg(t, t.onComment)), t;
}
function Mg(e, t) {
  return function(n, i, r, s, o, l) {
    var u = {
      type: n ? "Block" : "Line",
      value: i,
      start: r,
      end: s
    };
    e.locations && (u.loc = new qs(this, o, l)), e.ranges && (u.range = [r, s]), t.push(u);
  };
}
var Wr = 1, pr = 2, tl = 4, xh = 8, nl = 16, bh = 32, Js = 64, yh = 128, Vi = 256, es = 512, Ws = Wr | pr | Vi;
function il(e, t) {
  return pr | (e ? tl : 0) | (t ? xh : 0);
}
var Ds = 0, rl = 1, ni = 2, vh = 3, wh = 4, kh = 5, Et = function(t, n, i) {
  this.options = t = Dg(t), this.sourceFile = t.sourceFile, this.keywords = ui(Sg[t.ecmaVersion >= 6 ? 6 : t.sourceType === "module" ? "5module" : 5]);
  var r = "";
  t.allowReserved !== !0 && (r = Ea[t.ecmaVersion >= 6 ? 6 : t.ecmaVersion === 5 ? 5 : 3], t.sourceType === "module" && (r += " await")), this.reservedWords = ui(r);
  var s = (r ? r + " " : "") + Ea.strict;
  this.reservedWordsStrict = ui(s), this.reservedWordsStrictBind = ui(s + " " + Ea.strictBind), this.input = String(n), this.containsEsc = !1, i ? (this.pos = i, this.lineStart = this.input.lastIndexOf(`
`, i - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(Qt).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = I.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = t.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && t.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(Wr), this.regexpState = null, this.privateNameStack = [];
}, Bn = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
Et.prototype.parse = function() {
  var t = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(t);
};
Bn.inFunction.get = function() {
  return (this.currentVarScope().flags & pr) > 0;
};
Bn.inGenerator.get = function() {
  return (this.currentVarScope().flags & xh) > 0;
};
Bn.inAsync.get = function() {
  return (this.currentVarScope().flags & tl) > 0;
};
Bn.canAwait.get = function() {
  for (var e = this.scopeStack.length - 1; e >= 0; e--) {
    var t = this.scopeStack[e], n = t.flags;
    if (n & (Vi | es))
      return !1;
    if (n & pr)
      return (n & tl) > 0;
  }
  return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
};
Bn.allowSuper.get = function() {
  var e = this.currentThisScope(), t = e.flags;
  return (t & Js) > 0 || this.options.allowSuperOutsideMethod;
};
Bn.allowDirectSuper.get = function() {
  return (this.currentThisScope().flags & yh) > 0;
};
Bn.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
};
Bn.allowNewDotTarget.get = function() {
  for (var e = this.scopeStack.length - 1; e >= 0; e--) {
    var t = this.scopeStack[e], n = t.flags;
    if (n & (Vi | es) || n & pr && !(n & nl))
      return !0;
  }
  return !1;
};
Bn.inClassStaticBlock.get = function() {
  return (this.currentVarScope().flags & Vi) > 0;
};
Et.extend = function() {
  for (var t = [], n = arguments.length; n--; ) t[n] = arguments[n];
  for (var i = this, r = 0; r < t.length; r++)
    i = t[r](i);
  return i;
};
Et.parse = function(t, n) {
  return new this(n, t).parse();
};
Et.parseExpressionAt = function(t, n, i) {
  var r = new this(i, t, n);
  return r.nextToken(), r.parseExpression();
};
Et.tokenizer = function(t, n) {
  return new this(n, t);
};
Object.defineProperties(Et.prototype, Bn);
var Ut = Et.prototype, Vg = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
Ut.strictDirective = function(e) {
  if (this.options.ecmaVersion < 5)
    return !1;
  for (; ; ) {
    Rt.lastIndex = e, e += Rt.exec(this.input)[0].length;
    var t = Vg.exec(this.input.slice(e));
    if (!t)
      return !1;
    if ((t[1] || t[2]) === "use strict") {
      Rt.lastIndex = e + t[0].length;
      var n = Rt.exec(this.input), i = n.index + n[0].length, r = this.input.charAt(i);
      return r === ";" || r === "}" || Qt.test(n[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(r) || r === "!" && this.input.charAt(i + 1) === "=");
    }
    e += t[0].length, Rt.lastIndex = e, e += Rt.exec(this.input)[0].length, this.input[e] === ";" && e++;
  }
};
Ut.eat = function(e) {
  return this.type === e ? (this.next(), !0) : !1;
};
Ut.isContextual = function(e) {
  return this.type === I.name && this.value === e && !this.containsEsc;
};
Ut.eatContextual = function(e) {
  return this.isContextual(e) ? (this.next(), !0) : !1;
};
Ut.expectContextual = function(e) {
  this.eatContextual(e) || this.unexpected();
};
Ut.canInsertSemicolon = function() {
  return this.type === I.eof || this.type === I.braceR || Qt.test(this.input.slice(this.lastTokEnd, this.start));
};
Ut.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
};
Ut.semicolon = function() {
  !this.eat(I.semi) && !this.insertSemicolon() && this.unexpected();
};
Ut.afterTrailingComma = function(e, t) {
  if (this.type === e)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t || this.next(), !0;
};
Ut.expect = function(e) {
  this.eat(e) || this.unexpected();
};
Ut.unexpected = function(e) {
  this.raise(e ?? this.start, "Unexpected token");
};
var Zs = function() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
};
Ut.checkPatternErrors = function(e, t) {
  if (e) {
    e.trailingComma > -1 && this.raiseRecoverable(e.trailingComma, "Comma is not permitted after the rest element");
    var n = t ? e.parenthesizedAssign : e.parenthesizedBind;
    n > -1 && this.raiseRecoverable(n, t ? "Assigning to rvalue" : "Parenthesized pattern");
  }
};
Ut.checkExpressionErrors = function(e, t) {
  if (!e)
    return !1;
  var n = e.shorthandAssign, i = e.doubleProto;
  if (!t)
    return n >= 0 || i >= 0;
  n >= 0 && this.raise(n, "Shorthand property assignments are valid only in destructuring patterns"), i >= 0 && this.raiseRecoverable(i, "Redefinition of __proto__ property");
};
Ut.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
};
Ut.isSimpleAssignTarget = function(e) {
  return e.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e.expression) : e.type === "Identifier" || e.type === "MemberExpression";
};
var ke = Et.prototype;
ke.parseTopLevel = function(e) {
  var t = /* @__PURE__ */ Object.create(null);
  for (e.body || (e.body = []); this.type !== I.eof; ) {
    var n = this.parseStatement(null, !0, t);
    e.body.push(n);
  }
  if (this.inModule)
    for (var i = 0, r = Object.keys(this.undefinedExports); i < r.length; i += 1) {
      var s = r[i];
      this.raiseRecoverable(this.undefinedExports[s].start, "Export '" + s + "' is not defined");
    }
  return this.adaptDirectivePrologue(e.body), this.next(), e.sourceType = this.options.sourceType, this.finishNode(e, "Program");
};
var sl = { kind: "loop" }, Fg = { kind: "switch" };
ke.isLet = function(e) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return !1;
  Rt.lastIndex = this.pos;
  var t = Rt.exec(this.input), n = this.pos + t[0].length, i = this.input.charCodeAt(n);
  if (i === 91 || i === 92)
    return !0;
  if (e)
    return !1;
  if (i === 123 || i > 55295 && i < 56320)
    return !0;
  if (Vn(i, !0)) {
    for (var r = n + 1; mi(i = this.input.charCodeAt(r), !0); )
      ++r;
    if (i === 92 || i > 55295 && i < 56320)
      return !0;
    var s = this.input.slice(n, r);
    if (!Eg.test(s))
      return !0;
  }
  return !1;
};
ke.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return !1;
  Rt.lastIndex = this.pos;
  var e = Rt.exec(this.input), t = this.pos + e[0].length, n;
  return !Qt.test(this.input.slice(this.pos, t)) && this.input.slice(t, t + 8) === "function" && (t + 8 === this.input.length || !(mi(n = this.input.charCodeAt(t + 8)) || n > 55295 && n < 56320));
};
ke.isUsingKeyword = function(e, t) {
  if (this.options.ecmaVersion < 17 || !this.isContextual(e ? "await" : "using"))
    return !1;
  Rt.lastIndex = this.pos;
  var n = Rt.exec(this.input), i = this.pos + n[0].length;
  if (Qt.test(this.input.slice(this.pos, i)))
    return !1;
  if (e) {
    var r = i + 5, s;
    if (this.input.slice(i, r) !== "using" || r === this.input.length || mi(s = this.input.charCodeAt(r)) || s > 55295 && s < 56320)
      return !1;
    Rt.lastIndex = r;
    var o = Rt.exec(this.input);
    if (o && Qt.test(this.input.slice(r, r + o[0].length)))
      return !1;
  }
  if (t) {
    var l = i + 2, u;
    if (this.input.slice(i, l) === "of" && (l === this.input.length || !mi(u = this.input.charCodeAt(l)) && !(u > 55295 && u < 56320)))
      return !1;
  }
  var c = this.input.charCodeAt(i);
  return Vn(c, !0) || c === 92;
};
ke.isAwaitUsing = function(e) {
  return this.isUsingKeyword(!0, e);
};
ke.isUsing = function(e) {
  return this.isUsingKeyword(!1, e);
};
ke.parseStatement = function(e, t, n) {
  var i = this.type, r = this.startNode(), s;
  switch (this.isLet(e) && (i = I._var, s = "let"), i) {
    case I._break:
    case I._continue:
      return this.parseBreakContinueStatement(r, i.keyword);
    case I._debugger:
      return this.parseDebuggerStatement(r);
    case I._do:
      return this.parseDoStatement(r);
    case I._for:
      return this.parseForStatement(r);
    case I._function:
      return e && (this.strict || e !== "if" && e !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(r, !1, !e);
    case I._class:
      return e && this.unexpected(), this.parseClass(r, !0);
    case I._if:
      return this.parseIfStatement(r);
    case I._return:
      return this.parseReturnStatement(r);
    case I._switch:
      return this.parseSwitchStatement(r);
    case I._throw:
      return this.parseThrowStatement(r);
    case I._try:
      return this.parseTryStatement(r);
    case I._const:
    case I._var:
      return s = s || this.value, e && s !== "var" && this.unexpected(), this.parseVarStatement(r, s);
    case I._while:
      return this.parseWhileStatement(r);
    case I._with:
      return this.parseWithStatement(r);
    case I.braceL:
      return this.parseBlock(!0, r);
    case I.semi:
      return this.parseEmptyStatement(r);
    case I._export:
    case I._import:
      if (this.options.ecmaVersion > 10 && i === I._import) {
        Rt.lastIndex = this.pos;
        var o = Rt.exec(this.input), l = this.pos + o[0].length, u = this.input.charCodeAt(l);
        if (u === 40 || u === 46)
          return this.parseExpressionStatement(r, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), i === I._import ? this.parseImport(r) : this.parseExport(r, n);
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    default:
      if (this.isAsyncFunction())
        return e && this.unexpected(), this.next(), this.parseFunctionStatement(r, !0, !e);
      var c = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
      if (c)
        return t && this.options.sourceType === "script" && this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script`"), c === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(r, !1, c), this.semicolon(), this.finishNode(r, "VariableDeclaration");
      var d = this.value, h = this.parseExpression();
      return i === I.name && h.type === "Identifier" && this.eat(I.colon) ? this.parseLabeledStatement(r, d, h, e) : this.parseExpressionStatement(r, h);
  }
};
ke.parseBreakContinueStatement = function(e, t) {
  var n = t === "break";
  this.next(), this.eat(I.semi) || this.insertSemicolon() ? e.label = null : this.type !== I.name ? this.unexpected() : (e.label = this.parseIdent(), this.semicolon());
  for (var i = 0; i < this.labels.length; ++i) {
    var r = this.labels[i];
    if ((e.label == null || r.name === e.label.name) && (r.kind != null && (n || r.kind === "loop") || e.label && n))
      break;
  }
  return i === this.labels.length && this.raise(e.start, "Unsyntactic " + t), this.finishNode(e, n ? "BreakStatement" : "ContinueStatement");
};
ke.parseDebuggerStatement = function(e) {
  return this.next(), this.semicolon(), this.finishNode(e, "DebuggerStatement");
};
ke.parseDoStatement = function(e) {
  return this.next(), this.labels.push(sl), e.body = this.parseStatement("do"), this.labels.pop(), this.expect(I._while), e.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(I.semi) : this.semicolon(), this.finishNode(e, "DoWhileStatement");
};
ke.parseForStatement = function(e) {
  this.next();
  var t = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(sl), this.enterScope(0), this.expect(I.parenL), this.type === I.semi)
    return t > -1 && this.unexpected(t), this.parseFor(e, null);
  var n = this.isLet();
  if (this.type === I._var || this.type === I._const || n) {
    var i = this.startNode(), r = n ? "let" : this.value;
    return this.next(), this.parseVar(i, !0, r), this.finishNode(i, "VariableDeclaration"), this.parseForAfterInit(e, i, t);
  }
  var s = this.isContextual("let"), o = !1, l = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
  if (l) {
    var u = this.startNode();
    return this.next(), l === "await using" && this.next(), this.parseVar(u, !0, l), this.finishNode(u, "VariableDeclaration"), this.parseForAfterInit(e, u, t);
  }
  var c = this.containsEsc, d = new Zs(), h = this.start, m = t > -1 ? this.parseExprSubscripts(d, "await") : this.parseExpression(!0, d);
  return this.type === I._in || (o = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (t > -1 ? (this.type === I._in && this.unexpected(t), e.await = !0) : o && this.options.ecmaVersion >= 8 && (m.start === h && !c && m.type === "Identifier" && m.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (e.await = !1)), s && o && this.raise(m.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(m, !1, d), this.checkLValPattern(m), this.parseForIn(e, m)) : (this.checkExpressionErrors(d, !0), t > -1 && this.unexpected(t), this.parseFor(e, m));
};
ke.parseForAfterInit = function(e, t, n) {
  return (this.type === I._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && t.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === I._in ? n > -1 && this.unexpected(n) : e.await = n > -1), this.parseForIn(e, t)) : (n > -1 && this.unexpected(n), this.parseFor(e, t));
};
ke.parseFunctionStatement = function(e, t, n) {
  return this.next(), this.parseFunction(e, jr | (n ? 0 : wo), !1, t);
};
ke.parseIfStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), e.consequent = this.parseStatement("if"), e.alternate = this.eat(I._else) ? this.parseStatement("if") : null, this.finishNode(e, "IfStatement");
};
ke.parseReturnStatement = function(e) {
  return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(I.semi) || this.insertSemicolon() ? e.argument = null : (e.argument = this.parseExpression(), this.semicolon()), this.finishNode(e, "ReturnStatement");
};
ke.parseSwitchStatement = function(e) {
  this.next(), e.discriminant = this.parseParenExpression(), e.cases = [], this.expect(I.braceL), this.labels.push(Fg), this.enterScope(0);
  for (var t, n = !1; this.type !== I.braceR; )
    if (this.type === I._case || this.type === I._default) {
      var i = this.type === I._case;
      t && this.finishNode(t, "SwitchCase"), e.cases.push(t = this.startNode()), t.consequent = [], this.next(), i ? t.test = this.parseExpression() : (n && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), n = !0, t.test = null), this.expect(I.colon);
    } else
      t || this.unexpected(), t.consequent.push(this.parseStatement(null));
  return this.exitScope(), t && this.finishNode(t, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e, "SwitchStatement");
};
ke.parseThrowStatement = function(e) {
  return this.next(), Qt.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e.argument = this.parseExpression(), this.semicolon(), this.finishNode(e, "ThrowStatement");
};
var Rg = [];
ke.parseCatchClauseParam = function() {
  var e = this.parseBindingAtom(), t = e.type === "Identifier";
  return this.enterScope(t ? bh : 0), this.checkLValPattern(e, t ? wh : ni), this.expect(I.parenR), e;
};
ke.parseTryStatement = function(e) {
  if (this.next(), e.block = this.parseBlock(), e.handler = null, this.type === I._catch) {
    var t = this.startNode();
    this.next(), this.eat(I.parenL) ? t.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), t.param = null, this.enterScope(0)), t.body = this.parseBlock(!1), this.exitScope(), e.handler = this.finishNode(t, "CatchClause");
  }
  return e.finalizer = this.eat(I._finally) ? this.parseBlock() : null, !e.handler && !e.finalizer && this.raise(e.start, "Missing catch or finally clause"), this.finishNode(e, "TryStatement");
};
ke.parseVarStatement = function(e, t, n) {
  return this.next(), this.parseVar(e, !1, t, n), this.semicolon(), this.finishNode(e, "VariableDeclaration");
};
ke.parseWhileStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), this.labels.push(sl), e.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e, "WhileStatement");
};
ke.parseWithStatement = function(e) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e.object = this.parseParenExpression(), e.body = this.parseStatement("with"), this.finishNode(e, "WithStatement");
};
ke.parseEmptyStatement = function(e) {
  return this.next(), this.finishNode(e, "EmptyStatement");
};
ke.parseLabeledStatement = function(e, t, n, i) {
  for (var r = 0, s = this.labels; r < s.length; r += 1) {
    var o = s[r];
    o.name === t && this.raise(n.start, "Label '" + t + "' is already declared");
  }
  for (var l = this.type.isLoop ? "loop" : this.type === I._switch ? "switch" : null, u = this.labels.length - 1; u >= 0; u--) {
    var c = this.labels[u];
    if (c.statementStart === e.start)
      c.statementStart = this.start, c.kind = l;
    else
      break;
  }
  return this.labels.push({ name: t, kind: l, statementStart: this.start }), e.body = this.parseStatement(i ? i.indexOf("label") === -1 ? i + "label" : i : "label"), this.labels.pop(), e.label = n, this.finishNode(e, "LabeledStatement");
};
ke.parseExpressionStatement = function(e, t) {
  return e.expression = t, this.semicolon(), this.finishNode(e, "ExpressionStatement");
};
ke.parseBlock = function(e, t, n) {
  for (e === void 0 && (e = !0), t === void 0 && (t = this.startNode()), t.body = [], this.expect(I.braceL), e && this.enterScope(0); this.type !== I.braceR; ) {
    var i = this.parseStatement(null);
    t.body.push(i);
  }
  return n && (this.strict = !1), this.next(), e && this.exitScope(), this.finishNode(t, "BlockStatement");
};
ke.parseFor = function(e, t) {
  return e.init = t, this.expect(I.semi), e.test = this.type === I.semi ? null : this.parseExpression(), this.expect(I.semi), e.update = this.type === I.parenR ? null : this.parseExpression(), this.expect(I.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, "ForStatement");
};
ke.parseForIn = function(e, t) {
  var n = this.type === I._in;
  return this.next(), t.type === "VariableDeclaration" && t.declarations[0].init != null && (!n || this.options.ecmaVersion < 8 || this.strict || t.kind !== "var" || t.declarations[0].id.type !== "Identifier") && this.raise(
    t.start,
    (n ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
  ), e.left = t, e.right = n ? this.parseExpression() : this.parseMaybeAssign(), this.expect(I.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, n ? "ForInStatement" : "ForOfStatement");
};
ke.parseVar = function(e, t, n, i) {
  for (e.declarations = [], e.kind = n; ; ) {
    var r = this.startNode();
    if (this.parseVarId(r, n), this.eat(I.eq) ? r.init = this.parseMaybeAssign(t) : !i && n === "const" && !(this.type === I._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !i && (n === "using" || n === "await using") && this.options.ecmaVersion >= 17 && this.type !== I._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + n + " declaration") : !i && r.id.type !== "Identifier" && !(t && (this.type === I._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : r.init = null, e.declarations.push(this.finishNode(r, "VariableDeclarator")), !this.eat(I.comma))
      break;
  }
  return e;
};
ke.parseVarId = function(e, t) {
  e.id = t === "using" || t === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(e.id, t === "var" ? rl : ni, !1);
};
var jr = 1, wo = 2, Ch = 4;
ke.parseFunction = function(e, t, n, i, r) {
  this.initFunction(e), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !i) && (this.type === I.star && t & wo && this.unexpected(), e.generator = this.eat(I.star)), this.options.ecmaVersion >= 8 && (e.async = !!i), t & jr && (e.id = t & Ch && this.type !== I.name ? null : this.parseIdent(), e.id && !(t & wo) && this.checkLValSimple(e.id, this.strict || e.generator || e.async ? this.treatFunctionsAsVar ? rl : ni : vh));
  var s = this.yieldPos, o = this.awaitPos, l = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(il(e.async, e.generator)), t & jr || (e.id = this.type === I.name ? this.parseIdent() : null), this.parseFunctionParams(e), this.parseFunctionBody(e, n, !1, r), this.yieldPos = s, this.awaitPos = o, this.awaitIdentPos = l, this.finishNode(e, t & jr ? "FunctionDeclaration" : "FunctionExpression");
};
ke.parseFunctionParams = function(e) {
  this.expect(I.parenL), e.params = this.parseBindingList(I.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
};
ke.parseClass = function(e, t) {
  this.next();
  var n = this.strict;
  this.strict = !0, this.parseClassId(e, t), this.parseClassSuper(e);
  var i = this.enterClassBody(), r = this.startNode(), s = !1;
  for (r.body = [], this.expect(I.braceL); this.type !== I.braceR; ) {
    var o = this.parseClassElement(e.superClass !== null);
    o && (r.body.push(o), o.type === "MethodDefinition" && o.kind === "constructor" ? (s && this.raiseRecoverable(o.start, "Duplicate constructor in the same class"), s = !0) : o.key && o.key.type === "PrivateIdentifier" && Og(i, o) && this.raiseRecoverable(o.key.start, "Identifier '#" + o.key.name + "' has already been declared"));
  }
  return this.strict = n, this.next(), e.body = this.finishNode(r, "ClassBody"), this.exitClassBody(), this.finishNode(e, t ? "ClassDeclaration" : "ClassExpression");
};
ke.parseClassElement = function(e) {
  if (this.eat(I.semi))
    return null;
  var t = this.options.ecmaVersion, n = this.startNode(), i = "", r = !1, s = !1, o = "method", l = !1;
  if (this.eatContextual("static")) {
    if (t >= 13 && this.eat(I.braceL))
      return this.parseClassStaticBlock(n), n;
    this.isClassElementNameStart() || this.type === I.star ? l = !0 : i = "static";
  }
  if (n.static = l, !i && t >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === I.star) && !this.canInsertSemicolon() ? s = !0 : i = "async"), !i && (t >= 9 || !s) && this.eat(I.star) && (r = !0), !i && !s && !r) {
    var u = this.value;
    (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? o = u : i = u);
  }
  if (i ? (n.computed = !1, n.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), n.key.name = i, this.finishNode(n.key, "Identifier")) : this.parseClassElementName(n), t < 13 || this.type === I.parenL || o !== "method" || r || s) {
    var c = !n.static && Ms(n, "constructor"), d = c && e;
    c && o !== "method" && this.raise(n.key.start, "Constructor can't have get/set modifier"), n.kind = c ? "constructor" : o, this.parseClassMethod(n, r, s, d);
  } else
    this.parseClassField(n);
  return n;
};
ke.isClassElementNameStart = function() {
  return this.type === I.name || this.type === I.privateId || this.type === I.num || this.type === I.string || this.type === I.bracketL || this.type.keyword;
};
ke.parseClassElementName = function(e) {
  this.type === I.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), e.computed = !1, e.key = this.parsePrivateIdent()) : this.parsePropertyName(e);
};
ke.parseClassMethod = function(e, t, n, i) {
  var r = e.key;
  e.kind === "constructor" ? (t && this.raise(r.start, "Constructor can't be a generator"), n && this.raise(r.start, "Constructor can't be an async method")) : e.static && Ms(e, "prototype") && this.raise(r.start, "Classes may not have a static property named prototype");
  var s = e.value = this.parseMethod(t, n, i);
  return e.kind === "get" && s.params.length !== 0 && this.raiseRecoverable(s.start, "getter should have no params"), e.kind === "set" && s.params.length !== 1 && this.raiseRecoverable(s.start, "setter should have exactly one param"), e.kind === "set" && s.params[0].type === "RestElement" && this.raiseRecoverable(s.params[0].start, "Setter cannot use rest params"), this.finishNode(e, "MethodDefinition");
};
ke.parseClassField = function(e) {
  return Ms(e, "constructor") ? this.raise(e.key.start, "Classes can't have a field named 'constructor'") : e.static && Ms(e, "prototype") && this.raise(e.key.start, "Classes can't have a static field named 'prototype'"), this.eat(I.eq) ? (this.enterScope(es | Js), e.value = this.parseMaybeAssign(), this.exitScope()) : e.value = null, this.semicolon(), this.finishNode(e, "PropertyDefinition");
};
ke.parseClassStaticBlock = function(e) {
  e.body = [];
  var t = this.labels;
  for (this.labels = [], this.enterScope(Vi | Js); this.type !== I.braceR; ) {
    var n = this.parseStatement(null);
    e.body.push(n);
  }
  return this.next(), this.exitScope(), this.labels = t, this.finishNode(e, "StaticBlock");
};
ke.parseClassId = function(e, t) {
  this.type === I.name ? (e.id = this.parseIdent(), t && this.checkLValSimple(e.id, ni, !1)) : (t === !0 && this.unexpected(), e.id = null);
};
ke.parseClassSuper = function(e) {
  e.superClass = this.eat(I._extends) ? this.parseExprSubscripts(null, !1) : null;
};
ke.enterClassBody = function() {
  var e = { declared: /* @__PURE__ */ Object.create(null), used: [] };
  return this.privateNameStack.push(e), e.declared;
};
ke.exitClassBody = function() {
  var e = this.privateNameStack.pop(), t = e.declared, n = e.used;
  if (this.options.checkPrivateFields)
    for (var i = this.privateNameStack.length, r = i === 0 ? null : this.privateNameStack[i - 1], s = 0; s < n.length; ++s) {
      var o = n[s];
      hr(t, o.name) || (r ? r.used.push(o) : this.raiseRecoverable(o.start, "Private field '#" + o.name + "' must be declared in an enclosing class"));
    }
};
function Og(e, t) {
  var n = t.key.name, i = e[n], r = "true";
  return t.type === "MethodDefinition" && (t.kind === "get" || t.kind === "set") && (r = (t.static ? "s" : "i") + t.kind), i === "iget" && r === "iset" || i === "iset" && r === "iget" || i === "sget" && r === "sset" || i === "sset" && r === "sget" ? (e[n] = "true", !1) : i ? !0 : (e[n] = r, !1);
}
function Ms(e, t) {
  var n = e.computed, i = e.key;
  return !n && (i.type === "Identifier" && i.name === t || i.type === "Literal" && i.value === t);
}
ke.parseExportAllDeclaration = function(e, t) {
  return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (e.exported = this.parseModuleExportName(), this.checkExport(t, e.exported, this.lastTokStart)) : e.exported = null), this.expectContextual("from"), this.type !== I.string && this.unexpected(), e.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(e, "ExportAllDeclaration");
};
ke.parseExport = function(e, t) {
  if (this.next(), this.eat(I.star))
    return this.parseExportAllDeclaration(e, t);
  if (this.eat(I._default))
    return this.checkExport(t, "default", this.lastTokStart), e.declaration = this.parseExportDefaultDeclaration(), this.finishNode(e, "ExportDefaultDeclaration");
  if (this.shouldParseExportStatement())
    e.declaration = this.parseExportDeclaration(e), e.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t, e.declaration.declarations) : this.checkExport(t, e.declaration.id, e.declaration.id.start), e.specifiers = [], e.source = null, this.options.ecmaVersion >= 16 && (e.attributes = []);
  else {
    if (e.declaration = null, e.specifiers = this.parseExportSpecifiers(t), this.eatContextual("from"))
      this.type !== I.string && this.unexpected(), e.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause());
    else {
      for (var n = 0, i = e.specifiers; n < i.length; n += 1) {
        var r = i[n];
        this.checkUnreserved(r.local), this.checkLocalExport(r.local), r.local.type === "Literal" && this.raise(r.local.start, "A string literal cannot be used as an exported binding without `from`.");
      }
      e.source = null, this.options.ecmaVersion >= 16 && (e.attributes = []);
    }
    this.semicolon();
  }
  return this.finishNode(e, "ExportNamedDeclaration");
};
ke.parseExportDeclaration = function(e) {
  return this.parseStatement(null);
};
ke.parseExportDefaultDeclaration = function() {
  var e;
  if (this.type === I._function || (e = this.isAsyncFunction())) {
    var t = this.startNode();
    return this.next(), e && this.next(), this.parseFunction(t, jr | Ch, !1, e);
  } else if (this.type === I._class) {
    var n = this.startNode();
    return this.parseClass(n, "nullableID");
  } else {
    var i = this.parseMaybeAssign();
    return this.semicolon(), i;
  }
};
ke.checkExport = function(e, t, n) {
  e && (typeof t != "string" && (t = t.type === "Identifier" ? t.name : t.value), hr(e, t) && this.raiseRecoverable(n, "Duplicate export '" + t + "'"), e[t] = !0);
};
ke.checkPatternExport = function(e, t) {
  var n = t.type;
  if (n === "Identifier")
    this.checkExport(e, t, t.start);
  else if (n === "ObjectPattern")
    for (var i = 0, r = t.properties; i < r.length; i += 1) {
      var s = r[i];
      this.checkPatternExport(e, s);
    }
  else if (n === "ArrayPattern")
    for (var o = 0, l = t.elements; o < l.length; o += 1) {
      var u = l[o];
      u && this.checkPatternExport(e, u);
    }
  else n === "Property" ? this.checkPatternExport(e, t.value) : n === "AssignmentPattern" ? this.checkPatternExport(e, t.left) : n === "RestElement" && this.checkPatternExport(e, t.argument);
};
ke.checkVariableExport = function(e, t) {
  if (e)
    for (var n = 0, i = t; n < i.length; n += 1) {
      var r = i[n];
      this.checkPatternExport(e, r.id);
    }
};
ke.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
ke.parseExportSpecifier = function(e) {
  var t = this.startNode();
  return t.local = this.parseModuleExportName(), t.exported = this.eatContextual("as") ? this.parseModuleExportName() : t.local, this.checkExport(
    e,
    t.exported,
    t.exported.start
  ), this.finishNode(t, "ExportSpecifier");
};
ke.parseExportSpecifiers = function(e) {
  var t = [], n = !0;
  for (this.expect(I.braceL); !this.eat(I.braceR); ) {
    if (n)
      n = !1;
    else if (this.expect(I.comma), this.afterTrailingComma(I.braceR))
      break;
    t.push(this.parseExportSpecifier(e));
  }
  return t;
};
ke.parseImport = function(e) {
  return this.next(), this.type === I.string ? (e.specifiers = Rg, e.source = this.parseExprAtom()) : (e.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e.source = this.type === I.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(e, "ImportDeclaration");
};
ke.parseImportSpecifier = function() {
  var e = this.startNode();
  return e.imported = this.parseModuleExportName(), this.eatContextual("as") ? e.local = this.parseIdent() : (this.checkUnreserved(e.imported), e.local = e.imported), this.checkLValSimple(e.local, ni), this.finishNode(e, "ImportSpecifier");
};
ke.parseImportDefaultSpecifier = function() {
  var e = this.startNode();
  return e.local = this.parseIdent(), this.checkLValSimple(e.local, ni), this.finishNode(e, "ImportDefaultSpecifier");
};
ke.parseImportNamespaceSpecifier = function() {
  var e = this.startNode();
  return this.next(), this.expectContextual("as"), e.local = this.parseIdent(), this.checkLValSimple(e.local, ni), this.finishNode(e, "ImportNamespaceSpecifier");
};
ke.parseImportSpecifiers = function() {
  var e = [], t = !0;
  if (this.type === I.name && (e.push(this.parseImportDefaultSpecifier()), !this.eat(I.comma)))
    return e;
  if (this.type === I.star)
    return e.push(this.parseImportNamespaceSpecifier()), e;
  for (this.expect(I.braceL); !this.eat(I.braceR); ) {
    if (t)
      t = !1;
    else if (this.expect(I.comma), this.afterTrailingComma(I.braceR))
      break;
    e.push(this.parseImportSpecifier());
  }
  return e;
};
ke.parseWithClause = function() {
  var e = [];
  if (!this.eat(I._with))
    return e;
  this.expect(I.braceL);
  for (var t = {}, n = !0; !this.eat(I.braceR); ) {
    if (n)
      n = !1;
    else if (this.expect(I.comma), this.afterTrailingComma(I.braceR))
      break;
    var i = this.parseImportAttribute(), r = i.key.type === "Identifier" ? i.key.name : i.key.value;
    hr(t, r) && this.raiseRecoverable(i.key.start, "Duplicate attribute key '" + r + "'"), t[r] = !0, e.push(i);
  }
  return e;
};
ke.parseImportAttribute = function() {
  var e = this.startNode();
  return e.key = this.type === I.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(I.colon), this.type !== I.string && this.unexpected(), e.value = this.parseExprAtom(), this.finishNode(e, "ImportAttribute");
};
ke.parseModuleExportName = function() {
  if (this.options.ecmaVersion >= 13 && this.type === I.string) {
    var e = this.parseLiteral(this.value);
    return Pg.test(e.value) && this.raise(e.start, "An export name cannot include a lone surrogate."), e;
  }
  return this.parseIdent(!0);
};
ke.adaptDirectivePrologue = function(e) {
  for (var t = 0; t < e.length && this.isDirectiveCandidate(e[t]); ++t)
    e[t].directive = e[t].expression.raw.slice(1, -1);
};
ke.isDirectiveCandidate = function(e) {
  return this.options.ecmaVersion >= 5 && e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && // Reject parenthesized strings.
  (this.input[e.start] === '"' || this.input[e.start] === "'");
};
var gn = Et.prototype;
gn.toAssignable = function(e, t, n) {
  if (this.options.ecmaVersion >= 6 && e)
    switch (e.type) {
      case "Identifier":
        this.inAsync && e.name === "await" && this.raise(e.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "AssignmentPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e.type = "ObjectPattern", n && this.checkPatternErrors(n, !0);
        for (var i = 0, r = e.properties; i < r.length; i += 1) {
          var s = r[i];
          this.toAssignable(s, t), s.type === "RestElement" && (s.argument.type === "ArrayPattern" || s.argument.type === "ObjectPattern") && this.raise(s.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e.kind !== "init" && this.raise(e.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e.value, t);
        break;
      case "ArrayExpression":
        e.type = "ArrayPattern", n && this.checkPatternErrors(n, !0), this.toAssignableList(e.elements, t);
        break;
      case "SpreadElement":
        e.type = "RestElement", this.toAssignable(e.argument, t), e.argument.type === "AssignmentPattern" && this.raise(e.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e.operator !== "=" && this.raise(e.left.end, "Only '=' operator can be used for specifying default value."), e.type = "AssignmentPattern", delete e.operator, this.toAssignable(e.left, t);
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e.expression, t, n);
        break;
      case "ChainExpression":
        this.raiseRecoverable(e.start, "Optional chaining cannot appear in left-hand side");
        break;
      case "MemberExpression":
        if (!t)
          break;
      default:
        this.raise(e.start, "Assigning to rvalue");
    }
  else n && this.checkPatternErrors(n, !0);
  return e;
};
gn.toAssignableList = function(e, t) {
  for (var n = e.length, i = 0; i < n; i++) {
    var r = e[i];
    r && this.toAssignable(r, t);
  }
  if (n) {
    var s = e[n - 1];
    this.options.ecmaVersion === 6 && t && s && s.type === "RestElement" && s.argument.type !== "Identifier" && this.unexpected(s.argument.start);
  }
  return e;
};
gn.parseSpread = function(e) {
  var t = this.startNode();
  return this.next(), t.argument = this.parseMaybeAssign(!1, e), this.finishNode(t, "SpreadElement");
};
gn.parseRestBinding = function() {
  var e = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== I.name && this.unexpected(), e.argument = this.parseBindingAtom(), this.finishNode(e, "RestElement");
};
gn.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case I.bracketL:
        var e = this.startNode();
        return this.next(), e.elements = this.parseBindingList(I.bracketR, !0, !0), this.finishNode(e, "ArrayPattern");
      case I.braceL:
        return this.parseObj(!0);
    }
  return this.parseIdent();
};
gn.parseBindingList = function(e, t, n, i) {
  for (var r = [], s = !0; !this.eat(e); )
    if (s ? s = !1 : this.expect(I.comma), t && this.type === I.comma)
      r.push(null);
    else {
      if (n && this.afterTrailingComma(e))
        break;
      if (this.type === I.ellipsis) {
        var o = this.parseRestBinding();
        this.parseBindingListItem(o), r.push(o), this.type === I.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(e);
        break;
      } else
        r.push(this.parseAssignableListItem(i));
    }
  return r;
};
gn.parseAssignableListItem = function(e) {
  var t = this.parseMaybeDefault(this.start, this.startLoc);
  return this.parseBindingListItem(t), t;
};
gn.parseBindingListItem = function(e) {
  return e;
};
gn.parseMaybeDefault = function(e, t, n) {
  if (n = n || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(I.eq))
    return n;
  var i = this.startNodeAt(e, t);
  return i.left = n, i.right = this.parseMaybeAssign(), this.finishNode(i, "AssignmentPattern");
};
gn.checkLValSimple = function(e, t, n) {
  t === void 0 && (t = Ds);
  var i = t !== Ds;
  switch (e.type) {
    case "Identifier":
      this.strict && this.reservedWordsStrictBind.test(e.name) && this.raiseRecoverable(e.start, (i ? "Binding " : "Assigning to ") + e.name + " in strict mode"), i && (t === ni && e.name === "let" && this.raiseRecoverable(e.start, "let is disallowed as a lexically bound name"), n && (hr(n, e.name) && this.raiseRecoverable(e.start, "Argument name clash"), n[e.name] = !0), t !== kh && this.declareName(e.name, t, e.start));
      break;
    case "ChainExpression":
      this.raiseRecoverable(e.start, "Optional chaining cannot appear in left-hand side");
      break;
    case "MemberExpression":
      i && this.raiseRecoverable(e.start, "Binding member expression");
      break;
    case "ParenthesizedExpression":
      return i && this.raiseRecoverable(e.start, "Binding parenthesized expression"), this.checkLValSimple(e.expression, t, n);
    default:
      this.raise(e.start, (i ? "Binding" : "Assigning to") + " rvalue");
  }
};
gn.checkLValPattern = function(e, t, n) {
  switch (t === void 0 && (t = Ds), e.type) {
    case "ObjectPattern":
      for (var i = 0, r = e.properties; i < r.length; i += 1) {
        var s = r[i];
        this.checkLValInnerPattern(s, t, n);
      }
      break;
    case "ArrayPattern":
      for (var o = 0, l = e.elements; o < l.length; o += 1) {
        var u = l[o];
        u && this.checkLValInnerPattern(u, t, n);
      }
      break;
    default:
      this.checkLValSimple(e, t, n);
  }
};
gn.checkLValInnerPattern = function(e, t, n) {
  switch (t === void 0 && (t = Ds), e.type) {
    case "Property":
      this.checkLValInnerPattern(e.value, t, n);
      break;
    case "AssignmentPattern":
      this.checkLValPattern(e.left, t, n);
      break;
    case "RestElement":
      this.checkLValPattern(e.argument, t, n);
      break;
    default:
      this.checkLValPattern(e, t, n);
  }
};
var bn = function(t, n, i, r, s) {
  this.token = t, this.isExpr = !!n, this.preserveSpace = !!i, this.override = r, this.generator = !!s;
}, ht = {
  b_stat: new bn("{", !1),
  b_expr: new bn("{", !0),
  b_tmpl: new bn("${", !1),
  p_stat: new bn("(", !1),
  p_expr: new bn("(", !0),
  q_tmpl: new bn("`", !0, !0, function(e) {
    return e.tryReadTemplateToken();
  }),
  f_stat: new bn("function", !1),
  f_expr: new bn("function", !0),
  f_expr_gen: new bn("function", !0, !1, null, !0),
  f_gen: new bn("function", !1, !1, null, !0)
}, fr = Et.prototype;
fr.initialContext = function() {
  return [ht.b_stat];
};
fr.curContext = function() {
  return this.context[this.context.length - 1];
};
fr.braceIsBlock = function(e) {
  var t = this.curContext();
  return t === ht.f_expr || t === ht.f_stat ? !0 : e === I.colon && (t === ht.b_stat || t === ht.b_expr) ? !t.isExpr : e === I._return || e === I.name && this.exprAllowed ? Qt.test(this.input.slice(this.lastTokEnd, this.start)) : e === I._else || e === I.semi || e === I.eof || e === I.parenR || e === I.arrow ? !0 : e === I.braceL ? t === ht.b_stat : e === I._var || e === I._const || e === I.name ? !1 : !this.exprAllowed;
};
fr.inGeneratorContext = function() {
  for (var e = this.context.length - 1; e >= 1; e--) {
    var t = this.context[e];
    if (t.token === "function")
      return t.generator;
  }
  return !1;
};
fr.updateContext = function(e) {
  var t, n = this.type;
  n.keyword && e === I.dot ? this.exprAllowed = !1 : (t = n.updateContext) ? t.call(this, e) : this.exprAllowed = n.beforeExpr;
};
fr.overrideContext = function(e) {
  this.curContext() !== e && (this.context[this.context.length - 1] = e);
};
I.parenR.updateContext = I.braceR.updateContext = function() {
  if (this.context.length === 1) {
    this.exprAllowed = !0;
    return;
  }
  var e = this.context.pop();
  e === ht.b_stat && this.curContext().token === "function" && (e = this.context.pop()), this.exprAllowed = !e.isExpr;
};
I.braceL.updateContext = function(e) {
  this.context.push(this.braceIsBlock(e) ? ht.b_stat : ht.b_expr), this.exprAllowed = !0;
};
I.dollarBraceL.updateContext = function() {
  this.context.push(ht.b_tmpl), this.exprAllowed = !0;
};
I.parenL.updateContext = function(e) {
  var t = e === I._if || e === I._for || e === I._with || e === I._while;
  this.context.push(t ? ht.p_stat : ht.p_expr), this.exprAllowed = !0;
};
I.incDec.updateContext = function() {
};
I._function.updateContext = I._class.updateContext = function(e) {
  e.beforeExpr && e !== I._else && !(e === I.semi && this.curContext() !== ht.p_stat) && !(e === I._return && Qt.test(this.input.slice(this.lastTokEnd, this.start))) && !((e === I.colon || e === I.braceL) && this.curContext() === ht.b_stat) ? this.context.push(ht.f_expr) : this.context.push(ht.f_stat), this.exprAllowed = !1;
};
I.colon.updateContext = function() {
  this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
};
I.backQuote.updateContext = function() {
  this.curContext() === ht.q_tmpl ? this.context.pop() : this.context.push(ht.q_tmpl), this.exprAllowed = !1;
};
I.star.updateContext = function(e) {
  if (e === I._function) {
    var t = this.context.length - 1;
    this.context[t] === ht.f_expr ? this.context[t] = ht.f_expr_gen : this.context[t] = ht.f_gen;
  }
  this.exprAllowed = !0;
};
I.name.updateContext = function(e) {
  var t = !1;
  this.options.ecmaVersion >= 6 && e !== I.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t = !0), this.exprAllowed = t;
};
var Me = Et.prototype;
Me.checkPropClash = function(e, t, n) {
  if (!(this.options.ecmaVersion >= 9 && e.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (e.computed || e.method || e.shorthand))) {
    var i = e.key, r;
    switch (i.type) {
      case "Identifier":
        r = i.name;
        break;
      case "Literal":
        r = String(i.value);
        break;
      default:
        return;
    }
    var s = e.kind;
    if (this.options.ecmaVersion >= 6) {
      r === "__proto__" && s === "init" && (t.proto && (n ? n.doubleProto < 0 && (n.doubleProto = i.start) : this.raiseRecoverable(i.start, "Redefinition of __proto__ property")), t.proto = !0);
      return;
    }
    r = "$" + r;
    var o = t[r];
    if (o) {
      var l;
      s === "init" ? l = this.strict && o.init || o.get || o.set : l = o.init || o[s], l && this.raiseRecoverable(i.start, "Redefinition of property");
    } else
      o = t[r] = {
        init: !1,
        get: !1,
        set: !1
      };
    o[s] = !0;
  }
};
Me.parseExpression = function(e, t) {
  var n = this.start, i = this.startLoc, r = this.parseMaybeAssign(e, t);
  if (this.type === I.comma) {
    var s = this.startNodeAt(n, i);
    for (s.expressions = [r]; this.eat(I.comma); )
      s.expressions.push(this.parseMaybeAssign(e, t));
    return this.finishNode(s, "SequenceExpression");
  }
  return r;
};
Me.parseMaybeAssign = function(e, t, n) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e);
    this.exprAllowed = !1;
  }
  var i = !1, r = -1, s = -1, o = -1;
  t ? (r = t.parenthesizedAssign, s = t.trailingComma, o = t.doubleProto, t.parenthesizedAssign = t.trailingComma = -1) : (t = new Zs(), i = !0);
  var l = this.start, u = this.startLoc;
  (this.type === I.parenL || this.type === I.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = e === "await");
  var c = this.parseMaybeConditional(e, t);
  if (n && (c = n.call(this, c, l, u)), this.type.isAssign) {
    var d = this.startNodeAt(l, u);
    return d.operator = this.value, this.type === I.eq && (c = this.toAssignable(c, !1, t)), i || (t.parenthesizedAssign = t.trailingComma = t.doubleProto = -1), t.shorthandAssign >= c.start && (t.shorthandAssign = -1), this.type === I.eq ? this.checkLValPattern(c) : this.checkLValSimple(c), d.left = c, this.next(), d.right = this.parseMaybeAssign(e), o > -1 && (t.doubleProto = o), this.finishNode(d, "AssignmentExpression");
  } else
    i && this.checkExpressionErrors(t, !0);
  return r > -1 && (t.parenthesizedAssign = r), s > -1 && (t.trailingComma = s), c;
};
Me.parseMaybeConditional = function(e, t) {
  var n = this.start, i = this.startLoc, r = this.parseExprOps(e, t);
  if (this.checkExpressionErrors(t))
    return r;
  if (this.eat(I.question)) {
    var s = this.startNodeAt(n, i);
    return s.test = r, s.consequent = this.parseMaybeAssign(), this.expect(I.colon), s.alternate = this.parseMaybeAssign(e), this.finishNode(s, "ConditionalExpression");
  }
  return r;
};
Me.parseExprOps = function(e, t) {
  var n = this.start, i = this.startLoc, r = this.parseMaybeUnary(t, !1, !1, e);
  return this.checkExpressionErrors(t) || r.start === n && r.type === "ArrowFunctionExpression" ? r : this.parseExprOp(r, n, i, -1, e);
};
Me.parseExprOp = function(e, t, n, i, r) {
  var s = this.type.binop;
  if (s != null && (!r || this.type !== I._in) && s > i) {
    var o = this.type === I.logicalOR || this.type === I.logicalAND, l = this.type === I.coalesce;
    l && (s = I.logicalAND.binop);
    var u = this.value;
    this.next();
    var c = this.start, d = this.startLoc, h = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, r), c, d, s, r), m = this.buildBinary(t, n, e, h, u, o || l);
    return (o && this.type === I.coalesce || l && (this.type === I.logicalOR || this.type === I.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(m, t, n, i, r);
  }
  return e;
};
Me.buildBinary = function(e, t, n, i, r, s) {
  i.type === "PrivateIdentifier" && this.raise(i.start, "Private identifier can only be left side of binary expression");
  var o = this.startNodeAt(e, t);
  return o.left = n, o.operator = r, o.right = i, this.finishNode(o, s ? "LogicalExpression" : "BinaryExpression");
};
Me.parseMaybeUnary = function(e, t, n, i) {
  var r = this.start, s = this.startLoc, o;
  if (this.isContextual("await") && this.canAwait)
    o = this.parseAwait(i), t = !0;
  else if (this.type.prefix) {
    var l = this.startNode(), u = this.type === I.incDec;
    l.operator = this.value, l.prefix = !0, this.next(), l.argument = this.parseMaybeUnary(null, !0, u, i), this.checkExpressionErrors(e, !0), u ? this.checkLValSimple(l.argument) : this.strict && l.operator === "delete" && Sh(l.argument) ? this.raiseRecoverable(l.start, "Deleting local variable in strict mode") : l.operator === "delete" && ko(l.argument) ? this.raiseRecoverable(l.start, "Private fields can not be deleted") : t = !0, o = this.finishNode(l, u ? "UpdateExpression" : "UnaryExpression");
  } else if (!t && this.type === I.privateId)
    (i || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), o = this.parsePrivateIdent(), this.type !== I._in && this.unexpected();
  else {
    if (o = this.parseExprSubscripts(e, i), this.checkExpressionErrors(e))
      return o;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var c = this.startNodeAt(r, s);
      c.operator = this.value, c.prefix = !1, c.argument = o, this.checkLValSimple(o), this.next(), o = this.finishNode(c, "UpdateExpression");
    }
  }
  if (!n && this.eat(I.starstar))
    if (t)
      this.unexpected(this.lastTokStart);
    else
      return this.buildBinary(r, s, o, this.parseMaybeUnary(null, !1, !1, i), "**", !1);
  else
    return o;
};
function Sh(e) {
  return e.type === "Identifier" || e.type === "ParenthesizedExpression" && Sh(e.expression);
}
function ko(e) {
  return e.type === "MemberExpression" && e.property.type === "PrivateIdentifier" || e.type === "ChainExpression" && ko(e.expression) || e.type === "ParenthesizedExpression" && ko(e.expression);
}
Me.parseExprSubscripts = function(e, t) {
  var n = this.start, i = this.startLoc, r = this.parseExprAtom(e, t);
  if (r.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
    return r;
  var s = this.parseSubscripts(r, n, i, !1, t);
  return e && s.type === "MemberExpression" && (e.parenthesizedAssign >= s.start && (e.parenthesizedAssign = -1), e.parenthesizedBind >= s.start && (e.parenthesizedBind = -1), e.trailingComma >= s.start && (e.trailingComma = -1)), s;
};
Me.parseSubscripts = function(e, t, n, i, r) {
  for (var s = this.options.ecmaVersion >= 8 && e.type === "Identifier" && e.name === "async" && this.lastTokEnd === e.end && !this.canInsertSemicolon() && e.end - e.start === 5 && this.potentialArrowAt === e.start, o = !1; ; ) {
    var l = this.parseSubscript(e, t, n, i, s, o, r);
    if (l.optional && (o = !0), l === e || l.type === "ArrowFunctionExpression") {
      if (o) {
        var u = this.startNodeAt(t, n);
        u.expression = l, l = this.finishNode(u, "ChainExpression");
      }
      return l;
    }
    e = l;
  }
};
Me.shouldParseAsyncArrow = function() {
  return !this.canInsertSemicolon() && this.eat(I.arrow);
};
Me.parseSubscriptAsyncArrow = function(e, t, n, i) {
  return this.parseArrowExpression(this.startNodeAt(e, t), n, !0, i);
};
Me.parseSubscript = function(e, t, n, i, r, s, o) {
  var l = this.options.ecmaVersion >= 11, u = l && this.eat(I.questionDot);
  i && u && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
  var c = this.eat(I.bracketL);
  if (c || u && this.type !== I.parenL && this.type !== I.backQuote || this.eat(I.dot)) {
    var d = this.startNodeAt(t, n);
    d.object = e, c ? (d.property = this.parseExpression(), this.expect(I.bracketR)) : this.type === I.privateId && e.type !== "Super" ? d.property = this.parsePrivateIdent() : d.property = this.parseIdent(this.options.allowReserved !== "never"), d.computed = !!c, l && (d.optional = u), e = this.finishNode(d, "MemberExpression");
  } else if (!i && this.eat(I.parenL)) {
    var h = new Zs(), m = this.yieldPos, _ = this.awaitPos, y = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var v = this.parseExprList(I.parenR, this.options.ecmaVersion >= 8, !1, h);
    if (r && !u && this.shouldParseAsyncArrow())
      return this.checkPatternErrors(h, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = m, this.awaitPos = _, this.awaitIdentPos = y, this.parseSubscriptAsyncArrow(t, n, v, o);
    this.checkExpressionErrors(h, !0), this.yieldPos = m || this.yieldPos, this.awaitPos = _ || this.awaitPos, this.awaitIdentPos = y || this.awaitIdentPos;
    var w = this.startNodeAt(t, n);
    w.callee = e, w.arguments = v, l && (w.optional = u), e = this.finishNode(w, "CallExpression");
  } else if (this.type === I.backQuote) {
    (u || s) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
    var x = this.startNodeAt(t, n);
    x.tag = e, x.quasi = this.parseTemplate({ isTagged: !0 }), e = this.finishNode(x, "TaggedTemplateExpression");
  }
  return e;
};
Me.parseExprAtom = function(e, t, n) {
  this.type === I.slash && this.readRegexp();
  var i, r = this.potentialArrowAt === this.start;
  switch (this.type) {
    case I._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), i = this.startNode(), this.next(), this.type === I.parenL && !this.allowDirectSuper && this.raise(i.start, "super() call outside constructor of a subclass"), this.type !== I.dot && this.type !== I.bracketL && this.type !== I.parenL && this.unexpected(), this.finishNode(i, "Super");
    case I._this:
      return i = this.startNode(), this.next(), this.finishNode(i, "ThisExpression");
    case I.name:
      var s = this.start, o = this.startLoc, l = this.containsEsc, u = this.parseIdent(!1);
      if (this.options.ecmaVersion >= 8 && !l && u.name === "async" && !this.canInsertSemicolon() && this.eat(I._function))
        return this.overrideContext(ht.f_expr), this.parseFunction(this.startNodeAt(s, o), 0, !1, !0, t);
      if (r && !this.canInsertSemicolon()) {
        if (this.eat(I.arrow))
          return this.parseArrowExpression(this.startNodeAt(s, o), [u], !1, t);
        if (this.options.ecmaVersion >= 8 && u.name === "async" && this.type === I.name && !l && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
          return u = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(I.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(s, o), [u], !0, t);
      }
      return u;
    case I.regexp:
      var c = this.value;
      return i = this.parseLiteral(c.value), i.regex = { pattern: c.pattern, flags: c.flags }, i;
    case I.num:
    case I.string:
      return this.parseLiteral(this.value);
    case I._null:
    case I._true:
    case I._false:
      return i = this.startNode(), i.value = this.type === I._null ? null : this.type === I._true, i.raw = this.type.keyword, this.next(), this.finishNode(i, "Literal");
    case I.parenL:
      var d = this.start, h = this.parseParenAndDistinguishExpression(r, t);
      return e && (e.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(h) && (e.parenthesizedAssign = d), e.parenthesizedBind < 0 && (e.parenthesizedBind = d)), h;
    case I.bracketL:
      return i = this.startNode(), this.next(), i.elements = this.parseExprList(I.bracketR, !0, !0, e), this.finishNode(i, "ArrayExpression");
    case I.braceL:
      return this.overrideContext(ht.b_expr), this.parseObj(!1, e);
    case I._function:
      return i = this.startNode(), this.next(), this.parseFunction(i, 0);
    case I._class:
      return this.parseClass(this.startNode(), !1);
    case I._new:
      return this.parseNew();
    case I.backQuote:
      return this.parseTemplate();
    case I._import:
      return this.options.ecmaVersion >= 11 ? this.parseExprImport(n) : this.unexpected();
    default:
      return this.parseExprAtomDefault();
  }
};
Me.parseExprAtomDefault = function() {
  this.unexpected();
};
Me.parseExprImport = function(e) {
  var t = this.startNode();
  if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === I.parenL && !e)
    return this.parseDynamicImport(t);
  if (this.type === I.dot) {
    var n = this.startNodeAt(t.start, t.loc && t.loc.start);
    return n.name = "import", t.meta = this.finishNode(n, "Identifier"), this.parseImportMeta(t);
  } else
    this.unexpected();
};
Me.parseDynamicImport = function(e) {
  if (this.next(), e.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
    this.eat(I.parenR) ? e.options = null : (this.expect(I.comma), this.afterTrailingComma(I.parenR) ? e.options = null : (e.options = this.parseMaybeAssign(), this.eat(I.parenR) || (this.expect(I.comma), this.afterTrailingComma(I.parenR) || this.unexpected())));
  else if (!this.eat(I.parenR)) {
    var t = this.start;
    this.eat(I.comma) && this.eat(I.parenR) ? this.raiseRecoverable(t, "Trailing comma is not allowed in import()") : this.unexpected(t);
  }
  return this.finishNode(e, "ImportExpression");
};
Me.parseImportMeta = function(e) {
  this.next();
  var t = this.containsEsc;
  return e.property = this.parseIdent(!0), e.property.name !== "meta" && this.raiseRecoverable(e.property.start, "The only valid meta property for import is 'import.meta'"), t && this.raiseRecoverable(e.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(e.start, "Cannot use 'import.meta' outside a module"), this.finishNode(e, "MetaProperty");
};
Me.parseLiteral = function(e) {
  var t = this.startNode();
  return t.value = e, t.raw = this.input.slice(this.start, this.end), t.raw.charCodeAt(t.raw.length - 1) === 110 && (t.bigint = t.value != null ? t.value.toString() : t.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(t, "Literal");
};
Me.parseParenExpression = function() {
  this.expect(I.parenL);
  var e = this.parseExpression();
  return this.expect(I.parenR), e;
};
Me.shouldParseArrow = function(e) {
  return !this.canInsertSemicolon();
};
Me.parseParenAndDistinguishExpression = function(e, t) {
  var n = this.start, i = this.startLoc, r, s = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var o = this.start, l = this.startLoc, u = [], c = !0, d = !1, h = new Zs(), m = this.yieldPos, _ = this.awaitPos, y;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== I.parenR; )
      if (c ? c = !1 : this.expect(I.comma), s && this.afterTrailingComma(I.parenR, !0)) {
        d = !0;
        break;
      } else if (this.type === I.ellipsis) {
        y = this.start, u.push(this.parseParenItem(this.parseRestBinding())), this.type === I.comma && this.raiseRecoverable(
          this.start,
          "Comma is not permitted after the rest element"
        );
        break;
      } else
        u.push(this.parseMaybeAssign(!1, h, this.parseParenItem));
    var v = this.lastTokEnd, w = this.lastTokEndLoc;
    if (this.expect(I.parenR), e && this.shouldParseArrow(u) && this.eat(I.arrow))
      return this.checkPatternErrors(h, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = m, this.awaitPos = _, this.parseParenArrowList(n, i, u, t);
    (!u.length || d) && this.unexpected(this.lastTokStart), y && this.unexpected(y), this.checkExpressionErrors(h, !0), this.yieldPos = m || this.yieldPos, this.awaitPos = _ || this.awaitPos, u.length > 1 ? (r = this.startNodeAt(o, l), r.expressions = u, this.finishNodeAt(r, "SequenceExpression", v, w)) : r = u[0];
  } else
    r = this.parseParenExpression();
  if (this.options.preserveParens) {
    var x = this.startNodeAt(n, i);
    return x.expression = r, this.finishNode(x, "ParenthesizedExpression");
  } else
    return r;
};
Me.parseParenItem = function(e) {
  return e;
};
Me.parseParenArrowList = function(e, t, n, i) {
  return this.parseArrowExpression(this.startNodeAt(e, t), n, !1, i);
};
var Bg = [];
Me.parseNew = function() {
  this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
  var e = this.startNode();
  if (this.next(), this.options.ecmaVersion >= 6 && this.type === I.dot) {
    var t = this.startNodeAt(e.start, e.loc && e.loc.start);
    t.name = "new", e.meta = this.finishNode(t, "Identifier"), this.next();
    var n = this.containsEsc;
    return e.property = this.parseIdent(!0), e.property.name !== "target" && this.raiseRecoverable(e.property.start, "The only valid meta property for new is 'new.target'"), n && this.raiseRecoverable(e.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(e.start, "'new.target' can only be used in functions and class static block"), this.finishNode(e, "MetaProperty");
  }
  var i = this.start, r = this.startLoc;
  return e.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), i, r, !0, !1), this.eat(I.parenL) ? e.arguments = this.parseExprList(I.parenR, this.options.ecmaVersion >= 8, !1) : e.arguments = Bg, this.finishNode(e, "NewExpression");
};
Me.parseTemplateElement = function(e) {
  var t = e.isTagged, n = this.startNode();
  return this.type === I.invalidTemplate ? (t || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), n.value = {
    raw: this.value.replace(/\r\n?/g, `
`),
    cooked: null
  }) : n.value = {
    raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
    cooked: this.value
  }, this.next(), n.tail = this.type === I.backQuote, this.finishNode(n, "TemplateElement");
};
Me.parseTemplate = function(e) {
  e === void 0 && (e = {});
  var t = e.isTagged;
  t === void 0 && (t = !1);
  var n = this.startNode();
  this.next(), n.expressions = [];
  var i = this.parseTemplateElement({ isTagged: t });
  for (n.quasis = [i]; !i.tail; )
    this.type === I.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(I.dollarBraceL), n.expressions.push(this.parseExpression()), this.expect(I.braceR), n.quasis.push(i = this.parseTemplateElement({ isTagged: t }));
  return this.next(), this.finishNode(n, "TemplateLiteral");
};
Me.isAsyncProp = function(e) {
  return !e.computed && e.key.type === "Identifier" && e.key.name === "async" && (this.type === I.name || this.type === I.num || this.type === I.string || this.type === I.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === I.star) && !Qt.test(this.input.slice(this.lastTokEnd, this.start));
};
Me.parseObj = function(e, t) {
  var n = this.startNode(), i = !0, r = {};
  for (n.properties = [], this.next(); !this.eat(I.braceR); ) {
    if (i)
      i = !1;
    else if (this.expect(I.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(I.braceR))
      break;
    var s = this.parseProperty(e, t);
    e || this.checkPropClash(s, r, t), n.properties.push(s);
  }
  return this.finishNode(n, e ? "ObjectPattern" : "ObjectExpression");
};
Me.parseProperty = function(e, t) {
  var n = this.startNode(), i, r, s, o;
  if (this.options.ecmaVersion >= 9 && this.eat(I.ellipsis))
    return e ? (n.argument = this.parseIdent(!1), this.type === I.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(n, "RestElement")) : (n.argument = this.parseMaybeAssign(!1, t), this.type === I.comma && t && t.trailingComma < 0 && (t.trailingComma = this.start), this.finishNode(n, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (n.method = !1, n.shorthand = !1, (e || t) && (s = this.start, o = this.startLoc), e || (i = this.eat(I.star)));
  var l = this.containsEsc;
  return this.parsePropertyName(n), !e && !l && this.options.ecmaVersion >= 8 && !i && this.isAsyncProp(n) ? (r = !0, i = this.options.ecmaVersion >= 9 && this.eat(I.star), this.parsePropertyName(n)) : r = !1, this.parsePropertyValue(n, e, i, r, s, o, t, l), this.finishNode(n, "Property");
};
Me.parseGetterSetter = function(e) {
  var t = e.key.name;
  this.parsePropertyName(e), e.value = this.parseMethod(!1), e.kind = t;
  var n = e.kind === "get" ? 0 : 1;
  if (e.value.params.length !== n) {
    var i = e.value.start;
    e.kind === "get" ? this.raiseRecoverable(i, "getter should have no params") : this.raiseRecoverable(i, "setter should have exactly one param");
  } else
    e.kind === "set" && e.value.params[0].type === "RestElement" && this.raiseRecoverable(e.value.params[0].start, "Setter cannot use rest params");
};
Me.parsePropertyValue = function(e, t, n, i, r, s, o, l) {
  (n || i) && this.type === I.colon && this.unexpected(), this.eat(I.colon) ? (e.value = t ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, o), e.kind = "init") : this.options.ecmaVersion >= 6 && this.type === I.parenL ? (t && this.unexpected(), e.method = !0, e.value = this.parseMethod(n, i), e.kind = "init") : !t && !l && this.options.ecmaVersion >= 5 && !e.computed && e.key.type === "Identifier" && (e.key.name === "get" || e.key.name === "set") && this.type !== I.comma && this.type !== I.braceR && this.type !== I.eq ? ((n || i) && this.unexpected(), this.parseGetterSetter(e)) : this.options.ecmaVersion >= 6 && !e.computed && e.key.type === "Identifier" ? ((n || i) && this.unexpected(), this.checkUnreserved(e.key), e.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = r), t ? e.value = this.parseMaybeDefault(r, s, this.copyNode(e.key)) : this.type === I.eq && o ? (o.shorthandAssign < 0 && (o.shorthandAssign = this.start), e.value = this.parseMaybeDefault(r, s, this.copyNode(e.key))) : e.value = this.copyNode(e.key), e.kind = "init", e.shorthand = !0) : this.unexpected();
};
Me.parsePropertyName = function(e) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(I.bracketL))
      return e.computed = !0, e.key = this.parseMaybeAssign(), this.expect(I.bracketR), e.key;
    e.computed = !1;
  }
  return e.key = this.type === I.num || this.type === I.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
Me.initFunction = function(e) {
  e.id = null, this.options.ecmaVersion >= 6 && (e.generator = e.expression = !1), this.options.ecmaVersion >= 8 && (e.async = !1);
};
Me.parseMethod = function(e, t, n) {
  var i = this.startNode(), r = this.yieldPos, s = this.awaitPos, o = this.awaitIdentPos;
  return this.initFunction(i), this.options.ecmaVersion >= 6 && (i.generator = e), this.options.ecmaVersion >= 8 && (i.async = !!t), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(il(t, i.generator) | Js | (n ? yh : 0)), this.expect(I.parenL), i.params = this.parseBindingList(I.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(i, !1, !0, !1), this.yieldPos = r, this.awaitPos = s, this.awaitIdentPos = o, this.finishNode(i, "FunctionExpression");
};
Me.parseArrowExpression = function(e, t, n, i) {
  var r = this.yieldPos, s = this.awaitPos, o = this.awaitIdentPos;
  return this.enterScope(il(n, !1) | nl), this.initFunction(e), this.options.ecmaVersion >= 8 && (e.async = !!n), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e.params = this.toAssignableList(t, !0), this.parseFunctionBody(e, !0, !1, i), this.yieldPos = r, this.awaitPos = s, this.awaitIdentPos = o, this.finishNode(e, "ArrowFunctionExpression");
};
Me.parseFunctionBody = function(e, t, n, i) {
  var r = t && this.type !== I.braceL, s = this.strict, o = !1;
  if (r)
    e.body = this.parseMaybeAssign(i), e.expression = !0, this.checkParams(e, !1);
  else {
    var l = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e.params);
    (!s || l) && (o = this.strictDirective(this.end), o && l && this.raiseRecoverable(e.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
    var u = this.labels;
    this.labels = [], o && (this.strict = !0), this.checkParams(e, !s && !o && !t && !n && this.isSimpleParamList(e.params)), this.strict && e.id && this.checkLValSimple(e.id, kh), e.body = this.parseBlock(!1, void 0, o && !s), e.expression = !1, this.adaptDirectivePrologue(e.body.body), this.labels = u;
  }
  this.exitScope();
};
Me.isSimpleParamList = function(e) {
  for (var t = 0, n = e; t < n.length; t += 1) {
    var i = n[t];
    if (i.type !== "Identifier")
      return !1;
  }
  return !0;
};
Me.checkParams = function(e, t) {
  for (var n = /* @__PURE__ */ Object.create(null), i = 0, r = e.params; i < r.length; i += 1) {
    var s = r[i];
    this.checkLValInnerPattern(s, rl, t ? null : n);
  }
};
Me.parseExprList = function(e, t, n, i) {
  for (var r = [], s = !0; !this.eat(e); ) {
    if (s)
      s = !1;
    else if (this.expect(I.comma), t && this.afterTrailingComma(e))
      break;
    var o = void 0;
    n && this.type === I.comma ? o = null : this.type === I.ellipsis ? (o = this.parseSpread(i), i && this.type === I.comma && i.trailingComma < 0 && (i.trailingComma = this.start)) : o = this.parseMaybeAssign(!1, i), r.push(o);
  }
  return r;
};
Me.checkUnreserved = function(e) {
  var t = e.start, n = e.end, i = e.name;
  if (this.inGenerator && i === "yield" && this.raiseRecoverable(t, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && i === "await" && this.raiseRecoverable(t, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & Ws) && i === "arguments" && this.raiseRecoverable(t, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (i === "arguments" || i === "await") && this.raise(t, "Cannot use " + i + " in class static initialization block"), this.keywords.test(i) && this.raise(t, "Unexpected keyword '" + i + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(t, n).indexOf("\\") !== -1)) {
    var r = this.strict ? this.reservedWordsStrict : this.reservedWords;
    r.test(i) && (!this.inAsync && i === "await" && this.raiseRecoverable(t, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t, "The keyword '" + i + "' is reserved"));
  }
};
Me.parseIdent = function(e) {
  var t = this.parseIdentNode();
  return this.next(!!e), this.finishNode(t, "Identifier"), e || (this.checkUnreserved(t), t.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = t.start)), t;
};
Me.parseIdentNode = function() {
  var e = this.startNode();
  return this.type === I.name ? e.name = this.value : this.type.keyword ? (e.name = this.type.keyword, (e.name === "class" || e.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = I.name) : this.unexpected(), e;
};
Me.parsePrivateIdent = function() {
  var e = this.startNode();
  return this.type === I.privateId ? e.name = this.value : this.unexpected(), this.next(), this.finishNode(e, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(e.start, "Private field '#" + e.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(e)), e;
};
Me.parseYield = function(e) {
  this.yieldPos || (this.yieldPos = this.start);
  var t = this.startNode();
  return this.next(), this.type === I.semi || this.canInsertSemicolon() || this.type !== I.star && !this.type.startsExpr ? (t.delegate = !1, t.argument = null) : (t.delegate = this.eat(I.star), t.argument = this.parseMaybeAssign(e)), this.finishNode(t, "YieldExpression");
};
Me.parseAwait = function(e) {
  this.awaitPos || (this.awaitPos = this.start);
  var t = this.startNode();
  return this.next(), t.argument = this.parseMaybeUnary(null, !0, !1, e), this.finishNode(t, "AwaitExpression");
};
var Vs = Et.prototype;
Vs.raise = function(e, t) {
  var n = gh(this.input, e);
  t += " (" + n.line + ":" + n.column + ")", this.sourceFile && (t += " in " + this.sourceFile);
  var i = new SyntaxError(t);
  throw i.pos = e, i.loc = n, i.raisedAt = this.pos, i;
};
Vs.raiseRecoverable = Vs.raise;
Vs.curPosition = function() {
  if (this.options.locations)
    return new Jr(this.curLine, this.pos - this.lineStart);
};
var xi = Et.prototype, zg = function(t) {
  this.flags = t, this.var = [], this.lexical = [], this.functions = [];
};
xi.enterScope = function(e) {
  this.scopeStack.push(new zg(e));
};
xi.exitScope = function() {
  this.scopeStack.pop();
};
xi.treatFunctionsAsVarInScope = function(e) {
  return e.flags & pr || !this.inModule && e.flags & Wr;
};
xi.declareName = function(e, t, n) {
  var i = !1;
  if (t === ni) {
    var r = this.currentScope();
    i = r.lexical.indexOf(e) > -1 || r.functions.indexOf(e) > -1 || r.var.indexOf(e) > -1, r.lexical.push(e), this.inModule && r.flags & Wr && delete this.undefinedExports[e];
  } else if (t === wh) {
    var s = this.currentScope();
    s.lexical.push(e);
  } else if (t === vh) {
    var o = this.currentScope();
    this.treatFunctionsAsVar ? i = o.lexical.indexOf(e) > -1 : i = o.lexical.indexOf(e) > -1 || o.var.indexOf(e) > -1, o.functions.push(e);
  } else
    for (var l = this.scopeStack.length - 1; l >= 0; --l) {
      var u = this.scopeStack[l];
      if (u.lexical.indexOf(e) > -1 && !(u.flags & bh && u.lexical[0] === e) || !this.treatFunctionsAsVarInScope(u) && u.functions.indexOf(e) > -1) {
        i = !0;
        break;
      }
      if (u.var.push(e), this.inModule && u.flags & Wr && delete this.undefinedExports[e], u.flags & Ws)
        break;
    }
  i && this.raiseRecoverable(n, "Identifier '" + e + "' has already been declared");
};
xi.checkLocalExport = function(e) {
  this.scopeStack[0].lexical.indexOf(e.name) === -1 && this.scopeStack[0].var.indexOf(e.name) === -1 && (this.undefinedExports[e.name] = e);
};
xi.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
};
xi.currentVarScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & (Ws | es | Vi))
      return t;
  }
};
xi.currentThisScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & (Ws | es | Vi) && !(t.flags & nl))
      return t;
  }
};
var Xs = function(t, n, i) {
  this.type = "", this.start = n, this.end = 0, t.options.locations && (this.loc = new qs(t, i)), t.options.directSourceFile && (this.sourceFile = t.options.directSourceFile), t.options.ranges && (this.range = [n, 0]);
}, ts = Et.prototype;
ts.startNode = function() {
  return new Xs(this, this.start, this.startLoc);
};
ts.startNodeAt = function(e, t) {
  return new Xs(this, e, t);
};
function Eh(e, t, n, i) {
  return e.type = t, e.end = n, this.options.locations && (e.loc.end = i), this.options.ranges && (e.range[1] = n), e;
}
ts.finishNode = function(e, t) {
  return Eh.call(this, e, t, this.lastTokEnd, this.lastTokEndLoc);
};
ts.finishNodeAt = function(e, t, n, i) {
  return Eh.call(this, e, t, n, i);
};
ts.copyNode = function(e) {
  var t = new Xs(this, e.start, this.startLoc);
  for (var n in e)
    t[n] = e[n];
  return t;
};
var jg = "Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz", Ah = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Ih = Ah + " Extended_Pictographic", Lh = Ih, Nh = Lh + " EBase EComp EMod EPres ExtPict", Th = Nh, $g = Th, Hg = {
  9: Ah,
  10: Ih,
  11: Lh,
  12: Nh,
  13: Th,
  14: $g
}, Ug = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", qg = {
  9: "",
  10: "",
  11: "",
  12: "",
  13: "",
  14: Ug
}, Yu = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", Ph = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Dh = Ph + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", Mh = Dh + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", Vh = Mh + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", Fh = Vh + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", Jg = Fh + " " + jg, Wg = {
  9: Ph,
  10: Dh,
  11: Mh,
  12: Vh,
  13: Fh,
  14: Jg
}, Rh = {};
function Zg(e) {
  var t = Rh[e] = {
    binary: ui(Hg[e] + " " + Yu),
    binaryOfStrings: ui(qg[e]),
    nonBinary: {
      General_Category: ui(Yu),
      Script: ui(Wg[e])
    }
  };
  t.nonBinary.Script_Extensions = t.nonBinary.Script, t.nonBinary.gc = t.nonBinary.General_Category, t.nonBinary.sc = t.nonBinary.Script, t.nonBinary.scx = t.nonBinary.Script_Extensions;
}
for (var Ia = 0, Qu = [9, 10, 11, 12, 13, 14]; Ia < Qu.length; Ia += 1) {
  var Xg = Qu[Ia];
  Zg(Xg);
}
var ve = Et.prototype, Fs = function(t, n) {
  this.parent = t, this.base = n || this;
};
Fs.prototype.separatedFrom = function(t) {
  for (var n = this; n; n = n.parent)
    for (var i = t; i; i = i.parent)
      if (n.base === i.base && n !== i)
        return !0;
  return !1;
};
Fs.prototype.sibling = function() {
  return new Fs(this.parent, this.base);
};
var zn = function(t) {
  this.parser = t, this.validFlags = "gim" + (t.options.ecmaVersion >= 6 ? "uy" : "") + (t.options.ecmaVersion >= 9 ? "s" : "") + (t.options.ecmaVersion >= 13 ? "d" : "") + (t.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Rh[t.options.ecmaVersion >= 14 ? 14 : t.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
};
zn.prototype.reset = function(t, n, i) {
  var r = i.indexOf("v") !== -1, s = i.indexOf("u") !== -1;
  this.start = t | 0, this.source = n + "", this.flags = i, r && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = s && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = s && this.parser.options.ecmaVersion >= 9);
};
zn.prototype.raise = function(t) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + t);
};
zn.prototype.at = function(t, n) {
  n === void 0 && (n = !1);
  var i = this.source, r = i.length;
  if (t >= r)
    return -1;
  var s = i.charCodeAt(t);
  if (!(n || this.switchU) || s <= 55295 || s >= 57344 || t + 1 >= r)
    return s;
  var o = i.charCodeAt(t + 1);
  return o >= 56320 && o <= 57343 ? (s << 10) + o - 56613888 : s;
};
zn.prototype.nextIndex = function(t, n) {
  n === void 0 && (n = !1);
  var i = this.source, r = i.length;
  if (t >= r)
    return r;
  var s = i.charCodeAt(t), o;
  return !(n || this.switchU) || s <= 55295 || s >= 57344 || t + 1 >= r || (o = i.charCodeAt(t + 1)) < 56320 || o > 57343 ? t + 1 : t + 2;
};
zn.prototype.current = function(t) {
  return t === void 0 && (t = !1), this.at(this.pos, t);
};
zn.prototype.lookahead = function(t) {
  return t === void 0 && (t = !1), this.at(this.nextIndex(this.pos, t), t);
};
zn.prototype.advance = function(t) {
  t === void 0 && (t = !1), this.pos = this.nextIndex(this.pos, t);
};
zn.prototype.eat = function(t, n) {
  return n === void 0 && (n = !1), this.current(n) === t ? (this.advance(n), !0) : !1;
};
zn.prototype.eatChars = function(t, n) {
  n === void 0 && (n = !1);
  for (var i = this.pos, r = 0, s = t; r < s.length; r += 1) {
    var o = s[r], l = this.at(i, n);
    if (l === -1 || l !== o)
      return !1;
    i = this.nextIndex(i, n);
  }
  return this.pos = i, !0;
};
ve.validateRegExpFlags = function(e) {
  for (var t = e.validFlags, n = e.flags, i = !1, r = !1, s = 0; s < n.length; s++) {
    var o = n.charAt(s);
    t.indexOf(o) === -1 && this.raise(e.start, "Invalid regular expression flag"), n.indexOf(o, s + 1) > -1 && this.raise(e.start, "Duplicate regular expression flag"), o === "u" && (i = !0), o === "v" && (r = !0);
  }
  this.options.ecmaVersion >= 15 && i && r && this.raise(e.start, "Invalid regular expression flag");
};
function Gg(e) {
  for (var t in e)
    return !0;
  return !1;
}
ve.validateRegExpPattern = function(e) {
  this.regexp_pattern(e), !e.switchN && this.options.ecmaVersion >= 9 && Gg(e.groupNames) && (e.switchN = !0, this.regexp_pattern(e));
};
ve.regexp_pattern = function(e) {
  e.pos = 0, e.lastIntValue = 0, e.lastStringValue = "", e.lastAssertionIsQuantifiable = !1, e.numCapturingParens = 0, e.maxBackReference = 0, e.groupNames = /* @__PURE__ */ Object.create(null), e.backReferenceNames.length = 0, e.branchID = null, this.regexp_disjunction(e), e.pos !== e.source.length && (e.eat(
    41
    /* ) */
  ) && e.raise("Unmatched ')'"), (e.eat(
    93
    /* ] */
  ) || e.eat(
    125
    /* } */
  )) && e.raise("Lone quantifier brackets")), e.maxBackReference > e.numCapturingParens && e.raise("Invalid escape");
  for (var t = 0, n = e.backReferenceNames; t < n.length; t += 1) {
    var i = n[t];
    e.groupNames[i] || e.raise("Invalid named capture referenced");
  }
};
ve.regexp_disjunction = function(e) {
  var t = this.options.ecmaVersion >= 16;
  for (t && (e.branchID = new Fs(e.branchID, null)), this.regexp_alternative(e); e.eat(
    124
    /* | */
  ); )
    t && (e.branchID = e.branchID.sibling()), this.regexp_alternative(e);
  t && (e.branchID = e.branchID.parent), this.regexp_eatQuantifier(e, !0) && e.raise("Nothing to repeat"), e.eat(
    123
    /* { */
  ) && e.raise("Lone quantifier brackets");
};
ve.regexp_alternative = function(e) {
  for (; e.pos < e.source.length && this.regexp_eatTerm(e); )
    ;
};
ve.regexp_eatTerm = function(e) {
  return this.regexp_eatAssertion(e) ? (e.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e) && e.switchU && e.raise("Invalid quantifier"), !0) : (e.switchU ? this.regexp_eatAtom(e) : this.regexp_eatExtendedAtom(e)) ? (this.regexp_eatQuantifier(e), !0) : !1;
};
ve.regexp_eatAssertion = function(e) {
  var t = e.pos;
  if (e.lastAssertionIsQuantifiable = !1, e.eat(
    94
    /* ^ */
  ) || e.eat(
    36
    /* $ */
  ))
    return !0;
  if (e.eat(
    92
    /* \ */
  )) {
    if (e.eat(
      66
      /* B */
    ) || e.eat(
      98
      /* b */
    ))
      return !0;
    e.pos = t;
  }
  if (e.eat(
    40
    /* ( */
  ) && e.eat(
    63
    /* ? */
  )) {
    var n = !1;
    if (this.options.ecmaVersion >= 9 && (n = e.eat(
      60
      /* < */
    )), e.eat(
      61
      /* = */
    ) || e.eat(
      33
      /* ! */
    ))
      return this.regexp_disjunction(e), e.eat(
        41
        /* ) */
      ) || e.raise("Unterminated group"), e.lastAssertionIsQuantifiable = !n, !0;
  }
  return e.pos = t, !1;
};
ve.regexp_eatQuantifier = function(e, t) {
  return t === void 0 && (t = !1), this.regexp_eatQuantifierPrefix(e, t) ? (e.eat(
    63
    /* ? */
  ), !0) : !1;
};
ve.regexp_eatQuantifierPrefix = function(e, t) {
  return e.eat(
    42
    /* * */
  ) || e.eat(
    43
    /* + */
  ) || e.eat(
    63
    /* ? */
  ) || this.regexp_eatBracedQuantifier(e, t);
};
ve.regexp_eatBracedQuantifier = function(e, t) {
  var n = e.pos;
  if (e.eat(
    123
    /* { */
  )) {
    var i = 0, r = -1;
    if (this.regexp_eatDecimalDigits(e) && (i = e.lastIntValue, e.eat(
      44
      /* , */
    ) && this.regexp_eatDecimalDigits(e) && (r = e.lastIntValue), e.eat(
      125
      /* } */
    )))
      return r !== -1 && r < i && !t && e.raise("numbers out of order in {} quantifier"), !0;
    e.switchU && !t && e.raise("Incomplete quantifier"), e.pos = n;
  }
  return !1;
};
ve.regexp_eatAtom = function(e) {
  return this.regexp_eatPatternCharacters(e) || e.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e);
};
ve.regexp_eatReverseSolidusAtomEscape = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatAtomEscape(e))
      return !0;
    e.pos = t;
  }
  return !1;
};
ve.regexp_eatUncapturingGroup = function(e) {
  var t = e.pos;
  if (e.eat(
    40
    /* ( */
  )) {
    if (e.eat(
      63
      /* ? */
    )) {
      if (this.options.ecmaVersion >= 16) {
        var n = this.regexp_eatModifiers(e), i = e.eat(
          45
          /* - */
        );
        if (n || i) {
          for (var r = 0; r < n.length; r++) {
            var s = n.charAt(r);
            n.indexOf(s, r + 1) > -1 && e.raise("Duplicate regular expression modifiers");
          }
          if (i) {
            var o = this.regexp_eatModifiers(e);
            !n && !o && e.current() === 58 && e.raise("Invalid regular expression modifiers");
            for (var l = 0; l < o.length; l++) {
              var u = o.charAt(l);
              (o.indexOf(u, l + 1) > -1 || n.indexOf(u) > -1) && e.raise("Duplicate regular expression modifiers");
            }
          }
        }
      }
      if (e.eat(
        58
        /* : */
      )) {
        if (this.regexp_disjunction(e), e.eat(
          41
          /* ) */
        ))
          return !0;
        e.raise("Unterminated group");
      }
    }
    e.pos = t;
  }
  return !1;
};
ve.regexp_eatCapturingGroup = function(e) {
  if (e.eat(
    40
    /* ( */
  )) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e) : e.current() === 63 && e.raise("Invalid group"), this.regexp_disjunction(e), e.eat(
      41
      /* ) */
    ))
      return e.numCapturingParens += 1, !0;
    e.raise("Unterminated group");
  }
  return !1;
};
ve.regexp_eatModifiers = function(e) {
  for (var t = "", n = 0; (n = e.current()) !== -1 && Kg(n); )
    t += Yn(n), e.advance();
  return t;
};
function Kg(e) {
  return e === 105 || e === 109 || e === 115;
}
ve.regexp_eatExtendedAtom = function(e) {
  return e.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e) || this.regexp_eatInvalidBracedQuantifier(e) || this.regexp_eatExtendedPatternCharacter(e);
};
ve.regexp_eatInvalidBracedQuantifier = function(e) {
  return this.regexp_eatBracedQuantifier(e, !0) && e.raise("Nothing to repeat"), !1;
};
ve.regexp_eatSyntaxCharacter = function(e) {
  var t = e.current();
  return Oh(t) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
function Oh(e) {
  return e === 36 || e >= 40 && e <= 43 || e === 46 || e === 63 || e >= 91 && e <= 94 || e >= 123 && e <= 125;
}
ve.regexp_eatPatternCharacters = function(e) {
  for (var t = e.pos, n = 0; (n = e.current()) !== -1 && !Oh(n); )
    e.advance();
  return e.pos !== t;
};
ve.regexp_eatExtendedPatternCharacter = function(e) {
  var t = e.current();
  return t !== -1 && t !== 36 && !(t >= 40 && t <= 43) && t !== 46 && t !== 63 && t !== 91 && t !== 94 && t !== 124 ? (e.advance(), !0) : !1;
};
ve.regexp_groupSpecifier = function(e) {
  if (e.eat(
    63
    /* ? */
  )) {
    this.regexp_eatGroupName(e) || e.raise("Invalid group");
    var t = this.options.ecmaVersion >= 16, n = e.groupNames[e.lastStringValue];
    if (n)
      if (t)
        for (var i = 0, r = n; i < r.length; i += 1) {
          var s = r[i];
          s.separatedFrom(e.branchID) || e.raise("Duplicate capture group name");
        }
      else
        e.raise("Duplicate capture group name");
    t ? (n || (e.groupNames[e.lastStringValue] = [])).push(e.branchID) : e.groupNames[e.lastStringValue] = !0;
  }
};
ve.regexp_eatGroupName = function(e) {
  if (e.lastStringValue = "", e.eat(
    60
    /* < */
  )) {
    if (this.regexp_eatRegExpIdentifierName(e) && e.eat(
      62
      /* > */
    ))
      return !0;
    e.raise("Invalid capture group name");
  }
  return !1;
};
ve.regexp_eatRegExpIdentifierName = function(e) {
  if (e.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e)) {
    for (e.lastStringValue += Yn(e.lastIntValue); this.regexp_eatRegExpIdentifierPart(e); )
      e.lastStringValue += Yn(e.lastIntValue);
    return !0;
  }
  return !1;
};
ve.regexp_eatRegExpIdentifierStart = function(e) {
  var t = e.pos, n = this.options.ecmaVersion >= 11, i = e.current(n);
  return e.advance(n), i === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e, n) && (i = e.lastIntValue), Yg(i) ? (e.lastIntValue = i, !0) : (e.pos = t, !1);
};
function Yg(e) {
  return Vn(e, !0) || e === 36 || e === 95;
}
ve.regexp_eatRegExpIdentifierPart = function(e) {
  var t = e.pos, n = this.options.ecmaVersion >= 11, i = e.current(n);
  return e.advance(n), i === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e, n) && (i = e.lastIntValue), Qg(i) ? (e.lastIntValue = i, !0) : (e.pos = t, !1);
};
function Qg(e) {
  return mi(e, !0) || e === 36 || e === 95 || e === 8204 || e === 8205;
}
ve.regexp_eatAtomEscape = function(e) {
  return this.regexp_eatBackReference(e) || this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e) || e.switchN && this.regexp_eatKGroupName(e) ? !0 : (e.switchU && (e.current() === 99 && e.raise("Invalid unicode escape"), e.raise("Invalid escape")), !1);
};
ve.regexp_eatBackReference = function(e) {
  var t = e.pos;
  if (this.regexp_eatDecimalEscape(e)) {
    var n = e.lastIntValue;
    if (e.switchU)
      return n > e.maxBackReference && (e.maxBackReference = n), !0;
    if (n <= e.numCapturingParens)
      return !0;
    e.pos = t;
  }
  return !1;
};
ve.regexp_eatKGroupName = function(e) {
  if (e.eat(
    107
    /* k */
  )) {
    if (this.regexp_eatGroupName(e))
      return e.backReferenceNames.push(e.lastStringValue), !0;
    e.raise("Invalid named reference");
  }
  return !1;
};
ve.regexp_eatCharacterEscape = function(e) {
  return this.regexp_eatControlEscape(e) || this.regexp_eatCControlLetter(e) || this.regexp_eatZero(e) || this.regexp_eatHexEscapeSequence(e) || this.regexp_eatRegExpUnicodeEscapeSequence(e, !1) || !e.switchU && this.regexp_eatLegacyOctalEscapeSequence(e) || this.regexp_eatIdentityEscape(e);
};
ve.regexp_eatCControlLetter = function(e) {
  var t = e.pos;
  if (e.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatControlLetter(e))
      return !0;
    e.pos = t;
  }
  return !1;
};
ve.regexp_eatZero = function(e) {
  return e.current() === 48 && !Gs(e.lookahead()) ? (e.lastIntValue = 0, e.advance(), !0) : !1;
};
ve.regexp_eatControlEscape = function(e) {
  var t = e.current();
  return t === 116 ? (e.lastIntValue = 9, e.advance(), !0) : t === 110 ? (e.lastIntValue = 10, e.advance(), !0) : t === 118 ? (e.lastIntValue = 11, e.advance(), !0) : t === 102 ? (e.lastIntValue = 12, e.advance(), !0) : t === 114 ? (e.lastIntValue = 13, e.advance(), !0) : !1;
};
ve.regexp_eatControlLetter = function(e) {
  var t = e.current();
  return Bh(t) ? (e.lastIntValue = t % 32, e.advance(), !0) : !1;
};
function Bh(e) {
  return e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
ve.regexp_eatRegExpUnicodeEscapeSequence = function(e, t) {
  t === void 0 && (t = !1);
  var n = e.pos, i = t || e.switchU;
  if (e.eat(
    117
    /* u */
  )) {
    if (this.regexp_eatFixedHexDigits(e, 4)) {
      var r = e.lastIntValue;
      if (i && r >= 55296 && r <= 56319) {
        var s = e.pos;
        if (e.eat(
          92
          /* \ */
        ) && e.eat(
          117
          /* u */
        ) && this.regexp_eatFixedHexDigits(e, 4)) {
          var o = e.lastIntValue;
          if (o >= 56320 && o <= 57343)
            return e.lastIntValue = (r - 55296) * 1024 + (o - 56320) + 65536, !0;
        }
        e.pos = s, e.lastIntValue = r;
      }
      return !0;
    }
    if (i && e.eat(
      123
      /* { */
    ) && this.regexp_eatHexDigits(e) && e.eat(
      125
      /* } */
    ) && ex(e.lastIntValue))
      return !0;
    i && e.raise("Invalid unicode escape"), e.pos = n;
  }
  return !1;
};
function ex(e) {
  return e >= 0 && e <= 1114111;
}
ve.regexp_eatIdentityEscape = function(e) {
  if (e.switchU)
    return this.regexp_eatSyntaxCharacter(e) ? !0 : e.eat(
      47
      /* / */
    ) ? (e.lastIntValue = 47, !0) : !1;
  var t = e.current();
  return t !== 99 && (!e.switchN || t !== 107) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
ve.regexp_eatDecimalEscape = function(e) {
  e.lastIntValue = 0;
  var t = e.current();
  if (t >= 49 && t <= 57) {
    do
      e.lastIntValue = 10 * e.lastIntValue + (t - 48), e.advance();
    while ((t = e.current()) >= 48 && t <= 57);
    return !0;
  }
  return !1;
};
var zh = 0, Qn = 1, mn = 2;
ve.regexp_eatCharacterClassEscape = function(e) {
  var t = e.current();
  if (tx(t))
    return e.lastIntValue = -1, e.advance(), Qn;
  var n = !1;
  if (e.switchU && this.options.ecmaVersion >= 9 && ((n = t === 80) || t === 112)) {
    e.lastIntValue = -1, e.advance();
    var i;
    if (e.eat(
      123
      /* { */
    ) && (i = this.regexp_eatUnicodePropertyValueExpression(e)) && e.eat(
      125
      /* } */
    ))
      return n && i === mn && e.raise("Invalid property name"), i;
    e.raise("Invalid property name");
  }
  return zh;
};
function tx(e) {
  return e === 100 || e === 68 || e === 115 || e === 83 || e === 119 || e === 87;
}
ve.regexp_eatUnicodePropertyValueExpression = function(e) {
  var t = e.pos;
  if (this.regexp_eatUnicodePropertyName(e) && e.eat(
    61
    /* = */
  )) {
    var n = e.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e)) {
      var i = e.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e, n, i), Qn;
    }
  }
  if (e.pos = t, this.regexp_eatLoneUnicodePropertyNameOrValue(e)) {
    var r = e.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e, r);
  }
  return zh;
};
ve.regexp_validateUnicodePropertyNameAndValue = function(e, t, n) {
  hr(e.unicodeProperties.nonBinary, t) || e.raise("Invalid property name"), e.unicodeProperties.nonBinary[t].test(n) || e.raise("Invalid property value");
};
ve.regexp_validateUnicodePropertyNameOrValue = function(e, t) {
  if (e.unicodeProperties.binary.test(t))
    return Qn;
  if (e.switchV && e.unicodeProperties.binaryOfStrings.test(t))
    return mn;
  e.raise("Invalid property name");
};
ve.regexp_eatUnicodePropertyName = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; jh(t = e.current()); )
    e.lastStringValue += Yn(t), e.advance();
  return e.lastStringValue !== "";
};
function jh(e) {
  return Bh(e) || e === 95;
}
ve.regexp_eatUnicodePropertyValue = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; nx(t = e.current()); )
    e.lastStringValue += Yn(t), e.advance();
  return e.lastStringValue !== "";
};
function nx(e) {
  return jh(e) || Gs(e);
}
ve.regexp_eatLoneUnicodePropertyNameOrValue = function(e) {
  return this.regexp_eatUnicodePropertyValue(e);
};
ve.regexp_eatCharacterClass = function(e) {
  if (e.eat(
    91
    /* [ */
  )) {
    var t = e.eat(
      94
      /* ^ */
    ), n = this.regexp_classContents(e);
    return e.eat(
      93
      /* ] */
    ) || e.raise("Unterminated character class"), t && n === mn && e.raise("Negated character class may contain strings"), !0;
  }
  return !1;
};
ve.regexp_classContents = function(e) {
  return e.current() === 93 ? Qn : e.switchV ? this.regexp_classSetExpression(e) : (this.regexp_nonEmptyClassRanges(e), Qn);
};
ve.regexp_nonEmptyClassRanges = function(e) {
  for (; this.regexp_eatClassAtom(e); ) {
    var t = e.lastIntValue;
    if (e.eat(
      45
      /* - */
    ) && this.regexp_eatClassAtom(e)) {
      var n = e.lastIntValue;
      e.switchU && (t === -1 || n === -1) && e.raise("Invalid character class"), t !== -1 && n !== -1 && t > n && e.raise("Range out of order in character class");
    }
  }
};
ve.regexp_eatClassAtom = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatClassEscape(e))
      return !0;
    if (e.switchU) {
      var n = e.current();
      (n === 99 || Uh(n)) && e.raise("Invalid class escape"), e.raise("Invalid escape");
    }
    e.pos = t;
  }
  var i = e.current();
  return i !== 93 ? (e.lastIntValue = i, e.advance(), !0) : !1;
};
ve.regexp_eatClassEscape = function(e) {
  var t = e.pos;
  if (e.eat(
    98
    /* b */
  ))
    return e.lastIntValue = 8, !0;
  if (e.switchU && e.eat(
    45
    /* - */
  ))
    return e.lastIntValue = 45, !0;
  if (!e.switchU && e.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatClassControlLetter(e))
      return !0;
    e.pos = t;
  }
  return this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e);
};
ve.regexp_classSetExpression = function(e) {
  var t = Qn, n;
  if (!this.regexp_eatClassSetRange(e)) if (n = this.regexp_eatClassSetOperand(e)) {
    n === mn && (t = mn);
    for (var i = e.pos; e.eatChars(
      [38, 38]
      /* && */
    ); ) {
      if (e.current() !== 38 && (n = this.regexp_eatClassSetOperand(e))) {
        n !== mn && (t = Qn);
        continue;
      }
      e.raise("Invalid character in character class");
    }
    if (i !== e.pos)
      return t;
    for (; e.eatChars(
      [45, 45]
      /* -- */
    ); )
      this.regexp_eatClassSetOperand(e) || e.raise("Invalid character in character class");
    if (i !== e.pos)
      return t;
  } else
    e.raise("Invalid character in character class");
  for (; ; )
    if (!this.regexp_eatClassSetRange(e)) {
      if (n = this.regexp_eatClassSetOperand(e), !n)
        return t;
      n === mn && (t = mn);
    }
};
ve.regexp_eatClassSetRange = function(e) {
  var t = e.pos;
  if (this.regexp_eatClassSetCharacter(e)) {
    var n = e.lastIntValue;
    if (e.eat(
      45
      /* - */
    ) && this.regexp_eatClassSetCharacter(e)) {
      var i = e.lastIntValue;
      return n !== -1 && i !== -1 && n > i && e.raise("Range out of order in character class"), !0;
    }
    e.pos = t;
  }
  return !1;
};
ve.regexp_eatClassSetOperand = function(e) {
  return this.regexp_eatClassSetCharacter(e) ? Qn : this.regexp_eatClassStringDisjunction(e) || this.regexp_eatNestedClass(e);
};
ve.regexp_eatNestedClass = function(e) {
  var t = e.pos;
  if (e.eat(
    91
    /* [ */
  )) {
    var n = e.eat(
      94
      /* ^ */
    ), i = this.regexp_classContents(e);
    if (e.eat(
      93
      /* ] */
    ))
      return n && i === mn && e.raise("Negated character class may contain strings"), i;
    e.pos = t;
  }
  if (e.eat(
    92
    /* \ */
  )) {
    var r = this.regexp_eatCharacterClassEscape(e);
    if (r)
      return r;
    e.pos = t;
  }
  return null;
};
ve.regexp_eatClassStringDisjunction = function(e) {
  var t = e.pos;
  if (e.eatChars(
    [92, 113]
    /* \q */
  )) {
    if (e.eat(
      123
      /* { */
    )) {
      var n = this.regexp_classStringDisjunctionContents(e);
      if (e.eat(
        125
        /* } */
      ))
        return n;
    } else
      e.raise("Invalid escape");
    e.pos = t;
  }
  return null;
};
ve.regexp_classStringDisjunctionContents = function(e) {
  for (var t = this.regexp_classString(e); e.eat(
    124
    /* | */
  ); )
    this.regexp_classString(e) === mn && (t = mn);
  return t;
};
ve.regexp_classString = function(e) {
  for (var t = 0; this.regexp_eatClassSetCharacter(e); )
    t++;
  return t === 1 ? Qn : mn;
};
ve.regexp_eatClassSetCharacter = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  ))
    return this.regexp_eatCharacterEscape(e) || this.regexp_eatClassSetReservedPunctuator(e) ? !0 : e.eat(
      98
      /* b */
    ) ? (e.lastIntValue = 8, !0) : (e.pos = t, !1);
  var n = e.current();
  return n < 0 || n === e.lookahead() && ix(n) || rx(n) ? !1 : (e.advance(), e.lastIntValue = n, !0);
};
function ix(e) {
  return e === 33 || e >= 35 && e <= 38 || e >= 42 && e <= 44 || e === 46 || e >= 58 && e <= 64 || e === 94 || e === 96 || e === 126;
}
function rx(e) {
  return e === 40 || e === 41 || e === 45 || e === 47 || e >= 91 && e <= 93 || e >= 123 && e <= 125;
}
ve.regexp_eatClassSetReservedPunctuator = function(e) {
  var t = e.current();
  return sx(t) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
function sx(e) {
  return e === 33 || e === 35 || e === 37 || e === 38 || e === 44 || e === 45 || e >= 58 && e <= 62 || e === 64 || e === 96 || e === 126;
}
ve.regexp_eatClassControlLetter = function(e) {
  var t = e.current();
  return Gs(t) || t === 95 ? (e.lastIntValue = t % 32, e.advance(), !0) : !1;
};
ve.regexp_eatHexEscapeSequence = function(e) {
  var t = e.pos;
  if (e.eat(
    120
    /* x */
  )) {
    if (this.regexp_eatFixedHexDigits(e, 2))
      return !0;
    e.switchU && e.raise("Invalid escape"), e.pos = t;
  }
  return !1;
};
ve.regexp_eatDecimalDigits = function(e) {
  var t = e.pos, n = 0;
  for (e.lastIntValue = 0; Gs(n = e.current()); )
    e.lastIntValue = 10 * e.lastIntValue + (n - 48), e.advance();
  return e.pos !== t;
};
function Gs(e) {
  return e >= 48 && e <= 57;
}
ve.regexp_eatHexDigits = function(e) {
  var t = e.pos, n = 0;
  for (e.lastIntValue = 0; $h(n = e.current()); )
    e.lastIntValue = 16 * e.lastIntValue + Hh(n), e.advance();
  return e.pos !== t;
};
function $h(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function Hh(e) {
  return e >= 65 && e <= 70 ? 10 + (e - 65) : e >= 97 && e <= 102 ? 10 + (e - 97) : e - 48;
}
ve.regexp_eatLegacyOctalEscapeSequence = function(e) {
  if (this.regexp_eatOctalDigit(e)) {
    var t = e.lastIntValue;
    if (this.regexp_eatOctalDigit(e)) {
      var n = e.lastIntValue;
      t <= 3 && this.regexp_eatOctalDigit(e) ? e.lastIntValue = t * 64 + n * 8 + e.lastIntValue : e.lastIntValue = t * 8 + n;
    } else
      e.lastIntValue = t;
    return !0;
  }
  return !1;
};
ve.regexp_eatOctalDigit = function(e) {
  var t = e.current();
  return Uh(t) ? (e.lastIntValue = t - 48, e.advance(), !0) : (e.lastIntValue = 0, !1);
};
function Uh(e) {
  return e >= 48 && e <= 55;
}
ve.regexp_eatFixedHexDigits = function(e, t) {
  var n = e.pos;
  e.lastIntValue = 0;
  for (var i = 0; i < t; ++i) {
    var r = e.current();
    if (!$h(r))
      return e.pos = n, !1;
    e.lastIntValue = 16 * e.lastIntValue + Hh(r), e.advance();
  }
  return !0;
};
var al = function(t) {
  this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, t.options.locations && (this.loc = new qs(t, t.startLoc, t.endLoc)), t.options.ranges && (this.range = [t.start, t.end]);
}, Je = Et.prototype;
Je.next = function(e) {
  !e && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new al(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
};
Je.getToken = function() {
  return this.next(), new al(this);
};
typeof Symbol < "u" && (Je[Symbol.iterator] = function() {
  var e = this;
  return {
    next: function() {
      var t = e.getToken();
      return {
        done: t.type === I.eof,
        value: t
      };
    }
  };
});
Je.nextToken = function() {
  var e = this.curContext();
  if ((!e || !e.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
    return this.finishToken(I.eof);
  if (e.override)
    return e.override(this);
  this.readToken(this.fullCharCodeAtPos());
};
Je.readToken = function(e) {
  return Vn(e, this.options.ecmaVersion >= 6) || e === 92 ? this.readWord() : this.getTokenFromCode(e);
};
Je.fullCharCodeAtPos = function() {
  var e = this.input.charCodeAt(this.pos);
  if (e <= 55295 || e >= 56320)
    return e;
  var t = this.input.charCodeAt(this.pos + 1);
  return t <= 56319 || t >= 57344 ? e : (e << 10) + t - 56613888;
};
Je.skipBlockComment = function() {
  var e = this.options.onComment && this.curPosition(), t = this.pos, n = this.input.indexOf("*/", this.pos += 2);
  if (n === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = n + 2, this.options.locations)
    for (var i = void 0, r = t; (i = fh(this.input, r, this.pos)) > -1; )
      ++this.curLine, r = this.lineStart = i;
  this.options.onComment && this.options.onComment(
    !0,
    this.input.slice(t + 2, n),
    t,
    this.pos,
    e,
    this.curPosition()
  );
};
Je.skipLineComment = function(e) {
  for (var t = this.pos, n = this.options.onComment && this.curPosition(), i = this.input.charCodeAt(this.pos += e); this.pos < this.input.length && !dr(i); )
    i = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(
    !1,
    this.input.slice(t + e, this.pos),
    t,
    this.pos,
    n,
    this.curPosition()
  );
};
Je.skipSpace = function() {
  e: for (; this.pos < this.input.length; ) {
    var e = this.input.charCodeAt(this.pos);
    switch (e) {
      case 32:
      case 160:
        ++this.pos;
        break;
      case 13:
        this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
      case 10:
      case 8232:
      case 8233:
        ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
        break;
      case 47:
        switch (this.input.charCodeAt(this.pos + 1)) {
          case 42:
            this.skipBlockComment();
            break;
          case 47:
            this.skipLineComment(2);
            break;
          default:
            break e;
        }
        break;
      default:
        if (e > 8 && e < 14 || e >= 5760 && mh.test(String.fromCharCode(e)))
          ++this.pos;
        else
          break e;
    }
  }
};
Je.finishToken = function(e, t) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var n = this.type;
  this.type = e, this.value = t, this.updateContext(n);
};
Je.readToken_dot = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  if (e >= 48 && e <= 57)
    return this.readNumber(!0);
  var t = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e === 46 && t === 46 ? (this.pos += 3, this.finishToken(I.ellipsis)) : (++this.pos, this.finishToken(I.dot));
};
Je.readToken_slash = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e === 61 ? this.finishOp(I.assign, 2) : this.finishOp(I.slash, 1);
};
Je.readToken_mult_modulo_exp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), n = 1, i = e === 42 ? I.star : I.modulo;
  return this.options.ecmaVersion >= 7 && e === 42 && t === 42 && (++n, i = I.starstar, t = this.input.charCodeAt(this.pos + 2)), t === 61 ? this.finishOp(I.assign, n + 1) : this.finishOp(i, n);
};
Je.readToken_pipe_amp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  if (t === e) {
    if (this.options.ecmaVersion >= 12) {
      var n = this.input.charCodeAt(this.pos + 2);
      if (n === 61)
        return this.finishOp(I.assign, 3);
    }
    return this.finishOp(e === 124 ? I.logicalOR : I.logicalAND, 2);
  }
  return t === 61 ? this.finishOp(I.assign, 2) : this.finishOp(e === 124 ? I.bitwiseOR : I.bitwiseAND, 1);
};
Je.readToken_caret = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  return e === 61 ? this.finishOp(I.assign, 2) : this.finishOp(I.bitwiseXOR, 1);
};
Je.readToken_plus_min = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === e ? t === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || Qt.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(I.incDec, 2) : t === 61 ? this.finishOp(I.assign, 2) : this.finishOp(I.plusMin, 1);
};
Je.readToken_lt_gt = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), n = 1;
  return t === e ? (n = e === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + n) === 61 ? this.finishOp(I.assign, n + 1) : this.finishOp(I.bitShift, n)) : t === 33 && e === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (t === 61 && (n = 2), this.finishOp(I.relational, n));
};
Je.readToken_eq_excl = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === 61 ? this.finishOp(I.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e === 61 && t === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(I.arrow)) : this.finishOp(e === 61 ? I.eq : I.prefix, 1);
};
Je.readToken_question = function() {
  var e = this.options.ecmaVersion;
  if (e >= 11) {
    var t = this.input.charCodeAt(this.pos + 1);
    if (t === 46) {
      var n = this.input.charCodeAt(this.pos + 2);
      if (n < 48 || n > 57)
        return this.finishOp(I.questionDot, 2);
    }
    if (t === 63) {
      if (e >= 12) {
        var i = this.input.charCodeAt(this.pos + 2);
        if (i === 61)
          return this.finishOp(I.assign, 3);
      }
      return this.finishOp(I.coalesce, 2);
    }
  }
  return this.finishOp(I.question, 1);
};
Je.readToken_numberSign = function() {
  var e = this.options.ecmaVersion, t = 35;
  if (e >= 13 && (++this.pos, t = this.fullCharCodeAtPos(), Vn(t, !0) || t === 92))
    return this.finishToken(I.privateId, this.readWord1());
  this.raise(this.pos, "Unexpected character '" + Yn(t) + "'");
};
Je.getTokenFromCode = function(e) {
  switch (e) {
    // The interpretation of a dot depends on whether it is followed
    // by a digit or another two dots.
    case 46:
      return this.readToken_dot();
    // Punctuation tokens.
    case 40:
      return ++this.pos, this.finishToken(I.parenL);
    case 41:
      return ++this.pos, this.finishToken(I.parenR);
    case 59:
      return ++this.pos, this.finishToken(I.semi);
    case 44:
      return ++this.pos, this.finishToken(I.comma);
    case 91:
      return ++this.pos, this.finishToken(I.bracketL);
    case 93:
      return ++this.pos, this.finishToken(I.bracketR);
    case 123:
      return ++this.pos, this.finishToken(I.braceL);
    case 125:
      return ++this.pos, this.finishToken(I.braceR);
    case 58:
      return ++this.pos, this.finishToken(I.colon);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken(I.backQuote);
    case 48:
      var t = this.input.charCodeAt(this.pos + 1);
      if (t === 120 || t === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t === 111 || t === 79)
          return this.readRadixNumber(8);
        if (t === 98 || t === 66)
          return this.readRadixNumber(2);
      }
    // Anything else beginning with a digit is an integer, octal
    // number, or float.
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(!1);
    // Quotes produce strings.
    case 34:
    case 39:
      return this.readString(e);
    // Operators are parsed inline in tiny state machines. '=' (61) is
    // often referred to. `finishOp` simply skips the amount of
    // characters it is given as second argument, and returns a token
    // of the type given by its first argument.
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e);
    case 60:
    case 62:
      return this.readToken_lt_gt(e);
    case 61:
    case 33:
      return this.readToken_eq_excl(e);
    case 63:
      return this.readToken_question();
    case 126:
      return this.finishOp(I.prefix, 1);
    case 35:
      return this.readToken_numberSign();
  }
  this.raise(this.pos, "Unexpected character '" + Yn(e) + "'");
};
Je.finishOp = function(e, t) {
  var n = this.input.slice(this.pos, this.pos + t);
  return this.pos += t, this.finishToken(e, n);
};
Je.readRegexp = function() {
  for (var e, t, n = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(n, "Unterminated regular expression");
    var i = this.input.charAt(this.pos);
    if (Qt.test(i) && this.raise(n, "Unterminated regular expression"), e)
      e = !1;
    else {
      if (i === "[")
        t = !0;
      else if (i === "]" && t)
        t = !1;
      else if (i === "/" && !t)
        break;
      e = i === "\\";
    }
    ++this.pos;
  }
  var r = this.input.slice(n, this.pos);
  ++this.pos;
  var s = this.pos, o = this.readWord1();
  this.containsEsc && this.unexpected(s);
  var l = this.regexpState || (this.regexpState = new zn(this));
  l.reset(n, r, o), this.validateRegExpFlags(l), this.validateRegExpPattern(l);
  var u = null;
  try {
    u = new RegExp(r, o);
  } catch {
  }
  return this.finishToken(I.regexp, { pattern: r, flags: o, value: u });
};
Je.readInt = function(e, t, n) {
  for (var i = this.options.ecmaVersion >= 12 && t === void 0, r = n && this.input.charCodeAt(this.pos) === 48, s = this.pos, o = 0, l = 0, u = 0, c = t ?? 1 / 0; u < c; ++u, ++this.pos) {
    var d = this.input.charCodeAt(this.pos), h = void 0;
    if (i && d === 95) {
      r && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), l === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), u === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), l = d;
      continue;
    }
    if (d >= 97 ? h = d - 97 + 10 : d >= 65 ? h = d - 65 + 10 : d >= 48 && d <= 57 ? h = d - 48 : h = 1 / 0, h >= e)
      break;
    l = d, o = o * e + h;
  }
  return i && l === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === s || t != null && this.pos - s !== t ? null : o;
};
function ax(e, t) {
  return t ? parseInt(e, 8) : parseFloat(e.replace(/_/g, ""));
}
function qh(e) {
  return typeof BigInt != "function" ? null : BigInt(e.replace(/_/g, ""));
}
Je.readRadixNumber = function(e) {
  var t = this.pos;
  this.pos += 2;
  var n = this.readInt(e);
  return n == null && this.raise(this.start + 2, "Expected number in radix " + e), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (n = qh(this.input.slice(t, this.pos)), ++this.pos) : Vn(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(I.num, n);
};
Je.readNumber = function(e) {
  var t = this.pos;
  !e && this.readInt(10, void 0, !0) === null && this.raise(t, "Invalid number");
  var n = this.pos - t >= 2 && this.input.charCodeAt(t) === 48;
  n && this.strict && this.raise(t, "Invalid number");
  var i = this.input.charCodeAt(this.pos);
  if (!n && !e && this.options.ecmaVersion >= 11 && i === 110) {
    var r = qh(this.input.slice(t, this.pos));
    return ++this.pos, Vn(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(I.num, r);
  }
  n && /[89]/.test(this.input.slice(t, this.pos)) && (n = !1), i === 46 && !n && (++this.pos, this.readInt(10), i = this.input.charCodeAt(this.pos)), (i === 69 || i === 101) && !n && (i = this.input.charCodeAt(++this.pos), (i === 43 || i === 45) && ++this.pos, this.readInt(10) === null && this.raise(t, "Invalid number")), Vn(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var s = ax(this.input.slice(t, this.pos), n);
  return this.finishToken(I.num, s);
};
Je.readCodePoint = function() {
  var e = this.input.charCodeAt(this.pos), t;
  if (e === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var n = ++this.pos;
    t = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, t > 1114111 && this.invalidStringToken(n, "Code point out of bounds");
  } else
    t = this.readHexChar(4);
  return t;
};
Je.readString = function(e) {
  for (var t = "", n = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var i = this.input.charCodeAt(this.pos);
    if (i === e)
      break;
    i === 92 ? (t += this.input.slice(n, this.pos), t += this.readEscapedChar(!1), n = this.pos) : i === 8232 || i === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (dr(i) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t += this.input.slice(n, this.pos++), this.finishToken(I.string, t);
};
var Jh = {};
Je.tryReadTemplateToken = function() {
  this.inTemplateElement = !0;
  try {
    this.readTmplToken();
  } catch (e) {
    if (e === Jh)
      this.readInvalidTemplateToken();
    else
      throw e;
  }
  this.inTemplateElement = !1;
};
Je.invalidStringToken = function(e, t) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw Jh;
  this.raise(e, t);
};
Je.readTmplToken = function() {
  for (var e = "", t = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var n = this.input.charCodeAt(this.pos);
    if (n === 96 || n === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos === this.start && (this.type === I.template || this.type === I.invalidTemplate) ? n === 36 ? (this.pos += 2, this.finishToken(I.dollarBraceL)) : (++this.pos, this.finishToken(I.backQuote)) : (e += this.input.slice(t, this.pos), this.finishToken(I.template, e));
    if (n === 92)
      e += this.input.slice(t, this.pos), e += this.readEscapedChar(!0), t = this.pos;
    else if (dr(n)) {
      switch (e += this.input.slice(t, this.pos), ++this.pos, n) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e += `
`;
          break;
        default:
          e += String.fromCharCode(n);
          break;
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t = this.pos;
    } else
      ++this.pos;
  }
};
Je.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      // fall through
      case "`":
        return this.finishToken(I.invalidTemplate, this.input.slice(this.start, this.pos));
      case "\r":
        this.input[this.pos + 1] === `
` && ++this.pos;
      // fall through
      case `
`:
      case "\u2028":
      case "\u2029":
        ++this.curLine, this.lineStart = this.pos + 1;
        break;
    }
  this.raise(this.start, "Unterminated template");
};
Je.readEscapedChar = function(e) {
  var t = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t) {
    case 110:
      return `
`;
    // 'n' -> '\n'
    case 114:
      return "\r";
    // 'r' -> '\r'
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    // 'x'
    case 117:
      return Yn(this.readCodePoint());
    // 'u'
    case 116:
      return "	";
    // 't' -> '\t'
    case 98:
      return "\b";
    // 'b' -> '\b'
    case 118:
      return "\v";
    // 'v' -> '\u000b'
    case 102:
      return "\f";
    // 'f' -> '\f'
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    // '\r\n'
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    case 56:
    case 57:
      if (this.strict && this.invalidStringToken(
        this.pos - 1,
        "Invalid escape sequence"
      ), e) {
        var n = this.pos - 1;
        this.invalidStringToken(
          n,
          "Invalid escape sequence in template string"
        );
      }
    default:
      if (t >= 48 && t <= 55) {
        var i = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], r = parseInt(i, 8);
        return r > 255 && (i = i.slice(0, -1), r = parseInt(i, 8)), this.pos += i.length - 1, t = this.input.charCodeAt(this.pos), (i !== "0" || t === 56 || t === 57) && (this.strict || e) && this.invalidStringToken(
          this.pos - 1 - i.length,
          e ? "Octal literal in template string" : "Octal literal in strict mode"
        ), String.fromCharCode(r);
      }
      return dr(t) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(t);
  }
};
Je.readHexChar = function(e) {
  var t = this.pos, n = this.readInt(16, e);
  return n === null && this.invalidStringToken(t, "Bad character escape sequence"), n;
};
Je.readWord1 = function() {
  this.containsEsc = !1;
  for (var e = "", t = !0, n = this.pos, i = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var r = this.fullCharCodeAtPos();
    if (mi(r, i))
      this.pos += r <= 65535 ? 1 : 2;
    else if (r === 92) {
      this.containsEsc = !0, e += this.input.slice(n, this.pos);
      var s = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var o = this.readCodePoint();
      (t ? Vn : mi)(o, i) || this.invalidStringToken(s, "Invalid Unicode escape"), e += Yn(o), n = this.pos;
    } else
      break;
    t = !1;
  }
  return e + this.input.slice(n, this.pos);
};
Je.readWord = function() {
  var e = this.readWord1(), t = I.name;
  return this.keywords.test(e) && (t = el[e]), this.finishToken(t, e);
};
var ox = "8.15.0";
Et.acorn = {
  Parser: Et,
  version: ox,
  defaultOptions: vo,
  Position: Jr,
  SourceLocation: qs,
  getLineInfo: gh,
  Node: Xs,
  TokenType: Ge,
  tokTypes: I,
  keywordTypes: el,
  TokContext: bn,
  tokContexts: ht,
  isIdentifierChar: mi,
  isIdentifierStart: Vn,
  Token: al,
  isNewLine: dr,
  lineBreak: Qt,
  lineBreakG: Lg,
  nonASCIIwhitespace: mh
};
const Ot = bi(/[A-Za-z]/), Bt = bi(/[\dA-Za-z]/), lx = bi(/[#-'*+\--9=?A-Z^-~]/);
function Rs(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Co = bi(/\d/), ux = bi(/[\dA-Fa-f]/), cx = bi(/[!-/:-@[-`{-~]/);
function xe(e) {
  return e !== null && e < -2;
}
function Xe(e) {
  return e !== null && (e < 0 || e === 32);
}
function De(e) {
  return e === -2 || e === -1 || e === 32;
}
const Ks = bi(/\p{P}|\p{S}/u), Ht = bi(/\s/);
function bi(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Ue(e, t, n, i) {
  const r = i ? i - 1 : Number.POSITIVE_INFINITY;
  let s = 0;
  return o;
  function o(u) {
    return De(u) ? (e.enter(n), l(u)) : t(u);
  }
  function l(u) {
    return De(u) && s++ < r ? (e.consume(u), l) : (e.exit(n), t(u));
  }
}
const dx = {}.hasOwnProperty, hx = Symbol("continue"), La = Symbol("exit"), px = Symbol("skip");
function fx(e, t) {
  let n, i;
  typeof t == "function" ? n = t : t && typeof t == "object" && (t.enter && (n = t.enter), t.leave && (i = t.leave)), r(e, void 0, void 0, [])();
  function r(s, o, l, u) {
    return Na(s) && (c.displayName = "node (" + s.type + ")"), c;
    function c() {
      const d = n ? ec(n(s, o, l, u)) : [];
      if (d[0] === La)
        return d;
      if (d[0] !== px) {
        let h;
        for (h in s)
          if (dx.call(s, h) && s[h] && typeof s[h] == "object" && // @ts-expect-error: custom esast extension.
          h !== "data" && // @ts-expect-error: custom esast extension.
          h !== "position") {
            const m = u.concat(s), _ = s[h];
            if (Array.isArray(_)) {
              const y = (
                /** @type {Array<unknown>} */
                _
              );
              let v = 0;
              for (; v > -1 && v < y.length; ) {
                const w = y[v];
                if (Na(w)) {
                  const x = r(
                    w,
                    h,
                    v,
                    m
                  )();
                  if (x[0] === La) return x;
                  v = typeof x[1] == "number" ? x[1] : v + 1;
                } else
                  v++;
              }
            } else if (Na(_)) {
              const y = r(_, h, void 0, m)();
              if (y[0] === La) return y;
            }
          }
      }
      return i ? ec(i(s, o, l, u)) : d;
    }
  }
}
function ec(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [hx, e] : [e];
}
function Na(e) {
  return !!(e && typeof e == "object" && "type" in e && typeof e.type == "string" && e.type.length > 0);
}
function Wh(e, t) {
  const n = t.prefix || "", i = t.suffix || "", r = Object.assign({}, t.acornOptions), s = [], o = [], l = r.onComment, u = r.onToken;
  let c = !1, d, h;
  const m = Object.assign({}, r, {
    onComment: s,
    preserveParens: !0
  });
  u && (m.onToken = o);
  const _ = mx(e, t.tokenTypes), y = _.value, v = n + y + i, w = t.expression && tc(y);
  if (w && !t.allowEmpty)
    throw new Qe("Unexpected empty expression", {
      place: A(0),
      ruleId: "unexpected-empty-expression",
      source: "micromark-extension-mdx-expression"
    });
  try {
    d = t.expression && !w ? t.acorn.parseExpressionAt(v, 0, m) : t.acorn.parse(v, m);
  } catch (S) {
    const N = (
      /** @type {AcornError} */
      S
    ), E = A(N.pos);
    N.message = String(N.message).replace(/ \(\d+:\d+\)$/, ""), N.pos = E.offset, N.loc = {
      line: E.line,
      column: E.column - 1
    }, h = N, c = N.raisedAt >= n.length + y.length || // Broken comments are raised at their start, not their end.
    N.message === "Unterminated comment";
  }
  if (d && t.expression && !w)
    if (tc(v.slice(d.end, v.length - i.length)))
      d = {
        type: "Program",
        start: 0,
        end: n.length + y.length,
        // @ts-expect-error: It’s good.
        body: [{
          type: "ExpressionStatement",
          expression: d,
          start: 0,
          end: n.length + y.length
        }],
        sourceType: "module",
        comments: []
      };
    else {
      const S = A(d.end), N = (
        /** @type {AcornError} */
        new Error("Unexpected content after expression")
      );
      N.pos = S.offset, N.loc = {
        line: S.line,
        column: S.column - 1
      }, h = N, d = void 0;
    }
  if (d) {
    if (d.comments = s, fx(d, function(S, N, E, f) {
      let C = (
        /** @type {AcornNode | Array<AcornNode>} */
        f[f.length - 1]
      ), L = N;
      S.type === "ParenthesizedExpression" && C && L && (typeof E == "number" && (C = C[L], L = E), C[L] = S.expression), x(S);
    }), Array.isArray(l))
      l.push(...s);
    else if (typeof l == "function")
      for (const S of s)
        l(S.type === "Block", S.value, S.start, S.end, S.loc.start, S.loc.end);
    for (const S of o)
      S.end <= n.length || S.start - n.length >= y.length || (x(S), Array.isArray(u) ? u.push(S) : u(S));
  }
  return {
    estree: d,
    error: h,
    swallow: c
  };
  function x(S) {
    const N = A(S.start), E = A(S.end);
    S.start = N.offset, S.end = E.offset, S.loc = {
      start: {
        line: N.line,
        column: N.column - 1,
        // @ts-expect-error: not allowed by acorn types.
        offset: N.offset
      },
      end: {
        line: E.line,
        column: E.column - 1,
        // @ts-expect-error: not allowed by acorn types.
        offset: E.offset
      }
    }, S.range = [S.start, S.end];
  }
  function A(S) {
    let N = S - n.length;
    N < 0 ? N = 0 : N > y.length && (N = y.length);
    let E = _x(_.stops, N);
    return E || (E = {
      line: t.start.line,
      column: t.start.column,
      offset: t.start.offset
    }), E;
  }
}
function tc(e) {
  return /^\s*$/.test(e.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/[^\r\n]*(\r\n|\n|\r)/g, ""));
}
function mx(e, t) {
  const n = {
    value: "",
    stops: []
  };
  let i = -1;
  for (; ++i < e.length; ) {
    const r = e[i];
    if (r[0] === "enter") {
      const s = r[1].type;
      if (s === "lineEnding" || t.includes(s)) {
        const o = r[2].sliceStream(r[1]);
        for (; o.length > 0 && o[0] === -1; )
          o.shift();
        const l = gx(o);
        n.stops.push([n.value.length, r[1].start]), n.value += l, n.stops.push([n.value.length, r[1].end]);
      }
    }
  }
  return n;
}
function _x(e, t) {
  let n = 0;
  for (; n < e.length && e[n][0] <= t; )
    n += 1;
  if (n === 0)
    return;
  const [i, r] = e[n - 1], s = t - i;
  return {
    line: r.line,
    column: r.column + s,
    offset: r.offset + s
  };
}
function gx(e) {
  let t = -1;
  const n = [];
  let i;
  for (; ++t < e.length; ) {
    const r = e[t];
    let s;
    if (typeof r == "string")
      s = r;
    else switch (r) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = "	";
        break;
      }
      /* c8 ignore next 6 */
      case -1: {
        if (i) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(r);
    }
    i = r === -2, n.push(s);
  }
  return n.join("");
}
function Zn(e) {
  const t = e || {}, n = t.loc || {}, i = t.range || [void 0, void 0], r = nc(n.start, i[0] || t.start), s = nc(n.end, i[1] || t.end);
  if (r && s)
    return { start: r, end: s };
}
function nc(e, t) {
  if (e && typeof e == "object") {
    const n = "line" in e ? Ta(e.line) : void 0, i = "column" in e ? Ta(e.column) : void 0;
    if (n && i !== void 0)
      return {
        line: n,
        column: i + 1,
        offset: Ta(t)
      };
  }
}
function Ta(e) {
  return typeof e == "number" && e > -1 ? e : void 0;
}
const xx = 2, Yi = "https://github.com/micromark/micromark-extension-mdx-expression/tree/main/packages/micromark-extension-mdx-expression", bx = "#unexpected-end-of-file-in-expression-expected-a-corresponding-closing-brace-for-", yx = "#unexpected-lazy-line-in-expression-in-container-expected-line-to-be-prefixed", ic = "#unexpected-type-in-code-expected-an-object-spread-spread", vx = "#unexpected-extra-content-in-spread-only-a-single-spread-is-supported", wx = "#could-not-parse-expression-with-acorn";
function Os(e, t, n, i, r, s, o, l, u, c, d) {
  const h = this, m = this.events.length + 3;
  let _ = 0, y, v;
  return w;
  function w(N) {
    return e.enter(n), e.enter(i), e.consume(N), e.exit(i), y = h.now(), x;
  }
  function x(N) {
    if (N === null) {
      if (v) throw v;
      const E = new Qe("Unexpected end of file in expression, expected a corresponding closing brace for `{`", {
        place: h.now(),
        ruleId: "unexpected-eof",
        source: "micromark-extension-mdx-expression"
      });
      throw E.url = Yi + bx, E;
    }
    if (xe(N))
      return e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), S;
    if (N === 125 && _ === 0) {
      const E = s ? kx.call(h, s, o, r, m, y, c || !1, u || !1) : {
        type: "ok",
        estree: void 0
      };
      if (E.type === "ok") {
        e.enter(i), e.consume(N), e.exit(i);
        const f = e.exit(n);
        return l && E.estree && Object.assign(f, {
          estree: E.estree
        }), t;
      }
      return v = E.message, e.enter(r), e.consume(N), A;
    }
    return e.enter(r), A(N);
  }
  function A(N) {
    return N === 125 && _ === 0 || N === null || xe(N) ? (e.exit(r), x(N)) : (N === 123 && !s ? _ += 1 : N === 125 && (_ -= 1), e.consume(N), A);
  }
  function S(N) {
    const E = h.now();
    if (E.line !== y.line && !d && h.parser.lazy[E.line]) {
      const f = new Qe("Unexpected lazy line in expression in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", {
        place: h.now(),
        ruleId: "unexpected-lazy",
        source: "micromark-extension-mdx-expression"
      });
      throw f.url = Yi + yx, f;
    }
    return De(N) ? Ue(e, x, "linePrefix", xx + 1)(N) : x(N);
  }
}
function kx(e, t, n, i, r, s, o) {
  const l = Wh(this.events.slice(i), {
    acorn: e,
    tokenTypes: [n],
    acornOptions: t,
    start: r,
    expression: !0,
    allowEmpty: s,
    prefix: o ? "({" : "",
    suffix: o ? "})" : ""
  }), u = l.estree;
  if (o && u) {
    const c = u.body[0];
    if (c.type !== "ExpressionStatement" || c.expression.type !== "ObjectExpression") {
      const d = Zn(c), h = new Qe("Unexpected `" + c.type + "` in code: expected an object spread (`{...spread}`)", {
        place: d.start,
        ruleId: "non-spread",
        source: "micromark-extension-mdx-expression"
      });
      throw h.url = Yi + ic, h;
    }
    if (c.expression.properties[1]) {
      const d = Zn(c.expression.properties[1]), h = new Qe("Unexpected extra content in spread: only a single spread is supported", {
        place: d.start,
        ruleId: "spread-extra",
        source: "micromark-extension-mdx-expression"
      });
      throw h.url = Yi + vx, h;
    }
    if (c.expression.properties[0] && c.expression.properties[0].type !== "SpreadElement") {
      const d = Zn(c.expression.properties[0]), h = new Qe("Unexpected `" + c.expression.properties[0].type + "` in code: only spread elements are supported", {
        place: d.start,
        ruleId: "non-spread",
        source: "micromark-extension-mdx-expression"
      });
      throw h.url = Yi + ic, h;
    }
  }
  if (l.error) {
    const c = new Qe("Could not parse expression with acorn", {
      cause: l.error,
      place: {
        line: l.error.loc.line,
        column: l.error.loc.column + 1,
        offset: l.error.pos
      },
      ruleId: "acorn",
      source: "micromark-extension-mdx-expression"
    });
    return c.url = Yi + wx, {
      type: "nok",
      message: c
    };
  }
  return {
    type: "ok",
    estree: u
  };
}
function Cx(e) {
  const t = e || {}, n = t.addResult, i = t.acorn, r = t.spread;
  let s = t.allowEmpty, o;
  if (s == null && (s = !0), i) {
    if (!i.parseExpressionAt)
      throw new Error("Expected a proper `acorn` instance passed in as `options.acorn`");
    o = Object.assign({
      ecmaVersion: 2024,
      sourceType: "module"
    }, t.acornOptions);
  } else if (t.acornOptions || t.addResult)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  return {
    flow: {
      123: {
        name: "mdxFlowExpression",
        tokenize: l,
        concrete: !0
      }
    },
    text: {
      123: {
        name: "mdxTextExpression",
        tokenize: u
      }
    }
  };
  function l(c, d, h) {
    const m = this;
    return _;
    function _(x) {
      return y(x);
    }
    function y(x) {
      return Os.call(m, c, v, "mdxFlowExpression", "mdxFlowExpressionMarker", "mdxFlowExpressionChunk", i, o, n, r, s)(x);
    }
    function v(x) {
      return De(x) ? Ue(c, w, "whitespace")(x) : w(x);
    }
    function w(x) {
      const A = m.parser.constructs.flow[60], N = (Array.isArray(A) ? A : (
        /* c8 ignore next 3 -- always a list when normalized. */
        A ? [A] : []
      )).find(function(E) {
        return E.name === "mdxJsxFlowTag";
      });
      return x === 60 && N ? c.attempt(N, w, h)(x) : x === null || xe(x) ? d(x) : h(x);
    }
  }
  function u(c, d) {
    const h = this;
    return m;
    function m(_) {
      return Os.call(h, c, d, "mdxTextExpression", "mdxTextExpressionMarker", "mdxTextExpressionChunk", i, o, n, r, s, !0)(_);
    }
  }
}
const rc = "https://github.com/micromark/micromark-extension-mdx-jsx";
function Zh(e, t, n, i, r, s, o, l, u, c, d, h, m, _, y, v, w, x, A, S, N, E, f, C, L, R, V, z, $, H, B, O) {
  const W = this;
  let G, re;
  return K;
  function K(T) {
    return e.enter(l), e.enter(u), e.consume(T), e.exit(u), P;
  }
  function P(T) {
    return Xe(T) ? n(T) : (G = oe, Re(T));
  }
  function oe(T) {
    if (T === 47)
      return e.enter(c), e.consume(T), e.exit(c), G = se, Re;
    if (T === 62)
      return je(T);
    if (T !== null && T >= 0 && xn(T))
      return e.enter(h), e.enter(m), e.consume(T), D;
    Y(T, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (T === 33 ? " (note: to create a comment in MDX, use `{/* text */}`)" : ""));
  }
  function se(T) {
    if (T === 62)
      return je(T);
    if (T !== null && T >= 0 && xn(T))
      return e.enter(h), e.enter(m), e.consume(T), D;
    Y(T, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (T === 42 || T === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function D(T) {
    if (T !== null && T >= 0 && Lr(T, {
      jsx: !0
    }))
      return e.consume(T), D;
    if (T === 46 || T === 47 || T === 58 || T === 62 || T === 123 || Xe(T) || Ht(T))
      return e.exit(m), G = pe, Re(T);
    Y(T, "in name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (T === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function pe(T) {
    if (T === 46)
      return e.enter(_), e.consume(T), e.exit(_), G = Ce, Re;
    if (T === 58)
      return e.enter(v), e.consume(T), e.exit(v), G = ie, Re;
    if (T === 47 || T === 62 || T === 123 || T !== null && T >= 0 && xn(T))
      return e.exit(h), ne(T);
    Y(T, "after name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function Ce(T) {
    if (T !== null && T >= 0 && xn(T))
      return e.enter(y), e.consume(T), Z;
    Y(T, "before member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function Z(T) {
    if (T !== null && T >= 0 && Lr(T, {
      jsx: !0
    }))
      return e.consume(T), Z;
    if (T === 46 || T === 47 || T === 62 || T === 123 || Xe(T) || Ht(T))
      return e.exit(y), G = j, Re(T);
    Y(T, "in member name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (T === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function j(T) {
    if (T === 46)
      return e.enter(_), e.consume(T), e.exit(_), G = Ce, Re;
    if (T === 47 || T === 62 || T === 123 || T !== null && T >= 0 && xn(T))
      return e.exit(h), ne(T);
    Y(T, "after member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function ie(T) {
    if (T !== null && T >= 0 && xn(T))
      return e.enter(w), e.consume(T), te;
    Y(T, "before local name", "a character that can start a name, such as a letter, `$`, or `_`" + (T === 43 || T !== null && T > 46 && T < 58 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function te(T) {
    if (T !== null && T >= 0 && Lr(T, {
      jsx: !0
    }))
      return e.consume(T), te;
    if (T === 47 || T === 62 || T === 123 || Xe(T) || Ht(T))
      return e.exit(w), G = ge, Re(T);
    Y(T, "in local name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function ge(T) {
    if (T === 47 || T === 62 || T === 123 || T !== null && T >= 0 && xn(T))
      return e.exit(h), ne(T);
    Y(T, "after local name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function ne(T) {
    if (T === 47)
      return e.enter(d), e.consume(T), e.exit(d), G = Fe, Re;
    if (T === 62)
      return je(T);
    if (T === 123)
      return Os.call(W, e, _e, x, A, S, i, r, s, !0, !1, o)(T);
    if (T !== null && T >= 0 && xn(T))
      return e.enter(N), e.enter(E), e.enter(f), e.consume(T), Ie;
    Y(T, "before attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function _e(T) {
    return G = ne, Re(T);
  }
  function Ie(T) {
    if (T !== null && T >= 0 && Lr(T, {
      jsx: !0
    }))
      return e.consume(T), Ie;
    if (T === 47 || T === 58 || T === 61 || T === 62 || T === 123 || Xe(T) || Ht(T))
      return e.exit(f), G = Ve, Re(T);
    Y(T, "in attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function Ve(T) {
    if (T === 58)
      return e.enter(C), e.consume(T), e.exit(C), G = nt, Re;
    if (T === 61)
      return e.exit(E), e.enter(R), e.consume(T), e.exit(R), G = Be, Re;
    if (T === 47 || T === 62 || T === 123 || Xe(T) || Ht(T) || T !== null && T >= 0 && xn(T))
      return e.exit(E), e.exit(N), G = ne, Re(T);
    Y(T, "after attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function nt(T) {
    if (T !== null && T >= 0 && xn(T))
      return e.enter(L), e.consume(T), Ke;
    Y(T, "before local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function Ke(T) {
    if (T !== null && T >= 0 && Lr(T, {
      jsx: !0
    }))
      return e.consume(T), Ke;
    if (T === 47 || T === 61 || T === 62 || T === 123 || Xe(T) || Ht(T))
      return e.exit(L), e.exit(E), G = pt, Re(T);
    Y(T, "in local attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function pt(T) {
    if (T === 61)
      return e.enter(R), e.consume(T), e.exit(R), G = Be, Re;
    if (T === 47 || T === 62 || T === 123 || T !== null && T >= 0 && xn(T))
      return e.exit(N), ne(T);
    Y(T, "after local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function Be(T) {
    if (T === 34 || T === 39)
      return e.enter(V), e.enter(z), e.consume(T), e.exit(z), re = T, kt;
    if (T === 123)
      return Os.call(W, e, xt, H, B, O, i, r, s, !1, !1, o)(T);
    Y(T, "before attribute value", "a character that can start an attribute value, such as `\"`, `'`, or `{`" + (T === 60 ? " (note: to use an element or fragment as a prop value in MDX, use `{<element />}`)" : ""));
  }
  function xt(T) {
    return e.exit(N), G = ne, Re(T);
  }
  function kt(T) {
    return T === null && Y(T, "in attribute value", "a corresponding closing quote `" + String.fromCodePoint(re) + "`"), T === re ? (e.enter(z), e.consume(T), e.exit(z), e.exit(V), e.exit(N), re = void 0, G = ne, Re) : xe(T) ? (G = kt, Re(T)) : (e.enter($), ft(T));
  }
  function ft(T) {
    return T === null || T === re || xe(T) ? (e.exit($), kt(T)) : (e.consume(T), ft);
  }
  function Fe(T) {
    if (T === 62)
      return je(T);
    Y(T, "after self-closing slash", "`>` to end the tag" + (T === 42 || T === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function je(T) {
    return e.enter(u), e.consume(T), e.exit(u), e.exit(l), t;
  }
  function Re(T) {
    return xe(T) ? (e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), Q) : De(T) || Ht(T) ? (e.enter("esWhitespace"), on(T)) : G(T);
  }
  function on(T) {
    return xe(T) ? (e.exit("esWhitespace"), Re(T)) : De(T) || Ht(T) ? (e.consume(T), on) : (e.exit("esWhitespace"), G(T));
  }
  function Q(T) {
    if (!o && W.parser.lazy[W.now().line]) {
      const Se = new Qe("Unexpected lazy line in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", W.now(), "micromark-extension-mdx-jsx:unexpected-lazy");
      throw Se.url = rc + "#unexpected-lazy-line-in-container-expected-line-to-be", Se;
    }
    return Re(T);
  }
  function Y(T, Se, He) {
    const ut = new Qe("Unexpected " + (T === null ? "end of file" : "character `" + (T === 96 ? "` ` `" : String.fromCodePoint(T)) + "` (" + Sx(T) + ")") + " " + Se + ", expected " + He, W.now(), "micromark-extension-mdx-jsx:unexpected-" + (T === null ? "eof" : "character"));
    throw ut.url = rc + (T === null ? "#unexpected-end-of-file-at-expected-expect" : "#unexpected-character-at-expected-expect"), ut;
  }
}
function Sx(e) {
  return "U+" + e.toString(16).toUpperCase().padStart(4, "0");
}
function Ex(e, t) {
  return {
    name: "mdxJsxTextTag",
    tokenize: n
  };
  function n(i, r, s) {
    return Zh.call(this, i, r, s, e, t.acornOptions, t.addResult, !0, "mdxJsxTextTag", "mdxJsxTextTagMarker", "mdxJsxTextTagClosingMarker", "mdxJsxTextTagSelfClosingMarker", "mdxJsxTextTagName", "mdxJsxTextTagNamePrimary", "mdxJsxTextTagNameMemberMarker", "mdxJsxTextTagNameMember", "mdxJsxTextTagNamePrefixMarker", "mdxJsxTextTagNameLocal", "mdxJsxTextTagExpressionAttribute", "mdxJsxTextTagExpressionAttributeMarker", "mdxJsxTextTagExpressionAttributeValue", "mdxJsxTextTagAttribute", "mdxJsxTextTagAttributeName", "mdxJsxTextTagAttributeNamePrimary", "mdxJsxTextTagAttributeNamePrefixMarker", "mdxJsxTextTagAttributeNameLocal", "mdxJsxTextTagAttributeInitializerMarker", "mdxJsxTextTagAttributeValueLiteral", "mdxJsxTextTagAttributeValueLiteralMarker", "mdxJsxTextTagAttributeValueLiteralValue", "mdxJsxTextTagAttributeValueExpression", "mdxJsxTextTagAttributeValueExpressionMarker", "mdxJsxTextTagAttributeValueExpressionValue");
  }
}
function Ax(e, t) {
  return {
    concrete: !0,
    name: "mdxJsxFlowTag",
    tokenize: n
  };
  function n(i, r, s) {
    const o = this;
    return l;
    function l(h) {
      return u(h);
    }
    function u(h) {
      return Zh.call(o, i, c, s, e, t.acornOptions, t.addResult, !1, "mdxJsxFlowTag", "mdxJsxFlowTagMarker", "mdxJsxFlowTagClosingMarker", "mdxJsxFlowTagSelfClosingMarker", "mdxJsxFlowTagName", "mdxJsxFlowTagNamePrimary", "mdxJsxFlowTagNameMemberMarker", "mdxJsxFlowTagNameMember", "mdxJsxFlowTagNamePrefixMarker", "mdxJsxFlowTagNameLocal", "mdxJsxFlowTagExpressionAttribute", "mdxJsxFlowTagExpressionAttributeMarker", "mdxJsxFlowTagExpressionAttributeValue", "mdxJsxFlowTagAttribute", "mdxJsxFlowTagAttributeName", "mdxJsxFlowTagAttributeNamePrimary", "mdxJsxFlowTagAttributeNamePrefixMarker", "mdxJsxFlowTagAttributeNameLocal", "mdxJsxFlowTagAttributeInitializerMarker", "mdxJsxFlowTagAttributeValueLiteral", "mdxJsxFlowTagAttributeValueLiteralMarker", "mdxJsxFlowTagAttributeValueLiteralValue", "mdxJsxFlowTagAttributeValueExpression", "mdxJsxFlowTagAttributeValueExpressionMarker", "mdxJsxFlowTagAttributeValueExpressionValue")(h);
    }
    function c(h) {
      return De(h) ? Ue(i, d, "whitespace")(h) : d(h);
    }
    function d(h) {
      const m = o.parser.constructs.flow[123], _ = Array.isArray(m) ? m : m ? [m] : [];
      let y;
      for (const v of _)
        if (v.name === "mdxFlowExpression") {
          y = v;
          break;
        }
      return h === 60 ? (
        // We can’t just say: fine. Lines of blocks have to be parsed until an eol/eof.
        l(h)
      ) : h === 123 && y ? i.attempt(y, d, s)(h) : h === null || xe(h) ? r(h) : s(h);
    }
  }
}
function Ix(e) {
  const t = e || {}, n = t.acorn;
  let i;
  if (n) {
    if (!n.parse || !n.parseExpressionAt)
      throw new Error("Expected a proper `acorn` instance passed in as `options.acorn`");
    i = Object.assign({
      ecmaVersion: 2024,
      sourceType: "module"
    }, t.acornOptions, {
      locations: !0
    });
  } else if (t.acornOptions || t.addResult)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  return {
    flow: {
      60: Ax(n || void 0, {
        acornOptions: i,
        addResult: t.addResult || void 0
      })
    },
    text: {
      60: Ex(n || void 0, {
        acornOptions: i,
        addResult: t.addResult || void 0
      })
    }
  };
}
function Lx() {
  return {
    disable: { null: ["autolink", "codeIndented", "htmlFlow", "htmlText"] }
  };
}
function an(e, t, n, i) {
  const r = e.length;
  let s = 0, o;
  if (t < 0 ? t = -t > r ? 0 : r + t : t = t > r ? r : t, n = n > 0 ? n : 0, i.length < 1e4)
    o = Array.from(i), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); s < i.length; )
      o = i.slice(s, s + 1e4), o.unshift(t, 0), e.splice(...o), s += 1e4, t += 1e4;
}
function fn(e, t) {
  return e.length > 0 ? (an(e, e.length, 0, t), e) : t;
}
function ir(e) {
  if (e === null || Xe(e) || Ht(e))
    return 1;
  if (Ks(e))
    return 2;
}
function Ys(e, t, n) {
  const i = [];
  let r = -1;
  for (; ++r < e.length; ) {
    const s = e[r].resolveAll;
    s && !i.includes(s) && (t = s(t, n), i.push(s));
  }
  return t;
}
const So = {
  name: "attention",
  resolveAll: Nx,
  tokenize: Tx
};
function Nx(e, t) {
  let n = -1, i, r, s, o, l, u, c, d;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (i = n; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        t.sliceSerialize(e[i][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const h = {
            ...e[i][1].end
          }, m = {
            ...e[n][1].start
          };
          sc(h, -u), sc(m, u), o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: h,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: m
          }, s = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, r = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...o.start
          }, e[n][1].start = {
            ...l.end
          }, c = [], e[i][1].end.offset - e[i][1].start.offset && (c = fn(c, [["enter", e[i][1], t], ["exit", e[i][1], t]])), c = fn(c, [["enter", r, t], ["enter", o, t], ["exit", o, t], ["enter", s, t]]), c = fn(c, Ys(t.parser.constructs.insideSpan.null, e.slice(i + 1, n), t)), c = fn(c, [["exit", s, t], ["enter", l, t], ["exit", l, t], ["exit", r, t]]), e[n][1].end.offset - e[n][1].start.offset ? (d = 2, c = fn(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : d = 0, an(e, i - 1, n - i + 3, c), n = i + c.length - d - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function Tx(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, i = this.previous, r = ir(i);
  let s;
  return o;
  function o(u) {
    return s = u, e.enter("attentionSequence"), l(u);
  }
  function l(u) {
    if (u === s)
      return e.consume(u), l;
    const c = e.exit("attentionSequence"), d = ir(u), h = !d || d === 2 && r || n.includes(u), m = !r || r === 2 && d || n.includes(i);
    return c._open = !!(s === 42 ? h : h && (r || !m)), c._close = !!(s === 42 ? m : m && (d || !h)), t(u);
  }
}
function sc(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const Px = {
  name: "autolink",
  tokenize: Dx
};
function Dx(e, t, n) {
  let i = 0;
  return r;
  function r(_) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(_), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), s;
  }
  function s(_) {
    return Ot(_) ? (e.consume(_), o) : _ === 64 ? n(_) : c(_);
  }
  function o(_) {
    return _ === 43 || _ === 45 || _ === 46 || Bt(_) ? (i = 1, l(_)) : c(_);
  }
  function l(_) {
    return _ === 58 ? (e.consume(_), i = 0, u) : (_ === 43 || _ === 45 || _ === 46 || Bt(_)) && i++ < 32 ? (e.consume(_), l) : (i = 0, c(_));
  }
  function u(_) {
    return _ === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(_), e.exit("autolinkMarker"), e.exit("autolink"), t) : _ === null || _ === 32 || _ === 60 || Rs(_) ? n(_) : (e.consume(_), u);
  }
  function c(_) {
    return _ === 64 ? (e.consume(_), d) : lx(_) ? (e.consume(_), c) : n(_);
  }
  function d(_) {
    return Bt(_) ? h(_) : n(_);
  }
  function h(_) {
    return _ === 46 ? (e.consume(_), i = 0, d) : _ === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(_), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(_);
  }
  function m(_) {
    if ((_ === 45 || Bt(_)) && i++ < 63) {
      const y = _ === 45 ? m : h;
      return e.consume(_), y;
    }
    return n(_);
  }
}
const mr = {
  partial: !0,
  tokenize: Mx
};
function Mx(e, t, n) {
  return i;
  function i(s) {
    return De(s) ? Ue(e, r, "linePrefix")(s) : r(s);
  }
  function r(s) {
    return s === null || xe(s) ? t(s) : n(s);
  }
}
const Xh = {
  continuation: {
    tokenize: Fx
  },
  exit: Rx,
  name: "blockQuote",
  tokenize: Vx
};
function Vx(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    if (o === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), s;
    }
    return n(o);
  }
  function s(o) {
    return De(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function Fx(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return De(o) ? Ue(e, s, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : s(o);
  }
  function s(o) {
    return e.attempt(Xh, t, n)(o);
  }
}
function Rx(e) {
  e.exit("blockQuote");
}
const Gh = {
  name: "characterEscape",
  tokenize: Ox
};
function Ox(e, t, n) {
  return i;
  function i(s) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(s), e.exit("escapeMarker"), r;
  }
  function r(s) {
    return cx(s) ? (e.enter("characterEscapeValue"), e.consume(s), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(s);
  }
}
const Kh = {
  name: "characterReference",
  tokenize: Bx
};
function Bx(e, t, n) {
  const i = this;
  let r = 0, s, o;
  return l;
  function l(h) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), u;
  }
  function u(h) {
    return h === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(h), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), s = 31, o = Bt, d(h));
  }
  function c(h) {
    return h === 88 || h === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(h), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), s = 6, o = ux, d) : (e.enter("characterReferenceValue"), s = 7, o = Co, d(h));
  }
  function d(h) {
    if (h === 59 && r) {
      const m = e.exit("characterReferenceValue");
      return o === Bt && !qr(i.sliceSerialize(m)) ? n(h) : (e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(h) && r++ < s ? (e.consume(h), d) : n(h);
  }
}
const ac = {
  partial: !0,
  tokenize: jx
}, oc = {
  concrete: !0,
  name: "codeFenced",
  tokenize: zx
};
function zx(e, t, n) {
  const i = this, r = {
    partial: !0,
    tokenize: E
  };
  let s = 0, o = 0, l;
  return u;
  function u(f) {
    return c(f);
  }
  function c(f) {
    const C = i.events[i.events.length - 1];
    return s = C && C[1].type === "linePrefix" ? C[2].sliceSerialize(C[1], !0).length : 0, l = f, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(f);
  }
  function d(f) {
    return f === l ? (o++, e.consume(f), d) : o < 3 ? n(f) : (e.exit("codeFencedFenceSequence"), De(f) ? Ue(e, h, "whitespace")(f) : h(f));
  }
  function h(f) {
    return f === null || xe(f) ? (e.exit("codeFencedFence"), i.interrupt ? t(f) : e.check(ac, v, N)(f)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), m(f));
  }
  function m(f) {
    return f === null || xe(f) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), h(f)) : De(f) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Ue(e, _, "whitespace")(f)) : f === 96 && f === l ? n(f) : (e.consume(f), m);
  }
  function _(f) {
    return f === null || xe(f) ? h(f) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), y(f));
  }
  function y(f) {
    return f === null || xe(f) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), h(f)) : f === 96 && f === l ? n(f) : (e.consume(f), y);
  }
  function v(f) {
    return e.attempt(r, N, w)(f);
  }
  function w(f) {
    return e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), x;
  }
  function x(f) {
    return s > 0 && De(f) ? Ue(e, A, "linePrefix", s + 1)(f) : A(f);
  }
  function A(f) {
    return f === null || xe(f) ? e.check(ac, v, N)(f) : (e.enter("codeFlowValue"), S(f));
  }
  function S(f) {
    return f === null || xe(f) ? (e.exit("codeFlowValue"), A(f)) : (e.consume(f), S);
  }
  function N(f) {
    return e.exit("codeFenced"), t(f);
  }
  function E(f, C, L) {
    let R = 0;
    return V;
    function V(O) {
      return f.enter("lineEnding"), f.consume(O), f.exit("lineEnding"), z;
    }
    function z(O) {
      return f.enter("codeFencedFence"), De(O) ? Ue(f, $, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(O) : $(O);
    }
    function $(O) {
      return O === l ? (f.enter("codeFencedFenceSequence"), H(O)) : L(O);
    }
    function H(O) {
      return O === l ? (R++, f.consume(O), H) : R >= o ? (f.exit("codeFencedFenceSequence"), De(O) ? Ue(f, B, "whitespace")(O) : B(O)) : L(O);
    }
    function B(O) {
      return O === null || xe(O) ? (f.exit("codeFencedFence"), C(O)) : L(O);
    }
  }
}
function jx(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), s);
  }
  function s(o) {
    return i.parser.lazy[i.now().line] ? n(o) : t(o);
  }
}
const Pa = {
  name: "codeIndented",
  tokenize: Hx
}, $x = {
  partial: !0,
  tokenize: Ux
};
function Hx(e, t, n) {
  const i = this;
  return r;
  function r(c) {
    return e.enter("codeIndented"), Ue(e, s, "linePrefix", 5)(c);
  }
  function s(c) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? o(c) : n(c);
  }
  function o(c) {
    return c === null ? u(c) : xe(c) ? e.attempt($x, o, u)(c) : (e.enter("codeFlowValue"), l(c));
  }
  function l(c) {
    return c === null || xe(c) ? (e.exit("codeFlowValue"), o(c)) : (e.consume(c), l);
  }
  function u(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function Ux(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return i.parser.lazy[i.now().line] ? n(o) : xe(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), r) : Ue(e, s, "linePrefix", 5)(o);
  }
  function s(o) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(o) : xe(o) ? r(o) : n(o);
  }
}
const qx = {
  name: "codeText",
  previous: Wx,
  resolve: Jx,
  tokenize: Zx
};
function Jx(e) {
  let t = e.length - 4, n = 3, i, r;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (i = n; ++i < t; )
      if (e[i][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (i = n - 1, t++; ++i <= t; )
    r === void 0 ? i !== t && e[i][1].type !== "lineEnding" && (r = i) : (i === t || e[i][1].type === "lineEnding") && (e[r][1].type = "codeTextData", i !== r + 2 && (e[r][1].end = e[i - 1][1].end, e.splice(r + 2, i - r - 2), t -= i - r - 2, i = r + 2), r = void 0);
  return e;
}
function Wx(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Zx(e, t, n) {
  let i = 0, r, s;
  return o;
  function o(h) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(h);
  }
  function l(h) {
    return h === 96 ? (e.consume(h), i++, l) : (e.exit("codeTextSequence"), u(h));
  }
  function u(h) {
    return h === null ? n(h) : h === 32 ? (e.enter("space"), e.consume(h), e.exit("space"), u) : h === 96 ? (s = e.enter("codeTextSequence"), r = 0, d(h)) : xe(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), u) : (e.enter("codeTextData"), c(h));
  }
  function c(h) {
    return h === null || h === 32 || h === 96 || xe(h) ? (e.exit("codeTextData"), u(h)) : (e.consume(h), c);
  }
  function d(h) {
    return h === 96 ? (e.consume(h), r++, d) : r === i ? (e.exit("codeTextSequence"), e.exit("codeText"), t(h)) : (s.type = "codeTextData", c(h));
  }
}
class Xx {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const i = n ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(t, i) : t > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, i) {
    const r = n || 0;
    this.setCursor(Math.trunc(t));
    const s = this.right.splice(this.right.length - r, Number.POSITIVE_INFINITY);
    return i && Pr(this.left, i), s.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Pr(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Pr(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Pr(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Pr(this.left, n.reverse());
      }
  }
}
function Pr(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Yh(e) {
  const t = {};
  let n = -1, i, r, s, o, l, u, c;
  const d = new Xx(e);
  for (; ++n < d.length; ) {
    for (; n in t; )
      n = t[n];
    if (i = d.get(n), n && i[1].type === "chunkFlow" && d.get(n - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, s = 0, s < u.length && u[s][1].type === "lineEndingBlank" && (s += 2), s < u.length && u[s][1].type === "content"))
      for (; ++s < u.length && u[s][1].type !== "content"; )
        u[s][1].type === "chunkText" && (u[s][1]._isInFirstContentOfListItem = !0, s++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(t, Gx(d, n)), n = t[n], c = !0);
    else if (i[1]._container) {
      for (s = n, r = void 0; s--; )
        if (o = d.get(s), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (r && (d.get(r)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", r = s);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      r && (i[1].end = {
        ...d.get(r)[1].start
      }, l = d.slice(r, n), l.unshift(i), d.splice(r, n - r + 1, l));
    }
  }
  return an(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !c;
}
function Gx(e, t) {
  const n = e.get(t)[1], i = e.get(t)[2];
  let r = t - 1;
  const s = [];
  let o = n._tokenizer;
  o || (o = i.parser[n.contentType](n.start), n._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const l = o.events, u = [], c = {};
  let d, h, m = -1, _ = n, y = 0, v = 0;
  const w = [v];
  for (; _; ) {
    for (; e.get(++r)[1] !== _; )
      ;
    s.push(r), _._tokenizer || (d = i.sliceStream(_), _.next || d.push(null), h && o.defineSkip(_.start), _._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(d), _._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), h = _, _ = _.next;
  }
  for (_ = n; ++m < l.length; )
    // Find a void token that includes a break.
    l[m][0] === "exit" && l[m - 1][0] === "enter" && l[m][1].type === l[m - 1][1].type && l[m][1].start.line !== l[m][1].end.line && (v = m + 1, w.push(v), _._tokenizer = void 0, _.previous = void 0, _ = _.next);
  for (o.events = [], _ ? (_._tokenizer = void 0, _.previous = void 0) : w.pop(), m = w.length; m--; ) {
    const x = l.slice(w[m], w[m + 1]), A = s.pop();
    u.push([A, A + x.length - 1]), e.splice(A, 2, x);
  }
  for (u.reverse(), m = -1; ++m < u.length; )
    c[y + u[m][0]] = y + u[m][1], y += u[m][1] - u[m][0] - 1;
  return c;
}
const Kx = {
  resolve: Qx,
  tokenize: eb
}, Yx = {
  partial: !0,
  tokenize: tb
};
function Qx(e) {
  return Yh(e), e;
}
function eb(e, t) {
  let n;
  return i;
  function i(l) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), r(l);
  }
  function r(l) {
    return l === null ? s(l) : xe(l) ? e.check(Yx, o, s)(l) : (e.consume(l), r);
  }
  function s(l) {
    return e.exit("chunkContent"), e.exit("content"), t(l);
  }
  function o(l) {
    return e.consume(l), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, r;
  }
}
function tb(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), Ue(e, s, "linePrefix");
  }
  function s(o) {
    if (o === null || xe(o))
      return n(o);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? t(o) : e.interrupt(i.parser.constructs.flow, n, t)(o);
  }
}
function Qh(e, t, n, i, r, s, o, l, u) {
  const c = u || Number.POSITIVE_INFINITY;
  let d = 0;
  return h;
  function h(x) {
    return x === 60 ? (e.enter(i), e.enter(r), e.enter(s), e.consume(x), e.exit(s), m) : x === null || x === 32 || x === 41 || Rs(x) ? n(x) : (e.enter(i), e.enter(o), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(x));
  }
  function m(x) {
    return x === 62 ? (e.enter(s), e.consume(x), e.exit(s), e.exit(r), e.exit(i), t) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), _(x));
  }
  function _(x) {
    return x === 62 ? (e.exit("chunkString"), e.exit(l), m(x)) : x === null || x === 60 || xe(x) ? n(x) : (e.consume(x), x === 92 ? y : _);
  }
  function y(x) {
    return x === 60 || x === 62 || x === 92 ? (e.consume(x), _) : _(x);
  }
  function v(x) {
    return !d && (x === null || x === 41 || Xe(x)) ? (e.exit("chunkString"), e.exit(l), e.exit(o), e.exit(i), t(x)) : d < c && x === 40 ? (e.consume(x), d++, v) : x === 41 ? (e.consume(x), d--, v) : x === null || x === 32 || x === 40 || Rs(x) ? n(x) : (e.consume(x), x === 92 ? w : v);
  }
  function w(x) {
    return x === 40 || x === 41 || x === 92 ? (e.consume(x), v) : v(x);
  }
}
function ep(e, t, n, i, r, s) {
  const o = this;
  let l = 0, u;
  return c;
  function c(_) {
    return e.enter(i), e.enter(r), e.consume(_), e.exit(r), e.enter(s), d;
  }
  function d(_) {
    return l > 999 || _ === null || _ === 91 || _ === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    _ === 94 && !l && "_hiddenFootnoteSupport" in o.parser.constructs ? n(_) : _ === 93 ? (e.exit(s), e.enter(r), e.consume(_), e.exit(r), e.exit(i), t) : xe(_) ? (e.enter("lineEnding"), e.consume(_), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), h(_));
  }
  function h(_) {
    return _ === null || _ === 91 || _ === 93 || xe(_) || l++ > 999 ? (e.exit("chunkString"), d(_)) : (e.consume(_), u || (u = !De(_)), _ === 92 ? m : h);
  }
  function m(_) {
    return _ === 91 || _ === 92 || _ === 93 ? (e.consume(_), l++, h) : h(_);
  }
}
function tp(e, t, n, i, r, s) {
  let o;
  return l;
  function l(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(i), e.enter(r), e.consume(m), e.exit(r), o = m === 40 ? 41 : m, u) : n(m);
  }
  function u(m) {
    return m === o ? (e.enter(r), e.consume(m), e.exit(r), e.exit(i), t) : (e.enter(s), c(m));
  }
  function c(m) {
    return m === o ? (e.exit(s), u(o)) : m === null ? n(m) : xe(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), Ue(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(m));
  }
  function d(m) {
    return m === o || m === null || xe(m) ? (e.exit("chunkString"), c(m)) : (e.consume(m), m === 92 ? h : d);
  }
  function h(m) {
    return m === o || m === 92 ? (e.consume(m), d) : d(m);
  }
}
function $r(e, t) {
  let n;
  return i;
  function i(r) {
    return xe(r) ? (e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), n = !0, i) : De(r) ? Ue(e, i, n ? "linePrefix" : "lineSuffix")(r) : t(r);
  }
}
function wn(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const nb = {
  name: "definition",
  tokenize: rb
}, ib = {
  partial: !0,
  tokenize: sb
};
function rb(e, t, n) {
  const i = this;
  let r;
  return s;
  function s(_) {
    return e.enter("definition"), o(_);
  }
  function o(_) {
    return ep.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(_);
  }
  function l(_) {
    return r = wn(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), _ === 58 ? (e.enter("definitionMarker"), e.consume(_), e.exit("definitionMarker"), u) : n(_);
  }
  function u(_) {
    return Xe(_) ? $r(e, c)(_) : c(_);
  }
  function c(_) {
    return Qh(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(_);
  }
  function d(_) {
    return e.attempt(ib, h, h)(_);
  }
  function h(_) {
    return De(_) ? Ue(e, m, "whitespace")(_) : m(_);
  }
  function m(_) {
    return _ === null || xe(_) ? (e.exit("definition"), i.parser.defined.push(r), t(_)) : n(_);
  }
}
function sb(e, t, n) {
  return i;
  function i(l) {
    return Xe(l) ? $r(e, r)(l) : n(l);
  }
  function r(l) {
    return tp(e, s, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function s(l) {
    return De(l) ? Ue(e, o, "whitespace")(l) : o(l);
  }
  function o(l) {
    return l === null || xe(l) ? t(l) : n(l);
  }
}
const ab = {
  name: "hardBreakEscape",
  tokenize: ob
};
function ob(e, t, n) {
  return i;
  function i(s) {
    return e.enter("hardBreakEscape"), e.consume(s), r;
  }
  function r(s) {
    return xe(s) ? (e.exit("hardBreakEscape"), t(s)) : n(s);
  }
}
const lb = {
  name: "headingAtx",
  resolve: ub,
  tokenize: cb
};
function ub(e, t) {
  let n = e.length - 2, i = 3, r, s;
  return e[i][1].type === "whitespace" && (i += 2), n - 2 > i && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (i === n - 1 || n - 4 > i && e[n - 2][1].type === "whitespace") && (n -= i + 1 === n ? 2 : 4), n > i && (r = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[n][1].end
  }, s = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, an(e, i, n - i + 1, [["enter", r, t], ["enter", s, t], ["exit", s, t], ["exit", r, t]])), e;
}
function cb(e, t, n) {
  let i = 0;
  return r;
  function r(d) {
    return e.enter("atxHeading"), s(d);
  }
  function s(d) {
    return e.enter("atxHeadingSequence"), o(d);
  }
  function o(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), o) : d === null || Xe(d) ? (e.exit("atxHeadingSequence"), l(d)) : n(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), u(d)) : d === null || xe(d) ? (e.exit("atxHeading"), t(d)) : De(d) ? Ue(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), c(d));
  }
  function u(d) {
    return d === 35 ? (e.consume(d), u) : (e.exit("atxHeadingSequence"), l(d));
  }
  function c(d) {
    return d === null || d === 35 || Xe(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), c);
  }
}
const db = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], lc = ["pre", "script", "style", "textarea"], hb = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: mb,
  tokenize: _b
}, pb = {
  partial: !0,
  tokenize: xb
}, fb = {
  partial: !0,
  tokenize: gb
};
function mb(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function _b(e, t, n) {
  const i = this;
  let r, s, o, l, u;
  return c;
  function c(D) {
    return d(D);
  }
  function d(D) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(D), h;
  }
  function h(D) {
    return D === 33 ? (e.consume(D), m) : D === 47 ? (e.consume(D), s = !0, v) : D === 63 ? (e.consume(D), r = 3, i.interrupt ? t : P) : Ot(D) ? (e.consume(D), o = String.fromCharCode(D), w) : n(D);
  }
  function m(D) {
    return D === 45 ? (e.consume(D), r = 2, _) : D === 91 ? (e.consume(D), r = 5, l = 0, y) : Ot(D) ? (e.consume(D), r = 4, i.interrupt ? t : P) : n(D);
  }
  function _(D) {
    return D === 45 ? (e.consume(D), i.interrupt ? t : P) : n(D);
  }
  function y(D) {
    const pe = "CDATA[";
    return D === pe.charCodeAt(l++) ? (e.consume(D), l === pe.length ? i.interrupt ? t : $ : y) : n(D);
  }
  function v(D) {
    return Ot(D) ? (e.consume(D), o = String.fromCharCode(D), w) : n(D);
  }
  function w(D) {
    if (D === null || D === 47 || D === 62 || Xe(D)) {
      const pe = D === 47, Ce = o.toLowerCase();
      return !pe && !s && lc.includes(Ce) ? (r = 1, i.interrupt ? t(D) : $(D)) : db.includes(o.toLowerCase()) ? (r = 6, pe ? (e.consume(D), x) : i.interrupt ? t(D) : $(D)) : (r = 7, i.interrupt && !i.parser.lazy[i.now().line] ? n(D) : s ? A(D) : S(D));
    }
    return D === 45 || Bt(D) ? (e.consume(D), o += String.fromCharCode(D), w) : n(D);
  }
  function x(D) {
    return D === 62 ? (e.consume(D), i.interrupt ? t : $) : n(D);
  }
  function A(D) {
    return De(D) ? (e.consume(D), A) : V(D);
  }
  function S(D) {
    return D === 47 ? (e.consume(D), V) : D === 58 || D === 95 || Ot(D) ? (e.consume(D), N) : De(D) ? (e.consume(D), S) : V(D);
  }
  function N(D) {
    return D === 45 || D === 46 || D === 58 || D === 95 || Bt(D) ? (e.consume(D), N) : E(D);
  }
  function E(D) {
    return D === 61 ? (e.consume(D), f) : De(D) ? (e.consume(D), E) : S(D);
  }
  function f(D) {
    return D === null || D === 60 || D === 61 || D === 62 || D === 96 ? n(D) : D === 34 || D === 39 ? (e.consume(D), u = D, C) : De(D) ? (e.consume(D), f) : L(D);
  }
  function C(D) {
    return D === u ? (e.consume(D), u = null, R) : D === null || xe(D) ? n(D) : (e.consume(D), C);
  }
  function L(D) {
    return D === null || D === 34 || D === 39 || D === 47 || D === 60 || D === 61 || D === 62 || D === 96 || Xe(D) ? E(D) : (e.consume(D), L);
  }
  function R(D) {
    return D === 47 || D === 62 || De(D) ? S(D) : n(D);
  }
  function V(D) {
    return D === 62 ? (e.consume(D), z) : n(D);
  }
  function z(D) {
    return D === null || xe(D) ? $(D) : De(D) ? (e.consume(D), z) : n(D);
  }
  function $(D) {
    return D === 45 && r === 2 ? (e.consume(D), W) : D === 60 && r === 1 ? (e.consume(D), G) : D === 62 && r === 4 ? (e.consume(D), oe) : D === 63 && r === 3 ? (e.consume(D), P) : D === 93 && r === 5 ? (e.consume(D), K) : xe(D) && (r === 6 || r === 7) ? (e.exit("htmlFlowData"), e.check(pb, se, H)(D)) : D === null || xe(D) ? (e.exit("htmlFlowData"), H(D)) : (e.consume(D), $);
  }
  function H(D) {
    return e.check(fb, B, se)(D);
  }
  function B(D) {
    return e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), O;
  }
  function O(D) {
    return D === null || xe(D) ? H(D) : (e.enter("htmlFlowData"), $(D));
  }
  function W(D) {
    return D === 45 ? (e.consume(D), P) : $(D);
  }
  function G(D) {
    return D === 47 ? (e.consume(D), o = "", re) : $(D);
  }
  function re(D) {
    if (D === 62) {
      const pe = o.toLowerCase();
      return lc.includes(pe) ? (e.consume(D), oe) : $(D);
    }
    return Ot(D) && o.length < 8 ? (e.consume(D), o += String.fromCharCode(D), re) : $(D);
  }
  function K(D) {
    return D === 93 ? (e.consume(D), P) : $(D);
  }
  function P(D) {
    return D === 62 ? (e.consume(D), oe) : D === 45 && r === 2 ? (e.consume(D), P) : $(D);
  }
  function oe(D) {
    return D === null || xe(D) ? (e.exit("htmlFlowData"), se(D)) : (e.consume(D), oe);
  }
  function se(D) {
    return e.exit("htmlFlow"), t(D);
  }
}
function gb(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return xe(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), s) : n(o);
  }
  function s(o) {
    return i.parser.lazy[i.now().line] ? n(o) : t(o);
  }
}
function xb(e, t, n) {
  return i;
  function i(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), e.attempt(mr, t, n);
  }
}
const bb = {
  name: "htmlText",
  tokenize: yb
};
function yb(e, t, n) {
  const i = this;
  let r, s, o;
  return l;
  function l(P) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(P), u;
  }
  function u(P) {
    return P === 33 ? (e.consume(P), c) : P === 47 ? (e.consume(P), E) : P === 63 ? (e.consume(P), S) : Ot(P) ? (e.consume(P), L) : n(P);
  }
  function c(P) {
    return P === 45 ? (e.consume(P), d) : P === 91 ? (e.consume(P), s = 0, y) : Ot(P) ? (e.consume(P), A) : n(P);
  }
  function d(P) {
    return P === 45 ? (e.consume(P), _) : n(P);
  }
  function h(P) {
    return P === null ? n(P) : P === 45 ? (e.consume(P), m) : xe(P) ? (o = h, G(P)) : (e.consume(P), h);
  }
  function m(P) {
    return P === 45 ? (e.consume(P), _) : h(P);
  }
  function _(P) {
    return P === 62 ? W(P) : P === 45 ? m(P) : h(P);
  }
  function y(P) {
    const oe = "CDATA[";
    return P === oe.charCodeAt(s++) ? (e.consume(P), s === oe.length ? v : y) : n(P);
  }
  function v(P) {
    return P === null ? n(P) : P === 93 ? (e.consume(P), w) : xe(P) ? (o = v, G(P)) : (e.consume(P), v);
  }
  function w(P) {
    return P === 93 ? (e.consume(P), x) : v(P);
  }
  function x(P) {
    return P === 62 ? W(P) : P === 93 ? (e.consume(P), x) : v(P);
  }
  function A(P) {
    return P === null || P === 62 ? W(P) : xe(P) ? (o = A, G(P)) : (e.consume(P), A);
  }
  function S(P) {
    return P === null ? n(P) : P === 63 ? (e.consume(P), N) : xe(P) ? (o = S, G(P)) : (e.consume(P), S);
  }
  function N(P) {
    return P === 62 ? W(P) : S(P);
  }
  function E(P) {
    return Ot(P) ? (e.consume(P), f) : n(P);
  }
  function f(P) {
    return P === 45 || Bt(P) ? (e.consume(P), f) : C(P);
  }
  function C(P) {
    return xe(P) ? (o = C, G(P)) : De(P) ? (e.consume(P), C) : W(P);
  }
  function L(P) {
    return P === 45 || Bt(P) ? (e.consume(P), L) : P === 47 || P === 62 || Xe(P) ? R(P) : n(P);
  }
  function R(P) {
    return P === 47 ? (e.consume(P), W) : P === 58 || P === 95 || Ot(P) ? (e.consume(P), V) : xe(P) ? (o = R, G(P)) : De(P) ? (e.consume(P), R) : W(P);
  }
  function V(P) {
    return P === 45 || P === 46 || P === 58 || P === 95 || Bt(P) ? (e.consume(P), V) : z(P);
  }
  function z(P) {
    return P === 61 ? (e.consume(P), $) : xe(P) ? (o = z, G(P)) : De(P) ? (e.consume(P), z) : R(P);
  }
  function $(P) {
    return P === null || P === 60 || P === 61 || P === 62 || P === 96 ? n(P) : P === 34 || P === 39 ? (e.consume(P), r = P, H) : xe(P) ? (o = $, G(P)) : De(P) ? (e.consume(P), $) : (e.consume(P), B);
  }
  function H(P) {
    return P === r ? (e.consume(P), r = void 0, O) : P === null ? n(P) : xe(P) ? (o = H, G(P)) : (e.consume(P), H);
  }
  function B(P) {
    return P === null || P === 34 || P === 39 || P === 60 || P === 61 || P === 96 ? n(P) : P === 47 || P === 62 || Xe(P) ? R(P) : (e.consume(P), B);
  }
  function O(P) {
    return P === 47 || P === 62 || Xe(P) ? R(P) : n(P);
  }
  function W(P) {
    return P === 62 ? (e.consume(P), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(P);
  }
  function G(P) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(P), e.exit("lineEnding"), re;
  }
  function re(P) {
    return De(P) ? Ue(e, K, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(P) : K(P);
  }
  function K(P) {
    return e.enter("htmlTextData"), o(P);
  }
}
const ol = {
  name: "labelEnd",
  resolveAll: Cb,
  resolveTo: Sb,
  tokenize: Eb
}, vb = {
  tokenize: Ab
}, wb = {
  tokenize: Ib
}, kb = {
  tokenize: Lb
};
function Cb(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const i = e[t][1];
    if (n.push(e[t]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const r = i.type === "labelImage" ? 4 : 2;
      i.type = "data", t += r;
    }
  }
  return e.length !== n.length && an(e, 0, e.length, n), e;
}
function Sb(e, t) {
  let n = e.length, i = 0, r, s, o, l;
  for (; n--; )
    if (r = e[n][1], s) {
      if (r.type === "link" || r.type === "labelLink" && r._inactive)
        break;
      e[n][0] === "enter" && r.type === "labelLink" && (r._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (r.type === "labelImage" || r.type === "labelLink") && !r._balanced && (s = n, r.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else r.type === "labelEnd" && (o = n);
  const u = {
    type: e[s][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[s][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, c = {
    type: "label",
    start: {
      ...e[s][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, d = {
    type: "labelText",
    start: {
      ...e[s + i + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return l = [["enter", u, t], ["enter", c, t]], l = fn(l, e.slice(s + 1, s + i + 3)), l = fn(l, [["enter", d, t]]), l = fn(l, Ys(t.parser.constructs.insideSpan.null, e.slice(s + i + 4, o - 3), t)), l = fn(l, [["exit", d, t], e[o - 2], e[o - 1], ["exit", c, t]]), l = fn(l, e.slice(o + 1)), l = fn(l, [["exit", u, t]]), an(e, s, e.length, l), e;
}
function Eb(e, t, n) {
  const i = this;
  let r = i.events.length, s, o;
  for (; r--; )
    if ((i.events[r][1].type === "labelImage" || i.events[r][1].type === "labelLink") && !i.events[r][1]._balanced) {
      s = i.events[r][1];
      break;
    }
  return l;
  function l(m) {
    return s ? s._inactive ? h(m) : (o = i.parser.defined.includes(wn(i.sliceSerialize({
      start: s.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(m);
  }
  function u(m) {
    return m === 40 ? e.attempt(vb, d, o ? d : h)(m) : m === 91 ? e.attempt(wb, d, o ? c : h)(m) : o ? d(m) : h(m);
  }
  function c(m) {
    return e.attempt(kb, d, h)(m);
  }
  function d(m) {
    return t(m);
  }
  function h(m) {
    return s._balanced = !0, n(m);
  }
}
function Ab(e, t, n) {
  return i;
  function i(h) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), r;
  }
  function r(h) {
    return Xe(h) ? $r(e, s)(h) : s(h);
  }
  function s(h) {
    return h === 41 ? d(h) : Qh(e, o, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(h);
  }
  function o(h) {
    return Xe(h) ? $r(e, u)(h) : d(h);
  }
  function l(h) {
    return n(h);
  }
  function u(h) {
    return h === 34 || h === 39 || h === 40 ? tp(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(h) : d(h);
  }
  function c(h) {
    return Xe(h) ? $r(e, d)(h) : d(h);
  }
  function d(h) {
    return h === 41 ? (e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), e.exit("resource"), t) : n(h);
  }
}
function Ib(e, t, n) {
  const i = this;
  return r;
  function r(l) {
    return ep.call(i, e, s, o, "reference", "referenceMarker", "referenceString")(l);
  }
  function s(l) {
    return i.parser.defined.includes(wn(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? t(l) : n(l);
  }
  function o(l) {
    return n(l);
  }
}
function Lb(e, t, n) {
  return i;
  function i(s) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(s), e.exit("referenceMarker"), r;
  }
  function r(s) {
    return s === 93 ? (e.enter("referenceMarker"), e.consume(s), e.exit("referenceMarker"), e.exit("reference"), t) : n(s);
  }
}
const Nb = {
  name: "labelStartImage",
  resolveAll: ol.resolveAll,
  tokenize: Tb
};
function Tb(e, t, n) {
  const i = this;
  return r;
  function r(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), s;
  }
  function s(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), o) : n(l);
  }
  function o(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? n(l) : t(l);
  }
}
const Pb = {
  name: "labelStartLink",
  resolveAll: ol.resolveAll,
  tokenize: Db
};
function Db(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), s;
  }
  function s(o) {
    return o === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? n(o) : t(o);
  }
}
const Da = {
  name: "lineEnding",
  tokenize: Mb
};
function Mb(e, t) {
  return n;
  function n(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), Ue(e, t, "linePrefix");
  }
}
const As = {
  name: "thematicBreak",
  tokenize: Vb
};
function Vb(e, t, n) {
  let i = 0, r;
  return s;
  function s(c) {
    return e.enter("thematicBreak"), o(c);
  }
  function o(c) {
    return r = c, l(c);
  }
  function l(c) {
    return c === r ? (e.enter("thematicBreakSequence"), u(c)) : i >= 3 && (c === null || xe(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function u(c) {
    return c === r ? (e.consume(c), i++, u) : (e.exit("thematicBreakSequence"), De(c) ? Ue(e, l, "whitespace")(c) : l(c));
  }
}
const Xt = {
  continuation: {
    tokenize: Bb
  },
  exit: jb,
  name: "list",
  tokenize: Ob
}, Fb = {
  partial: !0,
  tokenize: $b
}, Rb = {
  partial: !0,
  tokenize: zb
};
function Ob(e, t, n) {
  const i = this, r = i.events[i.events.length - 1];
  let s = r && r[1].type === "linePrefix" ? r[2].sliceSerialize(r[1], !0).length : 0, o = 0;
  return l;
  function l(_) {
    const y = i.containerState.type || (_ === 42 || _ === 43 || _ === 45 ? "listUnordered" : "listOrdered");
    if (y === "listUnordered" ? !i.containerState.marker || _ === i.containerState.marker : Co(_)) {
      if (i.containerState.type || (i.containerState.type = y, e.enter(y, {
        _container: !0
      })), y === "listUnordered")
        return e.enter("listItemPrefix"), _ === 42 || _ === 45 ? e.check(As, n, c)(_) : c(_);
      if (!i.interrupt || _ === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(_);
    }
    return n(_);
  }
  function u(_) {
    return Co(_) && ++o < 10 ? (e.consume(_), u) : (!i.interrupt || o < 2) && (i.containerState.marker ? _ === i.containerState.marker : _ === 41 || _ === 46) ? (e.exit("listItemValue"), c(_)) : n(_);
  }
  function c(_) {
    return e.enter("listItemMarker"), e.consume(_), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || _, e.check(
      mr,
      // Can’t be empty when interrupting.
      i.interrupt ? n : d,
      e.attempt(Fb, m, h)
    );
  }
  function d(_) {
    return i.containerState.initialBlankLine = !0, s++, m(_);
  }
  function h(_) {
    return De(_) ? (e.enter("listItemPrefixWhitespace"), e.consume(_), e.exit("listItemPrefixWhitespace"), m) : n(_);
  }
  function m(_) {
    return i.containerState.size = s + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(_);
  }
}
function Bb(e, t, n) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(mr, r, s);
  function r(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Ue(e, t, "listItemIndent", i.containerState.size + 1)(l);
  }
  function s(l) {
    return i.containerState.furtherBlankLines || !De(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, o(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(Rb, t, o)(l));
  }
  function o(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Ue(e, e.attempt(Xt, t, n), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function zb(e, t, n) {
  const i = this;
  return Ue(e, r, "listItemIndent", i.containerState.size + 1);
  function r(s) {
    const o = i.events[i.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === i.containerState.size ? t(s) : n(s);
  }
}
function jb(e) {
  e.exit(this.containerState.type);
}
function $b(e, t, n) {
  const i = this;
  return Ue(e, r, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function r(s) {
    const o = i.events[i.events.length - 1];
    return !De(s) && o && o[1].type === "listItemPrefixWhitespace" ? t(s) : n(s);
  }
}
const uc = {
  name: "setextUnderline",
  resolveTo: Hb,
  tokenize: Ub
};
function Hb(e, t) {
  let n = e.length, i, r, s;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        i = n;
        break;
      }
      e[n][1].type === "paragraph" && (r = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !s && e[n][1].type === "definition" && (s = n);
  const o = {
    type: "setextHeading",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[r][1].type = "setextHeadingText", s ? (e.splice(r, 0, ["enter", o, t]), e.splice(s + 1, 0, ["exit", e[i][1], t]), e[i][1].end = {
    ...e[s][1].end
  }) : e[i][1] = o, e.push(["exit", o, t]), e;
}
function Ub(e, t, n) {
  const i = this;
  let r;
  return s;
  function s(c) {
    let d = i.events.length, h;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        h = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || h) ? (e.enter("setextHeadingLine"), r = c, o(c)) : n(c);
  }
  function o(c) {
    return e.enter("setextHeadingLineSequence"), l(c);
  }
  function l(c) {
    return c === r ? (e.consume(c), l) : (e.exit("setextHeadingLineSequence"), De(c) ? Ue(e, u, "lineSuffix")(c) : u(c));
  }
  function u(c) {
    return c === null || xe(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const qb = {
  tokenize: Zb,
  partial: !0
}, cc = "https://github.com/micromark/micromark-extension-mdxjs-esm", Jb = /* @__PURE__ */ new Set(["ExportAllDeclaration", "ExportDefaultDeclaration", "ExportNamedDeclaration", "ImportDeclaration"]);
function Wb(e) {
  const t = {
    tokenize: r,
    concrete: !0
  };
  if (!e || !e.acorn || !e.acorn.parse)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  const n = e.acorn, i = Object.assign({
    ecmaVersion: 2024,
    sourceType: "module"
  }, e.acornOptions, {
    locations: !0
  });
  return {
    flow: {
      101: t,
      105: t
    }
  };
  function r(s, o, l) {
    const u = this, c = u.parser.definedModuleSpecifiers || (u.parser.definedModuleSpecifiers = []), d = this.events.length + 1;
    let h = "";
    return u.interrupt ? l : m;
    function m(A) {
      return u.now().column > 1 ? l(A) : (s.enter("mdxjsEsm"), s.enter("mdxjsEsmData"), s.consume(A), h += String.fromCharCode(A), _);
    }
    function _(A) {
      return Ot(A) ? (s.consume(A), h += String.fromCharCode(A), _) : (h === "import" || h === "export") && A === 32 ? (s.consume(A), y) : l(A);
    }
    function y(A) {
      return A === null || xe(A) ? (s.exit("mdxjsEsmData"), v(A)) : (s.consume(A), y);
    }
    function v(A) {
      return A === null ? x(A) : xe(A) ? s.check(qb, x, w)(A) : (s.enter("mdxjsEsmData"), y(A));
    }
    function w(A) {
      return s.enter("lineEnding"), s.consume(A), s.exit("lineEnding"), v;
    }
    function x(A) {
      const S = Wh(u.events.slice(d), {
        acorn: n,
        acornOptions: i,
        tokenTypes: ["mdxjsEsmData"],
        prefix: c.length > 0 ? "var " + c.join(",") + `
` : ""
      });
      if (S.error) {
        if (A !== null && S.swallow)
          return w(A);
        const E = new Qe("Could not parse import/exports with acorn", {
          cause: S.error,
          place: {
            line: S.error.loc.line,
            column: S.error.loc.column + 1,
            offset: S.error.pos
          },
          ruleId: "acorn",
          source: "micromark-extension-mdxjs-esm"
        });
        throw E.url = cc + "#could-not-parse-importexports-with-acorn", E;
      }
      c.length > 0 && S.estree.body.shift();
      let N = -1;
      for (; ++N < S.estree.body.length; ) {
        const E = S.estree.body[N];
        if (!Jb.has(E.type)) {
          const f = new Qe("Unexpected `" + E.type + "` in code: only import/exports are supported", {
            place: Zn(E),
            ruleId: "non-esm",
            source: "micromark-extension-mdxjs-esm"
          });
          throw f.url = cc + "#unexpected-type-in-code-only-importexports-are-supported", f;
        }
        if (E.type === "ImportDeclaration" && !u.interrupt) {
          let f = -1;
          for (; ++f < E.specifiers.length; ) {
            const C = E.specifiers[f];
            c.push(C.local.name);
          }
        }
      }
      return Object.assign(s.exit("mdxjsEsm"), e.addResult ? {
        estree: S.estree
      } : void 0), o(A);
    }
  }
}
function Zb(e, t, n) {
  return i;
  function i(r) {
    return e.enter("lineEndingBlank"), e.consume(r), e.exit("lineEndingBlank"), e.attempt(mr, t, n);
  }
}
const dc = {}.hasOwnProperty;
function ll(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    Xb(t, e[n]);
  return t;
}
function Xb(e, t) {
  let n;
  for (n in t) {
    const r = (dc.call(e, n) ? e[n] : void 0) || (e[n] = {}), s = t[n];
    let o;
    if (s)
      for (o in s) {
        dc.call(r, o) || (r[o] = []);
        const l = s[o];
        Gb(
          // @ts-expect-error Looks like a list.
          r[o],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function Gb(e, t) {
  let n = -1;
  const i = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : i).push(t[n]);
  an(e, 0, 0, i);
}
function Kb(e) {
  const t = Object.assign(
    {
      acorn: Et.extend(Hd()),
      acornOptions: { ecmaVersion: 2024, sourceType: "module" },
      addResult: !0
    },
    e
  );
  return ll([
    Wb(t),
    Cx(t),
    Ix(t),
    Lx()
  ]);
}
const Yb = {};
function Qb(e) {
  const t = this, n = e || Yb, i = t.data(), r = i.micromarkExtensions || (i.micromarkExtensions = []), s = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), o = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  r.push(Kb(n)), s.push(vg()), o.push(wg(n));
}
const ey = {};
function ul(e, t) {
  const n = ey, i = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, r = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return np(e, i, r);
}
function np(e, t, n) {
  if (ty(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return hc(e.children, t, n);
  }
  return Array.isArray(e) ? hc(e, t, n) : "";
}
function hc(e, t, n) {
  const i = [];
  let r = -1;
  for (; ++r < e.length; )
    i[r] = np(e[r], t, n);
  return i.join("");
}
function ty(e) {
  return !!(e && typeof e == "object");
}
function ip(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function _r(e) {
  const t = [];
  let n = -1, i = 0, r = 0;
  for (; ++n < e.length; ) {
    const s = e.charCodeAt(n);
    let o = "";
    if (s === 37 && Bt(e.charCodeAt(n + 1)) && Bt(e.charCodeAt(n + 2)))
      r = 2;
    else if (s < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(s)) || (o = String.fromCharCode(s));
    else if (s > 55295 && s < 57344) {
      const l = e.charCodeAt(n + 1);
      s < 56320 && l > 56319 && l < 57344 ? (o = String.fromCharCode(s, l), r = 1) : o = "�";
    } else
      o = String.fromCharCode(s);
    o && (t.push(e.slice(i, n), encodeURIComponent(o)), i = n + r + 1, o = ""), r && (n += r, r = 0);
  }
  return t.join("") + e.slice(i);
}
const ny = {
  tokenize: iy
};
function iy(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, i, r);
  let n;
  return t;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Ue(e, t, "linePrefix");
  }
  function r(l) {
    return e.enter("paragraph"), s(l);
  }
  function s(l) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, o(l);
  }
  function o(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return xe(l) ? (e.consume(l), e.exit("chunkText"), s) : (e.consume(l), o);
  }
}
const ry = {
  tokenize: sy
}, pc = {
  tokenize: ay
};
function sy(e) {
  const t = this, n = [];
  let i = 0, r, s, o;
  return l;
  function l(S) {
    if (i < n.length) {
      const N = n[i];
      return t.containerState = N[1], e.attempt(N[0].continuation, u, c)(S);
    }
    return c(S);
  }
  function u(S) {
    if (i++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, r && A();
      const N = t.events.length;
      let E = N, f;
      for (; E--; )
        if (t.events[E][0] === "exit" && t.events[E][1].type === "chunkFlow") {
          f = t.events[E][1].end;
          break;
        }
      x(i);
      let C = N;
      for (; C < t.events.length; )
        t.events[C][1].end = {
          ...f
        }, C++;
      return an(t.events, E + 1, 0, t.events.slice(N)), t.events.length = C, c(S);
    }
    return l(S);
  }
  function c(S) {
    if (i === n.length) {
      if (!r)
        return m(S);
      if (r.currentConstruct && r.currentConstruct.concrete)
        return y(S);
      t.interrupt = !!(r.currentConstruct && !r._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(pc, d, h)(S);
  }
  function d(S) {
    return r && A(), x(i), m(S);
  }
  function h(S) {
    return t.parser.lazy[t.now().line] = i !== n.length, o = t.now().offset, y(S);
  }
  function m(S) {
    return t.containerState = {}, e.attempt(pc, _, y)(S);
  }
  function _(S) {
    return i++, n.push([t.currentConstruct, t.containerState]), m(S);
  }
  function y(S) {
    if (S === null) {
      r && A(), x(0), e.consume(S);
      return;
    }
    return r = r || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: r,
      contentType: "flow",
      previous: s
    }), v(S);
  }
  function v(S) {
    if (S === null) {
      w(e.exit("chunkFlow"), !0), x(0), e.consume(S);
      return;
    }
    return xe(S) ? (e.consume(S), w(e.exit("chunkFlow")), i = 0, t.interrupt = void 0, l) : (e.consume(S), v);
  }
  function w(S, N) {
    const E = t.sliceStream(S);
    if (N && E.push(null), S.previous = s, s && (s.next = S), s = S, r.defineSkip(S.start), r.write(E), t.parser.lazy[S.start.line]) {
      let f = r.events.length;
      for (; f--; )
        if (
          // The token starts before the line ending…
          r.events[f][1].start.offset < o && // …and either is not ended yet…
          (!r.events[f][1].end || // …or ends after it.
          r.events[f][1].end.offset > o)
        )
          return;
      const C = t.events.length;
      let L = C, R, V;
      for (; L--; )
        if (t.events[L][0] === "exit" && t.events[L][1].type === "chunkFlow") {
          if (R) {
            V = t.events[L][1].end;
            break;
          }
          R = !0;
        }
      for (x(i), f = C; f < t.events.length; )
        t.events[f][1].end = {
          ...V
        }, f++;
      an(t.events, L + 1, 0, t.events.slice(C)), t.events.length = f;
    }
  }
  function x(S) {
    let N = n.length;
    for (; N-- > S; ) {
      const E = n[N];
      t.containerState = E[1], E[0].exit.call(t, e);
    }
    n.length = S;
  }
  function A() {
    r.write([null]), s = void 0, r = void 0, t.containerState._closeFlow = void 0;
  }
}
function ay(e, t, n) {
  return Ue(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
const oy = {
  tokenize: ly
};
function ly(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    mr,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, r, Ue(e, e.attempt(this.parser.constructs.flow, r, e.attempt(Kx, r)), "linePrefix"))
  );
  return n;
  function i(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(s), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const uy = {
  resolveAll: sp()
}, cy = rp("string"), dy = rp("text");
function rp(e) {
  return {
    resolveAll: sp(e === "text" ? hy : void 0),
    tokenize: t
  };
  function t(n) {
    const i = this, r = this.parser.constructs[e], s = n.attempt(r, o, l);
    return o;
    function o(d) {
      return c(d) ? s(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        n.consume(d);
        return;
      }
      return n.enter("data"), n.consume(d), u;
    }
    function u(d) {
      return c(d) ? (n.exit("data"), s(d)) : (n.consume(d), u);
    }
    function c(d) {
      if (d === null)
        return !0;
      const h = r[d];
      let m = -1;
      if (h)
        for (; ++m < h.length; ) {
          const _ = h[m];
          if (!_.previous || _.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function sp(e) {
  return t;
  function t(n, i) {
    let r = -1, s;
    for (; ++r <= n.length; )
      s === void 0 ? n[r] && n[r][1].type === "data" && (s = r, r++) : (!n[r] || n[r][1].type !== "data") && (r !== s + 2 && (n[s][1].end = n[r - 1][1].end, n.splice(s + 2, r - s - 2), r = s + 2), s = void 0);
    return e ? e(n, i) : n;
  }
}
function hy(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const i = e[n - 1][1], r = t.sliceStream(i);
      let s = r.length, o = -1, l = 0, u;
      for (; s--; ) {
        const c = r[s];
        if (typeof c == "string") {
          for (o = c.length; c.charCodeAt(o - 1) === 32; )
            l++, o--;
          if (o) break;
          o = -1;
        } else if (c === -2)
          u = !0, l++;
        else if (c !== -1) {
          s++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (l = 0), l) {
        const c = {
          type: n === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: s ? o : i.start._bufferIndex + o,
            _index: i.start._index + s,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...c.start
        }, i.start.offset === i.end.offset ? Object.assign(i, c) : (e.splice(n, 0, ["enter", c, t], ["exit", c, t]), n += 2);
      }
      n++;
    }
  return e;
}
const py = {
  42: Xt,
  43: Xt,
  45: Xt,
  48: Xt,
  49: Xt,
  50: Xt,
  51: Xt,
  52: Xt,
  53: Xt,
  54: Xt,
  55: Xt,
  56: Xt,
  57: Xt,
  62: Xh
}, fy = {
  91: nb
}, my = {
  [-2]: Pa,
  [-1]: Pa,
  32: Pa
}, _y = {
  35: lb,
  42: As,
  45: [uc, As],
  60: hb,
  61: uc,
  95: As,
  96: oc,
  126: oc
}, gy = {
  38: Kh,
  92: Gh
}, xy = {
  [-5]: Da,
  [-4]: Da,
  [-3]: Da,
  33: Nb,
  38: Kh,
  42: So,
  60: [Px, bb],
  91: Pb,
  92: [ab, Gh],
  93: ol,
  95: So,
  96: qx
}, by = {
  null: [So, uy]
}, yy = {
  null: [42, 95]
}, vy = {
  null: []
}, wy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: yy,
  contentInitial: fy,
  disable: vy,
  document: py,
  flow: _y,
  flowInitial: my,
  insideSpan: by,
  string: gy,
  text: xy
}, Symbol.toStringTag, { value: "Module" }));
function ky(e, t, n) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const r = {}, s = [];
  let o = [], l = [];
  const u = {
    attempt: C(E),
    check: C(f),
    consume: A,
    enter: S,
    exit: N,
    interrupt: C(f, {
      interrupt: !0
    })
  }, c = {
    code: null,
    containerState: {},
    defineSkip: v,
    events: [],
    now: y,
    parser: e,
    previous: null,
    sliceSerialize: m,
    sliceStream: _,
    write: h
  };
  let d = t.tokenize.call(c, u);
  return t.resolveAll && s.push(t), c;
  function h(z) {
    return o = fn(o, z), w(), o[o.length - 1] !== null ? [] : (L(t, 0), c.events = Ys(s, c.events, c), c.events);
  }
  function m(z, $) {
    return Sy(_(z), $);
  }
  function _(z) {
    return Cy(o, z);
  }
  function y() {
    const {
      _bufferIndex: z,
      _index: $,
      line: H,
      column: B,
      offset: O
    } = i;
    return {
      _bufferIndex: z,
      _index: $,
      line: H,
      column: B,
      offset: O
    };
  }
  function v(z) {
    r[z.line] = z.column, V();
  }
  function w() {
    let z;
    for (; i._index < o.length; ) {
      const $ = o[i._index];
      if (typeof $ == "string")
        for (z = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === z && i._bufferIndex < $.length; )
          x($.charCodeAt(i._bufferIndex));
      else
        x($);
    }
  }
  function x(z) {
    d = d(z);
  }
  function A(z) {
    xe(z) ? (i.line++, i.column = 1, i.offset += z === -3 ? 2 : 1, V()) : z !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[i._index].length && (i._bufferIndex = -1, i._index++)), c.previous = z;
  }
  function S(z, $) {
    const H = $ || {};
    return H.type = z, H.start = y(), c.events.push(["enter", H, c]), l.push(H), H;
  }
  function N(z) {
    const $ = l.pop();
    return $.end = y(), c.events.push(["exit", $, c]), $;
  }
  function E(z, $) {
    L(z, $.from);
  }
  function f(z, $) {
    $.restore();
  }
  function C(z, $) {
    return H;
    function H(B, O, W) {
      let G, re, K, P;
      return Array.isArray(B) ? (
        /* c8 ignore next 1 */
        se(B)
      ) : "tokenize" in B ? (
        // Looks like a construct.
        se([
          /** @type {Construct} */
          B
        ])
      ) : oe(B);
      function oe(Z) {
        return j;
        function j(ie) {
          const te = ie !== null && Z[ie], ge = ie !== null && Z.null, ne = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(te) ? te : te ? [te] : [],
            ...Array.isArray(ge) ? ge : ge ? [ge] : []
          ];
          return se(ne)(ie);
        }
      }
      function se(Z) {
        return G = Z, re = 0, Z.length === 0 ? W : D(Z[re]);
      }
      function D(Z) {
        return j;
        function j(ie) {
          return P = R(), K = Z, Z.partial || (c.currentConstruct = Z), Z.name && c.parser.constructs.disable.null.includes(Z.name) ? Ce() : Z.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            $ ? Object.assign(Object.create(c), $) : c,
            u,
            pe,
            Ce
          )(ie);
        }
      }
      function pe(Z) {
        return z(K, P), O;
      }
      function Ce(Z) {
        return P.restore(), ++re < G.length ? D(G[re]) : W;
      }
    }
  }
  function L(z, $) {
    z.resolveAll && !s.includes(z) && s.push(z), z.resolve && an(c.events, $, c.events.length - $, z.resolve(c.events.slice($), c)), z.resolveTo && (c.events = z.resolveTo(c.events, c));
  }
  function R() {
    const z = y(), $ = c.previous, H = c.currentConstruct, B = c.events.length, O = Array.from(l);
    return {
      from: B,
      restore: W
    };
    function W() {
      i = z, c.previous = $, c.currentConstruct = H, c.events.length = B, l = O, V();
    }
  }
  function V() {
    i.line in r && i.column < 2 && (i.column = r[i.line], i.offset += r[i.line] - 1);
  }
}
function Cy(e, t) {
  const n = t.start._index, i = t.start._bufferIndex, r = t.end._index, s = t.end._bufferIndex;
  let o;
  if (n === r)
    o = [e[n].slice(i, s)];
  else {
    if (o = e.slice(n, r), i > -1) {
      const l = o[0];
      typeof l == "string" ? o[0] = l.slice(i) : o.shift();
    }
    s > 0 && o.push(e[r].slice(0, s));
  }
  return o;
}
function Sy(e, t) {
  let n = -1;
  const i = [];
  let r;
  for (; ++n < e.length; ) {
    const s = e[n];
    let o;
    if (typeof s == "string")
      o = s;
    else switch (s) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && r) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(s);
    }
    r = s === -2, i.push(o);
  }
  return i.join("");
}
function Ey(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      ll([wy, ...(e || {}).extensions || []])
    ),
    content: r(ny),
    defined: [],
    document: r(ry),
    flow: r(oy),
    lazy: {},
    string: r(cy),
    text: r(dy)
  };
  return i;
  function r(s) {
    return o;
    function o(l) {
      return ky(i, s, l);
    }
  }
}
function Ay(e) {
  for (; !Yh(e); )
    ;
  return e;
}
const fc = /[\0\t\n\r]/g;
function Iy() {
  let e = 1, t = "", n = !0, i;
  return r;
  function r(s, o, l) {
    const u = [];
    let c, d, h, m, _;
    for (s = t + (typeof s == "string" ? s.toString() : new TextDecoder(o || void 0).decode(s)), h = 0, t = "", n && (s.charCodeAt(0) === 65279 && h++, n = void 0); h < s.length; ) {
      if (fc.lastIndex = h, c = fc.exec(s), m = c && c.index !== void 0 ? c.index : s.length, _ = s.charCodeAt(m), !c) {
        t = s.slice(h);
        break;
      }
      if (_ === 10 && h === m && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), h < m && (u.push(s.slice(h, m)), e += m - h), _) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, u.push(-2); e++ < d; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      h = m + 1;
    }
    return l && (i && u.push(-5), t && u.push(t), u.push(null)), u;
  }
}
const Ly = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Ny(e) {
  return e.replace(Ly, Ty);
}
function Ty(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const r = n.charCodeAt(1), s = r === 120 || r === 88;
    return ip(n.slice(s ? 2 : 1), s ? 16 : 10);
  }
  return qr(n) || e;
}
const ap = {}.hasOwnProperty;
function Py(e, t, n) {
  return t && typeof t == "object" && (n = t, t = void 0), Dy(n)(Ay(Ey(n).document().write(Iy()(e, t, !0))));
}
function Dy(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: s(xt),
      autolinkProtocol: R,
      autolinkEmail: R,
      atxHeading: s(nt),
      blockQuote: s(ge),
      characterEscape: R,
      characterReference: R,
      codeFenced: s(ne),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: s(ne, o),
      codeText: s(_e, o),
      codeTextData: R,
      data: R,
      codeFlowValue: R,
      definition: s(Ie),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: s(Ve),
      hardBreakEscape: s(Ke),
      hardBreakTrailing: s(Ke),
      htmlFlow: s(pt, o),
      htmlFlowData: R,
      htmlText: s(pt, o),
      htmlTextData: R,
      image: s(Be),
      label: o,
      link: s(xt),
      listItem: s(ft),
      listItemValue: m,
      listOrdered: s(kt, h),
      listUnordered: s(kt),
      paragraph: s(Fe),
      reference: D,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: s(nt),
      strong: s(je),
      thematicBreak: s(on)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: E,
      autolink: u(),
      autolinkEmail: te,
      autolinkProtocol: ie,
      blockQuote: u(),
      characterEscapeValue: V,
      characterReferenceMarkerHexadecimal: Ce,
      characterReferenceMarkerNumeric: Ce,
      characterReferenceValue: Z,
      characterReference: j,
      codeFenced: u(w),
      codeFencedFence: v,
      codeFencedFenceInfo: _,
      codeFencedFenceMeta: y,
      codeFlowValue: V,
      codeIndented: u(x),
      codeText: u(O),
      codeTextData: V,
      data: V,
      definition: u(),
      definitionDestinationString: N,
      definitionLabelString: A,
      definitionTitleString: S,
      emphasis: u(),
      hardBreakEscape: u($),
      hardBreakTrailing: u($),
      htmlFlow: u(H),
      htmlFlowData: V,
      htmlText: u(B),
      htmlTextData: V,
      image: u(G),
      label: K,
      labelText: re,
      lineEnding: z,
      link: u(W),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: pe,
      resourceDestinationString: P,
      resourceTitleString: oe,
      resource: se,
      setextHeading: u(L),
      setextHeadingLineSequence: C,
      setextHeadingText: f,
      strong: u(),
      thematicBreak: u()
    }
  };
  op(t, (e || {}).mdastExtensions || []);
  const n = {};
  return i;
  function i(Q) {
    let Y = {
      type: "root",
      children: []
    };
    const T = {
      stack: [Y],
      tokenStack: [],
      config: t,
      enter: l,
      exit: c,
      buffer: o,
      resume: d,
      data: n
    }, Se = [];
    let He = -1;
    for (; ++He < Q.length; )
      if (Q[He][1].type === "listOrdered" || Q[He][1].type === "listUnordered")
        if (Q[He][0] === "enter")
          Se.push(He);
        else {
          const ut = Se.pop();
          He = r(Q, ut, He);
        }
    for (He = -1; ++He < Q.length; ) {
      const ut = t[Q[He][0]];
      ap.call(ut, Q[He][1].type) && ut[Q[He][1].type].call(Object.assign({
        sliceSerialize: Q[He][2].sliceSerialize
      }, T), Q[He][1]);
    }
    if (T.tokenStack.length > 0) {
      const ut = T.tokenStack[T.tokenStack.length - 1];
      (ut[1] || mc).call(T, void 0, ut[0]);
    }
    for (Y.position = {
      start: si(Q.length > 0 ? Q[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: si(Q.length > 0 ? Q[Q.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, He = -1; ++He < t.transforms.length; )
      Y = t.transforms[He](Y) || Y;
    return Y;
  }
  function r(Q, Y, T) {
    let Se = Y - 1, He = -1, ut = !1, ue, _t, Tt, ln;
    for (; ++Se <= T; ) {
      const bt = Q[Se];
      switch (bt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          bt[0] === "enter" ? He++ : He--, ln = void 0;
          break;
        }
        case "lineEndingBlank": {
          bt[0] === "enter" && (ue && !ln && !He && !Tt && (Tt = Se), ln = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          ln = void 0;
      }
      if (!He && bt[0] === "enter" && bt[1].type === "listItemPrefix" || He === -1 && bt[0] === "exit" && (bt[1].type === "listUnordered" || bt[1].type === "listOrdered")) {
        if (ue) {
          let un = Se;
          for (_t = void 0; un--; ) {
            const qt = Q[un];
            if (qt[1].type === "lineEnding" || qt[1].type === "lineEndingBlank") {
              if (qt[0] === "exit") continue;
              _t && (Q[_t][1].type = "lineEndingBlank", ut = !0), qt[1].type = "lineEnding", _t = un;
            } else if (!(qt[1].type === "linePrefix" || qt[1].type === "blockQuotePrefix" || qt[1].type === "blockQuotePrefixWhitespace" || qt[1].type === "blockQuoteMarker" || qt[1].type === "listItemIndent")) break;
          }
          Tt && (!_t || Tt < _t) && (ue._spread = !0), ue.end = Object.assign({}, _t ? Q[_t][1].start : bt[1].end), Q.splice(_t || Se, 0, ["exit", ue, bt[2]]), Se++, T++;
        }
        if (bt[1].type === "listItemPrefix") {
          const un = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, bt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          ue = un, Q.splice(Se, 0, ["enter", un, bt[2]]), Se++, T++, Tt = void 0, ln = !0;
        }
      }
    }
    return Q[Y][1]._spread = ut, T;
  }
  function s(Q, Y) {
    return T;
    function T(Se) {
      l.call(this, Q(Se), Se), Y && Y.call(this, Se);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(Q, Y, T) {
    this.stack[this.stack.length - 1].children.push(Q), this.stack.push(Q), this.tokenStack.push([Y, T || void 0]), Q.position = {
      start: si(Y.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(Q) {
    return Y;
    function Y(T) {
      Q && Q.call(this, T), c.call(this, T);
    }
  }
  function c(Q, Y) {
    const T = this.stack.pop(), Se = this.tokenStack.pop();
    if (Se)
      Se[0].type !== Q.type && (Y ? Y.call(this, Q, Se[0]) : (Se[1] || mc).call(this, Q, Se[0]));
    else throw new Error("Cannot close `" + Q.type + "` (" + _n({
      start: Q.start,
      end: Q.end
    }) + "): it’s not open");
    T.position.end = si(Q.end);
  }
  function d() {
    return ul(this.stack.pop());
  }
  function h() {
    this.data.expectingFirstListItemValue = !0;
  }
  function m(Q) {
    if (this.data.expectingFirstListItemValue) {
      const Y = this.stack[this.stack.length - 2];
      Y.start = Number.parseInt(this.sliceSerialize(Q), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function _() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.lang = Q;
  }
  function y() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.meta = Q;
  }
  function v() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function w() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = Q.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function x() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = Q.replace(/(\r?\n|\r)$/g, "");
  }
  function A(Q) {
    const Y = this.resume(), T = this.stack[this.stack.length - 1];
    T.label = Y, T.identifier = wn(this.sliceSerialize(Q)).toLowerCase();
  }
  function S() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.title = Q;
  }
  function N() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.url = Q;
  }
  function E(Q) {
    const Y = this.stack[this.stack.length - 1];
    if (!Y.depth) {
      const T = this.sliceSerialize(Q).length;
      Y.depth = T;
    }
  }
  function f() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function C(Q) {
    const Y = this.stack[this.stack.length - 1];
    Y.depth = this.sliceSerialize(Q).codePointAt(0) === 61 ? 1 : 2;
  }
  function L() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function R(Q) {
    const T = this.stack[this.stack.length - 1].children;
    let Se = T[T.length - 1];
    (!Se || Se.type !== "text") && (Se = Re(), Se.position = {
      start: si(Q.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, T.push(Se)), this.stack.push(Se);
  }
  function V(Q) {
    const Y = this.stack.pop();
    Y.value += this.sliceSerialize(Q), Y.position.end = si(Q.end);
  }
  function z(Q) {
    const Y = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const T = Y.children[Y.children.length - 1];
      T.position.end = si(Q.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(Y.type) && (R.call(this, Q), V.call(this, Q));
  }
  function $() {
    this.data.atHardBreak = !0;
  }
  function H() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = Q;
  }
  function B() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = Q;
  }
  function O() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = Q;
  }
  function W() {
    const Q = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Y = this.data.referenceType || "shortcut";
      Q.type += "Reference", Q.referenceType = Y, delete Q.url, delete Q.title;
    } else
      delete Q.identifier, delete Q.label;
    this.data.referenceType = void 0;
  }
  function G() {
    const Q = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Y = this.data.referenceType || "shortcut";
      Q.type += "Reference", Q.referenceType = Y, delete Q.url, delete Q.title;
    } else
      delete Q.identifier, delete Q.label;
    this.data.referenceType = void 0;
  }
  function re(Q) {
    const Y = this.sliceSerialize(Q), T = this.stack[this.stack.length - 2];
    T.label = Ny(Y), T.identifier = wn(Y).toLowerCase();
  }
  function K() {
    const Q = this.stack[this.stack.length - 1], Y = this.resume(), T = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, T.type === "link") {
      const Se = Q.children;
      T.children = Se;
    } else
      T.alt = Y;
  }
  function P() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.url = Q;
  }
  function oe() {
    const Q = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.title = Q;
  }
  function se() {
    this.data.inReference = void 0;
  }
  function D() {
    this.data.referenceType = "collapsed";
  }
  function pe(Q) {
    const Y = this.resume(), T = this.stack[this.stack.length - 1];
    T.label = Y, T.identifier = wn(this.sliceSerialize(Q)).toLowerCase(), this.data.referenceType = "full";
  }
  function Ce(Q) {
    this.data.characterReferenceType = Q.type;
  }
  function Z(Q) {
    const Y = this.sliceSerialize(Q), T = this.data.characterReferenceType;
    let Se;
    T ? (Se = ip(Y, T === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Se = qr(Y);
    const He = this.stack[this.stack.length - 1];
    He.value += Se;
  }
  function j(Q) {
    const Y = this.stack.pop();
    Y.position.end = si(Q.end);
  }
  function ie(Q) {
    V.call(this, Q);
    const Y = this.stack[this.stack.length - 1];
    Y.url = this.sliceSerialize(Q);
  }
  function te(Q) {
    V.call(this, Q);
    const Y = this.stack[this.stack.length - 1];
    Y.url = "mailto:" + this.sliceSerialize(Q);
  }
  function ge() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function ne() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function _e() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ie() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ve() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function nt() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Ke() {
    return {
      type: "break"
    };
  }
  function pt() {
    return {
      type: "html",
      value: ""
    };
  }
  function Be() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function xt() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function kt(Q) {
    return {
      type: "list",
      ordered: Q.type === "listOrdered",
      start: null,
      spread: Q._spread,
      children: []
    };
  }
  function ft(Q) {
    return {
      type: "listItem",
      spread: Q._spread,
      checked: null,
      children: []
    };
  }
  function Fe() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function je() {
    return {
      type: "strong",
      children: []
    };
  }
  function Re() {
    return {
      type: "text",
      value: ""
    };
  }
  function on() {
    return {
      type: "thematicBreak"
    };
  }
}
function si(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function op(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const i = t[n];
    Array.isArray(i) ? op(e, i) : My(e, i);
  }
}
function My(e, t) {
  let n;
  for (n in t)
    if (ap.call(t, n))
      switch (n) {
        case "canContainEols": {
          const i = t[n];
          i && e[n].push(...i);
          break;
        }
        case "transforms": {
          const i = t[n];
          i && e[n].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = t[n];
          i && Object.assign(e[n], i);
          break;
        }
      }
}
function mc(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + _n({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + _n({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + _n({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function Vy(e) {
  const t = this;
  t.parser = n;
  function n(i) {
    return Py(i, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function Fy(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Ry(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function Oy(e, t) {
  const n = t.value ? t.value + `
` : "", i = {}, r = t.lang ? t.lang.split(/\s+/) : [];
  r.length > 0 && (i.className = ["language-" + r[0]]);
  let s = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (s.data = { meta: t.meta }), e.patch(t, s), s = e.applyData(t, s), s = { type: "element", tagName: "pre", properties: {}, children: [s] }, e.patch(t, s), s;
}
function By(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function zy(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function jy(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(t.identifier).toUpperCase(), r = _r(i.toLowerCase()), s = e.footnoteOrder.indexOf(i);
  let o, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), o = e.footnoteOrder.length) : o = s + 1, l += 1, e.footnoteCounts.set(i, l);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + r,
      id: n + "fnref-" + r + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, u);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function $y(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Hy(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function lp(e, t) {
  const n = t.referenceType;
  let i = "]";
  if (n === "collapsed" ? i += "[]" : n === "full" && (i += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + i }];
  const r = e.all(t), s = r[0];
  s && s.type === "text" ? s.value = "[" + s.value : r.unshift({ type: "text", value: "[" });
  const o = r[r.length - 1];
  return o && o.type === "text" ? o.value += i : r.push({ type: "text", value: i }), r;
}
function Uy(e, t) {
  const n = String(t.identifier).toUpperCase(), i = e.definitionById.get(n);
  if (!i)
    return lp(e, t);
  const r = { src: _r(i.url || ""), alt: t.alt };
  i.title !== null && i.title !== void 0 && (r.title = i.title);
  const s = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, s), e.applyData(t, s);
}
function qy(e, t) {
  const n = { src: _r(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const i = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function Jy(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Wy(e, t) {
  const n = String(t.identifier).toUpperCase(), i = e.definitionById.get(n);
  if (!i)
    return lp(e, t);
  const r = { href: _r(i.url || "") };
  i.title !== null && i.title !== void 0 && (r.title = i.title);
  const s = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, s), e.applyData(t, s);
}
function Zy(e, t) {
  const n = { href: _r(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Xy(e, t, n) {
  const i = e.all(t), r = n ? Gy(n) : up(t), s = {}, o = [];
  if (typeof t.checked == "boolean") {
    const d = i[0];
    let h;
    d && d.type === "element" && d.tagName === "p" ? h = d : (h = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(h)), h.children.length > 0 && h.children.unshift({ type: "text", value: " " }), h.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), s.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const d = i[l];
    (r || l !== 0 || d.type !== "element" || d.tagName !== "p") && o.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !r ? o.push(...d.children) : o.push(d);
  }
  const u = i[i.length - 1];
  u && (r || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: s, children: o };
  return e.patch(t, c), e.applyData(t, c);
}
function Gy(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let i = -1;
    for (; !t && ++i < n.length; )
      t = up(n[i]);
  }
  return t;
}
function up(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function Ky(e, t) {
  const n = {}, i = e.all(t);
  let r = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++r < i.length; ) {
    const o = i[r];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const s = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(i, !0)
  };
  return e.patch(t, s), e.applyData(t, s);
}
function Yy(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Qy(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function ev(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function tv(e, t) {
  const n = e.all(t), i = n.shift(), r = [];
  if (i) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(t.children[0], o), r.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, l = ih(t.children[1]), u = nh(t.children[t.children.length - 1]);
    l && u && (o.position = { start: l, end: u }), r.push(o);
  }
  const s = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(r, !0)
  };
  return e.patch(t, s), e.applyData(t, s);
}
function nv(e, t, n) {
  const i = n ? n.children : void 0, s = (i ? i.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, l = o ? o.length : t.children.length;
  let u = -1;
  const c = [];
  for (; ++u < l; ) {
    const h = t.children[u], m = {}, _ = o ? o[u] : void 0;
    _ && (m.align = _);
    let y = { type: "element", tagName: s, properties: m, children: [] };
    h && (y.children = e.all(h), e.patch(h, y), y = e.applyData(h, y)), c.push(y);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, d), e.applyData(t, d);
}
function iv(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const _c = 9, gc = 32;
function rv(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let i = n.exec(t), r = 0;
  const s = [];
  for (; i; )
    s.push(
      xc(t.slice(r, i.index), r > 0, !0),
      i[0]
    ), r = i.index + i[0].length, i = n.exec(t);
  return s.push(xc(t.slice(r), r > 0, !1)), s.join("");
}
function xc(e, t, n) {
  let i = 0, r = e.length;
  if (t) {
    let s = e.codePointAt(i);
    for (; s === _c || s === gc; )
      i++, s = e.codePointAt(i);
  }
  if (n) {
    let s = e.codePointAt(r - 1);
    for (; s === _c || s === gc; )
      r--, s = e.codePointAt(r - 1);
  }
  return r > i ? e.slice(i, r) : "";
}
function sv(e, t) {
  const n = { type: "text", value: rv(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function av(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const ov = {
  blockquote: Fy,
  break: Ry,
  code: Oy,
  delete: By,
  emphasis: zy,
  footnoteReference: jy,
  heading: $y,
  html: Hy,
  imageReference: Uy,
  image: qy,
  inlineCode: Jy,
  linkReference: Wy,
  link: Zy,
  listItem: Xy,
  list: Ky,
  paragraph: Yy,
  // @ts-expect-error: root is different, but hard to type.
  root: Qy,
  strong: ev,
  table: tv,
  tableCell: iv,
  tableRow: nv,
  text: sv,
  thematicBreak: av,
  toml: ms,
  yaml: ms,
  definition: ms,
  footnoteDefinition: ms
};
function ms() {
}
const cp = -1, Qs = 0, Hr = 1, Bs = 2, cl = 3, dl = 4, hl = 5, pl = 6, dp = 7, hp = 8, bc = typeof self == "object" ? self : globalThis, lv = (e, t) => {
  const n = (r, s) => (e.set(s, r), r), i = (r) => {
    if (e.has(r))
      return e.get(r);
    const [s, o] = t[r];
    switch (s) {
      case Qs:
      case cp:
        return n(o, r);
      case Hr: {
        const l = n([], r);
        for (const u of o)
          l.push(i(u));
        return l;
      }
      case Bs: {
        const l = n({}, r);
        for (const [u, c] of o)
          l[i(u)] = i(c);
        return l;
      }
      case cl:
        return n(new Date(o), r);
      case dl: {
        const { source: l, flags: u } = o;
        return n(new RegExp(l, u), r);
      }
      case hl: {
        const l = n(/* @__PURE__ */ new Map(), r);
        for (const [u, c] of o)
          l.set(i(u), i(c));
        return l;
      }
      case pl: {
        const l = n(/* @__PURE__ */ new Set(), r);
        for (const u of o)
          l.add(i(u));
        return l;
      }
      case dp: {
        const { name: l, message: u } = o;
        return n(new bc[l](u), r);
      }
      case hp:
        return n(BigInt(o), r);
      case "BigInt":
        return n(Object(BigInt(o)), r);
      case "ArrayBuffer":
        return n(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: l } = new Uint8Array(o);
        return n(new DataView(l), o);
      }
    }
    return n(new bc[s](o), r);
  };
  return i;
}, yc = (e) => lv(/* @__PURE__ */ new Map(), e)(0), Wi = "", { toString: uv } = {}, { keys: cv } = Object, Dr = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [Qs, t];
  const n = uv.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Hr, Wi];
    case "Object":
      return [Bs, Wi];
    case "Date":
      return [cl, Wi];
    case "RegExp":
      return [dl, Wi];
    case "Map":
      return [hl, Wi];
    case "Set":
      return [pl, Wi];
    case "DataView":
      return [Hr, n];
  }
  return n.includes("Array") ? [Hr, n] : n.includes("Error") ? [dp, n] : [Bs, n];
}, _s = ([e, t]) => e === Qs && (t === "function" || t === "symbol"), dv = (e, t, n, i) => {
  const r = (o, l) => {
    const u = i.push(o) - 1;
    return n.set(l, u), u;
  }, s = (o) => {
    if (n.has(o))
      return n.get(o);
    let [l, u] = Dr(o);
    switch (l) {
      case Qs: {
        let d = o;
        switch (u) {
          case "bigint":
            l = hp, d = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            d = null;
            break;
          case "undefined":
            return r([cp], o);
        }
        return r([l, d], o);
      }
      case Hr: {
        if (u) {
          let m = o;
          return u === "DataView" ? m = new Uint8Array(o.buffer) : u === "ArrayBuffer" && (m = new Uint8Array(o)), r([u, [...m]], o);
        }
        const d = [], h = r([l, d], o);
        for (const m of o)
          d.push(s(m));
        return h;
      }
      case Bs: {
        if (u)
          switch (u) {
            case "BigInt":
              return r([u, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return r([u, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return s(o.toJSON());
        const d = [], h = r([l, d], o);
        for (const m of cv(o))
          (e || !_s(Dr(o[m]))) && d.push([s(m), s(o[m])]);
        return h;
      }
      case cl:
        return r([l, o.toISOString()], o);
      case dl: {
        const { source: d, flags: h } = o;
        return r([l, { source: d, flags: h }], o);
      }
      case hl: {
        const d = [], h = r([l, d], o);
        for (const [m, _] of o)
          (e || !(_s(Dr(m)) || _s(Dr(_)))) && d.push([s(m), s(_)]);
        return h;
      }
      case pl: {
        const d = [], h = r([l, d], o);
        for (const m of o)
          (e || !_s(Dr(m))) && d.push(s(m));
        return h;
      }
    }
    const { message: c } = o;
    return r([l, { name: u, message: c }], o);
  };
  return s;
}, vc = (e, { json: t, lossy: n } = {}) => {
  const i = [];
  return dv(!(t || n), !!t, /* @__PURE__ */ new Map(), i)(e), i;
}, zs = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? yc(vc(e, t)) : structuredClone(e)
) : (e, t) => yc(vc(e, t));
function hv(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function pv(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function fv(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || hv, i = e.options.footnoteBackLabel || pv, r = e.options.footnoteLabel || "Footnotes", s = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!c)
      continue;
    const d = e.all(c), h = String(c.identifier).toUpperCase(), m = _r(h.toLowerCase());
    let _ = 0;
    const y = [], v = e.footnoteCounts.get(h);
    for (; v !== void 0 && ++_ <= v; ) {
      y.length > 0 && y.push({ type: "text", value: " " });
      let A = typeof n == "string" ? n : n(u, _);
      typeof A == "string" && (A = { type: "text", value: A }), y.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + m + (_ > 1 ? "-" + _ : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, _),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(A) ? A : [A]
      });
    }
    const w = d[d.length - 1];
    if (w && w.type === "element" && w.tagName === "p") {
      const A = w.children[w.children.length - 1];
      A && A.type === "text" ? A.value += " " : w.children.push({ type: "text", value: " " }), w.children.push(...y);
    } else
      d.push(...y);
    const x = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + m },
      children: e.wrap(d, !0)
    };
    e.patch(c, x), l.push(x);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: s,
          properties: {
            ...zs(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: r }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const ea = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return xv;
    if (typeof e == "function")
      return ta(e);
    if (typeof e == "object")
      return Array.isArray(e) ? mv(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        _v(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return gv(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function mv(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = ea(e[n]);
  return ta(i);
  function i(...r) {
    let s = -1;
    for (; ++s < t.length; )
      if (t[s].apply(this, r)) return !0;
    return !1;
  }
}
function _v(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return ta(n);
  function n(i) {
    const r = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let s;
    for (s in e)
      if (r[s] !== t[s]) return !1;
    return !0;
  }
}
function gv(e) {
  return ta(t);
  function t(n) {
    return n && n.type === e;
  }
}
function ta(e) {
  return t;
  function t(n, i, r) {
    return !!(bv(n) && e.call(
      this,
      n,
      typeof i == "number" ? i : void 0,
      r || void 0
    ));
  }
}
function xv() {
  return !0;
}
function bv(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const pp = [], yv = !0, Eo = !1, vv = "skip";
function fp(e, t, n, i) {
  let r;
  typeof t == "function" && typeof n != "function" ? (i = n, n = t) : r = t;
  const s = ea(r), o = i ? -1 : 1;
  l(e, void 0, [])();
  function l(u, c, d) {
    const h = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof h.type == "string") {
      const _ = (
        // `hast`
        typeof h.tagName == "string" ? h.tagName : (
          // `xast`
          typeof h.name == "string" ? h.name : void 0
        )
      );
      Object.defineProperty(m, "name", {
        value: "node (" + (u.type + (_ ? "<" + _ + ">" : "")) + ")"
      });
    }
    return m;
    function m() {
      let _ = pp, y, v, w;
      if ((!t || s(u, c, d[d.length - 1] || void 0)) && (_ = wv(n(u, d)), _[0] === Eo))
        return _;
      if ("children" in u && u.children) {
        const x = (
          /** @type {UnistParent} */
          u
        );
        if (x.children && _[0] !== vv)
          for (v = (i ? x.children.length : -1) + o, w = d.concat(x); v > -1 && v < x.children.length; ) {
            const A = x.children[v];
            if (y = l(A, v, w)(), y[0] === Eo)
              return y;
            v = typeof y[1] == "number" ? y[1] : v + o;
          }
      }
      return _;
    }
  }
}
function wv(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [yv, e] : e == null ? pp : [e];
}
function na(e, t, n, i) {
  let r, s, o;
  typeof t == "function" && typeof n != "function" ? (s = void 0, o = t, r = n) : (s = t, o = n, r = i), fp(e, s, l, r);
  function l(u, c) {
    const d = c[c.length - 1], h = d ? d.children.indexOf(u) : void 0;
    return o(u, h, d);
  }
}
const Ao = {}.hasOwnProperty, kv = {};
function Cv(e, t) {
  const n = t || kv, i = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), o = { ...ov, ...n.handlers }, l = {
    all: c,
    applyData: Ev,
    definitionById: i,
    footnoteById: r,
    footnoteCounts: s,
    footnoteOrder: [],
    handlers: o,
    one: u,
    options: n,
    patch: Sv,
    wrap: Iv
  };
  return na(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const h = d.type === "definition" ? i : r, m = String(d.identifier).toUpperCase();
      h.has(m) || h.set(m, d);
    }
  }), l;
  function u(d, h) {
    const m = d.type, _ = l.handlers[m];
    if (Ao.call(l.handlers, m) && _)
      return _(l, d, h);
    if (l.options.passThrough && l.options.passThrough.includes(m)) {
      if ("children" in d) {
        const { children: v, ...w } = d, x = zs(w);
        return x.children = l.all(d), x;
      }
      return zs(d);
    }
    return (l.options.unknownHandler || Av)(l, d, h);
  }
  function c(d) {
    const h = [];
    if ("children" in d) {
      const m = d.children;
      let _ = -1;
      for (; ++_ < m.length; ) {
        const y = l.one(m[_], d);
        if (y) {
          if (_ && m[_ - 1].type === "break" && (!Array.isArray(y) && y.type === "text" && (y.value = wc(y.value)), !Array.isArray(y) && y.type === "element")) {
            const v = y.children[0];
            v && v.type === "text" && (v.value = wc(v.value));
          }
          Array.isArray(y) ? h.push(...y) : h.push(y);
        }
      }
    }
    return h;
  }
}
function Sv(e, t) {
  e.position && (t.position = sh(e));
}
function Ev(e, t) {
  let n = t;
  if (e && e.data) {
    const i = e.data.hName, r = e.data.hChildren, s = e.data.hProperties;
    if (typeof i == "string")
      if (n.type === "element")
        n.tagName = i;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: i, properties: {}, children: o };
      }
    n.type === "element" && s && Object.assign(n.properties, zs(s)), "children" in n && n.children && r !== null && r !== void 0 && (n.children = r);
  }
  return n;
}
function Av(e, t) {
  const n = t.data || {}, i = "value" in t && !(Ao.call(n, "hProperties") || Ao.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function Iv(e, t) {
  const n = [];
  let i = -1;
  for (t && n.push({ type: "text", value: `
` }); ++i < e.length; )
    i && n.push({ type: "text", value: `
` }), n.push(e[i]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function wc(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function kc(e, t) {
  const n = Cv(e, t), i = n.one(e, void 0), r = fv(n), s = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return r && s.children.push({ type: "text", value: `
` }, r), s;
}
function Lv(e, t) {
  return e && "run" in e ? async function(n, i) {
    const r = (
      /** @type {HastRoot} */
      kc(n, { file: i, ...t })
    );
    await e.run(r, i);
  } : function(n, i) {
    return (
      /** @type {HastRoot} */
      kc(n, { file: i, ...e || t })
    );
  };
}
function Cc(e) {
  if (e)
    throw e;
}
var Ma, Sc;
function Nv() {
  if (Sc) return Ma;
  Sc = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, i = Object.getOwnPropertyDescriptor, r = function(c) {
    return typeof Array.isArray == "function" ? Array.isArray(c) : t.call(c) === "[object Array]";
  }, s = function(c) {
    if (!c || t.call(c) !== "[object Object]")
      return !1;
    var d = e.call(c, "constructor"), h = c.constructor && c.constructor.prototype && e.call(c.constructor.prototype, "isPrototypeOf");
    if (c.constructor && !d && !h)
      return !1;
    var m;
    for (m in c)
      ;
    return typeof m > "u" || e.call(c, m);
  }, o = function(c, d) {
    n && d.name === "__proto__" ? n(c, d.name, {
      enumerable: !0,
      configurable: !0,
      value: d.newValue,
      writable: !0
    }) : c[d.name] = d.newValue;
  }, l = function(c, d) {
    if (d === "__proto__")
      if (e.call(c, d)) {
        if (i)
          return i(c, d).value;
      } else return;
    return c[d];
  };
  return Ma = function u() {
    var c, d, h, m, _, y, v = arguments[0], w = 1, x = arguments.length, A = !1;
    for (typeof v == "boolean" && (A = v, v = arguments[1] || {}, w = 2), (v == null || typeof v != "object" && typeof v != "function") && (v = {}); w < x; ++w)
      if (c = arguments[w], c != null)
        for (d in c)
          h = l(v, d), m = l(c, d), v !== m && (A && m && (s(m) || (_ = r(m))) ? (_ ? (_ = !1, y = h && r(h) ? h : []) : y = h && s(h) ? h : {}, o(v, { name: d, newValue: u(A, y, m) })) : typeof m < "u" && o(v, { name: d, newValue: m }));
    return v;
  }, Ma;
}
var Tv = Nv();
const Va = /* @__PURE__ */ Xr(Tv);
function Io(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Pv() {
  const e = [], t = { run: n, use: i };
  return t;
  function n(...r) {
    let s = -1;
    const o = r.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    l(null, ...r);
    function l(u, ...c) {
      const d = e[++s];
      let h = -1;
      if (u) {
        o(u);
        return;
      }
      for (; ++h < r.length; )
        (c[h] === null || c[h] === void 0) && (c[h] = r[h]);
      r = c, d ? Dv(d, l)(...c) : o(null, ...c);
    }
  }
  function i(r) {
    if (typeof r != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + r
      );
    return e.push(r), t;
  }
}
function Dv(e, t) {
  let n;
  return i;
  function i(...o) {
    const l = e.length > o.length;
    let u;
    l && o.push(r);
    try {
      u = e.apply(this, o);
    } catch (c) {
      const d = (
        /** @type {Error} */
        c
      );
      if (l && n)
        throw d;
      return r(d);
    }
    l || (u && u.then && typeof u.then == "function" ? u.then(s, r) : u instanceof Error ? r(u) : s(u));
  }
  function r(o, ...l) {
    n || (n = !0, t(o, ...l));
  }
  function s(o) {
    r(null, o);
  }
}
const Mv = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), r = i[e], s = function() {
      return r.apply(s, arguments);
    };
    return Object.setPrototypeOf(s, i), s;
  })
), Vv = {}.hasOwnProperty;
class fl extends Mv {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = Pv();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new fl()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const i = this.attachers[n];
      t.use(...i);
    }
    return t.data(Va(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (Oa("data", this.frozen), this.namespace[t] = n, this) : Vv.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (Oa("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const r = n.call(t, ...i);
      typeof r == "function" && this.transformers.use(r);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = gs(t), i = this.parser || this.Parser;
    return Fa("parse", i), i(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const i = this;
    return this.freeze(), Fa("process", this.parser || this.Parser), Ra("process", this.compiler || this.Compiler), n ? r(void 0, n) : new Promise(r);
    function r(s, o) {
      const l = gs(t), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(u, l, function(d, h, m) {
        if (d || !h || !m)
          return c(d);
        const _ = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          h
        ), y = i.stringify(_, m);
        Ov(y) ? m.value = y : m.result = y, c(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          m
        );
      });
      function c(d, h) {
        d || !h ? o(d) : s ? s(h) : n(void 0, h);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, i;
    return this.freeze(), Fa("processSync", this.parser || this.Parser), Ra("processSync", this.compiler || this.Compiler), this.process(t, r), Ac("processSync", "process", n), i;
    function r(s, o) {
      n = !0, Cc(s), i = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, i) {
    Ec(t), this.freeze();
    const r = this.transformers;
    return !i && typeof n == "function" && (i = n, n = void 0), i ? s(void 0, i) : new Promise(s);
    function s(o, l) {
      const u = gs(n);
      r.run(t, u, c);
      function c(d, h, m) {
        const _ = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          h || t
        );
        d ? l(d) : o ? o(_) : i(void 0, _, m);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let i = !1, r;
    return this.run(t, n, s), Ac("runSync", "run", i), r;
    function s(o, l) {
      Cc(o), r = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const i = gs(n), r = this.compiler || this.Compiler;
    return Ra("stringify", r), Ec(t), r(t, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const i = this.attachers, r = this.namespace;
    if (Oa("use", this.frozen), t != null) if (typeof t == "function")
      u(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? l(t) : o(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function s(c) {
      if (typeof c == "function")
        u(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [d, ...h] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          u(d, h);
        } else
          o(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function o(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(c.plugins), c.settings && (r.settings = Va(!0, r.settings, c.settings));
    }
    function l(c) {
      let d = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++d < c.length; ) {
          const h = c[d];
          s(h);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function u(c, d) {
      let h = -1, m = -1;
      for (; ++h < i.length; )
        if (i[h][0] === c) {
          m = h;
          break;
        }
      if (m === -1)
        i.push([c, ...d]);
      else if (d.length > 0) {
        let [_, ...y] = d;
        const v = i[m][1];
        Io(v) && Io(_) && (_ = Va(!0, v, _)), i[m] = [c, _, ...y];
      }
    }
  }
}
const Fv = new fl().freeze();
function Fa(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Ra(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Oa(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Ec(e) {
  if (!Io(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Ac(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function gs(e) {
  return Rv(e) ? e : new jd(e);
}
function Rv(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function Ov(e) {
  return typeof e == "string" || Bv(e);
}
function Bv(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
function oi(e, t) {
  const n = ["start", "end", "loc", "range"];
  let i = -1;
  for (; ++i < n.length; ) {
    const r = n[i];
    r in e && (t[r] = e[r]);
  }
}
function ml(e, t) {
  let n = -1;
  const i = [], r = [];
  let s;
  for (; ++n < e.length; ) {
    const o = e[n];
    o.type === "ImportNamespaceSpecifier" ? s = o : r.push(o);
  }
  if (s) {
    const o = {
      type: "VariableDeclarator",
      id: s.local,
      init: t
    };
    oi(s, o), i.push(o);
  }
  return i.push({
    type: "VariableDeclarator",
    id: {
      type: "ObjectPattern",
      properties: r.map(function(o) {
        let l = o.type === "ImportSpecifier" ? o.imported : o.type === "ExportSpecifier" ? o.exported : { type: "Identifier", name: "default" }, u = o.local;
        o.type === "ExportSpecifier" && (u = l, l = o.local), u.type;
        const c = {
          type: "Property",
          kind: "init",
          shorthand: l.type === "Identifier" && u.type === "Identifier" && l.name === u.name,
          method: !1,
          computed: !1,
          key: l,
          value: u
        };
        return oi(o, c), c;
      })
    },
    init: s ? { type: "Identifier", name: s.local.name } : t
  }), i;
}
function di(e) {
  let t = -1, n;
  for (; ++t < e.length; ) {
    const i = e[t], r = typeof i == "string" && Mn(i) ? { type: "Identifier", name: i } : { type: "Literal", value: i };
    n = n ? {
      type: "MemberExpression",
      object: n,
      property: r,
      computed: r.type === "Literal",
      optional: !1
    } : r;
  }
  return n.type, n;
}
function Ic(e) {
  let t = -1, n;
  for (; ++t < e.length; ) {
    const i = e[t];
    typeof i == "string" && Mn(i, { jsx: !0 });
    const r = { type: "JSXIdentifier", name: i };
    n = n ? { type: "JSXMemberExpression", object: n, property: r } : r;
  }
  return n;
}
function zv(e) {
  const { outputFormat: t } = e || {};
  return function(n) {
    if (n.comments && (n.comments = n.comments.filter(function(i) {
      return !i.data?._mdxIsPragmaComment;
    })), t === "function-body") {
      let i = 0;
      for (; i < n.body.length; ) {
        const s = n.body[i];
        if ("directive" in s && s.directive)
          i++;
        else
          break;
      }
      const r = n.body[i];
      r && r.type === "ImportDeclaration" && typeof r.source.value == "string" && /\/jsx-(dev-)?runtime$/.test(r.source.value) && (n.body[i] = {
        type: "VariableDeclaration",
        kind: "const",
        declarations: ml(
          r.specifiers,
          di(["arguments", 0])
        )
      });
    }
  };
}
function mp() {
  const e = [{ block: !1, defined: [] }];
  return { enter: t, exit: n, scopes: e };
  function t(s) {
    if (s.type === "ArrowFunctionExpression") {
      e.push({ block: !1, defined: [] });
      for (const o of s.params)
        r(o, !1);
    } else if (s.type === "BlockStatement" || s.type === "DoWhileStatement" || s.type === "ForInStatement" || s.type === "ForOfStatement" || s.type === "ForStatement" || s.type === "WhileStatement")
      e.push({ block: !0, defined: [] });
    else if (s.type === "CatchClause")
      e.push({ block: !0, defined: [] }), s.param && r(s.param, !0);
    else if (s.type === "ClassDeclaration")
      i(s.id.name, !1);
    else if (s.type === "FunctionDeclaration") {
      i(s.id.name, !1), e.push({ block: !1, defined: [] });
      for (const o of s.params)
        r(o, !1);
    } else if (s.type === "FunctionExpression") {
      s.id && i(s.id.name, !1), e.push({ block: !1, defined: [] });
      for (const o of s.params)
        r(o, !1);
    } else if (s.type === "ImportDeclaration")
      for (const o of s.specifiers)
        i(o.local.name, !1);
    else if (s.type === "VariableDeclaration")
      for (const o of s.declarations)
        r(o.id, s.kind !== "var");
  }
  function n(s) {
    if (s.type === "ArrowFunctionExpression" || s.type === "FunctionDeclaration" || s.type === "FunctionExpression") {
      const o = e.pop();
      o.block;
    } else if (s.type === "BlockStatement" || s.type === "CatchClause" || s.type === "DoWhileStatement" || s.type === "ForInStatement" || s.type === "ForOfStatement" || s.type === "ForStatement" || s.type === "WhileStatement") {
      const o = e.pop();
      o.block;
    }
  }
  function i(s, o) {
    let l = e.length, u;
    for (; l-- && (u = e[l], !(o || !u.block)); )
      ;
    u.defined.push(s);
  }
  function r(s, o) {
    if (s.type === "ArrayPattern")
      for (const l of s.elements)
        l && r(l, o);
    else if (s.type === "AssignmentPattern")
      r(s.left, o);
    else if (s.type === "Identifier")
      i(s.name, o);
    else if (s.type === "ObjectPattern")
      for (const l of s.properties)
        l.type === "Property" ? r(l.value, o) : (l.type, r(l, o));
    else
      s.type, r(s.argument, o);
  }
}
function jv(e) {
  return e.type === "FunctionDeclaration" ? { ...e, type: "FunctionExpression" } : (e.type, { ...e, type: "ClassExpression" });
}
function $v(e) {
  return e.type === "FunctionDeclaration" || e.type === "ClassDeclaration" || e.type === "VariableDeclaration";
}
function Hv(e) {
  const t = e.baseUrl || void 0, n = typeof t == "object" ? t.href : t, i = e.outputFormat || "program", r = e.pragma === void 0 ? "React.createElement" : e.pragma, s = e.pragmaFrag === void 0 ? "React.Fragment" : e.pragmaFrag, o = e.pragmaImportSource || "react", l = e.jsxImportSource || "react", u = e.jsxRuntime || "automatic";
  return function(d, h) {
    const m = [], _ = [];
    let y = 0, v, w, x;
    if (u === "classic" && s && xs(d, "@jsxFrag", s), u === "classic" && r && xs(d, "@jsx", r), u === "automatic" && l && xs(d, "@jsxImportSource", l), xs(d, "@jsxRuntime", u), u === "classic" && o) {
      if (!r)
        throw new Error(
          "Missing `pragma` in classic runtime with `pragmaImportSource`"
        );
      E({
        type: "ImportDeclaration",
        specifiers: [
          {
            type: "ImportDefaultSpecifier",
            local: { type: "Identifier", name: r.split(".")[0] }
          }
        ],
        attributes: [],
        source: { type: "Literal", value: o }
      });
    }
    for (x of d.body)
      if (x.type === "ExportDefaultDeclaration")
        v && h.fail(
          "Unexpected duplicate layout, expected a single layout (previous: " + _n(Zn(v)) + ")",
          {
            ancestors: [d, x],
            place: Zn(x),
            ruleId: "duplicate-layout",
            source: "recma-document"
          }
        ), v = x, _.push({
          type: "VariableDeclaration",
          kind: "const",
          declarations: [
            {
              type: "VariableDeclarator",
              id: { type: "Identifier", name: "MDXLayout" },
              init: $v(x.declaration) ? jv(x.declaration) : x.declaration
            }
          ]
        });
      else if (x.type === "ExportNamedDeclaration" && x.source) {
        const f = (
          /** @type {SimpleLiteral} */
          x.source
        );
        x.specifiers = x.specifiers.filter(function(C) {
          if (C.exported.type === "Identifier" && C.exported.name === "default") {
            v && h.fail(
              "Unexpected duplicate layout, expected a single layout (previous: " + _n(Zn(v)) + ")",
              {
                ancestors: [d, x, C],
                place: Zn(x),
                ruleId: "duplicate-layout",
                source: "recma-document"
              }
            ), v = C;
            const L = [];
            if (C.local.type === "Identifier" && C.local.name === "default")
              L.push({
                type: "ImportDefaultSpecifier",
                local: { type: "Identifier", name: "MDXLayout" }
              });
            else {
              const z = {
                type: "ImportSpecifier",
                imported: C.local,
                local: { type: "Identifier", name: "MDXLayout" }
              };
              oi(C.local, z), L.push(z);
            }
            const R = { type: "Literal", value: f.value };
            oi(f, R);
            const V = {
              type: "ImportDeclaration",
              specifiers: L,
              attributes: [],
              source: R
            };
            return oi(C, V), E(V), !1;
          }
          return !0;
        }), x.specifiers.length > 0 && N(x);
      } else x.type === "ExportNamedDeclaration" || x.type === "ExportAllDeclaration" ? N(x) : x.type === "ImportDeclaration" ? E(x) : x.type === "ExpressionStatement" && (x.expression.type === "JSXElement" || x.expression.type === "JSXFragment") ? (w = !0, _.push(
        ...c(x.expression, i, !!v)
      )) : _.push(x);
    w || _.push(
      ...c(void 0, i, !!v)
    ), m.push(["MDXContent", "default"]), i === "function-body" && _.push({
      type: "ReturnStatement",
      argument: {
        type: "ObjectExpression",
        properties: [
          ...Array.from({ length: y }).map(
            /**
             * @param {undefined} _
             *   Nothing.
             * @param {number} index
             *   Index.
             * @returns {SpreadElement}
             *   Node.
             */
            function(f, C) {
              return {
                type: "SpreadElement",
                argument: {
                  type: "Identifier",
                  name: "_exportAll" + (C + 1)
                }
              };
            }
          ),
          ...m.map(function(f) {
            return {
              type: "Property",
              kind: "init",
              method: !1,
              computed: !1,
              shorthand: typeof f == "string",
              key: {
                type: "Identifier",
                name: typeof f == "string" ? f : f[1]
              },
              value: {
                type: "Identifier",
                name: typeof f == "string" ? f : f[0]
              }
            };
          })
        ]
      }
    }), d.body = _;
    let A = !1, S = !1;
    (n || i === "function-body") && Qi(d, {
      enter(f) {
        if ((f.type === "ExportAllDeclaration" || f.type === "ExportNamedDeclaration" || f.type === "ImportDeclaration") && f.source) {
          let C = f.source.value;
          try {
            new URL(C);
          } catch {
            (C.startsWith("/") || C.startsWith("./") || C.startsWith("../")) && (C = new URL(C, n).href);
          }
          const L = { type: "Literal", value: C };
          oi(f.source, L), f.source = L;
          return;
        }
        if (f.type === "ImportExpression") {
          S = !0;
          const C = {
            type: "CallExpression",
            callee: { type: "Identifier", name: "_resolveDynamicMdxSpecifier" },
            arguments: [f.source],
            optional: !1
          };
          f.source = C;
          return;
        }
        if (f.type === "MemberExpression" && "object" in f && f.object.type === "MetaProperty" && f.property.type === "Identifier" && f.object.meta.name === "import" && f.object.property.name === "meta" && f.property.name === "url") {
          A = !0;
          const C = { type: "Identifier", name: "_importMetaUrl" };
          oi(f, C), this.replace(C);
        }
      }
    }), S && (n || (A = !0), d.body.push(
      Uv(
        n ? { type: "Literal", value: n } : { type: "Identifier", name: "_importMetaUrl" }
      )
    )), A && d.body.unshift(...qv());
    function N(f) {
      if (f.type === "ExportNamedDeclaration") {
        if (f.declaration) {
          const C = mp();
          Qi(f, {
            enter(L) {
              C.enter(L), (L.type === "ArrowFunctionExpression" || L.type === "FunctionDeclaration" || L.type === "FunctionExpression") && (this.skip(), C.exit(L));
            },
            leave: C.exit
          }), m.push(...C.scopes[0].defined);
        }
        for (x of f.specifiers)
          x.exported.type === "Identifier" ? m.push(x.exported.name) : (x.exported.value, m.push(x.exported.value));
      }
      E(f);
    }
    function E(f) {
      let C, L;
      if (i === "function-body")
        if (
          // Always have a source:
          f.type === "ImportDeclaration" || f.type === "ExportAllDeclaration" || // Source optional:
          f.type === "ExportNamedDeclaration" && f.source
        ) {
          f.source;
          const R = { type: "ImportExpression", source: f.source };
          oi(f, R), L = { type: "AwaitExpression", argument: R }, (f.type === "ImportDeclaration" || f.type === "ExportNamedDeclaration") && f.specifiers.length === 0 ? C = { type: "ExpressionStatement", expression: L } : C = {
            type: "VariableDeclaration",
            kind: "const",
            declarations: f.type === "ExportAllDeclaration" ? [
              {
                type: "VariableDeclarator",
                id: {
                  type: "Identifier",
                  name: "_exportAll" + ++y
                },
                init: L
              }
            ] : ml(f.specifiers, L)
          };
        } else if (f.declaration)
          C = f.declaration;
        else {
          const R = [];
          for (const V of f.specifiers)
            V.exported.type === "Identifier" && V.local.type === "Identifier" && V.local.name !== V.exported.name && R.push({
              type: "VariableDeclarator",
              id: V.exported,
              init: V.local
            });
          R.length > 0 && (C = {
            type: "VariableDeclaration",
            kind: "const",
            declarations: R
          });
        }
      else
        C = f;
      C && _.push(C);
    }
  };
  function c(d, h, m) {
    let y = {
      type: "JSXElement",
      openingElement: {
        type: "JSXOpeningElement",
        name: { type: "JSXIdentifier", name: "MDXLayout" },
        attributes: [
          {
            type: "JSXSpreadAttribute",
            argument: { type: "Identifier", name: "props" }
          }
        ],
        selfClosing: !1
      },
      closingElement: {
        type: "JSXClosingElement",
        name: { type: "JSXIdentifier", name: "MDXLayout" }
      },
      children: [
        {
          type: "JSXElement",
          openingElement: {
            type: "JSXOpeningElement",
            name: { type: "JSXIdentifier", name: "_createMdxContent" },
            attributes: [
              {
                type: "JSXSpreadAttribute",
                argument: { type: "Identifier", name: "props" }
              }
            ],
            selfClosing: !0
          },
          closingElement: null,
          children: []
        }
      ]
    };
    m || (y = {
      type: "ConditionalExpression",
      test: { type: "Identifier", name: "MDXLayout" },
      consequent: y,
      alternate: {
        type: "CallExpression",
        callee: { type: "Identifier", name: "_createMdxContent" },
        arguments: [{ type: "Identifier", name: "props" }],
        optional: !1
      }
    });
    let v = (
      // Cast because TS otherwise does not think `JSXFragment`s are expressions.
      /** @type {Readonly<Expression> | Readonly<JSXFragment>} */
      d || { type: "Identifier", name: "undefined" }
    );
    v.type === "JSXFragment" && v.children.length === 1 && v.children[0].type === "JSXElement" && (v = v.children[0]);
    let w = !1;
    Qi(v, {
      enter(A) {
        if (A.type === "ArrowFunctionExpression" || A.type === "FunctionDeclaration" || A.type === "FunctionExpression")
          return this.skip();
        (A.type === "AwaitExpression" || /* c8 ignore next 2 -- can only occur in a function (which then can
         * only be async, so skipped it) */
        A.type === "ForOfStatement" && A.await) && (w = !0);
      }
    });
    const x = {
      type: "FunctionDeclaration",
      id: { type: "Identifier", name: "MDXContent" },
      params: [
        {
          type: "AssignmentPattern",
          left: { type: "Identifier", name: "props" },
          right: { type: "ObjectExpression", properties: [] }
        }
      ],
      body: {
        type: "BlockStatement",
        body: [{ type: "ReturnStatement", argument: y }]
      }
    };
    return [
      {
        type: "FunctionDeclaration",
        async: w,
        id: { type: "Identifier", name: "_createMdxContent" },
        params: [{ type: "Identifier", name: "props" }],
        body: {
          type: "BlockStatement",
          body: [
            {
              type: "ReturnStatement",
              // Cast because TS doesn’t think `JSXFragment` is an expression.
              // eslint-disable-next-line object-shorthand
              argument: (
                /** @type {Expression} */
                v
              )
            }
          ]
        }
      },
      h === "program" ? { type: "ExportDefaultDeclaration", declaration: x } : x
    ];
  }
}
function xs(e, t, n) {
  e.comments?.unshift({
    type: "Block",
    value: t + " " + n,
    data: { _mdxIsPragmaComment: !0 }
  });
}
function Uv(e) {
  return {
    type: "FunctionDeclaration",
    id: { type: "Identifier", name: "_resolveDynamicMdxSpecifier" },
    generator: !1,
    async: !1,
    params: [{ type: "Identifier", name: "d" }],
    body: {
      type: "BlockStatement",
      body: [
        {
          type: "IfStatement",
          test: {
            type: "BinaryExpression",
            left: {
              type: "UnaryExpression",
              operator: "typeof",
              prefix: !0,
              argument: { type: "Identifier", name: "d" }
            },
            operator: "!==",
            right: { type: "Literal", value: "string" }
          },
          consequent: {
            type: "ReturnStatement",
            argument: { type: "Identifier", name: "d" }
          },
          alternate: null
        },
        // To do: use `URL.canParse` when widely supported (see commented
        // out code below).
        {
          type: "TryStatement",
          block: {
            type: "BlockStatement",
            body: [
              {
                type: "ExpressionStatement",
                expression: {
                  type: "NewExpression",
                  callee: { type: "Identifier", name: "URL" },
                  arguments: [{ type: "Identifier", name: "d" }]
                }
              },
              {
                type: "ReturnStatement",
                argument: { type: "Identifier", name: "d" }
              }
            ]
          },
          handler: {
            type: "CatchClause",
            param: null,
            body: { type: "BlockStatement", body: [] }
          },
          finalizer: null
        },
        // To do: use `URL.canParse` when widely supported.
        // {
        //   type: 'IfStatement',
        //   test: {
        //     type: 'CallExpression',
        //     callee: toIdOrMemberExpression(['URL', 'canParse']),
        //     arguments: [{type: 'Identifier', name: 'd'}],
        //     optional: false
        //   },
        //   consequent: {
        //     type: 'ReturnStatement',
        //     argument: {type: 'Identifier', name: 'd'}
        //   },
        //   alternate: null
        // },
        {
          type: "IfStatement",
          test: {
            type: "LogicalExpression",
            left: {
              type: "LogicalExpression",
              left: {
                type: "CallExpression",
                callee: di(["d", "startsWith"]),
                arguments: [{ type: "Literal", value: "/" }],
                optional: !1
              },
              operator: "||",
              right: {
                type: "CallExpression",
                callee: di(["d", "startsWith"]),
                arguments: [{ type: "Literal", value: "./" }],
                optional: !1
              }
            },
            operator: "||",
            right: {
              type: "CallExpression",
              callee: di(["d", "startsWith"]),
              arguments: [{ type: "Literal", value: "../" }],
              optional: !1
            }
          },
          consequent: {
            type: "ReturnStatement",
            argument: {
              type: "MemberExpression",
              object: {
                type: "NewExpression",
                callee: { type: "Identifier", name: "URL" },
                arguments: [{ type: "Identifier", name: "d" }, e]
              },
              property: { type: "Identifier", name: "href" },
              computed: !1,
              optional: !1
            }
          },
          alternate: null
        },
        {
          type: "ReturnStatement",
          argument: { type: "Identifier", name: "d" }
        }
      ]
    }
  };
}
function qv() {
  return [
    {
      type: "VariableDeclaration",
      declarations: [
        {
          type: "VariableDeclarator",
          id: { type: "Identifier", name: "_importMetaUrl" },
          init: di(["arguments", 0, "baseUrl"])
        }
      ],
      kind: "const"
    },
    {
      type: "IfStatement",
      test: {
        type: "UnaryExpression",
        operator: "!",
        prefix: !0,
        argument: { type: "Identifier", name: "_importMetaUrl" }
      },
      consequent: {
        type: "ThrowStatement",
        argument: {
          type: "NewExpression",
          callee: { type: "Identifier", name: "Error" },
          arguments: [
            {
              type: "Literal",
              value: "Unexpected missing `options.baseUrl` needed to support `export … from`, `import`, or `import.meta.url` when generating `function-body`"
            }
          ]
        }
      },
      alternate: null
    }
  ];
}
function Lc(e) {
  let t = -1, n;
  for (; ++t < e.length; ) {
    const i = e[t];
    n = n ? { type: "BinaryExpression", left: n, operator: "+", right: i } : i;
  }
  return n;
}
function Jv(e) {
  const { development: t, outputFormat: n, providerImportSource: i } = e;
  return function(r, s) {
    const o = mp(), l = [];
    let u = !1, c = !1;
    if (Qi(r, {
      enter(d) {
        o.enter(d), (d.type === "FunctionDeclaration" || d.type === "FunctionExpression" || d.type === "ArrowFunctionExpression") && (l.push({
          components: [],
          idToInvalidComponentName: /* @__PURE__ */ new Map(),
          node: d,
          objects: [],
          references: {},
          tags: []
        }), Zi(d, "MDXContent") && !Ba(o.scopes, "MDXLayout") && l[0].components.push("MDXLayout"));
        const h = l[0];
        if (!(!h || !Zi(h.node, "_createMdxContent") && !i) && d.type === "JSXElement") {
          let m = d.openingElement.name;
          if (m.type === "JSXMemberExpression") {
            const _ = [];
            for (; m.type === "JSXMemberExpression"; )
              _.unshift(m.property.name), m = m.object;
            _.unshift(m.name);
            const y = _.join("."), v = m.name, w = Ba(o.scopes, v);
            !Object.hasOwn(h.references, y) && (!w || // If the parent scope is `_createMdxContent`, then this
            // references a component we can add a check statement for.
            l.length === 1 && l[0].node.type === "FunctionDeclaration" && Zi(l[0].node, "_createMdxContent")) && (h.references[y] = { component: !0, node: d }), !h.objects.includes(v) && !w && h.objects.push(v);
          } else if (m.type !== "JSXNamespacedName") {
            if (Mn(m.name) && !/^[a-z]/.test(m.name)) {
              const _ = m.name;
              Ba(o.scopes, _) || (_ !== "MDXLayout" && !Object.hasOwn(h.references, _) && (h.references[_] = { component: !0, node: d }), h.components.includes(_) || h.components.push(_));
            } else if (!(d.data && d.data._mdxExplicitJsx)) {
              const _ = m.name;
              h.tags.includes(_) || h.tags.push(_);
              let y = ["_components", _];
              if (Mn(_) === !1) {
                let v = h.idToInvalidComponentName.get(_);
                v === void 0 && (v = `_component${h.idToInvalidComponentName.size}`, h.idToInvalidComponentName.set(
                  _,
                  v
                )), y = [v];
              }
              d.openingElement.name = Ic(y), d.closingElement && (d.closingElement.name = Ic(y));
            }
          }
        }
      },
      leave(d) {
        o.exit(d);
        const h = [], m = [], _ = [], y = [];
        if (d.type === "FunctionDeclaration" || d.type === "FunctionExpression" || d.type === "ArrowFunctionExpression") {
          const v = l[l.length - 1];
          let w;
          for (w of v.tags.sort())
            h.push({
              type: "Property",
              kind: "init",
              key: Mn(w) ? { type: "Identifier", name: w } : { type: "Literal", value: w },
              value: { type: "Literal", value: w },
              method: !1,
              shorthand: !1,
              computed: !1
            });
          m.push(...v.components);
          for (w of v.objects)
            m.includes(w) || m.push(w);
          m.sort();
          const x = [];
          if (h.length > 0 || m.length > 0 || v.idToInvalidComponentName.size > 0) {
            if (i && (u = !0, _.push({
              type: "CallExpression",
              callee: { type: "Identifier", name: "_provideComponents" },
              arguments: [],
              optional: !1
            })), (Zi(v.node, "MDXContent") || Zi(v.node, "_createMdxContent")) && _.push(di(["props", "components"])), h.length > 0 || _.length > 1)
              for (const C of _)
                h.push({ type: "SpreadElement", argument: C });
            let E = h.length > 0 ? { type: "ObjectExpression", properties: h } : (
              // If we’re only getting components from `props.components`,
              // make sure it’s defined.
              {
                type: "LogicalExpression",
                operator: "||",
                left: _[0],
                right: { type: "ObjectExpression", properties: [] }
              }
            ), f;
            if (m.length > 0 && (f = {
              type: "ObjectPattern",
              properties: m.map(function(C) {
                return {
                  type: "Property",
                  kind: "init",
                  key: {
                    type: "Identifier",
                    name: C === "MDXLayout" ? "wrapper" : C
                  },
                  value: { type: "Identifier", name: C },
                  method: !1,
                  shorthand: C !== "MDXLayout",
                  computed: !1
                };
              })
            }), v.tags.length > 0 && (y.push({
              type: "VariableDeclarator",
              id: { type: "Identifier", name: "_components" },
              init: E
            }), E = { type: "Identifier", name: "_components" }), Zi(v.node, "_createMdxContent"))
              for (const [C, L] of [
                ...v.idToInvalidComponentName
              ].sort(function([R], [V]) {
                return R.localeCompare(V);
              }))
                y.push({
                  type: "VariableDeclarator",
                  id: {
                    type: "Identifier",
                    name: L
                  },
                  init: {
                    type: "MemberExpression",
                    object: { type: "Identifier", name: "_components" },
                    property: { type: "Literal", value: C },
                    computed: !0,
                    optional: !1
                  }
                });
            f && y.push({
              type: "VariableDeclarator",
              id: f,
              init: E
            }), y.length > 0 && x.push({
              type: "VariableDeclaration",
              kind: "const",
              declarations: y
            });
          }
          let A;
          for (A in v.references)
            if (Object.hasOwn(v.references, A)) {
              const E = A.split(".");
              let f = 0;
              for (; ++f < E.length; ) {
                const C = E.slice(0, f).join(".");
                Object.hasOwn(v.references, C) || (v.references[C] = {
                  component: !1,
                  node: v.references[A].node
                });
              }
            }
          const S = Object.keys(v.references).sort();
          let N = -1;
          for (; ++N < S.length; ) {
            const E = S[N], f = v.references[E], C = _n(Zn(f.node)), L = [
              { type: "Literal", value: E },
              { type: "Literal", value: f.component }
            ];
            c = !0, t && C && L.push({ type: "Literal", value: C }), x.push({
              type: "IfStatement",
              test: {
                type: "UnaryExpression",
                operator: "!",
                prefix: !0,
                argument: di(E.split("."))
              },
              consequent: {
                type: "ExpressionStatement",
                expression: {
                  type: "CallExpression",
                  callee: { type: "Identifier", name: "_missingMdxReference" },
                  arguments: L,
                  optional: !1
                }
              },
              alternate: void 0
            });
          }
          x.length > 0 && (d.body.type !== "BlockStatement" && (d.body = {
            type: "BlockStatement",
            body: [{ type: "ReturnStatement", argument: d.body }]
          }), d.body.body.unshift(...x)), l.pop();
        }
      }
    }), u && i && r.body.unshift(
      Wv(i, n)
    ), c) {
      const d = [
        { type: "Literal", value: "Expected " },
        {
          type: "ConditionalExpression",
          test: { type: "Identifier", name: "component" },
          consequent: { type: "Literal", value: "component" },
          alternate: { type: "Literal", value: "object" }
        },
        { type: "Literal", value: " `" },
        { type: "Identifier", name: "id" },
        {
          type: "Literal",
          value: "` to be defined: you likely forgot to import, pass, or provide it."
        }
      ], h = [
        { type: "Identifier", name: "id" },
        { type: "Identifier", name: "component" }
      ];
      t && (d.push({
        type: "ConditionalExpression",
        test: { type: "Identifier", name: "place" },
        consequent: Lc([
          { type: "Literal", value: "\nIt’s referenced in your code at `" },
          { type: "Identifier", name: "place" },
          {
            type: "Literal",
            value: (s.path ? "` in `" + s.path : "") + "`"
          }
        ]),
        alternate: { type: "Literal", value: "" }
      }), h.push({ type: "Identifier", name: "place" })), r.body.push({
        type: "FunctionDeclaration",
        id: { type: "Identifier", name: "_missingMdxReference" },
        generator: !1,
        async: !1,
        params: h,
        body: {
          type: "BlockStatement",
          body: [
            {
              type: "ThrowStatement",
              argument: {
                type: "NewExpression",
                callee: { type: "Identifier", name: "Error" },
                arguments: [Lc(d)]
              }
            }
          ]
        }
      });
    }
    n === "function-body" && r.body.unshift({
      type: "ExpressionStatement",
      expression: { type: "Literal", value: "use strict" },
      directive: "use strict"
    });
  };
}
function Wv(e, t) {
  const n = [
    {
      type: "ImportSpecifier",
      imported: { type: "Identifier", name: "useMDXComponents" },
      local: { type: "Identifier", name: "_provideComponents" }
    }
  ];
  return t === "function-body" ? {
    type: "VariableDeclaration",
    kind: "const",
    declarations: ml(
      n,
      di(["arguments", 0])
    )
  } : {
    type: "ImportDeclaration",
    specifiers: n,
    attributes: [],
    source: { type: "Literal", value: e }
  };
}
function Zi(e, t) {
  return !!(e && "id" in e && e.id && e.id.name === t);
}
function Ba(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n].defined.includes(t))
      return !0;
  return !1;
}
function Zv() {
  return function(e) {
    na(e, "raw", function(t, n, i) {
      if (i && typeof n == "number")
        return i.children.splice(n, 1), n;
    });
  };
}
const Xv = /\s+/g, Gv = /[\t\n\v\f\r ]+/g;
function Kv(e, t) {
  t ? typeof t == "string" && (t = { style: t }) : t = {};
  const n = t.preserveLineEndings ? Yv : Qv;
  return String(e).replace(
    t.style === "html" ? Gv : Xv,
    t.trim ? e3(n) : n
  );
}
function Yv(e) {
  const t = /\r?\n|\r/.exec(e);
  return t ? t[0] : " ";
}
function Qv() {
  return " ";
}
function e3(e) {
  return t;
  function t(n, i, r) {
    return i === 0 || i + n.length === r.length ? "" : e(n);
  }
}
function t3() {
  return function(e) {
    na(e, function(t, n, i) {
      let r = -1, s = !0, o = !1;
      if (i && typeof n == "number" && t.type === "paragraph") {
        const l = t.children;
        for (; ++r < l.length; ) {
          const u = l[r];
          if (u.type === "mdxJsxTextElement" || u.type === "mdxTextExpression")
            o = !0;
          else if (!(u.type === "text" && Kv(u.value, { style: "html", trim: !0 }) === "")) {
            s = !1;
            break;
          }
        }
        if (s && o) {
          r = -1;
          const u = [];
          for (; ++r < l.length; ) {
            const c = l[r];
            c.type === "mdxJsxTextElement" && (c.type = "mdxJsxFlowElement"), c.type === "mdxTextExpression" && (c.type = "mdxFlowExpression"), c.type === "text" && /^[\t\r\n ]+$/.test(String(c.value)) || u.push(c);
          }
          return i.children.splice(n, 1, ...u), n;
        }
      }
      if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement") {
        const l = t.data || (t.data = {});
        l._mdxExplicitJsx = !0;
      }
      (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression" || t.type === "mdxjsEsm") && t.data && t.data.estree && Qi(t.data.estree, {
        enter(l) {
          if (l.type === "JSXElement") {
            const u = l.data || (l.data = {});
            u._mdxExplicitJsx = !0;
          }
        }
      });
    });
  };
}
const n3 = (
  /** @type {const} */
  [
    "mdxFlowExpression",
    "mdxJsxFlowElement",
    "mdxJsxTextElement",
    "mdxTextExpression",
    "mdxjsEsm"
  ]
);
let Nc = !1;
function i3(e) {
  const t = e || {};
  t.format, (t.jsxRuntime === "classic" || t.pragma || t.pragmaFrag || t.pragmaImportSource) && !Nc && (Nc = !0, console.warn(
    "Unexpected deprecated option `jsxRuntime: 'classic'`, `pragma`, `pragmaFrag`, or `pragmaImportSource`; see <https://mdxjs.com/migrating/v3/> on how to migrate"
  ));
  const n = Fv().use(Vy);
  t.format !== "md" && n.use(Qb);
  const i = t.remarkRehypeOptions || {};
  return n.use(t3).use(t.remarkPlugins || []).use(Lv, {
    ...i,
    allowDangerousHtml: !0,
    passThrough: [...i.passThrough || [], ...n3]
  }).use(t.rehypePlugins || []), t.format === "md" && n.use(Zv), n.use(U_, t).use(Hv, t).use(Jv, t), t.jsx || n.use(v2, t).use(zv, t), n.use(K2).use(Y2, t).use(t.recmaPlugins || []), n;
}
function r3(e, t) {
  const { file: n, options: i } = c2(e, t);
  return i3(i).process(n);
}
function s3(e) {
  const {
    Fragment: t,
    baseUrl: n,
    development: i,
    jsx: r,
    jsxDEV: s,
    jsxs: o,
    useMDXComponents: l,
    ...u
  } = e || {};
  if (!t) throw new Error("Expected `Fragment` given to `evaluate`");
  if (i) {
    if (!s) throw new Error("Expected `jsxDEV` given to `evaluate`");
  } else {
    if (!r) throw new Error("Expected `jsx` given to `evaluate`");
    if (!o) throw new Error("Expected `jsxs` given to `evaluate`");
  }
  return {
    compiletime: {
      ...u,
      development: i,
      outputFormat: "function-body",
      providerImportSource: l ? "#" : void 0
    },
    runtime: { Fragment: t, baseUrl: n, jsx: r, jsxDEV: s, jsxs: o, useMDXComponents: l }
  };
}
const a3 = Object.getPrototypeOf(_p).constructor;
async function _p(e, t) {
  return new a3(String(e))(t);
}
async function o3(e, t) {
  const { compiletime: n, runtime: i } = s3(t);
  return _p(await r3(e, n), i);
}
var za = { exports: {} }, Tc;
function l3() {
  return Tc || (Tc = 1, (function(e) {
    (function() {
      var t;
      t = e.exports = r, t.format = r, t.vsprintf = i, typeof console < "u" && typeof console.log == "function" && (t.printf = n);
      function n() {
        console.log(r.apply(null, arguments));
      }
      function i(s, o) {
        return r.apply(null, [s].concat(o));
      }
      function r(s) {
        for (var o = 1, l = [].slice.call(arguments), u = 0, c = s.length, d = "", h, m = !1, _, y, v = !1, w, x = function() {
          return l[o++];
        }, A = function() {
          for (var S = ""; /\d/.test(s[u]); )
            S += s[u++], h = s[u];
          return S.length > 0 ? parseInt(S) : null;
        }; u < c; ++u)
          if (h = s[u], m)
            switch (m = !1, h == "." ? (v = !1, h = s[++u]) : h == "0" && s[u + 1] == "." ? (v = !0, u += 2, h = s[u]) : v = !0, w = A(), h) {
              case "b":
                d += parseInt(x(), 10).toString(2);
                break;
              case "c":
                _ = x(), typeof _ == "string" || _ instanceof String ? d += _ : d += String.fromCharCode(parseInt(_, 10));
                break;
              case "d":
                d += parseInt(x(), 10);
                break;
              case "f":
                y = String(parseFloat(x()).toFixed(w || 6)), d += v ? y : y.replace(/^0/, "");
                break;
              case "j":
                d += JSON.stringify(x());
                break;
              case "o":
                d += "0" + parseInt(x(), 10).toString(8);
                break;
              case "s":
                d += x();
                break;
              case "x":
                d += "0x" + parseInt(x(), 10).toString(16);
                break;
              case "X":
                d += "0x" + parseInt(x(), 10).toString(16).toUpperCase();
                break;
              default:
                d += h;
                break;
            }
          else h === "%" ? m = !0 : d += h;
        return d;
      }
    })();
  })(za)), za.exports;
}
var u3 = l3();
const c3 = /* @__PURE__ */ Xr(u3), bs = Object.assign(Ci(Error), {
  eval: Ci(EvalError),
  range: Ci(RangeError),
  reference: Ci(ReferenceError),
  syntax: Ci(SyntaxError),
  type: Ci(TypeError),
  uri: Ci(URIError)
});
function Ci(e) {
  return t.displayName = e.displayName || e.name, t;
  function t(n, ...i) {
    const r = n && c3(n, ...i);
    return new e(r);
  }
}
const ys = {}.hasOwnProperty, Pc = {
  yaml: "-",
  toml: "+"
};
function _l(e) {
  const t = [];
  let n = -1;
  const i = Array.isArray(e) ? e : e ? [e] : ["yaml"];
  for (; ++n < i.length; )
    t[n] = d3(i[n]);
  return t;
}
function d3(e) {
  let t = e;
  if (typeof t == "string") {
    if (!ys.call(Pc, t))
      throw bs("Missing matter definition for `%s`", t);
    t = {
      type: t,
      marker: Pc[t]
    };
  } else if (typeof t != "object")
    throw bs("Expected matter to be an object, not `%j`", t);
  if (!ys.call(t, "type"))
    throw bs("Missing `type` in matter `%j`", t);
  if (!ys.call(t, "fence") && !ys.call(t, "marker"))
    throw bs("Missing `marker` or `fence` in matter `%j`", t);
  return t;
}
function h3(e) {
  const t = _l(e), n = {};
  let i = -1;
  for (; ++i < t.length; ) {
    const r = t[i], s = Lo(r, "open").charCodeAt(0), o = p3(r), l = n[s];
    Array.isArray(l) ? l.push(o) : n[s] = [o];
  }
  return {
    flow: n
  };
}
function p3(e) {
  const t = e.anywhere, n = (
    /** @type {TokenType} */
    e.type
  ), i = (
    /** @type {TokenType} */
    n + "Fence"
  ), r = (
    /** @type {TokenType} */
    i + "Sequence"
  ), s = (
    /** @type {TokenType} */
    n + "Value"
  ), o = {
    tokenize: d,
    partial: !0
  };
  let l, u = 0;
  return {
    tokenize: c,
    concrete: !0
  };
  function c(h, m, _) {
    const y = this;
    return v;
    function v(C) {
      const L = y.now();
      return (
        // Indent not allowed.
        L.column === 1 && // Normally, only allowed in first line.
        (L.line === 1 || t) && (l = Lo(e, "open"), u = 0, C === l.charCodeAt(u)) ? (h.enter(n), h.enter(i), h.enter(r), w(C)) : _(C)
      );
    }
    function w(C) {
      return u === l.length ? (h.exit(r), De(C) ? (h.enter("whitespace"), x(C)) : A(C)) : C === l.charCodeAt(u++) ? (h.consume(C), w) : _(C);
    }
    function x(C) {
      return De(C) ? (h.consume(C), x) : (h.exit("whitespace"), A(C));
    }
    function A(C) {
      return xe(C) ? (h.exit(i), h.enter("lineEnding"), h.consume(C), h.exit("lineEnding"), l = Lo(e, "close"), u = 0, h.attempt(o, f, S)) : _(C);
    }
    function S(C) {
      return C === null || xe(C) ? E(C) : (h.enter(s), N(C));
    }
    function N(C) {
      return C === null || xe(C) ? (h.exit(s), E(C)) : (h.consume(C), N);
    }
    function E(C) {
      return C === null ? _(C) : (h.enter("lineEnding"), h.consume(C), h.exit("lineEnding"), h.attempt(o, f, S));
    }
    function f(C) {
      return h.exit(n), m(C);
    }
  }
  function d(h, m, _) {
    let y = 0;
    return v;
    function v(S) {
      return S === l.charCodeAt(y) ? (h.enter(i), h.enter(r), w(S)) : _(S);
    }
    function w(S) {
      return y === l.length ? (h.exit(r), De(S) ? (h.enter("whitespace"), x(S)) : A(S)) : S === l.charCodeAt(y++) ? (h.consume(S), w) : _(S);
    }
    function x(S) {
      return De(S) ? (h.consume(S), x) : (h.exit("whitespace"), A(S));
    }
    function A(S) {
      return S === null || xe(S) ? (h.exit(i), m(S)) : _(S);
    }
  }
}
function Lo(e, t) {
  return e.marker ? Dc(e.marker, t).repeat(3) : (
    // @ts-expect-error: They’re mutually exclusive.
    Dc(e.fence, t)
  );
}
function Dc(e, t) {
  return typeof e == "string" ? e : e[t];
}
function gp(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function f3(e) {
  const t = _l(e), n = {}, i = {};
  let r = -1;
  for (; ++r < t.length; ) {
    const s = t[r];
    n[s.type] = m3(s), i[s.type] = _3, i[s.type + "Value"] = g3;
  }
  return { enter: n, exit: i };
}
function m3(e) {
  return t;
  function t(n) {
    this.enter({ type: e.type, value: "" }, n), this.buffer();
  }
}
function _3(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  this.exit(e), n.value = t.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
}
function g3(e) {
  this.config.enter.data.call(this, e), this.config.exit.data.call(this, e);
}
function x3(e) {
  const t = [], n = {}, i = _l(e);
  let r = -1;
  for (; ++r < i.length; ) {
    const s = i[r];
    n[s.type] = b3(s);
    const o = No(s, "open");
    t.push({
      atBreak: !0,
      character: o.charAt(0),
      after: gp(o.charAt(1))
    });
  }
  return { unsafe: t, handlers: n };
}
function b3(e) {
  const t = No(e, "open"), n = No(e, "close");
  return i;
  function i(r) {
    return t + (r.value ? `
` + r.value : "") + `
` + n;
  }
}
function No(e, t) {
  return e.marker ? Mc(e.marker, t).repeat(3) : (
    // @ts-expect-error: They’re mutually exclusive.
    Mc(e.fence, t)
  );
}
function Mc(e, t) {
  return typeof e == "string" ? e : e[t];
}
const y3 = "yaml";
function v3(e) {
  const t = (
    /** @type {Processor} */
    this
  ), n = e || y3, i = t.data(), r = i.micromarkExtensions || (i.micromarkExtensions = []), s = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), o = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  r.push(h3(n)), s.push(f3(n)), o.push(x3(n));
}
function w3(e, t, n) {
  const r = ea((n || {}).ignore || []), s = k3(t);
  let o = -1;
  for (; ++o < s.length; )
    fp(e, "text", l);
  function l(c, d) {
    let h = -1, m;
    for (; ++h < d.length; ) {
      const _ = d[h], y = m ? m.children : void 0;
      if (r(
        _,
        y ? y.indexOf(_) : void 0,
        m
      ))
        return;
      m = _;
    }
    if (m)
      return u(c, d);
  }
  function u(c, d) {
    const h = d[d.length - 1], m = s[o][0], _ = s[o][1];
    let y = 0;
    const w = h.children.indexOf(c);
    let x = !1, A = [];
    m.lastIndex = 0;
    let S = m.exec(c.value);
    for (; S; ) {
      const N = S.index, E = {
        index: S.index,
        input: S.input,
        stack: [...d, c]
      };
      let f = _(...S, E);
      if (typeof f == "string" && (f = f.length > 0 ? { type: "text", value: f } : void 0), f === !1 ? m.lastIndex = N + 1 : (y !== N && A.push({
        type: "text",
        value: c.value.slice(y, N)
      }), Array.isArray(f) ? A.push(...f) : f && A.push(f), y = N + S[0].length, x = !0), !m.global)
        break;
      S = m.exec(c.value);
    }
    return x ? (y < c.value.length && A.push({ type: "text", value: c.value.slice(y) }), h.children.splice(w, 1, ...A)) : A = [c], w + A.length;
  }
}
function k3(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let i = -1;
  for (; ++i < n.length; ) {
    const r = n[i];
    t.push([C3(r[0]), S3(r[1])]);
  }
  return t;
}
function C3(e) {
  return typeof e == "string" ? new RegExp(gp(e), "g") : e;
}
function S3(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const ja = "phrasing", $a = ["autolink", "link", "image", "label"];
function E3() {
  return {
    transforms: [D3],
    enter: {
      literalAutolink: I3,
      literalAutolinkEmail: Ha,
      literalAutolinkHttp: Ha,
      literalAutolinkWww: Ha
    },
    exit: {
      literalAutolink: P3,
      literalAutolinkEmail: T3,
      literalAutolinkHttp: L3,
      literalAutolinkWww: N3
    }
  };
}
function A3() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: ja,
        notInConstruct: $a
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: ja,
        notInConstruct: $a
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: ja,
        notInConstruct: $a
      }
    ]
  };
}
function I3(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Ha(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function L3(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function N3(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function T3(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function P3(e) {
  this.exit(e);
}
function D3(e) {
  w3(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, M3],
      [/(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu, V3]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function M3(e, t, n, i, r) {
  let s = "";
  if (!xp(r) || (/^w/i.test(t) && (n = t + n, t = "", s = "http://"), !F3(n)))
    return !1;
  const o = R3(n + i);
  if (!o[0]) return !1;
  const l = {
    type: "link",
    title: null,
    url: s + t + o[0],
    children: [{ type: "text", value: t + o[0] }]
  };
  return o[1] ? [l, { type: "text", value: o[1] }] : l;
}
function V3(e, t, n, i) {
  return (
    // Not an expected previous character.
    !xp(i, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function F3(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function R3(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], i = n.indexOf(")");
  const r = Ps(e, "(");
  let s = Ps(e, ")");
  for (; i !== -1 && r > s; )
    e += n.slice(0, i + 1), n = n.slice(i + 1), i = n.indexOf(")"), s++;
  return [e, n];
}
function xp(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Ht(n) || Ks(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
bp.peek = J3;
function O3() {
  this.buffer();
}
function B3(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function z3() {
  this.buffer();
}
function j3(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function $3(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = wn(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function H3(e) {
  this.exit(e);
}
function U3(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = wn(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function q3(e) {
  this.exit(e);
}
function J3() {
  return "[";
}
function bp(e, t, n, i) {
  const r = n.createTracker(i);
  let s = r.move("[^");
  const o = n.enter("footnoteReference"), l = n.enter("reference");
  return s += r.move(
    n.safe(n.associationId(e), { after: "]", before: s })
  ), l(), o(), s += r.move("]"), s;
}
function W3() {
  return {
    enter: {
      gfmFootnoteCallString: O3,
      gfmFootnoteCall: B3,
      gfmFootnoteDefinitionLabelString: z3,
      gfmFootnoteDefinition: j3
    },
    exit: {
      gfmFootnoteCallString: $3,
      gfmFootnoteCall: H3,
      gfmFootnoteDefinitionLabelString: U3,
      gfmFootnoteDefinition: q3
    }
  };
}
function Z3(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: n, footnoteReference: bp },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function n(i, r, s, o) {
    const l = s.createTracker(o);
    let u = l.move("[^");
    const c = s.enter("footnoteDefinition"), d = s.enter("label");
    return u += l.move(
      s.safe(s.associationId(i), { before: u, after: "]" })
    ), d(), u += l.move("]:"), i.children && i.children.length > 0 && (l.shift(4), u += l.move(
      (t ? `
` : " ") + s.indentLines(
        s.containerFlow(i, l.current()),
        t ? yp : X3
      )
    )), c(), u;
  }
}
function X3(e, t, n) {
  return t === 0 ? e : yp(e, t, n);
}
function yp(e, t, n) {
  return (n ? "" : "    ") + e;
}
const G3 = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
vp.peek = tw;
function K3() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: Q3 },
    exit: { strikethrough: ew }
  };
}
function Y3() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: G3
      }
    ],
    handlers: { delete: vp }
  };
}
function Q3(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function ew(e) {
  this.exit(e);
}
function vp(e, t, n, i) {
  const r = n.createTracker(i), s = n.enter("strikethrough");
  let o = r.move("~~");
  return o += n.containerPhrasing(e, {
    ...r.current(),
    before: o,
    after: "~"
  }), o += r.move("~~"), s(), o;
}
function tw() {
  return "~";
}
function nw(e) {
  return e.length;
}
function iw(e, t) {
  const n = t || {}, i = (n.align || []).concat(), r = n.stringLength || nw, s = [], o = [], l = [], u = [];
  let c = 0, d = -1;
  for (; ++d < e.length; ) {
    const v = [], w = [];
    let x = -1;
    for (e[d].length > c && (c = e[d].length); ++x < e[d].length; ) {
      const A = rw(e[d][x]);
      if (n.alignDelimiters !== !1) {
        const S = r(A);
        w[x] = S, (u[x] === void 0 || S > u[x]) && (u[x] = S);
      }
      v.push(A);
    }
    o[d] = v, l[d] = w;
  }
  let h = -1;
  if (typeof i == "object" && "length" in i)
    for (; ++h < c; )
      s[h] = Vc(i[h]);
  else {
    const v = Vc(i);
    for (; ++h < c; )
      s[h] = v;
  }
  h = -1;
  const m = [], _ = [];
  for (; ++h < c; ) {
    const v = s[h];
    let w = "", x = "";
    v === 99 ? (w = ":", x = ":") : v === 108 ? w = ":" : v === 114 && (x = ":");
    let A = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      u[h] - w.length - x.length
    );
    const S = w + "-".repeat(A) + x;
    n.alignDelimiters !== !1 && (A = w.length + A + x.length, A > u[h] && (u[h] = A), _[h] = A), m[h] = S;
  }
  o.splice(1, 0, m), l.splice(1, 0, _), d = -1;
  const y = [];
  for (; ++d < o.length; ) {
    const v = o[d], w = l[d];
    h = -1;
    const x = [];
    for (; ++h < c; ) {
      const A = v[h] || "";
      let S = "", N = "";
      if (n.alignDelimiters !== !1) {
        const E = u[h] - (w[h] || 0), f = s[h];
        f === 114 ? S = " ".repeat(E) : f === 99 ? E % 2 ? (S = " ".repeat(E / 2 + 0.5), N = " ".repeat(E / 2 - 0.5)) : (S = " ".repeat(E / 2), N = S) : N = " ".repeat(E);
      }
      n.delimiterStart !== !1 && !h && x.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && A === "") && (n.delimiterStart !== !1 || h) && x.push(" "), n.alignDelimiters !== !1 && x.push(S), x.push(A), n.alignDelimiters !== !1 && x.push(N), n.padding !== !1 && x.push(" "), (n.delimiterEnd !== !1 || h !== c - 1) && x.push("|");
    }
    y.push(
      n.delimiterEnd === !1 ? x.join("").replace(/ +$/, "") : x.join("")
    );
  }
  return y.join(`
`);
}
function rw(e) {
  return e == null ? "" : String(e);
}
function Vc(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function sw(e, t, n, i) {
  const r = n.enter("blockquote"), s = n.createTracker(i);
  s.move("> "), s.shift(2);
  const o = n.indentLines(
    n.containerFlow(e, s.current()),
    aw
  );
  return r(), o;
}
function aw(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function ow(e, t) {
  return Fc(e, t.inConstruct, !0) && !Fc(e, t.notInConstruct, !1);
}
function Fc(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let i = -1;
  for (; ++i < t.length; )
    if (e.includes(t[i]))
      return !0;
  return !1;
}
function Rc(e, t, n, i) {
  let r = -1;
  for (; ++r < n.unsafe.length; )
    if (n.unsafe[r].character === `
` && ow(n.stack, n.unsafe[r]))
      return /[ \t]/.test(i.before) ? "" : " ";
  return `\\
`;
}
function lw(e, t) {
  const n = String(e);
  let i = n.indexOf(t), r = i, s = 0, o = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; i !== -1; )
    i === r ? ++s > o && (o = s) : s = 1, r = i + t.length, i = n.indexOf(t, r);
  return o;
}
function uw(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function cw(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function dw(e, t, n, i) {
  const r = cw(n), s = e.value || "", o = r === "`" ? "GraveAccent" : "Tilde";
  if (uw(e, n)) {
    const h = n.enter("codeIndented"), m = n.indentLines(s, hw);
    return h(), m;
  }
  const l = n.createTracker(i), u = r.repeat(Math.max(lw(s, r) + 1, 3)), c = n.enter("codeFenced");
  let d = l.move(u);
  if (e.lang) {
    const h = n.enter(`codeFencedLang${o}`);
    d += l.move(
      n.safe(e.lang, {
        before: d,
        after: " ",
        encode: ["`"],
        ...l.current()
      })
    ), h();
  }
  if (e.lang && e.meta) {
    const h = n.enter(`codeFencedMeta${o}`);
    d += l.move(" "), d += l.move(
      n.safe(e.meta, {
        before: d,
        after: `
`,
        encode: ["`"],
        ...l.current()
      })
    ), h();
  }
  return d += l.move(`
`), s && (d += l.move(s + `
`)), d += l.move(u), c(), d;
}
function hw(e, t, n) {
  return (n ? "" : "    ") + e;
}
function gl(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function pw(e, t, n, i) {
  const r = gl(n), s = r === '"' ? "Quote" : "Apostrophe", o = n.enter("definition");
  let l = n.enter("label");
  const u = n.createTracker(i);
  let c = u.move("[");
  return c += u.move(
    n.safe(n.associationId(e), {
      before: c,
      after: "]",
      ...u.current()
    })
  ), c += u.move("]: "), l(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (l = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), l(), e.title && (l = n.enter(`title${s}`), c += u.move(" " + r), c += u.move(
    n.safe(e.title, {
      before: c,
      after: r,
      ...u.current()
    })
  ), c += u.move(r), l()), o(), c;
}
function fw(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function Zr(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function js(e, t, n) {
  const i = ir(e), r = ir(t);
  return i === void 0 ? r === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    n === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : i === 1 ? r === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : r === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
wp.peek = mw;
function wp(e, t, n, i) {
  const r = fw(n), s = n.enter("emphasis"), o = n.createTracker(i), l = o.move(r);
  let u = o.move(
    n.containerPhrasing(e, {
      after: r,
      before: l,
      ...o.current()
    })
  );
  const c = u.charCodeAt(0), d = js(
    i.before.charCodeAt(i.before.length - 1),
    c,
    r
  );
  d.inside && (u = Zr(c) + u.slice(1));
  const h = u.charCodeAt(u.length - 1), m = js(i.after.charCodeAt(0), h, r);
  m.inside && (u = u.slice(0, -1) + Zr(h));
  const _ = o.move(r);
  return s(), n.attentionEncodeSurroundingInfo = {
    after: m.outside,
    before: d.outside
  }, l + u + _;
}
function mw(e, t, n) {
  return n.options.emphasis || "*";
}
function _w(e, t) {
  let n = !1;
  return na(e, function(i) {
    if ("value" in i && /\r?\n|\r/.test(i.value) || i.type === "break")
      return n = !0, Eo;
  }), !!((!e.depth || e.depth < 3) && ul(e) && (t.options.setext || n));
}
function gw(e, t, n, i) {
  const r = Math.max(Math.min(6, e.depth || 1), 1), s = n.createTracker(i);
  if (_w(e, n)) {
    const d = n.enter("headingSetext"), h = n.enter("phrasing"), m = n.containerPhrasing(e, {
      ...s.current(),
      before: `
`,
      after: `
`
    });
    return h(), d(), m + `
` + (r === 1 ? "=" : "-").repeat(
      // The whole size…
      m.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(m.lastIndexOf("\r"), m.lastIndexOf(`
`)) + 1)
    );
  }
  const o = "#".repeat(r), l = n.enter("headingAtx"), u = n.enter("phrasing");
  s.move(o + " ");
  let c = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...s.current()
  });
  return /^[\t ]/.test(c) && (c = Zr(c.charCodeAt(0)) + c.slice(1)), c = c ? o + " " + c : o, n.options.closeAtx && (c += " " + o), u(), l(), c;
}
kp.peek = xw;
function kp(e) {
  return e.value || "";
}
function xw() {
  return "<";
}
Cp.peek = bw;
function Cp(e, t, n, i) {
  const r = gl(n), s = r === '"' ? "Quote" : "Apostrophe", o = n.enter("image");
  let l = n.enter("label");
  const u = n.createTracker(i);
  let c = u.move("![");
  return c += u.move(
    n.safe(e.alt, { before: c, after: "]", ...u.current() })
  ), c += u.move("]("), l(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (l = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (l = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), l(), e.title && (l = n.enter(`title${s}`), c += u.move(" " + r), c += u.move(
    n.safe(e.title, {
      before: c,
      after: r,
      ...u.current()
    })
  ), c += u.move(r), l()), c += u.move(")"), o(), c;
}
function bw() {
  return "!";
}
Sp.peek = yw;
function Sp(e, t, n, i) {
  const r = e.referenceType, s = n.enter("imageReference");
  let o = n.enter("label");
  const l = n.createTracker(i);
  let u = l.move("![");
  const c = n.safe(e.alt, {
    before: u,
    after: "]",
    ...l.current()
  });
  u += l.move(c + "]["), o();
  const d = n.stack;
  n.stack = [], o = n.enter("reference");
  const h = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...l.current()
  });
  return o(), n.stack = d, s(), r === "full" || !c || c !== h ? u += l.move(h + "]") : r === "shortcut" ? u = u.slice(0, -1) : u += l.move("]"), u;
}
function yw() {
  return "!";
}
Ep.peek = vw;
function Ep(e, t, n) {
  let i = e.value || "", r = "`", s = -1;
  for (; new RegExp("(^|[^`])" + r + "([^`]|$)").test(i); )
    r += "`";
  for (/[^ \r\n]/.test(i) && (/^[ \r\n]/.test(i) && /[ \r\n]$/.test(i) || /^`|`$/.test(i)) && (i = " " + i + " "); ++s < n.unsafe.length; ) {
    const o = n.unsafe[s], l = n.compilePattern(o);
    let u;
    if (o.atBreak)
      for (; u = l.exec(i); ) {
        let c = u.index;
        i.charCodeAt(c) === 10 && i.charCodeAt(c - 1) === 13 && c--, i = i.slice(0, c) + " " + i.slice(u.index + 1);
      }
  }
  return r + i + r;
}
function vw() {
  return "`";
}
function Ap(e, t) {
  const n = ul(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
Ip.peek = ww;
function Ip(e, t, n, i) {
  const r = gl(n), s = r === '"' ? "Quote" : "Apostrophe", o = n.createTracker(i);
  let l, u;
  if (Ap(e, n)) {
    const d = n.stack;
    n.stack = [], l = n.enter("autolink");
    let h = o.move("<");
    return h += o.move(
      n.containerPhrasing(e, {
        before: h,
        after: ">",
        ...o.current()
      })
    ), h += o.move(">"), l(), n.stack = d, h;
  }
  l = n.enter("link"), u = n.enter("label");
  let c = o.move("[");
  return c += o.move(
    n.containerPhrasing(e, {
      before: c,
      after: "](",
      ...o.current()
    })
  ), c += o.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = n.enter("destinationLiteral"), c += o.move("<"), c += o.move(
    n.safe(e.url, { before: c, after: ">", ...o.current() })
  ), c += o.move(">")) : (u = n.enter("destinationRaw"), c += o.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...o.current()
    })
  )), u(), e.title && (u = n.enter(`title${s}`), c += o.move(" " + r), c += o.move(
    n.safe(e.title, {
      before: c,
      after: r,
      ...o.current()
    })
  ), c += o.move(r), u()), c += o.move(")"), l(), c;
}
function ww(e, t, n) {
  return Ap(e, n) ? "<" : "[";
}
Lp.peek = kw;
function Lp(e, t, n, i) {
  const r = e.referenceType, s = n.enter("linkReference");
  let o = n.enter("label");
  const l = n.createTracker(i);
  let u = l.move("[");
  const c = n.containerPhrasing(e, {
    before: u,
    after: "]",
    ...l.current()
  });
  u += l.move(c + "]["), o();
  const d = n.stack;
  n.stack = [], o = n.enter("reference");
  const h = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...l.current()
  });
  return o(), n.stack = d, s(), r === "full" || !c || c !== h ? u += l.move(h + "]") : r === "shortcut" ? u = u.slice(0, -1) : u += l.move("]"), u;
}
function kw() {
  return "[";
}
function xl(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function Cw(e) {
  const t = xl(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function Sw(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function Np(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function Ew(e, t, n, i) {
  const r = n.enter("list"), s = n.bulletCurrent;
  let o = e.ordered ? Sw(n) : xl(n);
  const l = e.ordered ? o === "." ? ")" : "." : Cw(n);
  let u = t && n.bulletLastUsed ? o === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const d = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (o === "*" || o === "-") && // Empty first list item:
      d && (!d.children || !d.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), Np(n) === o && d
    ) {
      let h = -1;
      for (; ++h < e.children.length; ) {
        const m = e.children[h];
        if (m && m.type === "listItem" && m.children && m.children[0] && m.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (o = l), n.bulletCurrent = o;
  const c = n.containerFlow(e, i);
  return n.bulletLastUsed = o, n.bulletCurrent = s, r(), c;
}
function Aw(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function Iw(e, t, n, i) {
  const r = Aw(n);
  let s = n.bulletCurrent || xl(n);
  t && t.type === "list" && t.ordered && (s = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + s);
  let o = s.length + 1;
  (r === "tab" || r === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (o = Math.ceil(o / 4) * 4);
  const l = n.createTracker(i);
  l.move(s + " ".repeat(o - s.length)), l.shift(o);
  const u = n.enter("listItem"), c = n.indentLines(
    n.containerFlow(e, l.current()),
    d
  );
  return u(), c;
  function d(h, m, _) {
    return m ? (_ ? "" : " ".repeat(o)) + h : (_ ? s : s + " ".repeat(o - s.length)) + h;
  }
}
function Lw(e, t, n, i) {
  const r = n.enter("paragraph"), s = n.enter("phrasing"), o = n.containerPhrasing(e, i);
  return s(), r(), o;
}
const Nw = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  ea([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function Tw(e, t, n, i) {
  return (e.children.some(function(o) {
    return Nw(o);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, i);
}
function Pw(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
Tp.peek = Dw;
function Tp(e, t, n, i) {
  const r = Pw(n), s = n.enter("strong"), o = n.createTracker(i), l = o.move(r + r);
  let u = o.move(
    n.containerPhrasing(e, {
      after: r,
      before: l,
      ...o.current()
    })
  );
  const c = u.charCodeAt(0), d = js(
    i.before.charCodeAt(i.before.length - 1),
    c,
    r
  );
  d.inside && (u = Zr(c) + u.slice(1));
  const h = u.charCodeAt(u.length - 1), m = js(i.after.charCodeAt(0), h, r);
  m.inside && (u = u.slice(0, -1) + Zr(h));
  const _ = o.move(r + r);
  return s(), n.attentionEncodeSurroundingInfo = {
    after: m.outside,
    before: d.outside
  }, l + u + _;
}
function Dw(e, t, n) {
  return n.options.strong || "*";
}
function Mw(e, t, n, i) {
  return n.safe(e.value, i);
}
function Vw(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function Fw(e, t, n) {
  const i = (Np(n) + (n.options.ruleSpaces ? " " : "")).repeat(Vw(n));
  return n.options.ruleSpaces ? i.slice(0, -1) : i;
}
const Pp = {
  blockquote: sw,
  break: Rc,
  code: dw,
  definition: pw,
  emphasis: wp,
  hardBreak: Rc,
  heading: gw,
  html: kp,
  image: Cp,
  imageReference: Sp,
  inlineCode: Ep,
  link: Ip,
  linkReference: Lp,
  list: Ew,
  listItem: Iw,
  paragraph: Lw,
  root: Tw,
  strong: Tp,
  text: Mw,
  thematicBreak: Fw
};
function Rw() {
  return {
    enter: {
      table: Ow,
      tableData: Oc,
      tableHeader: Oc,
      tableRow: zw
    },
    exit: {
      codeText: jw,
      table: Bw,
      tableData: Ua,
      tableHeader: Ua,
      tableRow: Ua
    }
  };
}
function Ow(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function Bw(e) {
  this.exit(e), this.data.inTable = void 0;
}
function zw(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Ua(e) {
  this.exit(e);
}
function Oc(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function jw(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, $w));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function $w(e, t) {
  return t === "|" ? t : e;
}
function Hw(e) {
  const t = e || {}, n = t.tableCellPadding, i = t.tablePipeAlign, r = t.stringLength, s = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: m,
      table: o,
      tableCell: u,
      tableRow: l
    }
  };
  function o(_, y, v, w) {
    return c(d(_, v, w), _.align);
  }
  function l(_, y, v, w) {
    const x = h(_, v, w), A = c([x]);
    return A.slice(0, A.indexOf(`
`));
  }
  function u(_, y, v, w) {
    const x = v.enter("tableCell"), A = v.enter("phrasing"), S = v.containerPhrasing(_, {
      ...w,
      before: s,
      after: s
    });
    return A(), x(), S;
  }
  function c(_, y) {
    return iw(_, {
      align: y,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: i,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: r
    });
  }
  function d(_, y, v) {
    const w = _.children;
    let x = -1;
    const A = [], S = y.enter("table");
    for (; ++x < w.length; )
      A[x] = h(w[x], y, v);
    return S(), A;
  }
  function h(_, y, v) {
    const w = _.children;
    let x = -1;
    const A = [], S = y.enter("tableRow");
    for (; ++x < w.length; )
      A[x] = u(w[x], _, y, v);
    return S(), A;
  }
  function m(_, y, v) {
    let w = Pp.inlineCode(_, y, v);
    return v.stack.includes("tableCell") && (w = w.replace(/\|/g, "\\$&")), w;
  }
}
function Uw() {
  return {
    exit: {
      taskListCheckValueChecked: Bc,
      taskListCheckValueUnchecked: Bc,
      paragraph: Jw
    }
  };
}
function qw() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: Ww }
  };
}
function Bc(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function Jw(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const i = n.children[0];
    if (i && i.type === "text") {
      const r = t.children;
      let s = -1, o;
      for (; ++s < r.length; ) {
        const l = r[s];
        if (l.type === "paragraph") {
          o = l;
          break;
        }
      }
      o === n && (i.value = i.value.slice(1), i.value.length === 0 ? n.children.shift() : n.position && i.position && typeof i.position.start.offset == "number" && (i.position.start.column++, i.position.start.offset++, n.position.start = Object.assign({}, i.position.start)));
    }
  }
  this.exit(e);
}
function Ww(e, t, n, i) {
  const r = e.children[0], s = typeof e.checked == "boolean" && r && r.type === "paragraph", o = "[" + (e.checked ? "x" : " ") + "] ", l = n.createTracker(i);
  s && l.move(o);
  let u = Pp.listItem(e, t, n, {
    ...i,
    ...l.current()
  });
  return s && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, c)), u;
  function c(d) {
    return d + o;
  }
}
function Zw() {
  return [
    E3(),
    W3(),
    K3(),
    Rw(),
    Uw()
  ];
}
function Xw(e) {
  return {
    extensions: [
      A3(),
      Z3(e),
      Y3(),
      Hw(e),
      qw()
    ]
  };
}
const Gw = {
  tokenize: n4,
  partial: !0
}, Dp = {
  tokenize: i4,
  partial: !0
}, Mp = {
  tokenize: r4,
  partial: !0
}, Vp = {
  tokenize: s4,
  partial: !0
}, Kw = {
  tokenize: a4,
  partial: !0
}, Fp = {
  name: "wwwAutolink",
  tokenize: e4,
  previous: Op
}, Rp = {
  name: "protocolAutolink",
  tokenize: t4,
  previous: Bp
}, ii = {
  name: "emailAutolink",
  tokenize: Qw,
  previous: zp
}, jn = {};
function Yw() {
  return {
    text: jn
  };
}
let Si = 48;
for (; Si < 123; )
  jn[Si] = ii, Si++, Si === 58 ? Si = 65 : Si === 91 && (Si = 97);
jn[43] = ii;
jn[45] = ii;
jn[46] = ii;
jn[95] = ii;
jn[72] = [ii, Rp];
jn[104] = [ii, Rp];
jn[87] = [ii, Fp];
jn[119] = [ii, Fp];
function Qw(e, t, n) {
  const i = this;
  let r, s;
  return o;
  function o(h) {
    return !To(h) || !zp.call(i, i.previous) || bl(i.events) ? n(h) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), l(h));
  }
  function l(h) {
    return To(h) ? (e.consume(h), l) : h === 64 ? (e.consume(h), u) : n(h);
  }
  function u(h) {
    return h === 46 ? e.check(Kw, d, c)(h) : h === 45 || h === 95 || Bt(h) ? (s = !0, e.consume(h), u) : d(h);
  }
  function c(h) {
    return e.consume(h), r = !0, u;
  }
  function d(h) {
    return s && r && Ot(i.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(h)) : n(h);
  }
}
function e4(e, t, n) {
  const i = this;
  return r;
  function r(o) {
    return o !== 87 && o !== 119 || !Op.call(i, i.previous) || bl(i.events) ? n(o) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(Gw, e.attempt(Dp, e.attempt(Mp, s), n), n)(o));
  }
  function s(o) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(o);
  }
}
function t4(e, t, n) {
  const i = this;
  let r = "", s = !1;
  return o;
  function o(h) {
    return (h === 72 || h === 104) && Bp.call(i, i.previous) && !bl(i.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), r += String.fromCodePoint(h), e.consume(h), l) : n(h);
  }
  function l(h) {
    if (Ot(h) && r.length < 5)
      return r += String.fromCodePoint(h), e.consume(h), l;
    if (h === 58) {
      const m = r.toLowerCase();
      if (m === "http" || m === "https")
        return e.consume(h), u;
    }
    return n(h);
  }
  function u(h) {
    return h === 47 ? (e.consume(h), s ? c : (s = !0, u)) : n(h);
  }
  function c(h) {
    return h === null || Rs(h) || Xe(h) || Ht(h) || Ks(h) ? n(h) : e.attempt(Dp, e.attempt(Mp, d), n)(h);
  }
  function d(h) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(h);
  }
}
function n4(e, t, n) {
  let i = 0;
  return r;
  function r(o) {
    return (o === 87 || o === 119) && i < 3 ? (i++, e.consume(o), r) : o === 46 && i === 3 ? (e.consume(o), s) : n(o);
  }
  function s(o) {
    return o === null ? n(o) : t(o);
  }
}
function i4(e, t, n) {
  let i, r, s;
  return o;
  function o(c) {
    return c === 46 || c === 95 ? e.check(Vp, u, l)(c) : c === null || Xe(c) || Ht(c) || c !== 45 && Ks(c) ? u(c) : (s = !0, e.consume(c), o);
  }
  function l(c) {
    return c === 95 ? i = !0 : (r = i, i = void 0), e.consume(c), o;
  }
  function u(c) {
    return r || i || !s ? n(c) : t(c);
  }
}
function r4(e, t) {
  let n = 0, i = 0;
  return r;
  function r(o) {
    return o === 40 ? (n++, e.consume(o), r) : o === 41 && i < n ? s(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? e.check(Vp, t, s)(o) : o === null || Xe(o) || Ht(o) ? t(o) : (e.consume(o), r);
  }
  function s(o) {
    return o === 41 && i++, e.consume(o), r;
  }
}
function s4(e, t, n) {
  return i;
  function i(l) {
    return l === 33 || l === 34 || l === 39 || l === 41 || l === 42 || l === 44 || l === 46 || l === 58 || l === 59 || l === 63 || l === 95 || l === 126 ? (e.consume(l), i) : l === 38 ? (e.consume(l), s) : l === 93 ? (e.consume(l), r) : (
      // `<` is an end.
      l === 60 || // So is whitespace.
      l === null || Xe(l) || Ht(l) ? t(l) : n(l)
    );
  }
  function r(l) {
    return l === null || l === 40 || l === 91 || Xe(l) || Ht(l) ? t(l) : i(l);
  }
  function s(l) {
    return Ot(l) ? o(l) : n(l);
  }
  function o(l) {
    return l === 59 ? (e.consume(l), i) : Ot(l) ? (e.consume(l), o) : n(l);
  }
}
function a4(e, t, n) {
  return i;
  function i(s) {
    return e.consume(s), r;
  }
  function r(s) {
    return Bt(s) ? n(s) : t(s);
  }
}
function Op(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || Xe(e);
}
function Bp(e) {
  return !Ot(e);
}
function zp(e) {
  return !(e === 47 || To(e));
}
function To(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Bt(e);
}
function bl(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const i = e[t][1];
    if ((i.type === "labelLink" || i.type === "labelImage") && !i._balanced) {
      n = !0;
      break;
    }
    if (i._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const o4 = {
  tokenize: m4,
  partial: !0
};
function l4() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: h4,
        continuation: {
          tokenize: p4
        },
        exit: f4
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: d4
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: u4,
        resolveTo: c4
      }
    }
  };
}
function u4(e, t, n) {
  const i = this;
  let r = i.events.length;
  const s = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let o;
  for (; r--; ) {
    const u = i.events[r][1];
    if (u.type === "labelImage") {
      o = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return l;
  function l(u) {
    if (!o || !o._balanced)
      return n(u);
    const c = wn(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }));
    return c.codePointAt(0) !== 94 || !s.includes(c.slice(1)) ? n(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), t(u));
  }
}
function c4(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const i = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, r = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  r.end.column++, r.end.offset++, r.end._bufferIndex++;
  const s = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, r.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, o = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, s.start),
    end: Object.assign({}, s.end)
  }, l = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", i, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", r, t],
    ["exit", r, t],
    // Everything in between.
    ["enter", s, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", s, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", i, t]
  ];
  return e.splice(n, e.length - n + 1, ...l), e;
}
function d4(e, t, n) {
  const i = this, r = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let s = 0, o;
  return l;
  function l(h) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(h), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(h) {
    return h !== 94 ? n(h) : (e.enter("gfmFootnoteCallMarker"), e.consume(h), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", c);
  }
  function c(h) {
    if (
      // Too long.
      s > 999 || // Closing brace with nothing.
      h === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      h === null || h === 91 || Xe(h)
    )
      return n(h);
    if (h === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteCallString");
      return r.includes(wn(i.sliceSerialize(m))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(h), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(h);
    }
    return Xe(h) || (o = !0), s++, e.consume(h), h === 92 ? d : c;
  }
  function d(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), s++, c) : c(h);
  }
}
function h4(e, t, n) {
  const i = this, r = i.parser.gfmFootnotes || (i.parser.gfmFootnotes = []);
  let s, o = 0, l;
  return u;
  function u(y) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(y), e.exit("gfmFootnoteDefinitionLabelMarker"), c;
  }
  function c(y) {
    return y === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(y), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", d) : n(y);
  }
  function d(y) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      y === 93 && !l || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      y === null || y === 91 || Xe(y)
    )
      return n(y);
    if (y === 93) {
      e.exit("chunkString");
      const v = e.exit("gfmFootnoteDefinitionLabelString");
      return s = wn(i.sliceSerialize(v)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(y), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), m;
    }
    return Xe(y) || (l = !0), o++, e.consume(y), y === 92 ? h : d;
  }
  function h(y) {
    return y === 91 || y === 92 || y === 93 ? (e.consume(y), o++, d) : d(y);
  }
  function m(y) {
    return y === 58 ? (e.enter("definitionMarker"), e.consume(y), e.exit("definitionMarker"), r.includes(s) || r.push(s), Ue(e, _, "gfmFootnoteDefinitionWhitespace")) : n(y);
  }
  function _(y) {
    return t(y);
  }
}
function p4(e, t, n) {
  return e.check(mr, t, e.attempt(o4, t, n));
}
function f4(e) {
  e.exit("gfmFootnoteDefinition");
}
function m4(e, t, n) {
  const i = this;
  return Ue(e, r, "gfmFootnoteDefinitionIndent", 5);
  function r(s) {
    const o = i.events[i.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? t(s) : n(s);
  }
}
function _4(e) {
  let n = (e || {}).singleTilde;
  const i = {
    name: "strikethrough",
    tokenize: s,
    resolveAll: r
  };
  return n == null && (n = !0), {
    text: {
      126: i
    },
    insideSpan: {
      null: [i]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function r(o, l) {
    let u = -1;
    for (; ++u < o.length; )
      if (o[u][0] === "enter" && o[u][1].type === "strikethroughSequenceTemporary" && o[u][1]._close) {
        let c = u;
        for (; c--; )
          if (o[c][0] === "exit" && o[c][1].type === "strikethroughSequenceTemporary" && o[c][1]._open && // If the sizes are the same:
          o[u][1].end.offset - o[u][1].start.offset === o[c][1].end.offset - o[c][1].start.offset) {
            o[u][1].type = "strikethroughSequence", o[c][1].type = "strikethroughSequence";
            const d = {
              type: "strikethrough",
              start: Object.assign({}, o[c][1].start),
              end: Object.assign({}, o[u][1].end)
            }, h = {
              type: "strikethroughText",
              start: Object.assign({}, o[c][1].end),
              end: Object.assign({}, o[u][1].start)
            }, m = [["enter", d, l], ["enter", o[c][1], l], ["exit", o[c][1], l], ["enter", h, l]], _ = l.parser.constructs.insideSpan.null;
            _ && an(m, m.length, 0, Ys(_, o.slice(c + 1, u), l)), an(m, m.length, 0, [["exit", h, l], ["enter", o[u][1], l], ["exit", o[u][1], l], ["exit", d, l]]), an(o, c - 1, u - c + 3, m), u = c + m.length - 2;
            break;
          }
      }
    for (u = -1; ++u < o.length; )
      o[u][1].type === "strikethroughSequenceTemporary" && (o[u][1].type = "data");
    return o;
  }
  function s(o, l, u) {
    const c = this.previous, d = this.events;
    let h = 0;
    return m;
    function m(y) {
      return c === 126 && d[d.length - 1][1].type !== "characterEscape" ? u(y) : (o.enter("strikethroughSequenceTemporary"), _(y));
    }
    function _(y) {
      const v = ir(c);
      if (y === 126)
        return h > 1 ? u(y) : (o.consume(y), h++, _);
      if (h < 2 && !n) return u(y);
      const w = o.exit("strikethroughSequenceTemporary"), x = ir(y);
      return w._open = !x || x === 2 && !!v, w._close = !v || v === 2 && !!x, l(y);
    }
  }
}
class g4 {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, i) {
    x4(this, t, n, i);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(s, o) {
      return s[0] - o[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const i = [];
    for (; n > 0; )
      n -= 1, i.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    i.push(t.slice()), t.length = 0;
    let r = i.pop();
    for (; r; ) {
      for (const s of r)
        t.push(s);
      r = i.pop();
    }
    this.map.length = 0;
  }
}
function x4(e, t, n, i) {
  let r = 0;
  if (!(n === 0 && i.length === 0)) {
    for (; r < e.map.length; ) {
      if (e.map[r][0] === t) {
        e.map[r][1] += n, e.map[r][2].push(...i);
        return;
      }
      r += 1;
    }
    e.map.push([t, n, i]);
  }
}
function b4(e, t) {
  let n = !1;
  const i = [];
  for (; t < e.length; ) {
    const r = e[t];
    if (n) {
      if (r[0] === "enter")
        r[1].type === "tableContent" && i.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (r[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const s = i.length - 1;
          i[s] = i[s] === "left" ? "center" : "right";
        }
      } else if (r[1].type === "tableDelimiterRow")
        break;
    } else r[0] === "enter" && r[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return i;
}
function y4() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: v4,
        resolveAll: w4
      }
    }
  };
}
function v4(e, t, n) {
  const i = this;
  let r = 0, s = 0, o;
  return l;
  function l(V) {
    let z = i.events.length - 1;
    for (; z > -1; ) {
      const B = i.events[z][1].type;
      if (B === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      B === "linePrefix") z--;
      else break;
    }
    const $ = z > -1 ? i.events[z][1].type : null, H = $ === "tableHead" || $ === "tableRow" ? f : u;
    return H === f && i.parser.lazy[i.now().line] ? n(V) : H(V);
  }
  function u(V) {
    return e.enter("tableHead"), e.enter("tableRow"), c(V);
  }
  function c(V) {
    return V === 124 || (o = !0, s += 1), d(V);
  }
  function d(V) {
    return V === null ? n(V) : xe(V) ? s > 1 ? (s = 0, i.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(V), e.exit("lineEnding"), _) : n(V) : De(V) ? Ue(e, d, "whitespace")(V) : (s += 1, o && (o = !1, r += 1), V === 124 ? (e.enter("tableCellDivider"), e.consume(V), e.exit("tableCellDivider"), o = !0, d) : (e.enter("data"), h(V)));
  }
  function h(V) {
    return V === null || V === 124 || Xe(V) ? (e.exit("data"), d(V)) : (e.consume(V), V === 92 ? m : h);
  }
  function m(V) {
    return V === 92 || V === 124 ? (e.consume(V), h) : h(V);
  }
  function _(V) {
    return i.interrupt = !1, i.parser.lazy[i.now().line] ? n(V) : (e.enter("tableDelimiterRow"), o = !1, De(V) ? Ue(e, y, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(V) : y(V));
  }
  function y(V) {
    return V === 45 || V === 58 ? w(V) : V === 124 ? (o = !0, e.enter("tableCellDivider"), e.consume(V), e.exit("tableCellDivider"), v) : E(V);
  }
  function v(V) {
    return De(V) ? Ue(e, w, "whitespace")(V) : w(V);
  }
  function w(V) {
    return V === 58 ? (s += 1, o = !0, e.enter("tableDelimiterMarker"), e.consume(V), e.exit("tableDelimiterMarker"), x) : V === 45 ? (s += 1, x(V)) : V === null || xe(V) ? N(V) : E(V);
  }
  function x(V) {
    return V === 45 ? (e.enter("tableDelimiterFiller"), A(V)) : E(V);
  }
  function A(V) {
    return V === 45 ? (e.consume(V), A) : V === 58 ? (o = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(V), e.exit("tableDelimiterMarker"), S) : (e.exit("tableDelimiterFiller"), S(V));
  }
  function S(V) {
    return De(V) ? Ue(e, N, "whitespace")(V) : N(V);
  }
  function N(V) {
    return V === 124 ? y(V) : V === null || xe(V) ? !o || r !== s ? E(V) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(V)) : E(V);
  }
  function E(V) {
    return n(V);
  }
  function f(V) {
    return e.enter("tableRow"), C(V);
  }
  function C(V) {
    return V === 124 ? (e.enter("tableCellDivider"), e.consume(V), e.exit("tableCellDivider"), C) : V === null || xe(V) ? (e.exit("tableRow"), t(V)) : De(V) ? Ue(e, C, "whitespace")(V) : (e.enter("data"), L(V));
  }
  function L(V) {
    return V === null || V === 124 || Xe(V) ? (e.exit("data"), C(V)) : (e.consume(V), V === 92 ? R : L);
  }
  function R(V) {
    return V === 92 || V === 124 ? (e.consume(V), L) : L(V);
  }
}
function w4(e, t) {
  let n = -1, i = !0, r = 0, s = [0, 0, 0, 0], o = [0, 0, 0, 0], l = !1, u = 0, c, d, h;
  const m = new g4();
  for (; ++n < e.length; ) {
    const _ = e[n], y = _[1];
    _[0] === "enter" ? y.type === "tableHead" ? (l = !1, u !== 0 && (zc(m, t, u, c, d), d = void 0, u = 0), c = {
      type: "table",
      start: Object.assign({}, y.start),
      // Note: correct end is set later.
      end: Object.assign({}, y.end)
    }, m.add(n, 0, [["enter", c, t]])) : y.type === "tableRow" || y.type === "tableDelimiterRow" ? (i = !0, h = void 0, s = [0, 0, 0, 0], o = [0, n + 1, 0, 0], l && (l = !1, d = {
      type: "tableBody",
      start: Object.assign({}, y.start),
      // Note: correct end is set later.
      end: Object.assign({}, y.end)
    }, m.add(n, 0, [["enter", d, t]])), r = y.type === "tableDelimiterRow" ? 2 : d ? 3 : 1) : r && (y.type === "data" || y.type === "tableDelimiterMarker" || y.type === "tableDelimiterFiller") ? (i = !1, o[2] === 0 && (s[1] !== 0 && (o[0] = o[1], h = vs(m, t, s, r, void 0, h), s = [0, 0, 0, 0]), o[2] = n)) : y.type === "tableCellDivider" && (i ? i = !1 : (s[1] !== 0 && (o[0] = o[1], h = vs(m, t, s, r, void 0, h)), s = o, o = [s[1], n, 0, 0])) : y.type === "tableHead" ? (l = !0, u = n) : y.type === "tableRow" || y.type === "tableDelimiterRow" ? (u = n, s[1] !== 0 ? (o[0] = o[1], h = vs(m, t, s, r, n, h)) : o[1] !== 0 && (h = vs(m, t, o, r, n, h)), r = 0) : r && (y.type === "data" || y.type === "tableDelimiterMarker" || y.type === "tableDelimiterFiller") && (o[3] = n);
  }
  for (u !== 0 && zc(m, t, u, c, d), m.consume(t.events), n = -1; ++n < t.events.length; ) {
    const _ = t.events[n];
    _[0] === "enter" && _[1].type === "table" && (_[1]._align = b4(t.events, n));
  }
  return e;
}
function vs(e, t, n, i, r, s) {
  const o = i === 1 ? "tableHeader" : i === 2 ? "tableDelimiter" : "tableData", l = "tableContent";
  n[0] !== 0 && (s.end = Object.assign({}, Gi(t.events, n[0])), e.add(n[0], 0, [["exit", s, t]]));
  const u = Gi(t.events, n[1]);
  if (s = {
    type: o,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(n[1], 0, [["enter", s, t]]), n[2] !== 0) {
    const c = Gi(t.events, n[2]), d = Gi(t.events, n[3]), h = {
      type: l,
      start: Object.assign({}, c),
      end: Object.assign({}, d)
    };
    if (e.add(n[2], 0, [["enter", h, t]]), i !== 2) {
      const m = t.events[n[2]], _ = t.events[n[3]];
      if (m[1].end = Object.assign({}, _[1].end), m[1].type = "chunkText", m[1].contentType = "text", n[3] > n[2] + 1) {
        const y = n[2] + 1, v = n[3] - n[2] - 1;
        e.add(y, v, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", h, t]]);
  }
  return r !== void 0 && (s.end = Object.assign({}, Gi(t.events, r)), e.add(r, 0, [["exit", s, t]]), s = void 0), s;
}
function zc(e, t, n, i, r) {
  const s = [], o = Gi(t.events, n);
  r && (r.end = Object.assign({}, o), s.push(["exit", r, t])), i.end = Object.assign({}, o), s.push(["exit", i, t]), e.add(n + 1, 0, s);
}
function Gi(e, t) {
  const n = e[t], i = n[0] === "enter" ? "start" : "end";
  return n[1][i];
}
const k4 = {
  name: "tasklistCheck",
  tokenize: S4
};
function C4() {
  return {
    text: {
      91: k4
    }
  };
}
function S4(e, t, n) {
  const i = this;
  return r;
  function r(u) {
    return (
      // Exit if there’s stuff before.
      i.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !i._gfmTasklistFirstContentOfListItem ? n(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), s)
    );
  }
  function s(u) {
    return Xe(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), o) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), o) : n(u);
  }
  function o(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), l) : n(u);
  }
  function l(u) {
    return xe(u) ? t(u) : De(u) ? e.check({
      tokenize: E4
    }, t, n)(u) : n(u);
  }
}
function E4(e, t, n) {
  return Ue(e, i, "whitespace");
  function i(r) {
    return r === null ? n(r) : t(r);
  }
}
function A4(e) {
  return ll([
    Yw(),
    l4(),
    _4(e),
    y4(),
    C4()
  ]);
}
const I4 = {};
function L4(e) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), n = e || I4, i = t.data(), r = i.micromarkExtensions || (i.micromarkExtensions = []), s = i.fromMarkdownExtensions || (i.fromMarkdownExtensions = []), o = i.toMarkdownExtensions || (i.toMarkdownExtensions = []);
  r.push(A4(n)), s.push(Zw()), o.push(Xw(n));
}
function lk({ content: e, components: t = {} }) {
  const [n, i] = Ee(null), [r, s] = Ee(null);
  return me(() => {
    let o = !1;
    i(null), s(null);
    const l = {
      // `runtime` supplies jsx/jsxs/Fragment to the compiled MDX module.
      // The cast is required because the types between react/jsx-runtime and
      // EvaluateOptions don't perfectly overlap (known @mdx-js/mdx issue).
      ...Ef,
      remarkPlugins: [L4, v3]
    };
    return o3(e, l).then(({ default: u }) => {
      o || i(() => u);
    }).catch((u) => {
      o || s(u instanceof Error ? u : new Error(String(u)));
    }), () => {
      o = !0;
    };
  }, [e]), r ? /* @__PURE__ */ F("div", { className: "ns-mdx-error", role: "alert", children: [
    /* @__PURE__ */ g("strong", { children: "MDX rendering error:" }),
    " ",
    r.message
  ] }) : n ? /* @__PURE__ */ g(n, { components: { ...zd, ...t } }) : null;
}
const Ei = {
  "ns-data-card": "_ns-data-card_1xnme_1",
  "ns-data-card__action": "_ns-data-card__action_1xnme_12",
  "ns-data-card__heading": "_ns-data-card__heading_1xnme_17",
  "ns-data-card__list": "_ns-data-card__list_1xnme_25",
  "ns-data-card__property": "_ns-data-card__property_1xnme_31",
  "ns-data-card__term": "_ns-data-card__term_1xnme_36",
  "ns-data-card__value": "_ns-data-card__value_1xnme_45"
};
function N4(e) {
  return e == null || e === "" ? "—" : String(e);
}
const uk = ({
  "aria-label": e,
  heading: t,
  data: n,
  fields: i,
  action: r,
  onAction: s
}) => {
  const o = rt(), l = X({ [Ei["ns-data-card"]]: !0 }), u = !e && typeof t == "string";
  return /* @__PURE__ */ F(
    "section",
    {
      className: l,
      role: "group",
      "aria-label": u ? void 0 : e,
      "aria-labelledby": u ? o : void 0,
      children: [
        r ? /* @__PURE__ */ g("div", { className: Ei["ns-data-card__action"], children: /* @__PURE__ */ g(Ze, { ...r, onClick: () => s?.(r) }) }) : null,
        t != null ? /* @__PURE__ */ g("div", { id: u ? o : void 0, className: Ei["ns-data-card__heading"], children: t }) : null,
        /* @__PURE__ */ g("dl", { className: Ei["ns-data-card__list"], children: i.map((c) => /* @__PURE__ */ F("div", { className: Ei["ns-data-card__property"], children: [
          /* @__PURE__ */ g("dt", { className: Ei["ns-data-card__term"], children: c.label }),
          /* @__PURE__ */ g("dd", { className: Ei["ns-data-card__value"], children: c.transform ? c.transform(n[c.key]) : N4(n[c.key]) })
        ] }, c.key)) })
      ]
    }
  );
};
function ck(e) {
  return e;
}
function dk(e) {
  return e;
}
const jp = ei(null);
function $n() {
  const e = Fn(jp);
  if (e === null)
    throw new Error("DataTable compound components must be rendered inside <DataTable>.");
  return e;
}
const fe = {
  "ns-datatable": "_ns-datatable_s1tiw_1",
  "ns-datatable__toolbar": "_ns-datatable__toolbar_s1tiw_8",
  "ns-datatable__global-filter": "_ns-datatable__global-filter_s1tiw_12",
  "ns-datatable__global-filter-icon": "_ns-datatable__global-filter-icon_s1tiw_24",
  "ns-datatable__card": "_ns-datatable__card_s1tiw_36",
  "ns-datatable__scroll": "_ns-datatable__scroll_s1tiw_41",
  "ns-datatable__table": "_ns-datatable__table_s1tiw_48",
  "ns-datatable__caption": "_ns-datatable__caption_s1tiw_55",
  "ns-datatable__control-col": "_ns-datatable__control-col_s1tiw_63",
  "ns-datatable__head": "_ns-datatable__head_s1tiw_66",
  "ns-datatable__header-cell--align-center": "_ns-datatable__header-cell--align-center_s1tiw_85",
  "ns-datatable__header-inner": "_ns-datatable__header-inner_s1tiw_85",
  "ns-datatable__header-cell--align-end": "_ns-datatable__header-cell--align-end_s1tiw_88",
  "ns-datatable__header-cell": "_ns-datatable__header-cell_s1tiw_85",
  "ns-datatable__cell": "_ns-datatable__cell_s1tiw_92",
  "ns-datatable__header-text": "_ns-datatable__header-text_s1tiw_103",
  "ns-datatable__header-sub": "_ns-datatable__header-sub_s1tiw_108",
  "ns-datatable__sort-button": "_ns-datatable__sort-button_s1tiw_114",
  "ns-datatable__filter-button": "_ns-datatable__filter-button_s1tiw_115",
  "ns-datatable__kebab": "_ns-datatable__kebab_s1tiw_116",
  "ns-datatable__drag-handle": "_ns-datatable__drag-handle_s1tiw_117",
  "ns-datatable__expand-toggle": "_ns-datatable__expand-toggle_s1tiw_118",
  "ns-datatable__sort-icon": "_ns-datatable__sort-icon_s1tiw_145",
  "ns-datatable__filter-button--active": "_ns-datatable__filter-button--active_s1tiw_151",
  "ns-datatable__filter-field": "_ns-datatable__filter-field_s1tiw_154",
  "ns-datatable__filter-field-label": "_ns-datatable__filter-field-label_s1tiw_160",
  "ns-datatable__resize-handle": "_ns-datatable__resize-handle_s1tiw_175",
  "ns-datatable__control-cell": "_ns-datatable__control-cell_s1tiw_189",
  "ns-datatable__control-group": "_ns-datatable__control-group_s1tiw_195",
  "ns-datatable__row": "_ns-datatable__row_s1tiw_206",
  "ns-datatable__row--odd": "_ns-datatable__row--odd_s1tiw_206",
  "ns-datatable__row--even": "_ns-datatable__row--even_s1tiw_209",
  "ns-datatable__row--selected": "_ns-datatable__row--selected_s1tiw_212",
  "ns-datatable__row--dragging": "_ns-datatable__row--dragging_s1tiw_215",
  "ns-datatable__row--picked": "_ns-datatable__row--picked_s1tiw_218",
  "ns-datatable__row--drop-target": "_ns-datatable__row--drop-target_s1tiw_222",
  "ns-datatable__row--summary": "_ns-datatable__row--summary_s1tiw_225",
  "ns-datatable__cell--align-center": "_ns-datatable__cell--align-center_s1tiw_245",
  "ns-datatable__cell--align-end": "_ns-datatable__cell--align-end_s1tiw_248",
  "ns-datatable__cell-main": "_ns-datatable__cell-main_s1tiw_251",
  "ns-datatable__cell-main--text": "_ns-datatable__cell-main--text_s1tiw_254",
  "ns-datatable__cell-main--number": "_ns-datatable__cell-main--number_s1tiw_259",
  "ns-datatable__cell-sub": "_ns-datatable__cell-sub_s1tiw_264",
  "ns-datatable__link": "_ns-datatable__link_s1tiw_272",
  "ns-datatable__link-icon": "_ns-datatable__link-icon_s1tiw_283",
  "ns-datatable__link-text": "_ns-datatable__link-text_s1tiw_286",
  "ns-datatable__bool": "_ns-datatable__bool_s1tiw_297",
  "ns-datatable__bool-icon": "_ns-datatable__bool-icon_s1tiw_307",
  "ns-datatable__bool-icon--true": "_ns-datatable__bool-icon--true_s1tiw_310",
  "ns-datatable__bool-icon--false": "_ns-datatable__bool-icon--false_s1tiw_313",
  "ns-datatable__list": "_ns-datatable__list_s1tiw_316",
  "ns-datatable__expansion-cell": "_ns-datatable__expansion-cell_s1tiw_323",
  "ns-datatable__expansion-wrapper": "_ns-datatable__expansion-wrapper_s1tiw_328",
  "ns-datatable__expansion-wrapper--open": "_ns-datatable__expansion-wrapper--open_s1tiw_333",
  "ns-datatable__expansion-content": "_ns-datatable__expansion-content_s1tiw_341",
  "ns-datatable__expansion--top": "_ns-datatable__expansion--top_s1tiw_348",
  "ns-datatable__empty": "_ns-datatable__empty_s1tiw_351",
  "ns-datatable__sr-only": "_ns-datatable__sr-only_s1tiw_357",
  "ns-datatable__actions-inline": "_ns-datatable__actions-inline_s1tiw_368",
  "ns-datatable__actions-kebab": "_ns-datatable__actions-kebab_s1tiw_374",
  "ns-datatable__pagination": "_ns-datatable__pagination_s1tiw_385",
  "ns-datatable__pagination-left": "_ns-datatable__pagination-left_s1tiw_395",
  "ns-datatable__pagination-right": "_ns-datatable__pagination-right_s1tiw_396",
  "ns-datatable__page-label": "_ns-datatable__page-label_s1tiw_401",
  "ns-datatable__page-size-select": "_ns-datatable__page-size-select_s1tiw_406",
  "ns-datatable__page-range": "_ns-datatable__page-range_s1tiw_422",
  "ns-datatable__page-btn": "_ns-datatable__page-btn_s1tiw_427"
};
function $p({ id: e, isOpen: t, children: n, labelledBy: i, label: r, className: s }) {
  const { totalColumnCount: o } = $n(), l = X(fe["ns-datatable__expansion-wrapper"], {
    [fe["ns-datatable__expansion-wrapper--open"]]: t
  });
  return /* @__PURE__ */ g("tr", { className: X(fe["ns-datatable__expansion"], s), "aria-hidden": !t, children: /* @__PURE__ */ g("td", { colSpan: o, className: fe["ns-datatable__expansion-cell"], children: /* @__PURE__ */ g("div", { className: l, inert: !t, children: /* @__PURE__ */ g(
    "div",
    {
      id: e,
      role: "region",
      "aria-labelledby": i,
      "aria-label": i ? void 0 : r,
      className: fe["ns-datatable__expansion-content"],
      children: n
    }
  ) }) }) });
}
function T4(e, t) {
  const { dragState: n, keyboardDragId: i, beginDrag: r, dragOver: s, endDrag: o, toggleKeyboardDrag: l, moveKeyboardDrag: u } = $n(), c = he(
    (v) => {
      t && (v.preventDefault(), v.dataTransfer.dropEffect = "move", s(e));
    },
    [t, s, e]
  ), d = he((v) => {
    v.preventDefault();
  }, []), h = he(
    (v) => {
      v.dataTransfer.effectAllowed = "move", v.dataTransfer.setData("text/plain", e), r(e);
    },
    [r, e]
  ), m = he(
    (v) => {
      t && (v.currentTarget.contains(v.relatedTarget) || s(n.draggingId ?? e));
    },
    [t, s, n.draggingId, e]
  ), _ = he(
    (v) => {
      o(v.dataTransfer.dropEffect !== "none");
    },
    [o]
  ), y = he(
    (v) => {
      switch (v.key) {
        case " ":
        case "Enter":
          v.preventDefault(), l(e);
          break;
        case "ArrowUp":
          i === e && (v.preventDefault(), u(-1));
          break;
        case "ArrowDown":
          i === e && (v.preventDefault(), u(1));
          break;
        case "Escape":
          i === e && (v.preventDefault(), l(e));
          break;
      }
    },
    [i, e, l, u]
  );
  return {
    isDragging: n.draggingId === e,
    isDropTarget: n.draggingId !== null && n.draggingId !== e && n.overId === e,
    isKeyboardPicked: i === e,
    rowProps: t ? { onDragOver: c, onDrop: d, onDragLeave: m } : {},
    handleProps: { draggable: t, onDragStart: h, onDragEnd: _, onKeyDown: y }
  };
}
function P4({ rowId: e, menu: t, triggerLabel: n }) {
  const i = ee(null);
  return /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ g(
      Ze,
      {
        ref: i,
        type: "button",
        "aria-label": n,
        variant: Ye.Text,
        icon: q.MoreVert,
        size: lt.Small,
        isIconOnly: !0
      }
    ),
    /* @__PURE__ */ g(
      Kn,
      {
        id: `ns-datatable-menu-${e}`,
        label: t.label ?? "Row actions",
        items: t.items,
        anchorRef: i,
        placement: t.placement,
        onItemClick: t.onItemClick
      }
    )
  ] });
}
function D4(e) {
  switch (e.kind) {
    case "text":
    case "link":
    case "badge":
      return e.text;
    case "boolean":
    case "number":
    case "date":
      return e.value;
    case "list":
      return e.items.join(", ");
    default:
      return "";
  }
}
function M4(e, t) {
  if (!e || !t)
    return;
  let n;
  return e.mode === "boolean" ? n = t.value ? e.whenTrue : e.whenFalse : e.mode === "value" ? n = e.values[String(D4(t))] ?? e.fallback : n = typeof e.content == "function" ? e.content(t) : e.content, n === "" ? void 0 : n;
}
function V4({ text: e, variant: t, color: n, prefix: i }) {
  return /* @__PURE__ */ g(Gn, { id: `badge-${e}`, label: e, text: e, variant: t, color: n, prefix: i });
}
function F4({
  value: e,
  trueLabel: t = "Yes",
  falseLabel: n = "No",
  trueIcon: i = q.Done,
  falseIcon: r = q.Close
}) {
  const s = X(fe["ns-datatable__bool-icon"], {
    [fe["ns-datatable__bool-icon--true"]]: e,
    [fe["ns-datatable__bool-icon--false"]]: !e
  });
  return /* @__PURE__ */ F("span", { className: fe["ns-datatable__bool"], children: [
    /* @__PURE__ */ g("span", { "aria-hidden": "true", className: s, children: /* @__PURE__ */ g(be, { name: e ? i : r, size: 16 }) }),
    /* @__PURE__ */ g("span", { children: e ? t : n })
  ] });
}
const jc = /* @__PURE__ */ new Map(), $c = /* @__PURE__ */ new Map();
function R4(e, t) {
  const n = `${e ?? ""}|${JSON.stringify(t)}`;
  let i = jc.get(n);
  return i || (i = new Intl.NumberFormat(e, t), jc.set(n, i)), i;
}
function O4(e, t) {
  const n = `${e ?? ""}|${JSON.stringify(t)}`;
  let i = $c.get(n);
  return i || (i = new Intl.DateTimeFormat(e, t), $c.set(n, i)), i;
}
function B4(e) {
  return !e || e.style === "decimal" ? {
    style: "decimal",
    minimumFractionDigits: e?.style === "decimal" ? e.minimumFractionDigits : void 0,
    maximumFractionDigits: e?.style === "decimal" ? e.maximumFractionDigits : void 0
  } : e.style === "currency" ? { style: "currency", currency: e.currency } : { style: "unit", unit: e.unit, unitDisplay: "short" };
}
function Hp(e, t, n) {
  return R4(n, B4(t)).format(e);
}
function $s(e) {
  return typeof e == "number" ? e : new Date(e).getTime();
}
function Up(e) {
  const t = $s(e.value);
  if (Number.isNaN(t))
    return String(e.value);
  const n = e.options ?? { dateStyle: "medium" };
  return O4(e.locale, n).format(new Date(t));
}
function z4({ value: e, options: t, locale: n }) {
  const i = $s(e), r = Number.isNaN(i) ? void 0 : new Date(i).toISOString();
  return /* @__PURE__ */ g("time", { dateTime: r, children: Up({ value: e, options: t, locale: n }) });
}
function j4({ text: e, href: t, label: n, target: i = "_self", icon: r }) {
  const s = r ?? (i === "_blank" ? q.Launch : void 0);
  return /* @__PURE__ */ F(
    Gr,
    {
      url: t,
      target: i,
      ariaLabel: n,
      title: n,
      className: fe["ns-datatable__link"],
      children: [
        /* @__PURE__ */ g("span", { className: fe["ns-datatable__link-text"], children: e }),
        s !== void 0 && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: fe["ns-datatable__link-icon"], children: /* @__PURE__ */ g(be, { name: s, size: 16 }) })
      ]
    }
  );
}
function $4({ items: e, ordered: t = !1 }) {
  return /* @__PURE__ */ g(t ? "ol" : "ul", { className: fe["ns-datatable__list"], children: e.map((i, r) => /* @__PURE__ */ g("li", { children: i }, `${i}-${r}`)) });
}
function H4({ value: e, format: t, locale: n }) {
  return /* @__PURE__ */ g(et, { children: Hp(e, t, n) });
}
function U4({ text: e }) {
  return /* @__PURE__ */ g(et, { children: e });
}
function q4(e, t) {
  return {
    type: "button",
    id: e.name,
    label: e.text ?? e.title ?? e.name,
    prefix: e.prefix,
    danger: e.color === Le.Error,
    disabled: e.disabled,
    onClick: () => t?.(e)
  };
}
function J4({ rowId: e, items: t, onAction: n }) {
  const i = ee(null), r = `ns-datatable-actions-menu-${e}`, s = t.map((o) => q4(o, n));
  return /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ g("div", { className: fe["ns-datatable__actions-inline"], "aria-hidden": !1, children: t.map((o) => /* @__PURE__ */ g(Ze, { ...o, variant: Ye.Text, onClick: () => n?.(o) }, o.name)) }),
    /* @__PURE__ */ F("div", { className: fe["ns-datatable__actions-kebab"], children: [
      /* @__PURE__ */ g(
        "button",
        {
          ref: i,
          type: "button",
          className: fe["ns-datatable__kebab"],
          "aria-label": `Row actions for ${e}`,
          children: /* @__PURE__ */ g(be, { name: q.MoreVert, size: 20 })
        }
      ),
      /* @__PURE__ */ g(
        Kn,
        {
          id: r,
          label: `Row actions for ${e}`,
          items: s,
          anchorRef: i,
          placement: "bottom-end"
        }
      )
    ] })
  ] });
}
function qp(e) {
  return e.align ? e.align : e.type === "number" || e.type === "date" ? "end" : "start";
}
function W4(e, t) {
  switch (e.kind) {
    case "text":
      return /* @__PURE__ */ g(U4, { ...e });
    case "link":
      return /* @__PURE__ */ g(j4, { ...e });
    case "boolean":
      return /* @__PURE__ */ g(F4, { ...e });
    case "number":
      return /* @__PURE__ */ g(H4, { ...e });
    case "list":
      return /* @__PURE__ */ g($4, { ...e });
    case "date":
      return /* @__PURE__ */ g(z4, { ...e });
    case "badge":
      return /* @__PURE__ */ g(V4, { ...e });
    case "actions": {
      const n = e;
      return /* @__PURE__ */ g(J4, { rowId: t ?? "row", items: n.items, onAction: n.onAction });
    }
    default:
      return null;
  }
}
function Jp({ column: e, cell: t, rowId: n }) {
  const i = ee(null), r = rt(), s = qp(e), o = X(fe["ns-datatable__cell"], fe[`ns-datatable__cell--align-${s}`]);
  if (!t)
    return /* @__PURE__ */ g("td", { className: o });
  const l = t.tooltip ?? M4(e.tooltip, t), u = X(fe["ns-datatable__cell-main"], fe[`ns-datatable__cell-main--${t.kind}`]);
  return /* @__PURE__ */ F("td", { ref: i, className: o, children: [
    /* @__PURE__ */ g("span", { className: u, children: W4(t, n) }),
    t.sub !== void 0 && t.sub !== "" && /* @__PURE__ */ g("span", { className: fe["ns-datatable__cell-sub"], children: t.sub }),
    l && /* @__PURE__ */ g(kn, { id: `ns-datatable-tooltip-${r}`, content: l, anchorRef: i, placement: e.tooltip?.placement })
  ] });
}
function Z4(e, t) {
  for (const n of t)
    if (n.type === "text" || n.type === "link") {
      const i = e[n.key];
      if (i && (i.kind === "text" || i.kind === "link"))
        return i.text;
    }
  return e.id;
}
function X4({ row: e, displayIndex: t }) {
  const {
    columns: n,
    selectable: i,
    draggable: r,
    hasRowMenus: s,
    showRowExpandToggle: o,
    leadingColumnCount: l,
    selectedIds: u,
    expandedIds: c,
    toggleSelected: d,
    toggleExpanded: h
  } = $n(), m = i && e.isSelectable !== !1, _ = r && e.isDraggable !== !1, y = e.expandedContent !== void 0 && e.expandedContent !== null, v = u.has(e.id), w = c.has(e.id), x = Z4(e, n), A = T4(e.id, _), S = X(fe["ns-datatable__row"], {
    [fe["ns-datatable__row--even"]]: t % 2 === 0,
    [fe["ns-datatable__row--odd"]]: t % 2 === 1,
    [fe["ns-datatable__row--selected"]]: v,
    [fe["ns-datatable__row--dragging"]]: A.isDragging,
    [fe["ns-datatable__row--drop-target"]]: A.isDropTarget,
    [fe["ns-datatable__row--picked"]]: A.isKeyboardPicked
  }), N = _ || m || s || l > 0;
  return /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ F("tr", { className: S, "aria-selected": m ? v : void 0, ...A.rowProps, children: [
      N && /* @__PURE__ */ g("td", { className: fe["ns-datatable__control-cell"], children: /* @__PURE__ */ F("div", { className: fe["ns-datatable__control-group"], children: [
        _ && /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            className: fe["ns-datatable__drag-handle"],
            "aria-label": `Reorder ${x}`,
            "aria-pressed": A.isKeyboardPicked,
            ...A.handleProps,
            children: /* @__PURE__ */ g(be, { name: q.SwapHoriz, size: 18 })
          }
        ),
        m && /* @__PURE__ */ F(et, { children: [
          /* @__PURE__ */ F("label", { htmlFor: `ns-datatable-select-${e.id}`, className: fe["ns-datatable__sr-only"], children: [
            "Select ",
            x
          ] }),
          /* @__PURE__ */ g(
            ur,
            {
              id: `ns-datatable-select-${e.id}`,
              label: "",
              checked: v,
              size: lr.Small,
              onChange: () => d(e.id),
              className: fe["ns-datatable__select"]
            }
          )
        ] }),
        e.contextualMenu && /* @__PURE__ */ g(P4, { rowId: e.id, menu: e.contextualMenu, triggerLabel: `Actions for ${x}` }),
        y && o && /* @__PURE__ */ g(
          "button",
          {
            id: `ns-datatable-expand-${e.id}`,
            type: "button",
            className: fe["ns-datatable__expand-toggle"],
            "aria-expanded": w,
            "aria-controls": `ns-datatable-expansion-${e.id}`,
            "aria-label": w ? `Collapse ${x}` : `Expand ${x}`,
            onClick: () => h(e.id),
            children: /* @__PURE__ */ g(be, { name: w ? q.KeyboardArrowUp : q.KeyboardArrowDown, size: 20 })
          }
        )
      ] }) }),
      n.map((E) => {
        const f = e[E.key];
        return /* @__PURE__ */ g(Jp, { column: E, cell: f, rowId: e.id }, E.key);
      })
    ] }),
    y && /* @__PURE__ */ g(
      $p,
      {
        id: `ns-datatable-expansion-${e.id}`,
        labelledBy: o ? `ns-datatable-expand-${e.id}` : void 0,
        label: o ? void 0 : x,
        isOpen: w,
        children: e.expandedContent
      }
    )
  ] });
}
function G4() {
  const { columns: e, leadingColumnCount: t, summaryRow: n } = $n();
  return n ? /* @__PURE__ */ F("tr", { className: X(fe["ns-datatable__row"], fe["ns-datatable__row--summary"]), children: [
    t > 0 && /* @__PURE__ */ g("td", {}),
    e.map((i) => /* @__PURE__ */ g(Jp, { column: i, cell: n[i.key] }, i.key))
  ] }) : null;
}
function K4({
  rows: e,
  totalColumnCount: t,
  topExpansion: n,
  topExpansionOpen: i = !1,
  topExpansionId: r = "ns-datatable-top-expansion",
  topExpansionLabel: s = "Create record"
}) {
  const { summaryRow: o } = $n(), l = n != null;
  return /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ F("tbody", { children: [
      l && /* @__PURE__ */ g(
        $p,
        {
          id: r,
          isOpen: i,
          label: s,
          className: fe["ns-datatable__expansion--top"],
          children: n
        }
      ),
      e.length === 0 ? /* @__PURE__ */ g("tr", { children: /* @__PURE__ */ g("td", { colSpan: t, className: fe["ns-datatable__empty"], children: "No results." }) }) : e.map((u, c) => /* @__PURE__ */ g(X4, { row: u, displayIndex: c }, u.id))
    ] }),
    o && /* @__PURE__ */ g("tfoot", { children: /* @__PURE__ */ g(G4, {}) })
  ] });
}
const Y4 = 64, Hc = 8;
function Uc(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function Q4() {
  const { setColumnWidth: e } = $n(), t = ee(null), n = ee(e);
  n.current = e;
  const i = ee((u) => {
    const c = t.current;
    if (!c)
      return;
    const d = Uc(c.startWidth + (u.clientX - c.startX), c.min, c.max);
    n.current(c.columnKey, d);
  }).current, r = ee(() => {
    t.current = null, window.removeEventListener("pointermove", i), window.removeEventListener("pointerup", s), document.body.style.removeProperty("cursor"), document.body.style.removeProperty("user-select");
  }).current, s = ee(() => r()).current, o = he(
    (u, c, d, h) => {
      u.preventDefault(), u.stopPropagation();
      const m = u.currentTarget.closest("th"), _ = m ? m.getBoundingClientRect().width : d;
      t.current = { columnKey: c, startX: u.clientX, startWidth: _, min: d, max: h }, window.addEventListener("pointermove", i), window.addEventListener("pointerup", s), document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
    },
    [i, s]
  ), l = he(
    (u, c, d, h, m) => {
      let _ = 0;
      if (u.key === "ArrowLeft")
        _ = -Hc;
      else if (u.key === "ArrowRight")
        _ = Hc;
      else
        return;
      u.preventDefault(), n.current(c, Uc(d + _, h, m));
    },
    []
  );
  return me(() => r, [r]), { onPointerDown: o, onKeyboardResize: l };
}
function e5({ column: e }) {
  const { sort: t, cycleSort: n, filters: i, setColumnFilter: r, columnWidths: s } = $n(), o = Q4(), l = ee(null), u = t?.columnKey === e.key, c = e.isSortable ? u ? t?.direction === "asc" ? "ascending" : "descending" : "none" : void 0, d = u ? t?.direction === "asc" ? q.KeyboardArrowUp : q.KeyboardArrowDown : q.Sort, h = e.header ?? e.key, m = qp(e), _ = i[e.key] ?? "", y = _ !== "", v = e.minWidth ?? Y4, w = e.maxWidth ?? Number.MAX_SAFE_INTEGER, x = typeof e.width == "number" ? e.width : void 0, A = s[e.key] ?? x ?? v, S = /* @__PURE__ */ F("span", { className: fe["ns-datatable__header-text"], children: [
    /* @__PURE__ */ g("span", { className: fe["ns-datatable__header-title"], children: h }),
    e.subheader && /* @__PURE__ */ g("span", { className: fe["ns-datatable__header-sub"], children: e.subheader })
  ] }), N = e.filterType === "select" ? [
    { type: "button", id: "__all__", label: "All", onClick: () => r(e.key, "") },
    ...(e.filterOptions ?? []).map((E) => ({
      type: "button",
      id: E,
      label: E,
      suffix: _ === E ? q.Done : void 0,
      onClick: () => r(e.key, E)
    }))
  ] : void 0;
  return /* @__PURE__ */ F(
    "th",
    {
      scope: "col",
      "aria-sort": c,
      className: X(fe["ns-datatable__header-cell"], fe[`ns-datatable__header-cell--align-${m}`]),
      children: [
        /* @__PURE__ */ F("div", { className: fe["ns-datatable__header-inner"], children: [
          S,
          e.isSortable && /* @__PURE__ */ g(Ze, { type: "button", variant: Ye.Text, icon: d, isIconOnly: !0, "aria-label": h, onClick: () => n(e.key) }),
          e.isFilterable && /* @__PURE__ */ F(et, { children: [
            /* @__PURE__ */ g(
              "button",
              {
                ref: l,
                type: "button",
                className: X(fe["ns-datatable__filter-button"], {
                  [fe["ns-datatable__filter-button--active"]]: y
                }),
                "aria-label": `Filter ${h}`,
                children: /* @__PURE__ */ g(be, { name: q.FilterList, size: 16 })
              }
            ),
            N ? /* @__PURE__ */ g(
              Kn,
              {
                id: `ns-datatable-filter-${e.key}`,
                label: `Filter ${h}`,
                items: N,
                anchorRef: l,
                placement: "bottom-end"
              }
            ) : /* @__PURE__ */ g(
              Kn,
              {
                id: `ns-datatable-filter-${e.key}`,
                label: `Filter ${h}`,
                anchorRef: l,
                placement: "bottom-end",
                content: /* @__PURE__ */ F("label", { className: fe["ns-datatable__filter-field"], children: [
                  /* @__PURE__ */ F("span", { className: fe["ns-datatable__filter-field-label"], children: [
                    "Filter ",
                    h
                  ] }),
                  /* @__PURE__ */ g(
                    "input",
                    {
                      type: "text",
                      value: _,
                      placeholder: "Type to filter…",
                      onChange: (E) => r(e.key, E.target.value)
                    }
                  )
                ] })
              }
            )
          ] })
        ] }),
        e.isResizable && /* @__PURE__ */ g(
          "span",
          {
            role: "separator",
            "aria-orientation": "vertical",
            "aria-label": `Resize ${h}`,
            "aria-valuenow": Math.round(A),
            "aria-valuemin": v,
            "aria-valuemax": Number.isFinite(w) ? w : void 0,
            tabIndex: 0,
            className: fe["ns-datatable__resize-handle"],
            onPointerDown: (E) => o.onPointerDown(E, e.key, v, w),
            onKeyDown: (E) => o.onKeyboardResize(E, e.key, A, v, w)
          }
        )
      ]
    }
  );
}
function t5() {
  const { columns: e, selectable: t, leadingColumnCount: n, selectAllState: i, toggleSelectAll: r } = $n();
  return /* @__PURE__ */ g("thead", { className: fe["ns-datatable__head"], children: /* @__PURE__ */ F("tr", { children: [
    n > 0 && /* @__PURE__ */ g("th", { scope: "col", className: fe["ns-datatable__control-cell"], children: t ? /* @__PURE__ */ F(et, { children: [
      /* @__PURE__ */ g("label", { htmlFor: "ns-datatable-select-all", className: fe["ns-datatable__sr-only"], children: "Select all rows" }),
      /* @__PURE__ */ g(
        ur,
        {
          id: "ns-datatable-select-all",
          label: "",
          checked: i === "all",
          indeterminate: i === "some",
          size: lr.Small,
          onChange: r,
          className: fe["ns-datatable__select"]
        }
      )
    ] }) : /* @__PURE__ */ g("span", { className: fe["ns-datatable__sr-only"], children: "Row controls" }) }),
    e.map((s) => /* @__PURE__ */ g(e5, { column: s }, s.key))
  ] }) });
}
function n5() {
  const { page: e, pageSize: t, totalRows: n, setPage: i, setPageSize: r, pageSizeOptions: s } = $n(), o = n === 0 ? 0 : e * t + 1, l = Math.min((e + 1) * t, n), u = t > 0 ? Math.max(0, Math.ceil(n / t) - 1) : 0;
  return /* @__PURE__ */ F("div", { className: fe["ns-datatable__pagination"], children: [
    /* @__PURE__ */ F("div", { className: fe["ns-datatable__pagination-left"], children: [
      /* @__PURE__ */ g("span", { className: fe["ns-datatable__page-label"], children: "Rows per page:" }),
      /* @__PURE__ */ g(
        "select",
        {
          className: fe["ns-datatable__page-size-select"],
          value: t,
          onChange: (c) => r(Number(c.target.value)),
          "aria-label": "Rows per page",
          children: s.map((c) => /* @__PURE__ */ g("option", { value: c, children: c }, c))
        }
      )
    ] }),
    /* @__PURE__ */ F("div", { className: fe["ns-datatable__pagination-right"], children: [
      /* @__PURE__ */ F("span", { className: fe["ns-datatable__page-range"], children: [
        o,
        "–",
        l,
        " of ",
        n
      ] }),
      /* @__PURE__ */ g(
        "button",
        {
          type: "button",
          className: fe["ns-datatable__page-btn"],
          "aria-label": "Previous page",
          disabled: e === 0,
          onClick: () => i(e - 1),
          children: /* @__PURE__ */ g(be, { name: q.ChevronLeft, size: 20 })
        }
      ),
      /* @__PURE__ */ g(
        "button",
        {
          type: "button",
          className: fe["ns-datatable__page-btn"],
          "aria-label": "Next page",
          disabled: e >= u,
          onClick: () => i(e + 1),
          children: /* @__PURE__ */ g(be, { name: q.ChevronRight, size: 20 })
        }
      )
    ] })
  ] });
}
function i5() {
  const { tableId: e, globalFilter: t, setGlobalFilter: n } = $n(), i = `${e}-global-filter`;
  return /* @__PURE__ */ F("div", { className: fe["ns-datatable__toolbar"], children: [
    /* @__PURE__ */ g("label", { htmlFor: i, className: fe["ns-datatable__sr-only"], children: "Filter all columns" }),
    /* @__PURE__ */ F("div", { className: fe["ns-datatable__global-filter"], children: [
      /* @__PURE__ */ g("span", { "aria-hidden": "true", className: fe["ns-datatable__global-filter-icon"], children: /* @__PURE__ */ g(be, { name: q.FilterList, size: 18 }) }),
      /* @__PURE__ */ g(
        "input",
        {
          id: i,
          type: "search",
          value: t,
          placeholder: "Filter…",
          onChange: (r) => n(r.target.value)
        }
      )
    ] })
  ] });
}
function ai(e, t) {
  const [n, i] = Ee(t), r = e !== void 0, s = r ? e : n, o = he(
    (l, u) => {
      u?.(l), r || i(l);
    },
    [r]
  );
  return [s, o];
}
function r5(e, t, n) {
  const i = e.filter((o) => o !== t), r = i.indexOf(n);
  if (r === -1)
    return [...e];
  const s = e.indexOf(t) < e.indexOf(n) ? r + 1 : r;
  return i.splice(s, 0, t), i;
}
function s5(e) {
  const t = $e(() => e.data.map((ne) => ne.id), [e.data]), [n, i] = ai(e.selectedIds, e.defaultSelectedIds ?? []), r = $e(() => new Set(n), [n]), [s, o] = ai(e.expandedIds, e.defaultExpandedIds ?? []), l = $e(() => new Set(s), [s]), [u, c] = ai(e.sort, e.defaultSort ?? null), [d, h] = ai(e.filters, e.defaultFilters ?? {}), [m, _] = ai(e.globalFilter, e.defaultGlobalFilter ?? ""), [y, v] = ai(e.columnWidths, e.defaultColumnWidths ?? {}), [w, x] = ai(e.page, e.defaultPage ?? 0), [A, S] = ai(e.pageSize, e.defaultPageSize ?? 10), N = he(
    (ne) => x(ne, e.onPageChange),
    [x, e.onPageChange]
  ), E = he(
    (ne) => {
      S(ne, e.onPageSizeChange), x(0, e.onPageChange);
    },
    [S, x, e.onPageSizeChange, e.onPageChange]
  ), [f, C] = Ee(t), L = $e(() => {
    const ne = e.order ?? f, _e = new Set(t), Ie = ne.filter((Ke) => _e.has(Ke)), Ve = new Set(Ie), nt = t.filter((Ke) => !Ve.has(Ke));
    return [...Ie, ...nt];
  }, [e.order, f, t]), R = e.order !== void 0, V = he(
    (ne) => {
      e.onRowReorder?.(ne), R || C(ne);
    },
    [e, R]
  ), [z, $] = Ee({ draggingId: null, overId: null }), [H, B] = Ee(null), [O, W] = Ee(""), G = he((ne) => $({ draggingId: ne, overId: ne }), []), re = he((ne) => $((_e) => _e.overId === ne ? _e : { ..._e, overId: ne }), []), K = he(
    (ne) => {
      $((_e) => (ne && _e.draggingId && _e.overId && _e.draggingId !== _e.overId && V(r5(L, _e.draggingId, _e.overId)), { draggingId: null, overId: null }));
    },
    [L, V]
  ), P = he(
    (ne) => {
      B((_e) => _e === ne ? (W(`Dropped row at position ${L.indexOf(ne) + 1} of ${L.length}.`), null) : (W("Picked up row. Use arrow keys to move, space to drop, escape to cancel."), ne));
    },
    [L]
  ), oe = he(
    (ne) => {
      if (H === null)
        return;
      const _e = L.indexOf(H), Ie = _e + ne;
      if (Ie < 0 || Ie >= L.length)
        return;
      const Ve = [...L];
      Ve.splice(_e, 1), Ve.splice(Ie, 0, H), V(Ve), W(`Moved row to position ${Ie + 1} of ${L.length}.`);
    },
    [H, L, V]
  ), se = he(
    (ne) => {
      const _e = new Set(r);
      _e.has(ne) ? _e.delete(ne) : _e.add(ne), i([..._e], e.onSelectionChange);
    },
    [r, i, e.onSelectionChange]
  ), D = he(
    (ne) => {
      if (ne.length === 0)
        return "none";
      const _e = ne.filter((Ie) => r.has(Ie)).length;
      return _e === 0 ? "none" : _e === ne.length ? "all" : "some";
    },
    [r]
  ), pe = he(
    (ne) => {
      const _e = D(ne) === "all", Ie = new Set(r);
      _e ? ne.forEach((Ve) => Ie.delete(Ve)) : ne.forEach((Ve) => Ie.add(Ve)), i([...Ie], e.onSelectionChange);
    },
    [D, r, i, e.onSelectionChange]
  ), Ce = he(
    (ne, _e) => {
      const Ie = new Set(l);
      _e ? Ie.add(ne) : Ie.delete(ne), o([...Ie], e.onExpandedChange);
    },
    [l, o, e.onExpandedChange]
  ), Z = he(
    (ne) => Ce(ne, !l.has(ne)),
    [Ce, l]
  ), j = he(
    (ne) => {
      let _e;
      u?.columnKey !== ne ? _e = { columnKey: ne, direction: "asc" } : u.direction === "asc" ? _e = { columnKey: ne, direction: "desc" } : _e = null, c(_e, e.onSortChange);
    },
    [u, c, e.onSortChange]
  ), ie = he(
    (ne, _e) => {
      const Ie = { ...d };
      _e === "" ? delete Ie[ne] : Ie[ne] = _e, h(Ie, e.onFilterChange);
    },
    [d, h, e.onFilterChange]
  ), te = he(
    (ne) => _(ne, e.onGlobalFilterChange),
    [_, e.onGlobalFilterChange]
  ), ge = he(
    (ne, _e) => {
      v({ ...y, [ne]: _e }, e.onColumnWidthsChange);
    },
    [y, v, e.onColumnWidthsChange]
  );
  return {
    selectedIds: r,
    expandedIds: l,
    sort: u,
    filters: d,
    globalFilter: m,
    columnWidths: y,
    order: L,
    dragState: z,
    keyboardDragId: H,
    liveMessage: O,
    page: w,
    pageSize: A,
    setPage: N,
    setPageSize: E,
    selectAllStateFor: D,
    toggleSelected: se,
    toggleSelectAllFor: pe,
    toggleExpanded: Z,
    setExpanded: Ce,
    cycleSort: j,
    setColumnFilter: ie,
    setGlobalFilter: te,
    setColumnWidth: ge,
    beginDrag: G,
    dragOver: re,
    endDrag: K,
    toggleKeyboardDrag: P,
    moveKeyboardDrag: oe
  };
}
function ws(e, t) {
  return e.localeCompare(t, void 0, { sensitivity: "base", numeric: !0 });
}
function qc(e, t) {
  const n = Number.isNaN(e), i = Number.isNaN(t);
  return n && i ? 0 : n ? 1 : i ? -1 : e - t;
}
function a5(e) {
  switch (e) {
    case "text":
      return (t, n) => ws(t.text, n.text);
    case "link":
      return (t, n) => ws(t.text, n.text);
    case "number":
      return (t, n) => qc(t.value, n.value);
    case "boolean":
      return (t, n) => Number(t.value) - Number(n.value);
    case "date":
      return (t, n) => qc($s(t.value), $s(n.value));
    case "badge":
      return (t, n) => ws(t.text, n.text);
    case "list":
      return (t, n) => {
        const i = t.items, r = n.items, s = ws(i[0] ?? "", r[0] ?? "");
        return s !== 0 ? s : i.length - r.length;
      };
    default:
      return () => 0;
  }
}
function Po(e, t) {
  switch (e) {
    case "text":
      return Ai(t.text, t.sub);
    case "link":
      return Ai(t.text, t.label, t.sub);
    case "boolean": {
      const n = t;
      return Ai(n.value ? n.trueLabel ?? "Yes" : n.falseLabel ?? "No", t.sub);
    }
    case "number": {
      const n = t;
      return Ai(Hp(n.value, n.format, n.locale), String(n.value), t.sub);
    }
    case "date":
      return Ai(Up(t), t.sub);
    case "badge":
      return Ai(t.text, t.sub);
    case "list":
      return Ai(t.items.join(" "), t.sub);
    default:
      return "";
  }
}
function Ai(...e) {
  return e.filter((t) => t !== void 0 && t !== "").join(" ").toLowerCase();
}
function o5(e, t) {
  return t === "select" ? (n, i) => i === "" ? !0 : Po(e, n) === i.toLowerCase() : (n, i) => i === "" ? !0 : Po(e, n).includes(i.toLowerCase());
}
const l5 = [5, 10, 25, 50];
function hk(e) {
  const {
    caption: t,
    columns: n,
    data: i,
    selectable: r = !1,
    // `sortable` is deliberately NOT destructured: DataTableProps documents it
    // as "Enable sorting globally", but no code path reads it — per-column
    // `isSortable` is the only switch that has any effect. Binding it here
    // just asserted otherwise. Wiring up the global gate is a behaviour
    // change, so it is left to the DataTable owners.
    draggable: s = !1,
    showGlobalFilter: o = !1,
    manualSort: l = !1,
    manualFilter: u = !1,
    manualPagination: c = !1,
    showRowExpandToggle: d = !0,
    topExpansion: h,
    topExpansionOpen: m = !1,
    topExpansionLabel: _,
    pagination: y = !1,
    pageSizeOptions: v = l5,
    summaryRow: w,
    minWidth: x,
    className: A
  } = e, S = rt(), N = s5(e), E = $e(() => {
    if (x !== void 0)
      return {
        "--ns-datatable-min-width": typeof x == "number" ? `${x}px` : x
      };
  }, [x]), f = $e(() => i.some((O) => O.contextualMenu !== void 0), [i]), C = $e(() => i.some((O) => O.expandedContent !== void 0 && O.expandedContent !== null), [i]), L = r || s || f || C ? 1 : 0, R = L + n.length, V = $e(() => {
    const O = /* @__PURE__ */ new Map();
    for (const G of i)
      O.set(G.id, G);
    let W = N.order.map((G) => O.get(G)).filter((G) => G !== void 0);
    if (!u) {
      const G = N.globalFilter.trim().toLowerCase();
      W = W.filter((re) => {
        const K = re;
        return n.every((oe) => {
          const se = N.filters[oe.key];
          if (!se)
            return !0;
          const D = K[oe.key];
          return D ? (oe.filterPredicate ?? o5(oe.type, oe.filterType))(D, se) : !1;
        }) ? G === "" ? !0 : n.some((oe) => {
          const se = K[oe.key];
          return se ? Po(oe.type, se).includes(G) : !1;
        }) : !1;
      });
    }
    if (!l && N.sort) {
      const G = n.find((re) => re.key === N.sort.columnKey);
      if (G) {
        const re = G.sortComparator ?? a5(G.type), K = N.sort.direction === "asc" ? 1 : -1;
        W = [...W].sort((P, oe) => {
          const se = P[G.key], D = oe[G.key];
          return !se || !D ? 0 : K * re(se, D);
        });
      }
    }
    return W;
  }, [i, n, N.order, N.filters, N.globalFilter, N.sort, u, l]), z = c ? e.totalRows ?? 0 : V.length, $ = $e(() => {
    if (!y || c)
      return V;
    const O = N.page * N.pageSize;
    return V.slice(O, O + N.pageSize);
  }, [V, y, c, N.page, N.pageSize]), H = $e(() => $.map((O) => O.id), [$]), B = $e(
    () => ({
      selectedIds: N.selectedIds,
      expandedIds: N.expandedIds,
      sort: N.sort,
      filters: N.filters,
      globalFilter: N.globalFilter,
      columnWidths: N.columnWidths,
      dragState: N.dragState,
      keyboardDragId: N.keyboardDragId,
      selectAllState: N.selectAllStateFor(H),
      toggleSelected: N.toggleSelected,
      toggleSelectAll: () => N.toggleSelectAllFor(H),
      toggleExpanded: N.toggleExpanded,
      setExpanded: N.setExpanded,
      cycleSort: N.cycleSort,
      setColumnFilter: N.setColumnFilter,
      setGlobalFilter: N.setGlobalFilter,
      setColumnWidth: N.setColumnWidth,
      beginDrag: N.beginDrag,
      dragOver: N.dragOver,
      endDrag: N.endDrag,
      toggleKeyboardDrag: N.toggleKeyboardDrag,
      moveKeyboardDrag: N.moveKeyboardDrag,
      page: N.page,
      pageSize: N.pageSize,
      totalRows: z,
      setPage: N.setPage,
      setPageSize: N.setPageSize,
      pageSizeOptions: v,
      columns: n,
      selectable: r,
      draggable: s,
      hasRowMenus: f,
      showRowExpandToggle: d,
      leadingColumnCount: L,
      totalColumnCount: R,
      tableId: S,
      liveMessage: N.liveMessage,
      summaryRow: w
    }),
    [N, H, z, v, n, r, s, f, L, R, S, w]
  );
  return /* @__PURE__ */ g(jp.Provider, { value: B, children: /* @__PURE__ */ F("div", { className: X(fe["ns-datatable"], A), children: [
    o && /* @__PURE__ */ g(i5, {}),
    /* @__PURE__ */ F("div", { className: fe["ns-datatable__card"], children: [
      /* @__PURE__ */ g(
        "div",
        {
          className: fe["ns-datatable__scroll"],
          tabIndex: x === void 0 ? void 0 : 0,
          children: /* @__PURE__ */ F("table", { className: fe["ns-datatable__table"], style: E, children: [
            t && /* @__PURE__ */ g("caption", { className: fe["ns-datatable__caption"], children: t }),
            /* @__PURE__ */ F("colgroup", { children: [
              L > 0 && /* @__PURE__ */ g("col", { className: fe["ns-datatable__control-col"] }),
              n.map((O) => {
                const W = N.columnWidths[O.key], G = W !== void 0 ? `${W}px` : typeof O.width == "string" ? O.width : O.width !== void 0 ? `${O.width}px` : void 0;
                return /* @__PURE__ */ g("col", { style: G !== void 0 ? { width: G } : void 0 }, O.key);
              })
            ] }),
            /* @__PURE__ */ g(t5, {}),
            /* @__PURE__ */ g(
              K4,
              {
                rows: $,
                totalColumnCount: R,
                topExpansion: h,
                topExpansionOpen: m,
                topExpansionId: `${S}-top-expansion`,
                topExpansionLabel: _
              }
            )
          ] })
        }
      ),
      y && /* @__PURE__ */ g(n5, {})
    ] }),
    /* @__PURE__ */ g("div", { role: "status", "aria-live": "polite", className: fe["ns-datatable__sr-only"], children: N.liveMessage })
  ] }) });
}
const Wp = "__answer_later__";
function yl(e) {
  return e === Wp;
}
function Ii(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    return console.warn("[ISM] Malformed percent-encoding in slot segment, showing raw text"), e;
  }
}
function u5(e, t) {
  const n = {};
  for (const [i, r] of Object.entries(e)) {
    const s = t.get(r.param);
    if (s === null) {
      "default" in r && (n[i] = r.default);
      continue;
    }
    switch (r.type) {
      case "string":
        n[i] = s;
        break;
      case "boolean":
        n[i] = s === "1";
        break;
      case "number":
        n[i] = parseFloat(s);
        break;
      case "options":
        n[i] = s.split("|").filter(Boolean).map((o) => {
          const l = o.indexOf(":");
          if (l === -1)
            return { id: o, label: o, value: o };
          const u = o.slice(0, l), c = o.slice(l + 1);
          return { id: u, label: u, value: c };
        });
        break;
      // EntityPicker-only variant of "options": "Label:value" parsing,
      // plus an optional third ":job_title" segment, for a BE-supplied
      // candidate list that needs to carry secondary info (see
      // ISMPropType's "entityOptions" doc). Kept separate from "options"
      // (shared with Select) so a legitimate value containing its own `:`
      // is never misparsed there.
      //
      // The backend percent-encodes every field (label/value/job_title)
      // before joining, precisely so none of them can contain a raw ":"
      // or "|" — that's what makes splitting on the first two literal
      // colons here unambiguous, not an assumption about the field
      // contents. `safeDecode` never throws: decodeURIComponent throws
      // on a malformed sequence (e.g. a stray "%"), which must not
      // escape parseISMParams' documented never-throws contract — fall
      // back to the raw (still-encoded) segment rather than crashing.
      case "entityOptions":
        n[i] = s.split("|").filter(Boolean).map((o) => {
          const l = o.indexOf(":");
          if (l === -1) {
            const _ = Ii(o);
            return { id: _, label: _, value: _ };
          }
          const u = Ii(o.slice(0, l)), c = o.slice(l + 1), d = c.indexOf(":");
          if (d === -1) {
            const _ = Ii(c);
            return { id: u, label: u, value: _ };
          }
          const h = Ii(c.slice(0, d)), m = Ii(c.slice(d + 1));
          return {
            id: u,
            label: u,
            value: h,
            attributes: m ? { job_title: m } : void 0
          };
        });
        break;
      // "value:description" pairs → Record<string, string>, keyed by option
      // value (see ISMPropType's "descriptionMap" doc). Both halves are
      // percent-encoded by the producer, so the first literal ":" is an
      // unambiguous split point; `safeDecode` keeps the never-throws
      // contract for a malformed sequence. Entries without ":" are dropped.
      case "descriptionMap":
        n[i] = Object.fromEntries(
          s.split("|").filter(Boolean).flatMap((o) => {
            const l = o.indexOf(":");
            return l === -1 ? [] : [[Ii(o.slice(0, l)), Ii(o.slice(l + 1))]];
          })
        );
        break;
      case "fields":
        n[i] = s.split("|").filter(Boolean).map((o) => {
          const l = o.indexOf(":");
          if (l === -1)
            return { key: o, label: o };
          const u = o.slice(0, l), c = o.slice(l + 1);
          return { key: u, label: c };
        });
        break;
      // A set of scalar codes (e.g. MultiSelect's selected values), not a
      // single value — split on "," rather than "|" since these entries are
      // never themselves "Label:value" pairs (see ISMPropType's "stringList"
      // doc). Deduped here so a slot's seeded `value` and its ContextToken
      // open-time baseline are identical by construction.
      case "stringList":
        n[i] = Array.from(
          new Set(
            s.split(",").map((o) => o.trim()).filter(Boolean)
          )
        );
        break;
    }
  }
  return n;
}
const c5 = "⟪LEN:", Zp = "⟪/⟫", qa = [...Zp].length;
function Ja(e) {
  return [...e];
}
function ia(e, t) {
  const n = Ja(e), i = n.length, r = [], s = [];
  let o = "", l = 0;
  const u = () => {
    o && (r.push({ type: "text", content: o }), o = "");
  }, c = Ja(c5), d = c.length;
  for (; l < i; ) {
    let h = l + d <= i;
    if (h) {
      for (let B = 0; B < d; B++)
        if (n[l + B] !== c[B]) {
          h = !1;
          break;
        }
    }
    if (!h) {
      o += n[l], l++;
      continue;
    }
    u();
    const m = l;
    l += d;
    let _ = "";
    for (; l < i && n[l] !== "⟫"; ) {
      const B = n[l];
      if (B < "0" || B > "9") {
        s.push({
          position: m,
          message: `Non-digit character '${B}' inside LEN fence at position ${l}.`,
          raw: n.slice(m, l + 1).join("")
        }), l = m + d, _ = "";
        break;
      }
      _ += B, l++;
    }
    if (!_) {
      l < i && n[l] === "⟫" && l++;
      continue;
    }
    if (l >= i || n[l] !== "⟫") {
      s.push({
        position: m,
        message: `Opening fence at position ${m} has no closing ⟫.`,
        raw: n.slice(m, l).join("")
      });
      continue;
    }
    l++;
    const y = parseInt(_, 10);
    if (l + y > i) {
      s.push({
        position: m,
        message: `Payload at position ${m} is shorter than declared length ${y}.`,
        raw: n.slice(m, i).join("")
      });
      continue;
    }
    const w = n.slice(l, l + y).join("");
    if (l += y, w.includes("⟪") || w.includes("⟫")) {
      s.push({
        position: m,
        message: `Payload at position ${m} contains illegal fence characters.`,
        raw: w
      });
      continue;
    }
    const x = Ja(Zp);
    let A = l + qa <= i;
    if (A) {
      for (let B = 0; B < qa; B++)
        if (n[l + B] !== x[B]) {
          A = !1;
          break;
        }
    }
    if (!A) {
      s.push({
        position: m,
        message: `Expected closing fence ⟪/⟫ at position ${l} but found something else.`,
        raw: w
      }), l = m + d;
      continue;
    }
    l += qa;
    const S = w.indexOf("?"), N = S === -1 ? w : w.slice(0, S), E = S === -1 ? "" : w.slice(S + 1);
    if (!(N in t)) {
      console.warn(`[ISM] Unknown component "${N}" — slot ignored.`);
      continue;
    }
    const f = t[N], C = new URLSearchParams(E), L = C.get("source") ?? void 0, R = C.get("status"), V = R === "clear" || R === "unclear" || R === "invalid" ? R : void 0, z = C.get("interactive"), $ = z === null ? void 0 : z !== "0", H = u5(f.spec, C);
    r.push({ type: "slot", componentName: N, props: H, source: L, status: V, interactive: $, rawQuery: E });
  }
  return u(), { nodes: r, errors: s };
}
function pk(e, t) {
  const { errors: n } = ia(e, t);
  return { valid: n.length === 0, errors: n };
}
function d5(e, t) {
  const n = new URLSearchParams();
  for (const [o, l] of Object.entries(t))
    typeof l == "boolean" ? n.set(o, l ? "1" : "0") : n.set(o, String(l));
  const i = n.toString(), r = i ? `${e}?${i}` : e;
  return `⟪LEN:${[...r].length}⟫${r}⟪/⟫`;
}
function Wa(e) {
  return typeof e == "boolean" ? e ? "1" : "0" : Array.isArray(e) ? e.map((t) => String(t)).join(",") : String(e);
}
function h5(e) {
  return !!e && typeof e == "object" && "value" in e;
}
function fk(e, t, n) {
  const { nodes: i } = ia(e, t);
  return i.map((r) => {
    if (r.type === "text")
      return r.content;
    const s = r.props.name, o = typeof s == "string" ? s : "", l = Object.fromEntries(new URLSearchParams(r.rawQuery ?? ""));
    if (o in n) {
      const u = n[o];
      h5(u) ? (l.value = Wa(u.value), "label" in u && (l.selectedLabel = Wa(u.label))) : l.value = Wa(u), l.status = "clear";
    }
    return d5(r.componentName, l);
  }).join("");
}
function p5(e) {
  return e.length === 0 ? "" : e.length === 1 ? e[0] ?? "" : e.length === 2 ? `${e[0]} and ${e[1]}` : `${e.slice(0, -1).join(", ")}, and ${e[e.length - 1]}`;
}
const Xp = ei(null);
function Cn() {
  const e = Fn(Xp);
  if (!e)
    throw new Error(
      "[ISM] useISMForm() must be used inside an <ISMFormProvider>. Wrap your ISMR or slot components in an ISMFormProvider."
    );
  return e;
}
function f5({ children: e, onSubmit: t, onSearch: n, validate: i }) {
  const [r, s] = Ee({}), [o, l] = Ee({}), [u, c] = Ee({}), d = ee(/* @__PURE__ */ new Map()), h = ee({}), m = he((x, A, S) => {
    h.current = { ...h.current, [x]: A }, s((f) => ({ ...f, [x]: A })), S?.seed || c((f) => f[x] ? f : { ...f, [x]: !0 });
    const N = d.current.get(x);
    let E = N ? N(A) : null;
    !E && i && (E = i(x, A, h.current)), l((f) => ({ ...f, [x]: E }));
  }, [i]), _ = he((x, A) => (d.current.set(x, A), () => {
    d.current.delete(x);
  }), []), y = he(() => {
    const x = h.current, A = {};
    let S = !1;
    for (const [N, E] of d.current) {
      let f = E(x[N] ?? null);
      !f && i && (f = i(N, x[N] ?? null, x)), A[N] = f, f !== null && (S = !0);
    }
    l(A), S || t(x);
  }, [t, i]), v = he(
    async (x, A, S) => n ? n(x, A, S) : (console.warn(`[ISM] EntityPicker (kind="${x}") called onSearch but none was provided to ISMFormProvider.`), []),
    [n]
  ), w = {
    values: r,
    errors: o,
    touched: u,
    setValue: m,
    registerValidator: _,
    submit: y,
    onSearch: v
  };
  return /* @__PURE__ */ g(Xp.Provider, { value: w, children: e });
}
const m5 = {
  contained: Ye.Contained,
  outlined: Ye.Outlined,
  text: Ye.Text
}, _5 = {
  primary: Le.Primary,
  secondary: Le.Secondary
};
function g5({
  name: e,
  label: t,
  value: n,
  variant: i = "outlined",
  color: r = "primary",
  disabled: s = !1
}) {
  const { setValue: o, submit: l } = Cn();
  return /* @__PURE__ */ g(
    Ze,
    {
      text: t,
      variant: m5[i] ?? Ye.Outlined,
      color: _5[r] ?? Le.Primary,
      size: lt.Small,
      onClick: () => {
        o(e, n ?? t), l();
      },
      disabled: s
    }
  );
}
const Jc = {
  "ns-button-group-slot": "_ns-button-group-slot_ygfxr_1",
  "ns-button-group-slot__error": "_ns-button-group-slot__error_ygfxr_46"
};
function x5(e) {
  return e.split("|").filter(Boolean).map((t) => {
    const n = t.indexOf(":");
    return n === -1 ? { label: t, value: t } : { label: t.slice(0, n), value: t.slice(n + 1) };
  });
}
function b5({
  name: e,
  options: t,
  required: n = !1,
  autoSubmit: i = !0,
  label: r = "",
  disabled: s = !1
}) {
  const { values: o, errors: l, setValue: u, registerValidator: c, submit: d } = Cn(), h = `${rt()}-error`, m = l[e];
  me(() => c(e, (y) => n && !y ? "Please select an option." : null), [e, n, c]);
  const _ = x5(t);
  return /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ g(
      "div",
      {
        className: Jc["ns-button-group-slot"],
        role: "group",
        "aria-label": r === "" ? e : r,
        "aria-describedby": m ? h : void 0,
        children: _.map((y) => {
          const v = !i && o[e] === y.value;
          return /* @__PURE__ */ g(
            Ze,
            {
              variant: v ? Ye.Contained : Ye.Outlined,
              "aria-pressed": i ? void 0 : v,
              size: lt.Small,
              onClick: () => {
                u(e, y.value), i && d();
              },
              text: y.label,
              disabled: s
            },
            y.value
          );
        })
      }
    ),
    m ? /* @__PURE__ */ g("p", { id: h, role: "alert", className: Jc["ns-button-group-slot__error"], children: m }) : null
  ] });
}
const y5 = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function v5({
  name: e,
  label: t,
  required: n = !1,
  disabled: i = !1,
  width: r = "auto"
}) {
  const { values: s, setValue: o, registerValidator: l } = Cn();
  me(() => l(e, (c) => n && !c ? `${t} must be checked.` : null), [e, t, n, l]);
  const u = !!s[e];
  return /* @__PURE__ */ g(
    ur,
    {
      id: `ism-field-${e}`,
      label: t,
      checked: u,
      size: lr.Medium,
      onChange: (c) => o(e, c),
      disabled: i,
      width: y5[r] ?? we.Auto
    }
  );
}
const Wc = {
  "ns-date-picker-calendar-slot--width-full": "_ns-date-picker-calendar-slot--width-full_wyc3y_1",
  "ns-date-picker-calendar-slot--width-sm": "_ns-date-picker-calendar-slot--width-sm_wyc3y_4",
  "ns-date-picker-calendar-slot--width-md": "_ns-date-picker-calendar-slot--width-md_wyc3y_7",
  "ns-date-picker-calendar-slot--width-lg": "_ns-date-picker-calendar-slot--width-lg_wyc3y_10"
}, w5 = {
  contained: Ye.Contained,
  outlined: Ye.Outlined,
  text: Ye.Text
}, k5 = {
  primary: Le.Primary,
  secondary: Le.Secondary
};
function Zc(e) {
  if (e) {
    const n = e.split("-").map(Number);
    if (n[0] && n[1])
      return { year: n[0], month: n[1] - 1 };
  }
  const t = /* @__PURE__ */ new Date();
  return { year: t.getFullYear(), month: t.getMonth() };
}
function Gp({
  name: e,
  label: t,
  required: n = !1,
  minDate: i,
  maxDate: r,
  disabled: s,
  autoSubmit: o = !0,
  answerLater: l = !1,
  answerLaterLabel: u = "Answer later",
  answerLaterPrefix: c,
  answerLaterSuffix: d,
  answerLaterVariant: h = "text",
  answerLaterColor: m = "primary",
  value: _,
  width: y = "auto"
}) {
  const { values: v, errors: w, setValue: x, registerValidator: A, submit: S } = Cn();
  me(() => A(e, ($) => n && !$ ? `${t} is required.` : null), [e, t, n, A]), me(() => {
    v[e] === void 0 && _ !== void 0 && x(e, _, { seed: !0 });
  }, [e, _, v, x]);
  const N = v[e] ?? null, E = yl(N) ? null : N, f = w[e], [C, L] = Ee(() => Zc(E));
  me(() => {
    E && L(Zc(E));
  }, [E]);
  const R = () => L(($) => $.month === 0 ? { year: $.year - 1, month: 11 } : { year: $.year, month: $.month - 1 }), V = () => L(($) => $.month === 11 ? { year: $.year + 1, month: 0 } : { year: $.year, month: $.month + 1 }), z = ($) => L((H) => ({ ...H, year: $ }));
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        Wc["ns-date-picker-calendar-slot"],
        y !== "auto" && Wc[`ns-date-picker-calendar-slot--width-${y}`]
      ),
      children: [
        /* @__PURE__ */ g(
          pd,
          {
            id: `ism-calendar-${e}`,
            selectedIso: E,
            calState: C,
            minDate: i,
            maxDate: r,
            onSelectDay: ($) => {
              x(e, $), o && S();
            },
            onPrevMonth: R,
            onNextMonth: V,
            onSelectYear: z,
            disabled: s
          }
        ),
        l && /* @__PURE__ */ g(
          Ze,
          {
            text: u,
            prefix: c,
            suffix: d,
            variant: w5[h] ?? Ye.Text,
            color: k5[m] ?? Le.Primary,
            size: lt.Small,
            disabled: s,
            onClick: () => {
              x(e, Wp), o && S();
            }
          }
        ),
        f && /* @__PURE__ */ g("p", { role: "alert", style: { margin: "4px 0 0", fontSize: "12px", color: "var(--ns-color-red-500, #ef4444)" }, children: f })
      ]
    }
  );
}
const C5 = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function mk({
  disabled: e,
  name: t,
  label: n,
  required: i = !1,
  minDate: r,
  maxDate: s,
  width: o = "auto"
}) {
  const { values: l, errors: u, setValue: c, registerValidator: d } = Cn();
  me(() => d(t, (y) => i && !y ? `${n} is required.` : null), [t, n, i, d]);
  const h = l[t] ?? null, m = u[t], _ = m ? Pe.Error : Pe.Default;
  return /* @__PURE__ */ g(
    $o,
    {
      id: `ism-field-${t}`,
      name: t,
      label: n,
      required: i,
      value: h,
      onChange: (y) => c(t, y),
      state: _,
      hint: m ?? void 0,
      size: Nt.Small,
      minDate: r,
      maxDate: s,
      disabled: e,
      width: C5[o] ?? we.Auto
    }
  );
}
const S5 = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function Xc(e, t) {
  const n = t.map((i) => e.attributes?.[i.key]).filter((i) => typeof i == "string" && i.length > 0).join(", ");
  return {
    id: e.id,
    label: e.label,
    value: e,
    description: n || void 0
  };
}
function E5({
  name: e,
  label: t,
  kind: n,
  endpoint: i,
  required: r = !1,
  placeholder: s,
  disabled: o,
  autoSubmit: l = !0,
  infoFields: u = [],
  value: c,
  selectedLabel: d,
  options: h = [],
  width: m = "auto"
}) {
  const { values: _, errors: y, setValue: v, registerValidator: w, submit: x, onSearch: A } = Cn();
  me(() => w(e, (L) => r && !L ? `${t} is required.` : null), [e, t, r, w]), me(() => {
    _[e] === void 0 && c !== void 0 && v(
      e,
      {
        id: c,
        label: d ?? c,
        value: c
      },
      { seed: !0 }
    );
  }, [e, c, d, _, v]);
  const S = he(
    async (L) => (await A(n ?? e, L, i)).map((V) => Xc(V, u)),
    [n, e, i, A, u]
  ), N = _[e] ?? null, E = y[e], f = E ? Pe.Error : Pe.Default, C = $e(
    () => h.map(
      (L) => Xc(
        {
          id: L.value,
          label: L.label,
          value: L.value,
          attributes: L.attributes
        },
        u
      )
    ),
    [h, u]
  );
  return /* @__PURE__ */ g(
    Uo,
    {
      disabled: o,
      id: `ism-field-${e}`,
      name: e,
      label: t,
      required: r,
      placeholder: s,
      value: N,
      onChange: (L) => {
        v(e, L), l && x();
      },
      onSearch: S,
      getOptionLabel: (L) => L.label,
      initialOptions: C,
      state: f,
      hint: E ?? void 0,
      size: Nt.Small,
      width: S5[m] ?? we.Auto
    }
  );
}
const ks = {
  "ns-multi-select-slot": "_ns-multi-select-slot_ds7w4_1",
  "ns-multi-select-slot--width-full": "_ns-multi-select-slot--width-full_ds7w4_6",
  "ns-multi-select-slot--width-sm": "_ns-multi-select-slot--width-sm_ds7w4_9",
  "ns-multi-select-slot--width-md": "_ns-multi-select-slot--width-md_ds7w4_12",
  "ns-multi-select-slot--width-lg": "_ns-multi-select-slot--width-lg_ds7w4_15",
  "ns-multi-select-slot__list": "_ns-multi-select-slot__list_ds7w4_18",
  "ns-multi-select-slot__error": "_ns-multi-select-slot__error_ds7w4_23"
};
function Kp(e, t) {
  return t ? e.map((n) => {
    const i = Object.prototype.hasOwnProperty.call(t, n.value) ? t[n.value] : void 0;
    return n.description !== void 0 || !i ? n : { ...n, description: i };
  }) : e;
}
const A5 = [];
function I5({
  name: e,
  label: t,
  options: n,
  optionDescriptions: i,
  required: r = !1,
  placeholder: s,
  disabled: o,
  value: l,
  minSelections: u,
  minSelectionsHint: c,
  width: d = "auto"
}) {
  const { values: h, errors: m, setValue: _, registerValidator: y } = Cn(), [v, w] = Ee(""), [x, A] = Ee(!1), S = ee(null), N = rt();
  me(() => y(e, (K) => {
    const P = Array.isArray(K) ? K : [], oe = n.filter((se) => P.includes(se.value)).length;
    return r && oe === 0 ? `${t} is required.` : u && oe < u ? c ?? `Select at least ${u}.` : null;
  }), [e, t, r, u, c, n, y]), me(() => {
    h[e] === void 0 && l !== void 0 && _(e, l, { seed: !0 });
  }, [e, l, h, _]);
  const E = Array.isArray(h[e]) ? h[e] : A5, f = m[e], C = $e(
    () => n.filter((K) => E.includes(K.value)).map((K) => K.id),
    [n, E]
  ), L = $e(() => o || !u || u <= 0 || C.length > u ? /* @__PURE__ */ new Set() : new Set(C), [o, u, C]), R = $e(
    () => Kp(n, i),
    [n, i]
  ), V = Bo(R, v, !0), z = c ?? `Select at least ${u}.`, $ = $e(
    () => V.map((K) => o ? { ...K, disabled: !0 } : L.has(K.id) ? {
      ...K,
      disabled: !0,
      description: K.description ? `${K.description} — ${z}` : z
    } : K),
    [V, o, L, z]
  ), H = (K) => {
    if (K.disabled)
      return;
    const P = E.includes(K.value) ? E.filter((oe) => oe !== K.value) : [...E, K.value];
    _(
      e,
      n.filter((oe) => P.includes(oe.value)).map((oe) => oe.value)
    );
  }, { activeId: B, clearActiveId: O, handleInputKeyDown: W, onOptionRef: G } = ar({
    options: $,
    // The list has no separate open/closed state of its own — it's always
    // visible inside the token's popover panel, which is the thing that
    // opens/closes. onOpen/onClose are effectively unreachable no-ops.
    isOpen: !0,
    onOpen: () => {
    },
    onClose: () => {
    },
    onSelect: H
  }), re = t.length > 0 ? t : s ?? "Filter options";
  return /* @__PURE__ */ F(
    "div",
    {
      className: X(
        ks["ns-multi-select-slot"],
        d !== "auto" && ks[`ns-multi-select-slot--width-${d}`]
      ),
      children: [
        /* @__PURE__ */ g(
          Rn,
          {
            isFocused: x,
            disabled: o,
            state: f ? Pe.Error : Pe.Default,
            size: Nt.Small,
            prefix: q.Search,
            inputRef: S,
            children: /* @__PURE__ */ g(
              On,
              {
                ref: S,
                id: `ism-field-${e}`,
                value: v,
                placeholder: s ?? "Search…",
                type: gt.Search,
                disabled: o,
                role: "combobox",
                ariaLabel: re,
                ariaExpanded: !0,
                ariaControls: N,
                ariaActivedescendant: B ?? void 0,
                ariaInvalid: !!f,
                autoComplete: "off",
                onChange: w,
                onFocus: () => A(!0),
                onBlur: () => A(!1),
                onKeyDown: W
              }
            )
          }
        ),
        /* @__PURE__ */ g("div", { className: ks["ns-multi-select-slot__list"], children: /* @__PURE__ */ g(
          or,
          {
            id: N,
            options: $,
            selectedIds: C,
            activeId: B,
            mode: "multi",
            ariaLabel: re,
            emptyText: "No matching options",
            onActivate: (K) => {
              H(K), O();
            },
            onOptionRef: G
          }
        ) }),
        f && /* @__PURE__ */ g("p", { role: "alert", className: ks["ns-multi-select-slot__error"], children: f })
      ]
    }
  );
}
const L5 = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function N5({
  name: e,
  label: t,
  options: n,
  optionDescriptions: i,
  required: r = !1,
  placeholder: s,
  disabled: o,
  autoSubmit: l = !0,
  value: u,
  width: c = "auto"
}) {
  const { values: d, errors: h, setValue: m, registerValidator: _, submit: y } = Cn(), v = $e(
    () => Kp(n, i),
    [n, i]
  );
  me(() => _(e, (S) => r && !S ? `${t} is required.` : null), [e, t, r, _]), me(() => {
    d[e] === void 0 && u !== void 0 && m(e, u, { seed: !0 });
  }, [e, u, d, m]);
  const w = d[e] ?? null, x = h[e], A = x ? Pe.Error : Pe.Default;
  return /* @__PURE__ */ g(
    Oo,
    {
      disabled: o,
      id: `ism-field-${e}`,
      name: e,
      label: t,
      options: v,
      required: r,
      placeholder: s,
      value: w,
      onChange: (S) => {
        m(e, S), l && y();
      },
      state: A,
      hint: x ?? void 0,
      size: Nt.Small,
      width: L5[c] ?? we.Auto
    }
  );
}
const T5 = {
  "ns-animated-aries-icon": "_ns-animated-aries-icon_6az0b_11"
};
function Yp({ size: e = 20, className: t }) {
  return /* @__PURE__ */ g(be, { name: q.ARIES, size: e, className: X(T5["ns-animated-aries-icon"], t) });
}
const Gc = {
  "spinner-slot": "_spinner-slot_tpxx7_1",
  "spinner-slot__text": "_spinner-slot__text_tpxx7_11"
};
function Qp({ text: e = "Thinking…", minHeight: t }) {
  return /* @__PURE__ */ F(
    "div",
    {
      className: Gc["spinner-slot"],
      style: t ? { minHeight: t } : void 0,
      role: "status",
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ g(Yp, { size: 40 }),
        /* @__PURE__ */ g("span", { className: Gc["spinner-slot__text"], children: e })
      ]
    }
  );
}
const P5 = {
  text: gt.Text,
  email: gt.Email,
  number: gt.Number
}, D5 = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function M5({
  name: e,
  label: t,
  placeholder: n,
  required: i = !1,
  inputType: r = "text",
  disabled: s,
  width: o = "auto"
}) {
  const { values: l, errors: u, setValue: c, registerValidator: d, submit: h } = Cn();
  me(() => d(e, (w) => i && (!w || String(w).trim() === "") ? `${t} is required.` : null), [e, t, i, d]);
  const m = l[e] ?? "", _ = u[e], y = _ ? Pe.Error : Pe.Default, v = (w) => {
    w.key === "Enter" && !s && (w.preventDefault(), h());
  };
  return /* @__PURE__ */ g(
    Ki,
    {
      disabled: s,
      id: `ism-field-${e}`,
      name: e,
      label: t,
      placeholder: n,
      required: i,
      value: m,
      onChange: (w) => c(e, w),
      onKeyDown: v,
      state: y,
      hint: _ ?? void 0,
      size: Nt.Small,
      inputType: P5[r] ?? gt.Text,
      width: D5[o] ?? we.Auto
    }
  );
}
const V5 = {
  auto: we.Auto,
  full: we.Full,
  sm: we.Small,
  md: we.Medium,
  lg: we.Large
};
function F5({
  name: e,
  label: t,
  required: n = !1,
  minTime: i,
  maxTime: r,
  disabled: s,
  width: o = "auto"
}) {
  const { values: l, errors: u, setValue: c, registerValidator: d } = Cn();
  me(() => d(e, (y) => n && !y ? `${t} is required.` : null), [e, t, n, d]);
  const h = l[e] ?? null, m = u[e], _ = m ? Pe.Error : Pe.Default;
  return /* @__PURE__ */ g(
    Ho,
    {
      id: `ism-field-${e}`,
      disabled: s,
      name: e,
      label: t,
      required: n,
      value: h,
      onChange: (y) => c(e, y),
      state: _,
      hint: m ?? void 0,
      size: Nt.Small,
      minTime: i,
      maxTime: r,
      width: V5[o] ?? we.Auto
    }
  );
}
const R5 = {
  TextField: {
    Component: M5,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      placeholder: { param: "placeholder", type: "string" },
      required: { param: "required", type: "boolean", default: !1 },
      // The ISM param is "type" but the React prop is "inputType" to avoid
      // collision with the HTML `type` attribute forwarded by the input component.
      inputType: { param: "type", type: "string", default: "text" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  Checkbox: {
    Component: v5,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  DatePicker: {
    Component: Gp,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      minDate: { param: "minDate", type: "string" },
      maxDate: { param: "maxDate", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      // answerLater: renders an extra button under the calendar that submits
      // the ANSWER_LATER_VALUE sentinel instead of a date (see answerLater.ts).
      // autoSubmit is deliberately still absent from this spec — decoded
      // instances always auto-submit.
      answerLater: { param: "answerLater", type: "boolean", default: !1 },
      answerLaterLabel: { param: "answerLaterLabel", type: "string", default: "Answer later" },
      // Styling for the answer-later button, fully ISM-controllable (same
      // conventions as the Button slot). Prefix/suffix take IconName string
      // values (e.g. "calendar-today").
      answerLaterPrefix: { param: "answerLaterPrefix", type: "string" },
      answerLaterSuffix: { param: "answerLaterSuffix", type: "string" },
      answerLaterVariant: { param: "answerLaterVariant", type: "string", default: "text" },
      answerLaterColor: { param: "answerLaterColor", type: "string", default: "primary" },
      // value: pre-selected ISO date. Seeds ISMFormContext on mount so the
      // calendar renders with a day already selected.
      value: { param: "value", type: "string" },
      // width only constrains the slot's outer wrapper — the calendar grid
      // keeps its intrinsic ~240-280px sizing regardless of this value.
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  // we need to keep this as a way to quickly-toggle these two types...
  // {
  //   Component: DatePickerSlot,
  //   spec: {
  //     name:     { param: "name",     type: "string",  default: "" },
  //     label:    { param: "label",    type: "string",  default: "" },
  //     required: { param: "required", type: "boolean", default: false },
  //     minDate:  { param: "minDate",  type: "string" },
  //     maxDate:  { param: "maxDate",  type: "string" },
  //     disabled: { param: "disabled", type: "boolean", default: false },
  //   },
  // },
  Select: {
    Component: N5,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      // "options" is a pipe-separated list: "Label|Label:value|..."
      // Parsed into { id, label, value }[] by the "options" type parser.
      options: { param: "options", type: "options", default: [] },
      // optionDescriptions: "value:description|..." — an optional secondary
      // line per option value, rendered under the option's label.
      optionDescriptions: { param: "optionDescriptions", type: "descriptionMap", default: {} },
      placeholder: { param: "placeholder", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      // value: pre-selected option value, matched against `options[].value`.
      // Seeds ISMFormContext on mount so the Select renders pre-filled.
      value: { param: "value", type: "string" },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  // A set of option values rather than one — checked/unchecked via a
  // searchable checkbox list, no chips (LOA-1332). Unlike every other slot
  // here, this one never submits itself; it's only ever used inside a
  // ContextToken with `submitOnClose`, which submits once when the popover
  // closes rather than on every checkbox toggle. See MultiSelectSlot's
  // docstring for why, and ContextPrompt's SUBMIT_ON_CLOSE_COMPONENTS.
  MultiSelect: {
    Component: I5,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      // "options" is the same pipe-separated "Label:value" list Select
      // uses — one option per entry, not the selection.
      options: { param: "options", type: "options", default: [] },
      // optionDescriptions: same "value:description|..." map Select uses —
      // the always-visible secondary line under each option.
      optionDescriptions: { param: "optionDescriptions", type: "descriptionMap", default: {} },
      placeholder: { param: "placeholder", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      // value: comma-separated selected option values. Seeds
      // ISMFormContext on mount as a string[] via the "stringList" type —
      // see ISMPropType's doc for why "," rather than Select's "|".
      value: { param: "value", type: "stringList" },
      // minSelections: floor below which a selected option can't be
      // unchecked. No maximum counterpart exists yet — add one the same
      // way if a future ticket needs it.
      minSelections: { param: "minSelections", type: "number" },
      minSelectionsHint: { param: "minSelectionsHint", type: "string" },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  TimePicker: {
    Component: F5,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      minTime: { param: "minTime", type: "string" },
      maxTime: { param: "maxTime", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  EntityPicker: {
    Component: E5,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      // kind: semantic entity type, e.g. "employee", "department".
      // Passed to ISMFormProvider.onSearch so the host can route to the
      // correct data source. Falls back to `name` inside EntityPickerSlot
      // when not provided.
      kind: { param: "kind", type: "string" },
      // endpoint: optional REST endpoint override. When present, the host
      // may use this URL directly instead of resolving from `kind`.
      endpoint: { param: "endpoint", type: "string" },
      required: { param: "required", type: "boolean", default: !1 },
      placeholder: { param: "placeholder", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      // options: pipe-separated "Label:value[:job_title]" entries — a
      // BE-supplied candidate list shown immediately, with no search needed
      // (e.g. resolving an ambiguous employee-name match to a handful of
      // candidates). Uses the EntityPicker-only "entityOptions" type (NOT
      // the "options" type shared with Select) so its optional third
      // job_title segment can never be misparsed against a Select/
      // ButtonGroup value that legitimately contains its own ":". Parsed
      // into { id, label, value, attributes? }[]; EntityPickerSlot remaps
      // each into the ISMEntityOption shape below.
      options: { param: "options", type: "entityOptions", default: [] },
      // fields: pipe-separated "key:Label" entries declaring which entity
      // attributes to surface as secondary info under each search result
      // (e.g. "employee_id:Employee ID|job_title:Job Title"). Mirrors how
      // EntityViewer/EntityEditor declare columns/fields, just carried over
      // the ISM string. Parsed into { key, label }[] by the "fields" type.
      infoFields: { param: "fields", type: "fields", default: [] },
      // value: pre-selected entity's value (e.g. an Employee ID). Paired
      // with `selectedLabel` to seed ISMFormContext on mount so the picker
      // renders with an entity already selected, without a live search.
      value: { param: "value", type: "string" },
      // selectedLabel: display label for the pre-selected entity above.
      selectedLabel: { param: "selectedLabel", type: "string" },
      width: { param: "width", type: "string", default: "auto" }
    }
  },
  Button: {
    Component: g5,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      value: { param: "value", type: "string" },
      variant: { param: "variant", type: "string" },
      color: { param: "color", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 }
    }
  },
  ButtonGroup: {
    Component: b5,
    // Renders directly below the prose in ContextPrompt (never behind a
    // ContextToken popover) — its options must be immediately visible.
    inline: !0,
    spec: {
      name: { param: "name", type: "string", default: "" },
      // options is kept as a raw string; ButtonGroupSlot parses label:value
      // pairs internally (same format as Select, but deferred to the component
      // so the component can maintain its own selected-state rendering).
      options: { param: "options", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      // autoSubmit defaults to true — set autoSubmit=0 in ISM to disable.
      autoSubmit: { param: "autoSubmit", type: "boolean", default: !0 },
      // The group's accessible name (the question it answers). Without it the
      // group is named by `name`, which is an identifier, not words.
      label: { param: "label", type: "string", default: "" },
      disabled: { param: "disabled", type: "boolean", default: !1 }
    }
  },
  Spinner: {
    Component: Qp,
    spec: {
      text: { param: "text", type: "string", default: "Thinking…" }
    },
    // Renders alone, centered — never as an inline token. See
    // ISMComponentDefinition.standalone.
    standalone: !0
  }
}, _k = {
  ...R5,
  DatePicker: {
    Component: Gp,
    spec: {
      name: { param: "name", type: "string", default: "" },
      label: { param: "label", type: "string", default: "" },
      required: { param: "required", type: "boolean", default: !1 },
      minDate: { param: "minDate", type: "string" },
      maxDate: { param: "maxDate", type: "string" },
      disabled: { param: "disabled", type: "boolean", default: !1 },
      answerLater: { param: "answerLater", type: "boolean", default: !1 },
      answerLaterLabel: { param: "answerLaterLabel", type: "string", default: "Answer later" },
      answerLaterPrefix: { param: "answerLaterPrefix", type: "string" },
      answerLaterSuffix: { param: "answerLaterSuffix", type: "string" },
      answerLaterVariant: { param: "answerLaterVariant", type: "string", default: "text" },
      answerLaterColor: { param: "answerLaterColor", type: "string", default: "primary" },
      value: { param: "value", type: "string" },
      width: { param: "width", type: "string", default: "auto" }
    }
  }
}, Za = {
  "ns-formatted-text": "_ns-formatted-text_agcni_1",
  "ns-formatted-text__list": "_ns-formatted-text__list_agcni_16"
}, O5 = /\[([^\]\n]+)\]\((https?:\/\/[^\s<>"')]+)\)|https?:\/\/[^\s<>"']+/gi, B5 = ".,;:!?", z5 = { ")": "(", "]": "[", "}": "{" };
function Kc(e, t) {
  return e.split(t).length - 1;
}
function Yc(e) {
  const t = e.charAt(e.length - 1), n = z5[t];
  return t !== "" && B5.includes(t) || n !== void 0 && Kc(e, t) > Kc(e, n) ? e.slice(0, -1) : null;
}
function j5(e) {
  let t = e, n = Yc(t);
  for (; n !== null; )
    t = n, n = Yc(t);
  return t;
}
function $5(e) {
  try {
    const { protocol: t } = new URL(e);
    return t === "https:" || t === "http:";
  } catch {
    return !1;
  }
}
function H5(e) {
  const t = [];
  let n = 0;
  for (const i of e.matchAll(O5)) {
    const r = i.index ?? 0, s = i[1], o = s === void 0 ? j5(i[0]) : i[2] ?? "";
    $5(o) && (r > n && t.push({ kind: "text", value: e.slice(n, r) }), t.push(s === void 0 ? { kind: "link", value: o } : { kind: "link", value: o, label: s }), n = r + (s === void 0 ? o.length : i[0].length));
  }
  return n < e.length && t.push({ kind: "text", value: e.slice(n) }), t;
}
function Do({ text: e }) {
  return /* @__PURE__ */ g(et, { children: H5(e).map(
    (t, n) => t.kind === "link" ? (
      // Children, not `text`: the Link's trailing launch icon is a block
      // element, which would drop onto a line of its own inside a sentence.
      /* @__PURE__ */ g(
        Gr,
        {
          url: t.value,
          target: Xn.Blank,
          title: t.label === void 0 ? void 0 : t.value,
          ariaLabel: `${t.label ?? t.value} (opens in a new tab)`,
          children: t.label ?? t.value
        },
        n
      )
    ) : /* @__PURE__ */ g(Vo, { children: t.value }, n)
  ) });
}
const U5 = /^\s*[-*•]\s+(.*)$/, q5 = /\*\*([^*\n]+)\*\*/g;
function J5(e) {
  const t = [];
  let n = [], i = [];
  const r = () => {
    n.length > 0 && t.push({ kind: "paragraph", lines: n }), i.length > 0 && t.push({ kind: "list", items: i }), n = [], i = [];
  };
  for (const s of e.split(`
`)) {
    const o = U5.exec(s);
    s.trim() === "" ? r() : o ? (n.length > 0 && r(), i.push(o[1] ?? "")) : (i.length > 0 && r(), n.push(s));
  }
  return r(), t;
}
function Qc({ text: e }) {
  const t = [];
  let n = 0;
  for (const i of e.matchAll(q5)) {
    const r = i.index ?? 0;
    r > n && t.push(/* @__PURE__ */ g(Do, { text: e.slice(n, r) }, `t${n}`)), t.push(/* @__PURE__ */ g("strong", { children: i[1] }, `b${r}`)), n = r + i[0].length;
  }
  return n < e.length && t.push(/* @__PURE__ */ g(Do, { text: e.slice(n) }, `t${n}`)), /* @__PURE__ */ g(et, { children: t });
}
function W5({ text: e }) {
  return /* @__PURE__ */ g("div", { className: Za["ns-formatted-text"], children: J5(e).map(
    (t, n) => t.kind === "list" ? /* @__PURE__ */ g("ul", { className: Za["ns-formatted-text__list"], children: t.items.map((i, r) => /* @__PURE__ */ g("li", { children: /* @__PURE__ */ g(Qc, { text: i }) }, r)) }, n) : /* @__PURE__ */ g("p", { className: Za["ns-formatted-text__paragraph"], children: t.lines.map((i, r) => /* @__PURE__ */ F(Vo, { children: [
      r > 0 && /* @__PURE__ */ g("br", {}),
      /* @__PURE__ */ g(Qc, { text: i })
    ] }, r)) }, n)
  ) });
}
function vl({ ism: e, registry: t, onParseError: n, filter: i, isActiveISM: r }) {
  const { nodes: s, errors: o } = $e(() => ia(e, t), [e, t]);
  return me(() => {
    o.length > 0 && n?.(o);
  }, [o, n]), /* @__PURE__ */ g(et, { children: s.map((l, u) => {
    if (l.type === "text")
      return i === "slots" ? null : /* @__PURE__ */ g(W5, { text: l.content }, u);
    if (i === "text")
      return null;
    const c = t[l.componentName];
    if (!c)
      return null;
    const d = c.Component;
    return /* @__PURE__ */ g(
      d,
      {
        ...l.props,
        disabled: !r || l.interactive === !1
      },
      `${l.componentName}-${u}`
    );
  }) });
}
function gk({
  ism: e,
  registry: t,
  "aria-label": n = "AI message",
  isActiveISM: i = !1,
  onParseError: r
}) {
  return /* @__PURE__ */ g(vl, { ism: e, registry: t, onParseError: r, isActiveISM: i });
}
const Xa = {
  "context-prompt": "_context-prompt_15dzo_1",
  "context-prompt__prose": "_context-prompt__prose_15dzo_14",
  "context-prompt__inline-slots": "_context-prompt__inline-slots_15dzo_20"
}, Z5 = {
  "ds-context-token-panel": "_ds-context-token-panel_1s031_9"
}, X5 = {
  clear: Le.Success,
  unclear: Le.Warning,
  invalid: Le.Error
};
function G5(e, t, n, i) {
  return e ? Le.Error : t ? Le.Warning : n ? Le.Success : X5[i];
}
function Mo(e) {
  return e == null || Array.isArray(e) && e.length === 0;
}
function K5(e, t) {
  if (Mo(e) && Mo(t))
    return !0;
  if (Array.isArray(e) && Array.isArray(t)) {
    const n = e, i = t;
    if (n.length !== i.length)
      return !1;
    const r = [...n].sort(), s = [...i].sort();
    return r.every((o, l) => o === s[l]);
  }
  return e === t;
}
const Y5 = "ds-context-token-panel-layer";
function Q5({
  componentName: e,
  source: t,
  fieldName: n,
  status: i,
  icon: r,
  slotContent: s,
  formatValue: o,
  disabled: l = !1,
  closeOnChange: u = !1,
  submitOnClose: c = !1,
  initialValue: d
}) {
  const { values: h, errors: m, touched: _, submit: y } = Cn(), v = ee(null), [w, x] = Ee(!1), [A, S] = Ee({ top: 0, left: 0 }), N = ee(void 0), E = () => {
    x(!1), c && !K5(h[n], N.current) && y();
  }, f = ee(E);
  f.current = E;
  const { panelRef: C } = jo({ isOpen: w, onClose: E }), L = h[n], V = _[n] === !0 && L !== "" && !Mo(L), z = e === "DatePicker" && yl(L), $ = m[n], H = V ? o ? o(L) : String(L) : t, B = G5($, z, V, i), O = () => {
    const re = v.current?.getBoundingClientRect();
    re && S({ top: re.bottom + 2, left: re.left });
  }, W = () => {
    O(), N.current = L === void 0 ? d : L, x(!0);
  }, G = () => {
    l || (w ? E() : W());
  };
  return me(() => {
    if (!w)
      return;
    const re = { current: 0 }, K = () => {
      cancelAnimationFrame(re.current), re.current = requestAnimationFrame(O);
    };
    return window.addEventListener("scroll", K, { capture: !0, passive: !0 }), window.addEventListener("resize", K, { passive: !0 }), () => {
      window.removeEventListener("scroll", K, { capture: !0 }), window.removeEventListener("resize", K), cancelAnimationFrame(re.current);
    };
  }, [w]), me(() => {
    !u || !w || L !== void 0 && L !== N.current && f.current();
  }, [u, w, L]), me(() => {
    if (!w)
      return;
    const re = (K) => {
      const P = K.target;
      C.current?.contains(P) || v.current?.contains(P) || P?.closest?.("[data-ds-layer]") || f.current();
    };
    return document.addEventListener("pointerdown", re), () => document.removeEventListener("pointerdown", re);
  }, [w, C]), /* @__PURE__ */ F(et, { children: [
    /* @__PURE__ */ g(
      Ze,
      {
        ref: v,
        text: H,
        prefix: r,
        variant: Ye.Outlined,
        color: B,
        size: lt.Medium,
        disabled: l,
        "aria-label": V ? `${t}: ${H}` : `Clarify: ${t}`,
        tooltip: $ ?? void 0,
        onClick: G
      }
    ),
    w && hi(
      /* @__PURE__ */ g("div", { ref: C, className: Z5["ds-context-token-panel"], style: { top: A.top, left: A.left }, children: s }),
      pi(Y5)
    )
  ] });
}
const e6 = {
  DatePicker: q.CalendarToday
}, t6 = /* @__PURE__ */ new Set(["Select", "DatePicker", "EntityPicker"]), n6 = /* @__PURE__ */ new Set(["MultiSelect"]);
function i6(e) {
  return Array.isArray(e) ? e : typeof e == "string" ? e.split("|").filter(Boolean).map((t) => {
    const n = t.indexOf(":");
    return n === -1 ? { label: t, value: t } : { label: t.slice(0, n), value: t.slice(n + 1) };
  }) : [];
}
function ed(e, t) {
  const n = i6(e).find((i) => i.value === t);
  return n ? String(n.label) : void 0;
}
function r6(e) {
  const [t, n, i] = e.split("-").map(Number);
  return !t || !n || !i ? e : new Date(t, n - 1, i).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}
function s6(e, t, n, i) {
  if (e === "DatePicker" && yl(n))
    return i ?? "Answer later";
  if (typeof n == "boolean")
    return n ? "Yes" : "No";
  if (Array.isArray(n)) {
    const s = Array.from(
      new Set(n.map((o) => ed(t, o) ?? String(o)))
    ).sort((o, l) => o.localeCompare(l));
    return p5(s);
  }
  if (n && typeof n == "object" && "label" in n)
    return String(n.label);
  const r = ed(t, n);
  return r !== void 0 ? r : e === "DatePicker" && typeof n == "string" ? r6(n) : String(n);
}
function xk({
  text: e,
  registry: t,
  onSubmit: n,
  onSearch: i,
  validate: r,
  loading: s = !1,
  loadingText: o,
  disabled: l,
  inlineSlots: u = !1,
  autoFocus: c = !1
}) {
  const { nodes: d } = $e(
    () => e ? ia(e, t) : { nodes: [], errors: [] },
    [e, t]
  ), h = $e(
    () => d.filter(
      (w) => w.type === "slot" && (u || !!t[w.componentName]?.inline)
    ),
    [d, u, t]
  ), m = hd(e, { enabled: c }), _ = X({
    [Xa["context-prompt"]]: !0
  });
  if (s)
    return /* @__PURE__ */ g("div", { className: _, children: /* @__PURE__ */ g(Qp, { text: o }) });
  if (!e || d.length === 0)
    return null;
  const y = d.length === 1 ? d[0] : void 0, v = y?.type === "slot" ? t[y.componentName] : void 0;
  if (y?.type === "slot" && v?.standalone) {
    const w = v.Component;
    return /* @__PURE__ */ g("div", { className: _, children: /* @__PURE__ */ g(w, { ...y.props }) });
  }
  return /* @__PURE__ */ g(f5, { onSubmit: n, onSearch: i, validate: r, children: /* @__PURE__ */ F("div", { className: _, children: [
    /* @__PURE__ */ g("p", { className: Xa["context-prompt__prose"], children: d.map((w, x) => {
      if (w.type === "text")
        return /* @__PURE__ */ g("span", { children: w.content }, x);
      const A = t[w.componentName];
      if (!A || u || A.inline)
        return null;
      const S = w.source ?? w.componentName, N = w.status ?? "unclear", E = w.interactive === !1 || !!w.props.disabled || !!l, f = A.Component;
      return /* @__PURE__ */ g(
        Q5,
        {
          componentName: w.componentName,
          source: S,
          fieldName: String(w.props.name ?? w.componentName),
          status: N,
          icon: e6[w.componentName],
          disabled: E,
          closeOnChange: t6.has(w.componentName),
          submitOnClose: n6.has(w.componentName),
          initialValue: w.props.value,
          formatValue: (C) => {
            const L = w.props.answerLaterLabel;
            return s6(
              w.componentName,
              w.props.options,
              C,
              typeof L == "string" ? L : void 0
            );
          },
          slotContent: /* @__PURE__ */ g(f, { ...w.props, disabled: l, label: "" })
        },
        `${w.componentName}-${x}`
      );
    }) }),
    h.length > 0 && /* @__PURE__ */ g("div", { ref: m, className: Xa["context-prompt__inline-slots"], children: h.map((w, x) => {
      const A = t[w.componentName];
      if (!A)
        return null;
      const S = w.interactive === !1 || !!w.props.disabled || !!l, N = A.Component;
      return /* @__PURE__ */ g(
        N,
        {
          ...w.props,
          disabled: S
        },
        `${w.componentName}-${x}`
      );
    }) })
  ] }) });
}
const Ga = {
  "ns-aries-status-row": "_ns-aries-status-row_1mx9l_1",
  "ns-aries-status-row__icon-wrap": "_ns-aries-status-row__icon-wrap_1mx9l_8",
  "ns-aries-status-row__label": "_ns-aries-status-row__label_1mx9l_14"
}, a6 = [
  "Thinking…",
  "Working on it…",
  "Analyzing your request…",
  "Gathering the details…",
  "Reviewing your answer…",
  "Putting it together…",
  "One moment…"
], o6 = ["Scrubbing PHI…", "Removing personal details…", "Securing your message…"];
function l6(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function u6({ item: e }) {
  const t = e.status === "sanitizing" ? "sanitizing" : "working", n = $e(
    () => l6(t === "sanitizing" ? o6 : a6),
    [t]
  ), i = e.label ?? n;
  return /* @__PURE__ */ F("div", { className: Ga["ns-aries-status-row"], "aria-label": i, children: [
    /* @__PURE__ */ g("span", { className: Ga["ns-aries-status-row__icon-wrap"], "aria-hidden": "true", children: /* @__PURE__ */ g(Yp, { size: 20 }) }),
    /* @__PURE__ */ g("span", { className: Ga["ns-aries-status-row__label"], children: i })
  ] });
}
const Kt = {
  "ns-chat-message-row": "_ns-chat-message-row_14rb4_9",
  "ns-chat-message-row--end": "_ns-chat-message-row--end_14rb4_14",
  "ns-chat-message-row--start": "_ns-chat-message-row--start_14rb4_18",
  "ns-chat-message-row__content": "_ns-chat-message-row__content_14rb4_22",
  "ns-chat-message-row__ism-panel": "_ns-chat-message-row__ism-panel_14rb4_37",
  "ns-chat-message-row__meta": "_ns-chat-message-row__meta_14rb4_46",
  "ns-chat-message-row__timestamp": "_ns-chat-message-row__timestamp_14rb4_58",
  "ns-chat-message-row__delivery": "_ns-chat-message-row__delivery_14rb4_64",
  "ns-chat-message-row__delivery--sent": "_ns-chat-message-row__delivery--sent_14rb4_71",
  "ns-chat-message-row__delivery--failed": "_ns-chat-message-row__delivery--failed_14rb4_75",
  "ns-chat-message-row__delivery--sending": "_ns-chat-message-row__delivery--sending_14rb4_79",
  "ns-chat-message-row__sending-dot": "_ns-chat-message-row__sending-dot_14rb4_83"
};
function c6({ delivery: e }) {
  return e === "sent" || e === "complete" ? /* @__PURE__ */ g("span", { className: X(Kt["ns-chat-message-row__delivery"], Kt["ns-chat-message-row__delivery--sent"]), children: /* @__PURE__ */ g(be, { name: q.Done, "aria-label": "Sent" }) }) : e === "failed" ? /* @__PURE__ */ g("span", { className: X(Kt["ns-chat-message-row__delivery"], Kt["ns-chat-message-row__delivery--failed"]), children: /* @__PURE__ */ g(be, { name: q.Close, "aria-label": "Failed to send" }) }) : e === "sending" ? /* @__PURE__ */ g(
    "span",
    {
      className: X(Kt["ns-chat-message-row__delivery"], Kt["ns-chat-message-row__delivery--sending"]),
      "aria-label": "Sending",
      children: /* @__PURE__ */ g("span", { className: Kt["ns-chat-message-row__sending-dot"], "aria-hidden": "true" })
    }
  ) : null;
}
const Ka = {
  "ns-message-feedback-row": "_ns-message-feedback-row_1b813_1",
  "ns-message-feedback-row__btn": "_ns-message-feedback-row__btn_1b813_9"
};
function bk({ onFeedback: e }) {
  return /* @__PURE__ */ F("div", { className: Ka["ns-message-feedback-row"], "aria-label": "Was this response helpful?", children: [
    /* @__PURE__ */ g(
      Ze,
      {
        type: "button",
        className: Ka["ns-message-feedback-row__btn"],
        "aria-label": "Helpful",
        onClick: () => e("up"),
        icon: q.ThumbUp,
        variant: Ye.Outlined,
        size: lt.Small,
        isIconOnly: !0
      }
    ),
    /* @__PURE__ */ g(
      Ze,
      {
        type: "button",
        className: Ka["ns-message-feedback-row__btn"],
        "aria-label": "Not helpful",
        onClick: () => e("down"),
        icon: q.ThumbDown,
        variant: Ye.Outlined,
        size: lt.Small,
        isIconOnly: !0
      }
    )
  ] });
}
const Li = {
  "ns-chat-bubble": "_ns-chat-bubble_1cn1u_1",
  "ns-chat-bubble--end": "_ns-chat-bubble--end_1cn1u_7",
  "ns-chat-bubble--start": "_ns-chat-bubble--start_1cn1u_11",
  "ns-chat-bubble__pill": "_ns-chat-bubble__pill_1cn1u_15",
  "ns-chat-bubble__pill--human": "_ns-chat-bubble__pill--human_1cn1u_20",
  "ns-chat-bubble__text": "_ns-chat-bubble__text_1cn1u_28",
  "ns-chat-bubble__pill--assistant": "_ns-chat-bubble__pill--assistant_1cn1u_32"
};
function d6({
  content: e,
  alignment: t,
  participant: n,
  registry: i,
  "aria-label": r,
  isActiveISM: s = !1
}) {
  const o = t === "end", l = o ? Li["ns-chat-bubble--end"] : Li["ns-chat-bubble--start"], u = o ? Li["ns-chat-bubble__pill--human"] : Li["ns-chat-bubble__pill--assistant"], c = e.kind === "ism" ? /* @__PURE__ */ g(vl, { ism: e.ism, registry: i, filter: "text", isActiveISM: s }) : /* @__PURE__ */ g("p", { className: Li["ns-chat-bubble__text"], children: o ? e.text : /* @__PURE__ */ g(Do, { text: e.text }) });
  return /* @__PURE__ */ g("div", { className: X(Li["ns-chat-bubble"], l), "aria-label": r, children: /* @__PURE__ */ F("div", { className: X(Li["ns-chat-bubble__pill"], u), children: [
    /* @__PURE__ */ g(
      Hs,
      {
        imageUrl: n.avatarUrl,
        iconName: n.iconName,
        name: n.name,
        size: 32,
        isAries: !o
      }
    ),
    c
  ] }) });
}
const td = {
  "ns-chat-date-divider": "_ns-chat-date-divider_23x9d_1",
  "ns-chat-date-divider__label": "_ns-chat-date-divider__label_23x9d_14"
};
function h6({ item: e }) {
  const t = new Intl.DateTimeFormat(void 0, {
    weekday: "long",
    month: "long",
    day: "numeric"
  }).format(e.date);
  return /* @__PURE__ */ g("div", { className: td["ns-chat-date-divider"], role: "separator", "aria-label": t, children: /* @__PURE__ */ g("span", { className: td["ns-chat-date-divider__label"], "aria-hidden": "true", children: t }) });
}
const Ya = {
  "ns-chat-error-row": "_ns-chat-error-row_16809_1",
  "ns-chat-error-row__icon": "_ns-chat-error-row__icon_16809_12",
  "ns-chat-error-row__message": "_ns-chat-error-row__message_16809_18"
};
function p6({ item: e }) {
  return /* @__PURE__ */ F("div", { className: Ya["ns-chat-error-row"], role: "alert", children: [
    /* @__PURE__ */ g(be, { name: q.Close, className: Ya["ns-chat-error-row__icon"], "aria-hidden": "true" }),
    /* @__PURE__ */ g("span", { className: Ya["ns-chat-error-row__message"], children: e.message })
  ] });
}
function f6({
  item: e,
  registry: t,
  onMessageFeedback: n,
  showTimestamp: i = !1,
  showDeliveryBadge: r = !1,
  isActiveISM: s = !1,
  autoFocus: o = !1
}) {
  const l = hd(e.id, {
    enabled: o && s
  }), u = e.alignment === "end", c = e.timestamp.toISOString(), d = new Intl.DateTimeFormat(void 0, {
    hour: "numeric",
    minute: "2-digit"
  }).format(e.timestamp), m = !1, _ = i || r && u;
  return /* @__PURE__ */ g(
    "div",
    {
      className: X(
        Kt["ns-chat-message-row"],
        u ? Kt["ns-chat-message-row--end"] : Kt["ns-chat-message-row--start"]
      ),
      children: /* @__PURE__ */ F("div", { className: Kt["ns-chat-message-row__content"], children: [
        /* @__PURE__ */ g(
          d6,
          {
            content: e.content,
            alignment: e.alignment,
            participant: e.participant,
            registry: t,
            isActiveISM: s
          }
        ),
        e.content.kind === "ism" && s && /* @__PURE__ */ g("div", { ref: l, className: Kt["ns-chat-message-row__ism-panel"], children: /* @__PURE__ */ g(vl, { ism: e.content.ism, registry: t, isActiveISM: !0, filter: "slots" }) }),
        m,
        _ && /* @__PURE__ */ F("div", { className: Kt["ns-chat-message-row__meta"], children: [
          i && /* @__PURE__ */ g("time", { className: Kt["ns-chat-message-row__timestamp"], dateTime: c, children: d }),
          r && u && /* @__PURE__ */ g(c6, { delivery: e.delivery })
        ] })
      ] })
    }
  );
}
const nd = {
  "ns-chat-system-row": "_ns-chat-system-row_v9ntr_1",
  "ns-chat-system-row__text": "_ns-chat-system-row__text_v9ntr_7"
};
function m6({ item: e }) {
  return /* @__PURE__ */ g("div", { className: nd["ns-chat-system-row"], "aria-live": "polite", children: /* @__PURE__ */ g("span", { className: nd["ns-chat-system-row__text"], children: e.text }) });
}
const Qa = {
  "ns-chat-timeline": "_ns-chat-timeline_1xzg7_1",
  "ns-chat-timeline__list": "_ns-chat-timeline__list_1xzg7_8",
  "ns-chat-timeline__item": "_ns-chat-timeline__item_1xzg7_18"
}, Xi = {
  "ns-chat-typing-row": "_ns-chat-typing-row_z906l_9",
  "ns-chat-typing-row__avatar": "_ns-chat-typing-row__avatar_z906l_16",
  "ns-chat-typing-row__bubble": "_ns-chat-typing-row__bubble_z906l_39",
  "ns-chat-typing-row__dot": "_ns-chat-typing-row__dot_z906l_50"
};
function _6({ item: e }) {
  const t = e.participant.name.split(" ").slice(0, 2).map((n) => n[0]?.toUpperCase() ?? "").join("");
  return /* @__PURE__ */ F(
    "div",
    {
      className: Xi["ns-chat-typing-row"],
      role: "status",
      "aria-label": `${e.participant.name} is typing`,
      children: [
        /* @__PURE__ */ g("div", { className: Xi["ns-chat-typing-row__avatar"], "aria-hidden": "true", children: e.participant.avatarUrl ? /* @__PURE__ */ g("img", { src: e.participant.avatarUrl, alt: "" }) : /* @__PURE__ */ g("span", { children: t }) }),
        /* @__PURE__ */ F("div", { className: Xi["ns-chat-typing-row__bubble"], "aria-hidden": "true", children: [
          /* @__PURE__ */ g("span", { className: Xi["ns-chat-typing-row__dot"] }),
          /* @__PURE__ */ g("span", { className: Xi["ns-chat-typing-row__dot"] }),
          /* @__PURE__ */ g("span", { className: Xi["ns-chat-typing-row__dot"] })
        ] })
      ]
    }
  );
}
const g6 = 96;
function yk({
  items: e,
  registry: t,
  className: n,
  header: i,
  onMessageFeedback: r,
  showTimestamp: s = !1,
  showDeliveryBadge: o = !1,
  autoFocusActiveISM: l = !1
}) {
  const u = ee(null), c = ee(null), d = ee(null), h = ee(!0), m = ee(0), _ = he(() => {
    u.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, []), y = he(() => {
    const w = c.current;
    if (!w)
      return;
    const x = w.scrollTop;
    w.scrollHeight - x - w.clientHeight <= g6 ? h.current = !0 : x < m.current && (h.current = !1), m.current = x;
  }, []), v = $e(() => {
    let w;
    for (let x = e.length - 1; x >= 0; x--)
      if (e[x].kind === "message") {
        w = e[x];
        break;
      }
    return w?.kind === "message" && w.content.kind === "ism" && w.delivery !== "complete" ? w : void 0;
  }, [e]);
  return me(() => {
    h.current = !0, _();
  }, [e.length, _]), me(() => {
    const w = d.current;
    if (!w || typeof ResizeObserver > "u")
      return;
    const x = new ResizeObserver(() => {
      h.current && _();
    });
    return x.observe(w), () => x.disconnect();
  }, [_]), /* @__PURE__ */ F(
    "div",
    {
      ref: c,
      onScroll: y,
      className: X(Qa["ns-chat-timeline"], n),
      role: "log",
      "aria-live": "polite",
      "aria-label": "Conversation",
      "aria-relevant": "additions",
      children: [
        i,
        /* @__PURE__ */ g("ul", { ref: d, className: Qa["ns-chat-timeline__list"], children: e.map((w) => /* @__PURE__ */ F("li", { className: Qa["ns-chat-timeline__item"], children: [
          w.kind === "message" && /* @__PURE__ */ g(
            f6,
            {
              item: w,
              registry: t,
              onMessageFeedback: r,
              showTimestamp: s,
              showDeliveryBadge: o,
              isActiveISM: v ? w.id === v.id : !1,
              autoFocus: l
            }
          ),
          w.kind === "typing" && /* @__PURE__ */ g(_6, { item: w }),
          w.kind === "system" && /* @__PURE__ */ g(m6, { item: w }),
          w.kind === "date-divider" && /* @__PURE__ */ g(h6, { item: w }),
          w.kind === "error" && /* @__PURE__ */ g(p6, { item: w }),
          w.kind === "aries-status" && /* @__PURE__ */ g(u6, { item: w })
        ] }, w.id)) }),
        /* @__PURE__ */ g("div", { ref: u, "aria-hidden": "true" })
      ]
    }
  );
}
const id = {
  "ds-alert-container": "_ds-alert-container_19hve_1",
  "ds-alert-container--top-left": "_ds-alert-container--top-left_19hve_9",
  "ds-alert-container--top-center": "_ds-alert-container--top-center_19hve_13",
  "ds-alert-container--top-right": "_ds-alert-container--top-right_19hve_19",
  "ds-alert-container--center-left": "_ds-alert-container--center-left_19hve_24",
  "ds-alert-container--center": "_ds-alert-container--center_19hve_24",
  "ds-alert-container--center-right": "_ds-alert-container--center-right_19hve_35",
  "ds-alert-container--bottom-left": "_ds-alert-container--bottom-left_19hve_41",
  "ds-alert-container--bottom-center": "_ds-alert-container--bottom-center_19hve_45",
  "ds-alert-container--bottom-right": "_ds-alert-container--bottom-right_19hve_51"
}, x6 = "ds-alert-layer", b6 = 4e3, y6 = 150, v6 = Zo.BottomRight, w6 = wd.SlideIn, k6 = kd.SlideOut, wl = ei(null), ef = Object.values(Zo);
function C6(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of ef)
    t.set(n, []);
  for (const n of e)
    t.get(n.position).push(n);
  return t;
}
const S6 = ({ item: e, onSetPhase: t, onRemove: n }) => {
  const i = ee(null), r = ee(null), s = ee(null);
  me(() => (e.phase === "entering" && (i.current = requestAnimationFrame(() => {
    t(e.id, "visible");
  })), () => {
    i.current !== null && cancelAnimationFrame(i.current);
  }), []);
  const o = he(() => {
    r.current !== null && (clearTimeout(r.current), r.current = null), t(e.id, "exiting"), s.current = setTimeout(() => {
      n(e.id);
    }, y6);
  }, [e.id, t, n]);
  return me(() => {
    if (!(e.phase !== "visible" || e.duration === 0))
      return r.current = setTimeout(o, e.duration), () => {
        r.current !== null && clearTimeout(r.current);
      };
  }, [e.phase, e.duration, o]), me(() => () => {
    i.current !== null && cancelAnimationFrame(i.current), r.current !== null && clearTimeout(r.current), s.current !== null && clearTimeout(s.current);
  }, []), /* @__PURE__ */ g(
    Cd,
    {
      ...e.alertProps,
      phase: e.phase,
      enterEffect: e.enterEffect,
      exitEffect: e.exitEffect,
      onDismiss: o
    }
  );
}, E6 = () => {
  const e = Fn(wl);
  if (!e)
    return null;
  const { alerts: t, setPhase: n, removeAlert: i } = e, r = C6(t), s = pi(x6);
  return hi(
    /* @__PURE__ */ g(et, { children: ef.map((o) => {
      const l = r.get(o) ?? [];
      return l.length === 0 ? null : /* @__PURE__ */ g(
        "div",
        {
          className: `${id["ds-alert-container"]} ${id[`ds-alert-container--${o}`]}`,
          children: l.map((u) => /* @__PURE__ */ g(
            S6,
            {
              item: u,
              onSetPhase: n,
              onRemove: i
            },
            u.id
          ))
        },
        o
      );
    }) }),
    s
  );
};
function A6(e, t) {
  switch (t.type) {
    case "ADD_ALERT":
      return [...e, t.payload];
    case "SET_PHASE":
      return e.map(
        (n) => n.id === t.id ? { ...n, phase: t.phase } : n
      );
    case "REMOVE_ALERT":
      return e.filter((n) => n.id !== t.id);
    default:
      return e;
  }
}
const vk = ({ children: e }) => {
  const [t, n] = If(A6, []), i = he((u) => {
    const c = crypto.randomUUID(), d = {
      id: c,
      alertProps: {
        title: u.title,
        description: u.description,
        severity: u.severity ?? pn.Info,
        variant: u.variant ?? Us.Filled,
        dismissible: u.dismissible ?? !0,
        className: u.className
      },
      duration: u.duration ?? b6,
      position: u.position ?? v6,
      enterEffect: u.enterEffect ?? w6,
      exitEffect: u.exitEffect ?? k6,
      phase: "entering"
    };
    return n({ type: "ADD_ALERT", payload: d }), c;
  }, []), r = he((u) => {
    n({ type: "SET_PHASE", id: u, phase: "exiting" });
  }, []), s = he((u, c) => {
    n({ type: "SET_PHASE", id: u, phase: c });
  }, []), o = he((u) => {
    n({ type: "REMOVE_ALERT", id: u });
  }, []), l = { alerts: t, show: i, dismiss: r, setPhase: s, removeAlert: o };
  return /* @__PURE__ */ F(wl.Provider, { value: l, children: [
    e,
    /* @__PURE__ */ g(E6, {})
  ] });
};
function wk() {
  const e = Fn(wl);
  if (!e)
    throw new Error("useAlert must be used within an <AlertProvider>");
  return { show: e.show, dismiss: e.dismiss };
}
const I6 = {
  radius: {
    1: "4px",
    2: "6px",
    3: "8px",
    4: "12px",
    5: "16px",
    100: "100px"
  }
}, L6 = {
  desktop: {
    "min-width": "1025px"
  },
  tablet: {
    landscape: {
      from: {
        "max-width": "1024px"
      },
      to: {
        "min-width": "992px"
      }
    },
    portrait: {
      from: {
        "max-width": "991px"
      },
      to: {
        "min-width": "576px"
      }
    }
  },
  mobile: {
    "max-width": "575px"
  }
}, N6 = {
  neutral: {
    black: "#000000",
    white: "#FFFFFF"
  },
  "mitra-blue": {
    100: "#F2F7FD",
    200: "#BFD9F4",
    300: "#80B3E8",
    400: "#408DDE",
    500: "#0067D2",
    600: "#004D9E",
    700: "#003368",
    800: "#001A35",
    900: "#001A35"
  },
  "cool-gray": {
    100: "#F9FAFC",
    200: "#E3E9EF",
    300: "#C7D3DF",
    400: "#ABBDCF",
    500: "#8FA7BF",
    600: "#6B7D8F",
    700: "#47535F",
    800: "#242A30",
    900: "#07080A"
  },
  blue: {
    100: "#F2FAFD",
    200: "#BFE5F4",
    300: "#80CCE8",
    400: "#40B3DE",
    500: "#0099D2",
    600: "#00739E",
    700: "#004C68",
    800: "#002635",
    900: "#000F15"
  },
  green: {
    100: "#F2F8F6",
    200: "#BFDDD3",
    300: "#80BBA7",
    400: "#40997B",
    500: "#00774E",
    600: "#00593B",
    700: "#003B27",
    800: "#001E14",
    900: "#000C08"
  },
  red: {
    100: "#FCF4F4",
    200: "#F2C7C9",
    300: "#E69093",
    400: "#DA585D",
    500: "#CD2026",
    600: "#9A181D",
    700: "#661013",
    800: "#33080A",
    900: "#140304"
  },
  yellow: {
    100: "#FFFAF4",
    200: "#FFE5C7",
    300: "#FFCC8F",
    400: "#FFB357",
    500: "#FF991F",
    600: "#BF7317",
    700: "#7F4C0F",
    800: "#402608",
    900: "#190F03"
  }
}, T6 = {
  "sidebar-backdrop": "9",
  sidebar: "10",
  navbar: "10",
  "edge-tab": "50",
  "drawer-overlay": "100",
  drawer: "101",
  "dialog-overlay": "200",
  dialog: "201",
  "contextual-menu": "9998",
  tooltip: "9999"
}, P6 = {
  1: {
    x: "1px",
    y: "2px",
    blur: "3px",
    spread: "1px",
    color: "#00000017",
    opacity: "9%"
  },
  2: {
    x: "2px",
    y: "4px",
    blur: "6px",
    spread: "2px",
    color: "#00000017",
    opacity: "9%"
  },
  3: {
    x: "3px",
    y: "6px",
    blur: "9px",
    spread: "4px",
    color: "#00000017",
    opacity: "9%"
  },
  4: {
    x: "4px",
    y: "8px",
    blur: "12px",
    spread: "8px",
    color: "#00000017",
    opacity: "9%"
  }
}, D6 = {}, M6 = {
  navbar: {
    height: "80px"
  },
  sidebar: {
    width: {
      collapsed: "53px",
      expanded: "336px"
    }
  },
  "landmark-gap": "24px",
  drawer: {
    width: "600px"
  }
}, V6 = {}, F6 = {
  "space-1": "4px",
  "space-1-5": "6px",
  "space-2": "8px",
  "space-3": "12px",
  "space-4": "16px",
  "space-5": "20px",
  "space-6": "24px",
  "space-7": "32px",
  "space-8": "40px",
  "space-9": "48px",
  "space-10": "56px",
  "space-11": "64px",
  "space-12": "80px",
  "space-13": "96px"
}, R6 = {
  "font-family": {
    primary: "Poppins"
  },
  header: {
    1: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 600,
      "font-size": "48px",
      "font-kerning": "-0.5px",
      "line-height": "114.99999999999999%"
    },
    2: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 600,
      "font-size": "40px",
      "font-kerning": "0.4px",
      "line-height": "114.99999999999999%"
    },
    3: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "32px",
      "font-kerning": "-0.2px",
      "line-height": "120%"
    },
    4: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "28px",
      "font-kerning": "0px",
      "line-height": "120%"
    },
    5: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "24px",
      "font-kerning": "0px",
      "line-height": "120%"
    },
    6: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "20px",
      "font-kerning": "0px",
      "line-height": "120%"
    }
  },
  title: {
    page: {
      title: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "32px",
        "font-kerning": "-0.2px",
        "line-height": "120%",
        "text-transform": "capitalize"
      }
    },
    section: {
      title: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "20px",
        "font-kerning": "0px",
        "line-height": "120%"
      }
    }
  },
  body: {
    1: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "16px",
        "font-kerning": "0px",
        "line-height": "150%"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "16px",
        "font-kerning": "0px",
        "line-height": "150%"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "16px",
        "font-kerning": "0px",
        "line-height": "150%"
      }
    },
    2: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "14px",
        "font-kerning": "0px",
        "line-height": "150%"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "14px",
        "font-kerning": "0px",
        "line-height": "150%"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "14px",
        "font-kerning": "0px",
        "line-height": "150%"
      }
    },
    caption: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "12px",
        "font-kerning": "0.2px",
        "line-height": "140%"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "12px",
        "font-kerning": "0.2px",
        "line-height": "140%"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "12px",
        "font-kerning": "0.2px",
        "line-height": "140%"
      }
    },
    overline: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "10px",
        "font-kerning": "0.3px",
        "line-height": "130%",
        "text-transform": "uppercase"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "10px",
        "font-kerning": "0.3px",
        "line-height": "130%",
        "text-transform": "uppercase"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "10px",
        "font-kerning": "0.3px",
        "line-height": "130%",
        "text-transform": "uppercase"
      }
    },
    tooltip: {
      400: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "10px",
        "font-kerning": "0px",
        "line-height": "140%"
      },
      500: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "10px",
        "font-kerning": "0px",
        "line-height": "140%"
      },
      600: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 600,
        "font-size": "10px",
        "font-kerning": "0px",
        "line-height": "140%"
      }
    }
  },
  label: {
    accordion: {
      header: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "16px",
        "font-kerning": "0.1px",
        "line-height": "150%"
      }
    },
    button: {
      lg: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "16px",
        "font-kerning": "0.25px",
        "line-height": "120%",
        "text-transform": "capitalize"
      },
      md: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "14px",
        "font-kerning": "0.25px",
        "line-height": "120%",
        "text-transform": "capitalize"
      },
      sm: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "12px",
        "font-kerning": "0.25px",
        "line-height": "120%",
        "text-transform": "capitalize"
      }
    },
    chip: {
      "font-name": "var(--ns-typography-font-family-primary)",
      "font-weight": 500,
      "font-size": "12px",
      "font-kerning": "0.2px",
      "line-height": "114.99999999999999%",
      "text-transform": "capitalize"
    },
    input: {
      field: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 400,
        "font-size": "14px",
        "font-kerning": "0.25px",
        "line-height": "120%",
        "text-transform": "capitalize"
      }
    },
    table: {
      header: {
        "font-name": "var(--ns-typography-font-family-primary)",
        "font-weight": 500,
        "font-size": "14px",
        "font-kerning": "0.1px",
        "line-height": "145%",
        "text-transform": "capitalize"
      }
    }
  }
}, O6 = {
  sm: "160px",
  md: "280px",
  lg: "400px"
}, B6 = {
  primary: {
    100: "var(--ns-color-mitra-blue-100)",
    200: "var(--ns-color-mitra-blue-200)",
    300: "var(--ns-color-mitra-blue-300)",
    400: "var(--ns-color-mitra-blue-400)",
    500: "var(--ns-color-mitra-blue-500)",
    600: "var(--ns-color-mitra-blue-600)",
    700: "var(--ns-color-mitra-blue-700)",
    800: "var(--ns-color-mitra-blue-800)",
    900: "var(--ns-color-mitra-blue-900)"
  },
  secondary: {
    100: "var(--ns-color-cool-gray-100)",
    200: "var(--ns-color-cool-gray-200)",
    300: "var(--ns-color-cool-gray-300)",
    400: "var(--ns-color-cool-gray-400)",
    500: "var(--ns-color-cool-gray-500)",
    600: "var(--ns-color-cool-gray-600)",
    700: "var(--ns-color-cool-gray-700)",
    800: "var(--ns-color-cool-gray-800)",
    900: "var(--ns-color-cool-gray-900)"
  },
  accent: {
    yellow: {
      100: "var(--ns-color-yellow-100)"
    }
  },
  copy: {
    text: {
      primary: "var(--ns-color-neutral-black)",
      secondary: "var(--ns-color-cool-gray-700)",
      tertiary: "var(--ns-color-neutral-white)",
      link: "var(--ns-color-mitra-blue-500)",
      error: "var(--ns-color-red-500)"
    },
    label: {
      button: {
        primary: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-neutral-white)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-neutral-white)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-primary-500)",
              hover: "var(--ns-color-primary-500)",
              focused: "var(--ns-color-primary-600)",
              disabled: "var(--ns-color-primary-300)"
            },
            text: {
              enabled: "var(--ns-color-primary-500)",
              hover: "var(--ns-color-primary-500)",
              focused: "var(--ns-color-primary-600)",
              disabled: "var(--ns-color-primary-300)"
            }
          }
        },
        secondary: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-primary-100)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-secondary-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-secondary-700)",
              hover: "var(--ns-color-secondary-700)",
              focused: "var(--ns-color-secondary-700)",
              disabled: "var(--ns-color-secondary-300)"
            },
            text: {
              enabled: "var(--ns-color-secondary-700)",
              hover: "var(--ns-color-secondary-700)",
              focused: "var(--ns-color-secondary-700)",
              disabled: "var(--ns-color-secondary-300)"
            }
          }
        },
        info: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-neutral-white)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-semantic-info-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-semantic-info-600)",
              hover: "var(--ns-color-semantic-info-600)",
              focused: "var(--ns-color-semantic-info-700)",
              disabled: "var(--ns-color-semantic-info-300)"
            },
            text: {
              enabled: "var(--ns-color-semantic-info-600)",
              hover: "var(--ns-color-semantic-info-600)",
              focused: "var(--ns-color-semantic-info-700)",
              disabled: "var(--ns-color-semantic-info-300)"
            }
          }
        },
        success: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-neutral-white)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-semantic-success-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-semantic-success-primary)",
              hover: "var(--ns-color-semantic-success-primary)",
              focused: "var(--ns-color-semantic-success-600)",
              disabled: "var(--ns-color-semantic-success-300)"
            },
            text: {
              enabled: "var(--ns-color-semantic-success-primary)",
              hover: "var(--ns-color-semantic-success-primary)",
              focused: "var(--ns-color-semantic-success-600)",
              disabled: "var(--ns-color-semantic-success-300)"
            }
          }
        },
        warning: {
          enabled: "var(--ns-color-neutral-black)",
          hover: "var(--ns-color-neutral-black)",
          focused: "var(--ns-color-neutral-black)",
          disabled: "var(--ns-color-semantic-warning-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-semantic-warning-700)",
              hover: "var(--ns-color-semantic-warning-700)",
              focused: "var(--ns-color-semantic-warning-700)",
              disabled: "var(--ns-color-semantic-warning-300)"
            },
            text: {
              enabled: "var(--ns-color-semantic-warning-700)",
              hover: "var(--ns-color-semantic-warning-700)",
              focused: "var(--ns-color-semantic-warning-700)",
              disabled: "var(--ns-color-semantic-warning-300)"
            }
          }
        },
        error: {
          enabled: "var(--ns-color-neutral-white)",
          hover: "var(--ns-color-neutral-white)",
          focused: "var(--ns-color-neutral-white)",
          disabled: "var(--ns-color-semantic-error-300)",
          variant: {
            outlined: {
              enabled: "var(--ns-color-semantic-error-primary)",
              hover: "var(--ns-color-semantic-error-primary)",
              focused: "var(--ns-color-semantic-error-600)",
              disabled: "var(--ns-color-semantic-error-300)"
            },
            text: {
              enabled: "var(--ns-color-semantic-error-primary)",
              hover: "var(--ns-color-semantic-error-primary)",
              focused: "var(--ns-color-semantic-error-600)",
              disabled: "var(--ns-color-semantic-error-300)"
            }
          }
        }
      },
      input: {
        field: {
          default: "var(--ns-color-cool-gray-800)",
          disabled: "var(--ns-color-cool-gray-600)",
          placeholder: "var(--ns-color-cool-gray-700)"
        }
      }
    }
  },
  surface: {
    button: {
      primary: {
        enabled: "var(--ns-color-primary-500)",
        hover: "var(--ns-color-primary-600)",
        focused: "var(--ns-color-primary-700)",
        disabled: "var(--ns-color-primary-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-primary-100)",
            focused: "var(--ns-color-primary-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-primary-100)",
            focused: "var(--ns-color-primary-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      secondary: {
        enabled: "var(--ns-color-secondary-700)",
        hover: "var(--ns-color-secondary-800)",
        focused: "var(--ns-color-secondary-900)",
        disabled: "var(--ns-color-secondary-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-secondary-100)",
            focused: "var(--ns-color-secondary-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-secondary-100)",
            focused: "var(--ns-color-secondary-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      info: {
        enabled: "var(--ns-color-semantic-info-600)",
        hover: "var(--ns-color-semantic-info-700)",
        focused: "var(--ns-color-semantic-info-800)",
        disabled: "var(--ns-color-semantic-info-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-info-100)",
            focused: "var(--ns-color-semantic-info-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-info-100)",
            focused: "var(--ns-color-semantic-info-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      success: {
        enabled: "var(--ns-color-semantic-success-500)",
        hover: "var(--ns-color-semantic-success-600)",
        focused: "var(--ns-color-semantic-success-700)",
        disabled: "var(--ns-color-semantic-success-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-success-100)",
            focused: "var(--ns-color-semantic-success-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-success-100)",
            focused: "var(--ns-color-semantic-success-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      warning: {
        enabled: "var(--ns-color-semantic-warning-400)",
        hover: "var(--ns-color-semantic-warning-500)",
        focused: "var(--ns-color-semantic-warning-600)",
        disabled: "var(--ns-color-semantic-warning-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-warning-100)",
            focused: "var(--ns-color-semantic-warning-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-warning-100)",
            focused: "var(--ns-color-semantic-warning-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      },
      error: {
        enabled: "var(--ns-color-semantic-error-500)",
        hover: "var(--ns-color-semantic-error-600)",
        focused: "var(--ns-color-semantic-error-700)",
        disabled: "var(--ns-color-semantic-error-300)",
        variant: {
          outlined: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-error-100)",
            focused: "var(--ns-color-semantic-error-200)",
            disabled: "var(--ns-color-neutral-white)"
          },
          text: {
            enabled: "var(--ns-color-neutral-white)",
            hover: "var(--ns-color-semantic-error-100)",
            focused: "var(--ns-color-semantic-error-200)",
            disabled: "var(--ns-color-neutral-white)"
          }
        }
      }
    }
  },
  background: {
    primary: "var(--ns-color-cool-gray-100)",
    secondary: "var(--ns-color-neutral-white)",
    backdrop: "rgba(0,0,0,0.5)"
  },
  border: {
    normal: "var(--ns-color-cool-gray-300)",
    active: "var(--ns-color-mitra-blue-500)",
    // Underscore-prefixed deliberately: a plain `error` key would collide with
    // the `error: { … }` state object below and be silently dropped, taking
    // `--ns-color-border-_error` with it.
    _error: "var(--ns-color-red-500)",
    primary: {
      enabled: "var(--ns-color-primary-500)",
      hover: "var(--ns-color-primary-600)",
      focused: "var(--ns-color-primary-700)",
      disabled: "var(--ns-color-primary-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-primary-500)",
          hover: "var(--ns-color-primary-600)",
          focused: "var(--ns-color-primary-700)"
        }
      }
    },
    secondary: {
      enabled: "var(--ns-color-secondary-500)",
      hover: "var(--ns-color-secondary-600)",
      focused: "var(--ns-color-secondary-700)",
      disabled: "var(--ns-color-secondary-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-secondary-500)",
          hover: "var(--ns-color-secondary-600)",
          focused: "var(--ns-color-secondary-700)",
          disabled: "var(--ns-color-secondary-300)"
        }
      }
    },
    info: {
      enabled: "var(--ns-color-semantic-info-primary)",
      hover: "var(--ns-color-semantic-info-600)",
      focused: "var(--ns-color-semantic-info-700)",
      disabled: "var(--ns-color-semantic-info-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-semantic-info-primary)",
          hover: "var(--ns-color-semantic-info-600)",
          focused: "var(--ns-color-semantic-info-700)",
          disabled: "var(--ns-color-semantic-info-300)"
        }
      }
    },
    success: {
      enabled: "var(--ns-color-semantic-success-primary)",
      hover: "var(--ns-color-semantic-success-600)",
      focused: "var(--ns-color-semantic-success-700)",
      disabled: "var(--ns-color-semantic-success-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-semantic-success-primary)",
          hover: "var(--ns-color-semantic-success-600)",
          focused: "var(--ns-color-semantic-success-700)",
          disabled: "var(--ns-color-semantic-success-300)"
        }
      }
    },
    warning: {
      enabled: "var(--ns-color-semantic-warning-primary)",
      hover: "var(--ns-color-semantic-warning-600)",
      focused: "var(--ns-color-semantic-warning-700)",
      disabled: "var(--ns-color-semantic-warning-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-semantic-warning-primary)",
          hover: "var(--ns-color-semantic-warning-600)",
          focused: "var(--ns-color-semantic-warning-700)",
          disabled: "var(--ns-color-semantic-warning-300)"
        }
      }
    },
    error: {
      enabled: "var(--ns-color-semantic-error-primary)",
      hover: "var(--ns-color-semantic-error-600)",
      focused: "var(--ns-color-semantic-error-700)",
      disabled: "var(--ns-color-semantic-error-300)",
      variant: {
        outlined: {
          enabled: "var(--ns-color-semantic-error-primary)",
          hover: "var(--ns-color-semantic-error-600)",
          focused: "var(--ns-color-semantic-error-700)",
          disabled: "var(--ns-color-semantic-error-300)"
        }
      }
    }
  },
  semantic: {
    info: {
      primary: "var(--ns-color-blue-500)",
      100: "var(--ns-color-blue-100)",
      200: "var(--ns-color-blue-200)",
      300: "var(--ns-color-blue-300)",
      400: "var(--ns-color-blue-400)",
      500: "var(--ns-color-blue-500)",
      600: "var(--ns-color-blue-600)",
      700: "var(--ns-color-blue-700)",
      800: "var(--ns-color-blue-800)",
      900: "var(--ns-color-blue-900)"
    },
    success: {
      primary: "var(--ns-color-green-500)",
      100: "var(--ns-color-green-100)",
      200: "var(--ns-color-green-200)",
      300: "var(--ns-color-green-300)",
      400: "var(--ns-color-green-400)",
      500: "var(--ns-color-green-500)",
      600: "var(--ns-color-green-600)",
      700: "var(--ns-color-green-700)",
      800: "var(--ns-color-green-800)",
      900: "var(--ns-color-green-900)"
    },
    error: {
      primary: "var(--ns-color-red-500)",
      100: "var(--ns-color-red-100)",
      200: "var(--ns-color-red-200)",
      300: "var(--ns-color-red-300)",
      400: "var(--ns-color-red-400)",
      500: "var(--ns-color-red-500)",
      600: "var(--ns-color-red-600)",
      700: "var(--ns-color-red-700)",
      800: "var(--ns-color-red-800)",
      900: "var(--ns-color-red-900)"
    },
    warning: {
      primary: "var(--ns-color-yellow-500)",
      100: "var(--ns-color-yellow-100)",
      200: "var(--ns-color-yellow-200)",
      300: "var(--ns-color-yellow-300)",
      400: "var(--ns-color-yellow-400)",
      500: "var(--ns-color-yellow-500)",
      600: "var(--ns-color-yellow-600)",
      700: "var(--ns-color-yellow-700)",
      800: "var(--ns-color-yellow-800)",
      900: "var(--ns-color-yellow-900)"
    }
  }
}, kk = {
  border: I6,
  breakpoint: L6,
  color: {
    ...N6,
    ...B6
  },
  depth: T6,
  elevation: P6,
  iconography: D6,
  layout: M6,
  motion: V6,
  spacing: F6,
  typography: R6,
  width: O6
}, qn = {
  "ds-switch": "_ds-switch_j7kps_1",
  "ds-switch--disabled": "_ds-switch--disabled_j7kps_4",
  "ds-switch--width-full": "_ds-switch--width-full_j7kps_9",
  "ds-switch--width-sm": "_ds-switch--width-sm_j7kps_12",
  "ds-switch--width-md": "_ds-switch--width-md_j7kps_15",
  "ds-switch--width-lg": "_ds-switch--width-lg_j7kps_18",
  "ds-switch__control": "_ds-switch__control_j7kps_21",
  "ds-switch__input": "_ds-switch__input_j7kps_27",
  "ds-switch__track": "_ds-switch__track_j7kps_38",
  "ds-switch__thumb": "_ds-switch__thumb_j7kps_49",
  "ds-switch--size-medium": "_ds-switch--size-medium_j7kps_60",
  "ds-switch--size-small": "_ds-switch--size-small_j7kps_73",
  "ds-switch__label": "_ds-switch__label_j7kps_86"
};
var kl = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(kl || {});
const Ck = ({
  id: e,
  label: t,
  hideLabel: n = !1,
  ariaDescribedBy: i,
  checked: r,
  disabled: s = !1,
  focusableWhenDisabled: o = !1,
  size: l = kl.Medium,
  width: u = we.Auto,
  onChange: c,
  className: d
}) => {
  const h = X(
    qn["ds-switch"],
    qn[`ds-switch--size-${l}`],
    s && qn["ds-switch--disabled"],
    u !== we.Auto && qn[`ds-switch--width-${u}`],
    d
  );
  return /* @__PURE__ */ g("span", { className: h, "data-checked": r, children: /* @__PURE__ */ F(
    "label",
    {
      className: qn["ds-switch__control"],
      onClick: (m) => {
        m.preventDefault(), s || c(!r);
      },
      children: [
        /* @__PURE__ */ g(
          "input",
          {
            id: e,
            type: "checkbox",
            role: "switch",
            className: qn["ds-switch__input"],
            checked: r,
            disabled: s && !o,
            "aria-disabled": s && o || void 0,
            "aria-describedby": i,
            onChange: (m) => {
              s || c(m.target.checked);
            }
          }
        ),
        /* @__PURE__ */ g("span", { className: qn["ds-switch__track"], "aria-hidden": "true", children: /* @__PURE__ */ g("span", { className: qn["ds-switch__thumb"] }) }),
        t && n && /* @__PURE__ */ g(Kr, { children: t }),
        t && !n && /* @__PURE__ */ g("span", { className: qn["ds-switch__label"], children: t })
      ]
    }
  ) });
}, Jn = {
  "ds-segmented-switch": "_ds-segmented-switch_1m4ih_1",
  "ds-segmented-switch--disabled": "_ds-segmented-switch--disabled_1m4ih_7",
  "ds-segmented-switch__control": "_ds-segmented-switch__control_1m4ih_12",
  "ds-segmented-switch__input": "_ds-segmented-switch__input_1m4ih_17",
  "ds-segmented-switch__track": "_ds-segmented-switch__track_1m4ih_28",
  "ds-segmented-switch__thumb": "_ds-segmented-switch__thumb_1m4ih_39",
  "ds-segmented-switch--size-medium": "_ds-segmented-switch--size-medium_1m4ih_50",
  "ds-segmented-switch--size-small": "_ds-segmented-switch--size-small_1m4ih_63",
  "ds-segmented-switch__option": "_ds-segmented-switch__option_1m4ih_76"
}, Sk = ({
  id: e,
  labelLeft: t,
  labelRight: n,
  checked: i,
  disabled: r = !1,
  size: s = kl.Medium,
  onChange: o,
  className: l
}) => {
  const u = X(
    Jn["ds-segmented-switch"],
    Jn[`ds-segmented-switch--size-${s}`],
    r && Jn["ds-segmented-switch--disabled"],
    l
  );
  return /* @__PURE__ */ F("span", { className: u, "data-checked": i, children: [
    /* @__PURE__ */ g(
      "span",
      {
        className: Jn["ds-segmented-switch__option"],
        "data-side": "left",
        "aria-hidden": "true",
        onClick: () => o(!1),
        children: t
      }
    ),
    /* @__PURE__ */ F(
      "label",
      {
        className: Jn["ds-segmented-switch__control"],
        onClick: (c) => {
          c.preventDefault(), r || o(!i);
        },
        children: [
          /* @__PURE__ */ g(
            "input",
            {
              id: e,
              type: "checkbox",
              role: "switch",
              "aria-label": `${t} / ${n}`,
              className: Jn["ds-segmented-switch__input"],
              checked: i,
              disabled: r,
              onChange: (c) => o(c.target.checked)
            }
          ),
          /* @__PURE__ */ g("span", { className: Jn["ds-segmented-switch__track"], "aria-hidden": "true", children: /* @__PURE__ */ g("span", { className: Jn["ds-segmented-switch__thumb"] }) })
        ]
      }
    ),
    /* @__PURE__ */ g(
      "span",
      {
        className: Jn["ds-segmented-switch__option"],
        "data-side": "right",
        "aria-hidden": "true",
        onClick: () => o(!0),
        children: n
      }
    )
  ] });
};
export {
  Wp as ANSWER_LATER_VALUE,
  u6 as ARIESStatusRow,
  dd as AUTO_FOCUS_ATTRIBUTE,
  R1 as Accordion,
  O1 as AccordionItem,
  Cd as Alert,
  wd as AlertEnterEffect,
  kd as AlertExitEffect,
  Zo as AlertPosition,
  vk as AlertProvider,
  pn as AlertSeverity,
  Us as AlertVariant,
  Yp as AnimatedAriesIcon,
  Z1 as AriesCard,
  Y1 as AriesInput,
  o1 as Attachment,
  l1 as AttachmentList,
  ci as AttachmentState,
  Hs as Avatar,
  Pi as AvatarColor,
  M0 as Badge,
  io as BadgeVariant,
  Ze as Button,
  b5 as ButtonGroupSlot,
  Is as ButtonOrientation,
  g5 as ButtonSlot,
  Ye as ButtonVariant,
  pd as CalendarPanel,
  em as Card,
  co as CardVariant,
  d6 as ChatBubble,
  h6 as ChatDateDivider,
  p6 as ChatErrorRow,
  gk as ChatMessage,
  f6 as ChatMessageRow,
  m6 as ChatSystemRow,
  yk as ChatTimeline,
  _6 as ChatTypingRow,
  ur as Checkbox,
  lr as CheckboxSize,
  v5 as CheckboxSlot,
  Gn as Chip,
  fi as ChipVariant,
  Le as ColorVariant,
  rd as ComboBoxField,
  xk as ContextPrompt,
  Q5 as ContextToken,
  Kn as ContextualMenu,
  Y6 as ConversationItem,
  Q6 as ConversationList,
  ro as ConversationPreviewTone,
  Y0 as CopyButton,
  uo as CounterMode,
  uk as DataCard,
  hk as DataTable,
  Gp as DatePickerCalendarSlot,
  $o as DatePickerField,
  mk as DatePickerSlot,
  c6 as DeliveryBadge,
  Rm as Dialog,
  xd as Disclosure,
  im as Drawer,
  ad as EMAIL_REGEX,
  od as EMAIL_VALIDATION_MESSAGE,
  X6 as EmptyState,
  fm as EntityEditor,
  Uo as EntityPickerField,
  E5 as EntityPickerSlot,
  Vm as EntityViewer,
  Q1 as ErrorBoundary,
  ud as FOCUSABLE_SELECTORS,
  dt as FieldEditorType,
  Lf as FieldValueType,
  tk as FileTrigger,
  Q0 as FileTypeTone,
  Xp as ISMFormContext,
  f5 as ISMFormProvider,
  vl as ISMR,
  be as Icon,
  q as IconName,
  X1 as InfoCard,
  Jf as Input,
  Nt as InputSize,
  Pe as InputState,
  lo as InputStatus,
  G1 as InputType,
  Gr as Link,
  D0 as LoABadge,
  ok as MDXProvider,
  lk as MDXRenderer,
  nk as MessageCard,
  Sd as MessageCardVariant,
  bk as MessageFeedbackRow,
  Br as MessageStatus,
  U6 as MultiEntityPickerField,
  sd as MultiSelectField,
  I5 as MultiSelectSlot,
  mm as Navbar,
  G6 as PanelHeader,
  ek as ParticipantList,
  W6 as Popover,
  q0 as ProgressBar,
  Wo as ProgressBarSize,
  ik as ProjectionCalendar,
  H0 as Radio,
  U0 as RadioGroup,
  Jo as RadioSize,
  mu as SIDEBAR_WIDTH_PROPERTY,
  J6 as SegmentedControl,
  gd as SegmentedControlSize,
  Sk as SegmentedSwitch,
  Oo as SelectField,
  N5 as SelectSlot,
  km as Sidebar,
  lt as SizeVariant,
  Qp as SpinnerSlot,
  K6 as SplitView,
  bd as SplitViewMode,
  ce as SvgElem,
  Ck as Switch,
  kl as SwitchSize,
  H1 as Tab,
  j1 as TabList,
  U1 as TabPanel,
  Tm as Table,
  r0 as TableDataType,
  B1 as Tabs,
  E0 as TextAreaField,
  Ki as TextField,
  M5 as TextFieldSlot,
  Ho as TimePickerField,
  F5 as TimePickerSlot,
  Xm as Token,
  kn as Tooltip,
  q6 as UserBadge,
  Es as ViewFormat,
  Kr as VisuallyHidden,
  we as WidthVariant,
  _k as chatISMRegistry,
  ia as decodeISM,
  R5 as defaultISMRegistry,
  ck as defineEditorColumns,
  dk as defineEditorRows,
  ak as defineViewerColumns,
  Xn as eAnchorTarget,
  ho as eAsidePanelType,
  po as eCTA,
  Tf as eDataRawType,
  Nf as eHintType,
  Pf as eInputType,
  gt as eTextEntryType,
  d5 as encodeSlot,
  p5 as formatConjunctionList,
  L0 as formatFileSize,
  N0 as formatFileSizeProgress,
  md as formatTimestamp,
  qo as getInitials,
  nr as getTabbableElements,
  yl as isAnswerLaterValue,
  s0 as isValidEmail,
  sr as mergeRefs,
  zd as northStarComponents,
  fk as patchISMValues,
  kk as tokens,
  wk as useAlert,
  hd as useAutoFocusWithin,
  sk as useDrawer,
  Cn as useISMForm,
  Z6 as usePopover,
  rk as useTabPanelVisible,
  Go as useTabs,
  pk as validateISM
};
//# sourceMappingURL=north-star.esm.js.map
